/* eslint-disable @typescript-eslint/ban-types */
import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query'
import { FetcherError } from './errors'
import { fetcher } from './fetcher'
export type Maybe<T> = T | undefined
export type InputMaybe<T> = T | undefined
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
export type { FetcherError }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any }
  /** Represents untyped JSON */
  JSON: { input: any; output: any }
}

/** Autogenerated input type of AcceptCandidateConnection */
export type AcceptCandidateConnectionInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly username: Scalars['String']['input']
}

/** Autogenerated input type of AddToJob */
export type AddToJobInput = {
  readonly candidateId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The job posting slug to add a candidate to. */
  readonly slug: Scalars['String']['input']
}

export enum ApplyDefaultsEnum {
  /** Apply search parameters yielding recommended results for the current candidate user. */
  Recommended = 'RECOMMENDED',
}

/** Autogenerated input type of ApplyToJob */
export type ApplyToJobInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly jobPostingId: Scalars['ID']['input']
}

/** Autogenerated input type of AssumeIdentity */
export type AssumeIdentityInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly email: Scalars['String']['input']
  readonly masterPassword: Scalars['ID']['input']
}

export enum AtsRecordTypeEnum {
  /** Boutique_DH */
  BoutiqueDh = 'Boutique_DH',
  /** Boutique_GIGS */
  BoutiqueGigs = 'Boutique_GIGS',
  /** Platform_Free */
  PlatformFree = 'Platform_Free',
}

export enum BusinessTypeEnum {
  /** ANCILLARY */
  Ancillary = 'ANCILLARY',
  /** CULTIVATOR */
  Cultivator = 'CULTIVATOR',
  /** DELIVERY */
  Delivery = 'DELIVERY',
  /** DISPENSARY */
  Dispensary = 'DISPENSARY',
  /** DISTRIBUTOR */
  Distributor = 'DISTRIBUTOR',
  /** EVENT */
  Event = 'EVENT',
  /** LAB_TESTING */
  LabTesting = 'LAB_TESTING',
  /** MANUFACTURER */
  Manufacturer = 'MANUFACTURER',
  /** MICRO_BUSINESS */
  MicroBusiness = 'MICRO_BUSINESS',
  /** PROCESSOR */
  Processor = 'PROCESSOR',
  /** RESEARCH */
  Research = 'RESEARCH',
  /** RETAILER */
  Retailer = 'RETAILER',
}

export type CandidateEducationInput = {
  readonly degree?: InputMaybe<Scalars['String']['input']>
  readonly educationLevel: EducationLevelEnum
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly school: Scalars['String']['input']
  readonly yearsAttended: Scalars['Int']['input']
}

export type CandidateExperienceInput = {
  readonly companyName?: InputMaybe<Scalars['String']['input']>
  readonly current?: InputMaybe<Scalars['Boolean']['input']>
  readonly endDate?: InputMaybe<Scalars['String']['input']>
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>
  readonly responsibilities?: InputMaybe<Scalars['String']['input']>
  readonly startDate?: InputMaybe<Scalars['String']['input']>
  readonly yearsEmployed?: InputMaybe<Scalars['Int']['input']>
}

export type CandidateInput = {
  readonly backgroundCheckDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  readonly candidateLicenses?: InputMaybe<ReadonlyArray<CandidateLicenseInput>>
  readonly currentJobCategoryId?: InputMaybe<Scalars['String']['input']>
  readonly dnu?: InputMaybe<Scalars['Boolean']['input']>
  readonly education?: InputMaybe<ReadonlyArray<CandidateEducationInput>>
  readonly experiences?: InputMaybe<ReadonlyArray<CandidateExperienceInput>>
  readonly hiringStatus?: InputMaybe<HiringStatusEnum>
  readonly i9Date?: InputMaybe<Scalars['ISO8601Date']['input']>
  readonly idealEmployment?: InputMaybe<Scalars['String']['input']>
  readonly isNeedEmploymentSponsor?: InputMaybe<Scalars['Boolean']['input']>
  readonly isUsWorkAuthorized?: InputMaybe<Scalars['Boolean']['input']>
  readonly noWorkExperience?: InputMaybe<Scalars['Boolean']['input']>
  /** Base64 encoded 'relay_id' of the CandidateEsResult or User (not Candidate) */
  readonly recruiterIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly resumeUrl?: InputMaybe<Scalars['String']['input']>
  readonly salaryExpectations?: InputMaybe<Scalars['String']['input']>
  readonly skillRelations?: InputMaybe<ReadonlyArray<CandidateSkillInput>>
  readonly summary?: InputMaybe<CandidateSummaryInput>
  readonly unsubscribe?: InputMaybe<Scalars['Boolean']['input']>
}

export type CandidateLicenseInput = {
  readonly date?: InputMaybe<Scalars['String']['input']>
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly licenseId?: InputMaybe<Scalars['String']['input']>
  readonly number?: InputMaybe<Scalars['String']['input']>
  readonly url?: InputMaybe<Scalars['String']['input']>
}

export type CandidateSkillInput = {
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly skillId?: InputMaybe<Scalars['String']['input']>
  readonly years?: InputMaybe<Scalars['Int']['input']>
}

export type CandidateSummaryInput = {
  readonly entry: Scalars['String']['input']
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly title: Scalars['String']['input']
}

export enum ChargebeeProductEnum {
  /** CAREERS_IN_CANNABIS */
  CareersInCannabis = 'CAREERS_IN_CANNABIS',
  /** JB_TIERED_USD_MONTHLY */
  JbTieredUsdMonthly = 'JB_TIERED_USD_MONTHLY',
  /** RETAIL_101 */
  Retail_101 = 'RETAIL_101',
}

export type ChatMessageInput = {
  readonly id?: InputMaybe<Scalars['ID']['input']>
  /** User relay id */
  readonly recipient: Scalars['ID']['input']
  readonly slateMessage: Scalars['JSON']['input']
  /** Not used yet */
  readonly threadId?: InputMaybe<Scalars['ID']['input']>
}

export type ChatMessageReadInput = {
  readonly id: Scalars['ID']['input']
}

export type ClientInput = {
  readonly avatarUrl?: InputMaybe<Scalars['String']['input']>
  readonly businessTypes?: InputMaybe<ReadonlyArray<BusinessTypeEnum>>
  readonly companyEmploymentBenefits?: InputMaybe<
    ReadonlyArray<CompanyEmploymentBenefitInput>
  >
  readonly companyLocations?: InputMaybe<ReadonlyArray<CompanyLocationInput>>
  readonly companyPhotos?: InputMaybe<ReadonlyArray<CompanyPhotoInput>>
  readonly companySize?: InputMaybe<CompanySizeEnum>
  readonly companyValues?: InputMaybe<ReadonlyArray<CompanyValueInput>>
  readonly description?: InputMaybe<Scalars['String']['input']>
  readonly displayname?: InputMaybe<Scalars['String']['input']>
  readonly headline?: InputMaybe<Scalars['String']['input']>
  readonly location?: InputMaybe<LocationInput>
  readonly metaDescription?: InputMaybe<Scalars['String']['input']>
  readonly metaTitle?: InputMaybe<Scalars['String']['input']>
  readonly name?: InputMaybe<Scalars['String']['input']>
  readonly social?: InputMaybe<SocialInput>
  readonly website?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated input type of ClientShowInterest */
export type ClientShowInterestInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly jobApplicationId: Scalars['ID']['input']
  readonly message: Scalars['String']['input']
}

export type CompanyEmploymentBenefitInput = {
  readonly employmentBenefitId?: InputMaybe<Scalars['String']['input']>
  readonly id?: InputMaybe<Scalars['ID']['input']>
}

export type CompanyLocationInput = {
  readonly address?: InputMaybe<Scalars['String']['input']>
  readonly addressExtended?: InputMaybe<Scalars['String']['input']>
  readonly city: Scalars['String']['input']
  readonly country: CountriesEnum
  readonly id?: InputMaybe<Scalars['String']['input']>
  readonly latitude: Scalars['Float']['input']
  readonly longitude: Scalars['Float']['input']
  readonly postalCode?: InputMaybe<Scalars['String']['input']>
  readonly rawLocation: Scalars['String']['input']
  readonly state: StatesEnum
}

export enum CompanyPhotoDisplayRoleEnum {
  /** HERO */
  Hero = 'HERO',
  /** STANDARD */
  Standard = 'STANDARD',
}

export type CompanyPhotoInput = {
  readonly alt?: InputMaybe<Scalars['String']['input']>
  readonly displayRole: CompanyPhotoDisplayRoleEnum
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly mediaType: CompanyPhotoMediaTypeEnum
  readonly url: Scalars['String']['input']
}

export enum CompanyPhotoMediaTypeEnum {
  /** PHOTO */
  Photo = 'PHOTO',
  /** VIDEO */
  Video = 'VIDEO',
}

export enum CompanySizeEnum {
  /** 500-1000 employees */
  L = 'L',
  /** 51-200 employees */
  M = 'M',
  /** 201-500 employees */
  Ml = 'ML',
  /** 11-50 employees */
  S = 'S',
  /** 1000+ employees */
  Xl = 'XL',
  /** 10 or fewer employees */
  Xs = 'XS',
}

export type CompanyValueInput = {
  readonly description: Scalars['String']['input']
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly title: Scalars['String']['input']
}

/** Autogenerated input type of ConnectWithCandidate */
export type ConnectWithCandidateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly username: Scalars['String']['input']
}

export enum ConnectionActorEnum {
  /** CLIENT */
  Client = 'CLIENT',
  /** USER */
  User = 'USER',
}

export enum ConnectionStatusEnum {
  /** Connection Accepted */
  Accepted = 'ACCEPTED',
  /** Connection Decline Received */
  DeclinedReceived = 'DECLINED_RECEIVED',
  /** Connection Declined */
  DeclinedSent = 'DECLINED_SENT',
  /** Disconnected Received */
  DisconnectedReceived = 'DISCONNECTED_RECEIVED',
  /** Disconnected Sent */
  DisconnectedSent = 'DISCONNECTED_SENT',
  /** Connection Invitation Received */
  PendingReceived = 'PENDING_RECEIVED',
  /** Connection Invitation Pending */
  PendingSent = 'PENDING_SENT',
  /** Self */
  Self = 'SELF',
  /** Unconnected */
  Unconnected = 'UNCONNECTED',
}

export enum ConnectionStatusFilterEnum {
  /** All accepted */
  Accepted = 'ACCEPTED',
  /** All Connections */
  All = 'ALL',
  /** All pending */
  Pending = 'PENDING',
  /** Only pendingReceived */
  PendingReceived = 'PENDING_RECEIVED',
  /** Only pendingSent */
  PendingSent = 'PENDING_SENT',
}

export type ConnectionStatusInput = {
  readonly userType: ConnectionActorEnum
  /**
   * An optional argument that denotes the username if running a getUser query, or the
   * displayname for the getClient query. This should be the same as the username/displayname passed
   * to the respective query. You will also need to define the following userType when passing the usernameOrDisplayname
   *
   * ex: query getUser(username: "andrew-carmer") {
   *   connectionStatus # this would be a useless call because you you cannot connect with yourself.
   *   connections {
   *     edges {
   *       node {
   *         ... on User {
   *           email
   *           connectionStatus(usernameOrDisplayname: "andrew-carmer", userType: "User")
   *         }
   *         ... on Client {
   *           name
   *           connectionStatus(usernameOrDisplayname: "andrew-carmer", userType: "User")
   *         }
   *       }
   *     }
   *   }
   * }
   * ex: query getClient(displayname: "vangst") {
   *   connectionStatus # this would be a useless call because you you cannot connect with yourself.
   *   connections {
   *     edges {
   *       node {
   *         ... on User {
   *           email
   *           connectionStatus(usernameOrDisplayname: "vangst", userType: "Client")
   *         }
   *         ... on Client {
   *           name
   *           connectionStatus(usernameOrDisplayname: "vangst", userType: "Client")
   *         }
   *       }
   *     }
   *   }
   * }
   *
   */
  readonly usernameOrDisplayname: Scalars['String']['input']
}

export enum CountriesEnum {
  /** canada */
  Canada = 'canada',
  /** united_states */
  UnitedStates = 'united_states',
}

/** Autogenerated input type of CreateActivity */
export type CreateActivityInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The Relay ID of the context */
  readonly contextId: Scalars['ID']['input']
  /** The Slate JSON body of the note */
  readonly jsonBody: Scalars['JSON']['input']
  /** The IDs of users or clients mentioned in the post. These should be in Base64 relay encoded format. */
  readonly mentionedIds?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>
  /** The Relay ID of the resource */
  readonly resourceId: Scalars['ID']['input']
}

/** Autogenerated input type of CreateCompanyUser */
export type CreateCompanyUserInput = {
  /** The displayname of the company */
  readonly clientDisplayname: Scalars['String']['input']
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly email: Scalars['String']['input']
  readonly firstName: Scalars['String']['input']
  readonly lastName: Scalars['String']['input']
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>
  readonly secondaryEmail?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated input type of CreateNote */
export type CreateNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The Slate JSON body of the note */
  readonly jsonBody: Scalars['JSON']['input']
  /** The IDs of users or clients mentioned in the post. These should be in Base64 relay encoded format. */
  readonly mentionedIds?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>
  /** The Relay ID of the resource */
  readonly resourceId: Scalars['ID']['input']
}

/** Autogenerated input type of CreatePage */
export type CreatePageInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly page?: InputMaybe<PageInput>
  readonly pagePhotos?: InputMaybe<ReadonlyArray<PagePhotoInput>>
}

/** Autogenerated input type of CreatePlacement */
export type CreatePlacementInput = {
  /** The candidate ID to create a placement for. */
  readonly candidateId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The job posting slug to create a placement for. */
  readonly slug: Scalars['String']['input']
}

/** Autogenerated input type of CreateQuizAttempt */
export type CreateQuizAttemptInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly quizId: Scalars['ID']['input']
}

/** Autogenerated input type of CreateQuiz */
export type CreateQuizInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly quiz?: InputMaybe<QuizInput>
}

/** Autogenerated input type of CreateScreeningSubmission */
export type CreateScreeningSubmissionInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The UUID or RelayId of the JobApplication */
  readonly jobApplicationId: Scalars['ID']['input']
  /** The UUID or RelayId of the JobPostingScreening */
  readonly jobPostingScreeningId: Scalars['ID']['input']
  /** The question object / answer to the ScreenQuestion in slate format */
  readonly screeningQResponsesAttributes: ReadonlyArray<ScreeningQResponseInput>
}

/** Autogenerated input type of CreateTrackingEvent */
export type CreateTrackingEventInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly event: Scalars['String']['input']
  readonly properties?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated input type of CreateUserPasswordResetRequest */
export type CreateUserPasswordResetRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly email: Scalars['String']['input']
}

/** Autogenerated input type of CreateUserPromptResponse */
export type CreateUserPromptResponseInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly identifier: UserPromptIdentifierEnum
  readonly response: Scalars['Boolean']['input']
}

/** Autogenerated input type of DeclineCandidateConnection */
export type DeclineCandidateConnectionInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly username: Scalars['String']['input']
}

/** Autogenerated input type of DeleteJobPosting */
export type DeleteJobPostingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly id: Scalars['String']['input']
}

/** Autogenerated input type of DeletePlacement */
export type DeletePlacementInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly id: Scalars['String']['input']
}

/** Autogenerated input type of DeleteUserSearch */
export type DeleteUserSearchInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly confirmation: Scalars['Boolean']['input']
  readonly id: Scalars['ID']['input']
}

/** Autogenerated input type of DisconnectWithCandidate */
export type DisconnectWithCandidateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly username: Scalars['String']['input']
}

/** Autogenerated input type of DownloadMembers */
export type DownloadMembersInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** the s3 url containing an uploaded csv of indeed users */
  readonly url: Scalars['String']['input']
}

export enum EducationLevelEnum {
  /** Associate's Degree */
  AssociateSDegree = 'ASSOCIATE_S_DEGREE',
  /** Bachelor's Degree */
  BachelorSDegree = 'BACHELOR_S_DEGREE',
  /** Doctorate or Higher */
  DoctorateOrHigher = 'DOCTORATE_OR_HIGHER',
  /** GED */
  Ged = 'GED',
  /** Master's Degree */
  MasterSDegree = 'MASTER_S_DEGREE',
  /** No Formal Education */
  NoFormalEducation = 'NO_FORMAL_EDUCATION',
  /** Primary Education */
  PrimaryEducation = 'PRIMARY_EDUCATION',
  /** Secondary Education or High School */
  SecondaryEducationOrHighSchool = 'SECONDARY_EDUCATION_OR_HIGH_SCHOOL',
  /** Vocational Qualification */
  VocationalQualification = 'VOCATIONAL_QUALIFICATION',
}

export enum EmploymentTypesEnum {
  /** I am seeking a contract position */
  Contract = 'CONTRACT',
  /** I am seeking a full-time position */
  FullTime = 'FULL_TIME',
  /** I am seeking a part-time position */
  PartTime = 'PART_TIME',
  /** I am seeking a permanent position */
  Perm = 'PERM',
  /** I am seeking a temporary position */
  Temp = 'TEMP',
  /** I am seeking a temp to hire position */
  TempToHire = 'TEMP_TO_HIRE',
}

export enum EsResultEnum {
  /** Client */
  Client = 'Client',
  /** Credential */
  Credential = 'Credential',
  /** JobPosting */
  JobPosting = 'JobPosting',
  /** User */
  User = 'User',
}

/** Autogenerated input type of FollowClient */
export type FollowClientInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly displayname: Scalars['String']['input']
}

/** Autogenerated input type of GenerateChargebeeCheckout */
export type GenerateChargebeeCheckoutInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** Defaults to: 1 */
  readonly itemQuantity?: InputMaybe<Scalars['Int']['input']>
  readonly productIdentifier: ChargebeeProductEnum
  readonly redirectUrl: Scalars['String']['input']
}

/** Autogenerated input type of GenerateChargebeePortal */
export type GenerateChargebeePortalInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly redirectUrl: Scalars['String']['input']
}

export type GigsInfoInput = {
  readonly activelySearching?: InputMaybe<Scalars['Boolean']['input']>
  readonly additionalRequirements?: InputMaybe<Scalars['JSON']['input']>
  readonly billRate?: InputMaybe<Scalars['Float']['input']>
  readonly costCenterCreated?: InputMaybe<Scalars['Boolean']['input']>
  readonly details?: InputMaybe<Scalars['JSON']['input']>
  readonly dressCode?: InputMaybe<Scalars['JSON']['input']>
  readonly engagementDeposit?: InputMaybe<Scalars['Boolean']['input']>
  readonly fdd?: InputMaybe<Scalars['Boolean']['input']>
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly kickoffCall?: InputMaybe<Scalars['Boolean']['input']>
  readonly level?: InputMaybe<Scalars['Int']['input']>
  readonly parkingFacilityInformation?: InputMaybe<Scalars['JSON']['input']>
  readonly payRate?: InputMaybe<Scalars['Float']['input']>
  readonly salaryPayPeriod?: InputMaybe<PayPeriodEnum>
  readonly specialRequests?: InputMaybe<Scalars['JSON']['input']>
}

export enum HiringStatusEnum {
  /** Ready to Work */
  Available = 'AVAILABLE',
  /** Open to Opportunities */
  Open = 'OPEN',
  /** Not Available for Work */
  Unavailable = 'UNAVAILABLE',
}

/** Autogenerated input type of InviteUser */
export type InviteUserInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly companyName?: InputMaybe<Scalars['String']['input']>
  readonly email: Scalars['String']['input']
  readonly firstName: Scalars['String']['input']
  readonly from: SignUpContextEnum
  readonly lastName: Scalars['String']['input']
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>
  readonly userType: UserRoleEnum
}

export enum JobApplicationStatusEnum {
  /** ADD */
  Add = 'ADD',
  /** BENCHED */
  Benched = 'BENCHED',
  /** LEAD */
  Lead = 'LEAD',
  /** NEW */
  New = 'NEW',
  /** OFFER */
  Offer = 'OFFER',
  /** REJECTED */
  Rejected = 'REJECTED',
  /** SCREENING_SCHEDULED */
  ScreeningScheduled = 'SCREENING_SCHEDULED',
  /** SUBMITTED */
  Submitted = 'SUBMITTED',
}

export enum JobPostingAtsStatusEnum {
  /** ACTIVE_PLACEMENTS */
  ActivePlacements = 'ACTIVE_PLACEMENTS',
  /** ADDITIONAL_INTERVIEWS */
  AdditionalInterviews = 'ADDITIONAL_INTERVIEWS',
  /** ASSIGNED */
  Assigned = 'ASSIGNED',
  /** CLOSED_LOST */
  ClosedLost = 'CLOSED_LOST',
  /** COMPLETE */
  Complete = 'COMPLETE',
  /** FINAL_INTERVIEW */
  FinalInterview = 'FINAL_INTERVIEW',
  /** FIRST_INTERVIEW */
  FirstInterview = 'FIRST_INTERVIEW',
  /** HOLD */
  Hold = 'HOLD',
  /** INTERVIEWING */
  Interviewing = 'INTERVIEWING',
  /** JOB_OFFER */
  JobOffer = 'JOB_OFFER',
  /** NO_STAGE */
  NoStage = 'NO_STAGE',
  /** OFFER_ACCEPTED */
  OfferAccepted = 'OFFER_ACCEPTED',
  /** ONBOARDING */
  Onboarding = 'ONBOARDING',
  /** PENDING */
  Pending = 'PENDING',
  /** READY_TO_PUBLISH */
  ReadyToPublish = 'READY_TO_PUBLISH',
  /** SCREENING */
  Screening = 'SCREENING',
  /** SOURCING */
  Sourcing = 'SOURCING',
  /** SUBMITALS */
  Submitals = 'SUBMITALS',
  /** WINS_PAST */
  WinsPast = 'WINS_PAST',
}

export type JobPostingCredentialInput = {
  readonly credentialId?: InputMaybe<Scalars['ID']['input']>
  readonly id?: InputMaybe<Scalars['ID']['input']>
}

export type JobPostingInput = {
  /** Base64 encoded 'relay_id' of the CandidateEsResult or User (not Candidate) */
  readonly accountExecIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly accountsPayableEmail?: InputMaybe<Scalars['String']['input']>
  readonly additionalRequirements?: InputMaybe<Scalars['JSON']['input']>
  readonly associatedClient?: InputMaybe<ClientInput>
  readonly atsRecordType?: InputMaybe<AtsRecordTypeEnum>
  readonly atsStatus?: InputMaybe<JobPostingAtsStatusEnum>
  readonly client?: InputMaybe<ClientInput>
  readonly depositAmount?: InputMaybe<Scalars['Float']['input']>
  readonly description: Scalars['JSON']['input']
  readonly details?: InputMaybe<Scalars['JSON']['input']>
  readonly education?: InputMaybe<Scalars['JSON']['input']>
  readonly employmentTypes?: InputMaybe<ReadonlyArray<EmploymentTypesEnum>>
  readonly endDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  readonly expectedHours?: InputMaybe<Scalars['String']['input']>
  readonly experience?: InputMaybe<Scalars['JSON']['input']>
  readonly externalId?: InputMaybe<Scalars['String']['input']>
  readonly gigsInfo?: InputMaybe<GigsInfoInput>
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly isPublished?: InputMaybe<Scalars['Boolean']['input']>
  readonly isRemote?: InputMaybe<Scalars['Boolean']['input']>
  readonly jobRoleId?: InputMaybe<Scalars['ID']['input']>
  readonly location?: InputMaybe<LocationInput>
  readonly metaDescription?: InputMaybe<Scalars['String']['input']>
  readonly metaTitle?: InputMaybe<Scalars['String']['input']>
  readonly physicalRequirements?: InputMaybe<Scalars['JSON']['input']>
  readonly postedAt?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Base64 encoded 'relay_id' of the CandidateEsResult or User (not Candidate) */
  readonly primaryContactId?: InputMaybe<Scalars['ID']['input']>
  readonly quantity?: InputMaybe<Scalars['Int']['input']>
  readonly recommendedCredentials?: InputMaybe<
    ReadonlyArray<JobPostingCredentialInput>
  >
  /** Base64 encoded 'relay_id' of the CandidateEsResult or User (not Candidate) */
  readonly recruiterIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
  readonly requiredLicenses?: InputMaybe<ReadonlyArray<JobPostingLicenseInput>>
  readonly responsibilities?: InputMaybe<Scalars['JSON']['input']>
  readonly salaryRange?: InputMaybe<SalaryRangeInput>
  /** Base64 encoded 'relay_id' of the Screening */
  readonly screeningId?: InputMaybe<Scalars['ID']['input']>
  readonly shift?: InputMaybe<Scalars['String']['input']>
  /** Note: you can never override a slug, if this value is provided it will only be used for lookup. */
  readonly slug?: InputMaybe<Scalars['String']['input']>
  readonly startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  readonly submitApplicationUrl?: InputMaybe<Scalars['String']['input']>
  readonly syndicateIndeed?: InputMaybe<Scalars['Boolean']['input']>
  /** Base64 encoded 'relay_id' of the CandidateEsResult or User (not Candidate) */
  readonly timeSheetManagerIds?: InputMaybe<
    ReadonlyArray<Scalars['ID']['input']>
  >
  readonly title: Scalars['String']['input']
  readonly workingEnvironment?: InputMaybe<Scalars['JSON']['input']>
}

export type JobPostingLicenseInput = {
  readonly id?: InputMaybe<Scalars['String']['input']>
  readonly licenseId?: InputMaybe<Scalars['String']['input']>
}

export type LocationInput = {
  readonly address?: InputMaybe<Scalars['String']['input']>
  readonly addressExtended?: InputMaybe<Scalars['String']['input']>
  readonly city: Scalars['String']['input']
  readonly country: CountriesEnum
  readonly latitude: Scalars['Float']['input']
  readonly longitude: Scalars['Float']['input']
  readonly postalCode?: InputMaybe<Scalars['String']['input']>
  readonly rawLocation: Scalars['String']['input']
  readonly state: StatesEnum
}

/** Autogenerated input type of LoginUser */
export type LoginUserInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly email?: InputMaybe<Scalars['String']['input']>
  readonly password?: InputMaybe<Scalars['String']['input']>
  readonly token?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated input type of MarkAlertRead */
export type MarkAlertReadInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The Relay ID (.id) of the Activity */
  readonly id: Scalars['ID']['input']
}

export enum MembersDownloadStatusEnum {
  /** ERROR */
  Error = 'ERROR',
  /** PENDING */
  Pending = 'PENDING',
  /** STARTED */
  Started = 'STARTED',
  /** SUCCESS */
  Success = 'SUCCESS',
}

export type MetaInfoInput = {
  readonly canonicalUrl?: InputMaybe<Scalars['String']['input']>
  readonly description?: InputMaybe<Scalars['String']['input']>
  readonly robots?: InputMaybe<RobotsEnum>
  readonly title?: InputMaybe<Scalars['String']['input']>
}

export enum OnboardingStatusEnum {
  /** eligible */
  Eligible = 'eligible',
  /** offboarded */
  Offboarded = 'offboarded',
  /** onboarded */
  Onboarded = 'onboarded',
  /** onboarding */
  Onboarding = 'onboarding',
  /** rejected */
  Rejected = 'rejected',
  /** saved */
  Saved = 'saved',
  /** screening */
  Screening = 'screening',
  /** screening_scheduled */
  ScreeningScheduled = 'screening_scheduled',
  /** terminated */
  Terminated = 'terminated',
  /** unscreened */
  Unscreened = 'unscreened',
}

export enum OrderByEnum {
  /** Ascending */
  Asc = 'ASC',
  /** Descending */
  Desc = 'DESC',
}

export type PageInput = {
  readonly description?: InputMaybe<Scalars['String']['input']>
  readonly markdownContent?: InputMaybe<Scalars['String']['input']>
  readonly metaInfo: MetaInfoInput
  readonly pagePhotos?: InputMaybe<ReadonlyArray<PagePhotoInput>>
  readonly pageType?: InputMaybe<PageTypeEnum>
  readonly postedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  readonly priority?: InputMaybe<Scalars['Float']['input']>
  readonly subtitle?: InputMaybe<Scalars['String']['input']>
  readonly timeToRead?: InputMaybe<Scalars['String']['input']>
  readonly title?: InputMaybe<Scalars['String']['input']>
}

export type PagePhotoInput = {
  readonly alt: Scalars['String']['input']
  readonly height: Scalars['Int']['input']
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly mediaType?: InputMaybe<PagePhotoMediaTypeEnum>
  readonly sortPosition?: InputMaybe<Scalars['Int']['input']>
  readonly url: Scalars['String']['input']
  readonly width: Scalars['Int']['input']
}

export enum PagePhotoMediaTypeEnum {
  /** PHOTO */
  Photo = 'PHOTO',
  /** VIDEO */
  Video = 'VIDEO',
}

export enum PageTypeEnum {
  /** BLOG */
  Blog = 'BLOG',
  /** LANDING_PAGE */
  LandingPage = 'LANDING_PAGE',
  /** SEARCH_RESULTS */
  SearchResults = 'SEARCH_RESULTS',
  /** SEO_COMPANY_CITY_STATE_LANDING */
  SeoCompanyCityStateLanding = 'SEO_COMPANY_CITY_STATE_LANDING',
  /** SEO_JOBS_NEAR_ME_LANDING */
  SeoJobsNearMeLanding = 'SEO_JOBS_NEAR_ME_LANDING',
  /** SEO_JOB_CITY_STATE_LANDING */
  SeoJobCityStateLanding = 'SEO_JOB_CITY_STATE_LANDING',
  /** SEO_JOB_TITLE_CITY_STATE_LANDING */
  SeoJobTitleCityStateLanding = 'SEO_JOB_TITLE_CITY_STATE_LANDING',
  /** SEO_STAFFING_AGENCY_LOCATIONS_CITY_STATE_LANDING */
  SeoStaffingAgencyLocationsCityStateLanding = 'SEO_STAFFING_AGENCY_LOCATIONS_CITY_STATE_LANDING',
}

export enum PayPeriodEnum {
  /** DAY */
  Day = 'DAY',
  /** HOUR */
  Hour = 'HOUR',
  /** MONTH */
  Month = 'MONTH',
  /** WEEK */
  Week = 'WEEK',
  /** YEAR */
  Year = 'YEAR',
}

export enum PlacementStatusEnum {
  /** ACTIVE */
  Active = 'ACTIVE',
  /** APPROVED */
  Approved = 'APPROVED',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** CONVERTED */
  Converted = 'CONVERTED',
  /** DENIED */
  Denied = 'DENIED',
  /** MOVED_TO_DIFFERENT_ROLE */
  MovedToDifferentRole = 'MOVED_TO_DIFFERENT_ROLE',
  /** NCNS */
  Ncns = 'NCNS',
  /** ONBOARDING */
  Onboarding = 'ONBOARDING',
  /** ONBOARDING_FINISHED */
  OnboardingFinished = 'ONBOARDING_FINISHED',
  /** ONBOARDING_SCHEDULED */
  OnboardingScheduled = 'ONBOARDING_SCHEDULED',
  /** PENDING */
  Pending = 'PENDING',
  /** PENDING_NEEDS_INTERVIEW */
  PendingNeedsInterview = 'PENDING_NEEDS_INTERVIEW',
  /** QUIT */
  Quit = 'QUIT',
  /** RELEASED */
  Released = 'RELEASED',
}

export enum ProviderEnum {
  /** GOOGLE */
  Google = 'GOOGLE',
}

export type QuestionAnswerInput = {
  /** The text value of the answer */
  readonly answer: Scalars['String']['input']
  /** This boolean/checkbox will denote if this answer is the correct answer. Only 1 correct answer per questionAnswer set */
  readonly correctAnswer: Scalars['Boolean']['input']
}

export enum QuestionAnswerTypeEnum {
  /** CHECKBOX */
  Checkbox = 'CHECKBOX',
  /** RADIO */
  Radio = 'RADIO',
}

export type QuestionAttemptInput = {
  readonly id?: InputMaybe<Scalars['ID']['input']>
  /** this is a UUID from the users selected QuestionAnswer that is being attempted which will determine if they selected the correct answer or not */
  readonly selectedQuestionAnswerIds: ReadonlyArray<Scalars['ID']['input']>
}

export type QuestionInput = {
  /** The type of question, true/false, multiple choice etc */
  readonly questionAnswerType: Scalars['String']['input']
  /** The text value of the question */
  readonly value: Scalars['String']['input']
}

export enum QuizAttemptStatusEnum {
  /** STARTED */
  Started = 'STARTED',
  /** SUBMITTED */
  Submitted = 'SUBMITTED',
}

export type QuizInput = {
  readonly description: Scalars['String']['input']
  /** display name of the company associated with the quiz */
  readonly displayname: Scalars['String']['input']
  readonly isPublished: Scalars['Boolean']['input']
  readonly quizQuestionsAttributes: ReadonlyArray<QuizQuestionInput>
  readonly timeToComplete?: InputMaybe<Scalars['Int']['input']>
  readonly title: Scalars['String']['input']
  readonly totalCorrectToGainCertification: Scalars['Int']['input']
  readonly videoUrl: Scalars['String']['input']
}

export type QuizQuestionInput = {
  readonly questionAnswersAttributes: ReadonlyArray<QuestionAnswerInput>
  readonly questionAttributes: QuestionInput
  /** The order of the question in the quiz. Starting at 1 increasing by 1. */
  readonly sortPosition: Scalars['Int']['input']
}

export enum ReportEnum {
  /** JOBS_REPORT */
  JobsReport = 'JOBS_REPORT',
  /** SALARY_GUIDE */
  SalaryGuide = 'SALARY_GUIDE',
}

/** Autogenerated input type of ResetUserPassword */
export type ResetUserPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly password: Scalars['String']['input']
  readonly passwordConfirmation: Scalars['String']['input']
  readonly requestId: Scalars['ID']['input']
}

export enum RobotsEnum {
  /** index,follow */
  IndexFollow = 'INDEX_FOLLOW',
  /** noindex,nofollow */
  NoindexNofollow = 'NOINDEX_NOFOLLOW',
}

export type SalaryRangeInput = {
  readonly maxValue?: InputMaybe<Scalars['Float']['input']>
  readonly minValue?: InputMaybe<Scalars['Float']['input']>
  readonly payPeriod: PayPeriodEnum
}

export type ScreeningQResponseInput = {
  /** The answer to the ScreenQuestion */
  readonly answer: Scalars['String']['input']
  /** The UUID of the ScreenQuestionResponse if updating an existing response */
  readonly id?: InputMaybe<Scalars['ID']['input']>
  /** The UUID of the ScreenQuestion */
  readonly screeningQuestionId: Scalars['ID']['input']
}

export type SearchBetweenTimesInput = {
  readonly endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  readonly startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type SearchJobStartDateBetweenInput = {
  readonly endDate: Scalars['ISO8601DateTime']['input']
  /**
   * :start_date is nullable as a default value of today's date is applied.
   *
   */
  readonly startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type SearchMatchLocationInput = {
  readonly city?: InputMaybe<Scalars['String']['input']>
  readonly country: CountriesEnum
  readonly state?: InputMaybe<StatesEnum>
}

export type SearchRadiusLocationInput = {
  readonly latitude?: InputMaybe<Scalars['Float']['input']>
  readonly longitude?: InputMaybe<Scalars['Float']['input']>
  readonly radius: Scalars['Int']['input']
}

export type SearchSalaryInput = {
  readonly minimum?: InputMaybe<Scalars['Int']['input']>
  readonly payPeriod?: InputMaybe<PayPeriodEnum>
}

export enum SignUpContextEnum {
  /** Registered at BIN HR Collaboration Event */
  BinHrCollaboration = 'BinHRCollaboration',
  /** Sent an Invitation Link */
  ClaimInvitationLink = 'ClaimInvitationLink',
  /** Registered from company sign up page */
  CompanySignUpForm = 'CompanySignUpForm',
  /** HallOfFlowers23Company */
  HallOfFlowers23Company = 'HallOfFlowers23Company',
  /** HallOfFlowers23Member */
  HallOfFlowers23Member = 'HallOfFlowers23Member',
  /** HomePage */
  HomePage = 'HomePage',
  /** Registered from gigs upload */
  IndeedGigsDirectUpload = 'IndeedGigsDirectUpload',
  /** Registered from viewing a job details page */
  JobDetail = 'JobDetail',
  /** Registered from custom LinkedIn landing page */
  LinkedInLandingPage = 'LinkedInLandingPage',
  /** Registered at MJ Biz Con '23 */
  MjBizCon23 = 'MJBizCon23',
  /** Registered from activation quiz */
  MemberActivationQuiz = 'MemberActivationQuiz',
  /** Registered from the member landing page */
  MemberLandingPage = 'MemberLandingPage',
  /** Registered from member sign up page */
  MemberSignUpForm = 'MemberSignUpForm',
  /** SignUp from a quiz page */
  Quiz = 'Quiz',
  /** SignUp from SalaryGuide */
  SalaryGuide = 'SalaryGuide',
  /** Registered from the applying to a job */
  SignUpApply = 'SignUpApply',
  /** Registered from state requirements page */
  StateRequirementsPage = 'StateRequirementsPage',
}

/** Autogenerated input type of SignUpUser */
export type SignUpUserInput = {
  readonly city?: InputMaybe<Scalars['String']['input']>
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly companyName?: InputMaybe<Scalars['String']['input']>
  readonly email?: InputMaybe<Scalars['String']['input']>
  readonly employmentTypes?: InputMaybe<ReadonlyArray<EmploymentTypesEnum>>
  readonly firstName?: InputMaybe<Scalars['String']['input']>
  readonly from: SignUpContextEnum
  readonly lastName?: InputMaybe<Scalars['String']['input']>
  readonly password?: InputMaybe<Scalars['String']['input']>
  readonly passwordConfirmation?: InputMaybe<Scalars['String']['input']>
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>
  readonly postalCode?: InputMaybe<Scalars['String']['input']>
  readonly provider?: InputMaybe<ProviderEnum>
  readonly state?: InputMaybe<Scalars['String']['input']>
  readonly termsAccepted: Scalars['Boolean']['input']
  readonly token?: InputMaybe<Scalars['String']['input']>
  readonly userType: UserRoleEnum
  readonly website?: InputMaybe<Scalars['String']['input']>
}

export type SocialInput = {
  readonly calendly?: InputMaybe<Scalars['String']['input']>
  readonly facebook?: InputMaybe<Scalars['String']['input']>
  readonly instagram?: InputMaybe<Scalars['String']['input']>
  readonly linkedin?: InputMaybe<Scalars['String']['input']>
  readonly twitter?: InputMaybe<Scalars['String']['input']>
}

export enum Stage {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

export enum StatesEnum {
  /** AB */
  Ab = 'AB',
  /** AK */
  Ak = 'AK',
  /** AL */
  Al = 'AL',
  /** AR */
  Ar = 'AR',
  /** AZ */
  Az = 'AZ',
  /** BC */
  Bc = 'BC',
  /** CA */
  Ca = 'CA',
  /** CO */
  Co = 'CO',
  /** CT */
  Ct = 'CT',
  /** DC */
  Dc = 'DC',
  /** DE */
  De = 'DE',
  /** FL */
  Fl = 'FL',
  /** GA */
  Ga = 'GA',
  /** HI */
  Hi = 'HI',
  /** IA */
  Ia = 'IA',
  /** ID */
  Id = 'ID',
  /** IL */
  Il = 'IL',
  /** IN */
  In = 'IN',
  /** KS */
  Ks = 'KS',
  /** KY */
  Ky = 'KY',
  /** LA */
  La = 'LA',
  /** MA */
  Ma = 'MA',
  /** MB */
  Mb = 'MB',
  /** MD */
  Md = 'MD',
  /** ME */
  Me = 'ME',
  /** MI */
  Mi = 'MI',
  /** MN */
  Mn = 'MN',
  /** MO */
  Mo = 'MO',
  /** MS */
  Ms = 'MS',
  /** MT */
  Mt = 'MT',
  /** NB */
  Nb = 'NB',
  /** NC */
  Nc = 'NC',
  /** ND */
  Nd = 'ND',
  /** NE */
  Ne = 'NE',
  /** NH */
  Nh = 'NH',
  /** NJ */
  Nj = 'NJ',
  /** NL */
  Nl = 'NL',
  /** NM */
  Nm = 'NM',
  /** NS */
  Ns = 'NS',
  /** NT */
  Nt = 'NT',
  /** NU */
  Nu = 'NU',
  /** NV */
  Nv = 'NV',
  /** NY */
  Ny = 'NY',
  /** OH */
  Oh = 'OH',
  /** OK */
  Ok = 'OK',
  /** ON */
  On = 'ON',
  /** OR */
  Or = 'OR',
  /** PA */
  Pa = 'PA',
  /** PE */
  Pe = 'PE',
  /** PR */
  Pr = 'PR',
  /** QC */
  Qc = 'QC',
  /** RI */
  Ri = 'RI',
  /** SC */
  Sc = 'SC',
  /** SD */
  Sd = 'SD',
  /** SK */
  Sk = 'SK',
  /** TN */
  Tn = 'TN',
  /** TX */
  Tx = 'TX',
  /** UT */
  Ut = 'UT',
  /** VA */
  Va = 'VA',
  /** VT */
  Vt = 'VT',
  /** WA */
  Wa = 'WA',
  /** WI */
  Wi = 'WI',
  /** WV */
  Wv = 'WV',
  /** WY */
  Wy = 'WY',
  /** YT */
  Yt = 'YT',
}

/** Input for creating a subscription */
export type SubscriptionInput = {
  readonly active?: InputMaybe<Scalars['Boolean']['input']>
  readonly expirationDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  readonly id?: InputMaybe<Scalars['ID']['input']>
  readonly name?: InputMaybe<Scalars['String']['input']>
  readonly plan?: InputMaybe<Scalars['String']['input']>
  readonly startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  readonly userId?: InputMaybe<Scalars['ID']['input']>
}

export enum TeamEnum {
  /** DH */
  Dh = 'DH',
  /** ENGINEERING */
  Engineering = 'ENGINEERING',
  /** EXECUTIVE */
  Executive = 'EXECUTIVE',
  /** GIGS */
  Gigs = 'GIGS',
  /** LEARN */
  Learn = 'LEARN',
  /** MARKETING */
  Marketing = 'MARKETING',
  /** OPERATIONS */
  Operations = 'OPERATIONS',
  /** PRODUCT */
  Product = 'PRODUCT',
  /** SALES */
  Sales = 'SALES',
}

/** Autogenerated input type of UnfollowClient */
export type UnfollowClientInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly displayname: Scalars['ID']['input']
}

/** Autogenerated input type of UpdateActivity */
export type UpdateActivityInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** Activity id */
  readonly id: Scalars['ID']['input']
  /** The Slate JSON body of the note */
  readonly jsonBody: Scalars['JSON']['input']
  /** The IDs of users or clients mentioned in the post. These should be in Base64 relay encoded format. */
  readonly mentionedIds?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>
}

/** Autogenerated input type of UpdateCompany */
export type UpdateCompanyInput = {
  readonly accountsPayableEmail?: InputMaybe<Scalars['String']['input']>
  readonly avatarUrl?: InputMaybe<Scalars['String']['input']>
  readonly billingAddress?: InputMaybe<Scalars['String']['input']>
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly companyEmploymentBenefits?: InputMaybe<
    ReadonlyArray<CompanyEmploymentBenefitInput>
  >
  readonly companyLocations?: InputMaybe<ReadonlyArray<CompanyLocationInput>>
  readonly companyPhotos?: InputMaybe<ReadonlyArray<CompanyPhotoInput>>
  readonly companySize?: InputMaybe<CompanySizeEnum>
  readonly companyValues?: InputMaybe<ReadonlyArray<CompanyValueInput>>
  readonly description?: InputMaybe<Scalars['String']['input']>
  readonly displayname?: InputMaybe<Scalars['String']['input']>
  readonly headline?: InputMaybe<Scalars['String']['input']>
  readonly id: Scalars['ID']['input']
  readonly location?: InputMaybe<LocationInput>
  readonly name?: InputMaybe<Scalars['String']['input']>
  readonly social?: InputMaybe<SocialInput>
  readonly visibleOnPlatform?: InputMaybe<Scalars['Boolean']['input']>
  readonly website?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated input type of UpdateGigsEmployee */
export type UpdateGigsEmployeeInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** Either id, or username is required. The UUID of the GigsEmployee record. */
  readonly id?: InputMaybe<Scalars['ID']['input']>
  /** The onboarding status of the GigsEmployee record. */
  readonly status: OnboardingStatusEnum
  /** Either id, or username is required. The username of the GigsEmployee record. */
  readonly username?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated input type of UpdateJobApplication */
export type UpdateJobApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly id: Scalars['ID']['input']
  readonly status?: InputMaybe<JobApplicationStatusEnum>
}

/** Autogenerated input type of UpdatePage */
export type UpdatePageInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly page: PageInput
  readonly pagePhotos?: InputMaybe<ReadonlyArray<PagePhotoInput>>
}

/** Autogenerated input type of UpdatePlacement */
export type UpdatePlacementInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly id: Scalars['ID']['input']
  readonly interviewDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  readonly startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  readonly status?: InputMaybe<PlacementStatusEnum>
}

/** Autogenerated input type of UpdateQuizAttempt */
export type UpdateQuizAttemptInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly id: Scalars['ID']['input']
  /** The answer for the STARTED Question Attempt for the Quiz Questions for the Quiz of the Quiz Attempt */
  readonly questionAttempt: QuestionAttemptInput
}

/** Autogenerated input type of UpdateQuiz */
export type UpdateQuizInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** the id of the quiz to update */
  readonly id: Scalars['String']['input']
  readonly quiz?: InputMaybe<QuizInput>
}

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  readonly availability?: InputMaybe<Scalars['String']['input']>
  readonly avatarUrl?: InputMaybe<Scalars['String']['input']>
  readonly candidate?: InputMaybe<CandidateInput>
  readonly client?: InputMaybe<ClientInput>
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly email?: InputMaybe<Scalars['String']['input']>
  readonly firstName?: InputMaybe<Scalars['String']['input']>
  readonly id: Scalars['ID']['input']
  readonly lastName?: InputMaybe<Scalars['String']['input']>
  readonly location?: InputMaybe<LocationInput>
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>
  readonly secondaryEmail?: InputMaybe<Scalars['String']['input']>
  readonly social?: InputMaybe<SocialInput>
}

/** Autogenerated input type of UpdateUserPassword */
export type UpdateUserPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly confirmPassword: Scalars['String']['input']
  readonly currentPassword: Scalars['String']['input']
  readonly email: Scalars['String']['input']
  readonly newPassword: Scalars['String']['input']
}

/** Autogenerated input type of UpdateUserSearch */
export type UpdateUserSearchInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>
  readonly description?: InputMaybe<Scalars['String']['input']>
  readonly id: Scalars['ID']['input']
  readonly label?: InputMaybe<Scalars['String']['input']>
}

export enum UserPromptIdentifierEnum {
  /** INDISPENSABLE_SURVEY */
  IndispensableSurvey = 'INDISPENSABLE_SURVEY',
}

export enum UserRoleEnum {
  /** candidate user */
  Candidate = 'CANDIDATE',
  /** client user */
  Client = 'CLIENT',
}

export type CompanyFragment = {
  readonly __typename: 'Client'
  readonly id: string
  readonly billingAddress?: string | undefined
  readonly accountsPayableEmail?: string | undefined
  readonly displayname: string
  readonly avatarUrl?: string | undefined
  readonly companySize?: CompanySizeEnum | undefined
  readonly connectionStatus?: ConnectionStatusEnum | undefined
  readonly countAvailablePositions: number
  readonly countRecentPositions: number
  readonly headline: string
  readonly metaDescription: string
  readonly metaTitle: string
  readonly name: string
  readonly profileComplete: boolean
  readonly profileCompletedAt?: any | undefined
  readonly uri: string
  readonly visibleOnPlatform: boolean
  readonly website?: string | undefined
  readonly companyDescription?: string | undefined
  readonly companyEmploymentBenefits?:
    | ReadonlyArray<{
        readonly id: string
        readonly employmentBenefit: {
          readonly icon: string
          readonly id: string
          readonly name: string
        }
      }>
    | undefined
  readonly companyLocations?:
    | ReadonlyArray<{
        readonly address?: string | undefined
        readonly addressExtended?: string | undefined
        readonly city?: string | undefined
        readonly country?: CountriesEnum | undefined
        readonly latitude?: number | undefined
        readonly longitude?: number | undefined
        readonly postalCode?: string | undefined
        readonly rawLocation?: string | undefined
        readonly state?: StatesEnum | undefined
      }>
    | undefined
  readonly companyPhotos?:
    | ReadonlyArray<{
        readonly id: string
        readonly alt?: string | undefined
        readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
        readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
        readonly url: string
      }>
    | undefined
  readonly companyValues?:
    | ReadonlyArray<{
        readonly id: string
        readonly description: string
        readonly title: string
      }>
    | undefined
  readonly location: {
    readonly address?: string | undefined
    readonly addressExtended?: string | undefined
    readonly city?: string | undefined
    readonly country?: CountriesEnum | undefined
    readonly latitude?: number | undefined
    readonly longitude?: number | undefined
    readonly postalCode?: string | undefined
    readonly rawLocation?: string | undefined
    readonly state?: StatesEnum | undefined
  }
  readonly permissions: {
    readonly createJobPosting: boolean
    readonly edit: boolean
    readonly editMeta: boolean
    readonly internalUser: boolean
    readonly readPendingBanner: boolean
    readonly toggleVisible: boolean
  }
  readonly social?:
    | {
        readonly facebook?: string | undefined
        readonly instagram?: string | undefined
        readonly linkedin?: string | undefined
        readonly twitter?: string | undefined
      }
    | undefined
  readonly trainings: { readonly pageInfo: { readonly totalCount: number } }
}

export type Company_EditFragment = {
  readonly id: string
  readonly avatarUrl?: string | undefined
  readonly billingAddress?: string | undefined
  readonly accountsPayableEmail?: string | undefined
  readonly companySize?: CompanySizeEnum | undefined
  readonly description?: string | undefined
  readonly displayname: string
  readonly headline: string
  readonly metaDescription: string
  readonly metaTitle: string
  readonly name: string
  readonly visibleOnPlatform: boolean
  readonly website?: string | undefined
  readonly companyPhotos?:
    | ReadonlyArray<{
        readonly id: string
        readonly alt?: string | undefined
        readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
        readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
        readonly url: string
      }>
    | undefined
  readonly companyEmploymentBenefits?:
    | ReadonlyArray<{
        readonly id: string
        readonly employmentBenefit: {
          readonly icon: string
          readonly id: string
          readonly name: string
        }
      }>
    | undefined
  readonly companyLocations?:
    | ReadonlyArray<{
        readonly address?: string | undefined
        readonly addressExtended?: string | undefined
        readonly city?: string | undefined
        readonly country?: CountriesEnum | undefined
        readonly latitude?: number | undefined
        readonly longitude?: number | undefined
        readonly postalCode?: string | undefined
        readonly rawLocation?: string | undefined
        readonly state?: StatesEnum | undefined
      }>
    | undefined
  readonly companyValues?:
    | ReadonlyArray<{
        readonly id: string
        readonly description: string
        readonly title: string
      }>
    | undefined
  readonly location: {
    readonly address?: string | undefined
    readonly addressExtended?: string | undefined
    readonly city?: string | undefined
    readonly country?: CountriesEnum | undefined
    readonly latitude?: number | undefined
    readonly longitude?: number | undefined
    readonly postalCode?: string | undefined
    readonly rawLocation?: string | undefined
    readonly state?: StatesEnum | undefined
  }
  readonly permissions: {
    readonly toggleVisible: boolean
    readonly editMeta: boolean
  }
  readonly social?:
    | {
        readonly facebook?: string | undefined
        readonly instagram?: string | undefined
        readonly linkedin?: string | undefined
        readonly twitter?: string | undefined
      }
    | undefined
  readonly users?:
    | ReadonlyArray<{
        readonly id: string
        readonly firstName: string
        readonly lastName: string
        readonly email?: string | undefined
      }>
    | undefined
}

export type Company_FollowersFragment = {
  readonly followerCount: number
  readonly followers: {
    readonly edges?:
      | ReadonlyArray<
          | {
              readonly cursor: string
              readonly node?:
                | {
                    readonly __typename: 'Client'
                    readonly id: string
                    readonly billingAddress?: string | undefined
                    readonly accountsPayableEmail?: string | undefined
                    readonly displayname: string
                    readonly avatarUrl?: string | undefined
                    readonly companySize?: CompanySizeEnum | undefined
                    readonly connectionStatus?: ConnectionStatusEnum | undefined
                    readonly countAvailablePositions: number
                    readonly countRecentPositions: number
                    readonly headline: string
                    readonly metaDescription: string
                    readonly metaTitle: string
                    readonly name: string
                    readonly profileComplete: boolean
                    readonly profileCompletedAt?: any | undefined
                    readonly uri: string
                    readonly visibleOnPlatform: boolean
                    readonly website?: string | undefined
                    readonly companyDescription?: string | undefined
                    readonly companyEmploymentBenefits?:
                      | ReadonlyArray<{
                          readonly id: string
                          readonly employmentBenefit: {
                            readonly icon: string
                            readonly id: string
                            readonly name: string
                          }
                        }>
                      | undefined
                    readonly companyLocations?:
                      | ReadonlyArray<{
                          readonly address?: string | undefined
                          readonly addressExtended?: string | undefined
                          readonly city?: string | undefined
                          readonly country?: CountriesEnum | undefined
                          readonly latitude?: number | undefined
                          readonly longitude?: number | undefined
                          readonly postalCode?: string | undefined
                          readonly rawLocation?: string | undefined
                          readonly state?: StatesEnum | undefined
                        }>
                      | undefined
                    readonly companyPhotos?:
                      | ReadonlyArray<{
                          readonly id: string
                          readonly alt?: string | undefined
                          readonly displayRole?:
                            | CompanyPhotoDisplayRoleEnum
                            | undefined
                          readonly mediaType?:
                            | CompanyPhotoMediaTypeEnum
                            | undefined
                          readonly url: string
                        }>
                      | undefined
                    readonly companyValues?:
                      | ReadonlyArray<{
                          readonly id: string
                          readonly description: string
                          readonly title: string
                        }>
                      | undefined
                    readonly location: {
                      readonly address?: string | undefined
                      readonly addressExtended?: string | undefined
                      readonly city?: string | undefined
                      readonly country?: CountriesEnum | undefined
                      readonly latitude?: number | undefined
                      readonly longitude?: number | undefined
                      readonly postalCode?: string | undefined
                      readonly rawLocation?: string | undefined
                      readonly state?: StatesEnum | undefined
                    }
                    readonly permissions: {
                      readonly createJobPosting: boolean
                      readonly edit: boolean
                      readonly editMeta: boolean
                      readonly internalUser: boolean
                      readonly readPendingBanner: boolean
                      readonly toggleVisible: boolean
                    }
                    readonly social?:
                      | {
                          readonly facebook?: string | undefined
                          readonly instagram?: string | undefined
                          readonly linkedin?: string | undefined
                          readonly twitter?: string | undefined
                        }
                      | undefined
                    readonly trainings: {
                      readonly pageInfo: { readonly totalCount: number }
                    }
                  }
                | {
                    readonly __typename: 'User'
                    readonly id: string
                    readonly username: string
                    readonly availability?: string | undefined
                    readonly avatarUrl?: string | undefined
                    readonly connectionCount: number
                    readonly connectionStatus?: ConnectionStatusEnum | undefined
                    readonly email?: string | undefined
                    readonly secondaryEmail?: string | undefined
                    readonly firstName: string
                    readonly indispensableSurveyLink: string
                    readonly isCurrentUser: boolean
                    readonly lastName: string
                    readonly termsAcceptedAt?: any | undefined
                    readonly phoneNumber?: string | undefined
                    readonly uri: string
                    readonly activities?:
                      | { readonly pageInfo: { readonly totalCount: number } }
                      | undefined
                    readonly alerts?:
                      | { readonly pageInfo: { readonly totalCount: number } }
                      | undefined
                    readonly gigsEmployee?:
                      | {
                          readonly id: string
                          readonly createdAt: any
                          readonly deletedAt?: any | undefined
                          readonly eligibleAt?: any | undefined
                          readonly offboardedAt?: any | undefined
                          readonly onboardedAt?: any | undefined
                          readonly onboardingStatus: OnboardingStatusEnum
                          readonly percentComplete?: number | undefined
                          readonly rejectedAt?: any | undefined
                          readonly savedAt?: any | undefined
                          readonly screeningAt?: any | undefined
                          readonly terminatedAt?: any | undefined
                          readonly updatedAt: any
                          readonly permissions: { readonly seeHistory: boolean }
                        }
                      | undefined
                    readonly location: {
                      readonly address?: string | undefined
                      readonly addressExtended?: string | undefined
                      readonly city?: string | undefined
                      readonly country?: CountriesEnum | undefined
                      readonly latitude?: number | undefined
                      readonly longitude?: number | undefined
                      readonly postalCode?: string | undefined
                      readonly rawLocation?: string | undefined
                      readonly state?: StatesEnum | undefined
                    }
                    readonly permissions: {
                      readonly applyToJobs: boolean
                      readonly edit: boolean
                      readonly hasRecruiterLabel: boolean
                      readonly imposter: boolean
                      readonly internalUser: boolean
                      readonly publishJobOrders: boolean
                      readonly readEmail: boolean
                      readonly readJobBooster: boolean
                      readonly readNotes: boolean
                      readonly readPhone: boolean
                      readonly triggerIndispensableSurvey: boolean
                      readonly searchCandidates: boolean
                      readonly searchCandidatesAsClient: boolean
                      readonly searchCandidatesAsRecruiter: boolean
                      readonly searchClients: boolean
                      readonly searchClientsByRecruiters: boolean
                      readonly searchJobPostings: boolean
                      readonly searchJobPostingsByRecruiter: boolean
                      readonly sendMessage: boolean
                      readonly trainableUser: boolean
                      readonly updateConnectionStatus: boolean
                      readonly uploadCsv: boolean
                      readonly matchCriteria: boolean
                    }
                    readonly social?:
                      | {
                          readonly calendly?: string | undefined
                          readonly linkedin?: string | undefined
                        }
                      | undefined
                    readonly candidate?:
                      | {
                          readonly __typename: 'Candidate'
                          readonly id: string
                          readonly backgroundCheckDate?: any | undefined
                          readonly credentialCount: number
                          readonly dnu?: string | undefined
                          readonly hiringStatus?: HiringStatusEnum | undefined
                          readonly i9Date?: any | undefined
                          readonly idealEmployment?: string | undefined
                          readonly isAbleToApply: boolean
                          readonly isNeedEmploymentSponsor?: boolean | undefined
                          readonly isUsWorkAuthorized?: boolean | undefined
                          readonly noWorkExperience?: boolean | undefined
                          readonly profileCompletedAt?: any | undefined
                          readonly profilePercentComplete?: number | undefined
                          readonly relayId: string
                          readonly resumeUrl?: string | undefined
                          readonly salaryExpectations?: string | undefined
                          readonly candidateLicenses?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly date?: any | undefined
                                readonly number?: string | undefined
                                readonly url?: string | undefined
                                readonly license?:
                                  | {
                                      readonly id: string
                                      readonly name: string
                                      readonly country: CountriesEnum
                                      readonly state?: string | undefined
                                    }
                                  | undefined
                              }>
                            | undefined
                          readonly credentials?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly title: string
                                readonly badgeUrl: string
                                readonly description?: string | undefined
                                readonly training: {
                                  readonly id: string
                                  readonly trainingUrl: string
                                }
                              }>
                            | undefined
                          readonly education?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly degree?: string | undefined
                                readonly educationLevel?:
                                  | EducationLevelEnum
                                  | undefined
                                readonly school?: string | undefined
                                readonly yearsAttended?: number | undefined
                              }>
                            | undefined
                          readonly experiences?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly companyName?: string | undefined
                                readonly current?: boolean | undefined
                                readonly endDate?: any | undefined
                                readonly jobTitle?: string | undefined
                                readonly responsibilities?: string | undefined
                                readonly startDate?: any | undefined
                                readonly yearsEmployed?: number | undefined
                              }>
                            | undefined
                          readonly placements?:
                            | ReadonlyArray<{
                                readonly startDate?: any | undefined
                                readonly id: string
                                readonly interviewDate?: any | undefined
                                readonly status?:
                                  | PlacementStatusEnum
                                  | undefined
                                readonly permissions: {
                                  readonly update: boolean
                                }
                                readonly jobPosting: {
                                  readonly id: string
                                  readonly slug: string
                                  readonly title: string
                                  readonly client?:
                                    | { readonly displayname: string }
                                    | undefined
                                  readonly permissions: {
                                    readonly readJobApps: boolean
                                    readonly readPlacements: boolean
                                  }
                                }
                              }>
                            | undefined
                          readonly jobApplications?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly status?:
                                  | JobApplicationStatusEnum
                                  | undefined
                                readonly permissions: { readonly show: boolean }
                                readonly jobPosting: {
                                  readonly id: string
                                  readonly level?: number | undefined
                                  readonly slug: string
                                  readonly title: string
                                  readonly client?:
                                    | {
                                        readonly displayname: string
                                        readonly name: string
                                      }
                                    | undefined
                                  readonly permissions: {
                                    readonly readJobApps: boolean
                                    readonly readPlacements: boolean
                                    readonly managePlacements: boolean
                                  }
                                  readonly jobPostingScreening?:
                                    | { readonly id: string }
                                    | undefined
                                }
                                readonly screeningSubmissions?:
                                  | ReadonlyArray<{ readonly id: string }>
                                  | undefined
                              }>
                            | undefined
                          readonly permissions: {
                            readonly edit: boolean
                            readonly readApplications: boolean
                            readonly readCredentials: boolean
                            readonly readLicense: boolean
                            readonly readResume: boolean
                            readonly readWorkPreferences: boolean
                          }
                          readonly recruiters?:
                            | ReadonlyArray<{
                                readonly avatarUrl?: string | undefined
                                readonly firstName: string
                                readonly id: string
                                readonly lastName: string
                              }>
                            | undefined
                          readonly skillRelations?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly years: number
                                readonly skill: {
                                  readonly __typename: 'Skill'
                                  readonly id: string
                                  readonly name: string
                                }
                              }>
                            | undefined
                          readonly summary?:
                            | {
                                readonly id: string
                                readonly entry: string
                                readonly title: string
                              }
                            | undefined
                        }
                      | undefined
                    readonly subscription?:
                      | {
                          readonly __typename: 'Subscription'
                          readonly id: string
                          readonly active: boolean
                          readonly plan: string
                        }
                      | undefined
                  }
                | undefined
            }
          | undefined
        >
      | undefined
    readonly pageInfo: {
      readonly endCursor?: string | undefined
      readonly hasNextPage: boolean
      readonly hasPreviousPage: boolean
      readonly startCursor?: string | undefined
    }
  }
}

export type Company_JobPostingsFragment = {
  readonly jobPostings: {
    readonly edges?:
      | ReadonlyArray<
          | {
              readonly cursor: string
              readonly node?:
                | {
                    readonly __typename: 'JobPosting'
                    readonly id: string
                    readonly accountsPayableEmail?: string | undefined
                    readonly applicationReceived: boolean
                    readonly atsRecordType?: string | undefined
                    readonly atsStatus?: JobPostingAtsStatusEnum | undefined
                    readonly baseSalaryValue: number
                    readonly countJobApplicationsNew: number
                    readonly countJobApplicationsTotal: number
                    readonly description: string
                    readonly depositAmount?: number | undefined
                    readonly education?: string | undefined
                    readonly employmentTypes?:
                      | ReadonlyArray<EmploymentTypesEnum>
                      | undefined
                    readonly endDate?: any | undefined
                    readonly quantity?: number | undefined
                    readonly experience?: string | undefined
                    readonly externalId?: string | undefined
                    readonly isIngested: boolean
                    readonly isPublished: boolean
                    readonly isRemote: boolean
                    readonly physicalRequirements?: string | undefined
                    readonly postedAt?: any | undefined
                    readonly shift?: string | undefined
                    readonly syndicateIndeed: boolean
                    readonly responsibilities?: string | undefined
                    readonly slug: string
                    readonly startDate?: any | undefined
                    readonly submitApplicationUrl?: string | undefined
                    readonly title: string
                    readonly uri: string
                    readonly validThrough: any
                    readonly workingEnvironment?: string | undefined
                    readonly accountExecs?:
                      | ReadonlyArray<{
                          readonly avatarUrl?: string | undefined
                          readonly firstName: string
                          readonly id: string
                          readonly lastName: string
                          readonly username: string
                        }>
                      | undefined
                    readonly activities?:
                      | { readonly pageInfo: { readonly totalCount: number } }
                      | undefined
                    readonly client?:
                      | {
                          readonly __typename: 'Client'
                          readonly id: string
                          readonly displayname: string
                          readonly avatarUrl?: string | undefined
                          readonly billingAddress?: string | undefined
                          readonly companySize?: CompanySizeEnum | undefined
                          readonly connectionStatus?:
                            | ConnectionStatusEnum
                            | undefined
                          readonly countAvailablePositions: number
                          readonly countRecentPositions: number
                          readonly description?: string | undefined
                          readonly headline: string
                          readonly name: string
                          readonly profileComplete: boolean
                          readonly profileCompletedAt?: any | undefined
                          readonly visibleOnPlatform: boolean
                          readonly website?: string | undefined
                          readonly companyEmploymentBenefits?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly employmentBenefit: {
                                  readonly icon: string
                                  readonly id: string
                                  readonly name: string
                                }
                              }>
                            | undefined
                          readonly companyLocations?:
                            | ReadonlyArray<{
                                readonly address?: string | undefined
                                readonly addressExtended?: string | undefined
                                readonly city?: string | undefined
                                readonly country?: CountriesEnum | undefined
                                readonly latitude?: number | undefined
                                readonly longitude?: number | undefined
                                readonly postalCode?: string | undefined
                                readonly rawLocation?: string | undefined
                                readonly state?: StatesEnum | undefined
                              }>
                            | undefined
                          readonly companyPhotos?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly alt?: string | undefined
                                readonly displayRole?:
                                  | CompanyPhotoDisplayRoleEnum
                                  | undefined
                                readonly mediaType?:
                                  | CompanyPhotoMediaTypeEnum
                                  | undefined
                                readonly url: string
                              }>
                            | undefined
                          readonly companyValues?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly description: string
                                readonly title: string
                              }>
                            | undefined
                          readonly location: {
                            readonly address?: string | undefined
                            readonly addressExtended?: string | undefined
                            readonly city?: string | undefined
                            readonly country?: CountriesEnum | undefined
                            readonly latitude?: number | undefined
                            readonly longitude?: number | undefined
                            readonly postalCode?: string | undefined
                            readonly rawLocation?: string | undefined
                            readonly state?: StatesEnum | undefined
                          }
                          readonly permissions: {
                            readonly createJobPosting: boolean
                            readonly edit: boolean
                            readonly readPendingBanner: boolean
                            readonly toggleVisible: boolean
                          }
                          readonly social?:
                            | {
                                readonly facebook?: string | undefined
                                readonly instagram?: string | undefined
                                readonly linkedin?: string | undefined
                                readonly twitter?: string | undefined
                              }
                            | undefined
                        }
                      | undefined
                    readonly associatedClient?:
                      | {
                          readonly __typename: 'Client'
                          readonly id: string
                          readonly displayname: string
                          readonly avatarUrl?: string | undefined
                          readonly billingAddress?: string | undefined
                          readonly companySize?: CompanySizeEnum | undefined
                          readonly connectionStatus?:
                            | ConnectionStatusEnum
                            | undefined
                          readonly countAvailablePositions: number
                          readonly countRecentPositions: number
                          readonly description?: string | undefined
                          readonly headline: string
                          readonly name: string
                          readonly profileComplete: boolean
                          readonly profileCompletedAt?: any | undefined
                          readonly visibleOnPlatform: boolean
                          readonly website?: string | undefined
                          readonly companyEmploymentBenefits?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly employmentBenefit: {
                                  readonly icon: string
                                  readonly id: string
                                  readonly name: string
                                }
                              }>
                            | undefined
                          readonly companyLocations?:
                            | ReadonlyArray<{
                                readonly address?: string | undefined
                                readonly addressExtended?: string | undefined
                                readonly city?: string | undefined
                                readonly country?: CountriesEnum | undefined
                                readonly latitude?: number | undefined
                                readonly longitude?: number | undefined
                                readonly postalCode?: string | undefined
                                readonly rawLocation?: string | undefined
                                readonly state?: StatesEnum | undefined
                              }>
                            | undefined
                          readonly companyPhotos?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly alt?: string | undefined
                                readonly displayRole?:
                                  | CompanyPhotoDisplayRoleEnum
                                  | undefined
                                readonly mediaType?:
                                  | CompanyPhotoMediaTypeEnum
                                  | undefined
                                readonly url: string
                              }>
                            | undefined
                          readonly companyValues?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly description: string
                                readonly title: string
                              }>
                            | undefined
                          readonly location: {
                            readonly address?: string | undefined
                            readonly addressExtended?: string | undefined
                            readonly city?: string | undefined
                            readonly country?: CountriesEnum | undefined
                            readonly latitude?: number | undefined
                            readonly longitude?: number | undefined
                            readonly postalCode?: string | undefined
                            readonly rawLocation?: string | undefined
                            readonly state?: StatesEnum | undefined
                          }
                          readonly permissions: {
                            readonly createJobPosting: boolean
                            readonly edit: boolean
                            readonly readPendingBanner: boolean
                            readonly toggleVisible: boolean
                          }
                          readonly social?:
                            | {
                                readonly facebook?: string | undefined
                                readonly instagram?: string | undefined
                                readonly linkedin?: string | undefined
                                readonly twitter?: string | undefined
                              }
                            | undefined
                        }
                      | undefined
                    readonly employmentBenefits?:
                      | ReadonlyArray<{
                          readonly id: string
                          readonly employmentBenefit: {
                            readonly icon: string
                            readonly id: string
                            readonly name: string
                          }
                        }>
                      | undefined
                    readonly jobApplicationStatusCounts?:
                      | ReadonlyArray<{
                          readonly count: number
                          readonly status?: JobApplicationStatusEnum | undefined
                        }>
                      | undefined
                    readonly gigsInfo?:
                      | {
                          readonly additionalRequirements?: string | undefined
                          readonly billRate?: number | undefined
                          readonly costCenterCreated?: boolean | undefined
                          readonly companyOnboarded?: boolean | undefined
                          readonly details?: string | undefined
                          readonly engagementDeposit?: boolean | undefined
                          readonly kickoffCall?: boolean | undefined
                          readonly level?: number | undefined
                          readonly payRate?: number | undefined
                          readonly salaryPayPeriod?: PayPeriodEnum | undefined
                          readonly dressCode?: string | undefined
                          readonly specialRequests?: string | undefined
                          readonly parkingFacilityInformation?:
                            | string
                            | undefined
                        }
                      | undefined
                    readonly jobPostingScreening?:
                      | {
                          readonly id: string
                          readonly screening?:
                            | {
                                readonly id: string
                                readonly description?: string | undefined
                                readonly name?: string | undefined
                                readonly screeningQuestions?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly typeOf?: string | undefined
                                      readonly question?: string | undefined
                                    }>
                                  | undefined
                              }
                            | undefined
                        }
                      | undefined
                    readonly location: {
                      readonly address?: string | undefined
                      readonly addressExtended?: string | undefined
                      readonly city?: string | undefined
                      readonly country?: CountriesEnum | undefined
                      readonly latitude?: number | undefined
                      readonly longitude?: number | undefined
                      readonly postalCode?: string | undefined
                      readonly rawLocation?: string | undefined
                      readonly state?: StatesEnum | undefined
                    }
                    readonly permissions: {
                      readonly destroy: boolean
                      readonly edit: boolean
                      readonly internalUser: boolean
                      readonly managePlacements: boolean
                      readonly readEndDate: boolean
                      readonly readJobApps: boolean
                      readonly readPlacements: boolean
                      readonly togglePublished: boolean
                      readonly writeAtsRecordType: boolean
                      readonly writeRecruiterToJob: boolean
                      readonly writeSubmitApplicationUrl: boolean
                    }
                    readonly placements?:
                      | ReadonlyArray<{
                          readonly id: string
                          readonly status?: PlacementStatusEnum | undefined
                        }>
                      | undefined
                    readonly placementStatusCounts?:
                      | ReadonlyArray<{
                          readonly count: number
                          readonly status?: PlacementStatusEnum | undefined
                        }>
                      | undefined
                    readonly primaryContact?:
                      | {
                          readonly avatarUrl?: string | undefined
                          readonly firstName: string
                          readonly id: string
                          readonly lastName: string
                        }
                      | undefined
                    readonly recommendedCredentials?:
                      | ReadonlyArray<{
                          readonly id: string
                          readonly credential: {
                            readonly __typename: 'Credential'
                            readonly id: string
                            readonly badgeUrl: string
                            readonly description?: string | undefined
                            readonly title: string
                            readonly training: {
                              readonly id: string
                              readonly trainingUrl: string
                            }
                          }
                        }>
                      | undefined
                    readonly recruiters?:
                      | ReadonlyArray<{
                          readonly avatarUrl?: string | undefined
                          readonly firstName: string
                          readonly id: string
                          readonly lastName: string
                          readonly username: string
                        }>
                      | undefined
                    readonly timeSheetManagers?:
                      | ReadonlyArray<{
                          readonly avatarUrl?: string | undefined
                          readonly firstName: string
                          readonly id: string
                          readonly lastName: string
                          readonly username: string
                        }>
                      | undefined
                    readonly requiredLicenses: ReadonlyArray<{
                      readonly id: string
                      readonly license: {
                        readonly id: string
                        readonly name: string
                        readonly country: CountriesEnum
                        readonly state?: string | undefined
                      }
                    }>
                    readonly salaryRange?:
                      | {
                          readonly maxValue?: number | undefined
                          readonly minValue?: number | undefined
                          readonly payPeriod?: PayPeriodEnum | undefined
                        }
                      | undefined
                  }
                | undefined
            }
          | undefined
        >
      | undefined
    readonly pageInfo: {
      readonly endCursor?: string | undefined
      readonly hasNextPage: boolean
      readonly hasPreviousPage: boolean
      readonly startCursor?: string | undefined
      readonly totalCount: number
    }
  }
}

export type Company_PhotosFragment = {
  readonly companyPhotos?:
    | ReadonlyArray<{
        readonly id: string
        readonly alt?: string | undefined
        readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
        readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
        readonly url: string
      }>
    | undefined
}

export type Company_JobApplicationFragment = {
  readonly __typename: 'JobApplication'
  readonly id: string
  readonly atsRecordType?: string | undefined
  readonly createdAt: any
  readonly clientInterestAt?: any | undefined
  readonly clientInterestMessage: string
  readonly hasClientInterest: boolean
  readonly status?: JobApplicationStatusEnum | undefined
  readonly jobPosting: {
    readonly id: string
    readonly level?: number | undefined
    readonly title: string
    readonly slug: string
    readonly jobPostingScreening?:
      | {
          readonly id: string
          readonly screening?:
            | {
                readonly id: string
                readonly description?: string | undefined
                readonly name?: string | undefined
                readonly screeningQuestions?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly typeOf?: string | undefined
                      readonly question?: string | undefined
                    }>
                  | undefined
              }
            | undefined
        }
      | undefined
    readonly location: {
      readonly city?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly client?: { readonly displayname: string } | undefined
  }
  readonly permissions: {
    readonly indicateInterest: boolean
    readonly show: boolean
  }
  readonly screeningSubmissions?:
    | ReadonlyArray<{
        readonly id: string
        readonly jobApplication?:
          | {
              readonly id: string
              readonly jobPosting: {
                readonly id: string
                readonly title: string
                readonly slug: string
              }
            }
          | undefined
        readonly screeningQResponses?:
          | ReadonlyArray<{
              readonly id: string
              readonly answer?: any | undefined
              readonly screeningQuestion?:
                | {
                    readonly id: string
                    readonly question?: string | undefined
                  }
                | undefined
            }>
          | undefined
      }>
    | undefined
  readonly user?:
    | {
        readonly __typename: 'User'
        readonly id: string
        readonly username: string
        readonly availability?: string | undefined
        readonly avatarUrl?: string | undefined
        readonly connectionCount: number
        readonly connectionStatus?: ConnectionStatusEnum | undefined
        readonly email?: string | undefined
        readonly secondaryEmail?: string | undefined
        readonly firstName: string
        readonly indispensableSurveyLink: string
        readonly isCurrentUser: boolean
        readonly lastName: string
        readonly termsAcceptedAt?: any | undefined
        readonly phoneNumber?: string | undefined
        readonly uri: string
        readonly activities?:
          | { readonly pageInfo: { readonly totalCount: number } }
          | undefined
        readonly alerts?:
          | { readonly pageInfo: { readonly totalCount: number } }
          | undefined
        readonly gigsEmployee?:
          | {
              readonly id: string
              readonly createdAt: any
              readonly deletedAt?: any | undefined
              readonly eligibleAt?: any | undefined
              readonly offboardedAt?: any | undefined
              readonly onboardedAt?: any | undefined
              readonly onboardingStatus: OnboardingStatusEnum
              readonly percentComplete?: number | undefined
              readonly rejectedAt?: any | undefined
              readonly savedAt?: any | undefined
              readonly screeningAt?: any | undefined
              readonly terminatedAt?: any | undefined
              readonly updatedAt: any
              readonly permissions: { readonly seeHistory: boolean }
            }
          | undefined
        readonly location: {
          readonly address?: string | undefined
          readonly addressExtended?: string | undefined
          readonly city?: string | undefined
          readonly country?: CountriesEnum | undefined
          readonly latitude?: number | undefined
          readonly longitude?: number | undefined
          readonly postalCode?: string | undefined
          readonly rawLocation?: string | undefined
          readonly state?: StatesEnum | undefined
        }
        readonly permissions: {
          readonly applyToJobs: boolean
          readonly edit: boolean
          readonly hasRecruiterLabel: boolean
          readonly imposter: boolean
          readonly internalUser: boolean
          readonly publishJobOrders: boolean
          readonly readEmail: boolean
          readonly readJobBooster: boolean
          readonly readNotes: boolean
          readonly readPhone: boolean
          readonly triggerIndispensableSurvey: boolean
          readonly searchCandidates: boolean
          readonly searchCandidatesAsClient: boolean
          readonly searchCandidatesAsRecruiter: boolean
          readonly searchClients: boolean
          readonly searchClientsByRecruiters: boolean
          readonly searchJobPostings: boolean
          readonly searchJobPostingsByRecruiter: boolean
          readonly sendMessage: boolean
          readonly trainableUser: boolean
          readonly updateConnectionStatus: boolean
          readonly uploadCsv: boolean
          readonly matchCriteria: boolean
        }
        readonly social?:
          | {
              readonly calendly?: string | undefined
              readonly linkedin?: string | undefined
            }
          | undefined
        readonly candidate?:
          | {
              readonly __typename: 'Candidate'
              readonly id: string
              readonly backgroundCheckDate?: any | undefined
              readonly credentialCount: number
              readonly dnu?: string | undefined
              readonly hiringStatus?: HiringStatusEnum | undefined
              readonly i9Date?: any | undefined
              readonly idealEmployment?: string | undefined
              readonly isAbleToApply: boolean
              readonly isNeedEmploymentSponsor?: boolean | undefined
              readonly isUsWorkAuthorized?: boolean | undefined
              readonly noWorkExperience?: boolean | undefined
              readonly profileCompletedAt?: any | undefined
              readonly profilePercentComplete?: number | undefined
              readonly relayId: string
              readonly resumeUrl?: string | undefined
              readonly salaryExpectations?: string | undefined
              readonly candidateLicenses?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly date?: any | undefined
                    readonly number?: string | undefined
                    readonly url?: string | undefined
                    readonly license?:
                      | {
                          readonly id: string
                          readonly name: string
                          readonly country: CountriesEnum
                          readonly state?: string | undefined
                        }
                      | undefined
                  }>
                | undefined
              readonly credentials?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly title: string
                    readonly badgeUrl: string
                    readonly description?: string | undefined
                    readonly training: {
                      readonly id: string
                      readonly trainingUrl: string
                    }
                  }>
                | undefined
              readonly education?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly degree?: string | undefined
                    readonly educationLevel?: EducationLevelEnum | undefined
                    readonly school?: string | undefined
                    readonly yearsAttended?: number | undefined
                  }>
                | undefined
              readonly experiences?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly companyName?: string | undefined
                    readonly current?: boolean | undefined
                    readonly endDate?: any | undefined
                    readonly jobTitle?: string | undefined
                    readonly responsibilities?: string | undefined
                    readonly startDate?: any | undefined
                    readonly yearsEmployed?: number | undefined
                  }>
                | undefined
              readonly placements?:
                | ReadonlyArray<{
                    readonly startDate?: any | undefined
                    readonly id: string
                    readonly interviewDate?: any | undefined
                    readonly status?: PlacementStatusEnum | undefined
                    readonly permissions: { readonly update: boolean }
                    readonly jobPosting: {
                      readonly id: string
                      readonly slug: string
                      readonly title: string
                      readonly client?:
                        | { readonly displayname: string }
                        | undefined
                      readonly permissions: {
                        readonly readJobApps: boolean
                        readonly readPlacements: boolean
                      }
                    }
                  }>
                | undefined
              readonly jobApplications?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly status?: JobApplicationStatusEnum | undefined
                    readonly permissions: { readonly show: boolean }
                    readonly jobPosting: {
                      readonly id: string
                      readonly level?: number | undefined
                      readonly slug: string
                      readonly title: string
                      readonly client?:
                        | {
                            readonly displayname: string
                            readonly name: string
                          }
                        | undefined
                      readonly permissions: {
                        readonly readJobApps: boolean
                        readonly readPlacements: boolean
                        readonly managePlacements: boolean
                      }
                      readonly jobPostingScreening?:
                        | { readonly id: string }
                        | undefined
                    }
                    readonly screeningSubmissions?:
                      | ReadonlyArray<{ readonly id: string }>
                      | undefined
                  }>
                | undefined
              readonly permissions: {
                readonly edit: boolean
                readonly readApplications: boolean
                readonly readCredentials: boolean
                readonly readLicense: boolean
                readonly readResume: boolean
                readonly readWorkPreferences: boolean
              }
              readonly recruiters?:
                | ReadonlyArray<{
                    readonly avatarUrl?: string | undefined
                    readonly firstName: string
                    readonly id: string
                    readonly lastName: string
                  }>
                | undefined
              readonly skillRelations?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly years: number
                    readonly skill: {
                      readonly __typename: 'Skill'
                      readonly id: string
                      readonly name: string
                    }
                  }>
                | undefined
              readonly summary?:
                | {
                    readonly id: string
                    readonly entry: string
                    readonly title: string
                  }
                | undefined
            }
          | undefined
        readonly subscription?:
          | {
              readonly __typename: 'Subscription'
              readonly id: string
              readonly active: boolean
              readonly plan: string
            }
          | undefined
      }
    | undefined
}

export type CompanyJobApplications_JobApplicationConnectionFragment = {
  readonly edges?:
    | ReadonlyArray<
        | {
            readonly cursor: string
            readonly node?:
              | {
                  readonly __typename: 'JobApplication'
                  readonly id: string
                  readonly atsRecordType?: string | undefined
                  readonly createdAt: any
                  readonly clientInterestAt?: any | undefined
                  readonly clientInterestMessage: string
                  readonly hasClientInterest: boolean
                  readonly status?: JobApplicationStatusEnum | undefined
                  readonly jobPosting: {
                    readonly id: string
                    readonly level?: number | undefined
                    readonly title: string
                    readonly slug: string
                    readonly jobPostingScreening?:
                      | {
                          readonly id: string
                          readonly screening?:
                            | {
                                readonly id: string
                                readonly description?: string | undefined
                                readonly name?: string | undefined
                                readonly screeningQuestions?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly typeOf?: string | undefined
                                      readonly question?: string | undefined
                                    }>
                                  | undefined
                              }
                            | undefined
                        }
                      | undefined
                    readonly location: {
                      readonly city?: string | undefined
                      readonly state?: StatesEnum | undefined
                    }
                    readonly client?:
                      | { readonly displayname: string }
                      | undefined
                  }
                  readonly permissions: {
                    readonly indicateInterest: boolean
                    readonly show: boolean
                  }
                  readonly screeningSubmissions?:
                    | ReadonlyArray<{
                        readonly id: string
                        readonly jobApplication?:
                          | {
                              readonly id: string
                              readonly jobPosting: {
                                readonly id: string
                                readonly title: string
                                readonly slug: string
                              }
                            }
                          | undefined
                        readonly screeningQResponses?:
                          | ReadonlyArray<{
                              readonly id: string
                              readonly answer?: any | undefined
                              readonly screeningQuestion?:
                                | {
                                    readonly id: string
                                    readonly question?: string | undefined
                                  }
                                | undefined
                            }>
                          | undefined
                      }>
                    | undefined
                  readonly user?:
                    | {
                        readonly __typename: 'User'
                        readonly id: string
                        readonly username: string
                        readonly availability?: string | undefined
                        readonly avatarUrl?: string | undefined
                        readonly connectionCount: number
                        readonly connectionStatus?:
                          | ConnectionStatusEnum
                          | undefined
                        readonly email?: string | undefined
                        readonly secondaryEmail?: string | undefined
                        readonly firstName: string
                        readonly indispensableSurveyLink: string
                        readonly isCurrentUser: boolean
                        readonly lastName: string
                        readonly termsAcceptedAt?: any | undefined
                        readonly phoneNumber?: string | undefined
                        readonly uri: string
                        readonly activities?:
                          | {
                              readonly pageInfo: { readonly totalCount: number }
                            }
                          | undefined
                        readonly alerts?:
                          | {
                              readonly pageInfo: { readonly totalCount: number }
                            }
                          | undefined
                        readonly gigsEmployee?:
                          | {
                              readonly id: string
                              readonly createdAt: any
                              readonly deletedAt?: any | undefined
                              readonly eligibleAt?: any | undefined
                              readonly offboardedAt?: any | undefined
                              readonly onboardedAt?: any | undefined
                              readonly onboardingStatus: OnboardingStatusEnum
                              readonly percentComplete?: number | undefined
                              readonly rejectedAt?: any | undefined
                              readonly savedAt?: any | undefined
                              readonly screeningAt?: any | undefined
                              readonly terminatedAt?: any | undefined
                              readonly updatedAt: any
                              readonly permissions: {
                                readonly seeHistory: boolean
                              }
                            }
                          | undefined
                        readonly location: {
                          readonly address?: string | undefined
                          readonly addressExtended?: string | undefined
                          readonly city?: string | undefined
                          readonly country?: CountriesEnum | undefined
                          readonly latitude?: number | undefined
                          readonly longitude?: number | undefined
                          readonly postalCode?: string | undefined
                          readonly rawLocation?: string | undefined
                          readonly state?: StatesEnum | undefined
                        }
                        readonly permissions: {
                          readonly applyToJobs: boolean
                          readonly edit: boolean
                          readonly hasRecruiterLabel: boolean
                          readonly imposter: boolean
                          readonly internalUser: boolean
                          readonly publishJobOrders: boolean
                          readonly readEmail: boolean
                          readonly readJobBooster: boolean
                          readonly readNotes: boolean
                          readonly readPhone: boolean
                          readonly triggerIndispensableSurvey: boolean
                          readonly searchCandidates: boolean
                          readonly searchCandidatesAsClient: boolean
                          readonly searchCandidatesAsRecruiter: boolean
                          readonly searchClients: boolean
                          readonly searchClientsByRecruiters: boolean
                          readonly searchJobPostings: boolean
                          readonly searchJobPostingsByRecruiter: boolean
                          readonly sendMessage: boolean
                          readonly trainableUser: boolean
                          readonly updateConnectionStatus: boolean
                          readonly uploadCsv: boolean
                          readonly matchCriteria: boolean
                        }
                        readonly social?:
                          | {
                              readonly calendly?: string | undefined
                              readonly linkedin?: string | undefined
                            }
                          | undefined
                        readonly candidate?:
                          | {
                              readonly __typename: 'Candidate'
                              readonly id: string
                              readonly backgroundCheckDate?: any | undefined
                              readonly credentialCount: number
                              readonly dnu?: string | undefined
                              readonly hiringStatus?:
                                | HiringStatusEnum
                                | undefined
                              readonly i9Date?: any | undefined
                              readonly idealEmployment?: string | undefined
                              readonly isAbleToApply: boolean
                              readonly isNeedEmploymentSponsor?:
                                | boolean
                                | undefined
                              readonly isUsWorkAuthorized?: boolean | undefined
                              readonly noWorkExperience?: boolean | undefined
                              readonly profileCompletedAt?: any | undefined
                              readonly profilePercentComplete?:
                                | number
                                | undefined
                              readonly relayId: string
                              readonly resumeUrl?: string | undefined
                              readonly salaryExpectations?: string | undefined
                              readonly candidateLicenses?:
                                | ReadonlyArray<{
                                    readonly id: string
                                    readonly date?: any | undefined
                                    readonly number?: string | undefined
                                    readonly url?: string | undefined
                                    readonly license?:
                                      | {
                                          readonly id: string
                                          readonly name: string
                                          readonly country: CountriesEnum
                                          readonly state?: string | undefined
                                        }
                                      | undefined
                                  }>
                                | undefined
                              readonly credentials?:
                                | ReadonlyArray<{
                                    readonly id: string
                                    readonly title: string
                                    readonly badgeUrl: string
                                    readonly description?: string | undefined
                                    readonly training: {
                                      readonly id: string
                                      readonly trainingUrl: string
                                    }
                                  }>
                                | undefined
                              readonly education?:
                                | ReadonlyArray<{
                                    readonly id: string
                                    readonly degree?: string | undefined
                                    readonly educationLevel?:
                                      | EducationLevelEnum
                                      | undefined
                                    readonly school?: string | undefined
                                    readonly yearsAttended?: number | undefined
                                  }>
                                | undefined
                              readonly experiences?:
                                | ReadonlyArray<{
                                    readonly id: string
                                    readonly companyName?: string | undefined
                                    readonly current?: boolean | undefined
                                    readonly endDate?: any | undefined
                                    readonly jobTitle?: string | undefined
                                    readonly responsibilities?:
                                      | string
                                      | undefined
                                    readonly startDate?: any | undefined
                                    readonly yearsEmployed?: number | undefined
                                  }>
                                | undefined
                              readonly placements?:
                                | ReadonlyArray<{
                                    readonly startDate?: any | undefined
                                    readonly id: string
                                    readonly interviewDate?: any | undefined
                                    readonly status?:
                                      | PlacementStatusEnum
                                      | undefined
                                    readonly permissions: {
                                      readonly update: boolean
                                    }
                                    readonly jobPosting: {
                                      readonly id: string
                                      readonly slug: string
                                      readonly title: string
                                      readonly client?:
                                        | { readonly displayname: string }
                                        | undefined
                                      readonly permissions: {
                                        readonly readJobApps: boolean
                                        readonly readPlacements: boolean
                                      }
                                    }
                                  }>
                                | undefined
                              readonly jobApplications?:
                                | ReadonlyArray<{
                                    readonly id: string
                                    readonly status?:
                                      | JobApplicationStatusEnum
                                      | undefined
                                    readonly permissions: {
                                      readonly show: boolean
                                    }
                                    readonly jobPosting: {
                                      readonly id: string
                                      readonly level?: number | undefined
                                      readonly slug: string
                                      readonly title: string
                                      readonly client?:
                                        | {
                                            readonly displayname: string
                                            readonly name: string
                                          }
                                        | undefined
                                      readonly permissions: {
                                        readonly readJobApps: boolean
                                        readonly readPlacements: boolean
                                        readonly managePlacements: boolean
                                      }
                                      readonly jobPostingScreening?:
                                        | { readonly id: string }
                                        | undefined
                                    }
                                    readonly screeningSubmissions?:
                                      | ReadonlyArray<{ readonly id: string }>
                                      | undefined
                                  }>
                                | undefined
                              readonly permissions: {
                                readonly edit: boolean
                                readonly readApplications: boolean
                                readonly readCredentials: boolean
                                readonly readLicense: boolean
                                readonly readResume: boolean
                                readonly readWorkPreferences: boolean
                              }
                              readonly recruiters?:
                                | ReadonlyArray<{
                                    readonly avatarUrl?: string | undefined
                                    readonly firstName: string
                                    readonly id: string
                                    readonly lastName: string
                                  }>
                                | undefined
                              readonly skillRelations?:
                                | ReadonlyArray<{
                                    readonly id: string
                                    readonly years: number
                                    readonly skill: {
                                      readonly __typename: 'Skill'
                                      readonly id: string
                                      readonly name: string
                                    }
                                  }>
                                | undefined
                              readonly summary?:
                                | {
                                    readonly id: string
                                    readonly entry: string
                                    readonly title: string
                                  }
                                | undefined
                            }
                          | undefined
                        readonly subscription?:
                          | {
                              readonly __typename: 'Subscription'
                              readonly id: string
                              readonly active: boolean
                              readonly plan: string
                            }
                          | undefined
                      }
                    | undefined
                }
              | undefined
          }
        | undefined
      >
    | undefined
  readonly pageInfo: {
    readonly endCursor?: string | undefined
    readonly hasNextPage: boolean
    readonly hasPreviousPage: boolean
    readonly startCursor?: string | undefined
    readonly totalCount: number
  }
}

export type Company_PlacementFragment = {
  readonly __typename: 'Placement'
  readonly id: string
  readonly createdAt: any
  readonly interviewDate?: any | undefined
  readonly startDate?: any | undefined
  readonly status?: PlacementStatusEnum | undefined
  readonly updatedAt: any
  readonly jobPosting: { readonly id: string }
  readonly permissions: { readonly seeHistory: boolean }
  readonly history?:
    | ReadonlyArray<{
        readonly __typename: 'Version'
        readonly whodunnit?: string | undefined
      }>
    | undefined
  readonly user?:
    | {
        readonly __typename: 'User'
        readonly id: string
        readonly username: string
        readonly availability?: string | undefined
        readonly avatarUrl?: string | undefined
        readonly connectionCount: number
        readonly connectionStatus?: ConnectionStatusEnum | undefined
        readonly email?: string | undefined
        readonly secondaryEmail?: string | undefined
        readonly firstName: string
        readonly indispensableSurveyLink: string
        readonly isCurrentUser: boolean
        readonly lastName: string
        readonly termsAcceptedAt?: any | undefined
        readonly phoneNumber?: string | undefined
        readonly uri: string
        readonly activities?:
          | { readonly pageInfo: { readonly totalCount: number } }
          | undefined
        readonly alerts?:
          | { readonly pageInfo: { readonly totalCount: number } }
          | undefined
        readonly gigsEmployee?:
          | {
              readonly id: string
              readonly createdAt: any
              readonly deletedAt?: any | undefined
              readonly eligibleAt?: any | undefined
              readonly offboardedAt?: any | undefined
              readonly onboardedAt?: any | undefined
              readonly onboardingStatus: OnboardingStatusEnum
              readonly percentComplete?: number | undefined
              readonly rejectedAt?: any | undefined
              readonly savedAt?: any | undefined
              readonly screeningAt?: any | undefined
              readonly terminatedAt?: any | undefined
              readonly updatedAt: any
              readonly permissions: { readonly seeHistory: boolean }
            }
          | undefined
        readonly location: {
          readonly address?: string | undefined
          readonly addressExtended?: string | undefined
          readonly city?: string | undefined
          readonly country?: CountriesEnum | undefined
          readonly latitude?: number | undefined
          readonly longitude?: number | undefined
          readonly postalCode?: string | undefined
          readonly rawLocation?: string | undefined
          readonly state?: StatesEnum | undefined
        }
        readonly permissions: {
          readonly applyToJobs: boolean
          readonly edit: boolean
          readonly hasRecruiterLabel: boolean
          readonly imposter: boolean
          readonly internalUser: boolean
          readonly publishJobOrders: boolean
          readonly readEmail: boolean
          readonly readJobBooster: boolean
          readonly readNotes: boolean
          readonly readPhone: boolean
          readonly triggerIndispensableSurvey: boolean
          readonly searchCandidates: boolean
          readonly searchCandidatesAsClient: boolean
          readonly searchCandidatesAsRecruiter: boolean
          readonly searchClients: boolean
          readonly searchClientsByRecruiters: boolean
          readonly searchJobPostings: boolean
          readonly searchJobPostingsByRecruiter: boolean
          readonly sendMessage: boolean
          readonly trainableUser: boolean
          readonly updateConnectionStatus: boolean
          readonly uploadCsv: boolean
          readonly matchCriteria: boolean
        }
        readonly social?:
          | {
              readonly calendly?: string | undefined
              readonly linkedin?: string | undefined
            }
          | undefined
        readonly candidate?:
          | {
              readonly __typename: 'Candidate'
              readonly id: string
              readonly backgroundCheckDate?: any | undefined
              readonly credentialCount: number
              readonly dnu?: string | undefined
              readonly hiringStatus?: HiringStatusEnum | undefined
              readonly i9Date?: any | undefined
              readonly idealEmployment?: string | undefined
              readonly isAbleToApply: boolean
              readonly isNeedEmploymentSponsor?: boolean | undefined
              readonly isUsWorkAuthorized?: boolean | undefined
              readonly noWorkExperience?: boolean | undefined
              readonly profileCompletedAt?: any | undefined
              readonly profilePercentComplete?: number | undefined
              readonly relayId: string
              readonly resumeUrl?: string | undefined
              readonly salaryExpectations?: string | undefined
              readonly candidateLicenses?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly date?: any | undefined
                    readonly number?: string | undefined
                    readonly url?: string | undefined
                    readonly license?:
                      | {
                          readonly id: string
                          readonly name: string
                          readonly country: CountriesEnum
                          readonly state?: string | undefined
                        }
                      | undefined
                  }>
                | undefined
              readonly credentials?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly title: string
                    readonly badgeUrl: string
                    readonly description?: string | undefined
                    readonly training: {
                      readonly id: string
                      readonly trainingUrl: string
                    }
                  }>
                | undefined
              readonly education?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly degree?: string | undefined
                    readonly educationLevel?: EducationLevelEnum | undefined
                    readonly school?: string | undefined
                    readonly yearsAttended?: number | undefined
                  }>
                | undefined
              readonly experiences?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly companyName?: string | undefined
                    readonly current?: boolean | undefined
                    readonly endDate?: any | undefined
                    readonly jobTitle?: string | undefined
                    readonly responsibilities?: string | undefined
                    readonly startDate?: any | undefined
                    readonly yearsEmployed?: number | undefined
                  }>
                | undefined
              readonly placements?:
                | ReadonlyArray<{
                    readonly startDate?: any | undefined
                    readonly id: string
                    readonly interviewDate?: any | undefined
                    readonly status?: PlacementStatusEnum | undefined
                    readonly permissions: { readonly update: boolean }
                    readonly jobPosting: {
                      readonly id: string
                      readonly slug: string
                      readonly title: string
                      readonly client?:
                        | { readonly displayname: string }
                        | undefined
                      readonly permissions: {
                        readonly readJobApps: boolean
                        readonly readPlacements: boolean
                      }
                    }
                  }>
                | undefined
              readonly jobApplications?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly status?: JobApplicationStatusEnum | undefined
                    readonly permissions: { readonly show: boolean }
                    readonly jobPosting: {
                      readonly id: string
                      readonly level?: number | undefined
                      readonly slug: string
                      readonly title: string
                      readonly client?:
                        | {
                            readonly displayname: string
                            readonly name: string
                          }
                        | undefined
                      readonly permissions: {
                        readonly readJobApps: boolean
                        readonly readPlacements: boolean
                        readonly managePlacements: boolean
                      }
                      readonly jobPostingScreening?:
                        | { readonly id: string }
                        | undefined
                    }
                    readonly screeningSubmissions?:
                      | ReadonlyArray<{ readonly id: string }>
                      | undefined
                  }>
                | undefined
              readonly permissions: {
                readonly edit: boolean
                readonly readApplications: boolean
                readonly readCredentials: boolean
                readonly readLicense: boolean
                readonly readResume: boolean
                readonly readWorkPreferences: boolean
              }
              readonly recruiters?:
                | ReadonlyArray<{
                    readonly avatarUrl?: string | undefined
                    readonly firstName: string
                    readonly id: string
                    readonly lastName: string
                  }>
                | undefined
              readonly skillRelations?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly years: number
                    readonly skill: {
                      readonly __typename: 'Skill'
                      readonly id: string
                      readonly name: string
                    }
                  }>
                | undefined
              readonly summary?:
                | {
                    readonly id: string
                    readonly entry: string
                    readonly title: string
                  }
                | undefined
            }
          | undefined
        readonly subscription?:
          | {
              readonly __typename: 'Subscription'
              readonly id: string
              readonly active: boolean
              readonly plan: string
            }
          | undefined
      }
    | undefined
}

export type CompanyJobPlacments_JobPlacementConnectionFragment = {
  readonly edges?:
    | ReadonlyArray<
        | {
            readonly cursor: string
            readonly node?:
              | {
                  readonly __typename: 'Placement'
                  readonly id: string
                  readonly createdAt: any
                  readonly interviewDate?: any | undefined
                  readonly startDate?: any | undefined
                  readonly status?: PlacementStatusEnum | undefined
                  readonly updatedAt: any
                  readonly jobPosting: { readonly id: string }
                  readonly permissions: { readonly seeHistory: boolean }
                  readonly history?:
                    | ReadonlyArray<{
                        readonly __typename: 'Version'
                        readonly whodunnit?: string | undefined
                      }>
                    | undefined
                  readonly user?:
                    | {
                        readonly __typename: 'User'
                        readonly id: string
                        readonly username: string
                        readonly availability?: string | undefined
                        readonly avatarUrl?: string | undefined
                        readonly connectionCount: number
                        readonly connectionStatus?:
                          | ConnectionStatusEnum
                          | undefined
                        readonly email?: string | undefined
                        readonly secondaryEmail?: string | undefined
                        readonly firstName: string
                        readonly indispensableSurveyLink: string
                        readonly isCurrentUser: boolean
                        readonly lastName: string
                        readonly termsAcceptedAt?: any | undefined
                        readonly phoneNumber?: string | undefined
                        readonly uri: string
                        readonly activities?:
                          | {
                              readonly pageInfo: { readonly totalCount: number }
                            }
                          | undefined
                        readonly alerts?:
                          | {
                              readonly pageInfo: { readonly totalCount: number }
                            }
                          | undefined
                        readonly gigsEmployee?:
                          | {
                              readonly id: string
                              readonly createdAt: any
                              readonly deletedAt?: any | undefined
                              readonly eligibleAt?: any | undefined
                              readonly offboardedAt?: any | undefined
                              readonly onboardedAt?: any | undefined
                              readonly onboardingStatus: OnboardingStatusEnum
                              readonly percentComplete?: number | undefined
                              readonly rejectedAt?: any | undefined
                              readonly savedAt?: any | undefined
                              readonly screeningAt?: any | undefined
                              readonly terminatedAt?: any | undefined
                              readonly updatedAt: any
                              readonly permissions: {
                                readonly seeHistory: boolean
                              }
                            }
                          | undefined
                        readonly location: {
                          readonly address?: string | undefined
                          readonly addressExtended?: string | undefined
                          readonly city?: string | undefined
                          readonly country?: CountriesEnum | undefined
                          readonly latitude?: number | undefined
                          readonly longitude?: number | undefined
                          readonly postalCode?: string | undefined
                          readonly rawLocation?: string | undefined
                          readonly state?: StatesEnum | undefined
                        }
                        readonly permissions: {
                          readonly applyToJobs: boolean
                          readonly edit: boolean
                          readonly hasRecruiterLabel: boolean
                          readonly imposter: boolean
                          readonly internalUser: boolean
                          readonly publishJobOrders: boolean
                          readonly readEmail: boolean
                          readonly readJobBooster: boolean
                          readonly readNotes: boolean
                          readonly readPhone: boolean
                          readonly triggerIndispensableSurvey: boolean
                          readonly searchCandidates: boolean
                          readonly searchCandidatesAsClient: boolean
                          readonly searchCandidatesAsRecruiter: boolean
                          readonly searchClients: boolean
                          readonly searchClientsByRecruiters: boolean
                          readonly searchJobPostings: boolean
                          readonly searchJobPostingsByRecruiter: boolean
                          readonly sendMessage: boolean
                          readonly trainableUser: boolean
                          readonly updateConnectionStatus: boolean
                          readonly uploadCsv: boolean
                          readonly matchCriteria: boolean
                        }
                        readonly social?:
                          | {
                              readonly calendly?: string | undefined
                              readonly linkedin?: string | undefined
                            }
                          | undefined
                        readonly candidate?:
                          | {
                              readonly __typename: 'Candidate'
                              readonly id: string
                              readonly backgroundCheckDate?: any | undefined
                              readonly credentialCount: number
                              readonly dnu?: string | undefined
                              readonly hiringStatus?:
                                | HiringStatusEnum
                                | undefined
                              readonly i9Date?: any | undefined
                              readonly idealEmployment?: string | undefined
                              readonly isAbleToApply: boolean
                              readonly isNeedEmploymentSponsor?:
                                | boolean
                                | undefined
                              readonly isUsWorkAuthorized?: boolean | undefined
                              readonly noWorkExperience?: boolean | undefined
                              readonly profileCompletedAt?: any | undefined
                              readonly profilePercentComplete?:
                                | number
                                | undefined
                              readonly relayId: string
                              readonly resumeUrl?: string | undefined
                              readonly salaryExpectations?: string | undefined
                              readonly candidateLicenses?:
                                | ReadonlyArray<{
                                    readonly id: string
                                    readonly date?: any | undefined
                                    readonly number?: string | undefined
                                    readonly url?: string | undefined
                                    readonly license?:
                                      | {
                                          readonly id: string
                                          readonly name: string
                                          readonly country: CountriesEnum
                                          readonly state?: string | undefined
                                        }
                                      | undefined
                                  }>
                                | undefined
                              readonly credentials?:
                                | ReadonlyArray<{
                                    readonly id: string
                                    readonly title: string
                                    readonly badgeUrl: string
                                    readonly description?: string | undefined
                                    readonly training: {
                                      readonly id: string
                                      readonly trainingUrl: string
                                    }
                                  }>
                                | undefined
                              readonly education?:
                                | ReadonlyArray<{
                                    readonly id: string
                                    readonly degree?: string | undefined
                                    readonly educationLevel?:
                                      | EducationLevelEnum
                                      | undefined
                                    readonly school?: string | undefined
                                    readonly yearsAttended?: number | undefined
                                  }>
                                | undefined
                              readonly experiences?:
                                | ReadonlyArray<{
                                    readonly id: string
                                    readonly companyName?: string | undefined
                                    readonly current?: boolean | undefined
                                    readonly endDate?: any | undefined
                                    readonly jobTitle?: string | undefined
                                    readonly responsibilities?:
                                      | string
                                      | undefined
                                    readonly startDate?: any | undefined
                                    readonly yearsEmployed?: number | undefined
                                  }>
                                | undefined
                              readonly placements?:
                                | ReadonlyArray<{
                                    readonly startDate?: any | undefined
                                    readonly id: string
                                    readonly interviewDate?: any | undefined
                                    readonly status?:
                                      | PlacementStatusEnum
                                      | undefined
                                    readonly permissions: {
                                      readonly update: boolean
                                    }
                                    readonly jobPosting: {
                                      readonly id: string
                                      readonly slug: string
                                      readonly title: string
                                      readonly client?:
                                        | { readonly displayname: string }
                                        | undefined
                                      readonly permissions: {
                                        readonly readJobApps: boolean
                                        readonly readPlacements: boolean
                                      }
                                    }
                                  }>
                                | undefined
                              readonly jobApplications?:
                                | ReadonlyArray<{
                                    readonly id: string
                                    readonly status?:
                                      | JobApplicationStatusEnum
                                      | undefined
                                    readonly permissions: {
                                      readonly show: boolean
                                    }
                                    readonly jobPosting: {
                                      readonly id: string
                                      readonly level?: number | undefined
                                      readonly slug: string
                                      readonly title: string
                                      readonly client?:
                                        | {
                                            readonly displayname: string
                                            readonly name: string
                                          }
                                        | undefined
                                      readonly permissions: {
                                        readonly readJobApps: boolean
                                        readonly readPlacements: boolean
                                        readonly managePlacements: boolean
                                      }
                                      readonly jobPostingScreening?:
                                        | { readonly id: string }
                                        | undefined
                                    }
                                    readonly screeningSubmissions?:
                                      | ReadonlyArray<{ readonly id: string }>
                                      | undefined
                                  }>
                                | undefined
                              readonly permissions: {
                                readonly edit: boolean
                                readonly readApplications: boolean
                                readonly readCredentials: boolean
                                readonly readLicense: boolean
                                readonly readResume: boolean
                                readonly readWorkPreferences: boolean
                              }
                              readonly recruiters?:
                                | ReadonlyArray<{
                                    readonly avatarUrl?: string | undefined
                                    readonly firstName: string
                                    readonly id: string
                                    readonly lastName: string
                                  }>
                                | undefined
                              readonly skillRelations?:
                                | ReadonlyArray<{
                                    readonly id: string
                                    readonly years: number
                                    readonly skill: {
                                      readonly __typename: 'Skill'
                                      readonly id: string
                                      readonly name: string
                                    }
                                  }>
                                | undefined
                              readonly summary?:
                                | {
                                    readonly id: string
                                    readonly entry: string
                                    readonly title: string
                                  }
                                | undefined
                            }
                          | undefined
                        readonly subscription?:
                          | {
                              readonly __typename: 'Subscription'
                              readonly id: string
                              readonly active: boolean
                              readonly plan: string
                            }
                          | undefined
                      }
                    | undefined
                }
              | undefined
          }
        | undefined
      >
    | undefined
  readonly pageInfo: {
    readonly endCursor?: string | undefined
    readonly hasNextPage: boolean
    readonly hasPreviousPage: boolean
    readonly startCursor?: string | undefined
    readonly totalCount: number
  }
}

export type CompanyQueryVariables = Exact<{
  displayname: Scalars['String']['input']
}>

export type CompanyQuery = {
  readonly getClient: {
    readonly __typename: 'Client'
    readonly id: string
    readonly billingAddress?: string | undefined
    readonly accountsPayableEmail?: string | undefined
    readonly displayname: string
    readonly avatarUrl?: string | undefined
    readonly companySize?: CompanySizeEnum | undefined
    readonly connectionStatus?: ConnectionStatusEnum | undefined
    readonly countAvailablePositions: number
    readonly countRecentPositions: number
    readonly headline: string
    readonly metaDescription: string
    readonly metaTitle: string
    readonly name: string
    readonly profileComplete: boolean
    readonly profileCompletedAt?: any | undefined
    readonly uri: string
    readonly visibleOnPlatform: boolean
    readonly website?: string | undefined
    readonly companyDescription?: string | undefined
    readonly companyEmploymentBenefits?:
      | ReadonlyArray<{
          readonly id: string
          readonly employmentBenefit: {
            readonly icon: string
            readonly id: string
            readonly name: string
          }
        }>
      | undefined
    readonly companyLocations?:
      | ReadonlyArray<{
          readonly address?: string | undefined
          readonly addressExtended?: string | undefined
          readonly city?: string | undefined
          readonly country?: CountriesEnum | undefined
          readonly latitude?: number | undefined
          readonly longitude?: number | undefined
          readonly postalCode?: string | undefined
          readonly rawLocation?: string | undefined
          readonly state?: StatesEnum | undefined
        }>
      | undefined
    readonly companyPhotos?:
      | ReadonlyArray<{
          readonly id: string
          readonly alt?: string | undefined
          readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
          readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
          readonly url: string
        }>
      | undefined
    readonly companyValues?:
      | ReadonlyArray<{
          readonly id: string
          readonly description: string
          readonly title: string
        }>
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly createJobPosting: boolean
      readonly edit: boolean
      readonly editMeta: boolean
      readonly internalUser: boolean
      readonly readPendingBanner: boolean
      readonly toggleVisible: boolean
    }
    readonly social?:
      | {
          readonly facebook?: string | undefined
          readonly instagram?: string | undefined
          readonly linkedin?: string | undefined
          readonly twitter?: string | undefined
        }
      | undefined
    readonly trainings: { readonly pageInfo: { readonly totalCount: number } }
  }
}

export type CompanyEditQueryVariables = Exact<{
  displayname: Scalars['String']['input']
}>

export type CompanyEditQuery = {
  readonly getClient: {
    readonly id: string
    readonly avatarUrl?: string | undefined
    readonly billingAddress?: string | undefined
    readonly accountsPayableEmail?: string | undefined
    readonly companySize?: CompanySizeEnum | undefined
    readonly description?: string | undefined
    readonly displayname: string
    readonly headline: string
    readonly metaDescription: string
    readonly metaTitle: string
    readonly name: string
    readonly visibleOnPlatform: boolean
    readonly website?: string | undefined
    readonly companyPhotos?:
      | ReadonlyArray<{
          readonly id: string
          readonly alt?: string | undefined
          readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
          readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
          readonly url: string
        }>
      | undefined
    readonly companyEmploymentBenefits?:
      | ReadonlyArray<{
          readonly id: string
          readonly employmentBenefit: {
            readonly icon: string
            readonly id: string
            readonly name: string
          }
        }>
      | undefined
    readonly companyLocations?:
      | ReadonlyArray<{
          readonly address?: string | undefined
          readonly addressExtended?: string | undefined
          readonly city?: string | undefined
          readonly country?: CountriesEnum | undefined
          readonly latitude?: number | undefined
          readonly longitude?: number | undefined
          readonly postalCode?: string | undefined
          readonly rawLocation?: string | undefined
          readonly state?: StatesEnum | undefined
        }>
      | undefined
    readonly companyValues?:
      | ReadonlyArray<{
          readonly id: string
          readonly description: string
          readonly title: string
        }>
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly toggleVisible: boolean
      readonly editMeta: boolean
    }
    readonly social?:
      | {
          readonly facebook?: string | undefined
          readonly instagram?: string | undefined
          readonly linkedin?: string | undefined
          readonly twitter?: string | undefined
        }
      | undefined
    readonly users?:
      | ReadonlyArray<{
          readonly id: string
          readonly firstName: string
          readonly lastName: string
          readonly email?: string | undefined
        }>
      | undefined
  }
}

export type CompanyFollowersQueryVariables = Exact<{
  displayname: Scalars['String']['input']
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}>

export type CompanyFollowersQuery = {
  readonly getClient: {
    readonly followerCount: number
    readonly followers: {
      readonly edges?:
        | ReadonlyArray<
            | {
                readonly cursor: string
                readonly node?:
                  | {
                      readonly __typename: 'Client'
                      readonly id: string
                      readonly billingAddress?: string | undefined
                      readonly accountsPayableEmail?: string | undefined
                      readonly displayname: string
                      readonly avatarUrl?: string | undefined
                      readonly companySize?: CompanySizeEnum | undefined
                      readonly connectionStatus?:
                        | ConnectionStatusEnum
                        | undefined
                      readonly countAvailablePositions: number
                      readonly countRecentPositions: number
                      readonly headline: string
                      readonly metaDescription: string
                      readonly metaTitle: string
                      readonly name: string
                      readonly profileComplete: boolean
                      readonly profileCompletedAt?: any | undefined
                      readonly uri: string
                      readonly visibleOnPlatform: boolean
                      readonly website?: string | undefined
                      readonly companyDescription?: string | undefined
                      readonly companyEmploymentBenefits?:
                        | ReadonlyArray<{
                            readonly id: string
                            readonly employmentBenefit: {
                              readonly icon: string
                              readonly id: string
                              readonly name: string
                            }
                          }>
                        | undefined
                      readonly companyLocations?:
                        | ReadonlyArray<{
                            readonly address?: string | undefined
                            readonly addressExtended?: string | undefined
                            readonly city?: string | undefined
                            readonly country?: CountriesEnum | undefined
                            readonly latitude?: number | undefined
                            readonly longitude?: number | undefined
                            readonly postalCode?: string | undefined
                            readonly rawLocation?: string | undefined
                            readonly state?: StatesEnum | undefined
                          }>
                        | undefined
                      readonly companyPhotos?:
                        | ReadonlyArray<{
                            readonly id: string
                            readonly alt?: string | undefined
                            readonly displayRole?:
                              | CompanyPhotoDisplayRoleEnum
                              | undefined
                            readonly mediaType?:
                              | CompanyPhotoMediaTypeEnum
                              | undefined
                            readonly url: string
                          }>
                        | undefined
                      readonly companyValues?:
                        | ReadonlyArray<{
                            readonly id: string
                            readonly description: string
                            readonly title: string
                          }>
                        | undefined
                      readonly location: {
                        readonly address?: string | undefined
                        readonly addressExtended?: string | undefined
                        readonly city?: string | undefined
                        readonly country?: CountriesEnum | undefined
                        readonly latitude?: number | undefined
                        readonly longitude?: number | undefined
                        readonly postalCode?: string | undefined
                        readonly rawLocation?: string | undefined
                        readonly state?: StatesEnum | undefined
                      }
                      readonly permissions: {
                        readonly createJobPosting: boolean
                        readonly edit: boolean
                        readonly editMeta: boolean
                        readonly internalUser: boolean
                        readonly readPendingBanner: boolean
                        readonly toggleVisible: boolean
                      }
                      readonly social?:
                        | {
                            readonly facebook?: string | undefined
                            readonly instagram?: string | undefined
                            readonly linkedin?: string | undefined
                            readonly twitter?: string | undefined
                          }
                        | undefined
                      readonly trainings: {
                        readonly pageInfo: { readonly totalCount: number }
                      }
                    }
                  | {
                      readonly __typename: 'User'
                      readonly id: string
                      readonly username: string
                      readonly availability?: string | undefined
                      readonly avatarUrl?: string | undefined
                      readonly connectionCount: number
                      readonly connectionStatus?:
                        | ConnectionStatusEnum
                        | undefined
                      readonly email?: string | undefined
                      readonly secondaryEmail?: string | undefined
                      readonly firstName: string
                      readonly indispensableSurveyLink: string
                      readonly isCurrentUser: boolean
                      readonly lastName: string
                      readonly termsAcceptedAt?: any | undefined
                      readonly phoneNumber?: string | undefined
                      readonly uri: string
                      readonly activities?:
                        | { readonly pageInfo: { readonly totalCount: number } }
                        | undefined
                      readonly alerts?:
                        | { readonly pageInfo: { readonly totalCount: number } }
                        | undefined
                      readonly gigsEmployee?:
                        | {
                            readonly id: string
                            readonly createdAt: any
                            readonly deletedAt?: any | undefined
                            readonly eligibleAt?: any | undefined
                            readonly offboardedAt?: any | undefined
                            readonly onboardedAt?: any | undefined
                            readonly onboardingStatus: OnboardingStatusEnum
                            readonly percentComplete?: number | undefined
                            readonly rejectedAt?: any | undefined
                            readonly savedAt?: any | undefined
                            readonly screeningAt?: any | undefined
                            readonly terminatedAt?: any | undefined
                            readonly updatedAt: any
                            readonly permissions: {
                              readonly seeHistory: boolean
                            }
                          }
                        | undefined
                      readonly location: {
                        readonly address?: string | undefined
                        readonly addressExtended?: string | undefined
                        readonly city?: string | undefined
                        readonly country?: CountriesEnum | undefined
                        readonly latitude?: number | undefined
                        readonly longitude?: number | undefined
                        readonly postalCode?: string | undefined
                        readonly rawLocation?: string | undefined
                        readonly state?: StatesEnum | undefined
                      }
                      readonly permissions: {
                        readonly applyToJobs: boolean
                        readonly edit: boolean
                        readonly hasRecruiterLabel: boolean
                        readonly imposter: boolean
                        readonly internalUser: boolean
                        readonly publishJobOrders: boolean
                        readonly readEmail: boolean
                        readonly readJobBooster: boolean
                        readonly readNotes: boolean
                        readonly readPhone: boolean
                        readonly triggerIndispensableSurvey: boolean
                        readonly searchCandidates: boolean
                        readonly searchCandidatesAsClient: boolean
                        readonly searchCandidatesAsRecruiter: boolean
                        readonly searchClients: boolean
                        readonly searchClientsByRecruiters: boolean
                        readonly searchJobPostings: boolean
                        readonly searchJobPostingsByRecruiter: boolean
                        readonly sendMessage: boolean
                        readonly trainableUser: boolean
                        readonly updateConnectionStatus: boolean
                        readonly uploadCsv: boolean
                        readonly matchCriteria: boolean
                      }
                      readonly social?:
                        | {
                            readonly calendly?: string | undefined
                            readonly linkedin?: string | undefined
                          }
                        | undefined
                      readonly candidate?:
                        | {
                            readonly __typename: 'Candidate'
                            readonly id: string
                            readonly backgroundCheckDate?: any | undefined
                            readonly credentialCount: number
                            readonly dnu?: string | undefined
                            readonly hiringStatus?: HiringStatusEnum | undefined
                            readonly i9Date?: any | undefined
                            readonly idealEmployment?: string | undefined
                            readonly isAbleToApply: boolean
                            readonly isNeedEmploymentSponsor?:
                              | boolean
                              | undefined
                            readonly isUsWorkAuthorized?: boolean | undefined
                            readonly noWorkExperience?: boolean | undefined
                            readonly profileCompletedAt?: any | undefined
                            readonly profilePercentComplete?: number | undefined
                            readonly relayId: string
                            readonly resumeUrl?: string | undefined
                            readonly salaryExpectations?: string | undefined
                            readonly candidateLicenses?:
                              | ReadonlyArray<{
                                  readonly id: string
                                  readonly date?: any | undefined
                                  readonly number?: string | undefined
                                  readonly url?: string | undefined
                                  readonly license?:
                                    | {
                                        readonly id: string
                                        readonly name: string
                                        readonly country: CountriesEnum
                                        readonly state?: string | undefined
                                      }
                                    | undefined
                                }>
                              | undefined
                            readonly credentials?:
                              | ReadonlyArray<{
                                  readonly id: string
                                  readonly title: string
                                  readonly badgeUrl: string
                                  readonly description?: string | undefined
                                  readonly training: {
                                    readonly id: string
                                    readonly trainingUrl: string
                                  }
                                }>
                              | undefined
                            readonly education?:
                              | ReadonlyArray<{
                                  readonly id: string
                                  readonly degree?: string | undefined
                                  readonly educationLevel?:
                                    | EducationLevelEnum
                                    | undefined
                                  readonly school?: string | undefined
                                  readonly yearsAttended?: number | undefined
                                }>
                              | undefined
                            readonly experiences?:
                              | ReadonlyArray<{
                                  readonly id: string
                                  readonly companyName?: string | undefined
                                  readonly current?: boolean | undefined
                                  readonly endDate?: any | undefined
                                  readonly jobTitle?: string | undefined
                                  readonly responsibilities?: string | undefined
                                  readonly startDate?: any | undefined
                                  readonly yearsEmployed?: number | undefined
                                }>
                              | undefined
                            readonly placements?:
                              | ReadonlyArray<{
                                  readonly startDate?: any | undefined
                                  readonly id: string
                                  readonly interviewDate?: any | undefined
                                  readonly status?:
                                    | PlacementStatusEnum
                                    | undefined
                                  readonly permissions: {
                                    readonly update: boolean
                                  }
                                  readonly jobPosting: {
                                    readonly id: string
                                    readonly slug: string
                                    readonly title: string
                                    readonly client?:
                                      | { readonly displayname: string }
                                      | undefined
                                    readonly permissions: {
                                      readonly readJobApps: boolean
                                      readonly readPlacements: boolean
                                    }
                                  }
                                }>
                              | undefined
                            readonly jobApplications?:
                              | ReadonlyArray<{
                                  readonly id: string
                                  readonly status?:
                                    | JobApplicationStatusEnum
                                    | undefined
                                  readonly permissions: {
                                    readonly show: boolean
                                  }
                                  readonly jobPosting: {
                                    readonly id: string
                                    readonly level?: number | undefined
                                    readonly slug: string
                                    readonly title: string
                                    readonly client?:
                                      | {
                                          readonly displayname: string
                                          readonly name: string
                                        }
                                      | undefined
                                    readonly permissions: {
                                      readonly readJobApps: boolean
                                      readonly readPlacements: boolean
                                      readonly managePlacements: boolean
                                    }
                                    readonly jobPostingScreening?:
                                      | { readonly id: string }
                                      | undefined
                                  }
                                  readonly screeningSubmissions?:
                                    | ReadonlyArray<{ readonly id: string }>
                                    | undefined
                                }>
                              | undefined
                            readonly permissions: {
                              readonly edit: boolean
                              readonly readApplications: boolean
                              readonly readCredentials: boolean
                              readonly readLicense: boolean
                              readonly readResume: boolean
                              readonly readWorkPreferences: boolean
                            }
                            readonly recruiters?:
                              | ReadonlyArray<{
                                  readonly avatarUrl?: string | undefined
                                  readonly firstName: string
                                  readonly id: string
                                  readonly lastName: string
                                }>
                              | undefined
                            readonly skillRelations?:
                              | ReadonlyArray<{
                                  readonly id: string
                                  readonly years: number
                                  readonly skill: {
                                    readonly __typename: 'Skill'
                                    readonly id: string
                                    readonly name: string
                                  }
                                }>
                              | undefined
                            readonly summary?:
                              | {
                                  readonly id: string
                                  readonly entry: string
                                  readonly title: string
                                }
                              | undefined
                          }
                        | undefined
                      readonly subscription?:
                        | {
                            readonly __typename: 'Subscription'
                            readonly id: string
                            readonly active: boolean
                            readonly plan: string
                          }
                        | undefined
                    }
                  | undefined
              }
            | undefined
          >
        | undefined
      readonly pageInfo: {
        readonly endCursor?: string | undefined
        readonly hasNextPage: boolean
        readonly hasPreviousPage: boolean
        readonly startCursor?: string | undefined
      }
    }
  }
}

export type CompanyJobPostingsQueryVariables = Exact<{
  displayname: Scalars['String']['input']
  atsRecordTypes?: InputMaybe<
    ReadonlyArray<InputMaybe<AtsRecordTypeEnum>> | InputMaybe<AtsRecordTypeEnum>
  >
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}>

export type CompanyJobPostingsQuery = {
  readonly getClient: {
    readonly jobPostings: {
      readonly edges?:
        | ReadonlyArray<
            | {
                readonly cursor: string
                readonly node?:
                  | {
                      readonly __typename: 'JobPosting'
                      readonly id: string
                      readonly accountsPayableEmail?: string | undefined
                      readonly applicationReceived: boolean
                      readonly atsRecordType?: string | undefined
                      readonly atsStatus?: JobPostingAtsStatusEnum | undefined
                      readonly baseSalaryValue: number
                      readonly countJobApplicationsNew: number
                      readonly countJobApplicationsTotal: number
                      readonly description: string
                      readonly depositAmount?: number | undefined
                      readonly education?: string | undefined
                      readonly employmentTypes?:
                        | ReadonlyArray<EmploymentTypesEnum>
                        | undefined
                      readonly endDate?: any | undefined
                      readonly quantity?: number | undefined
                      readonly experience?: string | undefined
                      readonly externalId?: string | undefined
                      readonly isIngested: boolean
                      readonly isPublished: boolean
                      readonly isRemote: boolean
                      readonly physicalRequirements?: string | undefined
                      readonly postedAt?: any | undefined
                      readonly shift?: string | undefined
                      readonly syndicateIndeed: boolean
                      readonly responsibilities?: string | undefined
                      readonly slug: string
                      readonly startDate?: any | undefined
                      readonly submitApplicationUrl?: string | undefined
                      readonly title: string
                      readonly uri: string
                      readonly validThrough: any
                      readonly workingEnvironment?: string | undefined
                      readonly accountExecs?:
                        | ReadonlyArray<{
                            readonly avatarUrl?: string | undefined
                            readonly firstName: string
                            readonly id: string
                            readonly lastName: string
                            readonly username: string
                          }>
                        | undefined
                      readonly activities?:
                        | { readonly pageInfo: { readonly totalCount: number } }
                        | undefined
                      readonly client?:
                        | {
                            readonly __typename: 'Client'
                            readonly id: string
                            readonly displayname: string
                            readonly avatarUrl?: string | undefined
                            readonly billingAddress?: string | undefined
                            readonly companySize?: CompanySizeEnum | undefined
                            readonly connectionStatus?:
                              | ConnectionStatusEnum
                              | undefined
                            readonly countAvailablePositions: number
                            readonly countRecentPositions: number
                            readonly description?: string | undefined
                            readonly headline: string
                            readonly name: string
                            readonly profileComplete: boolean
                            readonly profileCompletedAt?: any | undefined
                            readonly visibleOnPlatform: boolean
                            readonly website?: string | undefined
                            readonly companyEmploymentBenefits?:
                              | ReadonlyArray<{
                                  readonly id: string
                                  readonly employmentBenefit: {
                                    readonly icon: string
                                    readonly id: string
                                    readonly name: string
                                  }
                                }>
                              | undefined
                            readonly companyLocations?:
                              | ReadonlyArray<{
                                  readonly address?: string | undefined
                                  readonly addressExtended?: string | undefined
                                  readonly city?: string | undefined
                                  readonly country?: CountriesEnum | undefined
                                  readonly latitude?: number | undefined
                                  readonly longitude?: number | undefined
                                  readonly postalCode?: string | undefined
                                  readonly rawLocation?: string | undefined
                                  readonly state?: StatesEnum | undefined
                                }>
                              | undefined
                            readonly companyPhotos?:
                              | ReadonlyArray<{
                                  readonly id: string
                                  readonly alt?: string | undefined
                                  readonly displayRole?:
                                    | CompanyPhotoDisplayRoleEnum
                                    | undefined
                                  readonly mediaType?:
                                    | CompanyPhotoMediaTypeEnum
                                    | undefined
                                  readonly url: string
                                }>
                              | undefined
                            readonly companyValues?:
                              | ReadonlyArray<{
                                  readonly id: string
                                  readonly description: string
                                  readonly title: string
                                }>
                              | undefined
                            readonly location: {
                              readonly address?: string | undefined
                              readonly addressExtended?: string | undefined
                              readonly city?: string | undefined
                              readonly country?: CountriesEnum | undefined
                              readonly latitude?: number | undefined
                              readonly longitude?: number | undefined
                              readonly postalCode?: string | undefined
                              readonly rawLocation?: string | undefined
                              readonly state?: StatesEnum | undefined
                            }
                            readonly permissions: {
                              readonly createJobPosting: boolean
                              readonly edit: boolean
                              readonly readPendingBanner: boolean
                              readonly toggleVisible: boolean
                            }
                            readonly social?:
                              | {
                                  readonly facebook?: string | undefined
                                  readonly instagram?: string | undefined
                                  readonly linkedin?: string | undefined
                                  readonly twitter?: string | undefined
                                }
                              | undefined
                          }
                        | undefined
                      readonly associatedClient?:
                        | {
                            readonly __typename: 'Client'
                            readonly id: string
                            readonly displayname: string
                            readonly avatarUrl?: string | undefined
                            readonly billingAddress?: string | undefined
                            readonly companySize?: CompanySizeEnum | undefined
                            readonly connectionStatus?:
                              | ConnectionStatusEnum
                              | undefined
                            readonly countAvailablePositions: number
                            readonly countRecentPositions: number
                            readonly description?: string | undefined
                            readonly headline: string
                            readonly name: string
                            readonly profileComplete: boolean
                            readonly profileCompletedAt?: any | undefined
                            readonly visibleOnPlatform: boolean
                            readonly website?: string | undefined
                            readonly companyEmploymentBenefits?:
                              | ReadonlyArray<{
                                  readonly id: string
                                  readonly employmentBenefit: {
                                    readonly icon: string
                                    readonly id: string
                                    readonly name: string
                                  }
                                }>
                              | undefined
                            readonly companyLocations?:
                              | ReadonlyArray<{
                                  readonly address?: string | undefined
                                  readonly addressExtended?: string | undefined
                                  readonly city?: string | undefined
                                  readonly country?: CountriesEnum | undefined
                                  readonly latitude?: number | undefined
                                  readonly longitude?: number | undefined
                                  readonly postalCode?: string | undefined
                                  readonly rawLocation?: string | undefined
                                  readonly state?: StatesEnum | undefined
                                }>
                              | undefined
                            readonly companyPhotos?:
                              | ReadonlyArray<{
                                  readonly id: string
                                  readonly alt?: string | undefined
                                  readonly displayRole?:
                                    | CompanyPhotoDisplayRoleEnum
                                    | undefined
                                  readonly mediaType?:
                                    | CompanyPhotoMediaTypeEnum
                                    | undefined
                                  readonly url: string
                                }>
                              | undefined
                            readonly companyValues?:
                              | ReadonlyArray<{
                                  readonly id: string
                                  readonly description: string
                                  readonly title: string
                                }>
                              | undefined
                            readonly location: {
                              readonly address?: string | undefined
                              readonly addressExtended?: string | undefined
                              readonly city?: string | undefined
                              readonly country?: CountriesEnum | undefined
                              readonly latitude?: number | undefined
                              readonly longitude?: number | undefined
                              readonly postalCode?: string | undefined
                              readonly rawLocation?: string | undefined
                              readonly state?: StatesEnum | undefined
                            }
                            readonly permissions: {
                              readonly createJobPosting: boolean
                              readonly edit: boolean
                              readonly readPendingBanner: boolean
                              readonly toggleVisible: boolean
                            }
                            readonly social?:
                              | {
                                  readonly facebook?: string | undefined
                                  readonly instagram?: string | undefined
                                  readonly linkedin?: string | undefined
                                  readonly twitter?: string | undefined
                                }
                              | undefined
                          }
                        | undefined
                      readonly employmentBenefits?:
                        | ReadonlyArray<{
                            readonly id: string
                            readonly employmentBenefit: {
                              readonly icon: string
                              readonly id: string
                              readonly name: string
                            }
                          }>
                        | undefined
                      readonly jobApplicationStatusCounts?:
                        | ReadonlyArray<{
                            readonly count: number
                            readonly status?:
                              | JobApplicationStatusEnum
                              | undefined
                          }>
                        | undefined
                      readonly gigsInfo?:
                        | {
                            readonly additionalRequirements?: string | undefined
                            readonly billRate?: number | undefined
                            readonly costCenterCreated?: boolean | undefined
                            readonly companyOnboarded?: boolean | undefined
                            readonly details?: string | undefined
                            readonly engagementDeposit?: boolean | undefined
                            readonly kickoffCall?: boolean | undefined
                            readonly level?: number | undefined
                            readonly payRate?: number | undefined
                            readonly salaryPayPeriod?: PayPeriodEnum | undefined
                            readonly dressCode?: string | undefined
                            readonly specialRequests?: string | undefined
                            readonly parkingFacilityInformation?:
                              | string
                              | undefined
                          }
                        | undefined
                      readonly jobPostingScreening?:
                        | {
                            readonly id: string
                            readonly screening?:
                              | {
                                  readonly id: string
                                  readonly description?: string | undefined
                                  readonly name?: string | undefined
                                  readonly screeningQuestions?:
                                    | ReadonlyArray<{
                                        readonly id: string
                                        readonly typeOf?: string | undefined
                                        readonly question?: string | undefined
                                      }>
                                    | undefined
                                }
                              | undefined
                          }
                        | undefined
                      readonly location: {
                        readonly address?: string | undefined
                        readonly addressExtended?: string | undefined
                        readonly city?: string | undefined
                        readonly country?: CountriesEnum | undefined
                        readonly latitude?: number | undefined
                        readonly longitude?: number | undefined
                        readonly postalCode?: string | undefined
                        readonly rawLocation?: string | undefined
                        readonly state?: StatesEnum | undefined
                      }
                      readonly permissions: {
                        readonly destroy: boolean
                        readonly edit: boolean
                        readonly internalUser: boolean
                        readonly managePlacements: boolean
                        readonly readEndDate: boolean
                        readonly readJobApps: boolean
                        readonly readPlacements: boolean
                        readonly togglePublished: boolean
                        readonly writeAtsRecordType: boolean
                        readonly writeRecruiterToJob: boolean
                        readonly writeSubmitApplicationUrl: boolean
                      }
                      readonly placements?:
                        | ReadonlyArray<{
                            readonly id: string
                            readonly status?: PlacementStatusEnum | undefined
                          }>
                        | undefined
                      readonly placementStatusCounts?:
                        | ReadonlyArray<{
                            readonly count: number
                            readonly status?: PlacementStatusEnum | undefined
                          }>
                        | undefined
                      readonly primaryContact?:
                        | {
                            readonly avatarUrl?: string | undefined
                            readonly firstName: string
                            readonly id: string
                            readonly lastName: string
                          }
                        | undefined
                      readonly recommendedCredentials?:
                        | ReadonlyArray<{
                            readonly id: string
                            readonly credential: {
                              readonly __typename: 'Credential'
                              readonly id: string
                              readonly badgeUrl: string
                              readonly description?: string | undefined
                              readonly title: string
                              readonly training: {
                                readonly id: string
                                readonly trainingUrl: string
                              }
                            }
                          }>
                        | undefined
                      readonly recruiters?:
                        | ReadonlyArray<{
                            readonly avatarUrl?: string | undefined
                            readonly firstName: string
                            readonly id: string
                            readonly lastName: string
                            readonly username: string
                          }>
                        | undefined
                      readonly timeSheetManagers?:
                        | ReadonlyArray<{
                            readonly avatarUrl?: string | undefined
                            readonly firstName: string
                            readonly id: string
                            readonly lastName: string
                            readonly username: string
                          }>
                        | undefined
                      readonly requiredLicenses: ReadonlyArray<{
                        readonly id: string
                        readonly license: {
                          readonly id: string
                          readonly name: string
                          readonly country: CountriesEnum
                          readonly state?: string | undefined
                        }
                      }>
                      readonly salaryRange?:
                        | {
                            readonly maxValue?: number | undefined
                            readonly minValue?: number | undefined
                            readonly payPeriod?: PayPeriodEnum | undefined
                          }
                        | undefined
                    }
                  | undefined
              }
            | undefined
          >
        | undefined
      readonly pageInfo: {
        readonly endCursor?: string | undefined
        readonly hasNextPage: boolean
        readonly hasPreviousPage: boolean
        readonly startCursor?: string | undefined
        readonly totalCount: number
      }
    }
  }
}

export type CompanyPhotosQueryVariables = Exact<{
  displayname: Scalars['String']['input']
}>

export type CompanyPhotosQuery = {
  readonly getClient: {
    readonly companyPhotos?:
      | ReadonlyArray<{
          readonly id: string
          readonly alt?: string | undefined
          readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
          readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
          readonly url: string
        }>
      | undefined
  }
}

export type CompanyJobApplicationQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CompanyJobApplicationQuery = {
  readonly getJobApplication: {
    readonly __typename: 'JobApplication'
    readonly id: string
    readonly atsRecordType?: string | undefined
    readonly createdAt: any
    readonly clientInterestAt?: any | undefined
    readonly clientInterestMessage: string
    readonly hasClientInterest: boolean
    readonly status?: JobApplicationStatusEnum | undefined
    readonly jobPosting: {
      readonly id: string
      readonly level?: number | undefined
      readonly title: string
      readonly slug: string
      readonly jobPostingScreening?:
        | {
            readonly id: string
            readonly screening?:
              | {
                  readonly id: string
                  readonly description?: string | undefined
                  readonly name?: string | undefined
                  readonly screeningQuestions?:
                    | ReadonlyArray<{
                        readonly id: string
                        readonly typeOf?: string | undefined
                        readonly question?: string | undefined
                      }>
                    | undefined
                }
              | undefined
          }
        | undefined
      readonly location: {
        readonly city?: string | undefined
        readonly state?: StatesEnum | undefined
      }
      readonly client?: { readonly displayname: string } | undefined
    }
    readonly permissions: {
      readonly indicateInterest: boolean
      readonly show: boolean
    }
    readonly screeningSubmissions?:
      | ReadonlyArray<{
          readonly id: string
          readonly jobApplication?:
            | {
                readonly id: string
                readonly jobPosting: {
                  readonly id: string
                  readonly title: string
                  readonly slug: string
                }
              }
            | undefined
          readonly screeningQResponses?:
            | ReadonlyArray<{
                readonly id: string
                readonly answer?: any | undefined
                readonly screeningQuestion?:
                  | {
                      readonly id: string
                      readonly question?: string | undefined
                    }
                  | undefined
              }>
            | undefined
        }>
      | undefined
    readonly user?:
      | {
          readonly __typename: 'User'
          readonly id: string
          readonly username: string
          readonly availability?: string | undefined
          readonly avatarUrl?: string | undefined
          readonly connectionCount: number
          readonly connectionStatus?: ConnectionStatusEnum | undefined
          readonly email?: string | undefined
          readonly secondaryEmail?: string | undefined
          readonly firstName: string
          readonly indispensableSurveyLink: string
          readonly isCurrentUser: boolean
          readonly lastName: string
          readonly termsAcceptedAt?: any | undefined
          readonly phoneNumber?: string | undefined
          readonly uri: string
          readonly activities?:
            | { readonly pageInfo: { readonly totalCount: number } }
            | undefined
          readonly alerts?:
            | { readonly pageInfo: { readonly totalCount: number } }
            | undefined
          readonly gigsEmployee?:
            | {
                readonly id: string
                readonly createdAt: any
                readonly deletedAt?: any | undefined
                readonly eligibleAt?: any | undefined
                readonly offboardedAt?: any | undefined
                readonly onboardedAt?: any | undefined
                readonly onboardingStatus: OnboardingStatusEnum
                readonly percentComplete?: number | undefined
                readonly rejectedAt?: any | undefined
                readonly savedAt?: any | undefined
                readonly screeningAt?: any | undefined
                readonly terminatedAt?: any | undefined
                readonly updatedAt: any
                readonly permissions: { readonly seeHistory: boolean }
              }
            | undefined
          readonly location: {
            readonly address?: string | undefined
            readonly addressExtended?: string | undefined
            readonly city?: string | undefined
            readonly country?: CountriesEnum | undefined
            readonly latitude?: number | undefined
            readonly longitude?: number | undefined
            readonly postalCode?: string | undefined
            readonly rawLocation?: string | undefined
            readonly state?: StatesEnum | undefined
          }
          readonly permissions: {
            readonly applyToJobs: boolean
            readonly edit: boolean
            readonly hasRecruiterLabel: boolean
            readonly imposter: boolean
            readonly internalUser: boolean
            readonly publishJobOrders: boolean
            readonly readEmail: boolean
            readonly readJobBooster: boolean
            readonly readNotes: boolean
            readonly readPhone: boolean
            readonly triggerIndispensableSurvey: boolean
            readonly searchCandidates: boolean
            readonly searchCandidatesAsClient: boolean
            readonly searchCandidatesAsRecruiter: boolean
            readonly searchClients: boolean
            readonly searchClientsByRecruiters: boolean
            readonly searchJobPostings: boolean
            readonly searchJobPostingsByRecruiter: boolean
            readonly sendMessage: boolean
            readonly trainableUser: boolean
            readonly updateConnectionStatus: boolean
            readonly uploadCsv: boolean
            readonly matchCriteria: boolean
          }
          readonly social?:
            | {
                readonly calendly?: string | undefined
                readonly linkedin?: string | undefined
              }
            | undefined
          readonly candidate?:
            | {
                readonly __typename: 'Candidate'
                readonly id: string
                readonly backgroundCheckDate?: any | undefined
                readonly credentialCount: number
                readonly dnu?: string | undefined
                readonly hiringStatus?: HiringStatusEnum | undefined
                readonly i9Date?: any | undefined
                readonly idealEmployment?: string | undefined
                readonly isAbleToApply: boolean
                readonly isNeedEmploymentSponsor?: boolean | undefined
                readonly isUsWorkAuthorized?: boolean | undefined
                readonly noWorkExperience?: boolean | undefined
                readonly profileCompletedAt?: any | undefined
                readonly profilePercentComplete?: number | undefined
                readonly relayId: string
                readonly resumeUrl?: string | undefined
                readonly salaryExpectations?: string | undefined
                readonly candidateLicenses?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly date?: any | undefined
                      readonly number?: string | undefined
                      readonly url?: string | undefined
                      readonly license?:
                        | {
                            readonly id: string
                            readonly name: string
                            readonly country: CountriesEnum
                            readonly state?: string | undefined
                          }
                        | undefined
                    }>
                  | undefined
                readonly credentials?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly title: string
                      readonly badgeUrl: string
                      readonly description?: string | undefined
                      readonly training: {
                        readonly id: string
                        readonly trainingUrl: string
                      }
                    }>
                  | undefined
                readonly education?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly degree?: string | undefined
                      readonly educationLevel?: EducationLevelEnum | undefined
                      readonly school?: string | undefined
                      readonly yearsAttended?: number | undefined
                    }>
                  | undefined
                readonly experiences?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly companyName?: string | undefined
                      readonly current?: boolean | undefined
                      readonly endDate?: any | undefined
                      readonly jobTitle?: string | undefined
                      readonly responsibilities?: string | undefined
                      readonly startDate?: any | undefined
                      readonly yearsEmployed?: number | undefined
                    }>
                  | undefined
                readonly placements?:
                  | ReadonlyArray<{
                      readonly startDate?: any | undefined
                      readonly id: string
                      readonly interviewDate?: any | undefined
                      readonly status?: PlacementStatusEnum | undefined
                      readonly permissions: { readonly update: boolean }
                      readonly jobPosting: {
                        readonly id: string
                        readonly slug: string
                        readonly title: string
                        readonly client?:
                          | { readonly displayname: string }
                          | undefined
                        readonly permissions: {
                          readonly readJobApps: boolean
                          readonly readPlacements: boolean
                        }
                      }
                    }>
                  | undefined
                readonly jobApplications?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly status?: JobApplicationStatusEnum | undefined
                      readonly permissions: { readonly show: boolean }
                      readonly jobPosting: {
                        readonly id: string
                        readonly level?: number | undefined
                        readonly slug: string
                        readonly title: string
                        readonly client?:
                          | {
                              readonly displayname: string
                              readonly name: string
                            }
                          | undefined
                        readonly permissions: {
                          readonly readJobApps: boolean
                          readonly readPlacements: boolean
                          readonly managePlacements: boolean
                        }
                        readonly jobPostingScreening?:
                          | { readonly id: string }
                          | undefined
                      }
                      readonly screeningSubmissions?:
                        | ReadonlyArray<{ readonly id: string }>
                        | undefined
                    }>
                  | undefined
                readonly permissions: {
                  readonly edit: boolean
                  readonly readApplications: boolean
                  readonly readCredentials: boolean
                  readonly readLicense: boolean
                  readonly readResume: boolean
                  readonly readWorkPreferences: boolean
                }
                readonly recruiters?:
                  | ReadonlyArray<{
                      readonly avatarUrl?: string | undefined
                      readonly firstName: string
                      readonly id: string
                      readonly lastName: string
                    }>
                  | undefined
                readonly skillRelations?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly years: number
                      readonly skill: {
                        readonly __typename: 'Skill'
                        readonly id: string
                        readonly name: string
                      }
                    }>
                  | undefined
                readonly summary?:
                  | {
                      readonly id: string
                      readonly entry: string
                      readonly title: string
                    }
                  | undefined
              }
            | undefined
          readonly subscription?:
            | {
                readonly __typename: 'Subscription'
                readonly id: string
                readonly active: boolean
                readonly plan: string
              }
            | undefined
        }
      | undefined
  }
}

export type CompanyJobApplicationsQueryVariables = Exact<{
  hasClientInterest?: InputMaybe<Scalars['Boolean']['input']>
  jobPostingId?: InputMaybe<Scalars['String']['input']>
  displayname?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<
    ReadonlyArray<JobApplicationStatusEnum> | JobApplicationStatusEnum
  >
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}>

export type CompanyJobApplicationsQuery = {
  readonly getJobApplications: {
    readonly edges?:
      | ReadonlyArray<
          | {
              readonly cursor: string
              readonly node?:
                | {
                    readonly __typename: 'JobApplication'
                    readonly id: string
                    readonly atsRecordType?: string | undefined
                    readonly createdAt: any
                    readonly clientInterestAt?: any | undefined
                    readonly clientInterestMessage: string
                    readonly hasClientInterest: boolean
                    readonly status?: JobApplicationStatusEnum | undefined
                    readonly jobPosting: {
                      readonly id: string
                      readonly level?: number | undefined
                      readonly title: string
                      readonly slug: string
                      readonly jobPostingScreening?:
                        | {
                            readonly id: string
                            readonly screening?:
                              | {
                                  readonly id: string
                                  readonly description?: string | undefined
                                  readonly name?: string | undefined
                                  readonly screeningQuestions?:
                                    | ReadonlyArray<{
                                        readonly id: string
                                        readonly typeOf?: string | undefined
                                        readonly question?: string | undefined
                                      }>
                                    | undefined
                                }
                              | undefined
                          }
                        | undefined
                      readonly location: {
                        readonly city?: string | undefined
                        readonly state?: StatesEnum | undefined
                      }
                      readonly client?:
                        | { readonly displayname: string }
                        | undefined
                    }
                    readonly permissions: {
                      readonly indicateInterest: boolean
                      readonly show: boolean
                    }
                    readonly screeningSubmissions?:
                      | ReadonlyArray<{
                          readonly id: string
                          readonly jobApplication?:
                            | {
                                readonly id: string
                                readonly jobPosting: {
                                  readonly id: string
                                  readonly title: string
                                  readonly slug: string
                                }
                              }
                            | undefined
                          readonly screeningQResponses?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly answer?: any | undefined
                                readonly screeningQuestion?:
                                  | {
                                      readonly id: string
                                      readonly question?: string | undefined
                                    }
                                  | undefined
                              }>
                            | undefined
                        }>
                      | undefined
                    readonly user?:
                      | {
                          readonly __typename: 'User'
                          readonly id: string
                          readonly username: string
                          readonly availability?: string | undefined
                          readonly avatarUrl?: string | undefined
                          readonly connectionCount: number
                          readonly connectionStatus?:
                            | ConnectionStatusEnum
                            | undefined
                          readonly email?: string | undefined
                          readonly secondaryEmail?: string | undefined
                          readonly firstName: string
                          readonly indispensableSurveyLink: string
                          readonly isCurrentUser: boolean
                          readonly lastName: string
                          readonly termsAcceptedAt?: any | undefined
                          readonly phoneNumber?: string | undefined
                          readonly uri: string
                          readonly activities?:
                            | {
                                readonly pageInfo: {
                                  readonly totalCount: number
                                }
                              }
                            | undefined
                          readonly alerts?:
                            | {
                                readonly pageInfo: {
                                  readonly totalCount: number
                                }
                              }
                            | undefined
                          readonly gigsEmployee?:
                            | {
                                readonly id: string
                                readonly createdAt: any
                                readonly deletedAt?: any | undefined
                                readonly eligibleAt?: any | undefined
                                readonly offboardedAt?: any | undefined
                                readonly onboardedAt?: any | undefined
                                readonly onboardingStatus: OnboardingStatusEnum
                                readonly percentComplete?: number | undefined
                                readonly rejectedAt?: any | undefined
                                readonly savedAt?: any | undefined
                                readonly screeningAt?: any | undefined
                                readonly terminatedAt?: any | undefined
                                readonly updatedAt: any
                                readonly permissions: {
                                  readonly seeHistory: boolean
                                }
                              }
                            | undefined
                          readonly location: {
                            readonly address?: string | undefined
                            readonly addressExtended?: string | undefined
                            readonly city?: string | undefined
                            readonly country?: CountriesEnum | undefined
                            readonly latitude?: number | undefined
                            readonly longitude?: number | undefined
                            readonly postalCode?: string | undefined
                            readonly rawLocation?: string | undefined
                            readonly state?: StatesEnum | undefined
                          }
                          readonly permissions: {
                            readonly applyToJobs: boolean
                            readonly edit: boolean
                            readonly hasRecruiterLabel: boolean
                            readonly imposter: boolean
                            readonly internalUser: boolean
                            readonly publishJobOrders: boolean
                            readonly readEmail: boolean
                            readonly readJobBooster: boolean
                            readonly readNotes: boolean
                            readonly readPhone: boolean
                            readonly triggerIndispensableSurvey: boolean
                            readonly searchCandidates: boolean
                            readonly searchCandidatesAsClient: boolean
                            readonly searchCandidatesAsRecruiter: boolean
                            readonly searchClients: boolean
                            readonly searchClientsByRecruiters: boolean
                            readonly searchJobPostings: boolean
                            readonly searchJobPostingsByRecruiter: boolean
                            readonly sendMessage: boolean
                            readonly trainableUser: boolean
                            readonly updateConnectionStatus: boolean
                            readonly uploadCsv: boolean
                            readonly matchCriteria: boolean
                          }
                          readonly social?:
                            | {
                                readonly calendly?: string | undefined
                                readonly linkedin?: string | undefined
                              }
                            | undefined
                          readonly candidate?:
                            | {
                                readonly __typename: 'Candidate'
                                readonly id: string
                                readonly backgroundCheckDate?: any | undefined
                                readonly credentialCount: number
                                readonly dnu?: string | undefined
                                readonly hiringStatus?:
                                  | HiringStatusEnum
                                  | undefined
                                readonly i9Date?: any | undefined
                                readonly idealEmployment?: string | undefined
                                readonly isAbleToApply: boolean
                                readonly isNeedEmploymentSponsor?:
                                  | boolean
                                  | undefined
                                readonly isUsWorkAuthorized?:
                                  | boolean
                                  | undefined
                                readonly noWorkExperience?: boolean | undefined
                                readonly profileCompletedAt?: any | undefined
                                readonly profilePercentComplete?:
                                  | number
                                  | undefined
                                readonly relayId: string
                                readonly resumeUrl?: string | undefined
                                readonly salaryExpectations?: string | undefined
                                readonly candidateLicenses?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly date?: any | undefined
                                      readonly number?: string | undefined
                                      readonly url?: string | undefined
                                      readonly license?:
                                        | {
                                            readonly id: string
                                            readonly name: string
                                            readonly country: CountriesEnum
                                            readonly state?: string | undefined
                                          }
                                        | undefined
                                    }>
                                  | undefined
                                readonly credentials?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly title: string
                                      readonly badgeUrl: string
                                      readonly description?: string | undefined
                                      readonly training: {
                                        readonly id: string
                                        readonly trainingUrl: string
                                      }
                                    }>
                                  | undefined
                                readonly education?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly degree?: string | undefined
                                      readonly educationLevel?:
                                        | EducationLevelEnum
                                        | undefined
                                      readonly school?: string | undefined
                                      readonly yearsAttended?:
                                        | number
                                        | undefined
                                    }>
                                  | undefined
                                readonly experiences?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly companyName?: string | undefined
                                      readonly current?: boolean | undefined
                                      readonly endDate?: any | undefined
                                      readonly jobTitle?: string | undefined
                                      readonly responsibilities?:
                                        | string
                                        | undefined
                                      readonly startDate?: any | undefined
                                      readonly yearsEmployed?:
                                        | number
                                        | undefined
                                    }>
                                  | undefined
                                readonly placements?:
                                  | ReadonlyArray<{
                                      readonly startDate?: any | undefined
                                      readonly id: string
                                      readonly interviewDate?: any | undefined
                                      readonly status?:
                                        | PlacementStatusEnum
                                        | undefined
                                      readonly permissions: {
                                        readonly update: boolean
                                      }
                                      readonly jobPosting: {
                                        readonly id: string
                                        readonly slug: string
                                        readonly title: string
                                        readonly client?:
                                          | { readonly displayname: string }
                                          | undefined
                                        readonly permissions: {
                                          readonly readJobApps: boolean
                                          readonly readPlacements: boolean
                                        }
                                      }
                                    }>
                                  | undefined
                                readonly jobApplications?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly status?:
                                        | JobApplicationStatusEnum
                                        | undefined
                                      readonly permissions: {
                                        readonly show: boolean
                                      }
                                      readonly jobPosting: {
                                        readonly id: string
                                        readonly level?: number | undefined
                                        readonly slug: string
                                        readonly title: string
                                        readonly client?:
                                          | {
                                              readonly displayname: string
                                              readonly name: string
                                            }
                                          | undefined
                                        readonly permissions: {
                                          readonly readJobApps: boolean
                                          readonly readPlacements: boolean
                                          readonly managePlacements: boolean
                                        }
                                        readonly jobPostingScreening?:
                                          | { readonly id: string }
                                          | undefined
                                      }
                                      readonly screeningSubmissions?:
                                        | ReadonlyArray<{ readonly id: string }>
                                        | undefined
                                    }>
                                  | undefined
                                readonly permissions: {
                                  readonly edit: boolean
                                  readonly readApplications: boolean
                                  readonly readCredentials: boolean
                                  readonly readLicense: boolean
                                  readonly readResume: boolean
                                  readonly readWorkPreferences: boolean
                                }
                                readonly recruiters?:
                                  | ReadonlyArray<{
                                      readonly avatarUrl?: string | undefined
                                      readonly firstName: string
                                      readonly id: string
                                      readonly lastName: string
                                    }>
                                  | undefined
                                readonly skillRelations?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly years: number
                                      readonly skill: {
                                        readonly __typename: 'Skill'
                                        readonly id: string
                                        readonly name: string
                                      }
                                    }>
                                  | undefined
                                readonly summary?:
                                  | {
                                      readonly id: string
                                      readonly entry: string
                                      readonly title: string
                                    }
                                  | undefined
                              }
                            | undefined
                          readonly subscription?:
                            | {
                                readonly __typename: 'Subscription'
                                readonly id: string
                                readonly active: boolean
                                readonly plan: string
                              }
                            | undefined
                        }
                      | undefined
                  }
                | undefined
            }
          | undefined
        >
      | undefined
    readonly pageInfo: {
      readonly endCursor?: string | undefined
      readonly hasNextPage: boolean
      readonly hasPreviousPage: boolean
      readonly startCursor?: string | undefined
      readonly totalCount: number
    }
  }
}

export type CompanyJobPlacementsQueryVariables = Exact<{
  jobPostingId: Scalars['String']['input']
  status?: InputMaybe<ReadonlyArray<PlacementStatusEnum> | PlacementStatusEnum>
  candidateId?: InputMaybe<Scalars['String']['input']>
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}>

export type CompanyJobPlacementsQuery = {
  readonly getPlacements: {
    readonly edges?:
      | ReadonlyArray<
          | {
              readonly cursor: string
              readonly node?:
                | {
                    readonly __typename: 'Placement'
                    readonly id: string
                    readonly createdAt: any
                    readonly interviewDate?: any | undefined
                    readonly startDate?: any | undefined
                    readonly status?: PlacementStatusEnum | undefined
                    readonly updatedAt: any
                    readonly jobPosting: { readonly id: string }
                    readonly permissions: { readonly seeHistory: boolean }
                    readonly history?:
                      | ReadonlyArray<{
                          readonly __typename: 'Version'
                          readonly whodunnit?: string | undefined
                        }>
                      | undefined
                    readonly user?:
                      | {
                          readonly __typename: 'User'
                          readonly id: string
                          readonly username: string
                          readonly availability?: string | undefined
                          readonly avatarUrl?: string | undefined
                          readonly connectionCount: number
                          readonly connectionStatus?:
                            | ConnectionStatusEnum
                            | undefined
                          readonly email?: string | undefined
                          readonly secondaryEmail?: string | undefined
                          readonly firstName: string
                          readonly indispensableSurveyLink: string
                          readonly isCurrentUser: boolean
                          readonly lastName: string
                          readonly termsAcceptedAt?: any | undefined
                          readonly phoneNumber?: string | undefined
                          readonly uri: string
                          readonly activities?:
                            | {
                                readonly pageInfo: {
                                  readonly totalCount: number
                                }
                              }
                            | undefined
                          readonly alerts?:
                            | {
                                readonly pageInfo: {
                                  readonly totalCount: number
                                }
                              }
                            | undefined
                          readonly gigsEmployee?:
                            | {
                                readonly id: string
                                readonly createdAt: any
                                readonly deletedAt?: any | undefined
                                readonly eligibleAt?: any | undefined
                                readonly offboardedAt?: any | undefined
                                readonly onboardedAt?: any | undefined
                                readonly onboardingStatus: OnboardingStatusEnum
                                readonly percentComplete?: number | undefined
                                readonly rejectedAt?: any | undefined
                                readonly savedAt?: any | undefined
                                readonly screeningAt?: any | undefined
                                readonly terminatedAt?: any | undefined
                                readonly updatedAt: any
                                readonly permissions: {
                                  readonly seeHistory: boolean
                                }
                              }
                            | undefined
                          readonly location: {
                            readonly address?: string | undefined
                            readonly addressExtended?: string | undefined
                            readonly city?: string | undefined
                            readonly country?: CountriesEnum | undefined
                            readonly latitude?: number | undefined
                            readonly longitude?: number | undefined
                            readonly postalCode?: string | undefined
                            readonly rawLocation?: string | undefined
                            readonly state?: StatesEnum | undefined
                          }
                          readonly permissions: {
                            readonly applyToJobs: boolean
                            readonly edit: boolean
                            readonly hasRecruiterLabel: boolean
                            readonly imposter: boolean
                            readonly internalUser: boolean
                            readonly publishJobOrders: boolean
                            readonly readEmail: boolean
                            readonly readJobBooster: boolean
                            readonly readNotes: boolean
                            readonly readPhone: boolean
                            readonly triggerIndispensableSurvey: boolean
                            readonly searchCandidates: boolean
                            readonly searchCandidatesAsClient: boolean
                            readonly searchCandidatesAsRecruiter: boolean
                            readonly searchClients: boolean
                            readonly searchClientsByRecruiters: boolean
                            readonly searchJobPostings: boolean
                            readonly searchJobPostingsByRecruiter: boolean
                            readonly sendMessage: boolean
                            readonly trainableUser: boolean
                            readonly updateConnectionStatus: boolean
                            readonly uploadCsv: boolean
                            readonly matchCriteria: boolean
                          }
                          readonly social?:
                            | {
                                readonly calendly?: string | undefined
                                readonly linkedin?: string | undefined
                              }
                            | undefined
                          readonly candidate?:
                            | {
                                readonly __typename: 'Candidate'
                                readonly id: string
                                readonly backgroundCheckDate?: any | undefined
                                readonly credentialCount: number
                                readonly dnu?: string | undefined
                                readonly hiringStatus?:
                                  | HiringStatusEnum
                                  | undefined
                                readonly i9Date?: any | undefined
                                readonly idealEmployment?: string | undefined
                                readonly isAbleToApply: boolean
                                readonly isNeedEmploymentSponsor?:
                                  | boolean
                                  | undefined
                                readonly isUsWorkAuthorized?:
                                  | boolean
                                  | undefined
                                readonly noWorkExperience?: boolean | undefined
                                readonly profileCompletedAt?: any | undefined
                                readonly profilePercentComplete?:
                                  | number
                                  | undefined
                                readonly relayId: string
                                readonly resumeUrl?: string | undefined
                                readonly salaryExpectations?: string | undefined
                                readonly candidateLicenses?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly date?: any | undefined
                                      readonly number?: string | undefined
                                      readonly url?: string | undefined
                                      readonly license?:
                                        | {
                                            readonly id: string
                                            readonly name: string
                                            readonly country: CountriesEnum
                                            readonly state?: string | undefined
                                          }
                                        | undefined
                                    }>
                                  | undefined
                                readonly credentials?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly title: string
                                      readonly badgeUrl: string
                                      readonly description?: string | undefined
                                      readonly training: {
                                        readonly id: string
                                        readonly trainingUrl: string
                                      }
                                    }>
                                  | undefined
                                readonly education?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly degree?: string | undefined
                                      readonly educationLevel?:
                                        | EducationLevelEnum
                                        | undefined
                                      readonly school?: string | undefined
                                      readonly yearsAttended?:
                                        | number
                                        | undefined
                                    }>
                                  | undefined
                                readonly experiences?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly companyName?: string | undefined
                                      readonly current?: boolean | undefined
                                      readonly endDate?: any | undefined
                                      readonly jobTitle?: string | undefined
                                      readonly responsibilities?:
                                        | string
                                        | undefined
                                      readonly startDate?: any | undefined
                                      readonly yearsEmployed?:
                                        | number
                                        | undefined
                                    }>
                                  | undefined
                                readonly placements?:
                                  | ReadonlyArray<{
                                      readonly startDate?: any | undefined
                                      readonly id: string
                                      readonly interviewDate?: any | undefined
                                      readonly status?:
                                        | PlacementStatusEnum
                                        | undefined
                                      readonly permissions: {
                                        readonly update: boolean
                                      }
                                      readonly jobPosting: {
                                        readonly id: string
                                        readonly slug: string
                                        readonly title: string
                                        readonly client?:
                                          | { readonly displayname: string }
                                          | undefined
                                        readonly permissions: {
                                          readonly readJobApps: boolean
                                          readonly readPlacements: boolean
                                        }
                                      }
                                    }>
                                  | undefined
                                readonly jobApplications?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly status?:
                                        | JobApplicationStatusEnum
                                        | undefined
                                      readonly permissions: {
                                        readonly show: boolean
                                      }
                                      readonly jobPosting: {
                                        readonly id: string
                                        readonly level?: number | undefined
                                        readonly slug: string
                                        readonly title: string
                                        readonly client?:
                                          | {
                                              readonly displayname: string
                                              readonly name: string
                                            }
                                          | undefined
                                        readonly permissions: {
                                          readonly readJobApps: boolean
                                          readonly readPlacements: boolean
                                          readonly managePlacements: boolean
                                        }
                                        readonly jobPostingScreening?:
                                          | { readonly id: string }
                                          | undefined
                                      }
                                      readonly screeningSubmissions?:
                                        | ReadonlyArray<{ readonly id: string }>
                                        | undefined
                                    }>
                                  | undefined
                                readonly permissions: {
                                  readonly edit: boolean
                                  readonly readApplications: boolean
                                  readonly readCredentials: boolean
                                  readonly readLicense: boolean
                                  readonly readResume: boolean
                                  readonly readWorkPreferences: boolean
                                }
                                readonly recruiters?:
                                  | ReadonlyArray<{
                                      readonly avatarUrl?: string | undefined
                                      readonly firstName: string
                                      readonly id: string
                                      readonly lastName: string
                                    }>
                                  | undefined
                                readonly skillRelations?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly years: number
                                      readonly skill: {
                                        readonly __typename: 'Skill'
                                        readonly id: string
                                        readonly name: string
                                      }
                                    }>
                                  | undefined
                                readonly summary?:
                                  | {
                                      readonly id: string
                                      readonly entry: string
                                      readonly title: string
                                    }
                                  | undefined
                              }
                            | undefined
                          readonly subscription?:
                            | {
                                readonly __typename: 'Subscription'
                                readonly id: string
                                readonly active: boolean
                                readonly plan: string
                              }
                            | undefined
                        }
                      | undefined
                  }
                | undefined
            }
          | undefined
        >
      | undefined
    readonly pageInfo: {
      readonly endCursor?: string | undefined
      readonly hasNextPage: boolean
      readonly hasPreviousPage: boolean
      readonly startCursor?: string | undefined
      readonly totalCount: number
    }
  }
}

export type CompanyCompanyJobPlacementsQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']['input']>
  jobPostingId: Scalars['String']['input']
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}>

export type CompanyCompanyJobPlacementsQuery = {
  readonly getCompanyPlacements: {
    readonly edges?:
      | ReadonlyArray<
          | {
              readonly cursor: string
              readonly node?:
                | {
                    readonly __typename: 'Placement'
                    readonly id: string
                    readonly createdAt: any
                    readonly interviewDate?: any | undefined
                    readonly startDate?: any | undefined
                    readonly status?: PlacementStatusEnum | undefined
                    readonly updatedAt: any
                    readonly jobPosting: { readonly id: string }
                    readonly permissions: { readonly seeHistory: boolean }
                    readonly history?:
                      | ReadonlyArray<{
                          readonly __typename: 'Version'
                          readonly whodunnit?: string | undefined
                        }>
                      | undefined
                    readonly user?:
                      | {
                          readonly __typename: 'User'
                          readonly id: string
                          readonly username: string
                          readonly availability?: string | undefined
                          readonly avatarUrl?: string | undefined
                          readonly connectionCount: number
                          readonly connectionStatus?:
                            | ConnectionStatusEnum
                            | undefined
                          readonly email?: string | undefined
                          readonly secondaryEmail?: string | undefined
                          readonly firstName: string
                          readonly indispensableSurveyLink: string
                          readonly isCurrentUser: boolean
                          readonly lastName: string
                          readonly termsAcceptedAt?: any | undefined
                          readonly phoneNumber?: string | undefined
                          readonly uri: string
                          readonly activities?:
                            | {
                                readonly pageInfo: {
                                  readonly totalCount: number
                                }
                              }
                            | undefined
                          readonly alerts?:
                            | {
                                readonly pageInfo: {
                                  readonly totalCount: number
                                }
                              }
                            | undefined
                          readonly gigsEmployee?:
                            | {
                                readonly id: string
                                readonly createdAt: any
                                readonly deletedAt?: any | undefined
                                readonly eligibleAt?: any | undefined
                                readonly offboardedAt?: any | undefined
                                readonly onboardedAt?: any | undefined
                                readonly onboardingStatus: OnboardingStatusEnum
                                readonly percentComplete?: number | undefined
                                readonly rejectedAt?: any | undefined
                                readonly savedAt?: any | undefined
                                readonly screeningAt?: any | undefined
                                readonly terminatedAt?: any | undefined
                                readonly updatedAt: any
                                readonly permissions: {
                                  readonly seeHistory: boolean
                                }
                              }
                            | undefined
                          readonly location: {
                            readonly address?: string | undefined
                            readonly addressExtended?: string | undefined
                            readonly city?: string | undefined
                            readonly country?: CountriesEnum | undefined
                            readonly latitude?: number | undefined
                            readonly longitude?: number | undefined
                            readonly postalCode?: string | undefined
                            readonly rawLocation?: string | undefined
                            readonly state?: StatesEnum | undefined
                          }
                          readonly permissions: {
                            readonly applyToJobs: boolean
                            readonly edit: boolean
                            readonly hasRecruiterLabel: boolean
                            readonly imposter: boolean
                            readonly internalUser: boolean
                            readonly publishJobOrders: boolean
                            readonly readEmail: boolean
                            readonly readJobBooster: boolean
                            readonly readNotes: boolean
                            readonly readPhone: boolean
                            readonly triggerIndispensableSurvey: boolean
                            readonly searchCandidates: boolean
                            readonly searchCandidatesAsClient: boolean
                            readonly searchCandidatesAsRecruiter: boolean
                            readonly searchClients: boolean
                            readonly searchClientsByRecruiters: boolean
                            readonly searchJobPostings: boolean
                            readonly searchJobPostingsByRecruiter: boolean
                            readonly sendMessage: boolean
                            readonly trainableUser: boolean
                            readonly updateConnectionStatus: boolean
                            readonly uploadCsv: boolean
                            readonly matchCriteria: boolean
                          }
                          readonly social?:
                            | {
                                readonly calendly?: string | undefined
                                readonly linkedin?: string | undefined
                              }
                            | undefined
                          readonly candidate?:
                            | {
                                readonly __typename: 'Candidate'
                                readonly id: string
                                readonly backgroundCheckDate?: any | undefined
                                readonly credentialCount: number
                                readonly dnu?: string | undefined
                                readonly hiringStatus?:
                                  | HiringStatusEnum
                                  | undefined
                                readonly i9Date?: any | undefined
                                readonly idealEmployment?: string | undefined
                                readonly isAbleToApply: boolean
                                readonly isNeedEmploymentSponsor?:
                                  | boolean
                                  | undefined
                                readonly isUsWorkAuthorized?:
                                  | boolean
                                  | undefined
                                readonly noWorkExperience?: boolean | undefined
                                readonly profileCompletedAt?: any | undefined
                                readonly profilePercentComplete?:
                                  | number
                                  | undefined
                                readonly relayId: string
                                readonly resumeUrl?: string | undefined
                                readonly salaryExpectations?: string | undefined
                                readonly candidateLicenses?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly date?: any | undefined
                                      readonly number?: string | undefined
                                      readonly url?: string | undefined
                                      readonly license?:
                                        | {
                                            readonly id: string
                                            readonly name: string
                                            readonly country: CountriesEnum
                                            readonly state?: string | undefined
                                          }
                                        | undefined
                                    }>
                                  | undefined
                                readonly credentials?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly title: string
                                      readonly badgeUrl: string
                                      readonly description?: string | undefined
                                      readonly training: {
                                        readonly id: string
                                        readonly trainingUrl: string
                                      }
                                    }>
                                  | undefined
                                readonly education?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly degree?: string | undefined
                                      readonly educationLevel?:
                                        | EducationLevelEnum
                                        | undefined
                                      readonly school?: string | undefined
                                      readonly yearsAttended?:
                                        | number
                                        | undefined
                                    }>
                                  | undefined
                                readonly experiences?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly companyName?: string | undefined
                                      readonly current?: boolean | undefined
                                      readonly endDate?: any | undefined
                                      readonly jobTitle?: string | undefined
                                      readonly responsibilities?:
                                        | string
                                        | undefined
                                      readonly startDate?: any | undefined
                                      readonly yearsEmployed?:
                                        | number
                                        | undefined
                                    }>
                                  | undefined
                                readonly placements?:
                                  | ReadonlyArray<{
                                      readonly startDate?: any | undefined
                                      readonly id: string
                                      readonly interviewDate?: any | undefined
                                      readonly status?:
                                        | PlacementStatusEnum
                                        | undefined
                                      readonly permissions: {
                                        readonly update: boolean
                                      }
                                      readonly jobPosting: {
                                        readonly id: string
                                        readonly slug: string
                                        readonly title: string
                                        readonly client?:
                                          | { readonly displayname: string }
                                          | undefined
                                        readonly permissions: {
                                          readonly readJobApps: boolean
                                          readonly readPlacements: boolean
                                        }
                                      }
                                    }>
                                  | undefined
                                readonly jobApplications?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly status?:
                                        | JobApplicationStatusEnum
                                        | undefined
                                      readonly permissions: {
                                        readonly show: boolean
                                      }
                                      readonly jobPosting: {
                                        readonly id: string
                                        readonly level?: number | undefined
                                        readonly slug: string
                                        readonly title: string
                                        readonly client?:
                                          | {
                                              readonly displayname: string
                                              readonly name: string
                                            }
                                          | undefined
                                        readonly permissions: {
                                          readonly readJobApps: boolean
                                          readonly readPlacements: boolean
                                          readonly managePlacements: boolean
                                        }
                                        readonly jobPostingScreening?:
                                          | { readonly id: string }
                                          | undefined
                                      }
                                      readonly screeningSubmissions?:
                                        | ReadonlyArray<{ readonly id: string }>
                                        | undefined
                                    }>
                                  | undefined
                                readonly permissions: {
                                  readonly edit: boolean
                                  readonly readApplications: boolean
                                  readonly readCredentials: boolean
                                  readonly readLicense: boolean
                                  readonly readResume: boolean
                                  readonly readWorkPreferences: boolean
                                }
                                readonly recruiters?:
                                  | ReadonlyArray<{
                                      readonly avatarUrl?: string | undefined
                                      readonly firstName: string
                                      readonly id: string
                                      readonly lastName: string
                                    }>
                                  | undefined
                                readonly skillRelations?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly years: number
                                      readonly skill: {
                                        readonly __typename: 'Skill'
                                        readonly id: string
                                        readonly name: string
                                      }
                                    }>
                                  | undefined
                                readonly summary?:
                                  | {
                                      readonly id: string
                                      readonly entry: string
                                      readonly title: string
                                    }
                                  | undefined
                              }
                            | undefined
                          readonly subscription?:
                            | {
                                readonly __typename: 'Subscription'
                                readonly id: string
                                readonly active: boolean
                                readonly plan: string
                              }
                            | undefined
                        }
                      | undefined
                  }
                | undefined
            }
          | undefined
        >
      | undefined
    readonly pageInfo: {
      readonly endCursor?: string | undefined
      readonly hasNextPage: boolean
      readonly hasPreviousPage: boolean
      readonly startCursor?: string | undefined
      readonly totalCount: number
    }
  }
}

export type CreateCompanyUserMutationVariables = Exact<{
  input: CreateCompanyUserInput
}>

export type CreateCompanyUserMutation = {
  readonly createCompanyUser?:
    | {
        readonly id: string
        readonly firstName: string
        readonly lastName: string
        readonly username: string
        readonly client?:
          | { readonly displayname: string; readonly name: string }
          | undefined
      }
    | undefined
}

export type FollowCompanyMutationVariables = Exact<{
  input: FollowClientInput
}>

export type FollowCompanyMutation = {
  readonly followClient: {
    readonly __typename: 'Client'
    readonly id: string
    readonly billingAddress?: string | undefined
    readonly accountsPayableEmail?: string | undefined
    readonly displayname: string
    readonly avatarUrl?: string | undefined
    readonly companySize?: CompanySizeEnum | undefined
    readonly connectionStatus?: ConnectionStatusEnum | undefined
    readonly countAvailablePositions: number
    readonly countRecentPositions: number
    readonly headline: string
    readonly metaDescription: string
    readonly metaTitle: string
    readonly name: string
    readonly profileComplete: boolean
    readonly profileCompletedAt?: any | undefined
    readonly uri: string
    readonly visibleOnPlatform: boolean
    readonly website?: string | undefined
    readonly companyDescription?: string | undefined
    readonly companyEmploymentBenefits?:
      | ReadonlyArray<{
          readonly id: string
          readonly employmentBenefit: {
            readonly icon: string
            readonly id: string
            readonly name: string
          }
        }>
      | undefined
    readonly companyLocations?:
      | ReadonlyArray<{
          readonly address?: string | undefined
          readonly addressExtended?: string | undefined
          readonly city?: string | undefined
          readonly country?: CountriesEnum | undefined
          readonly latitude?: number | undefined
          readonly longitude?: number | undefined
          readonly postalCode?: string | undefined
          readonly rawLocation?: string | undefined
          readonly state?: StatesEnum | undefined
        }>
      | undefined
    readonly companyPhotos?:
      | ReadonlyArray<{
          readonly id: string
          readonly alt?: string | undefined
          readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
          readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
          readonly url: string
        }>
      | undefined
    readonly companyValues?:
      | ReadonlyArray<{
          readonly id: string
          readonly description: string
          readonly title: string
        }>
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly createJobPosting: boolean
      readonly edit: boolean
      readonly editMeta: boolean
      readonly internalUser: boolean
      readonly readPendingBanner: boolean
      readonly toggleVisible: boolean
    }
    readonly social?:
      | {
          readonly facebook?: string | undefined
          readonly instagram?: string | undefined
          readonly linkedin?: string | undefined
          readonly twitter?: string | undefined
        }
      | undefined
    readonly trainings: { readonly pageInfo: { readonly totalCount: number } }
  }
}

export type IndicateInterestMutationVariables = Exact<{
  input: ClientShowInterestInput
}>

export type IndicateInterestMutation = {
  readonly clientShowInterest?:
    | {
        readonly __typename: 'JobApplication'
        readonly id: string
        readonly atsRecordType?: string | undefined
        readonly createdAt: any
        readonly clientInterestAt?: any | undefined
        readonly clientInterestMessage: string
        readonly hasClientInterest: boolean
        readonly status?: JobApplicationStatusEnum | undefined
        readonly jobPosting: {
          readonly id: string
          readonly level?: number | undefined
          readonly title: string
          readonly slug: string
          readonly jobPostingScreening?:
            | {
                readonly id: string
                readonly screening?:
                  | {
                      readonly id: string
                      readonly description?: string | undefined
                      readonly name?: string | undefined
                      readonly screeningQuestions?:
                        | ReadonlyArray<{
                            readonly id: string
                            readonly typeOf?: string | undefined
                            readonly question?: string | undefined
                          }>
                        | undefined
                    }
                  | undefined
              }
            | undefined
          readonly location: {
            readonly city?: string | undefined
            readonly state?: StatesEnum | undefined
          }
          readonly client?: { readonly displayname: string } | undefined
        }
        readonly permissions: {
          readonly indicateInterest: boolean
          readonly show: boolean
        }
        readonly screeningSubmissions?:
          | ReadonlyArray<{
              readonly id: string
              readonly jobApplication?:
                | {
                    readonly id: string
                    readonly jobPosting: {
                      readonly id: string
                      readonly title: string
                      readonly slug: string
                    }
                  }
                | undefined
              readonly screeningQResponses?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly answer?: any | undefined
                    readonly screeningQuestion?:
                      | {
                          readonly id: string
                          readonly question?: string | undefined
                        }
                      | undefined
                  }>
                | undefined
            }>
          | undefined
        readonly user?:
          | {
              readonly __typename: 'User'
              readonly id: string
              readonly username: string
              readonly availability?: string | undefined
              readonly avatarUrl?: string | undefined
              readonly connectionCount: number
              readonly connectionStatus?: ConnectionStatusEnum | undefined
              readonly email?: string | undefined
              readonly secondaryEmail?: string | undefined
              readonly firstName: string
              readonly indispensableSurveyLink: string
              readonly isCurrentUser: boolean
              readonly lastName: string
              readonly termsAcceptedAt?: any | undefined
              readonly phoneNumber?: string | undefined
              readonly uri: string
              readonly activities?:
                | { readonly pageInfo: { readonly totalCount: number } }
                | undefined
              readonly alerts?:
                | { readonly pageInfo: { readonly totalCount: number } }
                | undefined
              readonly gigsEmployee?:
                | {
                    readonly id: string
                    readonly createdAt: any
                    readonly deletedAt?: any | undefined
                    readonly eligibleAt?: any | undefined
                    readonly offboardedAt?: any | undefined
                    readonly onboardedAt?: any | undefined
                    readonly onboardingStatus: OnboardingStatusEnum
                    readonly percentComplete?: number | undefined
                    readonly rejectedAt?: any | undefined
                    readonly savedAt?: any | undefined
                    readonly screeningAt?: any | undefined
                    readonly terminatedAt?: any | undefined
                    readonly updatedAt: any
                    readonly permissions: { readonly seeHistory: boolean }
                  }
                | undefined
              readonly location: {
                readonly address?: string | undefined
                readonly addressExtended?: string | undefined
                readonly city?: string | undefined
                readonly country?: CountriesEnum | undefined
                readonly latitude?: number | undefined
                readonly longitude?: number | undefined
                readonly postalCode?: string | undefined
                readonly rawLocation?: string | undefined
                readonly state?: StatesEnum | undefined
              }
              readonly permissions: {
                readonly applyToJobs: boolean
                readonly edit: boolean
                readonly hasRecruiterLabel: boolean
                readonly imposter: boolean
                readonly internalUser: boolean
                readonly publishJobOrders: boolean
                readonly readEmail: boolean
                readonly readJobBooster: boolean
                readonly readNotes: boolean
                readonly readPhone: boolean
                readonly triggerIndispensableSurvey: boolean
                readonly searchCandidates: boolean
                readonly searchCandidatesAsClient: boolean
                readonly searchCandidatesAsRecruiter: boolean
                readonly searchClients: boolean
                readonly searchClientsByRecruiters: boolean
                readonly searchJobPostings: boolean
                readonly searchJobPostingsByRecruiter: boolean
                readonly sendMessage: boolean
                readonly trainableUser: boolean
                readonly updateConnectionStatus: boolean
                readonly uploadCsv: boolean
                readonly matchCriteria: boolean
              }
              readonly social?:
                | {
                    readonly calendly?: string | undefined
                    readonly linkedin?: string | undefined
                  }
                | undefined
              readonly candidate?:
                | {
                    readonly __typename: 'Candidate'
                    readonly id: string
                    readonly backgroundCheckDate?: any | undefined
                    readonly credentialCount: number
                    readonly dnu?: string | undefined
                    readonly hiringStatus?: HiringStatusEnum | undefined
                    readonly i9Date?: any | undefined
                    readonly idealEmployment?: string | undefined
                    readonly isAbleToApply: boolean
                    readonly isNeedEmploymentSponsor?: boolean | undefined
                    readonly isUsWorkAuthorized?: boolean | undefined
                    readonly noWorkExperience?: boolean | undefined
                    readonly profileCompletedAt?: any | undefined
                    readonly profilePercentComplete?: number | undefined
                    readonly relayId: string
                    readonly resumeUrl?: string | undefined
                    readonly salaryExpectations?: string | undefined
                    readonly candidateLicenses?:
                      | ReadonlyArray<{
                          readonly id: string
                          readonly date?: any | undefined
                          readonly number?: string | undefined
                          readonly url?: string | undefined
                          readonly license?:
                            | {
                                readonly id: string
                                readonly name: string
                                readonly country: CountriesEnum
                                readonly state?: string | undefined
                              }
                            | undefined
                        }>
                      | undefined
                    readonly credentials?:
                      | ReadonlyArray<{
                          readonly id: string
                          readonly title: string
                          readonly badgeUrl: string
                          readonly description?: string | undefined
                          readonly training: {
                            readonly id: string
                            readonly trainingUrl: string
                          }
                        }>
                      | undefined
                    readonly education?:
                      | ReadonlyArray<{
                          readonly id: string
                          readonly degree?: string | undefined
                          readonly educationLevel?:
                            | EducationLevelEnum
                            | undefined
                          readonly school?: string | undefined
                          readonly yearsAttended?: number | undefined
                        }>
                      | undefined
                    readonly experiences?:
                      | ReadonlyArray<{
                          readonly id: string
                          readonly companyName?: string | undefined
                          readonly current?: boolean | undefined
                          readonly endDate?: any | undefined
                          readonly jobTitle?: string | undefined
                          readonly responsibilities?: string | undefined
                          readonly startDate?: any | undefined
                          readonly yearsEmployed?: number | undefined
                        }>
                      | undefined
                    readonly placements?:
                      | ReadonlyArray<{
                          readonly startDate?: any | undefined
                          readonly id: string
                          readonly interviewDate?: any | undefined
                          readonly status?: PlacementStatusEnum | undefined
                          readonly permissions: { readonly update: boolean }
                          readonly jobPosting: {
                            readonly id: string
                            readonly slug: string
                            readonly title: string
                            readonly client?:
                              | { readonly displayname: string }
                              | undefined
                            readonly permissions: {
                              readonly readJobApps: boolean
                              readonly readPlacements: boolean
                            }
                          }
                        }>
                      | undefined
                    readonly jobApplications?:
                      | ReadonlyArray<{
                          readonly id: string
                          readonly status?: JobApplicationStatusEnum | undefined
                          readonly permissions: { readonly show: boolean }
                          readonly jobPosting: {
                            readonly id: string
                            readonly level?: number | undefined
                            readonly slug: string
                            readonly title: string
                            readonly client?:
                              | {
                                  readonly displayname: string
                                  readonly name: string
                                }
                              | undefined
                            readonly permissions: {
                              readonly readJobApps: boolean
                              readonly readPlacements: boolean
                              readonly managePlacements: boolean
                            }
                            readonly jobPostingScreening?:
                              | { readonly id: string }
                              | undefined
                          }
                          readonly screeningSubmissions?:
                            | ReadonlyArray<{ readonly id: string }>
                            | undefined
                        }>
                      | undefined
                    readonly permissions: {
                      readonly edit: boolean
                      readonly readApplications: boolean
                      readonly readCredentials: boolean
                      readonly readLicense: boolean
                      readonly readResume: boolean
                      readonly readWorkPreferences: boolean
                    }
                    readonly recruiters?:
                      | ReadonlyArray<{
                          readonly avatarUrl?: string | undefined
                          readonly firstName: string
                          readonly id: string
                          readonly lastName: string
                        }>
                      | undefined
                    readonly skillRelations?:
                      | ReadonlyArray<{
                          readonly id: string
                          readonly years: number
                          readonly skill: {
                            readonly __typename: 'Skill'
                            readonly id: string
                            readonly name: string
                          }
                        }>
                      | undefined
                    readonly summary?:
                      | {
                          readonly id: string
                          readonly entry: string
                          readonly title: string
                        }
                      | undefined
                  }
                | undefined
              readonly subscription?:
                | {
                    readonly __typename: 'Subscription'
                    readonly id: string
                    readonly active: boolean
                    readonly plan: string
                  }
                | undefined
            }
          | undefined
      }
    | undefined
}

export type UnfollowCompanyMutationVariables = Exact<{
  input: UnfollowClientInput
}>

export type UnfollowCompanyMutation = {
  readonly unfollowClient: {
    readonly __typename: 'Client'
    readonly id: string
    readonly billingAddress?: string | undefined
    readonly accountsPayableEmail?: string | undefined
    readonly displayname: string
    readonly avatarUrl?: string | undefined
    readonly companySize?: CompanySizeEnum | undefined
    readonly connectionStatus?: ConnectionStatusEnum | undefined
    readonly countAvailablePositions: number
    readonly countRecentPositions: number
    readonly headline: string
    readonly metaDescription: string
    readonly metaTitle: string
    readonly name: string
    readonly profileComplete: boolean
    readonly profileCompletedAt?: any | undefined
    readonly uri: string
    readonly visibleOnPlatform: boolean
    readonly website?: string | undefined
    readonly companyDescription?: string | undefined
    readonly companyEmploymentBenefits?:
      | ReadonlyArray<{
          readonly id: string
          readonly employmentBenefit: {
            readonly icon: string
            readonly id: string
            readonly name: string
          }
        }>
      | undefined
    readonly companyLocations?:
      | ReadonlyArray<{
          readonly address?: string | undefined
          readonly addressExtended?: string | undefined
          readonly city?: string | undefined
          readonly country?: CountriesEnum | undefined
          readonly latitude?: number | undefined
          readonly longitude?: number | undefined
          readonly postalCode?: string | undefined
          readonly rawLocation?: string | undefined
          readonly state?: StatesEnum | undefined
        }>
      | undefined
    readonly companyPhotos?:
      | ReadonlyArray<{
          readonly id: string
          readonly alt?: string | undefined
          readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
          readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
          readonly url: string
        }>
      | undefined
    readonly companyValues?:
      | ReadonlyArray<{
          readonly id: string
          readonly description: string
          readonly title: string
        }>
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly createJobPosting: boolean
      readonly edit: boolean
      readonly editMeta: boolean
      readonly internalUser: boolean
      readonly readPendingBanner: boolean
      readonly toggleVisible: boolean
    }
    readonly social?:
      | {
          readonly facebook?: string | undefined
          readonly instagram?: string | undefined
          readonly linkedin?: string | undefined
          readonly twitter?: string | undefined
        }
      | undefined
    readonly trainings: { readonly pageInfo: { readonly totalCount: number } }
  }
}

export type UpdateCompanyMutationVariables = Exact<{
  input: UpdateCompanyInput
}>

export type UpdateCompanyMutation = {
  readonly updateCompany: {
    readonly id: string
    readonly avatarUrl?: string | undefined
    readonly billingAddress?: string | undefined
    readonly accountsPayableEmail?: string | undefined
    readonly companySize?: CompanySizeEnum | undefined
    readonly description?: string | undefined
    readonly displayname: string
    readonly headline: string
    readonly metaDescription: string
    readonly metaTitle: string
    readonly name: string
    readonly visibleOnPlatform: boolean
    readonly website?: string | undefined
    readonly companyPhotos?:
      | ReadonlyArray<{
          readonly id: string
          readonly alt?: string | undefined
          readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
          readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
          readonly url: string
        }>
      | undefined
    readonly companyEmploymentBenefits?:
      | ReadonlyArray<{
          readonly id: string
          readonly employmentBenefit: {
            readonly icon: string
            readonly id: string
            readonly name: string
          }
        }>
      | undefined
    readonly companyLocations?:
      | ReadonlyArray<{
          readonly address?: string | undefined
          readonly addressExtended?: string | undefined
          readonly city?: string | undefined
          readonly country?: CountriesEnum | undefined
          readonly latitude?: number | undefined
          readonly longitude?: number | undefined
          readonly postalCode?: string | undefined
          readonly rawLocation?: string | undefined
          readonly state?: StatesEnum | undefined
        }>
      | undefined
    readonly companyValues?:
      | ReadonlyArray<{
          readonly id: string
          readonly description: string
          readonly title: string
        }>
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly toggleVisible: boolean
      readonly editMeta: boolean
    }
    readonly social?:
      | {
          readonly facebook?: string | undefined
          readonly instagram?: string | undefined
          readonly linkedin?: string | undefined
          readonly twitter?: string | undefined
        }
      | undefined
    readonly users?:
      | ReadonlyArray<{
          readonly id: string
          readonly firstName: string
          readonly lastName: string
          readonly email?: string | undefined
        }>
      | undefined
  }
}

export type UpdateJobApplicationMutationVariables = Exact<{
  input: UpdateJobApplicationInput
}>

export type UpdateJobApplicationMutation = {
  readonly updateJobApplication: {
    readonly __typename: 'JobApplication'
    readonly id: string
    readonly atsRecordType?: string | undefined
    readonly createdAt: any
    readonly clientInterestAt?: any | undefined
    readonly clientInterestMessage: string
    readonly hasClientInterest: boolean
    readonly status?: JobApplicationStatusEnum | undefined
    readonly jobPosting: {
      readonly id: string
      readonly level?: number | undefined
      readonly title: string
      readonly slug: string
      readonly jobPostingScreening?:
        | {
            readonly id: string
            readonly screening?:
              | {
                  readonly id: string
                  readonly description?: string | undefined
                  readonly name?: string | undefined
                  readonly screeningQuestions?:
                    | ReadonlyArray<{
                        readonly id: string
                        readonly typeOf?: string | undefined
                        readonly question?: string | undefined
                      }>
                    | undefined
                }
              | undefined
          }
        | undefined
      readonly location: {
        readonly city?: string | undefined
        readonly state?: StatesEnum | undefined
      }
      readonly client?: { readonly displayname: string } | undefined
    }
    readonly permissions: {
      readonly indicateInterest: boolean
      readonly show: boolean
    }
    readonly screeningSubmissions?:
      | ReadonlyArray<{
          readonly id: string
          readonly jobApplication?:
            | {
                readonly id: string
                readonly jobPosting: {
                  readonly id: string
                  readonly title: string
                  readonly slug: string
                }
              }
            | undefined
          readonly screeningQResponses?:
            | ReadonlyArray<{
                readonly id: string
                readonly answer?: any | undefined
                readonly screeningQuestion?:
                  | {
                      readonly id: string
                      readonly question?: string | undefined
                    }
                  | undefined
              }>
            | undefined
        }>
      | undefined
    readonly user?:
      | {
          readonly __typename: 'User'
          readonly id: string
          readonly username: string
          readonly availability?: string | undefined
          readonly avatarUrl?: string | undefined
          readonly connectionCount: number
          readonly connectionStatus?: ConnectionStatusEnum | undefined
          readonly email?: string | undefined
          readonly secondaryEmail?: string | undefined
          readonly firstName: string
          readonly indispensableSurveyLink: string
          readonly isCurrentUser: boolean
          readonly lastName: string
          readonly termsAcceptedAt?: any | undefined
          readonly phoneNumber?: string | undefined
          readonly uri: string
          readonly activities?:
            | { readonly pageInfo: { readonly totalCount: number } }
            | undefined
          readonly alerts?:
            | { readonly pageInfo: { readonly totalCount: number } }
            | undefined
          readonly gigsEmployee?:
            | {
                readonly id: string
                readonly createdAt: any
                readonly deletedAt?: any | undefined
                readonly eligibleAt?: any | undefined
                readonly offboardedAt?: any | undefined
                readonly onboardedAt?: any | undefined
                readonly onboardingStatus: OnboardingStatusEnum
                readonly percentComplete?: number | undefined
                readonly rejectedAt?: any | undefined
                readonly savedAt?: any | undefined
                readonly screeningAt?: any | undefined
                readonly terminatedAt?: any | undefined
                readonly updatedAt: any
                readonly permissions: { readonly seeHistory: boolean }
              }
            | undefined
          readonly location: {
            readonly address?: string | undefined
            readonly addressExtended?: string | undefined
            readonly city?: string | undefined
            readonly country?: CountriesEnum | undefined
            readonly latitude?: number | undefined
            readonly longitude?: number | undefined
            readonly postalCode?: string | undefined
            readonly rawLocation?: string | undefined
            readonly state?: StatesEnum | undefined
          }
          readonly permissions: {
            readonly applyToJobs: boolean
            readonly edit: boolean
            readonly hasRecruiterLabel: boolean
            readonly imposter: boolean
            readonly internalUser: boolean
            readonly publishJobOrders: boolean
            readonly readEmail: boolean
            readonly readJobBooster: boolean
            readonly readNotes: boolean
            readonly readPhone: boolean
            readonly triggerIndispensableSurvey: boolean
            readonly searchCandidates: boolean
            readonly searchCandidatesAsClient: boolean
            readonly searchCandidatesAsRecruiter: boolean
            readonly searchClients: boolean
            readonly searchClientsByRecruiters: boolean
            readonly searchJobPostings: boolean
            readonly searchJobPostingsByRecruiter: boolean
            readonly sendMessage: boolean
            readonly trainableUser: boolean
            readonly updateConnectionStatus: boolean
            readonly uploadCsv: boolean
            readonly matchCriteria: boolean
          }
          readonly social?:
            | {
                readonly calendly?: string | undefined
                readonly linkedin?: string | undefined
              }
            | undefined
          readonly candidate?:
            | {
                readonly __typename: 'Candidate'
                readonly id: string
                readonly backgroundCheckDate?: any | undefined
                readonly credentialCount: number
                readonly dnu?: string | undefined
                readonly hiringStatus?: HiringStatusEnum | undefined
                readonly i9Date?: any | undefined
                readonly idealEmployment?: string | undefined
                readonly isAbleToApply: boolean
                readonly isNeedEmploymentSponsor?: boolean | undefined
                readonly isUsWorkAuthorized?: boolean | undefined
                readonly noWorkExperience?: boolean | undefined
                readonly profileCompletedAt?: any | undefined
                readonly profilePercentComplete?: number | undefined
                readonly relayId: string
                readonly resumeUrl?: string | undefined
                readonly salaryExpectations?: string | undefined
                readonly candidateLicenses?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly date?: any | undefined
                      readonly number?: string | undefined
                      readonly url?: string | undefined
                      readonly license?:
                        | {
                            readonly id: string
                            readonly name: string
                            readonly country: CountriesEnum
                            readonly state?: string | undefined
                          }
                        | undefined
                    }>
                  | undefined
                readonly credentials?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly title: string
                      readonly badgeUrl: string
                      readonly description?: string | undefined
                      readonly training: {
                        readonly id: string
                        readonly trainingUrl: string
                      }
                    }>
                  | undefined
                readonly education?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly degree?: string | undefined
                      readonly educationLevel?: EducationLevelEnum | undefined
                      readonly school?: string | undefined
                      readonly yearsAttended?: number | undefined
                    }>
                  | undefined
                readonly experiences?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly companyName?: string | undefined
                      readonly current?: boolean | undefined
                      readonly endDate?: any | undefined
                      readonly jobTitle?: string | undefined
                      readonly responsibilities?: string | undefined
                      readonly startDate?: any | undefined
                      readonly yearsEmployed?: number | undefined
                    }>
                  | undefined
                readonly placements?:
                  | ReadonlyArray<{
                      readonly startDate?: any | undefined
                      readonly id: string
                      readonly interviewDate?: any | undefined
                      readonly status?: PlacementStatusEnum | undefined
                      readonly permissions: { readonly update: boolean }
                      readonly jobPosting: {
                        readonly id: string
                        readonly slug: string
                        readonly title: string
                        readonly client?:
                          | { readonly displayname: string }
                          | undefined
                        readonly permissions: {
                          readonly readJobApps: boolean
                          readonly readPlacements: boolean
                        }
                      }
                    }>
                  | undefined
                readonly jobApplications?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly status?: JobApplicationStatusEnum | undefined
                      readonly permissions: { readonly show: boolean }
                      readonly jobPosting: {
                        readonly id: string
                        readonly level?: number | undefined
                        readonly slug: string
                        readonly title: string
                        readonly client?:
                          | {
                              readonly displayname: string
                              readonly name: string
                            }
                          | undefined
                        readonly permissions: {
                          readonly readJobApps: boolean
                          readonly readPlacements: boolean
                          readonly managePlacements: boolean
                        }
                        readonly jobPostingScreening?:
                          | { readonly id: string }
                          | undefined
                      }
                      readonly screeningSubmissions?:
                        | ReadonlyArray<{ readonly id: string }>
                        | undefined
                    }>
                  | undefined
                readonly permissions: {
                  readonly edit: boolean
                  readonly readApplications: boolean
                  readonly readCredentials: boolean
                  readonly readLicense: boolean
                  readonly readResume: boolean
                  readonly readWorkPreferences: boolean
                }
                readonly recruiters?:
                  | ReadonlyArray<{
                      readonly avatarUrl?: string | undefined
                      readonly firstName: string
                      readonly id: string
                      readonly lastName: string
                    }>
                  | undefined
                readonly skillRelations?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly years: number
                      readonly skill: {
                        readonly __typename: 'Skill'
                        readonly id: string
                        readonly name: string
                      }
                    }>
                  | undefined
                readonly summary?:
                  | {
                      readonly id: string
                      readonly entry: string
                      readonly title: string
                    }
                  | undefined
              }
            | undefined
          readonly subscription?:
            | {
                readonly __typename: 'Subscription'
                readonly id: string
                readonly active: boolean
                readonly plan: string
              }
            | undefined
        }
      | undefined
  }
}

export type UpdatePlacementMutationVariables = Exact<{
  input: UpdatePlacementInput
}>

export type UpdatePlacementMutation = {
  readonly updatePlacement: {
    readonly __typename: 'Placement'
    readonly id: string
    readonly createdAt: any
    readonly interviewDate?: any | undefined
    readonly startDate?: any | undefined
    readonly status?: PlacementStatusEnum | undefined
    readonly updatedAt: any
    readonly jobPosting: { readonly id: string }
    readonly permissions: { readonly seeHistory: boolean }
    readonly history?:
      | ReadonlyArray<{
          readonly __typename: 'Version'
          readonly whodunnit?: string | undefined
        }>
      | undefined
    readonly user?:
      | {
          readonly __typename: 'User'
          readonly id: string
          readonly username: string
          readonly availability?: string | undefined
          readonly avatarUrl?: string | undefined
          readonly connectionCount: number
          readonly connectionStatus?: ConnectionStatusEnum | undefined
          readonly email?: string | undefined
          readonly secondaryEmail?: string | undefined
          readonly firstName: string
          readonly indispensableSurveyLink: string
          readonly isCurrentUser: boolean
          readonly lastName: string
          readonly termsAcceptedAt?: any | undefined
          readonly phoneNumber?: string | undefined
          readonly uri: string
          readonly activities?:
            | { readonly pageInfo: { readonly totalCount: number } }
            | undefined
          readonly alerts?:
            | { readonly pageInfo: { readonly totalCount: number } }
            | undefined
          readonly gigsEmployee?:
            | {
                readonly id: string
                readonly createdAt: any
                readonly deletedAt?: any | undefined
                readonly eligibleAt?: any | undefined
                readonly offboardedAt?: any | undefined
                readonly onboardedAt?: any | undefined
                readonly onboardingStatus: OnboardingStatusEnum
                readonly percentComplete?: number | undefined
                readonly rejectedAt?: any | undefined
                readonly savedAt?: any | undefined
                readonly screeningAt?: any | undefined
                readonly terminatedAt?: any | undefined
                readonly updatedAt: any
                readonly permissions: { readonly seeHistory: boolean }
              }
            | undefined
          readonly location: {
            readonly address?: string | undefined
            readonly addressExtended?: string | undefined
            readonly city?: string | undefined
            readonly country?: CountriesEnum | undefined
            readonly latitude?: number | undefined
            readonly longitude?: number | undefined
            readonly postalCode?: string | undefined
            readonly rawLocation?: string | undefined
            readonly state?: StatesEnum | undefined
          }
          readonly permissions: {
            readonly applyToJobs: boolean
            readonly edit: boolean
            readonly hasRecruiterLabel: boolean
            readonly imposter: boolean
            readonly internalUser: boolean
            readonly publishJobOrders: boolean
            readonly readEmail: boolean
            readonly readJobBooster: boolean
            readonly readNotes: boolean
            readonly readPhone: boolean
            readonly triggerIndispensableSurvey: boolean
            readonly searchCandidates: boolean
            readonly searchCandidatesAsClient: boolean
            readonly searchCandidatesAsRecruiter: boolean
            readonly searchClients: boolean
            readonly searchClientsByRecruiters: boolean
            readonly searchJobPostings: boolean
            readonly searchJobPostingsByRecruiter: boolean
            readonly sendMessage: boolean
            readonly trainableUser: boolean
            readonly updateConnectionStatus: boolean
            readonly uploadCsv: boolean
            readonly matchCriteria: boolean
          }
          readonly social?:
            | {
                readonly calendly?: string | undefined
                readonly linkedin?: string | undefined
              }
            | undefined
          readonly candidate?:
            | {
                readonly __typename: 'Candidate'
                readonly id: string
                readonly backgroundCheckDate?: any | undefined
                readonly credentialCount: number
                readonly dnu?: string | undefined
                readonly hiringStatus?: HiringStatusEnum | undefined
                readonly i9Date?: any | undefined
                readonly idealEmployment?: string | undefined
                readonly isAbleToApply: boolean
                readonly isNeedEmploymentSponsor?: boolean | undefined
                readonly isUsWorkAuthorized?: boolean | undefined
                readonly noWorkExperience?: boolean | undefined
                readonly profileCompletedAt?: any | undefined
                readonly profilePercentComplete?: number | undefined
                readonly relayId: string
                readonly resumeUrl?: string | undefined
                readonly salaryExpectations?: string | undefined
                readonly candidateLicenses?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly date?: any | undefined
                      readonly number?: string | undefined
                      readonly url?: string | undefined
                      readonly license?:
                        | {
                            readonly id: string
                            readonly name: string
                            readonly country: CountriesEnum
                            readonly state?: string | undefined
                          }
                        | undefined
                    }>
                  | undefined
                readonly credentials?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly title: string
                      readonly badgeUrl: string
                      readonly description?: string | undefined
                      readonly training: {
                        readonly id: string
                        readonly trainingUrl: string
                      }
                    }>
                  | undefined
                readonly education?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly degree?: string | undefined
                      readonly educationLevel?: EducationLevelEnum | undefined
                      readonly school?: string | undefined
                      readonly yearsAttended?: number | undefined
                    }>
                  | undefined
                readonly experiences?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly companyName?: string | undefined
                      readonly current?: boolean | undefined
                      readonly endDate?: any | undefined
                      readonly jobTitle?: string | undefined
                      readonly responsibilities?: string | undefined
                      readonly startDate?: any | undefined
                      readonly yearsEmployed?: number | undefined
                    }>
                  | undefined
                readonly placements?:
                  | ReadonlyArray<{
                      readonly startDate?: any | undefined
                      readonly id: string
                      readonly interviewDate?: any | undefined
                      readonly status?: PlacementStatusEnum | undefined
                      readonly permissions: { readonly update: boolean }
                      readonly jobPosting: {
                        readonly id: string
                        readonly slug: string
                        readonly title: string
                        readonly client?:
                          | { readonly displayname: string }
                          | undefined
                        readonly permissions: {
                          readonly readJobApps: boolean
                          readonly readPlacements: boolean
                        }
                      }
                    }>
                  | undefined
                readonly jobApplications?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly status?: JobApplicationStatusEnum | undefined
                      readonly permissions: { readonly show: boolean }
                      readonly jobPosting: {
                        readonly id: string
                        readonly level?: number | undefined
                        readonly slug: string
                        readonly title: string
                        readonly client?:
                          | {
                              readonly displayname: string
                              readonly name: string
                            }
                          | undefined
                        readonly permissions: {
                          readonly readJobApps: boolean
                          readonly readPlacements: boolean
                          readonly managePlacements: boolean
                        }
                        readonly jobPostingScreening?:
                          | { readonly id: string }
                          | undefined
                      }
                      readonly screeningSubmissions?:
                        | ReadonlyArray<{ readonly id: string }>
                        | undefined
                    }>
                  | undefined
                readonly permissions: {
                  readonly edit: boolean
                  readonly readApplications: boolean
                  readonly readCredentials: boolean
                  readonly readLicense: boolean
                  readonly readResume: boolean
                  readonly readWorkPreferences: boolean
                }
                readonly recruiters?:
                  | ReadonlyArray<{
                      readonly avatarUrl?: string | undefined
                      readonly firstName: string
                      readonly id: string
                      readonly lastName: string
                    }>
                  | undefined
                readonly skillRelations?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly years: number
                      readonly skill: {
                        readonly __typename: 'Skill'
                        readonly id: string
                        readonly name: string
                      }
                    }>
                  | undefined
                readonly summary?:
                  | {
                      readonly id: string
                      readonly entry: string
                      readonly title: string
                    }
                  | undefined
              }
            | undefined
          readonly subscription?:
            | {
                readonly __typename: 'Subscription'
                readonly id: string
                readonly active: boolean
                readonly plan: string
              }
            | undefined
        }
      | undefined
  }
}

export type AddToJobMutationVariables = Exact<{
  input: AddToJobInput
}>

export type AddToJobMutation = {
  readonly addToJob: {
    readonly __typename: 'JobApplication'
    readonly id: string
    readonly atsRecordType?: string | undefined
    readonly createdAt: any
    readonly clientInterestAt?: any | undefined
    readonly clientInterestMessage: string
    readonly hasClientInterest: boolean
    readonly status?: JobApplicationStatusEnum | undefined
    readonly jobPosting: {
      readonly id: string
      readonly level?: number | undefined
      readonly title: string
      readonly slug: string
      readonly jobPostingScreening?:
        | {
            readonly id: string
            readonly screening?:
              | {
                  readonly id: string
                  readonly description?: string | undefined
                  readonly name?: string | undefined
                  readonly screeningQuestions?:
                    | ReadonlyArray<{
                        readonly id: string
                        readonly typeOf?: string | undefined
                        readonly question?: string | undefined
                      }>
                    | undefined
                }
              | undefined
          }
        | undefined
      readonly location: {
        readonly city?: string | undefined
        readonly state?: StatesEnum | undefined
      }
      readonly client?: { readonly displayname: string } | undefined
    }
    readonly permissions: {
      readonly indicateInterest: boolean
      readonly show: boolean
    }
    readonly screeningSubmissions?:
      | ReadonlyArray<{
          readonly id: string
          readonly jobApplication?:
            | {
                readonly id: string
                readonly jobPosting: {
                  readonly id: string
                  readonly title: string
                  readonly slug: string
                }
              }
            | undefined
          readonly screeningQResponses?:
            | ReadonlyArray<{
                readonly id: string
                readonly answer?: any | undefined
                readonly screeningQuestion?:
                  | {
                      readonly id: string
                      readonly question?: string | undefined
                    }
                  | undefined
              }>
            | undefined
        }>
      | undefined
    readonly user?:
      | {
          readonly __typename: 'User'
          readonly id: string
          readonly username: string
          readonly availability?: string | undefined
          readonly avatarUrl?: string | undefined
          readonly connectionCount: number
          readonly connectionStatus?: ConnectionStatusEnum | undefined
          readonly email?: string | undefined
          readonly secondaryEmail?: string | undefined
          readonly firstName: string
          readonly indispensableSurveyLink: string
          readonly isCurrentUser: boolean
          readonly lastName: string
          readonly termsAcceptedAt?: any | undefined
          readonly phoneNumber?: string | undefined
          readonly uri: string
          readonly activities?:
            | { readonly pageInfo: { readonly totalCount: number } }
            | undefined
          readonly alerts?:
            | { readonly pageInfo: { readonly totalCount: number } }
            | undefined
          readonly gigsEmployee?:
            | {
                readonly id: string
                readonly createdAt: any
                readonly deletedAt?: any | undefined
                readonly eligibleAt?: any | undefined
                readonly offboardedAt?: any | undefined
                readonly onboardedAt?: any | undefined
                readonly onboardingStatus: OnboardingStatusEnum
                readonly percentComplete?: number | undefined
                readonly rejectedAt?: any | undefined
                readonly savedAt?: any | undefined
                readonly screeningAt?: any | undefined
                readonly terminatedAt?: any | undefined
                readonly updatedAt: any
                readonly permissions: { readonly seeHistory: boolean }
              }
            | undefined
          readonly location: {
            readonly address?: string | undefined
            readonly addressExtended?: string | undefined
            readonly city?: string | undefined
            readonly country?: CountriesEnum | undefined
            readonly latitude?: number | undefined
            readonly longitude?: number | undefined
            readonly postalCode?: string | undefined
            readonly rawLocation?: string | undefined
            readonly state?: StatesEnum | undefined
          }
          readonly permissions: {
            readonly applyToJobs: boolean
            readonly edit: boolean
            readonly hasRecruiterLabel: boolean
            readonly imposter: boolean
            readonly internalUser: boolean
            readonly publishJobOrders: boolean
            readonly readEmail: boolean
            readonly readJobBooster: boolean
            readonly readNotes: boolean
            readonly readPhone: boolean
            readonly triggerIndispensableSurvey: boolean
            readonly searchCandidates: boolean
            readonly searchCandidatesAsClient: boolean
            readonly searchCandidatesAsRecruiter: boolean
            readonly searchClients: boolean
            readonly searchClientsByRecruiters: boolean
            readonly searchJobPostings: boolean
            readonly searchJobPostingsByRecruiter: boolean
            readonly sendMessage: boolean
            readonly trainableUser: boolean
            readonly updateConnectionStatus: boolean
            readonly uploadCsv: boolean
            readonly matchCriteria: boolean
          }
          readonly social?:
            | {
                readonly calendly?: string | undefined
                readonly linkedin?: string | undefined
              }
            | undefined
          readonly candidate?:
            | {
                readonly __typename: 'Candidate'
                readonly id: string
                readonly backgroundCheckDate?: any | undefined
                readonly credentialCount: number
                readonly dnu?: string | undefined
                readonly hiringStatus?: HiringStatusEnum | undefined
                readonly i9Date?: any | undefined
                readonly idealEmployment?: string | undefined
                readonly isAbleToApply: boolean
                readonly isNeedEmploymentSponsor?: boolean | undefined
                readonly isUsWorkAuthorized?: boolean | undefined
                readonly noWorkExperience?: boolean | undefined
                readonly profileCompletedAt?: any | undefined
                readonly profilePercentComplete?: number | undefined
                readonly relayId: string
                readonly resumeUrl?: string | undefined
                readonly salaryExpectations?: string | undefined
                readonly candidateLicenses?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly date?: any | undefined
                      readonly number?: string | undefined
                      readonly url?: string | undefined
                      readonly license?:
                        | {
                            readonly id: string
                            readonly name: string
                            readonly country: CountriesEnum
                            readonly state?: string | undefined
                          }
                        | undefined
                    }>
                  | undefined
                readonly credentials?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly title: string
                      readonly badgeUrl: string
                      readonly description?: string | undefined
                      readonly training: {
                        readonly id: string
                        readonly trainingUrl: string
                      }
                    }>
                  | undefined
                readonly education?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly degree?: string | undefined
                      readonly educationLevel?: EducationLevelEnum | undefined
                      readonly school?: string | undefined
                      readonly yearsAttended?: number | undefined
                    }>
                  | undefined
                readonly experiences?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly companyName?: string | undefined
                      readonly current?: boolean | undefined
                      readonly endDate?: any | undefined
                      readonly jobTitle?: string | undefined
                      readonly responsibilities?: string | undefined
                      readonly startDate?: any | undefined
                      readonly yearsEmployed?: number | undefined
                    }>
                  | undefined
                readonly placements?:
                  | ReadonlyArray<{
                      readonly startDate?: any | undefined
                      readonly id: string
                      readonly interviewDate?: any | undefined
                      readonly status?: PlacementStatusEnum | undefined
                      readonly permissions: { readonly update: boolean }
                      readonly jobPosting: {
                        readonly id: string
                        readonly slug: string
                        readonly title: string
                        readonly client?:
                          | { readonly displayname: string }
                          | undefined
                        readonly permissions: {
                          readonly readJobApps: boolean
                          readonly readPlacements: boolean
                        }
                      }
                    }>
                  | undefined
                readonly jobApplications?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly status?: JobApplicationStatusEnum | undefined
                      readonly permissions: { readonly show: boolean }
                      readonly jobPosting: {
                        readonly id: string
                        readonly level?: number | undefined
                        readonly slug: string
                        readonly title: string
                        readonly client?:
                          | {
                              readonly displayname: string
                              readonly name: string
                            }
                          | undefined
                        readonly permissions: {
                          readonly readJobApps: boolean
                          readonly readPlacements: boolean
                          readonly managePlacements: boolean
                        }
                        readonly jobPostingScreening?:
                          | { readonly id: string }
                          | undefined
                      }
                      readonly screeningSubmissions?:
                        | ReadonlyArray<{ readonly id: string }>
                        | undefined
                    }>
                  | undefined
                readonly permissions: {
                  readonly edit: boolean
                  readonly readApplications: boolean
                  readonly readCredentials: boolean
                  readonly readLicense: boolean
                  readonly readResume: boolean
                  readonly readWorkPreferences: boolean
                }
                readonly recruiters?:
                  | ReadonlyArray<{
                      readonly avatarUrl?: string | undefined
                      readonly firstName: string
                      readonly id: string
                      readonly lastName: string
                    }>
                  | undefined
                readonly skillRelations?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly years: number
                      readonly skill: {
                        readonly __typename: 'Skill'
                        readonly id: string
                        readonly name: string
                      }
                    }>
                  | undefined
                readonly summary?:
                  | {
                      readonly id: string
                      readonly entry: string
                      readonly title: string
                    }
                  | undefined
              }
            | undefined
          readonly subscription?:
            | {
                readonly __typename: 'Subscription'
                readonly id: string
                readonly active: boolean
                readonly plan: string
              }
            | undefined
        }
      | undefined
  }
}

export type UpdateGigsEmployeeMutationVariables = Exact<{
  input: UpdateGigsEmployeeInput
}>

export type UpdateGigsEmployeeMutation = {
  readonly updateGigsEmployee: {
    readonly id: string
    readonly onboardingStatus: OnboardingStatusEnum
  }
}

export type JobPostingFragment = {
  readonly __typename: 'JobPosting'
  readonly id: string
  readonly accountsPayableEmail?: string | undefined
  readonly applicationReceived: boolean
  readonly atsRecordType?: string | undefined
  readonly atsStatus?: JobPostingAtsStatusEnum | undefined
  readonly baseSalaryValue: number
  readonly countJobApplicationsNew: number
  readonly countJobApplicationsTotal: number
  readonly description: string
  readonly depositAmount?: number | undefined
  readonly education?: string | undefined
  readonly employmentTypes?: ReadonlyArray<EmploymentTypesEnum> | undefined
  readonly endDate?: any | undefined
  readonly quantity?: number | undefined
  readonly experience?: string | undefined
  readonly externalId?: string | undefined
  readonly isIngested: boolean
  readonly isPublished: boolean
  readonly isRemote: boolean
  readonly physicalRequirements?: string | undefined
  readonly postedAt?: any | undefined
  readonly shift?: string | undefined
  readonly syndicateIndeed: boolean
  readonly responsibilities?: string | undefined
  readonly slug: string
  readonly startDate?: any | undefined
  readonly submitApplicationUrl?: string | undefined
  readonly title: string
  readonly uri: string
  readonly validThrough: any
  readonly workingEnvironment?: string | undefined
  readonly accountExecs?:
    | ReadonlyArray<{
        readonly avatarUrl?: string | undefined
        readonly firstName: string
        readonly id: string
        readonly lastName: string
        readonly username: string
      }>
    | undefined
  readonly activities?:
    | { readonly pageInfo: { readonly totalCount: number } }
    | undefined
  readonly client?:
    | {
        readonly __typename: 'Client'
        readonly id: string
        readonly displayname: string
        readonly avatarUrl?: string | undefined
        readonly billingAddress?: string | undefined
        readonly companySize?: CompanySizeEnum | undefined
        readonly connectionStatus?: ConnectionStatusEnum | undefined
        readonly countAvailablePositions: number
        readonly countRecentPositions: number
        readonly description?: string | undefined
        readonly headline: string
        readonly name: string
        readonly profileComplete: boolean
        readonly profileCompletedAt?: any | undefined
        readonly visibleOnPlatform: boolean
        readonly website?: string | undefined
        readonly companyEmploymentBenefits?:
          | ReadonlyArray<{
              readonly id: string
              readonly employmentBenefit: {
                readonly icon: string
                readonly id: string
                readonly name: string
              }
            }>
          | undefined
        readonly companyLocations?:
          | ReadonlyArray<{
              readonly address?: string | undefined
              readonly addressExtended?: string | undefined
              readonly city?: string | undefined
              readonly country?: CountriesEnum | undefined
              readonly latitude?: number | undefined
              readonly longitude?: number | undefined
              readonly postalCode?: string | undefined
              readonly rawLocation?: string | undefined
              readonly state?: StatesEnum | undefined
            }>
          | undefined
        readonly companyPhotos?:
          | ReadonlyArray<{
              readonly id: string
              readonly alt?: string | undefined
              readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
              readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
              readonly url: string
            }>
          | undefined
        readonly companyValues?:
          | ReadonlyArray<{
              readonly id: string
              readonly description: string
              readonly title: string
            }>
          | undefined
        readonly location: {
          readonly address?: string | undefined
          readonly addressExtended?: string | undefined
          readonly city?: string | undefined
          readonly country?: CountriesEnum | undefined
          readonly latitude?: number | undefined
          readonly longitude?: number | undefined
          readonly postalCode?: string | undefined
          readonly rawLocation?: string | undefined
          readonly state?: StatesEnum | undefined
        }
        readonly permissions: {
          readonly createJobPosting: boolean
          readonly edit: boolean
          readonly readPendingBanner: boolean
          readonly toggleVisible: boolean
        }
        readonly social?:
          | {
              readonly facebook?: string | undefined
              readonly instagram?: string | undefined
              readonly linkedin?: string | undefined
              readonly twitter?: string | undefined
            }
          | undefined
      }
    | undefined
  readonly associatedClient?:
    | {
        readonly __typename: 'Client'
        readonly id: string
        readonly displayname: string
        readonly avatarUrl?: string | undefined
        readonly billingAddress?: string | undefined
        readonly companySize?: CompanySizeEnum | undefined
        readonly connectionStatus?: ConnectionStatusEnum | undefined
        readonly countAvailablePositions: number
        readonly countRecentPositions: number
        readonly description?: string | undefined
        readonly headline: string
        readonly name: string
        readonly profileComplete: boolean
        readonly profileCompletedAt?: any | undefined
        readonly visibleOnPlatform: boolean
        readonly website?: string | undefined
        readonly companyEmploymentBenefits?:
          | ReadonlyArray<{
              readonly id: string
              readonly employmentBenefit: {
                readonly icon: string
                readonly id: string
                readonly name: string
              }
            }>
          | undefined
        readonly companyLocations?:
          | ReadonlyArray<{
              readonly address?: string | undefined
              readonly addressExtended?: string | undefined
              readonly city?: string | undefined
              readonly country?: CountriesEnum | undefined
              readonly latitude?: number | undefined
              readonly longitude?: number | undefined
              readonly postalCode?: string | undefined
              readonly rawLocation?: string | undefined
              readonly state?: StatesEnum | undefined
            }>
          | undefined
        readonly companyPhotos?:
          | ReadonlyArray<{
              readonly id: string
              readonly alt?: string | undefined
              readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
              readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
              readonly url: string
            }>
          | undefined
        readonly companyValues?:
          | ReadonlyArray<{
              readonly id: string
              readonly description: string
              readonly title: string
            }>
          | undefined
        readonly location: {
          readonly address?: string | undefined
          readonly addressExtended?: string | undefined
          readonly city?: string | undefined
          readonly country?: CountriesEnum | undefined
          readonly latitude?: number | undefined
          readonly longitude?: number | undefined
          readonly postalCode?: string | undefined
          readonly rawLocation?: string | undefined
          readonly state?: StatesEnum | undefined
        }
        readonly permissions: {
          readonly createJobPosting: boolean
          readonly edit: boolean
          readonly readPendingBanner: boolean
          readonly toggleVisible: boolean
        }
        readonly social?:
          | {
              readonly facebook?: string | undefined
              readonly instagram?: string | undefined
              readonly linkedin?: string | undefined
              readonly twitter?: string | undefined
            }
          | undefined
      }
    | undefined
  readonly employmentBenefits?:
    | ReadonlyArray<{
        readonly id: string
        readonly employmentBenefit: {
          readonly icon: string
          readonly id: string
          readonly name: string
        }
      }>
    | undefined
  readonly jobApplicationStatusCounts?:
    | ReadonlyArray<{
        readonly count: number
        readonly status?: JobApplicationStatusEnum | undefined
      }>
    | undefined
  readonly gigsInfo?:
    | {
        readonly additionalRequirements?: string | undefined
        readonly billRate?: number | undefined
        readonly costCenterCreated?: boolean | undefined
        readonly companyOnboarded?: boolean | undefined
        readonly details?: string | undefined
        readonly engagementDeposit?: boolean | undefined
        readonly kickoffCall?: boolean | undefined
        readonly level?: number | undefined
        readonly payRate?: number | undefined
        readonly salaryPayPeriod?: PayPeriodEnum | undefined
        readonly dressCode?: string | undefined
        readonly specialRequests?: string | undefined
        readonly parkingFacilityInformation?: string | undefined
      }
    | undefined
  readonly jobPostingScreening?:
    | {
        readonly id: string
        readonly screening?:
          | {
              readonly id: string
              readonly description?: string | undefined
              readonly name?: string | undefined
              readonly screeningQuestions?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly typeOf?: string | undefined
                    readonly question?: string | undefined
                  }>
                | undefined
            }
          | undefined
      }
    | undefined
  readonly location: {
    readonly address?: string | undefined
    readonly addressExtended?: string | undefined
    readonly city?: string | undefined
    readonly country?: CountriesEnum | undefined
    readonly latitude?: number | undefined
    readonly longitude?: number | undefined
    readonly postalCode?: string | undefined
    readonly rawLocation?: string | undefined
    readonly state?: StatesEnum | undefined
  }
  readonly permissions: {
    readonly destroy: boolean
    readonly edit: boolean
    readonly internalUser: boolean
    readonly managePlacements: boolean
    readonly readEndDate: boolean
    readonly readJobApps: boolean
    readonly readPlacements: boolean
    readonly togglePublished: boolean
    readonly writeAtsRecordType: boolean
    readonly writeRecruiterToJob: boolean
    readonly writeSubmitApplicationUrl: boolean
  }
  readonly placements?:
    | ReadonlyArray<{
        readonly id: string
        readonly status?: PlacementStatusEnum | undefined
      }>
    | undefined
  readonly placementStatusCounts?:
    | ReadonlyArray<{
        readonly count: number
        readonly status?: PlacementStatusEnum | undefined
      }>
    | undefined
  readonly primaryContact?:
    | {
        readonly avatarUrl?: string | undefined
        readonly firstName: string
        readonly id: string
        readonly lastName: string
      }
    | undefined
  readonly recommendedCredentials?:
    | ReadonlyArray<{
        readonly id: string
        readonly credential: {
          readonly __typename: 'Credential'
          readonly id: string
          readonly badgeUrl: string
          readonly description?: string | undefined
          readonly title: string
          readonly training: {
            readonly id: string
            readonly trainingUrl: string
          }
        }
      }>
    | undefined
  readonly recruiters?:
    | ReadonlyArray<{
        readonly avatarUrl?: string | undefined
        readonly firstName: string
        readonly id: string
        readonly lastName: string
        readonly username: string
      }>
    | undefined
  readonly timeSheetManagers?:
    | ReadonlyArray<{
        readonly avatarUrl?: string | undefined
        readonly firstName: string
        readonly id: string
        readonly lastName: string
        readonly username: string
      }>
    | undefined
  readonly requiredLicenses: ReadonlyArray<{
    readonly id: string
    readonly license: {
      readonly id: string
      readonly name: string
      readonly country: CountriesEnum
      readonly state?: string | undefined
    }
  }>
  readonly salaryRange?:
    | {
        readonly maxValue?: number | undefined
        readonly minValue?: number | undefined
        readonly payPeriod?: PayPeriodEnum | undefined
      }
    | undefined
}

export type JobPosting_EditFragment = {
  readonly id: string
  readonly accountsPayableEmail?: string | undefined
  readonly atsRecordType?: string | undefined
  readonly atsStatus?: JobPostingAtsStatusEnum | undefined
  readonly description: string
  readonly depositAmount?: number | undefined
  readonly education?: string | undefined
  readonly employmentTypes?: ReadonlyArray<EmploymentTypesEnum> | undefined
  readonly endDate?: any | undefined
  readonly expectedHours?: string | undefined
  readonly experience?: string | undefined
  readonly isPublished: boolean
  readonly externalId?: string | undefined
  readonly quantity?: number | undefined
  readonly isRemote: boolean
  readonly physicalRequirements?: string | undefined
  readonly shift?: string | undefined
  readonly syndicateIndeed: boolean
  readonly startDate?: any | undefined
  readonly submitApplicationUrl?: string | undefined
  readonly slug: string
  readonly responsibilities?: string | undefined
  readonly title: string
  readonly workingEnvironment?: string | undefined
  readonly accountExecs?:
    | ReadonlyArray<{
        readonly firstName: string
        readonly id: string
        readonly lastName: string
      }>
    | undefined
  readonly associatedClient?: { readonly displayname: string } | undefined
  readonly jobPostingScreening?:
    | {
        readonly id: string
        readonly screening?:
          | {
              readonly id: string
              readonly description?: string | undefined
              readonly name?: string | undefined
              readonly screeningQuestions?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly typeOf?: string | undefined
                    readonly question?: string | undefined
                  }>
                | undefined
            }
          | undefined
      }
    | undefined
  readonly gigsInfo?:
    | {
        readonly billRate?: number | undefined
        readonly payRate?: number | undefined
        readonly costCenterCreated?: boolean | undefined
        readonly engagementDeposit?: boolean | undefined
        readonly level?: number | undefined
        readonly details?: string | undefined
        readonly additionalRequirements?: string | undefined
        readonly kickoffCall?: boolean | undefined
        readonly salaryPayPeriod?: PayPeriodEnum | undefined
        readonly dressCode?: string | undefined
        readonly specialRequests?: string | undefined
        readonly parkingFacilityInformation?: string | undefined
      }
    | undefined
  readonly location: {
    readonly address?: string | undefined
    readonly addressExtended?: string | undefined
    readonly city?: string | undefined
    readonly country?: CountriesEnum | undefined
    readonly latitude?: number | undefined
    readonly longitude?: number | undefined
    readonly postalCode?: string | undefined
    readonly rawLocation?: string | undefined
    readonly state?: StatesEnum | undefined
  }
  readonly recommendedCredentials?:
    | ReadonlyArray<{
        readonly id: string
        readonly credential: {
          readonly __typename: 'Credential'
          readonly id: string
          readonly badgeUrl: string
          readonly description?: string | undefined
          readonly title: string
          readonly training: {
            readonly id: string
            readonly trainingUrl: string
          }
        }
      }>
    | undefined
  readonly primaryContact?:
    | {
        readonly avatarUrl?: string | undefined
        readonly firstName: string
        readonly id: string
        readonly lastName: string
      }
    | undefined
  readonly recruiters?:
    | ReadonlyArray<{
        readonly firstName: string
        readonly id: string
        readonly lastName: string
      }>
    | undefined
  readonly timeSheetManagers?:
    | ReadonlyArray<{
        readonly firstName: string
        readonly id: string
        readonly lastName: string
      }>
    | undefined
  readonly requiredLicenses: ReadonlyArray<{
    readonly id: string
    readonly license: {
      readonly id: string
      readonly name: string
      readonly country: CountriesEnum
      readonly state?: string | undefined
    }
  }>
  readonly salaryRange?:
    | {
        readonly maxValue?: number | undefined
        readonly minValue?: number | undefined
        readonly payPeriod?: PayPeriodEnum | undefined
      }
    | undefined
}

export type JobPosting_RecommendedCredentialFragment = {
  readonly id: string
  readonly credential: {
    readonly __typename: 'Credential'
    readonly id: string
    readonly badgeUrl: string
    readonly description?: string | undefined
    readonly title: string
    readonly training: { readonly id: string; readonly trainingUrl: string }
  }
}

export type JobPosting_ScreeningFragment = {
  readonly id: string
  readonly screening?:
    | {
        readonly id: string
        readonly description?: string | undefined
        readonly name?: string | undefined
        readonly screeningQuestions?:
          | ReadonlyArray<{
              readonly id: string
              readonly typeOf?: string | undefined
              readonly question?: string | undefined
            }>
          | undefined
      }
    | undefined
}

export type ScreeningQuestionFragment = {
  readonly id: string
  readonly typeOf?: string | undefined
  readonly question?: string | undefined
}

export type JobPosting_CredentialFragment = {
  readonly __typename: 'Credential'
  readonly id: string
  readonly badgeUrl: string
  readonly description?: string | undefined
  readonly title: string
  readonly training: { readonly id: string; readonly trainingUrl: string }
}

export type JobPosting_CompanyFragment = {
  readonly __typename: 'Client'
  readonly id: string
  readonly displayname: string
  readonly avatarUrl?: string | undefined
  readonly billingAddress?: string | undefined
  readonly companySize?: CompanySizeEnum | undefined
  readonly connectionStatus?: ConnectionStatusEnum | undefined
  readonly countAvailablePositions: number
  readonly countRecentPositions: number
  readonly description?: string | undefined
  readonly headline: string
  readonly name: string
  readonly profileComplete: boolean
  readonly profileCompletedAt?: any | undefined
  readonly visibleOnPlatform: boolean
  readonly website?: string | undefined
  readonly companyEmploymentBenefits?:
    | ReadonlyArray<{
        readonly id: string
        readonly employmentBenefit: {
          readonly icon: string
          readonly id: string
          readonly name: string
        }
      }>
    | undefined
  readonly companyLocations?:
    | ReadonlyArray<{
        readonly address?: string | undefined
        readonly addressExtended?: string | undefined
        readonly city?: string | undefined
        readonly country?: CountriesEnum | undefined
        readonly latitude?: number | undefined
        readonly longitude?: number | undefined
        readonly postalCode?: string | undefined
        readonly rawLocation?: string | undefined
        readonly state?: StatesEnum | undefined
      }>
    | undefined
  readonly companyPhotos?:
    | ReadonlyArray<{
        readonly id: string
        readonly alt?: string | undefined
        readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
        readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
        readonly url: string
      }>
    | undefined
  readonly companyValues?:
    | ReadonlyArray<{
        readonly id: string
        readonly description: string
        readonly title: string
      }>
    | undefined
  readonly location: {
    readonly address?: string | undefined
    readonly addressExtended?: string | undefined
    readonly city?: string | undefined
    readonly country?: CountriesEnum | undefined
    readonly latitude?: number | undefined
    readonly longitude?: number | undefined
    readonly postalCode?: string | undefined
    readonly rawLocation?: string | undefined
    readonly state?: StatesEnum | undefined
  }
  readonly permissions: {
    readonly createJobPosting: boolean
    readonly edit: boolean
    readonly readPendingBanner: boolean
    readonly toggleVisible: boolean
  }
  readonly social?:
    | {
        readonly facebook?: string | undefined
        readonly instagram?: string | undefined
        readonly linkedin?: string | undefined
        readonly twitter?: string | undefined
      }
    | undefined
}

export type JobPosting_NoteFragment = {
  readonly id: string
  readonly body?: string | undefined
  readonly createdAt: any
  readonly jsonBody?: any | undefined
  readonly namespace?: string | undefined
  readonly updatedAt: any
  readonly author?:
    | {
        readonly __typename: 'User'
        readonly id: string
        readonly username: string
        readonly availability?: string | undefined
        readonly avatarUrl?: string | undefined
        readonly connectionCount: number
        readonly connectionStatus?: ConnectionStatusEnum | undefined
        readonly email?: string | undefined
        readonly secondaryEmail?: string | undefined
        readonly firstName: string
        readonly indispensableSurveyLink: string
        readonly isCurrentUser: boolean
        readonly lastName: string
        readonly termsAcceptedAt?: any | undefined
        readonly phoneNumber?: string | undefined
        readonly uri: string
        readonly activities?:
          | { readonly pageInfo: { readonly totalCount: number } }
          | undefined
        readonly alerts?:
          | { readonly pageInfo: { readonly totalCount: number } }
          | undefined
        readonly gigsEmployee?:
          | {
              readonly id: string
              readonly createdAt: any
              readonly deletedAt?: any | undefined
              readonly eligibleAt?: any | undefined
              readonly offboardedAt?: any | undefined
              readonly onboardedAt?: any | undefined
              readonly onboardingStatus: OnboardingStatusEnum
              readonly percentComplete?: number | undefined
              readonly rejectedAt?: any | undefined
              readonly savedAt?: any | undefined
              readonly screeningAt?: any | undefined
              readonly terminatedAt?: any | undefined
              readonly updatedAt: any
              readonly permissions: { readonly seeHistory: boolean }
            }
          | undefined
        readonly location: {
          readonly address?: string | undefined
          readonly addressExtended?: string | undefined
          readonly city?: string | undefined
          readonly country?: CountriesEnum | undefined
          readonly latitude?: number | undefined
          readonly longitude?: number | undefined
          readonly postalCode?: string | undefined
          readonly rawLocation?: string | undefined
          readonly state?: StatesEnum | undefined
        }
        readonly permissions: {
          readonly applyToJobs: boolean
          readonly edit: boolean
          readonly hasRecruiterLabel: boolean
          readonly imposter: boolean
          readonly internalUser: boolean
          readonly publishJobOrders: boolean
          readonly readEmail: boolean
          readonly readJobBooster: boolean
          readonly readNotes: boolean
          readonly readPhone: boolean
          readonly triggerIndispensableSurvey: boolean
          readonly searchCandidates: boolean
          readonly searchCandidatesAsClient: boolean
          readonly searchCandidatesAsRecruiter: boolean
          readonly searchClients: boolean
          readonly searchClientsByRecruiters: boolean
          readonly searchJobPostings: boolean
          readonly searchJobPostingsByRecruiter: boolean
          readonly sendMessage: boolean
          readonly trainableUser: boolean
          readonly updateConnectionStatus: boolean
          readonly uploadCsv: boolean
          readonly matchCriteria: boolean
        }
        readonly social?:
          | {
              readonly calendly?: string | undefined
              readonly linkedin?: string | undefined
            }
          | undefined
        readonly candidate?:
          | {
              readonly __typename: 'Candidate'
              readonly id: string
              readonly backgroundCheckDate?: any | undefined
              readonly credentialCount: number
              readonly dnu?: string | undefined
              readonly hiringStatus?: HiringStatusEnum | undefined
              readonly i9Date?: any | undefined
              readonly idealEmployment?: string | undefined
              readonly isAbleToApply: boolean
              readonly isNeedEmploymentSponsor?: boolean | undefined
              readonly isUsWorkAuthorized?: boolean | undefined
              readonly noWorkExperience?: boolean | undefined
              readonly profileCompletedAt?: any | undefined
              readonly profilePercentComplete?: number | undefined
              readonly relayId: string
              readonly resumeUrl?: string | undefined
              readonly salaryExpectations?: string | undefined
              readonly candidateLicenses?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly date?: any | undefined
                    readonly number?: string | undefined
                    readonly url?: string | undefined
                    readonly license?:
                      | {
                          readonly id: string
                          readonly name: string
                          readonly country: CountriesEnum
                          readonly state?: string | undefined
                        }
                      | undefined
                  }>
                | undefined
              readonly credentials?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly title: string
                    readonly badgeUrl: string
                    readonly description?: string | undefined
                    readonly training: {
                      readonly id: string
                      readonly trainingUrl: string
                    }
                  }>
                | undefined
              readonly education?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly degree?: string | undefined
                    readonly educationLevel?: EducationLevelEnum | undefined
                    readonly school?: string | undefined
                    readonly yearsAttended?: number | undefined
                  }>
                | undefined
              readonly experiences?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly companyName?: string | undefined
                    readonly current?: boolean | undefined
                    readonly endDate?: any | undefined
                    readonly jobTitle?: string | undefined
                    readonly responsibilities?: string | undefined
                    readonly startDate?: any | undefined
                    readonly yearsEmployed?: number | undefined
                  }>
                | undefined
              readonly placements?:
                | ReadonlyArray<{
                    readonly startDate?: any | undefined
                    readonly id: string
                    readonly interviewDate?: any | undefined
                    readonly status?: PlacementStatusEnum | undefined
                    readonly permissions: { readonly update: boolean }
                    readonly jobPosting: {
                      readonly id: string
                      readonly slug: string
                      readonly title: string
                      readonly client?:
                        | { readonly displayname: string }
                        | undefined
                      readonly permissions: {
                        readonly readJobApps: boolean
                        readonly readPlacements: boolean
                      }
                    }
                  }>
                | undefined
              readonly jobApplications?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly status?: JobApplicationStatusEnum | undefined
                    readonly permissions: { readonly show: boolean }
                    readonly jobPosting: {
                      readonly id: string
                      readonly level?: number | undefined
                      readonly slug: string
                      readonly title: string
                      readonly client?:
                        | {
                            readonly displayname: string
                            readonly name: string
                          }
                        | undefined
                      readonly permissions: {
                        readonly readJobApps: boolean
                        readonly readPlacements: boolean
                        readonly managePlacements: boolean
                      }
                      readonly jobPostingScreening?:
                        | { readonly id: string }
                        | undefined
                    }
                    readonly screeningSubmissions?:
                      | ReadonlyArray<{ readonly id: string }>
                      | undefined
                  }>
                | undefined
              readonly permissions: {
                readonly edit: boolean
                readonly readApplications: boolean
                readonly readCredentials: boolean
                readonly readLicense: boolean
                readonly readResume: boolean
                readonly readWorkPreferences: boolean
              }
              readonly recruiters?:
                | ReadonlyArray<{
                    readonly avatarUrl?: string | undefined
                    readonly firstName: string
                    readonly id: string
                    readonly lastName: string
                  }>
                | undefined
              readonly skillRelations?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly years: number
                    readonly skill: {
                      readonly __typename: 'Skill'
                      readonly id: string
                      readonly name: string
                    }
                  }>
                | undefined
              readonly summary?:
                | {
                    readonly id: string
                    readonly entry: string
                    readonly title: string
                  }
                | undefined
            }
          | undefined
        readonly subscription?:
          | {
              readonly __typename: 'Subscription'
              readonly id: string
              readonly active: boolean
              readonly plan: string
            }
          | undefined
      }
    | undefined
}

export type JobPosting_ActivitiesFragment = {
  readonly id: string
  readonly activities?:
    | {
        readonly edges?:
          | ReadonlyArray<
              | {
                  readonly __typename: 'ActivityEdge'
                  readonly cursor: string
                  readonly node?:
                    | {
                        readonly id: string
                        readonly alert?: boolean | undefined
                        readonly body?: string | undefined
                        readonly createdAt: any
                        readonly jsonBody?: any | undefined
                        readonly recipientRead?: any | undefined
                        readonly updatedAt: any
                        readonly author?:
                          | {
                              readonly id: string
                              readonly avatarUrl?: string | undefined
                              readonly firstName: string
                              readonly lastName: string
                              readonly uri: string
                              readonly username: string
                            }
                          | undefined
                        readonly kontext?:
                          | {
                              readonly __typename: 'ChatMessage'
                              readonly id: string
                              readonly sender: { readonly username: string }
                            }
                          | {
                              readonly __typename: 'JobApplication'
                              readonly id: string
                              readonly uri: string
                              readonly jobPosting: {
                                readonly id: string
                                readonly slug: string
                                readonly client?:
                                  | { readonly displayname: string }
                                  | undefined
                              }
                              readonly user?:
                                | {
                                    readonly id: string
                                    readonly username: string
                                  }
                                | undefined
                            }
                          | {
                              readonly __typename: 'JobPosting'
                              readonly id: string
                              readonly slug: string
                              readonly uri: string
                              readonly client?:
                                | {
                                    readonly id: string
                                    readonly displayname: string
                                  }
                                | undefined
                            }
                          | {
                              readonly __typename: 'Placement'
                              readonly id: string
                              readonly uri: string
                              readonly updatedAt: any
                              readonly jobPosting: {
                                readonly id: string
                                readonly slug: string
                                readonly client?:
                                  | {
                                      readonly id: string
                                      readonly displayname: string
                                    }
                                  | undefined
                              }
                              readonly user?:
                                | {
                                    readonly id: string
                                    readonly username: string
                                  }
                                | undefined
                            }
                          | {
                              readonly __typename: 'User'
                              readonly id: string
                              readonly username: string
                              readonly uri: string
                            }
                          | {}
                          | undefined
                        readonly resource:
                          | {
                              readonly __typename: 'Client'
                              readonly id: string
                              readonly displayname: string
                              readonly uri: string
                            }
                          | { readonly __typename: 'GigsEmployee' }
                          | {
                              readonly __typename: 'JobApplication'
                              readonly id: string
                              readonly uri: string
                              readonly jobPosting: {
                                readonly id: string
                                readonly slug: string
                                readonly client?:
                                  | { readonly displayname: string }
                                  | undefined
                              }
                              readonly user?:
                                | {
                                    readonly id: string
                                    readonly username: string
                                  }
                                | undefined
                            }
                          | {
                              readonly __typename: 'JobPosting'
                              readonly id: string
                              readonly slug: string
                              readonly uri: string
                              readonly client?:
                                | {
                                    readonly id: string
                                    readonly displayname: string
                                  }
                                | undefined
                            }
                          | {
                              readonly __typename: 'Placement'
                              readonly id: string
                              readonly uri: string
                              readonly updatedAt: any
                              readonly jobPosting: {
                                readonly id: string
                                readonly slug: string
                                readonly client?:
                                  | {
                                      readonly id: string
                                      readonly displayname: string
                                    }
                                  | undefined
                              }
                              readonly user?:
                                | {
                                    readonly id: string
                                    readonly username: string
                                  }
                                | undefined
                            }
                          | {
                              readonly __typename: 'User'
                              readonly id: string
                              readonly username: string
                              readonly uri: string
                            }
                      }
                    | undefined
                }
              | undefined
            >
          | undefined
        readonly pageInfo: {
          readonly endCursor?: string | undefined
          readonly hasNextPage: boolean
          readonly hasPreviousPage: boolean
          readonly startCursor?: string | undefined
          readonly totalCount: number
        }
      }
    | undefined
}

export type JobPosting_ActivityConnectionFragment = {
  readonly edges?:
    | ReadonlyArray<
        | {
            readonly __typename: 'ActivityEdge'
            readonly cursor: string
            readonly node?:
              | {
                  readonly id: string
                  readonly alert?: boolean | undefined
                  readonly body?: string | undefined
                  readonly createdAt: any
                  readonly jsonBody?: any | undefined
                  readonly recipientRead?: any | undefined
                  readonly updatedAt: any
                  readonly author?:
                    | {
                        readonly id: string
                        readonly avatarUrl?: string | undefined
                        readonly firstName: string
                        readonly lastName: string
                        readonly uri: string
                        readonly username: string
                      }
                    | undefined
                  readonly kontext?:
                    | {
                        readonly __typename: 'ChatMessage'
                        readonly id: string
                        readonly sender: { readonly username: string }
                      }
                    | {
                        readonly __typename: 'JobApplication'
                        readonly id: string
                        readonly uri: string
                        readonly jobPosting: {
                          readonly id: string
                          readonly slug: string
                          readonly client?:
                            | { readonly displayname: string }
                            | undefined
                        }
                        readonly user?:
                          | { readonly id: string; readonly username: string }
                          | undefined
                      }
                    | {
                        readonly __typename: 'JobPosting'
                        readonly id: string
                        readonly slug: string
                        readonly uri: string
                        readonly client?:
                          | {
                              readonly id: string
                              readonly displayname: string
                            }
                          | undefined
                      }
                    | {
                        readonly __typename: 'Placement'
                        readonly id: string
                        readonly uri: string
                        readonly updatedAt: any
                        readonly jobPosting: {
                          readonly id: string
                          readonly slug: string
                          readonly client?:
                            | {
                                readonly id: string
                                readonly displayname: string
                              }
                            | undefined
                        }
                        readonly user?:
                          | { readonly id: string; readonly username: string }
                          | undefined
                      }
                    | {
                        readonly __typename: 'User'
                        readonly id: string
                        readonly username: string
                        readonly uri: string
                      }
                    | {}
                    | undefined
                  readonly resource:
                    | {
                        readonly __typename: 'Client'
                        readonly id: string
                        readonly displayname: string
                        readonly uri: string
                      }
                    | { readonly __typename: 'GigsEmployee' }
                    | {
                        readonly __typename: 'JobApplication'
                        readonly id: string
                        readonly uri: string
                        readonly jobPosting: {
                          readonly id: string
                          readonly slug: string
                          readonly client?:
                            | { readonly displayname: string }
                            | undefined
                        }
                        readonly user?:
                          | { readonly id: string; readonly username: string }
                          | undefined
                      }
                    | {
                        readonly __typename: 'JobPosting'
                        readonly id: string
                        readonly slug: string
                        readonly uri: string
                        readonly client?:
                          | {
                              readonly id: string
                              readonly displayname: string
                            }
                          | undefined
                      }
                    | {
                        readonly __typename: 'Placement'
                        readonly id: string
                        readonly uri: string
                        readonly updatedAt: any
                        readonly jobPosting: {
                          readonly id: string
                          readonly slug: string
                          readonly client?:
                            | {
                                readonly id: string
                                readonly displayname: string
                              }
                            | undefined
                        }
                        readonly user?:
                          | { readonly id: string; readonly username: string }
                          | undefined
                      }
                    | {
                        readonly __typename: 'User'
                        readonly id: string
                        readonly username: string
                        readonly uri: string
                      }
                }
              | undefined
          }
        | undefined
      >
    | undefined
  readonly pageInfo: {
    readonly endCursor?: string | undefined
    readonly hasNextPage: boolean
    readonly hasPreviousPage: boolean
    readonly startCursor?: string | undefined
    readonly totalCount: number
  }
}

export type JobPostingQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type JobPostingQuery = {
  readonly getJobPosting: {
    readonly __typename: 'JobPosting'
    readonly id: string
    readonly accountsPayableEmail?: string | undefined
    readonly applicationReceived: boolean
    readonly atsRecordType?: string | undefined
    readonly atsStatus?: JobPostingAtsStatusEnum | undefined
    readonly baseSalaryValue: number
    readonly countJobApplicationsNew: number
    readonly countJobApplicationsTotal: number
    readonly description: string
    readonly depositAmount?: number | undefined
    readonly education?: string | undefined
    readonly employmentTypes?: ReadonlyArray<EmploymentTypesEnum> | undefined
    readonly endDate?: any | undefined
    readonly quantity?: number | undefined
    readonly experience?: string | undefined
    readonly externalId?: string | undefined
    readonly isIngested: boolean
    readonly isPublished: boolean
    readonly isRemote: boolean
    readonly physicalRequirements?: string | undefined
    readonly postedAt?: any | undefined
    readonly shift?: string | undefined
    readonly syndicateIndeed: boolean
    readonly responsibilities?: string | undefined
    readonly slug: string
    readonly startDate?: any | undefined
    readonly submitApplicationUrl?: string | undefined
    readonly title: string
    readonly uri: string
    readonly validThrough: any
    readonly workingEnvironment?: string | undefined
    readonly accountExecs?:
      | ReadonlyArray<{
          readonly avatarUrl?: string | undefined
          readonly firstName: string
          readonly id: string
          readonly lastName: string
          readonly username: string
        }>
      | undefined
    readonly activities?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly client?:
      | {
          readonly __typename: 'Client'
          readonly id: string
          readonly displayname: string
          readonly avatarUrl?: string | undefined
          readonly billingAddress?: string | undefined
          readonly companySize?: CompanySizeEnum | undefined
          readonly connectionStatus?: ConnectionStatusEnum | undefined
          readonly countAvailablePositions: number
          readonly countRecentPositions: number
          readonly description?: string | undefined
          readonly headline: string
          readonly name: string
          readonly profileComplete: boolean
          readonly profileCompletedAt?: any | undefined
          readonly visibleOnPlatform: boolean
          readonly website?: string | undefined
          readonly companyEmploymentBenefits?:
            | ReadonlyArray<{
                readonly id: string
                readonly employmentBenefit: {
                  readonly icon: string
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly companyLocations?:
            | ReadonlyArray<{
                readonly address?: string | undefined
                readonly addressExtended?: string | undefined
                readonly city?: string | undefined
                readonly country?: CountriesEnum | undefined
                readonly latitude?: number | undefined
                readonly longitude?: number | undefined
                readonly postalCode?: string | undefined
                readonly rawLocation?: string | undefined
                readonly state?: StatesEnum | undefined
              }>
            | undefined
          readonly companyPhotos?:
            | ReadonlyArray<{
                readonly id: string
                readonly alt?: string | undefined
                readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
                readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
                readonly url: string
              }>
            | undefined
          readonly companyValues?:
            | ReadonlyArray<{
                readonly id: string
                readonly description: string
                readonly title: string
              }>
            | undefined
          readonly location: {
            readonly address?: string | undefined
            readonly addressExtended?: string | undefined
            readonly city?: string | undefined
            readonly country?: CountriesEnum | undefined
            readonly latitude?: number | undefined
            readonly longitude?: number | undefined
            readonly postalCode?: string | undefined
            readonly rawLocation?: string | undefined
            readonly state?: StatesEnum | undefined
          }
          readonly permissions: {
            readonly createJobPosting: boolean
            readonly edit: boolean
            readonly readPendingBanner: boolean
            readonly toggleVisible: boolean
          }
          readonly social?:
            | {
                readonly facebook?: string | undefined
                readonly instagram?: string | undefined
                readonly linkedin?: string | undefined
                readonly twitter?: string | undefined
              }
            | undefined
        }
      | undefined
    readonly associatedClient?:
      | {
          readonly __typename: 'Client'
          readonly id: string
          readonly displayname: string
          readonly avatarUrl?: string | undefined
          readonly billingAddress?: string | undefined
          readonly companySize?: CompanySizeEnum | undefined
          readonly connectionStatus?: ConnectionStatusEnum | undefined
          readonly countAvailablePositions: number
          readonly countRecentPositions: number
          readonly description?: string | undefined
          readonly headline: string
          readonly name: string
          readonly profileComplete: boolean
          readonly profileCompletedAt?: any | undefined
          readonly visibleOnPlatform: boolean
          readonly website?: string | undefined
          readonly companyEmploymentBenefits?:
            | ReadonlyArray<{
                readonly id: string
                readonly employmentBenefit: {
                  readonly icon: string
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly companyLocations?:
            | ReadonlyArray<{
                readonly address?: string | undefined
                readonly addressExtended?: string | undefined
                readonly city?: string | undefined
                readonly country?: CountriesEnum | undefined
                readonly latitude?: number | undefined
                readonly longitude?: number | undefined
                readonly postalCode?: string | undefined
                readonly rawLocation?: string | undefined
                readonly state?: StatesEnum | undefined
              }>
            | undefined
          readonly companyPhotos?:
            | ReadonlyArray<{
                readonly id: string
                readonly alt?: string | undefined
                readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
                readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
                readonly url: string
              }>
            | undefined
          readonly companyValues?:
            | ReadonlyArray<{
                readonly id: string
                readonly description: string
                readonly title: string
              }>
            | undefined
          readonly location: {
            readonly address?: string | undefined
            readonly addressExtended?: string | undefined
            readonly city?: string | undefined
            readonly country?: CountriesEnum | undefined
            readonly latitude?: number | undefined
            readonly longitude?: number | undefined
            readonly postalCode?: string | undefined
            readonly rawLocation?: string | undefined
            readonly state?: StatesEnum | undefined
          }
          readonly permissions: {
            readonly createJobPosting: boolean
            readonly edit: boolean
            readonly readPendingBanner: boolean
            readonly toggleVisible: boolean
          }
          readonly social?:
            | {
                readonly facebook?: string | undefined
                readonly instagram?: string | undefined
                readonly linkedin?: string | undefined
                readonly twitter?: string | undefined
              }
            | undefined
        }
      | undefined
    readonly employmentBenefits?:
      | ReadonlyArray<{
          readonly id: string
          readonly employmentBenefit: {
            readonly icon: string
            readonly id: string
            readonly name: string
          }
        }>
      | undefined
    readonly jobApplicationStatusCounts?:
      | ReadonlyArray<{
          readonly count: number
          readonly status?: JobApplicationStatusEnum | undefined
        }>
      | undefined
    readonly gigsInfo?:
      | {
          readonly additionalRequirements?: string | undefined
          readonly billRate?: number | undefined
          readonly costCenterCreated?: boolean | undefined
          readonly companyOnboarded?: boolean | undefined
          readonly details?: string | undefined
          readonly engagementDeposit?: boolean | undefined
          readonly kickoffCall?: boolean | undefined
          readonly level?: number | undefined
          readonly payRate?: number | undefined
          readonly salaryPayPeriod?: PayPeriodEnum | undefined
          readonly dressCode?: string | undefined
          readonly specialRequests?: string | undefined
          readonly parkingFacilityInformation?: string | undefined
        }
      | undefined
    readonly jobPostingScreening?:
      | {
          readonly id: string
          readonly screening?:
            | {
                readonly id: string
                readonly description?: string | undefined
                readonly name?: string | undefined
                readonly screeningQuestions?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly typeOf?: string | undefined
                      readonly question?: string | undefined
                    }>
                  | undefined
              }
            | undefined
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly destroy: boolean
      readonly edit: boolean
      readonly internalUser: boolean
      readonly managePlacements: boolean
      readonly readEndDate: boolean
      readonly readJobApps: boolean
      readonly readPlacements: boolean
      readonly togglePublished: boolean
      readonly writeAtsRecordType: boolean
      readonly writeRecruiterToJob: boolean
      readonly writeSubmitApplicationUrl: boolean
    }
    readonly placements?:
      | ReadonlyArray<{
          readonly id: string
          readonly status?: PlacementStatusEnum | undefined
        }>
      | undefined
    readonly placementStatusCounts?:
      | ReadonlyArray<{
          readonly count: number
          readonly status?: PlacementStatusEnum | undefined
        }>
      | undefined
    readonly primaryContact?:
      | {
          readonly avatarUrl?: string | undefined
          readonly firstName: string
          readonly id: string
          readonly lastName: string
        }
      | undefined
    readonly recommendedCredentials?:
      | ReadonlyArray<{
          readonly id: string
          readonly credential: {
            readonly __typename: 'Credential'
            readonly id: string
            readonly badgeUrl: string
            readonly description?: string | undefined
            readonly title: string
            readonly training: {
              readonly id: string
              readonly trainingUrl: string
            }
          }
        }>
      | undefined
    readonly recruiters?:
      | ReadonlyArray<{
          readonly avatarUrl?: string | undefined
          readonly firstName: string
          readonly id: string
          readonly lastName: string
          readonly username: string
        }>
      | undefined
    readonly timeSheetManagers?:
      | ReadonlyArray<{
          readonly avatarUrl?: string | undefined
          readonly firstName: string
          readonly id: string
          readonly lastName: string
          readonly username: string
        }>
      | undefined
    readonly requiredLicenses: ReadonlyArray<{
      readonly id: string
      readonly license: {
        readonly id: string
        readonly name: string
        readonly country: CountriesEnum
        readonly state?: string | undefined
      }
    }>
    readonly salaryRange?:
      | {
          readonly maxValue?: number | undefined
          readonly minValue?: number | undefined
          readonly payPeriod?: PayPeriodEnum | undefined
        }
      | undefined
  }
}

export type JobPostingEditQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type JobPostingEditQuery = {
  readonly getJobPosting: {
    readonly id: string
    readonly accountsPayableEmail?: string | undefined
    readonly atsRecordType?: string | undefined
    readonly atsStatus?: JobPostingAtsStatusEnum | undefined
    readonly description: string
    readonly depositAmount?: number | undefined
    readonly education?: string | undefined
    readonly employmentTypes?: ReadonlyArray<EmploymentTypesEnum> | undefined
    readonly endDate?: any | undefined
    readonly expectedHours?: string | undefined
    readonly experience?: string | undefined
    readonly isPublished: boolean
    readonly externalId?: string | undefined
    readonly quantity?: number | undefined
    readonly isRemote: boolean
    readonly physicalRequirements?: string | undefined
    readonly shift?: string | undefined
    readonly syndicateIndeed: boolean
    readonly startDate?: any | undefined
    readonly submitApplicationUrl?: string | undefined
    readonly slug: string
    readonly responsibilities?: string | undefined
    readonly title: string
    readonly workingEnvironment?: string | undefined
    readonly accountExecs?:
      | ReadonlyArray<{
          readonly firstName: string
          readonly id: string
          readonly lastName: string
        }>
      | undefined
    readonly associatedClient?: { readonly displayname: string } | undefined
    readonly jobPostingScreening?:
      | {
          readonly id: string
          readonly screening?:
            | {
                readonly id: string
                readonly description?: string | undefined
                readonly name?: string | undefined
                readonly screeningQuestions?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly typeOf?: string | undefined
                      readonly question?: string | undefined
                    }>
                  | undefined
              }
            | undefined
        }
      | undefined
    readonly gigsInfo?:
      | {
          readonly billRate?: number | undefined
          readonly payRate?: number | undefined
          readonly costCenterCreated?: boolean | undefined
          readonly engagementDeposit?: boolean | undefined
          readonly level?: number | undefined
          readonly details?: string | undefined
          readonly additionalRequirements?: string | undefined
          readonly kickoffCall?: boolean | undefined
          readonly salaryPayPeriod?: PayPeriodEnum | undefined
          readonly dressCode?: string | undefined
          readonly specialRequests?: string | undefined
          readonly parkingFacilityInformation?: string | undefined
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly recommendedCredentials?:
      | ReadonlyArray<{
          readonly id: string
          readonly credential: {
            readonly __typename: 'Credential'
            readonly id: string
            readonly badgeUrl: string
            readonly description?: string | undefined
            readonly title: string
            readonly training: {
              readonly id: string
              readonly trainingUrl: string
            }
          }
        }>
      | undefined
    readonly primaryContact?:
      | {
          readonly avatarUrl?: string | undefined
          readonly firstName: string
          readonly id: string
          readonly lastName: string
        }
      | undefined
    readonly recruiters?:
      | ReadonlyArray<{
          readonly firstName: string
          readonly id: string
          readonly lastName: string
        }>
      | undefined
    readonly timeSheetManagers?:
      | ReadonlyArray<{
          readonly firstName: string
          readonly id: string
          readonly lastName: string
        }>
      | undefined
    readonly requiredLicenses: ReadonlyArray<{
      readonly id: string
      readonly license: {
        readonly id: string
        readonly name: string
        readonly country: CountriesEnum
        readonly state?: string | undefined
      }
    }>
    readonly salaryRange?:
      | {
          readonly maxValue?: number | undefined
          readonly minValue?: number | undefined
          readonly payPeriod?: PayPeriodEnum | undefined
        }
      | undefined
  }
}

export type JobPostingActivitiesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['String']['input']
  notes?: InputMaybe<Scalars['Boolean']['input']>
}>

export type JobPostingActivitiesQuery = {
  readonly getJobPosting: {
    readonly id: string
    readonly activities?:
      | {
          readonly edges?:
            | ReadonlyArray<
                | {
                    readonly __typename: 'ActivityEdge'
                    readonly cursor: string
                    readonly node?:
                      | {
                          readonly id: string
                          readonly alert?: boolean | undefined
                          readonly body?: string | undefined
                          readonly createdAt: any
                          readonly jsonBody?: any | undefined
                          readonly recipientRead?: any | undefined
                          readonly updatedAt: any
                          readonly author?:
                            | {
                                readonly id: string
                                readonly avatarUrl?: string | undefined
                                readonly firstName: string
                                readonly lastName: string
                                readonly uri: string
                                readonly username: string
                              }
                            | undefined
                          readonly kontext?:
                            | {
                                readonly __typename: 'ChatMessage'
                                readonly id: string
                                readonly sender: { readonly username: string }
                              }
                            | {
                                readonly __typename: 'JobApplication'
                                readonly id: string
                                readonly uri: string
                                readonly jobPosting: {
                                  readonly id: string
                                  readonly slug: string
                                  readonly client?:
                                    | { readonly displayname: string }
                                    | undefined
                                }
                                readonly user?:
                                  | {
                                      readonly id: string
                                      readonly username: string
                                    }
                                  | undefined
                              }
                            | {
                                readonly __typename: 'JobPosting'
                                readonly id: string
                                readonly slug: string
                                readonly uri: string
                                readonly client?:
                                  | {
                                      readonly id: string
                                      readonly displayname: string
                                    }
                                  | undefined
                              }
                            | {
                                readonly __typename: 'Placement'
                                readonly id: string
                                readonly uri: string
                                readonly updatedAt: any
                                readonly jobPosting: {
                                  readonly id: string
                                  readonly slug: string
                                  readonly client?:
                                    | {
                                        readonly id: string
                                        readonly displayname: string
                                      }
                                    | undefined
                                }
                                readonly user?:
                                  | {
                                      readonly id: string
                                      readonly username: string
                                    }
                                  | undefined
                              }
                            | {
                                readonly __typename: 'User'
                                readonly id: string
                                readonly username: string
                                readonly uri: string
                              }
                            | {}
                            | undefined
                          readonly resource:
                            | {
                                readonly __typename: 'Client'
                                readonly id: string
                                readonly displayname: string
                                readonly uri: string
                              }
                            | { readonly __typename: 'GigsEmployee' }
                            | {
                                readonly __typename: 'JobApplication'
                                readonly id: string
                                readonly uri: string
                                readonly jobPosting: {
                                  readonly id: string
                                  readonly slug: string
                                  readonly client?:
                                    | { readonly displayname: string }
                                    | undefined
                                }
                                readonly user?:
                                  | {
                                      readonly id: string
                                      readonly username: string
                                    }
                                  | undefined
                              }
                            | {
                                readonly __typename: 'JobPosting'
                                readonly id: string
                                readonly slug: string
                                readonly uri: string
                                readonly client?:
                                  | {
                                      readonly id: string
                                      readonly displayname: string
                                    }
                                  | undefined
                              }
                            | {
                                readonly __typename: 'Placement'
                                readonly id: string
                                readonly uri: string
                                readonly updatedAt: any
                                readonly jobPosting: {
                                  readonly id: string
                                  readonly slug: string
                                  readonly client?:
                                    | {
                                        readonly id: string
                                        readonly displayname: string
                                      }
                                    | undefined
                                }
                                readonly user?:
                                  | {
                                      readonly id: string
                                      readonly username: string
                                    }
                                  | undefined
                              }
                            | {
                                readonly __typename: 'User'
                                readonly id: string
                                readonly username: string
                                readonly uri: string
                              }
                        }
                      | undefined
                  }
                | undefined
              >
            | undefined
          readonly pageInfo: {
            readonly endCursor?: string | undefined
            readonly hasNextPage: boolean
            readonly hasPreviousPage: boolean
            readonly startCursor?: string | undefined
            readonly totalCount: number
          }
        }
      | undefined
  }
}

export type GetMembersDownloadQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GetMembersDownloadQuery = {
  readonly getMembersDownload: {
    readonly id: string
    readonly status: MembersDownloadStatusEnum
    readonly url: string
    readonly failures?: string | undefined
    readonly processingStartedAt?: any | undefined
    readonly processingEndedAt?: any | undefined
  }
}

export type GetMembersDownloadsQueryVariables = Exact<{ [key: string]: never }>

export type GetMembersDownloadsQuery = {
  readonly getMembersDownloads: ReadonlyArray<{
    readonly id: string
    readonly status: MembersDownloadStatusEnum
    readonly url: string
    readonly failures?: string | undefined
    readonly processingStartedAt?: any | undefined
    readonly processingEndedAt?: any | undefined
  }>
}

export type CreateJobPostingMutationVariables = Exact<{
  input: JobPostingInput
}>

export type CreateJobPostingMutation = {
  readonly createJobPosting: {
    readonly __typename: 'JobPosting'
    readonly id: string
    readonly accountsPayableEmail?: string | undefined
    readonly applicationReceived: boolean
    readonly atsRecordType?: string | undefined
    readonly atsStatus?: JobPostingAtsStatusEnum | undefined
    readonly baseSalaryValue: number
    readonly countJobApplicationsNew: number
    readonly countJobApplicationsTotal: number
    readonly description: string
    readonly depositAmount?: number | undefined
    readonly education?: string | undefined
    readonly employmentTypes?: ReadonlyArray<EmploymentTypesEnum> | undefined
    readonly endDate?: any | undefined
    readonly quantity?: number | undefined
    readonly experience?: string | undefined
    readonly externalId?: string | undefined
    readonly isIngested: boolean
    readonly isPublished: boolean
    readonly isRemote: boolean
    readonly physicalRequirements?: string | undefined
    readonly postedAt?: any | undefined
    readonly shift?: string | undefined
    readonly syndicateIndeed: boolean
    readonly responsibilities?: string | undefined
    readonly slug: string
    readonly startDate?: any | undefined
    readonly submitApplicationUrl?: string | undefined
    readonly title: string
    readonly uri: string
    readonly validThrough: any
    readonly workingEnvironment?: string | undefined
    readonly accountExecs?:
      | ReadonlyArray<{
          readonly avatarUrl?: string | undefined
          readonly firstName: string
          readonly id: string
          readonly lastName: string
          readonly username: string
        }>
      | undefined
    readonly activities?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly client?:
      | {
          readonly __typename: 'Client'
          readonly id: string
          readonly displayname: string
          readonly avatarUrl?: string | undefined
          readonly billingAddress?: string | undefined
          readonly companySize?: CompanySizeEnum | undefined
          readonly connectionStatus?: ConnectionStatusEnum | undefined
          readonly countAvailablePositions: number
          readonly countRecentPositions: number
          readonly description?: string | undefined
          readonly headline: string
          readonly name: string
          readonly profileComplete: boolean
          readonly profileCompletedAt?: any | undefined
          readonly visibleOnPlatform: boolean
          readonly website?: string | undefined
          readonly companyEmploymentBenefits?:
            | ReadonlyArray<{
                readonly id: string
                readonly employmentBenefit: {
                  readonly icon: string
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly companyLocations?:
            | ReadonlyArray<{
                readonly address?: string | undefined
                readonly addressExtended?: string | undefined
                readonly city?: string | undefined
                readonly country?: CountriesEnum | undefined
                readonly latitude?: number | undefined
                readonly longitude?: number | undefined
                readonly postalCode?: string | undefined
                readonly rawLocation?: string | undefined
                readonly state?: StatesEnum | undefined
              }>
            | undefined
          readonly companyPhotos?:
            | ReadonlyArray<{
                readonly id: string
                readonly alt?: string | undefined
                readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
                readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
                readonly url: string
              }>
            | undefined
          readonly companyValues?:
            | ReadonlyArray<{
                readonly id: string
                readonly description: string
                readonly title: string
              }>
            | undefined
          readonly location: {
            readonly address?: string | undefined
            readonly addressExtended?: string | undefined
            readonly city?: string | undefined
            readonly country?: CountriesEnum | undefined
            readonly latitude?: number | undefined
            readonly longitude?: number | undefined
            readonly postalCode?: string | undefined
            readonly rawLocation?: string | undefined
            readonly state?: StatesEnum | undefined
          }
          readonly permissions: {
            readonly createJobPosting: boolean
            readonly edit: boolean
            readonly readPendingBanner: boolean
            readonly toggleVisible: boolean
          }
          readonly social?:
            | {
                readonly facebook?: string | undefined
                readonly instagram?: string | undefined
                readonly linkedin?: string | undefined
                readonly twitter?: string | undefined
              }
            | undefined
        }
      | undefined
    readonly associatedClient?:
      | {
          readonly __typename: 'Client'
          readonly id: string
          readonly displayname: string
          readonly avatarUrl?: string | undefined
          readonly billingAddress?: string | undefined
          readonly companySize?: CompanySizeEnum | undefined
          readonly connectionStatus?: ConnectionStatusEnum | undefined
          readonly countAvailablePositions: number
          readonly countRecentPositions: number
          readonly description?: string | undefined
          readonly headline: string
          readonly name: string
          readonly profileComplete: boolean
          readonly profileCompletedAt?: any | undefined
          readonly visibleOnPlatform: boolean
          readonly website?: string | undefined
          readonly companyEmploymentBenefits?:
            | ReadonlyArray<{
                readonly id: string
                readonly employmentBenefit: {
                  readonly icon: string
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly companyLocations?:
            | ReadonlyArray<{
                readonly address?: string | undefined
                readonly addressExtended?: string | undefined
                readonly city?: string | undefined
                readonly country?: CountriesEnum | undefined
                readonly latitude?: number | undefined
                readonly longitude?: number | undefined
                readonly postalCode?: string | undefined
                readonly rawLocation?: string | undefined
                readonly state?: StatesEnum | undefined
              }>
            | undefined
          readonly companyPhotos?:
            | ReadonlyArray<{
                readonly id: string
                readonly alt?: string | undefined
                readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
                readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
                readonly url: string
              }>
            | undefined
          readonly companyValues?:
            | ReadonlyArray<{
                readonly id: string
                readonly description: string
                readonly title: string
              }>
            | undefined
          readonly location: {
            readonly address?: string | undefined
            readonly addressExtended?: string | undefined
            readonly city?: string | undefined
            readonly country?: CountriesEnum | undefined
            readonly latitude?: number | undefined
            readonly longitude?: number | undefined
            readonly postalCode?: string | undefined
            readonly rawLocation?: string | undefined
            readonly state?: StatesEnum | undefined
          }
          readonly permissions: {
            readonly createJobPosting: boolean
            readonly edit: boolean
            readonly readPendingBanner: boolean
            readonly toggleVisible: boolean
          }
          readonly social?:
            | {
                readonly facebook?: string | undefined
                readonly instagram?: string | undefined
                readonly linkedin?: string | undefined
                readonly twitter?: string | undefined
              }
            | undefined
        }
      | undefined
    readonly employmentBenefits?:
      | ReadonlyArray<{
          readonly id: string
          readonly employmentBenefit: {
            readonly icon: string
            readonly id: string
            readonly name: string
          }
        }>
      | undefined
    readonly jobApplicationStatusCounts?:
      | ReadonlyArray<{
          readonly count: number
          readonly status?: JobApplicationStatusEnum | undefined
        }>
      | undefined
    readonly gigsInfo?:
      | {
          readonly additionalRequirements?: string | undefined
          readonly billRate?: number | undefined
          readonly costCenterCreated?: boolean | undefined
          readonly companyOnboarded?: boolean | undefined
          readonly details?: string | undefined
          readonly engagementDeposit?: boolean | undefined
          readonly kickoffCall?: boolean | undefined
          readonly level?: number | undefined
          readonly payRate?: number | undefined
          readonly salaryPayPeriod?: PayPeriodEnum | undefined
          readonly dressCode?: string | undefined
          readonly specialRequests?: string | undefined
          readonly parkingFacilityInformation?: string | undefined
        }
      | undefined
    readonly jobPostingScreening?:
      | {
          readonly id: string
          readonly screening?:
            | {
                readonly id: string
                readonly description?: string | undefined
                readonly name?: string | undefined
                readonly screeningQuestions?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly typeOf?: string | undefined
                      readonly question?: string | undefined
                    }>
                  | undefined
              }
            | undefined
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly destroy: boolean
      readonly edit: boolean
      readonly internalUser: boolean
      readonly managePlacements: boolean
      readonly readEndDate: boolean
      readonly readJobApps: boolean
      readonly readPlacements: boolean
      readonly togglePublished: boolean
      readonly writeAtsRecordType: boolean
      readonly writeRecruiterToJob: boolean
      readonly writeSubmitApplicationUrl: boolean
    }
    readonly placements?:
      | ReadonlyArray<{
          readonly id: string
          readonly status?: PlacementStatusEnum | undefined
        }>
      | undefined
    readonly placementStatusCounts?:
      | ReadonlyArray<{
          readonly count: number
          readonly status?: PlacementStatusEnum | undefined
        }>
      | undefined
    readonly primaryContact?:
      | {
          readonly avatarUrl?: string | undefined
          readonly firstName: string
          readonly id: string
          readonly lastName: string
        }
      | undefined
    readonly recommendedCredentials?:
      | ReadonlyArray<{
          readonly id: string
          readonly credential: {
            readonly __typename: 'Credential'
            readonly id: string
            readonly badgeUrl: string
            readonly description?: string | undefined
            readonly title: string
            readonly training: {
              readonly id: string
              readonly trainingUrl: string
            }
          }
        }>
      | undefined
    readonly recruiters?:
      | ReadonlyArray<{
          readonly avatarUrl?: string | undefined
          readonly firstName: string
          readonly id: string
          readonly lastName: string
          readonly username: string
        }>
      | undefined
    readonly timeSheetManagers?:
      | ReadonlyArray<{
          readonly avatarUrl?: string | undefined
          readonly firstName: string
          readonly id: string
          readonly lastName: string
          readonly username: string
        }>
      | undefined
    readonly requiredLicenses: ReadonlyArray<{
      readonly id: string
      readonly license: {
        readonly id: string
        readonly name: string
        readonly country: CountriesEnum
        readonly state?: string | undefined
      }
    }>
    readonly salaryRange?:
      | {
          readonly maxValue?: number | undefined
          readonly minValue?: number | undefined
          readonly payPeriod?: PayPeriodEnum | undefined
        }
      | undefined
  }
}

export type UpdateJobPostingMutationVariables = Exact<{
  input: JobPostingInput
}>

export type UpdateJobPostingMutation = {
  readonly updateJobPosting: {
    readonly __typename: 'JobPosting'
    readonly id: string
    readonly accountsPayableEmail?: string | undefined
    readonly applicationReceived: boolean
    readonly atsRecordType?: string | undefined
    readonly atsStatus?: JobPostingAtsStatusEnum | undefined
    readonly baseSalaryValue: number
    readonly countJobApplicationsNew: number
    readonly countJobApplicationsTotal: number
    readonly description: string
    readonly depositAmount?: number | undefined
    readonly education?: string | undefined
    readonly employmentTypes?: ReadonlyArray<EmploymentTypesEnum> | undefined
    readonly endDate?: any | undefined
    readonly quantity?: number | undefined
    readonly experience?: string | undefined
    readonly externalId?: string | undefined
    readonly isIngested: boolean
    readonly isPublished: boolean
    readonly isRemote: boolean
    readonly physicalRequirements?: string | undefined
    readonly postedAt?: any | undefined
    readonly shift?: string | undefined
    readonly syndicateIndeed: boolean
    readonly responsibilities?: string | undefined
    readonly slug: string
    readonly startDate?: any | undefined
    readonly submitApplicationUrl?: string | undefined
    readonly title: string
    readonly uri: string
    readonly validThrough: any
    readonly workingEnvironment?: string | undefined
    readonly accountExecs?:
      | ReadonlyArray<{
          readonly avatarUrl?: string | undefined
          readonly firstName: string
          readonly id: string
          readonly lastName: string
          readonly username: string
        }>
      | undefined
    readonly activities?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly client?:
      | {
          readonly __typename: 'Client'
          readonly id: string
          readonly displayname: string
          readonly avatarUrl?: string | undefined
          readonly billingAddress?: string | undefined
          readonly companySize?: CompanySizeEnum | undefined
          readonly connectionStatus?: ConnectionStatusEnum | undefined
          readonly countAvailablePositions: number
          readonly countRecentPositions: number
          readonly description?: string | undefined
          readonly headline: string
          readonly name: string
          readonly profileComplete: boolean
          readonly profileCompletedAt?: any | undefined
          readonly visibleOnPlatform: boolean
          readonly website?: string | undefined
          readonly companyEmploymentBenefits?:
            | ReadonlyArray<{
                readonly id: string
                readonly employmentBenefit: {
                  readonly icon: string
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly companyLocations?:
            | ReadonlyArray<{
                readonly address?: string | undefined
                readonly addressExtended?: string | undefined
                readonly city?: string | undefined
                readonly country?: CountriesEnum | undefined
                readonly latitude?: number | undefined
                readonly longitude?: number | undefined
                readonly postalCode?: string | undefined
                readonly rawLocation?: string | undefined
                readonly state?: StatesEnum | undefined
              }>
            | undefined
          readonly companyPhotos?:
            | ReadonlyArray<{
                readonly id: string
                readonly alt?: string | undefined
                readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
                readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
                readonly url: string
              }>
            | undefined
          readonly companyValues?:
            | ReadonlyArray<{
                readonly id: string
                readonly description: string
                readonly title: string
              }>
            | undefined
          readonly location: {
            readonly address?: string | undefined
            readonly addressExtended?: string | undefined
            readonly city?: string | undefined
            readonly country?: CountriesEnum | undefined
            readonly latitude?: number | undefined
            readonly longitude?: number | undefined
            readonly postalCode?: string | undefined
            readonly rawLocation?: string | undefined
            readonly state?: StatesEnum | undefined
          }
          readonly permissions: {
            readonly createJobPosting: boolean
            readonly edit: boolean
            readonly readPendingBanner: boolean
            readonly toggleVisible: boolean
          }
          readonly social?:
            | {
                readonly facebook?: string | undefined
                readonly instagram?: string | undefined
                readonly linkedin?: string | undefined
                readonly twitter?: string | undefined
              }
            | undefined
        }
      | undefined
    readonly associatedClient?:
      | {
          readonly __typename: 'Client'
          readonly id: string
          readonly displayname: string
          readonly avatarUrl?: string | undefined
          readonly billingAddress?: string | undefined
          readonly companySize?: CompanySizeEnum | undefined
          readonly connectionStatus?: ConnectionStatusEnum | undefined
          readonly countAvailablePositions: number
          readonly countRecentPositions: number
          readonly description?: string | undefined
          readonly headline: string
          readonly name: string
          readonly profileComplete: boolean
          readonly profileCompletedAt?: any | undefined
          readonly visibleOnPlatform: boolean
          readonly website?: string | undefined
          readonly companyEmploymentBenefits?:
            | ReadonlyArray<{
                readonly id: string
                readonly employmentBenefit: {
                  readonly icon: string
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly companyLocations?:
            | ReadonlyArray<{
                readonly address?: string | undefined
                readonly addressExtended?: string | undefined
                readonly city?: string | undefined
                readonly country?: CountriesEnum | undefined
                readonly latitude?: number | undefined
                readonly longitude?: number | undefined
                readonly postalCode?: string | undefined
                readonly rawLocation?: string | undefined
                readonly state?: StatesEnum | undefined
              }>
            | undefined
          readonly companyPhotos?:
            | ReadonlyArray<{
                readonly id: string
                readonly alt?: string | undefined
                readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
                readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
                readonly url: string
              }>
            | undefined
          readonly companyValues?:
            | ReadonlyArray<{
                readonly id: string
                readonly description: string
                readonly title: string
              }>
            | undefined
          readonly location: {
            readonly address?: string | undefined
            readonly addressExtended?: string | undefined
            readonly city?: string | undefined
            readonly country?: CountriesEnum | undefined
            readonly latitude?: number | undefined
            readonly longitude?: number | undefined
            readonly postalCode?: string | undefined
            readonly rawLocation?: string | undefined
            readonly state?: StatesEnum | undefined
          }
          readonly permissions: {
            readonly createJobPosting: boolean
            readonly edit: boolean
            readonly readPendingBanner: boolean
            readonly toggleVisible: boolean
          }
          readonly social?:
            | {
                readonly facebook?: string | undefined
                readonly instagram?: string | undefined
                readonly linkedin?: string | undefined
                readonly twitter?: string | undefined
              }
            | undefined
        }
      | undefined
    readonly employmentBenefits?:
      | ReadonlyArray<{
          readonly id: string
          readonly employmentBenefit: {
            readonly icon: string
            readonly id: string
            readonly name: string
          }
        }>
      | undefined
    readonly jobApplicationStatusCounts?:
      | ReadonlyArray<{
          readonly count: number
          readonly status?: JobApplicationStatusEnum | undefined
        }>
      | undefined
    readonly gigsInfo?:
      | {
          readonly additionalRequirements?: string | undefined
          readonly billRate?: number | undefined
          readonly costCenterCreated?: boolean | undefined
          readonly companyOnboarded?: boolean | undefined
          readonly details?: string | undefined
          readonly engagementDeposit?: boolean | undefined
          readonly kickoffCall?: boolean | undefined
          readonly level?: number | undefined
          readonly payRate?: number | undefined
          readonly salaryPayPeriod?: PayPeriodEnum | undefined
          readonly dressCode?: string | undefined
          readonly specialRequests?: string | undefined
          readonly parkingFacilityInformation?: string | undefined
        }
      | undefined
    readonly jobPostingScreening?:
      | {
          readonly id: string
          readonly screening?:
            | {
                readonly id: string
                readonly description?: string | undefined
                readonly name?: string | undefined
                readonly screeningQuestions?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly typeOf?: string | undefined
                      readonly question?: string | undefined
                    }>
                  | undefined
              }
            | undefined
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly destroy: boolean
      readonly edit: boolean
      readonly internalUser: boolean
      readonly managePlacements: boolean
      readonly readEndDate: boolean
      readonly readJobApps: boolean
      readonly readPlacements: boolean
      readonly togglePublished: boolean
      readonly writeAtsRecordType: boolean
      readonly writeRecruiterToJob: boolean
      readonly writeSubmitApplicationUrl: boolean
    }
    readonly placements?:
      | ReadonlyArray<{
          readonly id: string
          readonly status?: PlacementStatusEnum | undefined
        }>
      | undefined
    readonly placementStatusCounts?:
      | ReadonlyArray<{
          readonly count: number
          readonly status?: PlacementStatusEnum | undefined
        }>
      | undefined
    readonly primaryContact?:
      | {
          readonly avatarUrl?: string | undefined
          readonly firstName: string
          readonly id: string
          readonly lastName: string
        }
      | undefined
    readonly recommendedCredentials?:
      | ReadonlyArray<{
          readonly id: string
          readonly credential: {
            readonly __typename: 'Credential'
            readonly id: string
            readonly badgeUrl: string
            readonly description?: string | undefined
            readonly title: string
            readonly training: {
              readonly id: string
              readonly trainingUrl: string
            }
          }
        }>
      | undefined
    readonly recruiters?:
      | ReadonlyArray<{
          readonly avatarUrl?: string | undefined
          readonly firstName: string
          readonly id: string
          readonly lastName: string
          readonly username: string
        }>
      | undefined
    readonly timeSheetManagers?:
      | ReadonlyArray<{
          readonly avatarUrl?: string | undefined
          readonly firstName: string
          readonly id: string
          readonly lastName: string
          readonly username: string
        }>
      | undefined
    readonly requiredLicenses: ReadonlyArray<{
      readonly id: string
      readonly license: {
        readonly id: string
        readonly name: string
        readonly country: CountriesEnum
        readonly state?: string | undefined
      }
    }>
    readonly salaryRange?:
      | {
          readonly maxValue?: number | undefined
          readonly minValue?: number | undefined
          readonly payPeriod?: PayPeriodEnum | undefined
        }
      | undefined
  }
}

export type DeleteJobPostingMutationVariables = Exact<{
  input: DeleteJobPostingInput
}>

export type DeleteJobPostingMutation = {
  readonly deleteJobPosting: { readonly id: string }
}

export type DeletePlacementMutationVariables = Exact<{
  input: DeletePlacementInput
}>

export type DeletePlacementMutation = { readonly deletePlacement: boolean }

export type DownloadMembersMutationVariables = Exact<{
  input: DownloadMembersInput
}>

export type DownloadMembersMutation = {
  readonly downloadMembers: {
    readonly id: string
    readonly status: MembersDownloadStatusEnum
    readonly url: string
  }
}

export type MemberFragment = {
  readonly __typename: 'User'
  readonly id: string
  readonly username: string
  readonly availability?: string | undefined
  readonly avatarUrl?: string | undefined
  readonly connectionCount: number
  readonly connectionStatus?: ConnectionStatusEnum | undefined
  readonly email?: string | undefined
  readonly secondaryEmail?: string | undefined
  readonly firstName: string
  readonly indispensableSurveyLink: string
  readonly isCurrentUser: boolean
  readonly lastName: string
  readonly termsAcceptedAt?: any | undefined
  readonly phoneNumber?: string | undefined
  readonly uri: string
  readonly activities?:
    | { readonly pageInfo: { readonly totalCount: number } }
    | undefined
  readonly alerts?:
    | { readonly pageInfo: { readonly totalCount: number } }
    | undefined
  readonly gigsEmployee?:
    | {
        readonly id: string
        readonly createdAt: any
        readonly deletedAt?: any | undefined
        readonly eligibleAt?: any | undefined
        readonly offboardedAt?: any | undefined
        readonly onboardedAt?: any | undefined
        readonly onboardingStatus: OnboardingStatusEnum
        readonly percentComplete?: number | undefined
        readonly rejectedAt?: any | undefined
        readonly savedAt?: any | undefined
        readonly screeningAt?: any | undefined
        readonly terminatedAt?: any | undefined
        readonly updatedAt: any
        readonly permissions: { readonly seeHistory: boolean }
      }
    | undefined
  readonly location: {
    readonly address?: string | undefined
    readonly addressExtended?: string | undefined
    readonly city?: string | undefined
    readonly country?: CountriesEnum | undefined
    readonly latitude?: number | undefined
    readonly longitude?: number | undefined
    readonly postalCode?: string | undefined
    readonly rawLocation?: string | undefined
    readonly state?: StatesEnum | undefined
  }
  readonly permissions: {
    readonly applyToJobs: boolean
    readonly edit: boolean
    readonly hasRecruiterLabel: boolean
    readonly imposter: boolean
    readonly internalUser: boolean
    readonly publishJobOrders: boolean
    readonly readEmail: boolean
    readonly readJobBooster: boolean
    readonly readNotes: boolean
    readonly readPhone: boolean
    readonly triggerIndispensableSurvey: boolean
    readonly searchCandidates: boolean
    readonly searchCandidatesAsClient: boolean
    readonly searchCandidatesAsRecruiter: boolean
    readonly searchClients: boolean
    readonly searchClientsByRecruiters: boolean
    readonly searchJobPostings: boolean
    readonly searchJobPostingsByRecruiter: boolean
    readonly sendMessage: boolean
    readonly trainableUser: boolean
    readonly updateConnectionStatus: boolean
    readonly uploadCsv: boolean
    readonly matchCriteria: boolean
  }
  readonly social?:
    | {
        readonly calendly?: string | undefined
        readonly linkedin?: string | undefined
      }
    | undefined
  readonly candidate?:
    | {
        readonly __typename: 'Candidate'
        readonly id: string
        readonly backgroundCheckDate?: any | undefined
        readonly credentialCount: number
        readonly dnu?: string | undefined
        readonly hiringStatus?: HiringStatusEnum | undefined
        readonly i9Date?: any | undefined
        readonly idealEmployment?: string | undefined
        readonly isAbleToApply: boolean
        readonly isNeedEmploymentSponsor?: boolean | undefined
        readonly isUsWorkAuthorized?: boolean | undefined
        readonly noWorkExperience?: boolean | undefined
        readonly profileCompletedAt?: any | undefined
        readonly profilePercentComplete?: number | undefined
        readonly relayId: string
        readonly resumeUrl?: string | undefined
        readonly salaryExpectations?: string | undefined
        readonly candidateLicenses?:
          | ReadonlyArray<{
              readonly id: string
              readonly date?: any | undefined
              readonly number?: string | undefined
              readonly url?: string | undefined
              readonly license?:
                | {
                    readonly id: string
                    readonly name: string
                    readonly country: CountriesEnum
                    readonly state?: string | undefined
                  }
                | undefined
            }>
          | undefined
        readonly credentials?:
          | ReadonlyArray<{
              readonly id: string
              readonly title: string
              readonly badgeUrl: string
              readonly description?: string | undefined
              readonly training: {
                readonly id: string
                readonly trainingUrl: string
              }
            }>
          | undefined
        readonly education?:
          | ReadonlyArray<{
              readonly id: string
              readonly degree?: string | undefined
              readonly educationLevel?: EducationLevelEnum | undefined
              readonly school?: string | undefined
              readonly yearsAttended?: number | undefined
            }>
          | undefined
        readonly experiences?:
          | ReadonlyArray<{
              readonly id: string
              readonly companyName?: string | undefined
              readonly current?: boolean | undefined
              readonly endDate?: any | undefined
              readonly jobTitle?: string | undefined
              readonly responsibilities?: string | undefined
              readonly startDate?: any | undefined
              readonly yearsEmployed?: number | undefined
            }>
          | undefined
        readonly placements?:
          | ReadonlyArray<{
              readonly startDate?: any | undefined
              readonly id: string
              readonly interviewDate?: any | undefined
              readonly status?: PlacementStatusEnum | undefined
              readonly permissions: { readonly update: boolean }
              readonly jobPosting: {
                readonly id: string
                readonly slug: string
                readonly title: string
                readonly client?: { readonly displayname: string } | undefined
                readonly permissions: {
                  readonly readJobApps: boolean
                  readonly readPlacements: boolean
                }
              }
            }>
          | undefined
        readonly jobApplications?:
          | ReadonlyArray<{
              readonly id: string
              readonly status?: JobApplicationStatusEnum | undefined
              readonly permissions: { readonly show: boolean }
              readonly jobPosting: {
                readonly id: string
                readonly level?: number | undefined
                readonly slug: string
                readonly title: string
                readonly client?:
                  | { readonly displayname: string; readonly name: string }
                  | undefined
                readonly permissions: {
                  readonly readJobApps: boolean
                  readonly readPlacements: boolean
                  readonly managePlacements: boolean
                }
                readonly jobPostingScreening?:
                  | { readonly id: string }
                  | undefined
              }
              readonly screeningSubmissions?:
                | ReadonlyArray<{ readonly id: string }>
                | undefined
            }>
          | undefined
        readonly permissions: {
          readonly edit: boolean
          readonly readApplications: boolean
          readonly readCredentials: boolean
          readonly readLicense: boolean
          readonly readResume: boolean
          readonly readWorkPreferences: boolean
        }
        readonly recruiters?:
          | ReadonlyArray<{
              readonly avatarUrl?: string | undefined
              readonly firstName: string
              readonly id: string
              readonly lastName: string
            }>
          | undefined
        readonly skillRelations?:
          | ReadonlyArray<{
              readonly id: string
              readonly years: number
              readonly skill: {
                readonly __typename: 'Skill'
                readonly id: string
                readonly name: string
              }
            }>
          | undefined
        readonly summary?:
          | {
              readonly id: string
              readonly entry: string
              readonly title: string
            }
          | undefined
      }
    | undefined
  readonly subscription?:
    | {
        readonly __typename: 'Subscription'
        readonly id: string
        readonly active: boolean
        readonly plan: string
      }
    | undefined
}

export type Member_EditFragment = {
  readonly id: string
  readonly availability?: string | undefined
  readonly avatarUrl?: string | undefined
  readonly email?: string | undefined
  readonly secondaryEmail?: string | undefined
  readonly firstName: string
  readonly lastName: string
  readonly phoneNumber?: string | undefined
  readonly social?:
    | {
        readonly calendly?: string | undefined
        readonly linkedin?: string | undefined
      }
    | undefined
  readonly location: {
    readonly address?: string | undefined
    readonly addressExtended?: string | undefined
    readonly city?: string | undefined
    readonly country?: CountriesEnum | undefined
    readonly latitude?: number | undefined
    readonly longitude?: number | undefined
    readonly postalCode?: string | undefined
    readonly rawLocation?: string | undefined
    readonly state?: StatesEnum | undefined
  }
  readonly candidate?:
    | {
        readonly backgroundCheckDate?: any | undefined
        readonly dnu?: string | undefined
        readonly hiringStatus?: HiringStatusEnum | undefined
        readonly i9Date?: any | undefined
        readonly idealEmployment?: string | undefined
        readonly isNeedEmploymentSponsor?: boolean | undefined
        readonly isUsWorkAuthorized?: boolean | undefined
        readonly noWorkExperience?: boolean | undefined
        readonly profilePercentComplete?: number | undefined
        readonly resumeUrl?: string | undefined
        readonly salaryExpectations?: string | undefined
        readonly candidateLicenses?:
          | ReadonlyArray<{
              readonly id: string
              readonly date?: any | undefined
              readonly number?: string | undefined
              readonly url?: string | undefined
              readonly license?:
                | {
                    readonly id: string
                    readonly name: string
                    readonly country: CountriesEnum
                    readonly state?: string | undefined
                  }
                | undefined
            }>
          | undefined
        readonly education?:
          | ReadonlyArray<{
              readonly id: string
              readonly degree?: string | undefined
              readonly educationLevel?: EducationLevelEnum | undefined
              readonly school?: string | undefined
              readonly yearsAttended?: number | undefined
            }>
          | undefined
        readonly experiences?:
          | ReadonlyArray<{
              readonly id: string
              readonly companyName?: string | undefined
              readonly current?: boolean | undefined
              readonly endDate?: any | undefined
              readonly jobTitle?: string | undefined
              readonly responsibilities?: string | undefined
              readonly startDate?: any | undefined
              readonly yearsEmployed?: number | undefined
            }>
          | undefined
        readonly recruiters?:
          | ReadonlyArray<{
              readonly avatarUrl?: string | undefined
              readonly firstName: string
              readonly id: string
              readonly lastName: string
            }>
          | undefined
        readonly skillRelations?:
          | ReadonlyArray<{
              readonly id: string
              readonly years: number
              readonly skill: {
                readonly __typename: 'Skill'
                readonly id: string
                readonly name: string
              }
            }>
          | undefined
        readonly summary?:
          | {
              readonly id: string
              readonly entry: string
              readonly title: string
            }
          | undefined
      }
    | undefined
}

export type Member_ConnectionsFragment = {
  readonly connectionCount: number
  readonly connections: {
    readonly edges?:
      | ReadonlyArray<
          | {
              readonly cursor: string
              readonly node?:
                | {
                    readonly __typename: 'Client'
                    readonly id: string
                    readonly billingAddress?: string | undefined
                    readonly accountsPayableEmail?: string | undefined
                    readonly displayname: string
                    readonly avatarUrl?: string | undefined
                    readonly companySize?: CompanySizeEnum | undefined
                    readonly connectionStatus?: ConnectionStatusEnum | undefined
                    readonly countAvailablePositions: number
                    readonly countRecentPositions: number
                    readonly headline: string
                    readonly metaDescription: string
                    readonly metaTitle: string
                    readonly name: string
                    readonly profileComplete: boolean
                    readonly profileCompletedAt?: any | undefined
                    readonly uri: string
                    readonly visibleOnPlatform: boolean
                    readonly website?: string | undefined
                    readonly companyDescription?: string | undefined
                    readonly companyEmploymentBenefits?:
                      | ReadonlyArray<{
                          readonly id: string
                          readonly employmentBenefit: {
                            readonly icon: string
                            readonly id: string
                            readonly name: string
                          }
                        }>
                      | undefined
                    readonly companyLocations?:
                      | ReadonlyArray<{
                          readonly address?: string | undefined
                          readonly addressExtended?: string | undefined
                          readonly city?: string | undefined
                          readonly country?: CountriesEnum | undefined
                          readonly latitude?: number | undefined
                          readonly longitude?: number | undefined
                          readonly postalCode?: string | undefined
                          readonly rawLocation?: string | undefined
                          readonly state?: StatesEnum | undefined
                        }>
                      | undefined
                    readonly companyPhotos?:
                      | ReadonlyArray<{
                          readonly id: string
                          readonly alt?: string | undefined
                          readonly displayRole?:
                            | CompanyPhotoDisplayRoleEnum
                            | undefined
                          readonly mediaType?:
                            | CompanyPhotoMediaTypeEnum
                            | undefined
                          readonly url: string
                        }>
                      | undefined
                    readonly companyValues?:
                      | ReadonlyArray<{
                          readonly id: string
                          readonly description: string
                          readonly title: string
                        }>
                      | undefined
                    readonly location: {
                      readonly address?: string | undefined
                      readonly addressExtended?: string | undefined
                      readonly city?: string | undefined
                      readonly country?: CountriesEnum | undefined
                      readonly latitude?: number | undefined
                      readonly longitude?: number | undefined
                      readonly postalCode?: string | undefined
                      readonly rawLocation?: string | undefined
                      readonly state?: StatesEnum | undefined
                    }
                    readonly permissions: {
                      readonly createJobPosting: boolean
                      readonly edit: boolean
                      readonly editMeta: boolean
                      readonly internalUser: boolean
                      readonly readPendingBanner: boolean
                      readonly toggleVisible: boolean
                    }
                    readonly social?:
                      | {
                          readonly facebook?: string | undefined
                          readonly instagram?: string | undefined
                          readonly linkedin?: string | undefined
                          readonly twitter?: string | undefined
                        }
                      | undefined
                    readonly trainings: {
                      readonly pageInfo: { readonly totalCount: number }
                    }
                  }
                | {
                    readonly __typename: 'User'
                    readonly id: string
                    readonly username: string
                    readonly availability?: string | undefined
                    readonly avatarUrl?: string | undefined
                    readonly connectionCount: number
                    readonly connectionStatus?: ConnectionStatusEnum | undefined
                    readonly email?: string | undefined
                    readonly secondaryEmail?: string | undefined
                    readonly firstName: string
                    readonly indispensableSurveyLink: string
                    readonly isCurrentUser: boolean
                    readonly lastName: string
                    readonly termsAcceptedAt?: any | undefined
                    readonly phoneNumber?: string | undefined
                    readonly uri: string
                    readonly activities?:
                      | { readonly pageInfo: { readonly totalCount: number } }
                      | undefined
                    readonly alerts?:
                      | { readonly pageInfo: { readonly totalCount: number } }
                      | undefined
                    readonly gigsEmployee?:
                      | {
                          readonly id: string
                          readonly createdAt: any
                          readonly deletedAt?: any | undefined
                          readonly eligibleAt?: any | undefined
                          readonly offboardedAt?: any | undefined
                          readonly onboardedAt?: any | undefined
                          readonly onboardingStatus: OnboardingStatusEnum
                          readonly percentComplete?: number | undefined
                          readonly rejectedAt?: any | undefined
                          readonly savedAt?: any | undefined
                          readonly screeningAt?: any | undefined
                          readonly terminatedAt?: any | undefined
                          readonly updatedAt: any
                          readonly permissions: { readonly seeHistory: boolean }
                        }
                      | undefined
                    readonly location: {
                      readonly address?: string | undefined
                      readonly addressExtended?: string | undefined
                      readonly city?: string | undefined
                      readonly country?: CountriesEnum | undefined
                      readonly latitude?: number | undefined
                      readonly longitude?: number | undefined
                      readonly postalCode?: string | undefined
                      readonly rawLocation?: string | undefined
                      readonly state?: StatesEnum | undefined
                    }
                    readonly permissions: {
                      readonly applyToJobs: boolean
                      readonly edit: boolean
                      readonly hasRecruiterLabel: boolean
                      readonly imposter: boolean
                      readonly internalUser: boolean
                      readonly publishJobOrders: boolean
                      readonly readEmail: boolean
                      readonly readJobBooster: boolean
                      readonly readNotes: boolean
                      readonly readPhone: boolean
                      readonly triggerIndispensableSurvey: boolean
                      readonly searchCandidates: boolean
                      readonly searchCandidatesAsClient: boolean
                      readonly searchCandidatesAsRecruiter: boolean
                      readonly searchClients: boolean
                      readonly searchClientsByRecruiters: boolean
                      readonly searchJobPostings: boolean
                      readonly searchJobPostingsByRecruiter: boolean
                      readonly sendMessage: boolean
                      readonly trainableUser: boolean
                      readonly updateConnectionStatus: boolean
                      readonly uploadCsv: boolean
                      readonly matchCriteria: boolean
                    }
                    readonly social?:
                      | {
                          readonly calendly?: string | undefined
                          readonly linkedin?: string | undefined
                        }
                      | undefined
                    readonly candidate?:
                      | {
                          readonly __typename: 'Candidate'
                          readonly id: string
                          readonly backgroundCheckDate?: any | undefined
                          readonly credentialCount: number
                          readonly dnu?: string | undefined
                          readonly hiringStatus?: HiringStatusEnum | undefined
                          readonly i9Date?: any | undefined
                          readonly idealEmployment?: string | undefined
                          readonly isAbleToApply: boolean
                          readonly isNeedEmploymentSponsor?: boolean | undefined
                          readonly isUsWorkAuthorized?: boolean | undefined
                          readonly noWorkExperience?: boolean | undefined
                          readonly profileCompletedAt?: any | undefined
                          readonly profilePercentComplete?: number | undefined
                          readonly relayId: string
                          readonly resumeUrl?: string | undefined
                          readonly salaryExpectations?: string | undefined
                          readonly candidateLicenses?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly date?: any | undefined
                                readonly number?: string | undefined
                                readonly url?: string | undefined
                                readonly license?:
                                  | {
                                      readonly id: string
                                      readonly name: string
                                      readonly country: CountriesEnum
                                      readonly state?: string | undefined
                                    }
                                  | undefined
                              }>
                            | undefined
                          readonly credentials?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly title: string
                                readonly badgeUrl: string
                                readonly description?: string | undefined
                                readonly training: {
                                  readonly id: string
                                  readonly trainingUrl: string
                                }
                              }>
                            | undefined
                          readonly education?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly degree?: string | undefined
                                readonly educationLevel?:
                                  | EducationLevelEnum
                                  | undefined
                                readonly school?: string | undefined
                                readonly yearsAttended?: number | undefined
                              }>
                            | undefined
                          readonly experiences?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly companyName?: string | undefined
                                readonly current?: boolean | undefined
                                readonly endDate?: any | undefined
                                readonly jobTitle?: string | undefined
                                readonly responsibilities?: string | undefined
                                readonly startDate?: any | undefined
                                readonly yearsEmployed?: number | undefined
                              }>
                            | undefined
                          readonly placements?:
                            | ReadonlyArray<{
                                readonly startDate?: any | undefined
                                readonly id: string
                                readonly interviewDate?: any | undefined
                                readonly status?:
                                  | PlacementStatusEnum
                                  | undefined
                                readonly permissions: {
                                  readonly update: boolean
                                }
                                readonly jobPosting: {
                                  readonly id: string
                                  readonly slug: string
                                  readonly title: string
                                  readonly client?:
                                    | { readonly displayname: string }
                                    | undefined
                                  readonly permissions: {
                                    readonly readJobApps: boolean
                                    readonly readPlacements: boolean
                                  }
                                }
                              }>
                            | undefined
                          readonly jobApplications?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly status?:
                                  | JobApplicationStatusEnum
                                  | undefined
                                readonly permissions: { readonly show: boolean }
                                readonly jobPosting: {
                                  readonly id: string
                                  readonly level?: number | undefined
                                  readonly slug: string
                                  readonly title: string
                                  readonly client?:
                                    | {
                                        readonly displayname: string
                                        readonly name: string
                                      }
                                    | undefined
                                  readonly permissions: {
                                    readonly readJobApps: boolean
                                    readonly readPlacements: boolean
                                    readonly managePlacements: boolean
                                  }
                                  readonly jobPostingScreening?:
                                    | { readonly id: string }
                                    | undefined
                                }
                                readonly screeningSubmissions?:
                                  | ReadonlyArray<{ readonly id: string }>
                                  | undefined
                              }>
                            | undefined
                          readonly permissions: {
                            readonly edit: boolean
                            readonly readApplications: boolean
                            readonly readCredentials: boolean
                            readonly readLicense: boolean
                            readonly readResume: boolean
                            readonly readWorkPreferences: boolean
                          }
                          readonly recruiters?:
                            | ReadonlyArray<{
                                readonly avatarUrl?: string | undefined
                                readonly firstName: string
                                readonly id: string
                                readonly lastName: string
                              }>
                            | undefined
                          readonly skillRelations?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly years: number
                                readonly skill: {
                                  readonly __typename: 'Skill'
                                  readonly id: string
                                  readonly name: string
                                }
                              }>
                            | undefined
                          readonly summary?:
                            | {
                                readonly id: string
                                readonly entry: string
                                readonly title: string
                              }
                            | undefined
                        }
                      | undefined
                    readonly subscription?:
                      | {
                          readonly __typename: 'Subscription'
                          readonly id: string
                          readonly active: boolean
                          readonly plan: string
                        }
                      | undefined
                  }
                | undefined
            }
          | undefined
        >
      | undefined
    readonly pageInfo: {
      readonly endCursor?: string | undefined
      readonly hasNextPage: boolean
      readonly hasPreviousPage: boolean
      readonly startCursor?: string | undefined
    }
  }
}

export type Member_JobPostingFragment = {
  readonly __typename: 'JobPosting'
  readonly id: string
  readonly applicationReceived: boolean
  readonly atsRecordType?: string | undefined
  readonly description: string
  readonly employmentTypes?: ReadonlyArray<EmploymentTypesEnum> | undefined
  readonly postedAt?: any | undefined
  readonly slug: string
  readonly title: string
  readonly client?:
    | {
        readonly __typename: 'Client'
        readonly id: string
        readonly displayname: string
        readonly avatarUrl?: string | undefined
        readonly connectionStatus?: ConnectionStatusEnum | undefined
        readonly description?: string | undefined
        readonly name: string
        readonly location: {
          readonly address?: string | undefined
          readonly addressExtended?: string | undefined
          readonly city?: string | undefined
          readonly country?: CountriesEnum | undefined
          readonly latitude?: number | undefined
          readonly longitude?: number | undefined
          readonly postalCode?: string | undefined
          readonly rawLocation?: string | undefined
          readonly state?: StatesEnum | undefined
        }
      }
    | undefined
  readonly jobPostingScreening?:
    | {
        readonly id: string
        readonly screening?:
          | {
              readonly id: string
              readonly description?: string | undefined
              readonly name?: string | undefined
              readonly screeningQuestions?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly typeOf?: string | undefined
                    readonly question?: string | undefined
                  }>
                | undefined
            }
          | undefined
      }
    | undefined
  readonly location: {
    readonly address?: string | undefined
    readonly addressExtended?: string | undefined
    readonly city?: string | undefined
    readonly country?: CountriesEnum | undefined
    readonly latitude?: number | undefined
    readonly longitude?: number | undefined
    readonly postalCode?: string | undefined
    readonly rawLocation?: string | undefined
    readonly state?: StatesEnum | undefined
  }
  readonly permissions: {
    readonly destroy: boolean
    readonly edit: boolean
    readonly readJobApps: boolean
  }
  readonly requiredLicenses: ReadonlyArray<{
    readonly id: string
    readonly license: {
      readonly id: string
      readonly name: string
      readonly country: CountriesEnum
      readonly state?: string | undefined
    }
  }>
}

export type Member_JobApplicationFragment = {
  readonly __typename: 'JobApplication'
  readonly id: string
  readonly createdAt: any
  readonly clientInterestAt?: any | undefined
  readonly clientInterestMessage: string
  readonly hasClientInterest: boolean
  readonly status?: JobApplicationStatusEnum | undefined
  readonly permissions: { readonly show: boolean }
  readonly jobPosting: {
    readonly __typename: 'JobPosting'
    readonly id: string
    readonly applicationReceived: boolean
    readonly atsRecordType?: string | undefined
    readonly description: string
    readonly employmentTypes?: ReadonlyArray<EmploymentTypesEnum> | undefined
    readonly postedAt?: any | undefined
    readonly slug: string
    readonly title: string
    readonly client?:
      | {
          readonly __typename: 'Client'
          readonly id: string
          readonly displayname: string
          readonly avatarUrl?: string | undefined
          readonly connectionStatus?: ConnectionStatusEnum | undefined
          readonly description?: string | undefined
          readonly name: string
          readonly location: {
            readonly address?: string | undefined
            readonly addressExtended?: string | undefined
            readonly city?: string | undefined
            readonly country?: CountriesEnum | undefined
            readonly latitude?: number | undefined
            readonly longitude?: number | undefined
            readonly postalCode?: string | undefined
            readonly rawLocation?: string | undefined
            readonly state?: StatesEnum | undefined
          }
        }
      | undefined
    readonly jobPostingScreening?:
      | {
          readonly id: string
          readonly screening?:
            | {
                readonly id: string
                readonly description?: string | undefined
                readonly name?: string | undefined
                readonly screeningQuestions?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly typeOf?: string | undefined
                      readonly question?: string | undefined
                    }>
                  | undefined
              }
            | undefined
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly destroy: boolean
      readonly edit: boolean
      readonly readJobApps: boolean
    }
    readonly requiredLicenses: ReadonlyArray<{
      readonly id: string
      readonly license: {
        readonly id: string
        readonly name: string
        readonly country: CountriesEnum
        readonly state?: string | undefined
      }
    }>
  }
  readonly screeningSubmissions?:
    | ReadonlyArray<{
        readonly id: string
        readonly jobApplication?:
          | {
              readonly id: string
              readonly jobPosting: {
                readonly id: string
                readonly title: string
                readonly slug: string
              }
            }
          | undefined
        readonly screeningQResponses?:
          | ReadonlyArray<{
              readonly id: string
              readonly answer?: any | undefined
              readonly screeningQuestion?:
                | {
                    readonly id: string
                    readonly question?: string | undefined
                  }
                | undefined
            }>
          | undefined
      }>
    | undefined
}

export type Member_JobApplicationsFragment = {
  readonly candidate?:
    | {
        readonly jobApplications?:
          | ReadonlyArray<{
              readonly __typename: 'JobApplication'
              readonly id: string
              readonly createdAt: any
              readonly clientInterestAt?: any | undefined
              readonly clientInterestMessage: string
              readonly hasClientInterest: boolean
              readonly status?: JobApplicationStatusEnum | undefined
              readonly permissions: { readonly show: boolean }
              readonly jobPosting: {
                readonly __typename: 'JobPosting'
                readonly id: string
                readonly applicationReceived: boolean
                readonly atsRecordType?: string | undefined
                readonly description: string
                readonly employmentTypes?:
                  | ReadonlyArray<EmploymentTypesEnum>
                  | undefined
                readonly postedAt?: any | undefined
                readonly slug: string
                readonly title: string
                readonly client?:
                  | {
                      readonly __typename: 'Client'
                      readonly id: string
                      readonly displayname: string
                      readonly avatarUrl?: string | undefined
                      readonly connectionStatus?:
                        | ConnectionStatusEnum
                        | undefined
                      readonly description?: string | undefined
                      readonly name: string
                      readonly location: {
                        readonly address?: string | undefined
                        readonly addressExtended?: string | undefined
                        readonly city?: string | undefined
                        readonly country?: CountriesEnum | undefined
                        readonly latitude?: number | undefined
                        readonly longitude?: number | undefined
                        readonly postalCode?: string | undefined
                        readonly rawLocation?: string | undefined
                        readonly state?: StatesEnum | undefined
                      }
                    }
                  | undefined
                readonly jobPostingScreening?:
                  | {
                      readonly id: string
                      readonly screening?:
                        | {
                            readonly id: string
                            readonly description?: string | undefined
                            readonly name?: string | undefined
                            readonly screeningQuestions?:
                              | ReadonlyArray<{
                                  readonly id: string
                                  readonly typeOf?: string | undefined
                                  readonly question?: string | undefined
                                }>
                              | undefined
                          }
                        | undefined
                    }
                  | undefined
                readonly location: {
                  readonly address?: string | undefined
                  readonly addressExtended?: string | undefined
                  readonly city?: string | undefined
                  readonly country?: CountriesEnum | undefined
                  readonly latitude?: number | undefined
                  readonly longitude?: number | undefined
                  readonly postalCode?: string | undefined
                  readonly rawLocation?: string | undefined
                  readonly state?: StatesEnum | undefined
                }
                readonly permissions: {
                  readonly destroy: boolean
                  readonly edit: boolean
                  readonly readJobApps: boolean
                }
                readonly requiredLicenses: ReadonlyArray<{
                  readonly id: string
                  readonly license: {
                    readonly id: string
                    readonly name: string
                    readonly country: CountriesEnum
                    readonly state?: string | undefined
                  }
                }>
              }
              readonly screeningSubmissions?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly jobApplication?:
                      | {
                          readonly id: string
                          readonly jobPosting: {
                            readonly id: string
                            readonly title: string
                            readonly slug: string
                          }
                        }
                      | undefined
                    readonly screeningQResponses?:
                      | ReadonlyArray<{
                          readonly id: string
                          readonly answer?: any | undefined
                          readonly screeningQuestion?:
                            | {
                                readonly id: string
                                readonly question?: string | undefined
                              }
                            | undefined
                        }>
                      | undefined
                  }>
                | undefined
            }>
          | undefined
      }
    | undefined
}

export type MemberCredentialFragment = {
  readonly id: string
  readonly badgeUrl: string
  readonly description?: string | undefined
  readonly title: string
  readonly training: { readonly id: string; readonly trainingUrl: string }
}

export type MemberEducationFragment = {
  readonly id: string
  readonly degree?: string | undefined
  readonly educationLevel?: EducationLevelEnum | undefined
  readonly school?: string | undefined
  readonly yearsAttended?: number | undefined
}

export type MemberExperienceFragment = {
  readonly id: string
  readonly companyName?: string | undefined
  readonly current?: boolean | undefined
  readonly endDate?: any | undefined
  readonly jobTitle?: string | undefined
  readonly responsibilities?: string | undefined
  readonly startDate?: any | undefined
  readonly yearsEmployed?: number | undefined
}

export type MemberLicenseFragment = {
  readonly id: string
  readonly date?: any | undefined
  readonly number?: string | undefined
  readonly url?: string | undefined
  readonly license?:
    | {
        readonly id: string
        readonly name: string
        readonly country: CountriesEnum
        readonly state?: string | undefined
      }
    | undefined
}

export type MemberSkillFragment = {
  readonly id: string
  readonly years: number
  readonly skill: {
    readonly __typename: 'Skill'
    readonly id: string
    readonly name: string
  }
}

export type MemberSummaryFragment = {
  readonly id: string
  readonly entry: string
  readonly title: string
}

export type Member_AlertsFragment = {
  readonly id: string
  readonly username: string
  readonly alerts?:
    | {
        readonly edges?:
          | ReadonlyArray<
              | {
                  readonly __typename: 'ActivityEdge'
                  readonly cursor: string
                  readonly node?:
                    | {
                        readonly id: string
                        readonly alert?: boolean | undefined
                        readonly body?: string | undefined
                        readonly createdAt: any
                        readonly jsonBody?: any | undefined
                        readonly recipientRead?: any | undefined
                        readonly updatedAt: any
                        readonly author?:
                          | {
                              readonly id: string
                              readonly avatarUrl?: string | undefined
                              readonly firstName: string
                              readonly lastName: string
                              readonly uri: string
                              readonly username: string
                            }
                          | undefined
                        readonly kontext?:
                          | {
                              readonly __typename: 'ChatMessage'
                              readonly id: string
                              readonly sender: { readonly username: string }
                            }
                          | {
                              readonly __typename: 'JobApplication'
                              readonly id: string
                              readonly uri: string
                              readonly jobPosting: {
                                readonly id: string
                                readonly slug: string
                                readonly client?:
                                  | { readonly displayname: string }
                                  | undefined
                              }
                              readonly user?:
                                | {
                                    readonly id: string
                                    readonly username: string
                                  }
                                | undefined
                            }
                          | {
                              readonly __typename: 'JobPosting'
                              readonly id: string
                              readonly slug: string
                              readonly uri: string
                              readonly client?:
                                | {
                                    readonly id: string
                                    readonly displayname: string
                                  }
                                | undefined
                            }
                          | {
                              readonly __typename: 'Placement'
                              readonly id: string
                              readonly uri: string
                              readonly updatedAt: any
                              readonly jobPosting: {
                                readonly id: string
                                readonly slug: string
                                readonly client?:
                                  | {
                                      readonly id: string
                                      readonly displayname: string
                                    }
                                  | undefined
                              }
                              readonly user?:
                                | {
                                    readonly id: string
                                    readonly username: string
                                  }
                                | undefined
                            }
                          | {
                              readonly __typename: 'User'
                              readonly id: string
                              readonly username: string
                              readonly uri: string
                            }
                          | {}
                          | undefined
                        readonly resource:
                          | {
                              readonly __typename: 'Client'
                              readonly id: string
                              readonly displayname: string
                              readonly uri: string
                            }
                          | { readonly __typename: 'GigsEmployee' }
                          | {
                              readonly __typename: 'JobApplication'
                              readonly id: string
                              readonly uri: string
                              readonly jobPosting: {
                                readonly id: string
                                readonly slug: string
                                readonly client?:
                                  | { readonly displayname: string }
                                  | undefined
                              }
                              readonly user?:
                                | {
                                    readonly id: string
                                    readonly username: string
                                  }
                                | undefined
                            }
                          | {
                              readonly __typename: 'JobPosting'
                              readonly id: string
                              readonly slug: string
                              readonly uri: string
                              readonly client?:
                                | {
                                    readonly id: string
                                    readonly displayname: string
                                  }
                                | undefined
                            }
                          | {
                              readonly __typename: 'Placement'
                              readonly id: string
                              readonly uri: string
                              readonly updatedAt: any
                              readonly jobPosting: {
                                readonly id: string
                                readonly slug: string
                                readonly client?:
                                  | {
                                      readonly id: string
                                      readonly displayname: string
                                    }
                                  | undefined
                              }
                              readonly user?:
                                | {
                                    readonly id: string
                                    readonly username: string
                                  }
                                | undefined
                            }
                          | {
                              readonly __typename: 'User'
                              readonly id: string
                              readonly username: string
                              readonly uri: string
                            }
                      }
                    | undefined
                }
              | undefined
            >
          | undefined
        readonly pageInfo: {
          readonly endCursor?: string | undefined
          readonly hasNextPage: boolean
          readonly hasPreviousPage: boolean
          readonly startCursor?: string | undefined
          readonly totalCount: number
        }
      }
    | undefined
}

export type Member_ActivitiesFragment = {
  readonly id: string
  readonly username: string
  readonly activities?:
    | {
        readonly edges?:
          | ReadonlyArray<
              | {
                  readonly __typename: 'ActivityEdge'
                  readonly cursor: string
                  readonly node?:
                    | {
                        readonly id: string
                        readonly alert?: boolean | undefined
                        readonly body?: string | undefined
                        readonly createdAt: any
                        readonly jsonBody?: any | undefined
                        readonly recipientRead?: any | undefined
                        readonly updatedAt: any
                        readonly author?:
                          | {
                              readonly id: string
                              readonly avatarUrl?: string | undefined
                              readonly firstName: string
                              readonly lastName: string
                              readonly uri: string
                              readonly username: string
                            }
                          | undefined
                        readonly kontext?:
                          | {
                              readonly __typename: 'ChatMessage'
                              readonly id: string
                              readonly sender: { readonly username: string }
                            }
                          | {
                              readonly __typename: 'JobApplication'
                              readonly id: string
                              readonly uri: string
                              readonly jobPosting: {
                                readonly id: string
                                readonly slug: string
                                readonly client?:
                                  | { readonly displayname: string }
                                  | undefined
                              }
                              readonly user?:
                                | {
                                    readonly id: string
                                    readonly username: string
                                  }
                                | undefined
                            }
                          | {
                              readonly __typename: 'JobPosting'
                              readonly id: string
                              readonly slug: string
                              readonly uri: string
                              readonly client?:
                                | {
                                    readonly id: string
                                    readonly displayname: string
                                  }
                                | undefined
                            }
                          | {
                              readonly __typename: 'Placement'
                              readonly id: string
                              readonly uri: string
                              readonly updatedAt: any
                              readonly jobPosting: {
                                readonly id: string
                                readonly slug: string
                                readonly client?:
                                  | {
                                      readonly id: string
                                      readonly displayname: string
                                    }
                                  | undefined
                              }
                              readonly user?:
                                | {
                                    readonly id: string
                                    readonly username: string
                                  }
                                | undefined
                            }
                          | {
                              readonly __typename: 'User'
                              readonly id: string
                              readonly username: string
                              readonly uri: string
                            }
                          | {}
                          | undefined
                        readonly resource:
                          | {
                              readonly __typename: 'Client'
                              readonly id: string
                              readonly displayname: string
                              readonly uri: string
                            }
                          | { readonly __typename: 'GigsEmployee' }
                          | {
                              readonly __typename: 'JobApplication'
                              readonly id: string
                              readonly uri: string
                              readonly jobPosting: {
                                readonly id: string
                                readonly slug: string
                                readonly client?:
                                  | { readonly displayname: string }
                                  | undefined
                              }
                              readonly user?:
                                | {
                                    readonly id: string
                                    readonly username: string
                                  }
                                | undefined
                            }
                          | {
                              readonly __typename: 'JobPosting'
                              readonly id: string
                              readonly slug: string
                              readonly uri: string
                              readonly client?:
                                | {
                                    readonly id: string
                                    readonly displayname: string
                                  }
                                | undefined
                            }
                          | {
                              readonly __typename: 'Placement'
                              readonly id: string
                              readonly uri: string
                              readonly updatedAt: any
                              readonly jobPosting: {
                                readonly id: string
                                readonly slug: string
                                readonly client?:
                                  | {
                                      readonly id: string
                                      readonly displayname: string
                                    }
                                  | undefined
                              }
                              readonly user?:
                                | {
                                    readonly id: string
                                    readonly username: string
                                  }
                                | undefined
                            }
                          | {
                              readonly __typename: 'User'
                              readonly id: string
                              readonly username: string
                              readonly uri: string
                            }
                      }
                    | undefined
                }
              | undefined
            >
          | undefined
        readonly pageInfo: {
          readonly endCursor?: string | undefined
          readonly hasNextPage: boolean
          readonly hasPreviousPage: boolean
          readonly startCursor?: string | undefined
          readonly totalCount: number
        }
      }
    | undefined
}

export type ScreeningSubmissionFragment = {
  readonly id: string
  readonly jobApplication?:
    | {
        readonly id: string
        readonly jobPosting: {
          readonly id: string
          readonly title: string
          readonly slug: string
        }
      }
    | undefined
  readonly screeningQResponses?:
    | ReadonlyArray<{
        readonly id: string
        readonly answer?: any | undefined
        readonly screeningQuestion?:
          | { readonly id: string; readonly question?: string | undefined }
          | undefined
      }>
    | undefined
}

export type ScreeningQResponseFragment = {
  readonly id: string
  readonly answer?: any | undefined
  readonly screeningQuestion?:
    | { readonly id: string; readonly question?: string | undefined }
    | undefined
}

export type MemberQueryVariables = Exact<{
  username: Scalars['String']['input']
}>

export type MemberQuery = {
  readonly getUser: {
    readonly __typename: 'User'
    readonly id: string
    readonly username: string
    readonly availability?: string | undefined
    readonly avatarUrl?: string | undefined
    readonly connectionCount: number
    readonly connectionStatus?: ConnectionStatusEnum | undefined
    readonly email?: string | undefined
    readonly secondaryEmail?: string | undefined
    readonly firstName: string
    readonly indispensableSurveyLink: string
    readonly isCurrentUser: boolean
    readonly lastName: string
    readonly termsAcceptedAt?: any | undefined
    readonly phoneNumber?: string | undefined
    readonly uri: string
    readonly activities?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly alerts?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly gigsEmployee?:
      | {
          readonly id: string
          readonly createdAt: any
          readonly deletedAt?: any | undefined
          readonly eligibleAt?: any | undefined
          readonly offboardedAt?: any | undefined
          readonly onboardedAt?: any | undefined
          readonly onboardingStatus: OnboardingStatusEnum
          readonly percentComplete?: number | undefined
          readonly rejectedAt?: any | undefined
          readonly savedAt?: any | undefined
          readonly screeningAt?: any | undefined
          readonly terminatedAt?: any | undefined
          readonly updatedAt: any
          readonly permissions: { readonly seeHistory: boolean }
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly applyToJobs: boolean
      readonly edit: boolean
      readonly hasRecruiterLabel: boolean
      readonly imposter: boolean
      readonly internalUser: boolean
      readonly publishJobOrders: boolean
      readonly readEmail: boolean
      readonly readJobBooster: boolean
      readonly readNotes: boolean
      readonly readPhone: boolean
      readonly triggerIndispensableSurvey: boolean
      readonly searchCandidates: boolean
      readonly searchCandidatesAsClient: boolean
      readonly searchCandidatesAsRecruiter: boolean
      readonly searchClients: boolean
      readonly searchClientsByRecruiters: boolean
      readonly searchJobPostings: boolean
      readonly searchJobPostingsByRecruiter: boolean
      readonly sendMessage: boolean
      readonly trainableUser: boolean
      readonly updateConnectionStatus: boolean
      readonly uploadCsv: boolean
      readonly matchCriteria: boolean
    }
    readonly social?:
      | {
          readonly calendly?: string | undefined
          readonly linkedin?: string | undefined
        }
      | undefined
    readonly candidate?:
      | {
          readonly __typename: 'Candidate'
          readonly id: string
          readonly backgroundCheckDate?: any | undefined
          readonly credentialCount: number
          readonly dnu?: string | undefined
          readonly hiringStatus?: HiringStatusEnum | undefined
          readonly i9Date?: any | undefined
          readonly idealEmployment?: string | undefined
          readonly isAbleToApply: boolean
          readonly isNeedEmploymentSponsor?: boolean | undefined
          readonly isUsWorkAuthorized?: boolean | undefined
          readonly noWorkExperience?: boolean | undefined
          readonly profileCompletedAt?: any | undefined
          readonly profilePercentComplete?: number | undefined
          readonly relayId: string
          readonly resumeUrl?: string | undefined
          readonly salaryExpectations?: string | undefined
          readonly candidateLicenses?:
            | ReadonlyArray<{
                readonly id: string
                readonly date?: any | undefined
                readonly number?: string | undefined
                readonly url?: string | undefined
                readonly license?:
                  | {
                      readonly id: string
                      readonly name: string
                      readonly country: CountriesEnum
                      readonly state?: string | undefined
                    }
                  | undefined
              }>
            | undefined
          readonly credentials?:
            | ReadonlyArray<{
                readonly id: string
                readonly title: string
                readonly badgeUrl: string
                readonly description?: string | undefined
                readonly training: {
                  readonly id: string
                  readonly trainingUrl: string
                }
              }>
            | undefined
          readonly education?:
            | ReadonlyArray<{
                readonly id: string
                readonly degree?: string | undefined
                readonly educationLevel?: EducationLevelEnum | undefined
                readonly school?: string | undefined
                readonly yearsAttended?: number | undefined
              }>
            | undefined
          readonly experiences?:
            | ReadonlyArray<{
                readonly id: string
                readonly companyName?: string | undefined
                readonly current?: boolean | undefined
                readonly endDate?: any | undefined
                readonly jobTitle?: string | undefined
                readonly responsibilities?: string | undefined
                readonly startDate?: any | undefined
                readonly yearsEmployed?: number | undefined
              }>
            | undefined
          readonly placements?:
            | ReadonlyArray<{
                readonly startDate?: any | undefined
                readonly id: string
                readonly interviewDate?: any | undefined
                readonly status?: PlacementStatusEnum | undefined
                readonly permissions: { readonly update: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly slug: string
                  readonly title: string
                  readonly client?: { readonly displayname: string } | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                  }
                }
              }>
            | undefined
          readonly jobApplications?:
            | ReadonlyArray<{
                readonly id: string
                readonly status?: JobApplicationStatusEnum | undefined
                readonly permissions: { readonly show: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly level?: number | undefined
                  readonly slug: string
                  readonly title: string
                  readonly client?:
                    | { readonly displayname: string; readonly name: string }
                    | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                    readonly managePlacements: boolean
                  }
                  readonly jobPostingScreening?:
                    | { readonly id: string }
                    | undefined
                }
                readonly screeningSubmissions?:
                  | ReadonlyArray<{ readonly id: string }>
                  | undefined
              }>
            | undefined
          readonly permissions: {
            readonly edit: boolean
            readonly readApplications: boolean
            readonly readCredentials: boolean
            readonly readLicense: boolean
            readonly readResume: boolean
            readonly readWorkPreferences: boolean
          }
          readonly recruiters?:
            | ReadonlyArray<{
                readonly avatarUrl?: string | undefined
                readonly firstName: string
                readonly id: string
                readonly lastName: string
              }>
            | undefined
          readonly skillRelations?:
            | ReadonlyArray<{
                readonly id: string
                readonly years: number
                readonly skill: {
                  readonly __typename: 'Skill'
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly summary?:
            | {
                readonly id: string
                readonly entry: string
                readonly title: string
              }
            | undefined
        }
      | undefined
    readonly subscription?:
      | {
          readonly __typename: 'Subscription'
          readonly id: string
          readonly active: boolean
          readonly plan: string
        }
      | undefined
  }
}

export type MemberAlertsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  username: Scalars['String']['input']
}>

export type MemberAlertsQuery = {
  readonly getUser: {
    readonly id: string
    readonly username: string
    readonly alerts?:
      | {
          readonly edges?:
            | ReadonlyArray<
                | {
                    readonly __typename: 'ActivityEdge'
                    readonly cursor: string
                    readonly node?:
                      | {
                          readonly id: string
                          readonly alert?: boolean | undefined
                          readonly body?: string | undefined
                          readonly createdAt: any
                          readonly jsonBody?: any | undefined
                          readonly recipientRead?: any | undefined
                          readonly updatedAt: any
                          readonly author?:
                            | {
                                readonly id: string
                                readonly avatarUrl?: string | undefined
                                readonly firstName: string
                                readonly lastName: string
                                readonly uri: string
                                readonly username: string
                              }
                            | undefined
                          readonly kontext?:
                            | {
                                readonly __typename: 'ChatMessage'
                                readonly id: string
                                readonly sender: { readonly username: string }
                              }
                            | {
                                readonly __typename: 'JobApplication'
                                readonly id: string
                                readonly uri: string
                                readonly jobPosting: {
                                  readonly id: string
                                  readonly slug: string
                                  readonly client?:
                                    | { readonly displayname: string }
                                    | undefined
                                }
                                readonly user?:
                                  | {
                                      readonly id: string
                                      readonly username: string
                                    }
                                  | undefined
                              }
                            | {
                                readonly __typename: 'JobPosting'
                                readonly id: string
                                readonly slug: string
                                readonly uri: string
                                readonly client?:
                                  | {
                                      readonly id: string
                                      readonly displayname: string
                                    }
                                  | undefined
                              }
                            | {
                                readonly __typename: 'Placement'
                                readonly id: string
                                readonly uri: string
                                readonly updatedAt: any
                                readonly jobPosting: {
                                  readonly id: string
                                  readonly slug: string
                                  readonly client?:
                                    | {
                                        readonly id: string
                                        readonly displayname: string
                                      }
                                    | undefined
                                }
                                readonly user?:
                                  | {
                                      readonly id: string
                                      readonly username: string
                                    }
                                  | undefined
                              }
                            | {
                                readonly __typename: 'User'
                                readonly id: string
                                readonly username: string
                                readonly uri: string
                              }
                            | {}
                            | undefined
                          readonly resource:
                            | {
                                readonly __typename: 'Client'
                                readonly id: string
                                readonly displayname: string
                                readonly uri: string
                              }
                            | { readonly __typename: 'GigsEmployee' }
                            | {
                                readonly __typename: 'JobApplication'
                                readonly id: string
                                readonly uri: string
                                readonly jobPosting: {
                                  readonly id: string
                                  readonly slug: string
                                  readonly client?:
                                    | { readonly displayname: string }
                                    | undefined
                                }
                                readonly user?:
                                  | {
                                      readonly id: string
                                      readonly username: string
                                    }
                                  | undefined
                              }
                            | {
                                readonly __typename: 'JobPosting'
                                readonly id: string
                                readonly slug: string
                                readonly uri: string
                                readonly client?:
                                  | {
                                      readonly id: string
                                      readonly displayname: string
                                    }
                                  | undefined
                              }
                            | {
                                readonly __typename: 'Placement'
                                readonly id: string
                                readonly uri: string
                                readonly updatedAt: any
                                readonly jobPosting: {
                                  readonly id: string
                                  readonly slug: string
                                  readonly client?:
                                    | {
                                        readonly id: string
                                        readonly displayname: string
                                      }
                                    | undefined
                                }
                                readonly user?:
                                  | {
                                      readonly id: string
                                      readonly username: string
                                    }
                                  | undefined
                              }
                            | {
                                readonly __typename: 'User'
                                readonly id: string
                                readonly username: string
                                readonly uri: string
                              }
                        }
                      | undefined
                  }
                | undefined
              >
            | undefined
          readonly pageInfo: {
            readonly endCursor?: string | undefined
            readonly hasNextPage: boolean
            readonly hasPreviousPage: boolean
            readonly startCursor?: string | undefined
            readonly totalCount: number
          }
        }
      | undefined
  }
}

export type MemberActivitiesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  username: Scalars['String']['input']
  notes?: InputMaybe<Scalars['Boolean']['input']>
}>

export type MemberActivitiesQuery = {
  readonly getUser: {
    readonly id: string
    readonly username: string
    readonly activities?:
      | {
          readonly edges?:
            | ReadonlyArray<
                | {
                    readonly __typename: 'ActivityEdge'
                    readonly cursor: string
                    readonly node?:
                      | {
                          readonly id: string
                          readonly alert?: boolean | undefined
                          readonly body?: string | undefined
                          readonly createdAt: any
                          readonly jsonBody?: any | undefined
                          readonly recipientRead?: any | undefined
                          readonly updatedAt: any
                          readonly author?:
                            | {
                                readonly id: string
                                readonly avatarUrl?: string | undefined
                                readonly firstName: string
                                readonly lastName: string
                                readonly uri: string
                                readonly username: string
                              }
                            | undefined
                          readonly kontext?:
                            | {
                                readonly __typename: 'ChatMessage'
                                readonly id: string
                                readonly sender: { readonly username: string }
                              }
                            | {
                                readonly __typename: 'JobApplication'
                                readonly id: string
                                readonly uri: string
                                readonly jobPosting: {
                                  readonly id: string
                                  readonly slug: string
                                  readonly client?:
                                    | { readonly displayname: string }
                                    | undefined
                                }
                                readonly user?:
                                  | {
                                      readonly id: string
                                      readonly username: string
                                    }
                                  | undefined
                              }
                            | {
                                readonly __typename: 'JobPosting'
                                readonly id: string
                                readonly slug: string
                                readonly uri: string
                                readonly client?:
                                  | {
                                      readonly id: string
                                      readonly displayname: string
                                    }
                                  | undefined
                              }
                            | {
                                readonly __typename: 'Placement'
                                readonly id: string
                                readonly uri: string
                                readonly updatedAt: any
                                readonly jobPosting: {
                                  readonly id: string
                                  readonly slug: string
                                  readonly client?:
                                    | {
                                        readonly id: string
                                        readonly displayname: string
                                      }
                                    | undefined
                                }
                                readonly user?:
                                  | {
                                      readonly id: string
                                      readonly username: string
                                    }
                                  | undefined
                              }
                            | {
                                readonly __typename: 'User'
                                readonly id: string
                                readonly username: string
                                readonly uri: string
                              }
                            | {}
                            | undefined
                          readonly resource:
                            | {
                                readonly __typename: 'Client'
                                readonly id: string
                                readonly displayname: string
                                readonly uri: string
                              }
                            | { readonly __typename: 'GigsEmployee' }
                            | {
                                readonly __typename: 'JobApplication'
                                readonly id: string
                                readonly uri: string
                                readonly jobPosting: {
                                  readonly id: string
                                  readonly slug: string
                                  readonly client?:
                                    | { readonly displayname: string }
                                    | undefined
                                }
                                readonly user?:
                                  | {
                                      readonly id: string
                                      readonly username: string
                                    }
                                  | undefined
                              }
                            | {
                                readonly __typename: 'JobPosting'
                                readonly id: string
                                readonly slug: string
                                readonly uri: string
                                readonly client?:
                                  | {
                                      readonly id: string
                                      readonly displayname: string
                                    }
                                  | undefined
                              }
                            | {
                                readonly __typename: 'Placement'
                                readonly id: string
                                readonly uri: string
                                readonly updatedAt: any
                                readonly jobPosting: {
                                  readonly id: string
                                  readonly slug: string
                                  readonly client?:
                                    | {
                                        readonly id: string
                                        readonly displayname: string
                                      }
                                    | undefined
                                }
                                readonly user?:
                                  | {
                                      readonly id: string
                                      readonly username: string
                                    }
                                  | undefined
                              }
                            | {
                                readonly __typename: 'User'
                                readonly id: string
                                readonly username: string
                                readonly uri: string
                              }
                        }
                      | undefined
                  }
                | undefined
              >
            | undefined
          readonly pageInfo: {
            readonly endCursor?: string | undefined
            readonly hasNextPage: boolean
            readonly hasPreviousPage: boolean
            readonly startCursor?: string | undefined
            readonly totalCount: number
          }
        }
      | undefined
  }
}

export type MemberEditQueryVariables = Exact<{
  username: Scalars['String']['input']
}>

export type MemberEditQuery = {
  readonly getUser: {
    readonly id: string
    readonly availability?: string | undefined
    readonly avatarUrl?: string | undefined
    readonly email?: string | undefined
    readonly secondaryEmail?: string | undefined
    readonly firstName: string
    readonly lastName: string
    readonly phoneNumber?: string | undefined
    readonly social?:
      | {
          readonly calendly?: string | undefined
          readonly linkedin?: string | undefined
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly candidate?:
      | {
          readonly backgroundCheckDate?: any | undefined
          readonly dnu?: string | undefined
          readonly hiringStatus?: HiringStatusEnum | undefined
          readonly i9Date?: any | undefined
          readonly idealEmployment?: string | undefined
          readonly isNeedEmploymentSponsor?: boolean | undefined
          readonly isUsWorkAuthorized?: boolean | undefined
          readonly noWorkExperience?: boolean | undefined
          readonly profilePercentComplete?: number | undefined
          readonly resumeUrl?: string | undefined
          readonly salaryExpectations?: string | undefined
          readonly candidateLicenses?:
            | ReadonlyArray<{
                readonly id: string
                readonly date?: any | undefined
                readonly number?: string | undefined
                readonly url?: string | undefined
                readonly license?:
                  | {
                      readonly id: string
                      readonly name: string
                      readonly country: CountriesEnum
                      readonly state?: string | undefined
                    }
                  | undefined
              }>
            | undefined
          readonly education?:
            | ReadonlyArray<{
                readonly id: string
                readonly degree?: string | undefined
                readonly educationLevel?: EducationLevelEnum | undefined
                readonly school?: string | undefined
                readonly yearsAttended?: number | undefined
              }>
            | undefined
          readonly experiences?:
            | ReadonlyArray<{
                readonly id: string
                readonly companyName?: string | undefined
                readonly current?: boolean | undefined
                readonly endDate?: any | undefined
                readonly jobTitle?: string | undefined
                readonly responsibilities?: string | undefined
                readonly startDate?: any | undefined
                readonly yearsEmployed?: number | undefined
              }>
            | undefined
          readonly recruiters?:
            | ReadonlyArray<{
                readonly avatarUrl?: string | undefined
                readonly firstName: string
                readonly id: string
                readonly lastName: string
              }>
            | undefined
          readonly skillRelations?:
            | ReadonlyArray<{
                readonly id: string
                readonly years: number
                readonly skill: {
                  readonly __typename: 'Skill'
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly summary?:
            | {
                readonly id: string
                readonly entry: string
                readonly title: string
              }
            | undefined
        }
      | undefined
  }
}

export type MemberConnectionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  connectionResourceType?: InputMaybe<ConnectionActorEnum>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<ConnectionStatusFilterEnum>
  username: Scalars['String']['input']
}>

export type MemberConnectionsQuery = {
  readonly getUser: {
    readonly connectionCount: number
    readonly connections: {
      readonly edges?:
        | ReadonlyArray<
            | {
                readonly cursor: string
                readonly node?:
                  | {
                      readonly __typename: 'Client'
                      readonly id: string
                      readonly billingAddress?: string | undefined
                      readonly accountsPayableEmail?: string | undefined
                      readonly displayname: string
                      readonly avatarUrl?: string | undefined
                      readonly companySize?: CompanySizeEnum | undefined
                      readonly connectionStatus?:
                        | ConnectionStatusEnum
                        | undefined
                      readonly countAvailablePositions: number
                      readonly countRecentPositions: number
                      readonly headline: string
                      readonly metaDescription: string
                      readonly metaTitle: string
                      readonly name: string
                      readonly profileComplete: boolean
                      readonly profileCompletedAt?: any | undefined
                      readonly uri: string
                      readonly visibleOnPlatform: boolean
                      readonly website?: string | undefined
                      readonly companyDescription?: string | undefined
                      readonly companyEmploymentBenefits?:
                        | ReadonlyArray<{
                            readonly id: string
                            readonly employmentBenefit: {
                              readonly icon: string
                              readonly id: string
                              readonly name: string
                            }
                          }>
                        | undefined
                      readonly companyLocations?:
                        | ReadonlyArray<{
                            readonly address?: string | undefined
                            readonly addressExtended?: string | undefined
                            readonly city?: string | undefined
                            readonly country?: CountriesEnum | undefined
                            readonly latitude?: number | undefined
                            readonly longitude?: number | undefined
                            readonly postalCode?: string | undefined
                            readonly rawLocation?: string | undefined
                            readonly state?: StatesEnum | undefined
                          }>
                        | undefined
                      readonly companyPhotos?:
                        | ReadonlyArray<{
                            readonly id: string
                            readonly alt?: string | undefined
                            readonly displayRole?:
                              | CompanyPhotoDisplayRoleEnum
                              | undefined
                            readonly mediaType?:
                              | CompanyPhotoMediaTypeEnum
                              | undefined
                            readonly url: string
                          }>
                        | undefined
                      readonly companyValues?:
                        | ReadonlyArray<{
                            readonly id: string
                            readonly description: string
                            readonly title: string
                          }>
                        | undefined
                      readonly location: {
                        readonly address?: string | undefined
                        readonly addressExtended?: string | undefined
                        readonly city?: string | undefined
                        readonly country?: CountriesEnum | undefined
                        readonly latitude?: number | undefined
                        readonly longitude?: number | undefined
                        readonly postalCode?: string | undefined
                        readonly rawLocation?: string | undefined
                        readonly state?: StatesEnum | undefined
                      }
                      readonly permissions: {
                        readonly createJobPosting: boolean
                        readonly edit: boolean
                        readonly editMeta: boolean
                        readonly internalUser: boolean
                        readonly readPendingBanner: boolean
                        readonly toggleVisible: boolean
                      }
                      readonly social?:
                        | {
                            readonly facebook?: string | undefined
                            readonly instagram?: string | undefined
                            readonly linkedin?: string | undefined
                            readonly twitter?: string | undefined
                          }
                        | undefined
                      readonly trainings: {
                        readonly pageInfo: { readonly totalCount: number }
                      }
                    }
                  | {
                      readonly __typename: 'User'
                      readonly id: string
                      readonly username: string
                      readonly availability?: string | undefined
                      readonly avatarUrl?: string | undefined
                      readonly connectionCount: number
                      readonly connectionStatus?:
                        | ConnectionStatusEnum
                        | undefined
                      readonly email?: string | undefined
                      readonly secondaryEmail?: string | undefined
                      readonly firstName: string
                      readonly indispensableSurveyLink: string
                      readonly isCurrentUser: boolean
                      readonly lastName: string
                      readonly termsAcceptedAt?: any | undefined
                      readonly phoneNumber?: string | undefined
                      readonly uri: string
                      readonly activities?:
                        | { readonly pageInfo: { readonly totalCount: number } }
                        | undefined
                      readonly alerts?:
                        | { readonly pageInfo: { readonly totalCount: number } }
                        | undefined
                      readonly gigsEmployee?:
                        | {
                            readonly id: string
                            readonly createdAt: any
                            readonly deletedAt?: any | undefined
                            readonly eligibleAt?: any | undefined
                            readonly offboardedAt?: any | undefined
                            readonly onboardedAt?: any | undefined
                            readonly onboardingStatus: OnboardingStatusEnum
                            readonly percentComplete?: number | undefined
                            readonly rejectedAt?: any | undefined
                            readonly savedAt?: any | undefined
                            readonly screeningAt?: any | undefined
                            readonly terminatedAt?: any | undefined
                            readonly updatedAt: any
                            readonly permissions: {
                              readonly seeHistory: boolean
                            }
                          }
                        | undefined
                      readonly location: {
                        readonly address?: string | undefined
                        readonly addressExtended?: string | undefined
                        readonly city?: string | undefined
                        readonly country?: CountriesEnum | undefined
                        readonly latitude?: number | undefined
                        readonly longitude?: number | undefined
                        readonly postalCode?: string | undefined
                        readonly rawLocation?: string | undefined
                        readonly state?: StatesEnum | undefined
                      }
                      readonly permissions: {
                        readonly applyToJobs: boolean
                        readonly edit: boolean
                        readonly hasRecruiterLabel: boolean
                        readonly imposter: boolean
                        readonly internalUser: boolean
                        readonly publishJobOrders: boolean
                        readonly readEmail: boolean
                        readonly readJobBooster: boolean
                        readonly readNotes: boolean
                        readonly readPhone: boolean
                        readonly triggerIndispensableSurvey: boolean
                        readonly searchCandidates: boolean
                        readonly searchCandidatesAsClient: boolean
                        readonly searchCandidatesAsRecruiter: boolean
                        readonly searchClients: boolean
                        readonly searchClientsByRecruiters: boolean
                        readonly searchJobPostings: boolean
                        readonly searchJobPostingsByRecruiter: boolean
                        readonly sendMessage: boolean
                        readonly trainableUser: boolean
                        readonly updateConnectionStatus: boolean
                        readonly uploadCsv: boolean
                        readonly matchCriteria: boolean
                      }
                      readonly social?:
                        | {
                            readonly calendly?: string | undefined
                            readonly linkedin?: string | undefined
                          }
                        | undefined
                      readonly candidate?:
                        | {
                            readonly __typename: 'Candidate'
                            readonly id: string
                            readonly backgroundCheckDate?: any | undefined
                            readonly credentialCount: number
                            readonly dnu?: string | undefined
                            readonly hiringStatus?: HiringStatusEnum | undefined
                            readonly i9Date?: any | undefined
                            readonly idealEmployment?: string | undefined
                            readonly isAbleToApply: boolean
                            readonly isNeedEmploymentSponsor?:
                              | boolean
                              | undefined
                            readonly isUsWorkAuthorized?: boolean | undefined
                            readonly noWorkExperience?: boolean | undefined
                            readonly profileCompletedAt?: any | undefined
                            readonly profilePercentComplete?: number | undefined
                            readonly relayId: string
                            readonly resumeUrl?: string | undefined
                            readonly salaryExpectations?: string | undefined
                            readonly candidateLicenses?:
                              | ReadonlyArray<{
                                  readonly id: string
                                  readonly date?: any | undefined
                                  readonly number?: string | undefined
                                  readonly url?: string | undefined
                                  readonly license?:
                                    | {
                                        readonly id: string
                                        readonly name: string
                                        readonly country: CountriesEnum
                                        readonly state?: string | undefined
                                      }
                                    | undefined
                                }>
                              | undefined
                            readonly credentials?:
                              | ReadonlyArray<{
                                  readonly id: string
                                  readonly title: string
                                  readonly badgeUrl: string
                                  readonly description?: string | undefined
                                  readonly training: {
                                    readonly id: string
                                    readonly trainingUrl: string
                                  }
                                }>
                              | undefined
                            readonly education?:
                              | ReadonlyArray<{
                                  readonly id: string
                                  readonly degree?: string | undefined
                                  readonly educationLevel?:
                                    | EducationLevelEnum
                                    | undefined
                                  readonly school?: string | undefined
                                  readonly yearsAttended?: number | undefined
                                }>
                              | undefined
                            readonly experiences?:
                              | ReadonlyArray<{
                                  readonly id: string
                                  readonly companyName?: string | undefined
                                  readonly current?: boolean | undefined
                                  readonly endDate?: any | undefined
                                  readonly jobTitle?: string | undefined
                                  readonly responsibilities?: string | undefined
                                  readonly startDate?: any | undefined
                                  readonly yearsEmployed?: number | undefined
                                }>
                              | undefined
                            readonly placements?:
                              | ReadonlyArray<{
                                  readonly startDate?: any | undefined
                                  readonly id: string
                                  readonly interviewDate?: any | undefined
                                  readonly status?:
                                    | PlacementStatusEnum
                                    | undefined
                                  readonly permissions: {
                                    readonly update: boolean
                                  }
                                  readonly jobPosting: {
                                    readonly id: string
                                    readonly slug: string
                                    readonly title: string
                                    readonly client?:
                                      | { readonly displayname: string }
                                      | undefined
                                    readonly permissions: {
                                      readonly readJobApps: boolean
                                      readonly readPlacements: boolean
                                    }
                                  }
                                }>
                              | undefined
                            readonly jobApplications?:
                              | ReadonlyArray<{
                                  readonly id: string
                                  readonly status?:
                                    | JobApplicationStatusEnum
                                    | undefined
                                  readonly permissions: {
                                    readonly show: boolean
                                  }
                                  readonly jobPosting: {
                                    readonly id: string
                                    readonly level?: number | undefined
                                    readonly slug: string
                                    readonly title: string
                                    readonly client?:
                                      | {
                                          readonly displayname: string
                                          readonly name: string
                                        }
                                      | undefined
                                    readonly permissions: {
                                      readonly readJobApps: boolean
                                      readonly readPlacements: boolean
                                      readonly managePlacements: boolean
                                    }
                                    readonly jobPostingScreening?:
                                      | { readonly id: string }
                                      | undefined
                                  }
                                  readonly screeningSubmissions?:
                                    | ReadonlyArray<{ readonly id: string }>
                                    | undefined
                                }>
                              | undefined
                            readonly permissions: {
                              readonly edit: boolean
                              readonly readApplications: boolean
                              readonly readCredentials: boolean
                              readonly readLicense: boolean
                              readonly readResume: boolean
                              readonly readWorkPreferences: boolean
                            }
                            readonly recruiters?:
                              | ReadonlyArray<{
                                  readonly avatarUrl?: string | undefined
                                  readonly firstName: string
                                  readonly id: string
                                  readonly lastName: string
                                }>
                              | undefined
                            readonly skillRelations?:
                              | ReadonlyArray<{
                                  readonly id: string
                                  readonly years: number
                                  readonly skill: {
                                    readonly __typename: 'Skill'
                                    readonly id: string
                                    readonly name: string
                                  }
                                }>
                              | undefined
                            readonly summary?:
                              | {
                                  readonly id: string
                                  readonly entry: string
                                  readonly title: string
                                }
                              | undefined
                          }
                        | undefined
                      readonly subscription?:
                        | {
                            readonly __typename: 'Subscription'
                            readonly id: string
                            readonly active: boolean
                            readonly plan: string
                          }
                        | undefined
                    }
                  | undefined
              }
            | undefined
          >
        | undefined
      readonly pageInfo: {
        readonly endCursor?: string | undefined
        readonly hasNextPage: boolean
        readonly hasPreviousPage: boolean
        readonly startCursor?: string | undefined
      }
    }
  }
}

export type MemberJobApplicationsQueryVariables = Exact<{
  username: Scalars['String']['input']
}>

export type MemberJobApplicationsQuery = {
  readonly getUser: {
    readonly candidate?:
      | {
          readonly jobApplications?:
            | ReadonlyArray<{
                readonly __typename: 'JobApplication'
                readonly id: string
                readonly createdAt: any
                readonly clientInterestAt?: any | undefined
                readonly clientInterestMessage: string
                readonly hasClientInterest: boolean
                readonly status?: JobApplicationStatusEnum | undefined
                readonly permissions: { readonly show: boolean }
                readonly jobPosting: {
                  readonly __typename: 'JobPosting'
                  readonly id: string
                  readonly applicationReceived: boolean
                  readonly atsRecordType?: string | undefined
                  readonly description: string
                  readonly employmentTypes?:
                    | ReadonlyArray<EmploymentTypesEnum>
                    | undefined
                  readonly postedAt?: any | undefined
                  readonly slug: string
                  readonly title: string
                  readonly client?:
                    | {
                        readonly __typename: 'Client'
                        readonly id: string
                        readonly displayname: string
                        readonly avatarUrl?: string | undefined
                        readonly connectionStatus?:
                          | ConnectionStatusEnum
                          | undefined
                        readonly description?: string | undefined
                        readonly name: string
                        readonly location: {
                          readonly address?: string | undefined
                          readonly addressExtended?: string | undefined
                          readonly city?: string | undefined
                          readonly country?: CountriesEnum | undefined
                          readonly latitude?: number | undefined
                          readonly longitude?: number | undefined
                          readonly postalCode?: string | undefined
                          readonly rawLocation?: string | undefined
                          readonly state?: StatesEnum | undefined
                        }
                      }
                    | undefined
                  readonly jobPostingScreening?:
                    | {
                        readonly id: string
                        readonly screening?:
                          | {
                              readonly id: string
                              readonly description?: string | undefined
                              readonly name?: string | undefined
                              readonly screeningQuestions?:
                                | ReadonlyArray<{
                                    readonly id: string
                                    readonly typeOf?: string | undefined
                                    readonly question?: string | undefined
                                  }>
                                | undefined
                            }
                          | undefined
                      }
                    | undefined
                  readonly location: {
                    readonly address?: string | undefined
                    readonly addressExtended?: string | undefined
                    readonly city?: string | undefined
                    readonly country?: CountriesEnum | undefined
                    readonly latitude?: number | undefined
                    readonly longitude?: number | undefined
                    readonly postalCode?: string | undefined
                    readonly rawLocation?: string | undefined
                    readonly state?: StatesEnum | undefined
                  }
                  readonly permissions: {
                    readonly destroy: boolean
                    readonly edit: boolean
                    readonly readJobApps: boolean
                  }
                  readonly requiredLicenses: ReadonlyArray<{
                    readonly id: string
                    readonly license: {
                      readonly id: string
                      readonly name: string
                      readonly country: CountriesEnum
                      readonly state?: string | undefined
                    }
                  }>
                }
                readonly screeningSubmissions?:
                  | ReadonlyArray<{
                      readonly id: string
                      readonly jobApplication?:
                        | {
                            readonly id: string
                            readonly jobPosting: {
                              readonly id: string
                              readonly title: string
                              readonly slug: string
                            }
                          }
                        | undefined
                      readonly screeningQResponses?:
                        | ReadonlyArray<{
                            readonly id: string
                            readonly answer?: any | undefined
                            readonly screeningQuestion?:
                              | {
                                  readonly id: string
                                  readonly question?: string | undefined
                                }
                              | undefined
                          }>
                        | undefined
                    }>
                  | undefined
              }>
            | undefined
        }
      | undefined
  }
}

export type AcceptMemberConnectionMutationVariables = Exact<{
  input: AcceptCandidateConnectionInput
}>

export type AcceptMemberConnectionMutation = {
  readonly acceptCandidateConnection: {
    readonly __typename: 'User'
    readonly id: string
    readonly username: string
    readonly availability?: string | undefined
    readonly avatarUrl?: string | undefined
    readonly connectionCount: number
    readonly connectionStatus?: ConnectionStatusEnum | undefined
    readonly email?: string | undefined
    readonly secondaryEmail?: string | undefined
    readonly firstName: string
    readonly indispensableSurveyLink: string
    readonly isCurrentUser: boolean
    readonly lastName: string
    readonly termsAcceptedAt?: any | undefined
    readonly phoneNumber?: string | undefined
    readonly uri: string
    readonly activities?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly alerts?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly gigsEmployee?:
      | {
          readonly id: string
          readonly createdAt: any
          readonly deletedAt?: any | undefined
          readonly eligibleAt?: any | undefined
          readonly offboardedAt?: any | undefined
          readonly onboardedAt?: any | undefined
          readonly onboardingStatus: OnboardingStatusEnum
          readonly percentComplete?: number | undefined
          readonly rejectedAt?: any | undefined
          readonly savedAt?: any | undefined
          readonly screeningAt?: any | undefined
          readonly terminatedAt?: any | undefined
          readonly updatedAt: any
          readonly permissions: { readonly seeHistory: boolean }
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly applyToJobs: boolean
      readonly edit: boolean
      readonly hasRecruiterLabel: boolean
      readonly imposter: boolean
      readonly internalUser: boolean
      readonly publishJobOrders: boolean
      readonly readEmail: boolean
      readonly readJobBooster: boolean
      readonly readNotes: boolean
      readonly readPhone: boolean
      readonly triggerIndispensableSurvey: boolean
      readonly searchCandidates: boolean
      readonly searchCandidatesAsClient: boolean
      readonly searchCandidatesAsRecruiter: boolean
      readonly searchClients: boolean
      readonly searchClientsByRecruiters: boolean
      readonly searchJobPostings: boolean
      readonly searchJobPostingsByRecruiter: boolean
      readonly sendMessage: boolean
      readonly trainableUser: boolean
      readonly updateConnectionStatus: boolean
      readonly uploadCsv: boolean
      readonly matchCriteria: boolean
    }
    readonly social?:
      | {
          readonly calendly?: string | undefined
          readonly linkedin?: string | undefined
        }
      | undefined
    readonly candidate?:
      | {
          readonly __typename: 'Candidate'
          readonly id: string
          readonly backgroundCheckDate?: any | undefined
          readonly credentialCount: number
          readonly dnu?: string | undefined
          readonly hiringStatus?: HiringStatusEnum | undefined
          readonly i9Date?: any | undefined
          readonly idealEmployment?: string | undefined
          readonly isAbleToApply: boolean
          readonly isNeedEmploymentSponsor?: boolean | undefined
          readonly isUsWorkAuthorized?: boolean | undefined
          readonly noWorkExperience?: boolean | undefined
          readonly profileCompletedAt?: any | undefined
          readonly profilePercentComplete?: number | undefined
          readonly relayId: string
          readonly resumeUrl?: string | undefined
          readonly salaryExpectations?: string | undefined
          readonly candidateLicenses?:
            | ReadonlyArray<{
                readonly id: string
                readonly date?: any | undefined
                readonly number?: string | undefined
                readonly url?: string | undefined
                readonly license?:
                  | {
                      readonly id: string
                      readonly name: string
                      readonly country: CountriesEnum
                      readonly state?: string | undefined
                    }
                  | undefined
              }>
            | undefined
          readonly credentials?:
            | ReadonlyArray<{
                readonly id: string
                readonly title: string
                readonly badgeUrl: string
                readonly description?: string | undefined
                readonly training: {
                  readonly id: string
                  readonly trainingUrl: string
                }
              }>
            | undefined
          readonly education?:
            | ReadonlyArray<{
                readonly id: string
                readonly degree?: string | undefined
                readonly educationLevel?: EducationLevelEnum | undefined
                readonly school?: string | undefined
                readonly yearsAttended?: number | undefined
              }>
            | undefined
          readonly experiences?:
            | ReadonlyArray<{
                readonly id: string
                readonly companyName?: string | undefined
                readonly current?: boolean | undefined
                readonly endDate?: any | undefined
                readonly jobTitle?: string | undefined
                readonly responsibilities?: string | undefined
                readonly startDate?: any | undefined
                readonly yearsEmployed?: number | undefined
              }>
            | undefined
          readonly placements?:
            | ReadonlyArray<{
                readonly startDate?: any | undefined
                readonly id: string
                readonly interviewDate?: any | undefined
                readonly status?: PlacementStatusEnum | undefined
                readonly permissions: { readonly update: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly slug: string
                  readonly title: string
                  readonly client?: { readonly displayname: string } | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                  }
                }
              }>
            | undefined
          readonly jobApplications?:
            | ReadonlyArray<{
                readonly id: string
                readonly status?: JobApplicationStatusEnum | undefined
                readonly permissions: { readonly show: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly level?: number | undefined
                  readonly slug: string
                  readonly title: string
                  readonly client?:
                    | { readonly displayname: string; readonly name: string }
                    | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                    readonly managePlacements: boolean
                  }
                  readonly jobPostingScreening?:
                    | { readonly id: string }
                    | undefined
                }
                readonly screeningSubmissions?:
                  | ReadonlyArray<{ readonly id: string }>
                  | undefined
              }>
            | undefined
          readonly permissions: {
            readonly edit: boolean
            readonly readApplications: boolean
            readonly readCredentials: boolean
            readonly readLicense: boolean
            readonly readResume: boolean
            readonly readWorkPreferences: boolean
          }
          readonly recruiters?:
            | ReadonlyArray<{
                readonly avatarUrl?: string | undefined
                readonly firstName: string
                readonly id: string
                readonly lastName: string
              }>
            | undefined
          readonly skillRelations?:
            | ReadonlyArray<{
                readonly id: string
                readonly years: number
                readonly skill: {
                  readonly __typename: 'Skill'
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly summary?:
            | {
                readonly id: string
                readonly entry: string
                readonly title: string
              }
            | undefined
        }
      | undefined
    readonly subscription?:
      | {
          readonly __typename: 'Subscription'
          readonly id: string
          readonly active: boolean
          readonly plan: string
        }
      | undefined
  }
}

export type ApplyToJobMutationVariables = Exact<{
  input: ApplyToJobInput
}>

export type ApplyToJobMutation = {
  readonly applyToJob: {
    readonly __typename: 'JobApplication'
    readonly id: string
    readonly createdAt: any
    readonly clientInterestAt?: any | undefined
    readonly clientInterestMessage: string
    readonly hasClientInterest: boolean
    readonly status?: JobApplicationStatusEnum | undefined
    readonly permissions: { readonly show: boolean }
    readonly jobPosting: {
      readonly __typename: 'JobPosting'
      readonly id: string
      readonly applicationReceived: boolean
      readonly atsRecordType?: string | undefined
      readonly description: string
      readonly employmentTypes?: ReadonlyArray<EmploymentTypesEnum> | undefined
      readonly postedAt?: any | undefined
      readonly slug: string
      readonly title: string
      readonly client?:
        | {
            readonly __typename: 'Client'
            readonly id: string
            readonly displayname: string
            readonly avatarUrl?: string | undefined
            readonly connectionStatus?: ConnectionStatusEnum | undefined
            readonly description?: string | undefined
            readonly name: string
            readonly location: {
              readonly address?: string | undefined
              readonly addressExtended?: string | undefined
              readonly city?: string | undefined
              readonly country?: CountriesEnum | undefined
              readonly latitude?: number | undefined
              readonly longitude?: number | undefined
              readonly postalCode?: string | undefined
              readonly rawLocation?: string | undefined
              readonly state?: StatesEnum | undefined
            }
          }
        | undefined
      readonly jobPostingScreening?:
        | {
            readonly id: string
            readonly screening?:
              | {
                  readonly id: string
                  readonly description?: string | undefined
                  readonly name?: string | undefined
                  readonly screeningQuestions?:
                    | ReadonlyArray<{
                        readonly id: string
                        readonly typeOf?: string | undefined
                        readonly question?: string | undefined
                      }>
                    | undefined
                }
              | undefined
          }
        | undefined
      readonly location: {
        readonly address?: string | undefined
        readonly addressExtended?: string | undefined
        readonly city?: string | undefined
        readonly country?: CountriesEnum | undefined
        readonly latitude?: number | undefined
        readonly longitude?: number | undefined
        readonly postalCode?: string | undefined
        readonly rawLocation?: string | undefined
        readonly state?: StatesEnum | undefined
      }
      readonly permissions: {
        readonly destroy: boolean
        readonly edit: boolean
        readonly readJobApps: boolean
      }
      readonly requiredLicenses: ReadonlyArray<{
        readonly id: string
        readonly license: {
          readonly id: string
          readonly name: string
          readonly country: CountriesEnum
          readonly state?: string | undefined
        }
      }>
    }
    readonly screeningSubmissions?:
      | ReadonlyArray<{
          readonly id: string
          readonly jobApplication?:
            | {
                readonly id: string
                readonly jobPosting: {
                  readonly id: string
                  readonly title: string
                  readonly slug: string
                }
              }
            | undefined
          readonly screeningQResponses?:
            | ReadonlyArray<{
                readonly id: string
                readonly answer?: any | undefined
                readonly screeningQuestion?:
                  | {
                      readonly id: string
                      readonly question?: string | undefined
                    }
                  | undefined
              }>
            | undefined
        }>
      | undefined
  }
}

export type ConnectWithMemberMutationVariables = Exact<{
  input: ConnectWithCandidateInput
}>

export type ConnectWithMemberMutation = {
  readonly connectWithCandidate: {
    readonly __typename: 'User'
    readonly id: string
    readonly username: string
    readonly availability?: string | undefined
    readonly avatarUrl?: string | undefined
    readonly connectionCount: number
    readonly connectionStatus?: ConnectionStatusEnum | undefined
    readonly email?: string | undefined
    readonly secondaryEmail?: string | undefined
    readonly firstName: string
    readonly indispensableSurveyLink: string
    readonly isCurrentUser: boolean
    readonly lastName: string
    readonly termsAcceptedAt?: any | undefined
    readonly phoneNumber?: string | undefined
    readonly uri: string
    readonly activities?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly alerts?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly gigsEmployee?:
      | {
          readonly id: string
          readonly createdAt: any
          readonly deletedAt?: any | undefined
          readonly eligibleAt?: any | undefined
          readonly offboardedAt?: any | undefined
          readonly onboardedAt?: any | undefined
          readonly onboardingStatus: OnboardingStatusEnum
          readonly percentComplete?: number | undefined
          readonly rejectedAt?: any | undefined
          readonly savedAt?: any | undefined
          readonly screeningAt?: any | undefined
          readonly terminatedAt?: any | undefined
          readonly updatedAt: any
          readonly permissions: { readonly seeHistory: boolean }
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly applyToJobs: boolean
      readonly edit: boolean
      readonly hasRecruiterLabel: boolean
      readonly imposter: boolean
      readonly internalUser: boolean
      readonly publishJobOrders: boolean
      readonly readEmail: boolean
      readonly readJobBooster: boolean
      readonly readNotes: boolean
      readonly readPhone: boolean
      readonly triggerIndispensableSurvey: boolean
      readonly searchCandidates: boolean
      readonly searchCandidatesAsClient: boolean
      readonly searchCandidatesAsRecruiter: boolean
      readonly searchClients: boolean
      readonly searchClientsByRecruiters: boolean
      readonly searchJobPostings: boolean
      readonly searchJobPostingsByRecruiter: boolean
      readonly sendMessage: boolean
      readonly trainableUser: boolean
      readonly updateConnectionStatus: boolean
      readonly uploadCsv: boolean
      readonly matchCriteria: boolean
    }
    readonly social?:
      | {
          readonly calendly?: string | undefined
          readonly linkedin?: string | undefined
        }
      | undefined
    readonly candidate?:
      | {
          readonly __typename: 'Candidate'
          readonly id: string
          readonly backgroundCheckDate?: any | undefined
          readonly credentialCount: number
          readonly dnu?: string | undefined
          readonly hiringStatus?: HiringStatusEnum | undefined
          readonly i9Date?: any | undefined
          readonly idealEmployment?: string | undefined
          readonly isAbleToApply: boolean
          readonly isNeedEmploymentSponsor?: boolean | undefined
          readonly isUsWorkAuthorized?: boolean | undefined
          readonly noWorkExperience?: boolean | undefined
          readonly profileCompletedAt?: any | undefined
          readonly profilePercentComplete?: number | undefined
          readonly relayId: string
          readonly resumeUrl?: string | undefined
          readonly salaryExpectations?: string | undefined
          readonly candidateLicenses?:
            | ReadonlyArray<{
                readonly id: string
                readonly date?: any | undefined
                readonly number?: string | undefined
                readonly url?: string | undefined
                readonly license?:
                  | {
                      readonly id: string
                      readonly name: string
                      readonly country: CountriesEnum
                      readonly state?: string | undefined
                    }
                  | undefined
              }>
            | undefined
          readonly credentials?:
            | ReadonlyArray<{
                readonly id: string
                readonly title: string
                readonly badgeUrl: string
                readonly description?: string | undefined
                readonly training: {
                  readonly id: string
                  readonly trainingUrl: string
                }
              }>
            | undefined
          readonly education?:
            | ReadonlyArray<{
                readonly id: string
                readonly degree?: string | undefined
                readonly educationLevel?: EducationLevelEnum | undefined
                readonly school?: string | undefined
                readonly yearsAttended?: number | undefined
              }>
            | undefined
          readonly experiences?:
            | ReadonlyArray<{
                readonly id: string
                readonly companyName?: string | undefined
                readonly current?: boolean | undefined
                readonly endDate?: any | undefined
                readonly jobTitle?: string | undefined
                readonly responsibilities?: string | undefined
                readonly startDate?: any | undefined
                readonly yearsEmployed?: number | undefined
              }>
            | undefined
          readonly placements?:
            | ReadonlyArray<{
                readonly startDate?: any | undefined
                readonly id: string
                readonly interviewDate?: any | undefined
                readonly status?: PlacementStatusEnum | undefined
                readonly permissions: { readonly update: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly slug: string
                  readonly title: string
                  readonly client?: { readonly displayname: string } | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                  }
                }
              }>
            | undefined
          readonly jobApplications?:
            | ReadonlyArray<{
                readonly id: string
                readonly status?: JobApplicationStatusEnum | undefined
                readonly permissions: { readonly show: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly level?: number | undefined
                  readonly slug: string
                  readonly title: string
                  readonly client?:
                    | { readonly displayname: string; readonly name: string }
                    | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                    readonly managePlacements: boolean
                  }
                  readonly jobPostingScreening?:
                    | { readonly id: string }
                    | undefined
                }
                readonly screeningSubmissions?:
                  | ReadonlyArray<{ readonly id: string }>
                  | undefined
              }>
            | undefined
          readonly permissions: {
            readonly edit: boolean
            readonly readApplications: boolean
            readonly readCredentials: boolean
            readonly readLicense: boolean
            readonly readResume: boolean
            readonly readWorkPreferences: boolean
          }
          readonly recruiters?:
            | ReadonlyArray<{
                readonly avatarUrl?: string | undefined
                readonly firstName: string
                readonly id: string
                readonly lastName: string
              }>
            | undefined
          readonly skillRelations?:
            | ReadonlyArray<{
                readonly id: string
                readonly years: number
                readonly skill: {
                  readonly __typename: 'Skill'
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly summary?:
            | {
                readonly id: string
                readonly entry: string
                readonly title: string
              }
            | undefined
        }
      | undefined
    readonly subscription?:
      | {
          readonly __typename: 'Subscription'
          readonly id: string
          readonly active: boolean
          readonly plan: string
        }
      | undefined
  }
}

export type CreateScreeningSubmissionMutationVariables = Exact<{
  input: CreateScreeningSubmissionInput
}>

export type CreateScreeningSubmissionMutation = {
  readonly createScreeningSubmission?:
    | {
        readonly id: string
        readonly jobApplication?:
          | {
              readonly id: string
              readonly jobPosting: {
                readonly id: string
                readonly title: string
                readonly slug: string
              }
            }
          | undefined
        readonly screeningQResponses?:
          | ReadonlyArray<{
              readonly id: string
              readonly answer?: any | undefined
              readonly screeningQuestion?:
                | {
                    readonly id: string
                    readonly question?: string | undefined
                  }
                | undefined
            }>
          | undefined
      }
    | undefined
}

export type CreateActivityMutationVariables = Exact<{
  input: CreateActivityInput
}>

export type CreateActivityMutation = {
  readonly createActivity?:
    | {
        readonly id: string
        readonly alert?: boolean | undefined
        readonly body?: string | undefined
        readonly createdAt: any
        readonly jsonBody?: any | undefined
        readonly recipientRead?: any | undefined
        readonly updatedAt: any
        readonly author?:
          | {
              readonly id: string
              readonly avatarUrl?: string | undefined
              readonly firstName: string
              readonly lastName: string
              readonly uri: string
              readonly username: string
            }
          | undefined
        readonly kontext?:
          | {
              readonly __typename: 'ChatMessage'
              readonly id: string
              readonly sender: { readonly username: string }
            }
          | {
              readonly __typename: 'JobApplication'
              readonly id: string
              readonly uri: string
              readonly jobPosting: {
                readonly id: string
                readonly slug: string
                readonly client?: { readonly displayname: string } | undefined
              }
              readonly user?:
                | { readonly id: string; readonly username: string }
                | undefined
            }
          | {
              readonly __typename: 'JobPosting'
              readonly id: string
              readonly slug: string
              readonly uri: string
              readonly client?:
                | { readonly id: string; readonly displayname: string }
                | undefined
            }
          | {
              readonly __typename: 'Placement'
              readonly id: string
              readonly uri: string
              readonly updatedAt: any
              readonly jobPosting: {
                readonly id: string
                readonly slug: string
                readonly client?:
                  | { readonly id: string; readonly displayname: string }
                  | undefined
              }
              readonly user?:
                | { readonly id: string; readonly username: string }
                | undefined
            }
          | {
              readonly __typename: 'User'
              readonly id: string
              readonly username: string
              readonly uri: string
            }
          | {}
          | undefined
        readonly resource:
          | {
              readonly __typename: 'Client'
              readonly id: string
              readonly displayname: string
              readonly uri: string
            }
          | { readonly __typename: 'GigsEmployee' }
          | {
              readonly __typename: 'JobApplication'
              readonly id: string
              readonly uri: string
              readonly jobPosting: {
                readonly id: string
                readonly slug: string
                readonly client?: { readonly displayname: string } | undefined
              }
              readonly user?:
                | { readonly id: string; readonly username: string }
                | undefined
            }
          | {
              readonly __typename: 'JobPosting'
              readonly id: string
              readonly slug: string
              readonly uri: string
              readonly client?:
                | { readonly id: string; readonly displayname: string }
                | undefined
            }
          | {
              readonly __typename: 'Placement'
              readonly id: string
              readonly uri: string
              readonly updatedAt: any
              readonly jobPosting: {
                readonly id: string
                readonly slug: string
                readonly client?:
                  | { readonly id: string; readonly displayname: string }
                  | undefined
              }
              readonly user?:
                | { readonly id: string; readonly username: string }
                | undefined
            }
          | {
              readonly __typename: 'User'
              readonly id: string
              readonly username: string
              readonly uri: string
            }
      }
    | undefined
}

export type CreateNoteMutationVariables = Exact<{
  input: CreateNoteInput
}>

export type CreateNoteMutation = {
  readonly createNote?: { readonly id: string } | undefined
}

export type DeclineMemberConnectionMutationVariables = Exact<{
  input: DeclineCandidateConnectionInput
}>

export type DeclineMemberConnectionMutation = {
  readonly declineCandidateConnection: {
    readonly __typename: 'User'
    readonly id: string
    readonly username: string
    readonly availability?: string | undefined
    readonly avatarUrl?: string | undefined
    readonly connectionCount: number
    readonly connectionStatus?: ConnectionStatusEnum | undefined
    readonly email?: string | undefined
    readonly secondaryEmail?: string | undefined
    readonly firstName: string
    readonly indispensableSurveyLink: string
    readonly isCurrentUser: boolean
    readonly lastName: string
    readonly termsAcceptedAt?: any | undefined
    readonly phoneNumber?: string | undefined
    readonly uri: string
    readonly activities?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly alerts?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly gigsEmployee?:
      | {
          readonly id: string
          readonly createdAt: any
          readonly deletedAt?: any | undefined
          readonly eligibleAt?: any | undefined
          readonly offboardedAt?: any | undefined
          readonly onboardedAt?: any | undefined
          readonly onboardingStatus: OnboardingStatusEnum
          readonly percentComplete?: number | undefined
          readonly rejectedAt?: any | undefined
          readonly savedAt?: any | undefined
          readonly screeningAt?: any | undefined
          readonly terminatedAt?: any | undefined
          readonly updatedAt: any
          readonly permissions: { readonly seeHistory: boolean }
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly applyToJobs: boolean
      readonly edit: boolean
      readonly hasRecruiterLabel: boolean
      readonly imposter: boolean
      readonly internalUser: boolean
      readonly publishJobOrders: boolean
      readonly readEmail: boolean
      readonly readJobBooster: boolean
      readonly readNotes: boolean
      readonly readPhone: boolean
      readonly triggerIndispensableSurvey: boolean
      readonly searchCandidates: boolean
      readonly searchCandidatesAsClient: boolean
      readonly searchCandidatesAsRecruiter: boolean
      readonly searchClients: boolean
      readonly searchClientsByRecruiters: boolean
      readonly searchJobPostings: boolean
      readonly searchJobPostingsByRecruiter: boolean
      readonly sendMessage: boolean
      readonly trainableUser: boolean
      readonly updateConnectionStatus: boolean
      readonly uploadCsv: boolean
      readonly matchCriteria: boolean
    }
    readonly social?:
      | {
          readonly calendly?: string | undefined
          readonly linkedin?: string | undefined
        }
      | undefined
    readonly candidate?:
      | {
          readonly __typename: 'Candidate'
          readonly id: string
          readonly backgroundCheckDate?: any | undefined
          readonly credentialCount: number
          readonly dnu?: string | undefined
          readonly hiringStatus?: HiringStatusEnum | undefined
          readonly i9Date?: any | undefined
          readonly idealEmployment?: string | undefined
          readonly isAbleToApply: boolean
          readonly isNeedEmploymentSponsor?: boolean | undefined
          readonly isUsWorkAuthorized?: boolean | undefined
          readonly noWorkExperience?: boolean | undefined
          readonly profileCompletedAt?: any | undefined
          readonly profilePercentComplete?: number | undefined
          readonly relayId: string
          readonly resumeUrl?: string | undefined
          readonly salaryExpectations?: string | undefined
          readonly candidateLicenses?:
            | ReadonlyArray<{
                readonly id: string
                readonly date?: any | undefined
                readonly number?: string | undefined
                readonly url?: string | undefined
                readonly license?:
                  | {
                      readonly id: string
                      readonly name: string
                      readonly country: CountriesEnum
                      readonly state?: string | undefined
                    }
                  | undefined
              }>
            | undefined
          readonly credentials?:
            | ReadonlyArray<{
                readonly id: string
                readonly title: string
                readonly badgeUrl: string
                readonly description?: string | undefined
                readonly training: {
                  readonly id: string
                  readonly trainingUrl: string
                }
              }>
            | undefined
          readonly education?:
            | ReadonlyArray<{
                readonly id: string
                readonly degree?: string | undefined
                readonly educationLevel?: EducationLevelEnum | undefined
                readonly school?: string | undefined
                readonly yearsAttended?: number | undefined
              }>
            | undefined
          readonly experiences?:
            | ReadonlyArray<{
                readonly id: string
                readonly companyName?: string | undefined
                readonly current?: boolean | undefined
                readonly endDate?: any | undefined
                readonly jobTitle?: string | undefined
                readonly responsibilities?: string | undefined
                readonly startDate?: any | undefined
                readonly yearsEmployed?: number | undefined
              }>
            | undefined
          readonly placements?:
            | ReadonlyArray<{
                readonly startDate?: any | undefined
                readonly id: string
                readonly interviewDate?: any | undefined
                readonly status?: PlacementStatusEnum | undefined
                readonly permissions: { readonly update: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly slug: string
                  readonly title: string
                  readonly client?: { readonly displayname: string } | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                  }
                }
              }>
            | undefined
          readonly jobApplications?:
            | ReadonlyArray<{
                readonly id: string
                readonly status?: JobApplicationStatusEnum | undefined
                readonly permissions: { readonly show: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly level?: number | undefined
                  readonly slug: string
                  readonly title: string
                  readonly client?:
                    | { readonly displayname: string; readonly name: string }
                    | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                    readonly managePlacements: boolean
                  }
                  readonly jobPostingScreening?:
                    | { readonly id: string }
                    | undefined
                }
                readonly screeningSubmissions?:
                  | ReadonlyArray<{ readonly id: string }>
                  | undefined
              }>
            | undefined
          readonly permissions: {
            readonly edit: boolean
            readonly readApplications: boolean
            readonly readCredentials: boolean
            readonly readLicense: boolean
            readonly readResume: boolean
            readonly readWorkPreferences: boolean
          }
          readonly recruiters?:
            | ReadonlyArray<{
                readonly avatarUrl?: string | undefined
                readonly firstName: string
                readonly id: string
                readonly lastName: string
              }>
            | undefined
          readonly skillRelations?:
            | ReadonlyArray<{
                readonly id: string
                readonly years: number
                readonly skill: {
                  readonly __typename: 'Skill'
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly summary?:
            | {
                readonly id: string
                readonly entry: string
                readonly title: string
              }
            | undefined
        }
      | undefined
    readonly subscription?:
      | {
          readonly __typename: 'Subscription'
          readonly id: string
          readonly active: boolean
          readonly plan: string
        }
      | undefined
  }
}

export type DisconnectWithMemberMutationVariables = Exact<{
  input: DisconnectWithCandidateInput
}>

export type DisconnectWithMemberMutation = {
  readonly disconnectWithCandidate: {
    readonly __typename: 'User'
    readonly id: string
    readonly username: string
    readonly availability?: string | undefined
    readonly avatarUrl?: string | undefined
    readonly connectionCount: number
    readonly connectionStatus?: ConnectionStatusEnum | undefined
    readonly email?: string | undefined
    readonly secondaryEmail?: string | undefined
    readonly firstName: string
    readonly indispensableSurveyLink: string
    readonly isCurrentUser: boolean
    readonly lastName: string
    readonly termsAcceptedAt?: any | undefined
    readonly phoneNumber?: string | undefined
    readonly uri: string
    readonly activities?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly alerts?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly gigsEmployee?:
      | {
          readonly id: string
          readonly createdAt: any
          readonly deletedAt?: any | undefined
          readonly eligibleAt?: any | undefined
          readonly offboardedAt?: any | undefined
          readonly onboardedAt?: any | undefined
          readonly onboardingStatus: OnboardingStatusEnum
          readonly percentComplete?: number | undefined
          readonly rejectedAt?: any | undefined
          readonly savedAt?: any | undefined
          readonly screeningAt?: any | undefined
          readonly terminatedAt?: any | undefined
          readonly updatedAt: any
          readonly permissions: { readonly seeHistory: boolean }
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly applyToJobs: boolean
      readonly edit: boolean
      readonly hasRecruiterLabel: boolean
      readonly imposter: boolean
      readonly internalUser: boolean
      readonly publishJobOrders: boolean
      readonly readEmail: boolean
      readonly readJobBooster: boolean
      readonly readNotes: boolean
      readonly readPhone: boolean
      readonly triggerIndispensableSurvey: boolean
      readonly searchCandidates: boolean
      readonly searchCandidatesAsClient: boolean
      readonly searchCandidatesAsRecruiter: boolean
      readonly searchClients: boolean
      readonly searchClientsByRecruiters: boolean
      readonly searchJobPostings: boolean
      readonly searchJobPostingsByRecruiter: boolean
      readonly sendMessage: boolean
      readonly trainableUser: boolean
      readonly updateConnectionStatus: boolean
      readonly uploadCsv: boolean
      readonly matchCriteria: boolean
    }
    readonly social?:
      | {
          readonly calendly?: string | undefined
          readonly linkedin?: string | undefined
        }
      | undefined
    readonly candidate?:
      | {
          readonly __typename: 'Candidate'
          readonly id: string
          readonly backgroundCheckDate?: any | undefined
          readonly credentialCount: number
          readonly dnu?: string | undefined
          readonly hiringStatus?: HiringStatusEnum | undefined
          readonly i9Date?: any | undefined
          readonly idealEmployment?: string | undefined
          readonly isAbleToApply: boolean
          readonly isNeedEmploymentSponsor?: boolean | undefined
          readonly isUsWorkAuthorized?: boolean | undefined
          readonly noWorkExperience?: boolean | undefined
          readonly profileCompletedAt?: any | undefined
          readonly profilePercentComplete?: number | undefined
          readonly relayId: string
          readonly resumeUrl?: string | undefined
          readonly salaryExpectations?: string | undefined
          readonly candidateLicenses?:
            | ReadonlyArray<{
                readonly id: string
                readonly date?: any | undefined
                readonly number?: string | undefined
                readonly url?: string | undefined
                readonly license?:
                  | {
                      readonly id: string
                      readonly name: string
                      readonly country: CountriesEnum
                      readonly state?: string | undefined
                    }
                  | undefined
              }>
            | undefined
          readonly credentials?:
            | ReadonlyArray<{
                readonly id: string
                readonly title: string
                readonly badgeUrl: string
                readonly description?: string | undefined
                readonly training: {
                  readonly id: string
                  readonly trainingUrl: string
                }
              }>
            | undefined
          readonly education?:
            | ReadonlyArray<{
                readonly id: string
                readonly degree?: string | undefined
                readonly educationLevel?: EducationLevelEnum | undefined
                readonly school?: string | undefined
                readonly yearsAttended?: number | undefined
              }>
            | undefined
          readonly experiences?:
            | ReadonlyArray<{
                readonly id: string
                readonly companyName?: string | undefined
                readonly current?: boolean | undefined
                readonly endDate?: any | undefined
                readonly jobTitle?: string | undefined
                readonly responsibilities?: string | undefined
                readonly startDate?: any | undefined
                readonly yearsEmployed?: number | undefined
              }>
            | undefined
          readonly placements?:
            | ReadonlyArray<{
                readonly startDate?: any | undefined
                readonly id: string
                readonly interviewDate?: any | undefined
                readonly status?: PlacementStatusEnum | undefined
                readonly permissions: { readonly update: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly slug: string
                  readonly title: string
                  readonly client?: { readonly displayname: string } | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                  }
                }
              }>
            | undefined
          readonly jobApplications?:
            | ReadonlyArray<{
                readonly id: string
                readonly status?: JobApplicationStatusEnum | undefined
                readonly permissions: { readonly show: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly level?: number | undefined
                  readonly slug: string
                  readonly title: string
                  readonly client?:
                    | { readonly displayname: string; readonly name: string }
                    | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                    readonly managePlacements: boolean
                  }
                  readonly jobPostingScreening?:
                    | { readonly id: string }
                    | undefined
                }
                readonly screeningSubmissions?:
                  | ReadonlyArray<{ readonly id: string }>
                  | undefined
              }>
            | undefined
          readonly permissions: {
            readonly edit: boolean
            readonly readApplications: boolean
            readonly readCredentials: boolean
            readonly readLicense: boolean
            readonly readResume: boolean
            readonly readWorkPreferences: boolean
          }
          readonly recruiters?:
            | ReadonlyArray<{
                readonly avatarUrl?: string | undefined
                readonly firstName: string
                readonly id: string
                readonly lastName: string
              }>
            | undefined
          readonly skillRelations?:
            | ReadonlyArray<{
                readonly id: string
                readonly years: number
                readonly skill: {
                  readonly __typename: 'Skill'
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly summary?:
            | {
                readonly id: string
                readonly entry: string
                readonly title: string
              }
            | undefined
        }
      | undefined
    readonly subscription?:
      | {
          readonly __typename: 'Subscription'
          readonly id: string
          readonly active: boolean
          readonly plan: string
        }
      | undefined
  }
}

export type GenerateChargebeeCheckoutMutationVariables = Exact<{
  input: GenerateChargebeeCheckoutInput
}>

export type GenerateChargebeeCheckoutMutation = {
  readonly generateChargebeeCheckout?:
    | { readonly id: string; readonly url: string }
    | undefined
}

export type GenerateChargebeePortalMutationVariables = Exact<{
  input: GenerateChargebeePortalInput
}>

export type GenerateChargebeePortalMutation = {
  readonly generateChargebeePortal?:
    | { readonly id: string; readonly accessUrl: string }
    | undefined
}

export type MarkAlertReadMutationVariables = Exact<{
  input: MarkAlertReadInput
}>

export type MarkAlertReadMutation = {
  readonly markAlertRead?:
    | {
        readonly id: string
        readonly resource: { readonly username: string } | {}
      }
    | undefined
}

export type UpdateMemberUserMutationVariables = Exact<{
  input: UpdateUserInput
}>

export type UpdateMemberUserMutation = {
  readonly updateUser: {
    readonly __typename: 'User'
    readonly id: string
    readonly username: string
    readonly availability?: string | undefined
    readonly avatarUrl?: string | undefined
    readonly connectionCount: number
    readonly connectionStatus?: ConnectionStatusEnum | undefined
    readonly email?: string | undefined
    readonly secondaryEmail?: string | undefined
    readonly firstName: string
    readonly indispensableSurveyLink: string
    readonly isCurrentUser: boolean
    readonly lastName: string
    readonly termsAcceptedAt?: any | undefined
    readonly phoneNumber?: string | undefined
    readonly uri: string
    readonly activities?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly alerts?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly gigsEmployee?:
      | {
          readonly id: string
          readonly createdAt: any
          readonly deletedAt?: any | undefined
          readonly eligibleAt?: any | undefined
          readonly offboardedAt?: any | undefined
          readonly onboardedAt?: any | undefined
          readonly onboardingStatus: OnboardingStatusEnum
          readonly percentComplete?: number | undefined
          readonly rejectedAt?: any | undefined
          readonly savedAt?: any | undefined
          readonly screeningAt?: any | undefined
          readonly terminatedAt?: any | undefined
          readonly updatedAt: any
          readonly permissions: { readonly seeHistory: boolean }
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly applyToJobs: boolean
      readonly edit: boolean
      readonly hasRecruiterLabel: boolean
      readonly imposter: boolean
      readonly internalUser: boolean
      readonly publishJobOrders: boolean
      readonly readEmail: boolean
      readonly readJobBooster: boolean
      readonly readNotes: boolean
      readonly readPhone: boolean
      readonly triggerIndispensableSurvey: boolean
      readonly searchCandidates: boolean
      readonly searchCandidatesAsClient: boolean
      readonly searchCandidatesAsRecruiter: boolean
      readonly searchClients: boolean
      readonly searchClientsByRecruiters: boolean
      readonly searchJobPostings: boolean
      readonly searchJobPostingsByRecruiter: boolean
      readonly sendMessage: boolean
      readonly trainableUser: boolean
      readonly updateConnectionStatus: boolean
      readonly uploadCsv: boolean
      readonly matchCriteria: boolean
    }
    readonly social?:
      | {
          readonly calendly?: string | undefined
          readonly linkedin?: string | undefined
        }
      | undefined
    readonly candidate?:
      | {
          readonly __typename: 'Candidate'
          readonly id: string
          readonly backgroundCheckDate?: any | undefined
          readonly credentialCount: number
          readonly dnu?: string | undefined
          readonly hiringStatus?: HiringStatusEnum | undefined
          readonly i9Date?: any | undefined
          readonly idealEmployment?: string | undefined
          readonly isAbleToApply: boolean
          readonly isNeedEmploymentSponsor?: boolean | undefined
          readonly isUsWorkAuthorized?: boolean | undefined
          readonly noWorkExperience?: boolean | undefined
          readonly profileCompletedAt?: any | undefined
          readonly profilePercentComplete?: number | undefined
          readonly relayId: string
          readonly resumeUrl?: string | undefined
          readonly salaryExpectations?: string | undefined
          readonly candidateLicenses?:
            | ReadonlyArray<{
                readonly id: string
                readonly date?: any | undefined
                readonly number?: string | undefined
                readonly url?: string | undefined
                readonly license?:
                  | {
                      readonly id: string
                      readonly name: string
                      readonly country: CountriesEnum
                      readonly state?: string | undefined
                    }
                  | undefined
              }>
            | undefined
          readonly credentials?:
            | ReadonlyArray<{
                readonly id: string
                readonly title: string
                readonly badgeUrl: string
                readonly description?: string | undefined
                readonly training: {
                  readonly id: string
                  readonly trainingUrl: string
                }
              }>
            | undefined
          readonly education?:
            | ReadonlyArray<{
                readonly id: string
                readonly degree?: string | undefined
                readonly educationLevel?: EducationLevelEnum | undefined
                readonly school?: string | undefined
                readonly yearsAttended?: number | undefined
              }>
            | undefined
          readonly experiences?:
            | ReadonlyArray<{
                readonly id: string
                readonly companyName?: string | undefined
                readonly current?: boolean | undefined
                readonly endDate?: any | undefined
                readonly jobTitle?: string | undefined
                readonly responsibilities?: string | undefined
                readonly startDate?: any | undefined
                readonly yearsEmployed?: number | undefined
              }>
            | undefined
          readonly placements?:
            | ReadonlyArray<{
                readonly startDate?: any | undefined
                readonly id: string
                readonly interviewDate?: any | undefined
                readonly status?: PlacementStatusEnum | undefined
                readonly permissions: { readonly update: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly slug: string
                  readonly title: string
                  readonly client?: { readonly displayname: string } | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                  }
                }
              }>
            | undefined
          readonly jobApplications?:
            | ReadonlyArray<{
                readonly id: string
                readonly status?: JobApplicationStatusEnum | undefined
                readonly permissions: { readonly show: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly level?: number | undefined
                  readonly slug: string
                  readonly title: string
                  readonly client?:
                    | { readonly displayname: string; readonly name: string }
                    | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                    readonly managePlacements: boolean
                  }
                  readonly jobPostingScreening?:
                    | { readonly id: string }
                    | undefined
                }
                readonly screeningSubmissions?:
                  | ReadonlyArray<{ readonly id: string }>
                  | undefined
              }>
            | undefined
          readonly permissions: {
            readonly edit: boolean
            readonly readApplications: boolean
            readonly readCredentials: boolean
            readonly readLicense: boolean
            readonly readResume: boolean
            readonly readWorkPreferences: boolean
          }
          readonly recruiters?:
            | ReadonlyArray<{
                readonly avatarUrl?: string | undefined
                readonly firstName: string
                readonly id: string
                readonly lastName: string
              }>
            | undefined
          readonly skillRelations?:
            | ReadonlyArray<{
                readonly id: string
                readonly years: number
                readonly skill: {
                  readonly __typename: 'Skill'
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly summary?:
            | {
                readonly id: string
                readonly entry: string
                readonly title: string
              }
            | undefined
        }
      | undefined
    readonly subscription?:
      | {
          readonly __typename: 'Subscription'
          readonly id: string
          readonly active: boolean
          readonly plan: string
        }
      | undefined
  }
}

export type NodeQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type NodeQuery = {
  readonly node?:
    | {
        readonly __typename: 'Client'
        readonly id: string
        readonly billingAddress?: string | undefined
        readonly accountsPayableEmail?: string | undefined
        readonly displayname: string
        readonly avatarUrl?: string | undefined
        readonly companySize?: CompanySizeEnum | undefined
        readonly connectionStatus?: ConnectionStatusEnum | undefined
        readonly countAvailablePositions: number
        readonly countRecentPositions: number
        readonly headline: string
        readonly metaDescription: string
        readonly metaTitle: string
        readonly name: string
        readonly profileComplete: boolean
        readonly profileCompletedAt?: any | undefined
        readonly uri: string
        readonly visibleOnPlatform: boolean
        readonly website?: string | undefined
        readonly companyDescription?: string | undefined
        readonly companyEmploymentBenefits?:
          | ReadonlyArray<{
              readonly id: string
              readonly employmentBenefit: {
                readonly icon: string
                readonly id: string
                readonly name: string
              }
            }>
          | undefined
        readonly companyLocations?:
          | ReadonlyArray<{
              readonly address?: string | undefined
              readonly addressExtended?: string | undefined
              readonly city?: string | undefined
              readonly country?: CountriesEnum | undefined
              readonly latitude?: number | undefined
              readonly longitude?: number | undefined
              readonly postalCode?: string | undefined
              readonly rawLocation?: string | undefined
              readonly state?: StatesEnum | undefined
            }>
          | undefined
        readonly companyPhotos?:
          | ReadonlyArray<{
              readonly id: string
              readonly alt?: string | undefined
              readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
              readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
              readonly url: string
            }>
          | undefined
        readonly companyValues?:
          | ReadonlyArray<{
              readonly id: string
              readonly description: string
              readonly title: string
            }>
          | undefined
        readonly location: {
          readonly address?: string | undefined
          readonly addressExtended?: string | undefined
          readonly city?: string | undefined
          readonly country?: CountriesEnum | undefined
          readonly latitude?: number | undefined
          readonly longitude?: number | undefined
          readonly postalCode?: string | undefined
          readonly rawLocation?: string | undefined
          readonly state?: StatesEnum | undefined
        }
        readonly permissions: {
          readonly createJobPosting: boolean
          readonly edit: boolean
          readonly editMeta: boolean
          readonly internalUser: boolean
          readonly readPendingBanner: boolean
          readonly toggleVisible: boolean
        }
        readonly social?:
          | {
              readonly facebook?: string | undefined
              readonly instagram?: string | undefined
              readonly linkedin?: string | undefined
              readonly twitter?: string | undefined
            }
          | undefined
        readonly trainings: {
          readonly pageInfo: { readonly totalCount: number }
        }
      }
    | {
        readonly __typename: 'Credential'
        readonly id: string
        readonly training: {
          readonly __typename: 'Training'
          readonly id: string
          readonly currentUserPassed: boolean
          readonly countCandidatesCompletedTraining: number
          readonly description: string
          readonly isPublished: boolean
          readonly slug: string
          readonly title: string
          readonly totalQuestionsCount: number
          readonly totalTimeToComplete: number
          readonly trainingUrl: string
          readonly creatorClient: {
            readonly id: string
            readonly avatarUrl?: string | undefined
            readonly displayname: string
          }
          readonly credential: {
            readonly id: string
            readonly badgeUrl: string
            readonly description?: string | undefined
            readonly title: string
          }
          readonly permissions: {
            readonly viewCount: boolean
            readonly viewTrainingMembers: boolean
          }
          readonly quizzes: ReadonlyArray<{
            readonly __typename: 'Quiz'
            readonly createdAt: any
            readonly id: string
            readonly description: string
            readonly slug: string
            readonly timeToComplete?: number | undefined
            readonly title: string
            readonly totalCorrectToGainCertification: number
            readonly totalQuestions?: number | undefined
            readonly videoUrl: string
            readonly currentUserQuizAttempts?:
              | ReadonlyArray<{
                  readonly __typename: 'QuizAttempt'
                  readonly id: string
                  readonly createdAt: any
                  readonly grade?: number | undefined
                  readonly status: QuizAttemptStatusEnum
                  readonly userCurrentQuestionAttempt?:
                    | {
                        readonly __typename: 'QuestionAttempt'
                        readonly id: string
                        readonly quizQuestion: {
                          readonly sortPosition?: number | undefined
                          readonly question: {
                            readonly value: string
                            readonly questionAnswerType?:
                              | QuestionAnswerTypeEnum
                              | undefined
                          }
                          readonly questionAnswers: ReadonlyArray<{
                            readonly id: string
                            readonly answer: string
                          }>
                        }
                      }
                    | undefined
                }>
              | undefined
          }>
        }
      }
    | {
        readonly __typename: 'JobPosting'
        readonly id: string
        readonly accountsPayableEmail?: string | undefined
        readonly applicationReceived: boolean
        readonly atsRecordType?: string | undefined
        readonly atsStatus?: JobPostingAtsStatusEnum | undefined
        readonly baseSalaryValue: number
        readonly countJobApplicationsNew: number
        readonly countJobApplicationsTotal: number
        readonly description: string
        readonly depositAmount?: number | undefined
        readonly education?: string | undefined
        readonly employmentTypes?:
          | ReadonlyArray<EmploymentTypesEnum>
          | undefined
        readonly endDate?: any | undefined
        readonly quantity?: number | undefined
        readonly experience?: string | undefined
        readonly externalId?: string | undefined
        readonly isIngested: boolean
        readonly isPublished: boolean
        readonly isRemote: boolean
        readonly physicalRequirements?: string | undefined
        readonly postedAt?: any | undefined
        readonly shift?: string | undefined
        readonly syndicateIndeed: boolean
        readonly responsibilities?: string | undefined
        readonly slug: string
        readonly startDate?: any | undefined
        readonly submitApplicationUrl?: string | undefined
        readonly title: string
        readonly uri: string
        readonly validThrough: any
        readonly workingEnvironment?: string | undefined
        readonly accountExecs?:
          | ReadonlyArray<{
              readonly avatarUrl?: string | undefined
              readonly firstName: string
              readonly id: string
              readonly lastName: string
              readonly username: string
            }>
          | undefined
        readonly activities?:
          | { readonly pageInfo: { readonly totalCount: number } }
          | undefined
        readonly client?:
          | {
              readonly __typename: 'Client'
              readonly id: string
              readonly displayname: string
              readonly avatarUrl?: string | undefined
              readonly billingAddress?: string | undefined
              readonly companySize?: CompanySizeEnum | undefined
              readonly connectionStatus?: ConnectionStatusEnum | undefined
              readonly countAvailablePositions: number
              readonly countRecentPositions: number
              readonly description?: string | undefined
              readonly headline: string
              readonly name: string
              readonly profileComplete: boolean
              readonly profileCompletedAt?: any | undefined
              readonly visibleOnPlatform: boolean
              readonly website?: string | undefined
              readonly companyEmploymentBenefits?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly employmentBenefit: {
                      readonly icon: string
                      readonly id: string
                      readonly name: string
                    }
                  }>
                | undefined
              readonly companyLocations?:
                | ReadonlyArray<{
                    readonly address?: string | undefined
                    readonly addressExtended?: string | undefined
                    readonly city?: string | undefined
                    readonly country?: CountriesEnum | undefined
                    readonly latitude?: number | undefined
                    readonly longitude?: number | undefined
                    readonly postalCode?: string | undefined
                    readonly rawLocation?: string | undefined
                    readonly state?: StatesEnum | undefined
                  }>
                | undefined
              readonly companyPhotos?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly alt?: string | undefined
                    readonly displayRole?:
                      | CompanyPhotoDisplayRoleEnum
                      | undefined
                    readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
                    readonly url: string
                  }>
                | undefined
              readonly companyValues?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly description: string
                    readonly title: string
                  }>
                | undefined
              readonly location: {
                readonly address?: string | undefined
                readonly addressExtended?: string | undefined
                readonly city?: string | undefined
                readonly country?: CountriesEnum | undefined
                readonly latitude?: number | undefined
                readonly longitude?: number | undefined
                readonly postalCode?: string | undefined
                readonly rawLocation?: string | undefined
                readonly state?: StatesEnum | undefined
              }
              readonly permissions: {
                readonly createJobPosting: boolean
                readonly edit: boolean
                readonly readPendingBanner: boolean
                readonly toggleVisible: boolean
              }
              readonly social?:
                | {
                    readonly facebook?: string | undefined
                    readonly instagram?: string | undefined
                    readonly linkedin?: string | undefined
                    readonly twitter?: string | undefined
                  }
                | undefined
            }
          | undefined
        readonly associatedClient?:
          | {
              readonly __typename: 'Client'
              readonly id: string
              readonly displayname: string
              readonly avatarUrl?: string | undefined
              readonly billingAddress?: string | undefined
              readonly companySize?: CompanySizeEnum | undefined
              readonly connectionStatus?: ConnectionStatusEnum | undefined
              readonly countAvailablePositions: number
              readonly countRecentPositions: number
              readonly description?: string | undefined
              readonly headline: string
              readonly name: string
              readonly profileComplete: boolean
              readonly profileCompletedAt?: any | undefined
              readonly visibleOnPlatform: boolean
              readonly website?: string | undefined
              readonly companyEmploymentBenefits?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly employmentBenefit: {
                      readonly icon: string
                      readonly id: string
                      readonly name: string
                    }
                  }>
                | undefined
              readonly companyLocations?:
                | ReadonlyArray<{
                    readonly address?: string | undefined
                    readonly addressExtended?: string | undefined
                    readonly city?: string | undefined
                    readonly country?: CountriesEnum | undefined
                    readonly latitude?: number | undefined
                    readonly longitude?: number | undefined
                    readonly postalCode?: string | undefined
                    readonly rawLocation?: string | undefined
                    readonly state?: StatesEnum | undefined
                  }>
                | undefined
              readonly companyPhotos?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly alt?: string | undefined
                    readonly displayRole?:
                      | CompanyPhotoDisplayRoleEnum
                      | undefined
                    readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
                    readonly url: string
                  }>
                | undefined
              readonly companyValues?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly description: string
                    readonly title: string
                  }>
                | undefined
              readonly location: {
                readonly address?: string | undefined
                readonly addressExtended?: string | undefined
                readonly city?: string | undefined
                readonly country?: CountriesEnum | undefined
                readonly latitude?: number | undefined
                readonly longitude?: number | undefined
                readonly postalCode?: string | undefined
                readonly rawLocation?: string | undefined
                readonly state?: StatesEnum | undefined
              }
              readonly permissions: {
                readonly createJobPosting: boolean
                readonly edit: boolean
                readonly readPendingBanner: boolean
                readonly toggleVisible: boolean
              }
              readonly social?:
                | {
                    readonly facebook?: string | undefined
                    readonly instagram?: string | undefined
                    readonly linkedin?: string | undefined
                    readonly twitter?: string | undefined
                  }
                | undefined
            }
          | undefined
        readonly employmentBenefits?:
          | ReadonlyArray<{
              readonly id: string
              readonly employmentBenefit: {
                readonly icon: string
                readonly id: string
                readonly name: string
              }
            }>
          | undefined
        readonly jobApplicationStatusCounts?:
          | ReadonlyArray<{
              readonly count: number
              readonly status?: JobApplicationStatusEnum | undefined
            }>
          | undefined
        readonly gigsInfo?:
          | {
              readonly additionalRequirements?: string | undefined
              readonly billRate?: number | undefined
              readonly costCenterCreated?: boolean | undefined
              readonly companyOnboarded?: boolean | undefined
              readonly details?: string | undefined
              readonly engagementDeposit?: boolean | undefined
              readonly kickoffCall?: boolean | undefined
              readonly level?: number | undefined
              readonly payRate?: number | undefined
              readonly salaryPayPeriod?: PayPeriodEnum | undefined
              readonly dressCode?: string | undefined
              readonly specialRequests?: string | undefined
              readonly parkingFacilityInformation?: string | undefined
            }
          | undefined
        readonly jobPostingScreening?:
          | {
              readonly id: string
              readonly screening?:
                | {
                    readonly id: string
                    readonly description?: string | undefined
                    readonly name?: string | undefined
                    readonly screeningQuestions?:
                      | ReadonlyArray<{
                          readonly id: string
                          readonly typeOf?: string | undefined
                          readonly question?: string | undefined
                        }>
                      | undefined
                  }
                | undefined
            }
          | undefined
        readonly location: {
          readonly address?: string | undefined
          readonly addressExtended?: string | undefined
          readonly city?: string | undefined
          readonly country?: CountriesEnum | undefined
          readonly latitude?: number | undefined
          readonly longitude?: number | undefined
          readonly postalCode?: string | undefined
          readonly rawLocation?: string | undefined
          readonly state?: StatesEnum | undefined
        }
        readonly permissions: {
          readonly destroy: boolean
          readonly edit: boolean
          readonly internalUser: boolean
          readonly managePlacements: boolean
          readonly readEndDate: boolean
          readonly readJobApps: boolean
          readonly readPlacements: boolean
          readonly togglePublished: boolean
          readonly writeAtsRecordType: boolean
          readonly writeRecruiterToJob: boolean
          readonly writeSubmitApplicationUrl: boolean
        }
        readonly placements?:
          | ReadonlyArray<{
              readonly id: string
              readonly status?: PlacementStatusEnum | undefined
            }>
          | undefined
        readonly placementStatusCounts?:
          | ReadonlyArray<{
              readonly count: number
              readonly status?: PlacementStatusEnum | undefined
            }>
          | undefined
        readonly primaryContact?:
          | {
              readonly avatarUrl?: string | undefined
              readonly firstName: string
              readonly id: string
              readonly lastName: string
            }
          | undefined
        readonly recommendedCredentials?:
          | ReadonlyArray<{
              readonly id: string
              readonly credential: {
                readonly __typename: 'Credential'
                readonly id: string
                readonly badgeUrl: string
                readonly description?: string | undefined
                readonly title: string
                readonly training: {
                  readonly id: string
                  readonly trainingUrl: string
                }
              }
            }>
          | undefined
        readonly recruiters?:
          | ReadonlyArray<{
              readonly avatarUrl?: string | undefined
              readonly firstName: string
              readonly id: string
              readonly lastName: string
              readonly username: string
            }>
          | undefined
        readonly timeSheetManagers?:
          | ReadonlyArray<{
              readonly avatarUrl?: string | undefined
              readonly firstName: string
              readonly id: string
              readonly lastName: string
              readonly username: string
            }>
          | undefined
        readonly requiredLicenses: ReadonlyArray<{
          readonly id: string
          readonly license: {
            readonly id: string
            readonly name: string
            readonly country: CountriesEnum
            readonly state?: string | undefined
          }
        }>
        readonly salaryRange?:
          | {
              readonly maxValue?: number | undefined
              readonly minValue?: number | undefined
              readonly payPeriod?: PayPeriodEnum | undefined
            }
          | undefined
      }
    | {
        readonly __typename: 'User'
        readonly id: string
        readonly username: string
        readonly availability?: string | undefined
        readonly avatarUrl?: string | undefined
        readonly connectionCount: number
        readonly connectionStatus?: ConnectionStatusEnum | undefined
        readonly email?: string | undefined
        readonly secondaryEmail?: string | undefined
        readonly firstName: string
        readonly indispensableSurveyLink: string
        readonly isCurrentUser: boolean
        readonly lastName: string
        readonly termsAcceptedAt?: any | undefined
        readonly phoneNumber?: string | undefined
        readonly uri: string
        readonly activities?:
          | { readonly pageInfo: { readonly totalCount: number } }
          | undefined
        readonly alerts?:
          | { readonly pageInfo: { readonly totalCount: number } }
          | undefined
        readonly gigsEmployee?:
          | {
              readonly id: string
              readonly createdAt: any
              readonly deletedAt?: any | undefined
              readonly eligibleAt?: any | undefined
              readonly offboardedAt?: any | undefined
              readonly onboardedAt?: any | undefined
              readonly onboardingStatus: OnboardingStatusEnum
              readonly percentComplete?: number | undefined
              readonly rejectedAt?: any | undefined
              readonly savedAt?: any | undefined
              readonly screeningAt?: any | undefined
              readonly terminatedAt?: any | undefined
              readonly updatedAt: any
              readonly permissions: { readonly seeHistory: boolean }
            }
          | undefined
        readonly location: {
          readonly address?: string | undefined
          readonly addressExtended?: string | undefined
          readonly city?: string | undefined
          readonly country?: CountriesEnum | undefined
          readonly latitude?: number | undefined
          readonly longitude?: number | undefined
          readonly postalCode?: string | undefined
          readonly rawLocation?: string | undefined
          readonly state?: StatesEnum | undefined
        }
        readonly permissions: {
          readonly applyToJobs: boolean
          readonly edit: boolean
          readonly hasRecruiterLabel: boolean
          readonly imposter: boolean
          readonly internalUser: boolean
          readonly publishJobOrders: boolean
          readonly readEmail: boolean
          readonly readJobBooster: boolean
          readonly readNotes: boolean
          readonly readPhone: boolean
          readonly triggerIndispensableSurvey: boolean
          readonly searchCandidates: boolean
          readonly searchCandidatesAsClient: boolean
          readonly searchCandidatesAsRecruiter: boolean
          readonly searchClients: boolean
          readonly searchClientsByRecruiters: boolean
          readonly searchJobPostings: boolean
          readonly searchJobPostingsByRecruiter: boolean
          readonly sendMessage: boolean
          readonly trainableUser: boolean
          readonly updateConnectionStatus: boolean
          readonly uploadCsv: boolean
          readonly matchCriteria: boolean
        }
        readonly social?:
          | {
              readonly calendly?: string | undefined
              readonly linkedin?: string | undefined
            }
          | undefined
        readonly candidate?:
          | {
              readonly __typename: 'Candidate'
              readonly id: string
              readonly backgroundCheckDate?: any | undefined
              readonly credentialCount: number
              readonly dnu?: string | undefined
              readonly hiringStatus?: HiringStatusEnum | undefined
              readonly i9Date?: any | undefined
              readonly idealEmployment?: string | undefined
              readonly isAbleToApply: boolean
              readonly isNeedEmploymentSponsor?: boolean | undefined
              readonly isUsWorkAuthorized?: boolean | undefined
              readonly noWorkExperience?: boolean | undefined
              readonly profileCompletedAt?: any | undefined
              readonly profilePercentComplete?: number | undefined
              readonly relayId: string
              readonly resumeUrl?: string | undefined
              readonly salaryExpectations?: string | undefined
              readonly candidateLicenses?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly date?: any | undefined
                    readonly number?: string | undefined
                    readonly url?: string | undefined
                    readonly license?:
                      | {
                          readonly id: string
                          readonly name: string
                          readonly country: CountriesEnum
                          readonly state?: string | undefined
                        }
                      | undefined
                  }>
                | undefined
              readonly credentials?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly title: string
                    readonly badgeUrl: string
                    readonly description?: string | undefined
                    readonly training: {
                      readonly id: string
                      readonly trainingUrl: string
                    }
                  }>
                | undefined
              readonly education?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly degree?: string | undefined
                    readonly educationLevel?: EducationLevelEnum | undefined
                    readonly school?: string | undefined
                    readonly yearsAttended?: number | undefined
                  }>
                | undefined
              readonly experiences?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly companyName?: string | undefined
                    readonly current?: boolean | undefined
                    readonly endDate?: any | undefined
                    readonly jobTitle?: string | undefined
                    readonly responsibilities?: string | undefined
                    readonly startDate?: any | undefined
                    readonly yearsEmployed?: number | undefined
                  }>
                | undefined
              readonly placements?:
                | ReadonlyArray<{
                    readonly startDate?: any | undefined
                    readonly id: string
                    readonly interviewDate?: any | undefined
                    readonly status?: PlacementStatusEnum | undefined
                    readonly permissions: { readonly update: boolean }
                    readonly jobPosting: {
                      readonly id: string
                      readonly slug: string
                      readonly title: string
                      readonly client?:
                        | { readonly displayname: string }
                        | undefined
                      readonly permissions: {
                        readonly readJobApps: boolean
                        readonly readPlacements: boolean
                      }
                    }
                  }>
                | undefined
              readonly jobApplications?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly status?: JobApplicationStatusEnum | undefined
                    readonly permissions: { readonly show: boolean }
                    readonly jobPosting: {
                      readonly id: string
                      readonly level?: number | undefined
                      readonly slug: string
                      readonly title: string
                      readonly client?:
                        | {
                            readonly displayname: string
                            readonly name: string
                          }
                        | undefined
                      readonly permissions: {
                        readonly readJobApps: boolean
                        readonly readPlacements: boolean
                        readonly managePlacements: boolean
                      }
                      readonly jobPostingScreening?:
                        | { readonly id: string }
                        | undefined
                    }
                    readonly screeningSubmissions?:
                      | ReadonlyArray<{ readonly id: string }>
                      | undefined
                  }>
                | undefined
              readonly permissions: {
                readonly edit: boolean
                readonly readApplications: boolean
                readonly readCredentials: boolean
                readonly readLicense: boolean
                readonly readResume: boolean
                readonly readWorkPreferences: boolean
              }
              readonly recruiters?:
                | ReadonlyArray<{
                    readonly avatarUrl?: string | undefined
                    readonly firstName: string
                    readonly id: string
                    readonly lastName: string
                  }>
                | undefined
              readonly skillRelations?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly years: number
                    readonly skill: {
                      readonly __typename: 'Skill'
                      readonly id: string
                      readonly name: string
                    }
                  }>
                | undefined
              readonly summary?:
                | {
                    readonly id: string
                    readonly entry: string
                    readonly title: string
                  }
                | undefined
            }
          | undefined
        readonly subscription?:
          | {
              readonly __typename: 'Subscription'
              readonly id: string
              readonly active: boolean
              readonly plan: string
            }
          | undefined
      }
    | {}
    | undefined
}

export type NodesQueryVariables = Exact<{
  ids: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type NodesQuery = {
  readonly nodes: ReadonlyArray<
    | {
        readonly __typename: 'Client'
        readonly id: string
        readonly billingAddress?: string | undefined
        readonly accountsPayableEmail?: string | undefined
        readonly displayname: string
        readonly avatarUrl?: string | undefined
        readonly companySize?: CompanySizeEnum | undefined
        readonly connectionStatus?: ConnectionStatusEnum | undefined
        readonly countAvailablePositions: number
        readonly countRecentPositions: number
        readonly headline: string
        readonly metaDescription: string
        readonly metaTitle: string
        readonly name: string
        readonly profileComplete: boolean
        readonly profileCompletedAt?: any | undefined
        readonly uri: string
        readonly visibleOnPlatform: boolean
        readonly website?: string | undefined
        readonly companyDescription?: string | undefined
        readonly companyEmploymentBenefits?:
          | ReadonlyArray<{
              readonly id: string
              readonly employmentBenefit: {
                readonly icon: string
                readonly id: string
                readonly name: string
              }
            }>
          | undefined
        readonly companyLocations?:
          | ReadonlyArray<{
              readonly address?: string | undefined
              readonly addressExtended?: string | undefined
              readonly city?: string | undefined
              readonly country?: CountriesEnum | undefined
              readonly latitude?: number | undefined
              readonly longitude?: number | undefined
              readonly postalCode?: string | undefined
              readonly rawLocation?: string | undefined
              readonly state?: StatesEnum | undefined
            }>
          | undefined
        readonly companyPhotos?:
          | ReadonlyArray<{
              readonly id: string
              readonly alt?: string | undefined
              readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
              readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
              readonly url: string
            }>
          | undefined
        readonly companyValues?:
          | ReadonlyArray<{
              readonly id: string
              readonly description: string
              readonly title: string
            }>
          | undefined
        readonly location: {
          readonly address?: string | undefined
          readonly addressExtended?: string | undefined
          readonly city?: string | undefined
          readonly country?: CountriesEnum | undefined
          readonly latitude?: number | undefined
          readonly longitude?: number | undefined
          readonly postalCode?: string | undefined
          readonly rawLocation?: string | undefined
          readonly state?: StatesEnum | undefined
        }
        readonly permissions: {
          readonly createJobPosting: boolean
          readonly edit: boolean
          readonly editMeta: boolean
          readonly internalUser: boolean
          readonly readPendingBanner: boolean
          readonly toggleVisible: boolean
        }
        readonly social?:
          | {
              readonly facebook?: string | undefined
              readonly instagram?: string | undefined
              readonly linkedin?: string | undefined
              readonly twitter?: string | undefined
            }
          | undefined
        readonly trainings: {
          readonly pageInfo: { readonly totalCount: number }
        }
      }
    | {
        readonly __typename: 'Credential'
        readonly id: string
        readonly training: {
          readonly __typename: 'Training'
          readonly id: string
          readonly currentUserPassed: boolean
          readonly countCandidatesCompletedTraining: number
          readonly description: string
          readonly isPublished: boolean
          readonly slug: string
          readonly title: string
          readonly totalQuestionsCount: number
          readonly totalTimeToComplete: number
          readonly trainingUrl: string
          readonly creatorClient: {
            readonly id: string
            readonly avatarUrl?: string | undefined
            readonly displayname: string
          }
          readonly credential: {
            readonly id: string
            readonly badgeUrl: string
            readonly description?: string | undefined
            readonly title: string
          }
          readonly permissions: {
            readonly viewCount: boolean
            readonly viewTrainingMembers: boolean
          }
          readonly quizzes: ReadonlyArray<{
            readonly __typename: 'Quiz'
            readonly createdAt: any
            readonly id: string
            readonly description: string
            readonly slug: string
            readonly timeToComplete?: number | undefined
            readonly title: string
            readonly totalCorrectToGainCertification: number
            readonly totalQuestions?: number | undefined
            readonly videoUrl: string
            readonly currentUserQuizAttempts?:
              | ReadonlyArray<{
                  readonly __typename: 'QuizAttempt'
                  readonly id: string
                  readonly createdAt: any
                  readonly grade?: number | undefined
                  readonly status: QuizAttemptStatusEnum
                  readonly userCurrentQuestionAttempt?:
                    | {
                        readonly __typename: 'QuestionAttempt'
                        readonly id: string
                        readonly quizQuestion: {
                          readonly sortPosition?: number | undefined
                          readonly question: {
                            readonly value: string
                            readonly questionAnswerType?:
                              | QuestionAnswerTypeEnum
                              | undefined
                          }
                          readonly questionAnswers: ReadonlyArray<{
                            readonly id: string
                            readonly answer: string
                          }>
                        }
                      }
                    | undefined
                }>
              | undefined
          }>
        }
      }
    | {
        readonly __typename: 'JobPosting'
        readonly id: string
        readonly accountsPayableEmail?: string | undefined
        readonly applicationReceived: boolean
        readonly atsRecordType?: string | undefined
        readonly atsStatus?: JobPostingAtsStatusEnum | undefined
        readonly baseSalaryValue: number
        readonly countJobApplicationsNew: number
        readonly countJobApplicationsTotal: number
        readonly description: string
        readonly depositAmount?: number | undefined
        readonly education?: string | undefined
        readonly employmentTypes?:
          | ReadonlyArray<EmploymentTypesEnum>
          | undefined
        readonly endDate?: any | undefined
        readonly quantity?: number | undefined
        readonly experience?: string | undefined
        readonly externalId?: string | undefined
        readonly isIngested: boolean
        readonly isPublished: boolean
        readonly isRemote: boolean
        readonly physicalRequirements?: string | undefined
        readonly postedAt?: any | undefined
        readonly shift?: string | undefined
        readonly syndicateIndeed: boolean
        readonly responsibilities?: string | undefined
        readonly slug: string
        readonly startDate?: any | undefined
        readonly submitApplicationUrl?: string | undefined
        readonly title: string
        readonly uri: string
        readonly validThrough: any
        readonly workingEnvironment?: string | undefined
        readonly accountExecs?:
          | ReadonlyArray<{
              readonly avatarUrl?: string | undefined
              readonly firstName: string
              readonly id: string
              readonly lastName: string
              readonly username: string
            }>
          | undefined
        readonly activities?:
          | { readonly pageInfo: { readonly totalCount: number } }
          | undefined
        readonly client?:
          | {
              readonly __typename: 'Client'
              readonly id: string
              readonly displayname: string
              readonly avatarUrl?: string | undefined
              readonly billingAddress?: string | undefined
              readonly companySize?: CompanySizeEnum | undefined
              readonly connectionStatus?: ConnectionStatusEnum | undefined
              readonly countAvailablePositions: number
              readonly countRecentPositions: number
              readonly description?: string | undefined
              readonly headline: string
              readonly name: string
              readonly profileComplete: boolean
              readonly profileCompletedAt?: any | undefined
              readonly visibleOnPlatform: boolean
              readonly website?: string | undefined
              readonly companyEmploymentBenefits?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly employmentBenefit: {
                      readonly icon: string
                      readonly id: string
                      readonly name: string
                    }
                  }>
                | undefined
              readonly companyLocations?:
                | ReadonlyArray<{
                    readonly address?: string | undefined
                    readonly addressExtended?: string | undefined
                    readonly city?: string | undefined
                    readonly country?: CountriesEnum | undefined
                    readonly latitude?: number | undefined
                    readonly longitude?: number | undefined
                    readonly postalCode?: string | undefined
                    readonly rawLocation?: string | undefined
                    readonly state?: StatesEnum | undefined
                  }>
                | undefined
              readonly companyPhotos?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly alt?: string | undefined
                    readonly displayRole?:
                      | CompanyPhotoDisplayRoleEnum
                      | undefined
                    readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
                    readonly url: string
                  }>
                | undefined
              readonly companyValues?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly description: string
                    readonly title: string
                  }>
                | undefined
              readonly location: {
                readonly address?: string | undefined
                readonly addressExtended?: string | undefined
                readonly city?: string | undefined
                readonly country?: CountriesEnum | undefined
                readonly latitude?: number | undefined
                readonly longitude?: number | undefined
                readonly postalCode?: string | undefined
                readonly rawLocation?: string | undefined
                readonly state?: StatesEnum | undefined
              }
              readonly permissions: {
                readonly createJobPosting: boolean
                readonly edit: boolean
                readonly readPendingBanner: boolean
                readonly toggleVisible: boolean
              }
              readonly social?:
                | {
                    readonly facebook?: string | undefined
                    readonly instagram?: string | undefined
                    readonly linkedin?: string | undefined
                    readonly twitter?: string | undefined
                  }
                | undefined
            }
          | undefined
        readonly associatedClient?:
          | {
              readonly __typename: 'Client'
              readonly id: string
              readonly displayname: string
              readonly avatarUrl?: string | undefined
              readonly billingAddress?: string | undefined
              readonly companySize?: CompanySizeEnum | undefined
              readonly connectionStatus?: ConnectionStatusEnum | undefined
              readonly countAvailablePositions: number
              readonly countRecentPositions: number
              readonly description?: string | undefined
              readonly headline: string
              readonly name: string
              readonly profileComplete: boolean
              readonly profileCompletedAt?: any | undefined
              readonly visibleOnPlatform: boolean
              readonly website?: string | undefined
              readonly companyEmploymentBenefits?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly employmentBenefit: {
                      readonly icon: string
                      readonly id: string
                      readonly name: string
                    }
                  }>
                | undefined
              readonly companyLocations?:
                | ReadonlyArray<{
                    readonly address?: string | undefined
                    readonly addressExtended?: string | undefined
                    readonly city?: string | undefined
                    readonly country?: CountriesEnum | undefined
                    readonly latitude?: number | undefined
                    readonly longitude?: number | undefined
                    readonly postalCode?: string | undefined
                    readonly rawLocation?: string | undefined
                    readonly state?: StatesEnum | undefined
                  }>
                | undefined
              readonly companyPhotos?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly alt?: string | undefined
                    readonly displayRole?:
                      | CompanyPhotoDisplayRoleEnum
                      | undefined
                    readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
                    readonly url: string
                  }>
                | undefined
              readonly companyValues?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly description: string
                    readonly title: string
                  }>
                | undefined
              readonly location: {
                readonly address?: string | undefined
                readonly addressExtended?: string | undefined
                readonly city?: string | undefined
                readonly country?: CountriesEnum | undefined
                readonly latitude?: number | undefined
                readonly longitude?: number | undefined
                readonly postalCode?: string | undefined
                readonly rawLocation?: string | undefined
                readonly state?: StatesEnum | undefined
              }
              readonly permissions: {
                readonly createJobPosting: boolean
                readonly edit: boolean
                readonly readPendingBanner: boolean
                readonly toggleVisible: boolean
              }
              readonly social?:
                | {
                    readonly facebook?: string | undefined
                    readonly instagram?: string | undefined
                    readonly linkedin?: string | undefined
                    readonly twitter?: string | undefined
                  }
                | undefined
            }
          | undefined
        readonly employmentBenefits?:
          | ReadonlyArray<{
              readonly id: string
              readonly employmentBenefit: {
                readonly icon: string
                readonly id: string
                readonly name: string
              }
            }>
          | undefined
        readonly jobApplicationStatusCounts?:
          | ReadonlyArray<{
              readonly count: number
              readonly status?: JobApplicationStatusEnum | undefined
            }>
          | undefined
        readonly gigsInfo?:
          | {
              readonly additionalRequirements?: string | undefined
              readonly billRate?: number | undefined
              readonly costCenterCreated?: boolean | undefined
              readonly companyOnboarded?: boolean | undefined
              readonly details?: string | undefined
              readonly engagementDeposit?: boolean | undefined
              readonly kickoffCall?: boolean | undefined
              readonly level?: number | undefined
              readonly payRate?: number | undefined
              readonly salaryPayPeriod?: PayPeriodEnum | undefined
              readonly dressCode?: string | undefined
              readonly specialRequests?: string | undefined
              readonly parkingFacilityInformation?: string | undefined
            }
          | undefined
        readonly jobPostingScreening?:
          | {
              readonly id: string
              readonly screening?:
                | {
                    readonly id: string
                    readonly description?: string | undefined
                    readonly name?: string | undefined
                    readonly screeningQuestions?:
                      | ReadonlyArray<{
                          readonly id: string
                          readonly typeOf?: string | undefined
                          readonly question?: string | undefined
                        }>
                      | undefined
                  }
                | undefined
            }
          | undefined
        readonly location: {
          readonly address?: string | undefined
          readonly addressExtended?: string | undefined
          readonly city?: string | undefined
          readonly country?: CountriesEnum | undefined
          readonly latitude?: number | undefined
          readonly longitude?: number | undefined
          readonly postalCode?: string | undefined
          readonly rawLocation?: string | undefined
          readonly state?: StatesEnum | undefined
        }
        readonly permissions: {
          readonly destroy: boolean
          readonly edit: boolean
          readonly internalUser: boolean
          readonly managePlacements: boolean
          readonly readEndDate: boolean
          readonly readJobApps: boolean
          readonly readPlacements: boolean
          readonly togglePublished: boolean
          readonly writeAtsRecordType: boolean
          readonly writeRecruiterToJob: boolean
          readonly writeSubmitApplicationUrl: boolean
        }
        readonly placements?:
          | ReadonlyArray<{
              readonly id: string
              readonly status?: PlacementStatusEnum | undefined
            }>
          | undefined
        readonly placementStatusCounts?:
          | ReadonlyArray<{
              readonly count: number
              readonly status?: PlacementStatusEnum | undefined
            }>
          | undefined
        readonly primaryContact?:
          | {
              readonly avatarUrl?: string | undefined
              readonly firstName: string
              readonly id: string
              readonly lastName: string
            }
          | undefined
        readonly recommendedCredentials?:
          | ReadonlyArray<{
              readonly id: string
              readonly credential: {
                readonly __typename: 'Credential'
                readonly id: string
                readonly badgeUrl: string
                readonly description?: string | undefined
                readonly title: string
                readonly training: {
                  readonly id: string
                  readonly trainingUrl: string
                }
              }
            }>
          | undefined
        readonly recruiters?:
          | ReadonlyArray<{
              readonly avatarUrl?: string | undefined
              readonly firstName: string
              readonly id: string
              readonly lastName: string
              readonly username: string
            }>
          | undefined
        readonly timeSheetManagers?:
          | ReadonlyArray<{
              readonly avatarUrl?: string | undefined
              readonly firstName: string
              readonly id: string
              readonly lastName: string
              readonly username: string
            }>
          | undefined
        readonly requiredLicenses: ReadonlyArray<{
          readonly id: string
          readonly license: {
            readonly id: string
            readonly name: string
            readonly country: CountriesEnum
            readonly state?: string | undefined
          }
        }>
        readonly salaryRange?:
          | {
              readonly maxValue?: number | undefined
              readonly minValue?: number | undefined
              readonly payPeriod?: PayPeriodEnum | undefined
            }
          | undefined
      }
    | {
        readonly __typename: 'User'
        readonly id: string
        readonly username: string
        readonly availability?: string | undefined
        readonly avatarUrl?: string | undefined
        readonly connectionCount: number
        readonly connectionStatus?: ConnectionStatusEnum | undefined
        readonly email?: string | undefined
        readonly secondaryEmail?: string | undefined
        readonly firstName: string
        readonly indispensableSurveyLink: string
        readonly isCurrentUser: boolean
        readonly lastName: string
        readonly termsAcceptedAt?: any | undefined
        readonly phoneNumber?: string | undefined
        readonly uri: string
        readonly activities?:
          | { readonly pageInfo: { readonly totalCount: number } }
          | undefined
        readonly alerts?:
          | { readonly pageInfo: { readonly totalCount: number } }
          | undefined
        readonly gigsEmployee?:
          | {
              readonly id: string
              readonly createdAt: any
              readonly deletedAt?: any | undefined
              readonly eligibleAt?: any | undefined
              readonly offboardedAt?: any | undefined
              readonly onboardedAt?: any | undefined
              readonly onboardingStatus: OnboardingStatusEnum
              readonly percentComplete?: number | undefined
              readonly rejectedAt?: any | undefined
              readonly savedAt?: any | undefined
              readonly screeningAt?: any | undefined
              readonly terminatedAt?: any | undefined
              readonly updatedAt: any
              readonly permissions: { readonly seeHistory: boolean }
            }
          | undefined
        readonly location: {
          readonly address?: string | undefined
          readonly addressExtended?: string | undefined
          readonly city?: string | undefined
          readonly country?: CountriesEnum | undefined
          readonly latitude?: number | undefined
          readonly longitude?: number | undefined
          readonly postalCode?: string | undefined
          readonly rawLocation?: string | undefined
          readonly state?: StatesEnum | undefined
        }
        readonly permissions: {
          readonly applyToJobs: boolean
          readonly edit: boolean
          readonly hasRecruiterLabel: boolean
          readonly imposter: boolean
          readonly internalUser: boolean
          readonly publishJobOrders: boolean
          readonly readEmail: boolean
          readonly readJobBooster: boolean
          readonly readNotes: boolean
          readonly readPhone: boolean
          readonly triggerIndispensableSurvey: boolean
          readonly searchCandidates: boolean
          readonly searchCandidatesAsClient: boolean
          readonly searchCandidatesAsRecruiter: boolean
          readonly searchClients: boolean
          readonly searchClientsByRecruiters: boolean
          readonly searchJobPostings: boolean
          readonly searchJobPostingsByRecruiter: boolean
          readonly sendMessage: boolean
          readonly trainableUser: boolean
          readonly updateConnectionStatus: boolean
          readonly uploadCsv: boolean
          readonly matchCriteria: boolean
        }
        readonly social?:
          | {
              readonly calendly?: string | undefined
              readonly linkedin?: string | undefined
            }
          | undefined
        readonly candidate?:
          | {
              readonly __typename: 'Candidate'
              readonly id: string
              readonly backgroundCheckDate?: any | undefined
              readonly credentialCount: number
              readonly dnu?: string | undefined
              readonly hiringStatus?: HiringStatusEnum | undefined
              readonly i9Date?: any | undefined
              readonly idealEmployment?: string | undefined
              readonly isAbleToApply: boolean
              readonly isNeedEmploymentSponsor?: boolean | undefined
              readonly isUsWorkAuthorized?: boolean | undefined
              readonly noWorkExperience?: boolean | undefined
              readonly profileCompletedAt?: any | undefined
              readonly profilePercentComplete?: number | undefined
              readonly relayId: string
              readonly resumeUrl?: string | undefined
              readonly salaryExpectations?: string | undefined
              readonly candidateLicenses?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly date?: any | undefined
                    readonly number?: string | undefined
                    readonly url?: string | undefined
                    readonly license?:
                      | {
                          readonly id: string
                          readonly name: string
                          readonly country: CountriesEnum
                          readonly state?: string | undefined
                        }
                      | undefined
                  }>
                | undefined
              readonly credentials?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly title: string
                    readonly badgeUrl: string
                    readonly description?: string | undefined
                    readonly training: {
                      readonly id: string
                      readonly trainingUrl: string
                    }
                  }>
                | undefined
              readonly education?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly degree?: string | undefined
                    readonly educationLevel?: EducationLevelEnum | undefined
                    readonly school?: string | undefined
                    readonly yearsAttended?: number | undefined
                  }>
                | undefined
              readonly experiences?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly companyName?: string | undefined
                    readonly current?: boolean | undefined
                    readonly endDate?: any | undefined
                    readonly jobTitle?: string | undefined
                    readonly responsibilities?: string | undefined
                    readonly startDate?: any | undefined
                    readonly yearsEmployed?: number | undefined
                  }>
                | undefined
              readonly placements?:
                | ReadonlyArray<{
                    readonly startDate?: any | undefined
                    readonly id: string
                    readonly interviewDate?: any | undefined
                    readonly status?: PlacementStatusEnum | undefined
                    readonly permissions: { readonly update: boolean }
                    readonly jobPosting: {
                      readonly id: string
                      readonly slug: string
                      readonly title: string
                      readonly client?:
                        | { readonly displayname: string }
                        | undefined
                      readonly permissions: {
                        readonly readJobApps: boolean
                        readonly readPlacements: boolean
                      }
                    }
                  }>
                | undefined
              readonly jobApplications?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly status?: JobApplicationStatusEnum | undefined
                    readonly permissions: { readonly show: boolean }
                    readonly jobPosting: {
                      readonly id: string
                      readonly level?: number | undefined
                      readonly slug: string
                      readonly title: string
                      readonly client?:
                        | {
                            readonly displayname: string
                            readonly name: string
                          }
                        | undefined
                      readonly permissions: {
                        readonly readJobApps: boolean
                        readonly readPlacements: boolean
                        readonly managePlacements: boolean
                      }
                      readonly jobPostingScreening?:
                        | { readonly id: string }
                        | undefined
                    }
                    readonly screeningSubmissions?:
                      | ReadonlyArray<{ readonly id: string }>
                      | undefined
                  }>
                | undefined
              readonly permissions: {
                readonly edit: boolean
                readonly readApplications: boolean
                readonly readCredentials: boolean
                readonly readLicense: boolean
                readonly readResume: boolean
                readonly readWorkPreferences: boolean
              }
              readonly recruiters?:
                | ReadonlyArray<{
                    readonly avatarUrl?: string | undefined
                    readonly firstName: string
                    readonly id: string
                    readonly lastName: string
                  }>
                | undefined
              readonly skillRelations?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly years: number
                    readonly skill: {
                      readonly __typename: 'Skill'
                      readonly id: string
                      readonly name: string
                    }
                  }>
                | undefined
              readonly summary?:
                | {
                    readonly id: string
                    readonly entry: string
                    readonly title: string
                  }
                | undefined
            }
          | undefined
        readonly subscription?:
          | {
              readonly __typename: 'Subscription'
              readonly id: string
              readonly active: boolean
              readonly plan: string
            }
          | undefined
      }
    | {}
    | undefined
  >
}

export type PageFragment = {
  readonly createdAt: any
  readonly description?: string | undefined
  readonly id: string
  readonly markdownContent?: string | undefined
  readonly pageType?: PageTypeEnum | undefined
  readonly postedAt?: any | undefined
  readonly rawUrl?: string | undefined
  readonly subtitle?: string | undefined
  readonly title?: string | undefined
  readonly updatedAt: any
  readonly author?:
    | {
        readonly id: string
        readonly avatarUrl?: string | undefined
        readonly firstName: string
        readonly lastName: string
        readonly username: string
      }
    | undefined
  readonly metaInfo: {
    readonly canonicalUrl?: string | undefined
    readonly createdAt: any
    readonly description: string
    readonly id: string
    readonly robots?: RobotsEnum | undefined
    readonly title: string
    readonly updatedAt: any
  }
  readonly pagePhotos?:
    | ReadonlyArray<{
        readonly id: string
        readonly alt: string
        readonly height: number
        readonly mediaType?: PagePhotoMediaTypeEnum | undefined
        readonly width: number
        readonly url: string
      }>
    | undefined
  readonly search?:
    | {
        readonly id: string
        readonly domainQueryName: string
        readonly queryString: string
        readonly resourceType: EsResultEnum
      }
    | undefined
}

export type MetaInfoFragment = {
  readonly canonicalUrl?: string | undefined
  readonly createdAt: any
  readonly description: string
  readonly id: string
  readonly robots?: RobotsEnum | undefined
  readonly title: string
  readonly updatedAt: any
}

export type PageQueryVariables = Exact<{
  rawUrl?: InputMaybe<Scalars['String']['input']>
}>

export type PageQuery = {
  readonly getPage?:
    | {
        readonly createdAt: any
        readonly description?: string | undefined
        readonly id: string
        readonly markdownContent?: string | undefined
        readonly pageType?: PageTypeEnum | undefined
        readonly postedAt?: any | undefined
        readonly rawUrl?: string | undefined
        readonly subtitle?: string | undefined
        readonly title?: string | undefined
        readonly updatedAt: any
        readonly author?:
          | {
              readonly id: string
              readonly avatarUrl?: string | undefined
              readonly firstName: string
              readonly lastName: string
              readonly username: string
            }
          | undefined
        readonly metaInfo: {
          readonly canonicalUrl?: string | undefined
          readonly createdAt: any
          readonly description: string
          readonly id: string
          readonly robots?: RobotsEnum | undefined
          readonly title: string
          readonly updatedAt: any
        }
        readonly pagePhotos?:
          | ReadonlyArray<{
              readonly id: string
              readonly alt: string
              readonly height: number
              readonly mediaType?: PagePhotoMediaTypeEnum | undefined
              readonly width: number
              readonly url: string
            }>
          | undefined
        readonly search?:
          | {
              readonly id: string
              readonly domainQueryName: string
              readonly queryString: string
              readonly resourceType: EsResultEnum
            }
          | undefined
      }
    | undefined
}

export type CreatePageMutationVariables = Exact<{
  input: CreatePageInput
}>

export type CreatePageMutation = {
  readonly createPage?:
    | {
        readonly createdAt: any
        readonly description?: string | undefined
        readonly id: string
        readonly markdownContent?: string | undefined
        readonly pageType?: PageTypeEnum | undefined
        readonly postedAt?: any | undefined
        readonly rawUrl?: string | undefined
        readonly subtitle?: string | undefined
        readonly title?: string | undefined
        readonly updatedAt: any
        readonly author?:
          | {
              readonly id: string
              readonly avatarUrl?: string | undefined
              readonly firstName: string
              readonly lastName: string
              readonly username: string
            }
          | undefined
        readonly metaInfo: {
          readonly canonicalUrl?: string | undefined
          readonly createdAt: any
          readonly description: string
          readonly id: string
          readonly robots?: RobotsEnum | undefined
          readonly title: string
          readonly updatedAt: any
        }
        readonly pagePhotos?:
          | ReadonlyArray<{
              readonly id: string
              readonly alt: string
              readonly height: number
              readonly mediaType?: PagePhotoMediaTypeEnum | undefined
              readonly width: number
              readonly url: string
            }>
          | undefined
        readonly search?:
          | {
              readonly id: string
              readonly domainQueryName: string
              readonly queryString: string
              readonly resourceType: EsResultEnum
            }
          | undefined
      }
    | undefined
}

export type UpdatePageMutationVariables = Exact<{
  input: UpdatePageInput
}>

export type UpdatePageMutation = {
  readonly updatePage?:
    | {
        readonly createdAt: any
        readonly description?: string | undefined
        readonly id: string
        readonly markdownContent?: string | undefined
        readonly pageType?: PageTypeEnum | undefined
        readonly postedAt?: any | undefined
        readonly rawUrl?: string | undefined
        readonly subtitle?: string | undefined
        readonly title?: string | undefined
        readonly updatedAt: any
        readonly author?:
          | {
              readonly id: string
              readonly avatarUrl?: string | undefined
              readonly firstName: string
              readonly lastName: string
              readonly username: string
            }
          | undefined
        readonly metaInfo: {
          readonly canonicalUrl?: string | undefined
          readonly createdAt: any
          readonly description: string
          readonly id: string
          readonly robots?: RobotsEnum | undefined
          readonly title: string
          readonly updatedAt: any
        }
        readonly pagePhotos?:
          | ReadonlyArray<{
              readonly id: string
              readonly alt: string
              readonly height: number
              readonly mediaType?: PagePhotoMediaTypeEnum | undefined
              readonly width: number
              readonly url: string
            }>
          | undefined
        readonly search?:
          | {
              readonly id: string
              readonly domainQueryName: string
              readonly queryString: string
              readonly resourceType: EsResultEnum
            }
          | undefined
      }
    | undefined
}

export type PagesQueryVariables = Exact<{
  rawUrl?: InputMaybe<Scalars['String']['input']>
  rawUrlCont?: InputMaybe<Scalars['String']['input']>
  rawUrlEndsWith?: InputMaybe<Scalars['String']['input']>
  ids?: InputMaybe<Scalars['String']['input']>
  beforePostedAt?: InputMaybe<Scalars['ISO8601Date']['input']>
  afterPostedAt?: InputMaybe<Scalars['ISO8601Date']['input']>
  postedAtStart?: InputMaybe<Scalars['ISO8601Date']['input']>
  postedAtEnd?: InputMaybe<Scalars['ISO8601Date']['input']>
  pageType?: InputMaybe<ReadonlyArray<PageTypeEnum> | PageTypeEnum>
}>

export type PagesQuery = {
  readonly getPages?:
    | ReadonlyArray<{
        readonly createdAt: any
        readonly description?: string | undefined
        readonly id: string
        readonly markdownContent?: string | undefined
        readonly pageType?: PageTypeEnum | undefined
        readonly postedAt?: any | undefined
        readonly rawUrl?: string | undefined
        readonly subtitle?: string | undefined
        readonly title?: string | undefined
        readonly updatedAt: any
        readonly author?:
          | {
              readonly id: string
              readonly avatarUrl?: string | undefined
              readonly firstName: string
              readonly lastName: string
              readonly username: string
            }
          | undefined
        readonly metaInfo: {
          readonly canonicalUrl?: string | undefined
          readonly createdAt: any
          readonly description: string
          readonly id: string
          readonly robots?: RobotsEnum | undefined
          readonly title: string
          readonly updatedAt: any
        }
        readonly pagePhotos?:
          | ReadonlyArray<{
              readonly id: string
              readonly alt: string
              readonly height: number
              readonly mediaType?: PagePhotoMediaTypeEnum | undefined
              readonly width: number
              readonly url: string
            }>
          | undefined
        readonly search?:
          | {
              readonly id: string
              readonly domainQueryName: string
              readonly queryString: string
              readonly resourceType: EsResultEnum
            }
          | undefined
      }>
    | undefined
}

export type GetSalaryGuideQueryVariables = Exact<{ [key: string]: never }>

export type GetSalaryGuideQuery = {
  readonly getReport: { readonly __typename: 'Report'; readonly url: string }
}

export type GetJobsReportQueryVariables = Exact<{ [key: string]: never }>

export type GetJobsReportQuery = {
  readonly getReport: { readonly __typename: 'Report'; readonly url: string }
}

type EsResult_EsCandidateResult_Fragment = {
  readonly id: string
  readonly score: string
  readonly highlight: any
  readonly label: string
  readonly slug: string
  readonly type: EsResultEnum
}

type EsResult_EsClientResult_Fragment = {
  readonly id: string
  readonly score: string
  readonly highlight: any
  readonly label: string
  readonly slug: string
  readonly type: EsResultEnum
}

type EsResult_EsCredentialResult_Fragment = {
  readonly id: string
  readonly score: string
  readonly highlight: any
  readonly label: string
  readonly slug: string
  readonly type: EsResultEnum
}

type EsResult_EsJobPostingResult_Fragment = {
  readonly id: string
  readonly score: string
  readonly highlight: any
  readonly label: string
  readonly slug: string
  readonly type: EsResultEnum
}

type EsResult_EsSlugNameResult_Fragment = {
  readonly id: string
  readonly score: string
  readonly highlight: any
  readonly label: string
  readonly slug: string
  readonly type: EsResultEnum
}

export type EsResultFragment =
  | EsResult_EsCandidateResult_Fragment
  | EsResult_EsClientResult_Fragment
  | EsResult_EsCredentialResult_Fragment
  | EsResult_EsJobPostingResult_Fragment
  | EsResult_EsSlugNameResult_Fragment

export type EsSlugNameResultFragment = {
  readonly id: string
  readonly name: string
  readonly slug: string
  readonly avatarUrl?: string | undefined
  readonly type: EsResultEnum
}

export type EsCompanyResultConnectionFragment = {
  readonly edges?:
    | ReadonlyArray<
        | {
            readonly cursor: string
            readonly node?:
              | {
                  readonly id: string
                  readonly score: string
                  readonly highlight: any
                  readonly label: string
                  readonly slug: string
                  readonly type: EsResultEnum
                }
              | undefined
          }
        | undefined
      >
    | undefined
  readonly pageInfo: {
    readonly endCursor?: string | undefined
    readonly hasNextPage: boolean
    readonly hasPreviousPage: boolean
    readonly startCursor?: string | undefined
    readonly totalCount: number
  }
}

export type EsCredentialResultConnectionFragment = {
  readonly edges?:
    | ReadonlyArray<
        | {
            readonly cursor: string
            readonly node?:
              | {
                  readonly id: string
                  readonly score: string
                  readonly highlight: any
                  readonly label: string
                  readonly slug: string
                  readonly type: EsResultEnum
                }
              | undefined
          }
        | undefined
      >
    | undefined
  readonly pageInfo: {
    readonly endCursor?: string | undefined
    readonly hasNextPage: boolean
    readonly hasPreviousPage: boolean
    readonly startCursor?: string | undefined
    readonly totalCount: number
  }
}

export type EsJobPostingResultConnectionFragment = {
  readonly edges?:
    | ReadonlyArray<
        | {
            readonly cursor: string
            readonly node?:
              | {
                  readonly id: string
                  readonly score: string
                  readonly highlight: any
                  readonly label: string
                  readonly slug: string
                  readonly type: EsResultEnum
                }
              | undefined
          }
        | undefined
      >
    | undefined
  readonly pageInfo: {
    readonly endCursor?: string | undefined
    readonly hasNextPage: boolean
    readonly hasPreviousPage: boolean
    readonly startCursor?: string | undefined
    readonly totalCount: number
  }
}

export type EsMemberResultConnectionFragment = {
  readonly edges?:
    | ReadonlyArray<
        | {
            readonly cursor: string
            readonly node?:
              | {
                  readonly id: string
                  readonly score: string
                  readonly highlight: any
                  readonly label: string
                  readonly slug: string
                  readonly type: EsResultEnum
                }
              | undefined
          }
        | undefined
      >
    | undefined
  readonly pageInfo: {
    readonly endCursor?: string | undefined
    readonly hasNextPage: boolean
    readonly hasPreviousPage: boolean
    readonly startCursor?: string | undefined
    readonly totalCount: number
  }
}

export type EsSlugNameResultConnectionFragment = {
  readonly edges?:
    | ReadonlyArray<
        | {
            readonly cursor: string
            readonly node?:
              | {
                  readonly id: string
                  readonly name: string
                  readonly slug: string
                  readonly avatarUrl?: string | undefined
                  readonly type: EsResultEnum
                }
              | undefined
          }
        | undefined
      >
    | undefined
}

export type SearchCompaniesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companySize?: InputMaybe<CompanySizeEnum>
  first?: InputMaybe<Scalars['Int']['input']>
  hasTraining?: InputMaybe<Scalars['Boolean']['input']>
  hiring?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  matchLocation?: InputMaybe<SearchMatchLocationInput>
  radiusLocation?: InputMaybe<SearchRadiusLocationInput>
  term?: InputMaybe<Scalars['String']['input']>
}>

export type SearchCompaniesQuery = {
  readonly searchClients: {
    readonly edges?:
      | ReadonlyArray<
          | {
              readonly cursor: string
              readonly node?:
                | {
                    readonly id: string
                    readonly score: string
                    readonly highlight: any
                    readonly label: string
                    readonly slug: string
                    readonly type: EsResultEnum
                  }
                | undefined
            }
          | undefined
        >
      | undefined
    readonly pageInfo: {
      readonly endCursor?: string | undefined
      readonly hasNextPage: boolean
      readonly hasPreviousPage: boolean
      readonly startCursor?: string | undefined
      readonly totalCount: number
    }
  }
}

export type SearchCredentialsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  term?: InputMaybe<Scalars['String']['input']>
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>
}>

export type SearchCredentialsQuery = {
  readonly searchCredentials: {
    readonly edges?:
      | ReadonlyArray<
          | {
              readonly cursor: string
              readonly node?:
                | {
                    readonly id: string
                    readonly score: string
                    readonly highlight: any
                    readonly label: string
                    readonly slug: string
                    readonly type: EsResultEnum
                  }
                | undefined
            }
          | undefined
        >
      | undefined
    readonly pageInfo: {
      readonly endCursor?: string | undefined
      readonly hasNextPage: boolean
      readonly hasPreviousPage: boolean
      readonly startCursor?: string | undefined
      readonly totalCount: number
    }
  }
}

export type SearchCompaniesByRecruitersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companySize?: InputMaybe<CompanySizeEnum>
  first?: InputMaybe<Scalars['Int']['input']>
  hasTraining?: InputMaybe<Scalars['Boolean']['input']>
  hiring?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  matchLocation?: InputMaybe<SearchMatchLocationInput>
  radiusLocation?: InputMaybe<SearchRadiusLocationInput>
  term?: InputMaybe<Scalars['String']['input']>
  visibleOnPlatform?: InputMaybe<Scalars['Boolean']['input']>
}>

export type SearchCompaniesByRecruitersQuery = {
  readonly searchClientsByRecruiters: {
    readonly edges?:
      | ReadonlyArray<
          | {
              readonly cursor: string
              readonly node?:
                | {
                    readonly id: string
                    readonly score: string
                    readonly highlight: any
                    readonly label: string
                    readonly slug: string
                    readonly type: EsResultEnum
                  }
                | undefined
            }
          | undefined
        >
      | undefined
    readonly pageInfo: {
      readonly endCursor?: string | undefined
      readonly hasNextPage: boolean
      readonly hasPreviousPage: boolean
      readonly startCursor?: string | undefined
      readonly totalCount: number
    }
  }
}

export type SearchJobPostingsQueryVariables = Exact<{
  applyDefaults?: InputMaybe<ApplyDefaultsEnum>
  after?: InputMaybe<Scalars['String']['input']>
  atsRecordTypes?: InputMaybe<
    ReadonlyArray<AtsRecordTypeEnum> | AtsRecordTypeEnum
  >
  atsStatus?: InputMaybe<
    ReadonlyArray<JobPostingAtsStatusEnum> | JobPostingAtsStatusEnum
  >
  before?: InputMaybe<Scalars['String']['input']>
  betweenTimes?: InputMaybe<SearchBetweenTimesInput>
  displayname?: InputMaybe<Scalars['String']['input']>
  associatedClientDisplayname?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  isRemote?: InputMaybe<Scalars['Boolean']['input']>
  jobStartDateBetween?: InputMaybe<SearchJobStartDateBetweenInput>
  last?: InputMaybe<Scalars['Int']['input']>
  matchLocation?: InputMaybe<SearchMatchLocationInput>
  orderBy?: InputMaybe<OrderByEnum>
  radiusLocation?: InputMaybe<SearchRadiusLocationInput>
  requiredLicenseIds?: InputMaybe<
    ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']
  >
  term?: InputMaybe<Scalars['String']['input']>
  employmentTypes?: InputMaybe<
    ReadonlyArray<EmploymentTypesEnum> | EmploymentTypesEnum
  >
}>

export type SearchJobPostingsQuery = {
  readonly searchJobPostings: {
    readonly edges?:
      | ReadonlyArray<
          | {
              readonly cursor: string
              readonly node?:
                | {
                    readonly id: string
                    readonly score: string
                    readonly highlight: any
                    readonly label: string
                    readonly slug: string
                    readonly type: EsResultEnum
                  }
                | undefined
            }
          | undefined
        >
      | undefined
    readonly pageInfo: {
      readonly endCursor?: string | undefined
      readonly hasNextPage: boolean
      readonly hasPreviousPage: boolean
      readonly startCursor?: string | undefined
      readonly totalCount: number
    }
  }
}

export type SearchJobPostingsByRecruitersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>
  atsRecordTypes?: InputMaybe<
    ReadonlyArray<AtsRecordTypeEnum> | AtsRecordTypeEnum
  >
  atsStatus?: InputMaybe<
    ReadonlyArray<JobPostingAtsStatusEnum> | JobPostingAtsStatusEnum
  >
  before?: InputMaybe<Scalars['String']['input']>
  betweenTimes?: InputMaybe<SearchBetweenTimesInput>
  first?: InputMaybe<Scalars['Int']['input']>
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  isRemote?: InputMaybe<Scalars['Boolean']['input']>
  jobStartDateBetween?: InputMaybe<SearchJobStartDateBetweenInput>
  last?: InputMaybe<Scalars['Int']['input']>
  matchLocation?: InputMaybe<SearchMatchLocationInput>
  radiusLocation?: InputMaybe<SearchRadiusLocationInput>
  recruiterUsername?: InputMaybe<Scalars['String']['input']>
  requiredLicenseIds?: InputMaybe<
    ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']
  >
  term?: InputMaybe<Scalars['String']['input']>
  employmentTypes?: InputMaybe<
    ReadonlyArray<EmploymentTypesEnum> | EmploymentTypesEnum
  >
  visibleClient?: InputMaybe<Scalars['Boolean']['input']>
}>

export type SearchJobPostingsByRecruitersQuery = {
  readonly searchJobPostingsByRecruiters: {
    readonly edges?:
      | ReadonlyArray<
          | {
              readonly cursor: string
              readonly node?:
                | {
                    readonly id: string
                    readonly score: string
                    readonly highlight: any
                    readonly label: string
                    readonly slug: string
                    readonly type: EsResultEnum
                  }
                | undefined
            }
          | undefined
        >
      | undefined
    readonly pageInfo: {
      readonly endCursor?: string | undefined
      readonly hasNextPage: boolean
      readonly hasPreviousPage: boolean
      readonly startCursor?: string | undefined
      readonly totalCount: number
    }
  }
}

export type SearchMembersQueryVariables = Exact<{
  acceptedMemberConnectionsFor?: InputMaybe<Scalars['String']['input']>
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  isRecruiter?: InputMaybe<Scalars['Boolean']['input']>
  matchLocation?: InputMaybe<SearchMatchLocationInput>
  radiusLocation?: InputMaybe<SearchRadiusLocationInput>
  skills?: InputMaybe<
    ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']
  >
  term?: InputMaybe<Scalars['String']['input']>
}>

export type SearchMembersQuery = {
  readonly searchCandidates: {
    readonly edges?:
      | ReadonlyArray<
          | {
              readonly cursor: string
              readonly node?:
                | {
                    readonly id: string
                    readonly score: string
                    readonly highlight: any
                    readonly label: string
                    readonly slug: string
                    readonly type: EsResultEnum
                  }
                | undefined
            }
          | undefined
        >
      | undefined
    readonly pageInfo: {
      readonly endCursor?: string | undefined
      readonly hasNextPage: boolean
      readonly hasPreviousPage: boolean
      readonly startCursor?: string | undefined
      readonly totalCount: number
    }
  }
}

export type SearchSlugNamesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  term?: InputMaybe<Scalars['String']['input']>
}>

export type SearchSlugNamesQuery = {
  readonly searchSlugNames: {
    readonly edges?:
      | ReadonlyArray<
          | {
              readonly cursor: string
              readonly node?:
                | {
                    readonly id: string
                    readonly name: string
                    readonly slug: string
                    readonly avatarUrl?: string | undefined
                    readonly type: EsResultEnum
                  }
                | undefined
            }
          | undefined
        >
      | undefined
  }
}

export type SearchCandidatesByClientsQueryVariables = Exact<{
  acceptedMemberConnectionsFor?: InputMaybe<Scalars['String']['input']>
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  hasALicense?: InputMaybe<Scalars['Boolean']['input']>
  hasResume?: InputMaybe<Scalars['Boolean']['input']>
  hasWorkExperience?: InputMaybe<Scalars['Boolean']['input']>
  hiringStatus?: InputMaybe<ReadonlyArray<HiringStatusEnum> | HiringStatusEnum>
  isNeedEmploymentSponsor?: InputMaybe<Scalars['Boolean']['input']>
  isUsWorkAuthorized?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  matchLocation?: InputMaybe<SearchMatchLocationInput>
  possessedLicenseIds?: InputMaybe<
    ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']
  >
  radiusLocation?: InputMaybe<SearchRadiusLocationInput>
  skills?: InputMaybe<
    ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']
  >
  term?: InputMaybe<Scalars['String']['input']>
}>

export type SearchCandidatesByClientsQuery = {
  readonly searchCandidatesByClients: {
    readonly edges?:
      | ReadonlyArray<
          | {
              readonly cursor: string
              readonly node?:
                | {
                    readonly id: string
                    readonly score: string
                    readonly highlight: any
                    readonly label: string
                    readonly slug: string
                    readonly type: EsResultEnum
                  }
                | undefined
            }
          | undefined
        >
      | undefined
    readonly pageInfo: {
      readonly endCursor?: string | undefined
      readonly hasNextPage: boolean
      readonly hasPreviousPage: boolean
      readonly startCursor?: string | undefined
      readonly totalCount: number
    }
  }
}

export type SearchCandidatesByRecruitersQueryVariables = Exact<{
  acceptedMemberConnectionsFor?: InputMaybe<Scalars['String']['input']>
  hasALicense?: InputMaybe<Scalars['Boolean']['input']>
  hasResume?: InputMaybe<Scalars['Boolean']['input']>
  hasWorkExperience?: InputMaybe<Scalars['Boolean']['input']>
  hiringStatus?: InputMaybe<ReadonlyArray<HiringStatusEnum> | HiringStatusEnum>
  isAbleToApply?: InputMaybe<Scalars['Boolean']['input']>
  isNeedEmploymentSponsor?: InputMaybe<Scalars['Boolean']['input']>
  isRecruiter?: InputMaybe<Scalars['Boolean']['input']>
  isAccountExec?: InputMaybe<Scalars['Boolean']['input']>
  isUsWorkAuthorized?: InputMaybe<Scalars['Boolean']['input']>
  matchLocation?: InputMaybe<SearchMatchLocationInput>
  placementStatus?: InputMaybe<
    ReadonlyArray<PlacementStatusEnum> | PlacementStatusEnum
  >
  placementsForCompany?: InputMaybe<Scalars['String']['input']>
  possessedLicenseIds?: InputMaybe<
    ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']
  >
  recruiter?: InputMaybe<Scalars['String']['input']>
  radiusLocation?: InputMaybe<SearchRadiusLocationInput>
  skills?: InputMaybe<
    ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']
  >
  term?: InputMaybe<Scalars['String']['input']>
  termsAccepted?: InputMaybe<Scalars['Boolean']['input']>
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}>

export type SearchCandidatesByRecruitersQuery = {
  readonly searchCandidatesByRecruiters: {
    readonly edges?:
      | ReadonlyArray<
          | {
              readonly cursor: string
              readonly node?:
                | {
                    readonly id: string
                    readonly score: string
                    readonly highlight: any
                    readonly label: string
                    readonly slug: string
                    readonly type: EsResultEnum
                  }
                | undefined
            }
          | undefined
        >
      | undefined
    readonly pageInfo: {
      readonly endCursor?: string | undefined
      readonly hasNextPage: boolean
      readonly hasPreviousPage: boolean
      readonly startCursor?: string | undefined
      readonly totalCount: number
    }
  }
}

export type SubscriptionFragment = {
  readonly __typename: 'Subscription'
  readonly id: string
  readonly name: string
  readonly plan: string
  readonly active: boolean
  readonly userId: string
}

export type SubscriptionQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type SubscriptionQuery = {
  readonly getSubscription: {
    readonly __typename: 'Subscription'
    readonly id: string
    readonly name: string
    readonly plan: string
    readonly active: boolean
    readonly userId: string
  }
}

export type CreateSubscriptionMutationVariables = Exact<{
  input: SubscriptionInput
}>

export type CreateSubscriptionMutation = {
  readonly createSubscription: {
    readonly __typename: 'Subscription'
    readonly id: string
    readonly name: string
    readonly plan: string
    readonly active: boolean
    readonly userId: string
  }
}

export type UpdateSubscriptionMutationVariables = Exact<{
  input: SubscriptionInput
}>

export type UpdateSubscriptionMutation = {
  readonly updateSubscription: {
    readonly __typename: 'Subscription'
    readonly id: string
    readonly name: string
    readonly plan: string
    readonly active: boolean
    readonly userId: string
  }
}

export type ClientTrainingFragment = {
  readonly __typename: 'ClientTraining'
  readonly id: string
  readonly client: { readonly displayname: string }
  readonly training: {
    readonly __typename: 'Training'
    readonly id: string
    readonly currentUserPassed: boolean
    readonly countCandidatesCompletedTraining: number
    readonly description: string
    readonly isPublished: boolean
    readonly slug: string
    readonly title: string
    readonly totalQuestionsCount: number
    readonly totalTimeToComplete: number
    readonly trainingUrl: string
    readonly creatorClient: {
      readonly id: string
      readonly avatarUrl?: string | undefined
      readonly displayname: string
    }
    readonly credential: {
      readonly id: string
      readonly badgeUrl: string
      readonly description?: string | undefined
      readonly title: string
    }
    readonly permissions: {
      readonly viewCount: boolean
      readonly viewTrainingMembers: boolean
    }
    readonly quizzes: ReadonlyArray<{
      readonly __typename: 'Quiz'
      readonly createdAt: any
      readonly id: string
      readonly description: string
      readonly slug: string
      readonly timeToComplete?: number | undefined
      readonly title: string
      readonly totalCorrectToGainCertification: number
      readonly totalQuestions?: number | undefined
      readonly videoUrl: string
      readonly currentUserQuizAttempts?:
        | ReadonlyArray<{
            readonly __typename: 'QuizAttempt'
            readonly id: string
            readonly createdAt: any
            readonly grade?: number | undefined
            readonly status: QuizAttemptStatusEnum
            readonly userCurrentQuestionAttempt?:
              | {
                  readonly __typename: 'QuestionAttempt'
                  readonly id: string
                  readonly quizQuestion: {
                    readonly sortPosition?: number | undefined
                    readonly question: {
                      readonly value: string
                      readonly questionAnswerType?:
                        | QuestionAnswerTypeEnum
                        | undefined
                    }
                    readonly questionAnswers: ReadonlyArray<{
                      readonly id: string
                      readonly answer: string
                    }>
                  }
                }
              | undefined
          }>
        | undefined
    }>
  }
}

export type TrainingFragment = {
  readonly __typename: 'Training'
  readonly id: string
  readonly currentUserPassed: boolean
  readonly countCandidatesCompletedTraining: number
  readonly description: string
  readonly isPublished: boolean
  readonly slug: string
  readonly title: string
  readonly totalQuestionsCount: number
  readonly totalTimeToComplete: number
  readonly trainingUrl: string
  readonly creatorClient: {
    readonly id: string
    readonly avatarUrl?: string | undefined
    readonly displayname: string
  }
  readonly credential: {
    readonly id: string
    readonly badgeUrl: string
    readonly description?: string | undefined
    readonly title: string
  }
  readonly permissions: {
    readonly viewCount: boolean
    readonly viewTrainingMembers: boolean
  }
  readonly quizzes: ReadonlyArray<{
    readonly __typename: 'Quiz'
    readonly createdAt: any
    readonly id: string
    readonly description: string
    readonly slug: string
    readonly timeToComplete?: number | undefined
    readonly title: string
    readonly totalCorrectToGainCertification: number
    readonly totalQuestions?: number | undefined
    readonly videoUrl: string
    readonly currentUserQuizAttempts?:
      | ReadonlyArray<{
          readonly __typename: 'QuizAttempt'
          readonly id: string
          readonly createdAt: any
          readonly grade?: number | undefined
          readonly status: QuizAttemptStatusEnum
          readonly userCurrentQuestionAttempt?:
            | {
                readonly __typename: 'QuestionAttempt'
                readonly id: string
                readonly quizQuestion: {
                  readonly sortPosition?: number | undefined
                  readonly question: {
                    readonly value: string
                    readonly questionAnswerType?:
                      | QuestionAnswerTypeEnum
                      | undefined
                  }
                  readonly questionAnswers: ReadonlyArray<{
                    readonly id: string
                    readonly answer: string
                  }>
                }
              }
            | undefined
        }>
      | undefined
  }>
}

export type ClientTrainingConnectionFragment = {
  readonly edges?:
    | ReadonlyArray<
        | {
            readonly __typename: 'ClientTrainingEdge'
            readonly cursor: string
            readonly node?:
              | {
                  readonly __typename: 'ClientTraining'
                  readonly id: string
                  readonly client: { readonly displayname: string }
                  readonly training: {
                    readonly __typename: 'Training'
                    readonly id: string
                    readonly currentUserPassed: boolean
                    readonly countCandidatesCompletedTraining: number
                    readonly description: string
                    readonly isPublished: boolean
                    readonly slug: string
                    readonly title: string
                    readonly totalQuestionsCount: number
                    readonly totalTimeToComplete: number
                    readonly trainingUrl: string
                    readonly creatorClient: {
                      readonly id: string
                      readonly avatarUrl?: string | undefined
                      readonly displayname: string
                    }
                    readonly credential: {
                      readonly id: string
                      readonly badgeUrl: string
                      readonly description?: string | undefined
                      readonly title: string
                    }
                    readonly permissions: {
                      readonly viewCount: boolean
                      readonly viewTrainingMembers: boolean
                    }
                    readonly quizzes: ReadonlyArray<{
                      readonly __typename: 'Quiz'
                      readonly createdAt: any
                      readonly id: string
                      readonly description: string
                      readonly slug: string
                      readonly timeToComplete?: number | undefined
                      readonly title: string
                      readonly totalCorrectToGainCertification: number
                      readonly totalQuestions?: number | undefined
                      readonly videoUrl: string
                      readonly currentUserQuizAttempts?:
                        | ReadonlyArray<{
                            readonly __typename: 'QuizAttempt'
                            readonly id: string
                            readonly createdAt: any
                            readonly grade?: number | undefined
                            readonly status: QuizAttemptStatusEnum
                            readonly userCurrentQuestionAttempt?:
                              | {
                                  readonly __typename: 'QuestionAttempt'
                                  readonly id: string
                                  readonly quizQuestion: {
                                    readonly sortPosition?: number | undefined
                                    readonly question: {
                                      readonly value: string
                                      readonly questionAnswerType?:
                                        | QuestionAnswerTypeEnum
                                        | undefined
                                    }
                                    readonly questionAnswers: ReadonlyArray<{
                                      readonly id: string
                                      readonly answer: string
                                    }>
                                  }
                                }
                              | undefined
                          }>
                        | undefined
                    }>
                  }
                }
              | undefined
          }
        | undefined
      >
    | undefined
  readonly pageInfo: {
    readonly endCursor?: string | undefined
    readonly hasNextPage: boolean
    readonly hasPreviousPage: boolean
    readonly startCursor?: string | undefined
    readonly totalCount: number
  }
}

export type ClientTrainingEdgeFragment = {
  readonly __typename: 'ClientTrainingEdge'
  readonly cursor: string
  readonly node?:
    | {
        readonly __typename: 'ClientTraining'
        readonly id: string
        readonly client: { readonly displayname: string }
        readonly training: {
          readonly __typename: 'Training'
          readonly id: string
          readonly currentUserPassed: boolean
          readonly countCandidatesCompletedTraining: number
          readonly description: string
          readonly isPublished: boolean
          readonly slug: string
          readonly title: string
          readonly totalQuestionsCount: number
          readonly totalTimeToComplete: number
          readonly trainingUrl: string
          readonly creatorClient: {
            readonly id: string
            readonly avatarUrl?: string | undefined
            readonly displayname: string
          }
          readonly credential: {
            readonly id: string
            readonly badgeUrl: string
            readonly description?: string | undefined
            readonly title: string
          }
          readonly permissions: {
            readonly viewCount: boolean
            readonly viewTrainingMembers: boolean
          }
          readonly quizzes: ReadonlyArray<{
            readonly __typename: 'Quiz'
            readonly createdAt: any
            readonly id: string
            readonly description: string
            readonly slug: string
            readonly timeToComplete?: number | undefined
            readonly title: string
            readonly totalCorrectToGainCertification: number
            readonly totalQuestions?: number | undefined
            readonly videoUrl: string
            readonly currentUserQuizAttempts?:
              | ReadonlyArray<{
                  readonly __typename: 'QuizAttempt'
                  readonly id: string
                  readonly createdAt: any
                  readonly grade?: number | undefined
                  readonly status: QuizAttemptStatusEnum
                  readonly userCurrentQuestionAttempt?:
                    | {
                        readonly __typename: 'QuestionAttempt'
                        readonly id: string
                        readonly quizQuestion: {
                          readonly sortPosition?: number | undefined
                          readonly question: {
                            readonly value: string
                            readonly questionAnswerType?:
                              | QuestionAnswerTypeEnum
                              | undefined
                          }
                          readonly questionAnswers: ReadonlyArray<{
                            readonly id: string
                            readonly answer: string
                          }>
                        }
                      }
                    | undefined
                }>
              | undefined
          }>
        }
      }
    | undefined
}

export type TrainingMemberConnectionFragment = {
  readonly edges?:
    | ReadonlyArray<
        | {
            readonly __typename: 'UserEdge'
            readonly cursor: string
            readonly node?:
              | {
                  readonly __typename: 'User'
                  readonly id: string
                  readonly username: string
                  readonly availability?: string | undefined
                  readonly avatarUrl?: string | undefined
                  readonly connectionCount: number
                  readonly connectionStatus?: ConnectionStatusEnum | undefined
                  readonly email?: string | undefined
                  readonly secondaryEmail?: string | undefined
                  readonly firstName: string
                  readonly indispensableSurveyLink: string
                  readonly isCurrentUser: boolean
                  readonly lastName: string
                  readonly termsAcceptedAt?: any | undefined
                  readonly phoneNumber?: string | undefined
                  readonly uri: string
                  readonly activities?:
                    | { readonly pageInfo: { readonly totalCount: number } }
                    | undefined
                  readonly alerts?:
                    | { readonly pageInfo: { readonly totalCount: number } }
                    | undefined
                  readonly gigsEmployee?:
                    | {
                        readonly id: string
                        readonly createdAt: any
                        readonly deletedAt?: any | undefined
                        readonly eligibleAt?: any | undefined
                        readonly offboardedAt?: any | undefined
                        readonly onboardedAt?: any | undefined
                        readonly onboardingStatus: OnboardingStatusEnum
                        readonly percentComplete?: number | undefined
                        readonly rejectedAt?: any | undefined
                        readonly savedAt?: any | undefined
                        readonly screeningAt?: any | undefined
                        readonly terminatedAt?: any | undefined
                        readonly updatedAt: any
                        readonly permissions: { readonly seeHistory: boolean }
                      }
                    | undefined
                  readonly location: {
                    readonly address?: string | undefined
                    readonly addressExtended?: string | undefined
                    readonly city?: string | undefined
                    readonly country?: CountriesEnum | undefined
                    readonly latitude?: number | undefined
                    readonly longitude?: number | undefined
                    readonly postalCode?: string | undefined
                    readonly rawLocation?: string | undefined
                    readonly state?: StatesEnum | undefined
                  }
                  readonly permissions: {
                    readonly applyToJobs: boolean
                    readonly edit: boolean
                    readonly hasRecruiterLabel: boolean
                    readonly imposter: boolean
                    readonly internalUser: boolean
                    readonly publishJobOrders: boolean
                    readonly readEmail: boolean
                    readonly readJobBooster: boolean
                    readonly readNotes: boolean
                    readonly readPhone: boolean
                    readonly triggerIndispensableSurvey: boolean
                    readonly searchCandidates: boolean
                    readonly searchCandidatesAsClient: boolean
                    readonly searchCandidatesAsRecruiter: boolean
                    readonly searchClients: boolean
                    readonly searchClientsByRecruiters: boolean
                    readonly searchJobPostings: boolean
                    readonly searchJobPostingsByRecruiter: boolean
                    readonly sendMessage: boolean
                    readonly trainableUser: boolean
                    readonly updateConnectionStatus: boolean
                    readonly uploadCsv: boolean
                    readonly matchCriteria: boolean
                  }
                  readonly social?:
                    | {
                        readonly calendly?: string | undefined
                        readonly linkedin?: string | undefined
                      }
                    | undefined
                  readonly candidate?:
                    | {
                        readonly __typename: 'Candidate'
                        readonly id: string
                        readonly backgroundCheckDate?: any | undefined
                        readonly credentialCount: number
                        readonly dnu?: string | undefined
                        readonly hiringStatus?: HiringStatusEnum | undefined
                        readonly i9Date?: any | undefined
                        readonly idealEmployment?: string | undefined
                        readonly isAbleToApply: boolean
                        readonly isNeedEmploymentSponsor?: boolean | undefined
                        readonly isUsWorkAuthorized?: boolean | undefined
                        readonly noWorkExperience?: boolean | undefined
                        readonly profileCompletedAt?: any | undefined
                        readonly profilePercentComplete?: number | undefined
                        readonly relayId: string
                        readonly resumeUrl?: string | undefined
                        readonly salaryExpectations?: string | undefined
                        readonly candidateLicenses?:
                          | ReadonlyArray<{
                              readonly id: string
                              readonly date?: any | undefined
                              readonly number?: string | undefined
                              readonly url?: string | undefined
                              readonly license?:
                                | {
                                    readonly id: string
                                    readonly name: string
                                    readonly country: CountriesEnum
                                    readonly state?: string | undefined
                                  }
                                | undefined
                            }>
                          | undefined
                        readonly credentials?:
                          | ReadonlyArray<{
                              readonly id: string
                              readonly title: string
                              readonly badgeUrl: string
                              readonly description?: string | undefined
                              readonly training: {
                                readonly id: string
                                readonly trainingUrl: string
                              }
                            }>
                          | undefined
                        readonly education?:
                          | ReadonlyArray<{
                              readonly id: string
                              readonly degree?: string | undefined
                              readonly educationLevel?:
                                | EducationLevelEnum
                                | undefined
                              readonly school?: string | undefined
                              readonly yearsAttended?: number | undefined
                            }>
                          | undefined
                        readonly experiences?:
                          | ReadonlyArray<{
                              readonly id: string
                              readonly companyName?: string | undefined
                              readonly current?: boolean | undefined
                              readonly endDate?: any | undefined
                              readonly jobTitle?: string | undefined
                              readonly responsibilities?: string | undefined
                              readonly startDate?: any | undefined
                              readonly yearsEmployed?: number | undefined
                            }>
                          | undefined
                        readonly placements?:
                          | ReadonlyArray<{
                              readonly startDate?: any | undefined
                              readonly id: string
                              readonly interviewDate?: any | undefined
                              readonly status?: PlacementStatusEnum | undefined
                              readonly permissions: { readonly update: boolean }
                              readonly jobPosting: {
                                readonly id: string
                                readonly slug: string
                                readonly title: string
                                readonly client?:
                                  | { readonly displayname: string }
                                  | undefined
                                readonly permissions: {
                                  readonly readJobApps: boolean
                                  readonly readPlacements: boolean
                                }
                              }
                            }>
                          | undefined
                        readonly jobApplications?:
                          | ReadonlyArray<{
                              readonly id: string
                              readonly status?:
                                | JobApplicationStatusEnum
                                | undefined
                              readonly permissions: { readonly show: boolean }
                              readonly jobPosting: {
                                readonly id: string
                                readonly level?: number | undefined
                                readonly slug: string
                                readonly title: string
                                readonly client?:
                                  | {
                                      readonly displayname: string
                                      readonly name: string
                                    }
                                  | undefined
                                readonly permissions: {
                                  readonly readJobApps: boolean
                                  readonly readPlacements: boolean
                                  readonly managePlacements: boolean
                                }
                                readonly jobPostingScreening?:
                                  | { readonly id: string }
                                  | undefined
                              }
                              readonly screeningSubmissions?:
                                | ReadonlyArray<{ readonly id: string }>
                                | undefined
                            }>
                          | undefined
                        readonly permissions: {
                          readonly edit: boolean
                          readonly readApplications: boolean
                          readonly readCredentials: boolean
                          readonly readLicense: boolean
                          readonly readResume: boolean
                          readonly readWorkPreferences: boolean
                        }
                        readonly recruiters?:
                          | ReadonlyArray<{
                              readonly avatarUrl?: string | undefined
                              readonly firstName: string
                              readonly id: string
                              readonly lastName: string
                            }>
                          | undefined
                        readonly skillRelations?:
                          | ReadonlyArray<{
                              readonly id: string
                              readonly years: number
                              readonly skill: {
                                readonly __typename: 'Skill'
                                readonly id: string
                                readonly name: string
                              }
                            }>
                          | undefined
                        readonly summary?:
                          | {
                              readonly id: string
                              readonly entry: string
                              readonly title: string
                            }
                          | undefined
                      }
                    | undefined
                  readonly subscription?:
                    | {
                        readonly __typename: 'Subscription'
                        readonly id: string
                        readonly active: boolean
                        readonly plan: string
                      }
                    | undefined
                }
              | undefined
          }
        | undefined
      >
    | undefined
  readonly pageInfo: {
    readonly endCursor?: string | undefined
    readonly hasNextPage: boolean
    readonly hasPreviousPage: boolean
    readonly startCursor?: string | undefined
    readonly totalCount: number
  }
}

export type TrainingMemberEdgeFragment = {
  readonly __typename: 'UserEdge'
  readonly cursor: string
  readonly node?:
    | {
        readonly __typename: 'User'
        readonly id: string
        readonly username: string
        readonly availability?: string | undefined
        readonly avatarUrl?: string | undefined
        readonly connectionCount: number
        readonly connectionStatus?: ConnectionStatusEnum | undefined
        readonly email?: string | undefined
        readonly secondaryEmail?: string | undefined
        readonly firstName: string
        readonly indispensableSurveyLink: string
        readonly isCurrentUser: boolean
        readonly lastName: string
        readonly termsAcceptedAt?: any | undefined
        readonly phoneNumber?: string | undefined
        readonly uri: string
        readonly activities?:
          | { readonly pageInfo: { readonly totalCount: number } }
          | undefined
        readonly alerts?:
          | { readonly pageInfo: { readonly totalCount: number } }
          | undefined
        readonly gigsEmployee?:
          | {
              readonly id: string
              readonly createdAt: any
              readonly deletedAt?: any | undefined
              readonly eligibleAt?: any | undefined
              readonly offboardedAt?: any | undefined
              readonly onboardedAt?: any | undefined
              readonly onboardingStatus: OnboardingStatusEnum
              readonly percentComplete?: number | undefined
              readonly rejectedAt?: any | undefined
              readonly savedAt?: any | undefined
              readonly screeningAt?: any | undefined
              readonly terminatedAt?: any | undefined
              readonly updatedAt: any
              readonly permissions: { readonly seeHistory: boolean }
            }
          | undefined
        readonly location: {
          readonly address?: string | undefined
          readonly addressExtended?: string | undefined
          readonly city?: string | undefined
          readonly country?: CountriesEnum | undefined
          readonly latitude?: number | undefined
          readonly longitude?: number | undefined
          readonly postalCode?: string | undefined
          readonly rawLocation?: string | undefined
          readonly state?: StatesEnum | undefined
        }
        readonly permissions: {
          readonly applyToJobs: boolean
          readonly edit: boolean
          readonly hasRecruiterLabel: boolean
          readonly imposter: boolean
          readonly internalUser: boolean
          readonly publishJobOrders: boolean
          readonly readEmail: boolean
          readonly readJobBooster: boolean
          readonly readNotes: boolean
          readonly readPhone: boolean
          readonly triggerIndispensableSurvey: boolean
          readonly searchCandidates: boolean
          readonly searchCandidatesAsClient: boolean
          readonly searchCandidatesAsRecruiter: boolean
          readonly searchClients: boolean
          readonly searchClientsByRecruiters: boolean
          readonly searchJobPostings: boolean
          readonly searchJobPostingsByRecruiter: boolean
          readonly sendMessage: boolean
          readonly trainableUser: boolean
          readonly updateConnectionStatus: boolean
          readonly uploadCsv: boolean
          readonly matchCriteria: boolean
        }
        readonly social?:
          | {
              readonly calendly?: string | undefined
              readonly linkedin?: string | undefined
            }
          | undefined
        readonly candidate?:
          | {
              readonly __typename: 'Candidate'
              readonly id: string
              readonly backgroundCheckDate?: any | undefined
              readonly credentialCount: number
              readonly dnu?: string | undefined
              readonly hiringStatus?: HiringStatusEnum | undefined
              readonly i9Date?: any | undefined
              readonly idealEmployment?: string | undefined
              readonly isAbleToApply: boolean
              readonly isNeedEmploymentSponsor?: boolean | undefined
              readonly isUsWorkAuthorized?: boolean | undefined
              readonly noWorkExperience?: boolean | undefined
              readonly profileCompletedAt?: any | undefined
              readonly profilePercentComplete?: number | undefined
              readonly relayId: string
              readonly resumeUrl?: string | undefined
              readonly salaryExpectations?: string | undefined
              readonly candidateLicenses?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly date?: any | undefined
                    readonly number?: string | undefined
                    readonly url?: string | undefined
                    readonly license?:
                      | {
                          readonly id: string
                          readonly name: string
                          readonly country: CountriesEnum
                          readonly state?: string | undefined
                        }
                      | undefined
                  }>
                | undefined
              readonly credentials?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly title: string
                    readonly badgeUrl: string
                    readonly description?: string | undefined
                    readonly training: {
                      readonly id: string
                      readonly trainingUrl: string
                    }
                  }>
                | undefined
              readonly education?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly degree?: string | undefined
                    readonly educationLevel?: EducationLevelEnum | undefined
                    readonly school?: string | undefined
                    readonly yearsAttended?: number | undefined
                  }>
                | undefined
              readonly experiences?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly companyName?: string | undefined
                    readonly current?: boolean | undefined
                    readonly endDate?: any | undefined
                    readonly jobTitle?: string | undefined
                    readonly responsibilities?: string | undefined
                    readonly startDate?: any | undefined
                    readonly yearsEmployed?: number | undefined
                  }>
                | undefined
              readonly placements?:
                | ReadonlyArray<{
                    readonly startDate?: any | undefined
                    readonly id: string
                    readonly interviewDate?: any | undefined
                    readonly status?: PlacementStatusEnum | undefined
                    readonly permissions: { readonly update: boolean }
                    readonly jobPosting: {
                      readonly id: string
                      readonly slug: string
                      readonly title: string
                      readonly client?:
                        | { readonly displayname: string }
                        | undefined
                      readonly permissions: {
                        readonly readJobApps: boolean
                        readonly readPlacements: boolean
                      }
                    }
                  }>
                | undefined
              readonly jobApplications?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly status?: JobApplicationStatusEnum | undefined
                    readonly permissions: { readonly show: boolean }
                    readonly jobPosting: {
                      readonly id: string
                      readonly level?: number | undefined
                      readonly slug: string
                      readonly title: string
                      readonly client?:
                        | {
                            readonly displayname: string
                            readonly name: string
                          }
                        | undefined
                      readonly permissions: {
                        readonly readJobApps: boolean
                        readonly readPlacements: boolean
                        readonly managePlacements: boolean
                      }
                      readonly jobPostingScreening?:
                        | { readonly id: string }
                        | undefined
                    }
                    readonly screeningSubmissions?:
                      | ReadonlyArray<{ readonly id: string }>
                      | undefined
                  }>
                | undefined
              readonly permissions: {
                readonly edit: boolean
                readonly readApplications: boolean
                readonly readCredentials: boolean
                readonly readLicense: boolean
                readonly readResume: boolean
                readonly readWorkPreferences: boolean
              }
              readonly recruiters?:
                | ReadonlyArray<{
                    readonly avatarUrl?: string | undefined
                    readonly firstName: string
                    readonly id: string
                    readonly lastName: string
                  }>
                | undefined
              readonly skillRelations?:
                | ReadonlyArray<{
                    readonly id: string
                    readonly years: number
                    readonly skill: {
                      readonly __typename: 'Skill'
                      readonly id: string
                      readonly name: string
                    }
                  }>
                | undefined
              readonly summary?:
                | {
                    readonly id: string
                    readonly entry: string
                    readonly title: string
                  }
                | undefined
            }
          | undefined
        readonly subscription?:
          | {
              readonly __typename: 'Subscription'
              readonly id: string
              readonly active: boolean
              readonly plan: string
            }
          | undefined
      }
    | undefined
}

export type QuizFragment = {
  readonly __typename: 'Quiz'
  readonly createdAt: any
  readonly id: string
  readonly description: string
  readonly slug: string
  readonly timeToComplete?: number | undefined
  readonly title: string
  readonly totalCorrectToGainCertification: number
  readonly totalQuestions?: number | undefined
  readonly videoUrl: string
  readonly currentUserQuizAttempts?:
    | ReadonlyArray<{
        readonly __typename: 'QuizAttempt'
        readonly id: string
        readonly createdAt: any
        readonly grade?: number | undefined
        readonly status: QuizAttemptStatusEnum
        readonly userCurrentQuestionAttempt?:
          | {
              readonly __typename: 'QuestionAttempt'
              readonly id: string
              readonly quizQuestion: {
                readonly sortPosition?: number | undefined
                readonly question: {
                  readonly value: string
                  readonly questionAnswerType?:
                    | QuestionAnswerTypeEnum
                    | undefined
                }
                readonly questionAnswers: ReadonlyArray<{
                  readonly id: string
                  readonly answer: string
                }>
              }
            }
          | undefined
      }>
    | undefined
}

export type QuizConnectionFragment = {
  readonly edges?:
    | ReadonlyArray<
        | {
            readonly __typename: 'QuizEdge'
            readonly cursor: string
            readonly node?:
              | {
                  readonly __typename: 'Quiz'
                  readonly createdAt: any
                  readonly id: string
                  readonly description: string
                  readonly slug: string
                  readonly timeToComplete?: number | undefined
                  readonly title: string
                  readonly totalCorrectToGainCertification: number
                  readonly totalQuestions?: number | undefined
                  readonly videoUrl: string
                  readonly currentUserQuizAttempts?:
                    | ReadonlyArray<{
                        readonly __typename: 'QuizAttempt'
                        readonly id: string
                        readonly createdAt: any
                        readonly grade?: number | undefined
                        readonly status: QuizAttemptStatusEnum
                        readonly userCurrentQuestionAttempt?:
                          | {
                              readonly __typename: 'QuestionAttempt'
                              readonly id: string
                              readonly quizQuestion: {
                                readonly sortPosition?: number | undefined
                                readonly question: {
                                  readonly value: string
                                  readonly questionAnswerType?:
                                    | QuestionAnswerTypeEnum
                                    | undefined
                                }
                                readonly questionAnswers: ReadonlyArray<{
                                  readonly id: string
                                  readonly answer: string
                                }>
                              }
                            }
                          | undefined
                      }>
                    | undefined
                }
              | undefined
          }
        | undefined
      >
    | undefined
  readonly pageInfo: {
    readonly endCursor?: string | undefined
    readonly hasNextPage: boolean
    readonly hasPreviousPage: boolean
    readonly startCursor?: string | undefined
    readonly totalCount: number
  }
}

export type QuizEdgeFragment = {
  readonly __typename: 'QuizEdge'
  readonly cursor: string
  readonly node?:
    | {
        readonly __typename: 'Quiz'
        readonly createdAt: any
        readonly id: string
        readonly description: string
        readonly slug: string
        readonly timeToComplete?: number | undefined
        readonly title: string
        readonly totalCorrectToGainCertification: number
        readonly totalQuestions?: number | undefined
        readonly videoUrl: string
        readonly currentUserQuizAttempts?:
          | ReadonlyArray<{
              readonly __typename: 'QuizAttempt'
              readonly id: string
              readonly createdAt: any
              readonly grade?: number | undefined
              readonly status: QuizAttemptStatusEnum
              readonly userCurrentQuestionAttempt?:
                | {
                    readonly __typename: 'QuestionAttempt'
                    readonly id: string
                    readonly quizQuestion: {
                      readonly sortPosition?: number | undefined
                      readonly question: {
                        readonly value: string
                        readonly questionAnswerType?:
                          | QuestionAnswerTypeEnum
                          | undefined
                      }
                      readonly questionAnswers: ReadonlyArray<{
                        readonly id: string
                        readonly answer: string
                      }>
                    }
                  }
                | undefined
            }>
          | undefined
      }
    | undefined
}

export type QuizAttemptFragment = {
  readonly __typename: 'QuizAttempt'
  readonly id: string
  readonly createdAt: any
  readonly grade?: number | undefined
  readonly status: QuizAttemptStatusEnum
  readonly userCurrentQuestionAttempt?:
    | {
        readonly __typename: 'QuestionAttempt'
        readonly id: string
        readonly quizQuestion: {
          readonly sortPosition?: number | undefined
          readonly question: {
            readonly value: string
            readonly questionAnswerType?: QuestionAnswerTypeEnum | undefined
          }
          readonly questionAnswers: ReadonlyArray<{
            readonly id: string
            readonly answer: string
          }>
        }
      }
    | undefined
}

export type QuestionAttemptFragment = {
  readonly __typename: 'QuestionAttempt'
  readonly id: string
  readonly quizQuestion: {
    readonly sortPosition?: number | undefined
    readonly question: {
      readonly value: string
      readonly questionAnswerType?: QuestionAnswerTypeEnum | undefined
    }
    readonly questionAnswers: ReadonlyArray<{
      readonly id: string
      readonly answer: string
    }>
  }
}

export type QuestionAnswerFragment = {
  readonly id: string
  readonly answer: string
}

export type QuizQuestionFragment = {
  readonly __typename: 'QuizQuestion'
  readonly sortPosition?: number | undefined
  readonly question: {
    readonly id: string
    readonly questionAnswerType?: QuestionAnswerTypeEnum | undefined
    readonly value: string
  }
  readonly questionAnswers: ReadonlyArray<{
    readonly id: string
    readonly answer: string
  }>
}

export type CredentialFragment = {
  readonly __typename: 'Credential'
  readonly id: string
  readonly badgeUrl: string
  readonly description?: string | undefined
  readonly slug: string
  readonly title: string
  readonly training: { readonly id: string; readonly trainingUrl: string }
}

export type QuizQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type QuizQuery = {
  readonly getQuiz?:
    | {
        readonly __typename: 'Quiz'
        readonly createdAt: any
        readonly id: string
        readonly description: string
        readonly slug: string
        readonly timeToComplete?: number | undefined
        readonly title: string
        readonly totalCorrectToGainCertification: number
        readonly totalQuestions?: number | undefined
        readonly videoUrl: string
        readonly currentUserQuizAttempts?:
          | ReadonlyArray<{
              readonly __typename: 'QuizAttempt'
              readonly id: string
              readonly createdAt: any
              readonly grade?: number | undefined
              readonly status: QuizAttemptStatusEnum
              readonly userCurrentQuestionAttempt?:
                | {
                    readonly __typename: 'QuestionAttempt'
                    readonly id: string
                    readonly quizQuestion: {
                      readonly sortPosition?: number | undefined
                      readonly question: {
                        readonly value: string
                        readonly questionAnswerType?:
                          | QuestionAnswerTypeEnum
                          | undefined
                      }
                      readonly questionAnswers: ReadonlyArray<{
                        readonly id: string
                        readonly answer: string
                      }>
                    }
                  }
                | undefined
            }>
          | undefined
      }
    | undefined
}

export type TrainingQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type TrainingQuery = {
  readonly getTraining?:
    | {
        readonly __typename: 'Training'
        readonly id: string
        readonly currentUserPassed: boolean
        readonly countCandidatesCompletedTraining: number
        readonly description: string
        readonly isPublished: boolean
        readonly slug: string
        readonly title: string
        readonly totalQuestionsCount: number
        readonly totalTimeToComplete: number
        readonly trainingUrl: string
        readonly creatorClient: {
          readonly id: string
          readonly avatarUrl?: string | undefined
          readonly displayname: string
        }
        readonly credential: {
          readonly id: string
          readonly badgeUrl: string
          readonly description?: string | undefined
          readonly title: string
        }
        readonly permissions: {
          readonly viewCount: boolean
          readonly viewTrainingMembers: boolean
        }
        readonly quizzes: ReadonlyArray<{
          readonly __typename: 'Quiz'
          readonly createdAt: any
          readonly id: string
          readonly description: string
          readonly slug: string
          readonly timeToComplete?: number | undefined
          readonly title: string
          readonly totalCorrectToGainCertification: number
          readonly totalQuestions?: number | undefined
          readonly videoUrl: string
          readonly currentUserQuizAttempts?:
            | ReadonlyArray<{
                readonly __typename: 'QuizAttempt'
                readonly id: string
                readonly createdAt: any
                readonly grade?: number | undefined
                readonly status: QuizAttemptStatusEnum
                readonly userCurrentQuestionAttempt?:
                  | {
                      readonly __typename: 'QuestionAttempt'
                      readonly id: string
                      readonly quizQuestion: {
                        readonly sortPosition?: number | undefined
                        readonly question: {
                          readonly value: string
                          readonly questionAnswerType?:
                            | QuestionAnswerTypeEnum
                            | undefined
                        }
                        readonly questionAnswers: ReadonlyArray<{
                          readonly id: string
                          readonly answer: string
                        }>
                      }
                    }
                  | undefined
              }>
            | undefined
        }>
      }
    | undefined
}

export type PublicCredentialsCatalogueQueryVariables = Exact<{
  [key: string]: never
}>

export type PublicCredentialsCatalogueQuery = {
  readonly publicCredentialsCatalogue: ReadonlyArray<{
    readonly __typename: 'Credential'
    readonly id: string
    readonly badgeUrl: string
    readonly description?: string | undefined
    readonly slug: string
    readonly title: string
    readonly training: { readonly id: string; readonly trainingUrl: string }
  }>
}

export type CompanyCredentialsCatalogueQueryVariables = Exact<{
  displayname: Scalars['String']['input']
}>

export type CompanyCredentialsCatalogueQuery = {
  readonly getCompanyCredentialsCatalogue?:
    | ReadonlyArray<{
        readonly __typename: 'Credential'
        readonly id: string
        readonly badgeUrl: string
        readonly description?: string | undefined
        readonly slug: string
        readonly title: string
        readonly training: { readonly id: string; readonly trainingUrl: string }
      }>
    | undefined
}

export type ClientTrainingsWtfQueryVariables = Exact<{
  displayname: Scalars['String']['input']
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}>

export type ClientTrainingsWtfQuery = {
  readonly getClientTrainings?:
    | {
        readonly edges?:
          | ReadonlyArray<
              | {
                  readonly __typename: 'ClientTrainingEdge'
                  readonly cursor: string
                  readonly node?:
                    | {
                        readonly __typename: 'ClientTraining'
                        readonly id: string
                        readonly client: { readonly displayname: string }
                        readonly training: {
                          readonly __typename: 'Training'
                          readonly id: string
                          readonly currentUserPassed: boolean
                          readonly countCandidatesCompletedTraining: number
                          readonly description: string
                          readonly isPublished: boolean
                          readonly slug: string
                          readonly title: string
                          readonly totalQuestionsCount: number
                          readonly totalTimeToComplete: number
                          readonly trainingUrl: string
                          readonly creatorClient: {
                            readonly id: string
                            readonly avatarUrl?: string | undefined
                            readonly displayname: string
                          }
                          readonly credential: {
                            readonly id: string
                            readonly badgeUrl: string
                            readonly description?: string | undefined
                            readonly title: string
                          }
                          readonly permissions: {
                            readonly viewCount: boolean
                            readonly viewTrainingMembers: boolean
                          }
                          readonly quizzes: ReadonlyArray<{
                            readonly __typename: 'Quiz'
                            readonly createdAt: any
                            readonly id: string
                            readonly description: string
                            readonly slug: string
                            readonly timeToComplete?: number | undefined
                            readonly title: string
                            readonly totalCorrectToGainCertification: number
                            readonly totalQuestions?: number | undefined
                            readonly videoUrl: string
                            readonly currentUserQuizAttempts?:
                              | ReadonlyArray<{
                                  readonly __typename: 'QuizAttempt'
                                  readonly id: string
                                  readonly createdAt: any
                                  readonly grade?: number | undefined
                                  readonly status: QuizAttemptStatusEnum
                                  readonly userCurrentQuestionAttempt?:
                                    | {
                                        readonly __typename: 'QuestionAttempt'
                                        readonly id: string
                                        readonly quizQuestion: {
                                          readonly sortPosition?:
                                            | number
                                            | undefined
                                          readonly question: {
                                            readonly value: string
                                            readonly questionAnswerType?:
                                              | QuestionAnswerTypeEnum
                                              | undefined
                                          }
                                          readonly questionAnswers: ReadonlyArray<{
                                            readonly id: string
                                            readonly answer: string
                                          }>
                                        }
                                      }
                                    | undefined
                                }>
                              | undefined
                          }>
                        }
                      }
                    | undefined
                }
              | undefined
            >
          | undefined
        readonly pageInfo: {
          readonly endCursor?: string | undefined
          readonly hasNextPage: boolean
          readonly hasPreviousPage: boolean
          readonly startCursor?: string | undefined
          readonly totalCount: number
        }
      }
    | undefined
}

export type ClientTrainingsQueryVariables = Exact<{
  displayname: Scalars['String']['input']
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}>

export type ClientTrainingsQuery = {
  readonly getClient: {
    readonly clientTrainings: {
      readonly edges?:
        | ReadonlyArray<
            | {
                readonly __typename: 'ClientTrainingEdge'
                readonly cursor: string
                readonly node?:
                  | {
                      readonly __typename: 'ClientTraining'
                      readonly id: string
                      readonly client: { readonly displayname: string }
                      readonly training: {
                        readonly __typename: 'Training'
                        readonly id: string
                        readonly currentUserPassed: boolean
                        readonly countCandidatesCompletedTraining: number
                        readonly description: string
                        readonly isPublished: boolean
                        readonly slug: string
                        readonly title: string
                        readonly totalQuestionsCount: number
                        readonly totalTimeToComplete: number
                        readonly trainingUrl: string
                        readonly creatorClient: {
                          readonly id: string
                          readonly avatarUrl?: string | undefined
                          readonly displayname: string
                        }
                        readonly credential: {
                          readonly id: string
                          readonly badgeUrl: string
                          readonly description?: string | undefined
                          readonly title: string
                        }
                        readonly permissions: {
                          readonly viewCount: boolean
                          readonly viewTrainingMembers: boolean
                        }
                        readonly quizzes: ReadonlyArray<{
                          readonly __typename: 'Quiz'
                          readonly createdAt: any
                          readonly id: string
                          readonly description: string
                          readonly slug: string
                          readonly timeToComplete?: number | undefined
                          readonly title: string
                          readonly totalCorrectToGainCertification: number
                          readonly totalQuestions?: number | undefined
                          readonly videoUrl: string
                          readonly currentUserQuizAttempts?:
                            | ReadonlyArray<{
                                readonly __typename: 'QuizAttempt'
                                readonly id: string
                                readonly createdAt: any
                                readonly grade?: number | undefined
                                readonly status: QuizAttemptStatusEnum
                                readonly userCurrentQuestionAttempt?:
                                  | {
                                      readonly __typename: 'QuestionAttempt'
                                      readonly id: string
                                      readonly quizQuestion: {
                                        readonly sortPosition?:
                                          | number
                                          | undefined
                                        readonly question: {
                                          readonly value: string
                                          readonly questionAnswerType?:
                                            | QuestionAnswerTypeEnum
                                            | undefined
                                        }
                                        readonly questionAnswers: ReadonlyArray<{
                                          readonly id: string
                                          readonly answer: string
                                        }>
                                      }
                                    }
                                  | undefined
                              }>
                            | undefined
                        }>
                      }
                    }
                  | undefined
              }
            | undefined
          >
        | undefined
      readonly pageInfo: {
        readonly endCursor?: string | undefined
        readonly hasNextPage: boolean
        readonly hasPreviousPage: boolean
        readonly startCursor?: string | undefined
        readonly totalCount: number
      }
    }
  }
}

export type TrainingMembersQueryVariables = Exact<{
  trainingId?: InputMaybe<Scalars['String']['input']>
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}>

export type TrainingMembersQuery = {
  readonly getTrainingMembers?:
    | {
        readonly edges?:
          | ReadonlyArray<
              | {
                  readonly __typename: 'UserEdge'
                  readonly cursor: string
                  readonly node?:
                    | {
                        readonly __typename: 'User'
                        readonly id: string
                        readonly username: string
                        readonly availability?: string | undefined
                        readonly avatarUrl?: string | undefined
                        readonly connectionCount: number
                        readonly connectionStatus?:
                          | ConnectionStatusEnum
                          | undefined
                        readonly email?: string | undefined
                        readonly secondaryEmail?: string | undefined
                        readonly firstName: string
                        readonly indispensableSurveyLink: string
                        readonly isCurrentUser: boolean
                        readonly lastName: string
                        readonly termsAcceptedAt?: any | undefined
                        readonly phoneNumber?: string | undefined
                        readonly uri: string
                        readonly activities?:
                          | {
                              readonly pageInfo: { readonly totalCount: number }
                            }
                          | undefined
                        readonly alerts?:
                          | {
                              readonly pageInfo: { readonly totalCount: number }
                            }
                          | undefined
                        readonly gigsEmployee?:
                          | {
                              readonly id: string
                              readonly createdAt: any
                              readonly deletedAt?: any | undefined
                              readonly eligibleAt?: any | undefined
                              readonly offboardedAt?: any | undefined
                              readonly onboardedAt?: any | undefined
                              readonly onboardingStatus: OnboardingStatusEnum
                              readonly percentComplete?: number | undefined
                              readonly rejectedAt?: any | undefined
                              readonly savedAt?: any | undefined
                              readonly screeningAt?: any | undefined
                              readonly terminatedAt?: any | undefined
                              readonly updatedAt: any
                              readonly permissions: {
                                readonly seeHistory: boolean
                              }
                            }
                          | undefined
                        readonly location: {
                          readonly address?: string | undefined
                          readonly addressExtended?: string | undefined
                          readonly city?: string | undefined
                          readonly country?: CountriesEnum | undefined
                          readonly latitude?: number | undefined
                          readonly longitude?: number | undefined
                          readonly postalCode?: string | undefined
                          readonly rawLocation?: string | undefined
                          readonly state?: StatesEnum | undefined
                        }
                        readonly permissions: {
                          readonly applyToJobs: boolean
                          readonly edit: boolean
                          readonly hasRecruiterLabel: boolean
                          readonly imposter: boolean
                          readonly internalUser: boolean
                          readonly publishJobOrders: boolean
                          readonly readEmail: boolean
                          readonly readJobBooster: boolean
                          readonly readNotes: boolean
                          readonly readPhone: boolean
                          readonly triggerIndispensableSurvey: boolean
                          readonly searchCandidates: boolean
                          readonly searchCandidatesAsClient: boolean
                          readonly searchCandidatesAsRecruiter: boolean
                          readonly searchClients: boolean
                          readonly searchClientsByRecruiters: boolean
                          readonly searchJobPostings: boolean
                          readonly searchJobPostingsByRecruiter: boolean
                          readonly sendMessage: boolean
                          readonly trainableUser: boolean
                          readonly updateConnectionStatus: boolean
                          readonly uploadCsv: boolean
                          readonly matchCriteria: boolean
                        }
                        readonly social?:
                          | {
                              readonly calendly?: string | undefined
                              readonly linkedin?: string | undefined
                            }
                          | undefined
                        readonly candidate?:
                          | {
                              readonly __typename: 'Candidate'
                              readonly id: string
                              readonly backgroundCheckDate?: any | undefined
                              readonly credentialCount: number
                              readonly dnu?: string | undefined
                              readonly hiringStatus?:
                                | HiringStatusEnum
                                | undefined
                              readonly i9Date?: any | undefined
                              readonly idealEmployment?: string | undefined
                              readonly isAbleToApply: boolean
                              readonly isNeedEmploymentSponsor?:
                                | boolean
                                | undefined
                              readonly isUsWorkAuthorized?: boolean | undefined
                              readonly noWorkExperience?: boolean | undefined
                              readonly profileCompletedAt?: any | undefined
                              readonly profilePercentComplete?:
                                | number
                                | undefined
                              readonly relayId: string
                              readonly resumeUrl?: string | undefined
                              readonly salaryExpectations?: string | undefined
                              readonly candidateLicenses?:
                                | ReadonlyArray<{
                                    readonly id: string
                                    readonly date?: any | undefined
                                    readonly number?: string | undefined
                                    readonly url?: string | undefined
                                    readonly license?:
                                      | {
                                          readonly id: string
                                          readonly name: string
                                          readonly country: CountriesEnum
                                          readonly state?: string | undefined
                                        }
                                      | undefined
                                  }>
                                | undefined
                              readonly credentials?:
                                | ReadonlyArray<{
                                    readonly id: string
                                    readonly title: string
                                    readonly badgeUrl: string
                                    readonly description?: string | undefined
                                    readonly training: {
                                      readonly id: string
                                      readonly trainingUrl: string
                                    }
                                  }>
                                | undefined
                              readonly education?:
                                | ReadonlyArray<{
                                    readonly id: string
                                    readonly degree?: string | undefined
                                    readonly educationLevel?:
                                      | EducationLevelEnum
                                      | undefined
                                    readonly school?: string | undefined
                                    readonly yearsAttended?: number | undefined
                                  }>
                                | undefined
                              readonly experiences?:
                                | ReadonlyArray<{
                                    readonly id: string
                                    readonly companyName?: string | undefined
                                    readonly current?: boolean | undefined
                                    readonly endDate?: any | undefined
                                    readonly jobTitle?: string | undefined
                                    readonly responsibilities?:
                                      | string
                                      | undefined
                                    readonly startDate?: any | undefined
                                    readonly yearsEmployed?: number | undefined
                                  }>
                                | undefined
                              readonly placements?:
                                | ReadonlyArray<{
                                    readonly startDate?: any | undefined
                                    readonly id: string
                                    readonly interviewDate?: any | undefined
                                    readonly status?:
                                      | PlacementStatusEnum
                                      | undefined
                                    readonly permissions: {
                                      readonly update: boolean
                                    }
                                    readonly jobPosting: {
                                      readonly id: string
                                      readonly slug: string
                                      readonly title: string
                                      readonly client?:
                                        | { readonly displayname: string }
                                        | undefined
                                      readonly permissions: {
                                        readonly readJobApps: boolean
                                        readonly readPlacements: boolean
                                      }
                                    }
                                  }>
                                | undefined
                              readonly jobApplications?:
                                | ReadonlyArray<{
                                    readonly id: string
                                    readonly status?:
                                      | JobApplicationStatusEnum
                                      | undefined
                                    readonly permissions: {
                                      readonly show: boolean
                                    }
                                    readonly jobPosting: {
                                      readonly id: string
                                      readonly level?: number | undefined
                                      readonly slug: string
                                      readonly title: string
                                      readonly client?:
                                        | {
                                            readonly displayname: string
                                            readonly name: string
                                          }
                                        | undefined
                                      readonly permissions: {
                                        readonly readJobApps: boolean
                                        readonly readPlacements: boolean
                                        readonly managePlacements: boolean
                                      }
                                      readonly jobPostingScreening?:
                                        | { readonly id: string }
                                        | undefined
                                    }
                                    readonly screeningSubmissions?:
                                      | ReadonlyArray<{ readonly id: string }>
                                      | undefined
                                  }>
                                | undefined
                              readonly permissions: {
                                readonly edit: boolean
                                readonly readApplications: boolean
                                readonly readCredentials: boolean
                                readonly readLicense: boolean
                                readonly readResume: boolean
                                readonly readWorkPreferences: boolean
                              }
                              readonly recruiters?:
                                | ReadonlyArray<{
                                    readonly avatarUrl?: string | undefined
                                    readonly firstName: string
                                    readonly id: string
                                    readonly lastName: string
                                  }>
                                | undefined
                              readonly skillRelations?:
                                | ReadonlyArray<{
                                    readonly id: string
                                    readonly years: number
                                    readonly skill: {
                                      readonly __typename: 'Skill'
                                      readonly id: string
                                      readonly name: string
                                    }
                                  }>
                                | undefined
                              readonly summary?:
                                | {
                                    readonly id: string
                                    readonly entry: string
                                    readonly title: string
                                  }
                                | undefined
                            }
                          | undefined
                        readonly subscription?:
                          | {
                              readonly __typename: 'Subscription'
                              readonly id: string
                              readonly active: boolean
                              readonly plan: string
                            }
                          | undefined
                      }
                    | undefined
                }
              | undefined
            >
          | undefined
        readonly pageInfo: {
          readonly endCursor?: string | undefined
          readonly hasNextPage: boolean
          readonly hasPreviousPage: boolean
          readonly startCursor?: string | undefined
          readonly totalCount: number
        }
      }
    | undefined
}

export type CreateQuizMutationVariables = Exact<{
  input: CreateQuizInput
}>

export type CreateQuizMutation = {
  readonly createQuiz?:
    | {
        readonly __typename: 'Quiz'
        readonly createdAt: any
        readonly id: string
        readonly description: string
        readonly slug: string
        readonly timeToComplete?: number | undefined
        readonly title: string
        readonly totalCorrectToGainCertification: number
        readonly totalQuestions?: number | undefined
        readonly videoUrl: string
        readonly currentUserQuizAttempts?:
          | ReadonlyArray<{
              readonly __typename: 'QuizAttempt'
              readonly id: string
              readonly createdAt: any
              readonly grade?: number | undefined
              readonly status: QuizAttemptStatusEnum
              readonly userCurrentQuestionAttempt?:
                | {
                    readonly __typename: 'QuestionAttempt'
                    readonly id: string
                    readonly quizQuestion: {
                      readonly sortPosition?: number | undefined
                      readonly question: {
                        readonly value: string
                        readonly questionAnswerType?:
                          | QuestionAnswerTypeEnum
                          | undefined
                      }
                      readonly questionAnswers: ReadonlyArray<{
                        readonly id: string
                        readonly answer: string
                      }>
                    }
                  }
                | undefined
            }>
          | undefined
      }
    | undefined
}

export type CreateQuizAttemptMutationVariables = Exact<{
  input: CreateQuizAttemptInput
}>

export type CreateQuizAttemptMutation = {
  readonly createQuizAttempt?:
    | {
        readonly __typename: 'QuizAttempt'
        readonly id: string
        readonly createdAt: any
        readonly grade?: number | undefined
        readonly status: QuizAttemptStatusEnum
        readonly userCurrentQuestionAttempt?:
          | {
              readonly __typename: 'QuestionAttempt'
              readonly id: string
              readonly quizQuestion: {
                readonly sortPosition?: number | undefined
                readonly question: {
                  readonly value: string
                  readonly questionAnswerType?:
                    | QuestionAnswerTypeEnum
                    | undefined
                }
                readonly questionAnswers: ReadonlyArray<{
                  readonly id: string
                  readonly answer: string
                }>
              }
            }
          | undefined
      }
    | undefined
}

export type UpdateQuizAttemptMutationVariables = Exact<{
  input: UpdateQuizAttemptInput
}>

export type UpdateQuizAttemptMutation = {
  readonly updateQuizAttempt?:
    | {
        readonly __typename: 'QuizAttempt'
        readonly id: string
        readonly createdAt: any
        readonly grade?: number | undefined
        readonly status: QuizAttemptStatusEnum
        readonly userCurrentQuestionAttempt?:
          | {
              readonly __typename: 'QuestionAttempt'
              readonly id: string
              readonly quizQuestion: {
                readonly sortPosition?: number | undefined
                readonly question: {
                  readonly value: string
                  readonly questionAnswerType?:
                    | QuestionAnswerTypeEnum
                    | undefined
                }
                readonly questionAnswers: ReadonlyArray<{
                  readonly id: string
                  readonly answer: string
                }>
              }
            }
          | undefined
      }
    | undefined
}

export type Viewer_UserFragment = {
  readonly __typename: 'User'
  readonly jwt?: string | undefined
  readonly termsAcceptedAt?: any | undefined
  readonly id: string
  readonly username: string
  readonly availability?: string | undefined
  readonly avatarUrl?: string | undefined
  readonly connectionCount: number
  readonly connectionStatus?: ConnectionStatusEnum | undefined
  readonly email?: string | undefined
  readonly secondaryEmail?: string | undefined
  readonly firstName: string
  readonly indispensableSurveyLink: string
  readonly isCurrentUser: boolean
  readonly lastName: string
  readonly phoneNumber?: string | undefined
  readonly uri: string
  readonly client?:
    | {
        readonly __typename: 'Client'
        readonly id: string
        readonly billingAddress?: string | undefined
        readonly accountsPayableEmail?: string | undefined
        readonly displayname: string
        readonly avatarUrl?: string | undefined
        readonly companySize?: CompanySizeEnum | undefined
        readonly connectionStatus?: ConnectionStatusEnum | undefined
        readonly countAvailablePositions: number
        readonly countRecentPositions: number
        readonly headline: string
        readonly metaDescription: string
        readonly metaTitle: string
        readonly name: string
        readonly profileComplete: boolean
        readonly profileCompletedAt?: any | undefined
        readonly uri: string
        readonly visibleOnPlatform: boolean
        readonly website?: string | undefined
        readonly companyDescription?: string | undefined
        readonly companyEmploymentBenefits?:
          | ReadonlyArray<{
              readonly id: string
              readonly employmentBenefit: {
                readonly icon: string
                readonly id: string
                readonly name: string
              }
            }>
          | undefined
        readonly companyLocations?:
          | ReadonlyArray<{
              readonly address?: string | undefined
              readonly addressExtended?: string | undefined
              readonly city?: string | undefined
              readonly country?: CountriesEnum | undefined
              readonly latitude?: number | undefined
              readonly longitude?: number | undefined
              readonly postalCode?: string | undefined
              readonly rawLocation?: string | undefined
              readonly state?: StatesEnum | undefined
            }>
          | undefined
        readonly companyPhotos?:
          | ReadonlyArray<{
              readonly id: string
              readonly alt?: string | undefined
              readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
              readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
              readonly url: string
            }>
          | undefined
        readonly companyValues?:
          | ReadonlyArray<{
              readonly id: string
              readonly description: string
              readonly title: string
            }>
          | undefined
        readonly location: {
          readonly address?: string | undefined
          readonly addressExtended?: string | undefined
          readonly city?: string | undefined
          readonly country?: CountriesEnum | undefined
          readonly latitude?: number | undefined
          readonly longitude?: number | undefined
          readonly postalCode?: string | undefined
          readonly rawLocation?: string | undefined
          readonly state?: StatesEnum | undefined
        }
        readonly permissions: {
          readonly createJobPosting: boolean
          readonly edit: boolean
          readonly editMeta: boolean
          readonly internalUser: boolean
          readonly readPendingBanner: boolean
          readonly toggleVisible: boolean
        }
        readonly social?:
          | {
              readonly facebook?: string | undefined
              readonly instagram?: string | undefined
              readonly linkedin?: string | undefined
              readonly twitter?: string | undefined
            }
          | undefined
        readonly trainings: {
          readonly pageInfo: { readonly totalCount: number }
        }
      }
    | undefined
  readonly activities?:
    | { readonly pageInfo: { readonly totalCount: number } }
    | undefined
  readonly alerts?:
    | { readonly pageInfo: { readonly totalCount: number } }
    | undefined
  readonly gigsEmployee?:
    | {
        readonly id: string
        readonly createdAt: any
        readonly deletedAt?: any | undefined
        readonly eligibleAt?: any | undefined
        readonly offboardedAt?: any | undefined
        readonly onboardedAt?: any | undefined
        readonly onboardingStatus: OnboardingStatusEnum
        readonly percentComplete?: number | undefined
        readonly rejectedAt?: any | undefined
        readonly savedAt?: any | undefined
        readonly screeningAt?: any | undefined
        readonly terminatedAt?: any | undefined
        readonly updatedAt: any
        readonly permissions: { readonly seeHistory: boolean }
      }
    | undefined
  readonly location: {
    readonly address?: string | undefined
    readonly addressExtended?: string | undefined
    readonly city?: string | undefined
    readonly country?: CountriesEnum | undefined
    readonly latitude?: number | undefined
    readonly longitude?: number | undefined
    readonly postalCode?: string | undefined
    readonly rawLocation?: string | undefined
    readonly state?: StatesEnum | undefined
  }
  readonly permissions: {
    readonly applyToJobs: boolean
    readonly edit: boolean
    readonly hasRecruiterLabel: boolean
    readonly imposter: boolean
    readonly internalUser: boolean
    readonly publishJobOrders: boolean
    readonly readEmail: boolean
    readonly readJobBooster: boolean
    readonly readNotes: boolean
    readonly readPhone: boolean
    readonly triggerIndispensableSurvey: boolean
    readonly searchCandidates: boolean
    readonly searchCandidatesAsClient: boolean
    readonly searchCandidatesAsRecruiter: boolean
    readonly searchClients: boolean
    readonly searchClientsByRecruiters: boolean
    readonly searchJobPostings: boolean
    readonly searchJobPostingsByRecruiter: boolean
    readonly sendMessage: boolean
    readonly trainableUser: boolean
    readonly updateConnectionStatus: boolean
    readonly uploadCsv: boolean
    readonly matchCriteria: boolean
  }
  readonly social?:
    | {
        readonly calendly?: string | undefined
        readonly linkedin?: string | undefined
      }
    | undefined
  readonly candidate?:
    | {
        readonly __typename: 'Candidate'
        readonly id: string
        readonly backgroundCheckDate?: any | undefined
        readonly credentialCount: number
        readonly dnu?: string | undefined
        readonly hiringStatus?: HiringStatusEnum | undefined
        readonly i9Date?: any | undefined
        readonly idealEmployment?: string | undefined
        readonly isAbleToApply: boolean
        readonly isNeedEmploymentSponsor?: boolean | undefined
        readonly isUsWorkAuthorized?: boolean | undefined
        readonly noWorkExperience?: boolean | undefined
        readonly profileCompletedAt?: any | undefined
        readonly profilePercentComplete?: number | undefined
        readonly relayId: string
        readonly resumeUrl?: string | undefined
        readonly salaryExpectations?: string | undefined
        readonly candidateLicenses?:
          | ReadonlyArray<{
              readonly id: string
              readonly date?: any | undefined
              readonly number?: string | undefined
              readonly url?: string | undefined
              readonly license?:
                | {
                    readonly id: string
                    readonly name: string
                    readonly country: CountriesEnum
                    readonly state?: string | undefined
                  }
                | undefined
            }>
          | undefined
        readonly credentials?:
          | ReadonlyArray<{
              readonly id: string
              readonly title: string
              readonly badgeUrl: string
              readonly description?: string | undefined
              readonly training: {
                readonly id: string
                readonly trainingUrl: string
              }
            }>
          | undefined
        readonly education?:
          | ReadonlyArray<{
              readonly id: string
              readonly degree?: string | undefined
              readonly educationLevel?: EducationLevelEnum | undefined
              readonly school?: string | undefined
              readonly yearsAttended?: number | undefined
            }>
          | undefined
        readonly experiences?:
          | ReadonlyArray<{
              readonly id: string
              readonly companyName?: string | undefined
              readonly current?: boolean | undefined
              readonly endDate?: any | undefined
              readonly jobTitle?: string | undefined
              readonly responsibilities?: string | undefined
              readonly startDate?: any | undefined
              readonly yearsEmployed?: number | undefined
            }>
          | undefined
        readonly placements?:
          | ReadonlyArray<{
              readonly startDate?: any | undefined
              readonly id: string
              readonly interviewDate?: any | undefined
              readonly status?: PlacementStatusEnum | undefined
              readonly permissions: { readonly update: boolean }
              readonly jobPosting: {
                readonly id: string
                readonly slug: string
                readonly title: string
                readonly client?: { readonly displayname: string } | undefined
                readonly permissions: {
                  readonly readJobApps: boolean
                  readonly readPlacements: boolean
                }
              }
            }>
          | undefined
        readonly jobApplications?:
          | ReadonlyArray<{
              readonly id: string
              readonly status?: JobApplicationStatusEnum | undefined
              readonly permissions: { readonly show: boolean }
              readonly jobPosting: {
                readonly id: string
                readonly level?: number | undefined
                readonly slug: string
                readonly title: string
                readonly client?:
                  | { readonly displayname: string; readonly name: string }
                  | undefined
                readonly permissions: {
                  readonly readJobApps: boolean
                  readonly readPlacements: boolean
                  readonly managePlacements: boolean
                }
                readonly jobPostingScreening?:
                  | { readonly id: string }
                  | undefined
              }
              readonly screeningSubmissions?:
                | ReadonlyArray<{ readonly id: string }>
                | undefined
            }>
          | undefined
        readonly permissions: {
          readonly edit: boolean
          readonly readApplications: boolean
          readonly readCredentials: boolean
          readonly readLicense: boolean
          readonly readResume: boolean
          readonly readWorkPreferences: boolean
        }
        readonly recruiters?:
          | ReadonlyArray<{
              readonly avatarUrl?: string | undefined
              readonly firstName: string
              readonly id: string
              readonly lastName: string
            }>
          | undefined
        readonly skillRelations?:
          | ReadonlyArray<{
              readonly id: string
              readonly years: number
              readonly skill: {
                readonly __typename: 'Skill'
                readonly id: string
                readonly name: string
              }
            }>
          | undefined
        readonly summary?:
          | {
              readonly id: string
              readonly entry: string
              readonly title: string
            }
          | undefined
      }
    | undefined
  readonly subscription?:
    | {
        readonly __typename: 'Subscription'
        readonly id: string
        readonly active: boolean
        readonly plan: string
      }
    | undefined
}

export type ViewerQueryVariables = Exact<{ [key: string]: never }>

export type ViewerQuery = {
  readonly currentUser: {
    readonly __typename: 'User'
    readonly jwt?: string | undefined
    readonly termsAcceptedAt?: any | undefined
    readonly id: string
    readonly username: string
    readonly availability?: string | undefined
    readonly avatarUrl?: string | undefined
    readonly connectionCount: number
    readonly connectionStatus?: ConnectionStatusEnum | undefined
    readonly email?: string | undefined
    readonly secondaryEmail?: string | undefined
    readonly firstName: string
    readonly indispensableSurveyLink: string
    readonly isCurrentUser: boolean
    readonly lastName: string
    readonly phoneNumber?: string | undefined
    readonly uri: string
    readonly client?:
      | {
          readonly __typename: 'Client'
          readonly id: string
          readonly billingAddress?: string | undefined
          readonly accountsPayableEmail?: string | undefined
          readonly displayname: string
          readonly avatarUrl?: string | undefined
          readonly companySize?: CompanySizeEnum | undefined
          readonly connectionStatus?: ConnectionStatusEnum | undefined
          readonly countAvailablePositions: number
          readonly countRecentPositions: number
          readonly headline: string
          readonly metaDescription: string
          readonly metaTitle: string
          readonly name: string
          readonly profileComplete: boolean
          readonly profileCompletedAt?: any | undefined
          readonly uri: string
          readonly visibleOnPlatform: boolean
          readonly website?: string | undefined
          readonly companyDescription?: string | undefined
          readonly companyEmploymentBenefits?:
            | ReadonlyArray<{
                readonly id: string
                readonly employmentBenefit: {
                  readonly icon: string
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly companyLocations?:
            | ReadonlyArray<{
                readonly address?: string | undefined
                readonly addressExtended?: string | undefined
                readonly city?: string | undefined
                readonly country?: CountriesEnum | undefined
                readonly latitude?: number | undefined
                readonly longitude?: number | undefined
                readonly postalCode?: string | undefined
                readonly rawLocation?: string | undefined
                readonly state?: StatesEnum | undefined
              }>
            | undefined
          readonly companyPhotos?:
            | ReadonlyArray<{
                readonly id: string
                readonly alt?: string | undefined
                readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
                readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
                readonly url: string
              }>
            | undefined
          readonly companyValues?:
            | ReadonlyArray<{
                readonly id: string
                readonly description: string
                readonly title: string
              }>
            | undefined
          readonly location: {
            readonly address?: string | undefined
            readonly addressExtended?: string | undefined
            readonly city?: string | undefined
            readonly country?: CountriesEnum | undefined
            readonly latitude?: number | undefined
            readonly longitude?: number | undefined
            readonly postalCode?: string | undefined
            readonly rawLocation?: string | undefined
            readonly state?: StatesEnum | undefined
          }
          readonly permissions: {
            readonly createJobPosting: boolean
            readonly edit: boolean
            readonly editMeta: boolean
            readonly internalUser: boolean
            readonly readPendingBanner: boolean
            readonly toggleVisible: boolean
          }
          readonly social?:
            | {
                readonly facebook?: string | undefined
                readonly instagram?: string | undefined
                readonly linkedin?: string | undefined
                readonly twitter?: string | undefined
              }
            | undefined
          readonly trainings: {
            readonly pageInfo: { readonly totalCount: number }
          }
        }
      | undefined
    readonly activities?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly alerts?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly gigsEmployee?:
      | {
          readonly id: string
          readonly createdAt: any
          readonly deletedAt?: any | undefined
          readonly eligibleAt?: any | undefined
          readonly offboardedAt?: any | undefined
          readonly onboardedAt?: any | undefined
          readonly onboardingStatus: OnboardingStatusEnum
          readonly percentComplete?: number | undefined
          readonly rejectedAt?: any | undefined
          readonly savedAt?: any | undefined
          readonly screeningAt?: any | undefined
          readonly terminatedAt?: any | undefined
          readonly updatedAt: any
          readonly permissions: { readonly seeHistory: boolean }
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly applyToJobs: boolean
      readonly edit: boolean
      readonly hasRecruiterLabel: boolean
      readonly imposter: boolean
      readonly internalUser: boolean
      readonly publishJobOrders: boolean
      readonly readEmail: boolean
      readonly readJobBooster: boolean
      readonly readNotes: boolean
      readonly readPhone: boolean
      readonly triggerIndispensableSurvey: boolean
      readonly searchCandidates: boolean
      readonly searchCandidatesAsClient: boolean
      readonly searchCandidatesAsRecruiter: boolean
      readonly searchClients: boolean
      readonly searchClientsByRecruiters: boolean
      readonly searchJobPostings: boolean
      readonly searchJobPostingsByRecruiter: boolean
      readonly sendMessage: boolean
      readonly trainableUser: boolean
      readonly updateConnectionStatus: boolean
      readonly uploadCsv: boolean
      readonly matchCriteria: boolean
    }
    readonly social?:
      | {
          readonly calendly?: string | undefined
          readonly linkedin?: string | undefined
        }
      | undefined
    readonly candidate?:
      | {
          readonly __typename: 'Candidate'
          readonly id: string
          readonly backgroundCheckDate?: any | undefined
          readonly credentialCount: number
          readonly dnu?: string | undefined
          readonly hiringStatus?: HiringStatusEnum | undefined
          readonly i9Date?: any | undefined
          readonly idealEmployment?: string | undefined
          readonly isAbleToApply: boolean
          readonly isNeedEmploymentSponsor?: boolean | undefined
          readonly isUsWorkAuthorized?: boolean | undefined
          readonly noWorkExperience?: boolean | undefined
          readonly profileCompletedAt?: any | undefined
          readonly profilePercentComplete?: number | undefined
          readonly relayId: string
          readonly resumeUrl?: string | undefined
          readonly salaryExpectations?: string | undefined
          readonly candidateLicenses?:
            | ReadonlyArray<{
                readonly id: string
                readonly date?: any | undefined
                readonly number?: string | undefined
                readonly url?: string | undefined
                readonly license?:
                  | {
                      readonly id: string
                      readonly name: string
                      readonly country: CountriesEnum
                      readonly state?: string | undefined
                    }
                  | undefined
              }>
            | undefined
          readonly credentials?:
            | ReadonlyArray<{
                readonly id: string
                readonly title: string
                readonly badgeUrl: string
                readonly description?: string | undefined
                readonly training: {
                  readonly id: string
                  readonly trainingUrl: string
                }
              }>
            | undefined
          readonly education?:
            | ReadonlyArray<{
                readonly id: string
                readonly degree?: string | undefined
                readonly educationLevel?: EducationLevelEnum | undefined
                readonly school?: string | undefined
                readonly yearsAttended?: number | undefined
              }>
            | undefined
          readonly experiences?:
            | ReadonlyArray<{
                readonly id: string
                readonly companyName?: string | undefined
                readonly current?: boolean | undefined
                readonly endDate?: any | undefined
                readonly jobTitle?: string | undefined
                readonly responsibilities?: string | undefined
                readonly startDate?: any | undefined
                readonly yearsEmployed?: number | undefined
              }>
            | undefined
          readonly placements?:
            | ReadonlyArray<{
                readonly startDate?: any | undefined
                readonly id: string
                readonly interviewDate?: any | undefined
                readonly status?: PlacementStatusEnum | undefined
                readonly permissions: { readonly update: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly slug: string
                  readonly title: string
                  readonly client?: { readonly displayname: string } | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                  }
                }
              }>
            | undefined
          readonly jobApplications?:
            | ReadonlyArray<{
                readonly id: string
                readonly status?: JobApplicationStatusEnum | undefined
                readonly permissions: { readonly show: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly level?: number | undefined
                  readonly slug: string
                  readonly title: string
                  readonly client?:
                    | { readonly displayname: string; readonly name: string }
                    | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                    readonly managePlacements: boolean
                  }
                  readonly jobPostingScreening?:
                    | { readonly id: string }
                    | undefined
                }
                readonly screeningSubmissions?:
                  | ReadonlyArray<{ readonly id: string }>
                  | undefined
              }>
            | undefined
          readonly permissions: {
            readonly edit: boolean
            readonly readApplications: boolean
            readonly readCredentials: boolean
            readonly readLicense: boolean
            readonly readResume: boolean
            readonly readWorkPreferences: boolean
          }
          readonly recruiters?:
            | ReadonlyArray<{
                readonly avatarUrl?: string | undefined
                readonly firstName: string
                readonly id: string
                readonly lastName: string
              }>
            | undefined
          readonly skillRelations?:
            | ReadonlyArray<{
                readonly id: string
                readonly years: number
                readonly skill: {
                  readonly __typename: 'Skill'
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly summary?:
            | {
                readonly id: string
                readonly entry: string
                readonly title: string
              }
            | undefined
        }
      | undefined
    readonly subscription?:
      | {
          readonly __typename: 'Subscription'
          readonly id: string
          readonly active: boolean
          readonly plan: string
        }
      | undefined
  }
}

export type GetUserInvitationQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GetUserInvitationQuery = {
  readonly getUserInvitation: {
    readonly __typename: 'UserInvitation'
    readonly id: string
    readonly userEmail: string
    readonly userType: UserRoleEnum
    readonly user: {
      readonly __typename: 'User'
      readonly jwt?: string | undefined
      readonly termsAcceptedAt?: any | undefined
      readonly id: string
      readonly username: string
      readonly availability?: string | undefined
      readonly avatarUrl?: string | undefined
      readonly connectionCount: number
      readonly connectionStatus?: ConnectionStatusEnum | undefined
      readonly email?: string | undefined
      readonly secondaryEmail?: string | undefined
      readonly firstName: string
      readonly indispensableSurveyLink: string
      readonly isCurrentUser: boolean
      readonly lastName: string
      readonly phoneNumber?: string | undefined
      readonly uri: string
      readonly client?:
        | {
            readonly __typename: 'Client'
            readonly id: string
            readonly billingAddress?: string | undefined
            readonly accountsPayableEmail?: string | undefined
            readonly displayname: string
            readonly avatarUrl?: string | undefined
            readonly companySize?: CompanySizeEnum | undefined
            readonly connectionStatus?: ConnectionStatusEnum | undefined
            readonly countAvailablePositions: number
            readonly countRecentPositions: number
            readonly headline: string
            readonly metaDescription: string
            readonly metaTitle: string
            readonly name: string
            readonly profileComplete: boolean
            readonly profileCompletedAt?: any | undefined
            readonly uri: string
            readonly visibleOnPlatform: boolean
            readonly website?: string | undefined
            readonly companyDescription?: string | undefined
            readonly companyEmploymentBenefits?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly employmentBenefit: {
                    readonly icon: string
                    readonly id: string
                    readonly name: string
                  }
                }>
              | undefined
            readonly companyLocations?:
              | ReadonlyArray<{
                  readonly address?: string | undefined
                  readonly addressExtended?: string | undefined
                  readonly city?: string | undefined
                  readonly country?: CountriesEnum | undefined
                  readonly latitude?: number | undefined
                  readonly longitude?: number | undefined
                  readonly postalCode?: string | undefined
                  readonly rawLocation?: string | undefined
                  readonly state?: StatesEnum | undefined
                }>
              | undefined
            readonly companyPhotos?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly alt?: string | undefined
                  readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
                  readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
                  readonly url: string
                }>
              | undefined
            readonly companyValues?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly description: string
                  readonly title: string
                }>
              | undefined
            readonly location: {
              readonly address?: string | undefined
              readonly addressExtended?: string | undefined
              readonly city?: string | undefined
              readonly country?: CountriesEnum | undefined
              readonly latitude?: number | undefined
              readonly longitude?: number | undefined
              readonly postalCode?: string | undefined
              readonly rawLocation?: string | undefined
              readonly state?: StatesEnum | undefined
            }
            readonly permissions: {
              readonly createJobPosting: boolean
              readonly edit: boolean
              readonly editMeta: boolean
              readonly internalUser: boolean
              readonly readPendingBanner: boolean
              readonly toggleVisible: boolean
            }
            readonly social?:
              | {
                  readonly facebook?: string | undefined
                  readonly instagram?: string | undefined
                  readonly linkedin?: string | undefined
                  readonly twitter?: string | undefined
                }
              | undefined
            readonly trainings: {
              readonly pageInfo: { readonly totalCount: number }
            }
          }
        | undefined
      readonly activities?:
        | { readonly pageInfo: { readonly totalCount: number } }
        | undefined
      readonly alerts?:
        | { readonly pageInfo: { readonly totalCount: number } }
        | undefined
      readonly gigsEmployee?:
        | {
            readonly id: string
            readonly createdAt: any
            readonly deletedAt?: any | undefined
            readonly eligibleAt?: any | undefined
            readonly offboardedAt?: any | undefined
            readonly onboardedAt?: any | undefined
            readonly onboardingStatus: OnboardingStatusEnum
            readonly percentComplete?: number | undefined
            readonly rejectedAt?: any | undefined
            readonly savedAt?: any | undefined
            readonly screeningAt?: any | undefined
            readonly terminatedAt?: any | undefined
            readonly updatedAt: any
            readonly permissions: { readonly seeHistory: boolean }
          }
        | undefined
      readonly location: {
        readonly address?: string | undefined
        readonly addressExtended?: string | undefined
        readonly city?: string | undefined
        readonly country?: CountriesEnum | undefined
        readonly latitude?: number | undefined
        readonly longitude?: number | undefined
        readonly postalCode?: string | undefined
        readonly rawLocation?: string | undefined
        readonly state?: StatesEnum | undefined
      }
      readonly permissions: {
        readonly applyToJobs: boolean
        readonly edit: boolean
        readonly hasRecruiterLabel: boolean
        readonly imposter: boolean
        readonly internalUser: boolean
        readonly publishJobOrders: boolean
        readonly readEmail: boolean
        readonly readJobBooster: boolean
        readonly readNotes: boolean
        readonly readPhone: boolean
        readonly triggerIndispensableSurvey: boolean
        readonly searchCandidates: boolean
        readonly searchCandidatesAsClient: boolean
        readonly searchCandidatesAsRecruiter: boolean
        readonly searchClients: boolean
        readonly searchClientsByRecruiters: boolean
        readonly searchJobPostings: boolean
        readonly searchJobPostingsByRecruiter: boolean
        readonly sendMessage: boolean
        readonly trainableUser: boolean
        readonly updateConnectionStatus: boolean
        readonly uploadCsv: boolean
        readonly matchCriteria: boolean
      }
      readonly social?:
        | {
            readonly calendly?: string | undefined
            readonly linkedin?: string | undefined
          }
        | undefined
      readonly candidate?:
        | {
            readonly __typename: 'Candidate'
            readonly id: string
            readonly backgroundCheckDate?: any | undefined
            readonly credentialCount: number
            readonly dnu?: string | undefined
            readonly hiringStatus?: HiringStatusEnum | undefined
            readonly i9Date?: any | undefined
            readonly idealEmployment?: string | undefined
            readonly isAbleToApply: boolean
            readonly isNeedEmploymentSponsor?: boolean | undefined
            readonly isUsWorkAuthorized?: boolean | undefined
            readonly noWorkExperience?: boolean | undefined
            readonly profileCompletedAt?: any | undefined
            readonly profilePercentComplete?: number | undefined
            readonly relayId: string
            readonly resumeUrl?: string | undefined
            readonly salaryExpectations?: string | undefined
            readonly candidateLicenses?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly date?: any | undefined
                  readonly number?: string | undefined
                  readonly url?: string | undefined
                  readonly license?:
                    | {
                        readonly id: string
                        readonly name: string
                        readonly country: CountriesEnum
                        readonly state?: string | undefined
                      }
                    | undefined
                }>
              | undefined
            readonly credentials?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly title: string
                  readonly badgeUrl: string
                  readonly description?: string | undefined
                  readonly training: {
                    readonly id: string
                    readonly trainingUrl: string
                  }
                }>
              | undefined
            readonly education?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly degree?: string | undefined
                  readonly educationLevel?: EducationLevelEnum | undefined
                  readonly school?: string | undefined
                  readonly yearsAttended?: number | undefined
                }>
              | undefined
            readonly experiences?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly companyName?: string | undefined
                  readonly current?: boolean | undefined
                  readonly endDate?: any | undefined
                  readonly jobTitle?: string | undefined
                  readonly responsibilities?: string | undefined
                  readonly startDate?: any | undefined
                  readonly yearsEmployed?: number | undefined
                }>
              | undefined
            readonly placements?:
              | ReadonlyArray<{
                  readonly startDate?: any | undefined
                  readonly id: string
                  readonly interviewDate?: any | undefined
                  readonly status?: PlacementStatusEnum | undefined
                  readonly permissions: { readonly update: boolean }
                  readonly jobPosting: {
                    readonly id: string
                    readonly slug: string
                    readonly title: string
                    readonly client?:
                      | { readonly displayname: string }
                      | undefined
                    readonly permissions: {
                      readonly readJobApps: boolean
                      readonly readPlacements: boolean
                    }
                  }
                }>
              | undefined
            readonly jobApplications?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly status?: JobApplicationStatusEnum | undefined
                  readonly permissions: { readonly show: boolean }
                  readonly jobPosting: {
                    readonly id: string
                    readonly level?: number | undefined
                    readonly slug: string
                    readonly title: string
                    readonly client?:
                      | { readonly displayname: string; readonly name: string }
                      | undefined
                    readonly permissions: {
                      readonly readJobApps: boolean
                      readonly readPlacements: boolean
                      readonly managePlacements: boolean
                    }
                    readonly jobPostingScreening?:
                      | { readonly id: string }
                      | undefined
                  }
                  readonly screeningSubmissions?:
                    | ReadonlyArray<{ readonly id: string }>
                    | undefined
                }>
              | undefined
            readonly permissions: {
              readonly edit: boolean
              readonly readApplications: boolean
              readonly readCredentials: boolean
              readonly readLicense: boolean
              readonly readResume: boolean
              readonly readWorkPreferences: boolean
            }
            readonly recruiters?:
              | ReadonlyArray<{
                  readonly avatarUrl?: string | undefined
                  readonly firstName: string
                  readonly id: string
                  readonly lastName: string
                }>
              | undefined
            readonly skillRelations?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly years: number
                  readonly skill: {
                    readonly __typename: 'Skill'
                    readonly id: string
                    readonly name: string
                  }
                }>
              | undefined
            readonly summary?:
              | {
                  readonly id: string
                  readonly entry: string
                  readonly title: string
                }
              | undefined
          }
        | undefined
      readonly subscription?:
        | {
            readonly __typename: 'Subscription'
            readonly id: string
            readonly active: boolean
            readonly plan: string
          }
        | undefined
    }
  }
}

export type GetUserPasswordResetRequestQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GetUserPasswordResetRequestQuery = {
  readonly getUserPasswordResetRequest: {
    readonly __typename: 'UserPasswordResetRequest'
    readonly id: string
    readonly expiresAt: any
    readonly user: {
      readonly __typename: 'User'
      readonly jwt?: string | undefined
      readonly termsAcceptedAt?: any | undefined
      readonly id: string
      readonly username: string
      readonly availability?: string | undefined
      readonly avatarUrl?: string | undefined
      readonly connectionCount: number
      readonly connectionStatus?: ConnectionStatusEnum | undefined
      readonly email?: string | undefined
      readonly secondaryEmail?: string | undefined
      readonly firstName: string
      readonly indispensableSurveyLink: string
      readonly isCurrentUser: boolean
      readonly lastName: string
      readonly phoneNumber?: string | undefined
      readonly uri: string
      readonly client?:
        | {
            readonly __typename: 'Client'
            readonly id: string
            readonly billingAddress?: string | undefined
            readonly accountsPayableEmail?: string | undefined
            readonly displayname: string
            readonly avatarUrl?: string | undefined
            readonly companySize?: CompanySizeEnum | undefined
            readonly connectionStatus?: ConnectionStatusEnum | undefined
            readonly countAvailablePositions: number
            readonly countRecentPositions: number
            readonly headline: string
            readonly metaDescription: string
            readonly metaTitle: string
            readonly name: string
            readonly profileComplete: boolean
            readonly profileCompletedAt?: any | undefined
            readonly uri: string
            readonly visibleOnPlatform: boolean
            readonly website?: string | undefined
            readonly companyDescription?: string | undefined
            readonly companyEmploymentBenefits?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly employmentBenefit: {
                    readonly icon: string
                    readonly id: string
                    readonly name: string
                  }
                }>
              | undefined
            readonly companyLocations?:
              | ReadonlyArray<{
                  readonly address?: string | undefined
                  readonly addressExtended?: string | undefined
                  readonly city?: string | undefined
                  readonly country?: CountriesEnum | undefined
                  readonly latitude?: number | undefined
                  readonly longitude?: number | undefined
                  readonly postalCode?: string | undefined
                  readonly rawLocation?: string | undefined
                  readonly state?: StatesEnum | undefined
                }>
              | undefined
            readonly companyPhotos?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly alt?: string | undefined
                  readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
                  readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
                  readonly url: string
                }>
              | undefined
            readonly companyValues?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly description: string
                  readonly title: string
                }>
              | undefined
            readonly location: {
              readonly address?: string | undefined
              readonly addressExtended?: string | undefined
              readonly city?: string | undefined
              readonly country?: CountriesEnum | undefined
              readonly latitude?: number | undefined
              readonly longitude?: number | undefined
              readonly postalCode?: string | undefined
              readonly rawLocation?: string | undefined
              readonly state?: StatesEnum | undefined
            }
            readonly permissions: {
              readonly createJobPosting: boolean
              readonly edit: boolean
              readonly editMeta: boolean
              readonly internalUser: boolean
              readonly readPendingBanner: boolean
              readonly toggleVisible: boolean
            }
            readonly social?:
              | {
                  readonly facebook?: string | undefined
                  readonly instagram?: string | undefined
                  readonly linkedin?: string | undefined
                  readonly twitter?: string | undefined
                }
              | undefined
            readonly trainings: {
              readonly pageInfo: { readonly totalCount: number }
            }
          }
        | undefined
      readonly activities?:
        | { readonly pageInfo: { readonly totalCount: number } }
        | undefined
      readonly alerts?:
        | { readonly pageInfo: { readonly totalCount: number } }
        | undefined
      readonly gigsEmployee?:
        | {
            readonly id: string
            readonly createdAt: any
            readonly deletedAt?: any | undefined
            readonly eligibleAt?: any | undefined
            readonly offboardedAt?: any | undefined
            readonly onboardedAt?: any | undefined
            readonly onboardingStatus: OnboardingStatusEnum
            readonly percentComplete?: number | undefined
            readonly rejectedAt?: any | undefined
            readonly savedAt?: any | undefined
            readonly screeningAt?: any | undefined
            readonly terminatedAt?: any | undefined
            readonly updatedAt: any
            readonly permissions: { readonly seeHistory: boolean }
          }
        | undefined
      readonly location: {
        readonly address?: string | undefined
        readonly addressExtended?: string | undefined
        readonly city?: string | undefined
        readonly country?: CountriesEnum | undefined
        readonly latitude?: number | undefined
        readonly longitude?: number | undefined
        readonly postalCode?: string | undefined
        readonly rawLocation?: string | undefined
        readonly state?: StatesEnum | undefined
      }
      readonly permissions: {
        readonly applyToJobs: boolean
        readonly edit: boolean
        readonly hasRecruiterLabel: boolean
        readonly imposter: boolean
        readonly internalUser: boolean
        readonly publishJobOrders: boolean
        readonly readEmail: boolean
        readonly readJobBooster: boolean
        readonly readNotes: boolean
        readonly readPhone: boolean
        readonly triggerIndispensableSurvey: boolean
        readonly searchCandidates: boolean
        readonly searchCandidatesAsClient: boolean
        readonly searchCandidatesAsRecruiter: boolean
        readonly searchClients: boolean
        readonly searchClientsByRecruiters: boolean
        readonly searchJobPostings: boolean
        readonly searchJobPostingsByRecruiter: boolean
        readonly sendMessage: boolean
        readonly trainableUser: boolean
        readonly updateConnectionStatus: boolean
        readonly uploadCsv: boolean
        readonly matchCriteria: boolean
      }
      readonly social?:
        | {
            readonly calendly?: string | undefined
            readonly linkedin?: string | undefined
          }
        | undefined
      readonly candidate?:
        | {
            readonly __typename: 'Candidate'
            readonly id: string
            readonly backgroundCheckDate?: any | undefined
            readonly credentialCount: number
            readonly dnu?: string | undefined
            readonly hiringStatus?: HiringStatusEnum | undefined
            readonly i9Date?: any | undefined
            readonly idealEmployment?: string | undefined
            readonly isAbleToApply: boolean
            readonly isNeedEmploymentSponsor?: boolean | undefined
            readonly isUsWorkAuthorized?: boolean | undefined
            readonly noWorkExperience?: boolean | undefined
            readonly profileCompletedAt?: any | undefined
            readonly profilePercentComplete?: number | undefined
            readonly relayId: string
            readonly resumeUrl?: string | undefined
            readonly salaryExpectations?: string | undefined
            readonly candidateLicenses?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly date?: any | undefined
                  readonly number?: string | undefined
                  readonly url?: string | undefined
                  readonly license?:
                    | {
                        readonly id: string
                        readonly name: string
                        readonly country: CountriesEnum
                        readonly state?: string | undefined
                      }
                    | undefined
                }>
              | undefined
            readonly credentials?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly title: string
                  readonly badgeUrl: string
                  readonly description?: string | undefined
                  readonly training: {
                    readonly id: string
                    readonly trainingUrl: string
                  }
                }>
              | undefined
            readonly education?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly degree?: string | undefined
                  readonly educationLevel?: EducationLevelEnum | undefined
                  readonly school?: string | undefined
                  readonly yearsAttended?: number | undefined
                }>
              | undefined
            readonly experiences?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly companyName?: string | undefined
                  readonly current?: boolean | undefined
                  readonly endDate?: any | undefined
                  readonly jobTitle?: string | undefined
                  readonly responsibilities?: string | undefined
                  readonly startDate?: any | undefined
                  readonly yearsEmployed?: number | undefined
                }>
              | undefined
            readonly placements?:
              | ReadonlyArray<{
                  readonly startDate?: any | undefined
                  readonly id: string
                  readonly interviewDate?: any | undefined
                  readonly status?: PlacementStatusEnum | undefined
                  readonly permissions: { readonly update: boolean }
                  readonly jobPosting: {
                    readonly id: string
                    readonly slug: string
                    readonly title: string
                    readonly client?:
                      | { readonly displayname: string }
                      | undefined
                    readonly permissions: {
                      readonly readJobApps: boolean
                      readonly readPlacements: boolean
                    }
                  }
                }>
              | undefined
            readonly jobApplications?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly status?: JobApplicationStatusEnum | undefined
                  readonly permissions: { readonly show: boolean }
                  readonly jobPosting: {
                    readonly id: string
                    readonly level?: number | undefined
                    readonly slug: string
                    readonly title: string
                    readonly client?:
                      | { readonly displayname: string; readonly name: string }
                      | undefined
                    readonly permissions: {
                      readonly readJobApps: boolean
                      readonly readPlacements: boolean
                      readonly managePlacements: boolean
                    }
                    readonly jobPostingScreening?:
                      | { readonly id: string }
                      | undefined
                  }
                  readonly screeningSubmissions?:
                    | ReadonlyArray<{ readonly id: string }>
                    | undefined
                }>
              | undefined
            readonly permissions: {
              readonly edit: boolean
              readonly readApplications: boolean
              readonly readCredentials: boolean
              readonly readLicense: boolean
              readonly readResume: boolean
              readonly readWorkPreferences: boolean
            }
            readonly recruiters?:
              | ReadonlyArray<{
                  readonly avatarUrl?: string | undefined
                  readonly firstName: string
                  readonly id: string
                  readonly lastName: string
                }>
              | undefined
            readonly skillRelations?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly years: number
                  readonly skill: {
                    readonly __typename: 'Skill'
                    readonly id: string
                    readonly name: string
                  }
                }>
              | undefined
            readonly summary?:
              | {
                  readonly id: string
                  readonly entry: string
                  readonly title: string
                }
              | undefined
          }
        | undefined
      readonly subscription?:
        | {
            readonly __typename: 'Subscription'
            readonly id: string
            readonly active: boolean
            readonly plan: string
          }
        | undefined
    }
  }
}

export type AcceptTermsAndConditionsMutationVariables = Exact<{
  [key: string]: never
}>

export type AcceptTermsAndConditionsMutation = {
  readonly acceptTermsAndConditions: {
    readonly __typename: 'User'
    readonly jwt?: string | undefined
    readonly termsAcceptedAt?: any | undefined
    readonly id: string
    readonly username: string
    readonly availability?: string | undefined
    readonly avatarUrl?: string | undefined
    readonly connectionCount: number
    readonly connectionStatus?: ConnectionStatusEnum | undefined
    readonly email?: string | undefined
    readonly secondaryEmail?: string | undefined
    readonly firstName: string
    readonly indispensableSurveyLink: string
    readonly isCurrentUser: boolean
    readonly lastName: string
    readonly phoneNumber?: string | undefined
    readonly uri: string
    readonly client?:
      | {
          readonly __typename: 'Client'
          readonly id: string
          readonly billingAddress?: string | undefined
          readonly accountsPayableEmail?: string | undefined
          readonly displayname: string
          readonly avatarUrl?: string | undefined
          readonly companySize?: CompanySizeEnum | undefined
          readonly connectionStatus?: ConnectionStatusEnum | undefined
          readonly countAvailablePositions: number
          readonly countRecentPositions: number
          readonly headline: string
          readonly metaDescription: string
          readonly metaTitle: string
          readonly name: string
          readonly profileComplete: boolean
          readonly profileCompletedAt?: any | undefined
          readonly uri: string
          readonly visibleOnPlatform: boolean
          readonly website?: string | undefined
          readonly companyDescription?: string | undefined
          readonly companyEmploymentBenefits?:
            | ReadonlyArray<{
                readonly id: string
                readonly employmentBenefit: {
                  readonly icon: string
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly companyLocations?:
            | ReadonlyArray<{
                readonly address?: string | undefined
                readonly addressExtended?: string | undefined
                readonly city?: string | undefined
                readonly country?: CountriesEnum | undefined
                readonly latitude?: number | undefined
                readonly longitude?: number | undefined
                readonly postalCode?: string | undefined
                readonly rawLocation?: string | undefined
                readonly state?: StatesEnum | undefined
              }>
            | undefined
          readonly companyPhotos?:
            | ReadonlyArray<{
                readonly id: string
                readonly alt?: string | undefined
                readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
                readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
                readonly url: string
              }>
            | undefined
          readonly companyValues?:
            | ReadonlyArray<{
                readonly id: string
                readonly description: string
                readonly title: string
              }>
            | undefined
          readonly location: {
            readonly address?: string | undefined
            readonly addressExtended?: string | undefined
            readonly city?: string | undefined
            readonly country?: CountriesEnum | undefined
            readonly latitude?: number | undefined
            readonly longitude?: number | undefined
            readonly postalCode?: string | undefined
            readonly rawLocation?: string | undefined
            readonly state?: StatesEnum | undefined
          }
          readonly permissions: {
            readonly createJobPosting: boolean
            readonly edit: boolean
            readonly editMeta: boolean
            readonly internalUser: boolean
            readonly readPendingBanner: boolean
            readonly toggleVisible: boolean
          }
          readonly social?:
            | {
                readonly facebook?: string | undefined
                readonly instagram?: string | undefined
                readonly linkedin?: string | undefined
                readonly twitter?: string | undefined
              }
            | undefined
          readonly trainings: {
            readonly pageInfo: { readonly totalCount: number }
          }
        }
      | undefined
    readonly activities?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly alerts?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly gigsEmployee?:
      | {
          readonly id: string
          readonly createdAt: any
          readonly deletedAt?: any | undefined
          readonly eligibleAt?: any | undefined
          readonly offboardedAt?: any | undefined
          readonly onboardedAt?: any | undefined
          readonly onboardingStatus: OnboardingStatusEnum
          readonly percentComplete?: number | undefined
          readonly rejectedAt?: any | undefined
          readonly savedAt?: any | undefined
          readonly screeningAt?: any | undefined
          readonly terminatedAt?: any | undefined
          readonly updatedAt: any
          readonly permissions: { readonly seeHistory: boolean }
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly applyToJobs: boolean
      readonly edit: boolean
      readonly hasRecruiterLabel: boolean
      readonly imposter: boolean
      readonly internalUser: boolean
      readonly publishJobOrders: boolean
      readonly readEmail: boolean
      readonly readJobBooster: boolean
      readonly readNotes: boolean
      readonly readPhone: boolean
      readonly triggerIndispensableSurvey: boolean
      readonly searchCandidates: boolean
      readonly searchCandidatesAsClient: boolean
      readonly searchCandidatesAsRecruiter: boolean
      readonly searchClients: boolean
      readonly searchClientsByRecruiters: boolean
      readonly searchJobPostings: boolean
      readonly searchJobPostingsByRecruiter: boolean
      readonly sendMessage: boolean
      readonly trainableUser: boolean
      readonly updateConnectionStatus: boolean
      readonly uploadCsv: boolean
      readonly matchCriteria: boolean
    }
    readonly social?:
      | {
          readonly calendly?: string | undefined
          readonly linkedin?: string | undefined
        }
      | undefined
    readonly candidate?:
      | {
          readonly __typename: 'Candidate'
          readonly id: string
          readonly backgroundCheckDate?: any | undefined
          readonly credentialCount: number
          readonly dnu?: string | undefined
          readonly hiringStatus?: HiringStatusEnum | undefined
          readonly i9Date?: any | undefined
          readonly idealEmployment?: string | undefined
          readonly isAbleToApply: boolean
          readonly isNeedEmploymentSponsor?: boolean | undefined
          readonly isUsWorkAuthorized?: boolean | undefined
          readonly noWorkExperience?: boolean | undefined
          readonly profileCompletedAt?: any | undefined
          readonly profilePercentComplete?: number | undefined
          readonly relayId: string
          readonly resumeUrl?: string | undefined
          readonly salaryExpectations?: string | undefined
          readonly candidateLicenses?:
            | ReadonlyArray<{
                readonly id: string
                readonly date?: any | undefined
                readonly number?: string | undefined
                readonly url?: string | undefined
                readonly license?:
                  | {
                      readonly id: string
                      readonly name: string
                      readonly country: CountriesEnum
                      readonly state?: string | undefined
                    }
                  | undefined
              }>
            | undefined
          readonly credentials?:
            | ReadonlyArray<{
                readonly id: string
                readonly title: string
                readonly badgeUrl: string
                readonly description?: string | undefined
                readonly training: {
                  readonly id: string
                  readonly trainingUrl: string
                }
              }>
            | undefined
          readonly education?:
            | ReadonlyArray<{
                readonly id: string
                readonly degree?: string | undefined
                readonly educationLevel?: EducationLevelEnum | undefined
                readonly school?: string | undefined
                readonly yearsAttended?: number | undefined
              }>
            | undefined
          readonly experiences?:
            | ReadonlyArray<{
                readonly id: string
                readonly companyName?: string | undefined
                readonly current?: boolean | undefined
                readonly endDate?: any | undefined
                readonly jobTitle?: string | undefined
                readonly responsibilities?: string | undefined
                readonly startDate?: any | undefined
                readonly yearsEmployed?: number | undefined
              }>
            | undefined
          readonly placements?:
            | ReadonlyArray<{
                readonly startDate?: any | undefined
                readonly id: string
                readonly interviewDate?: any | undefined
                readonly status?: PlacementStatusEnum | undefined
                readonly permissions: { readonly update: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly slug: string
                  readonly title: string
                  readonly client?: { readonly displayname: string } | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                  }
                }
              }>
            | undefined
          readonly jobApplications?:
            | ReadonlyArray<{
                readonly id: string
                readonly status?: JobApplicationStatusEnum | undefined
                readonly permissions: { readonly show: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly level?: number | undefined
                  readonly slug: string
                  readonly title: string
                  readonly client?:
                    | { readonly displayname: string; readonly name: string }
                    | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                    readonly managePlacements: boolean
                  }
                  readonly jobPostingScreening?:
                    | { readonly id: string }
                    | undefined
                }
                readonly screeningSubmissions?:
                  | ReadonlyArray<{ readonly id: string }>
                  | undefined
              }>
            | undefined
          readonly permissions: {
            readonly edit: boolean
            readonly readApplications: boolean
            readonly readCredentials: boolean
            readonly readLicense: boolean
            readonly readResume: boolean
            readonly readWorkPreferences: boolean
          }
          readonly recruiters?:
            | ReadonlyArray<{
                readonly avatarUrl?: string | undefined
                readonly firstName: string
                readonly id: string
                readonly lastName: string
              }>
            | undefined
          readonly skillRelations?:
            | ReadonlyArray<{
                readonly id: string
                readonly years: number
                readonly skill: {
                  readonly __typename: 'Skill'
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly summary?:
            | {
                readonly id: string
                readonly entry: string
                readonly title: string
              }
            | undefined
        }
      | undefined
    readonly subscription?:
      | {
          readonly __typename: 'Subscription'
          readonly id: string
          readonly active: boolean
          readonly plan: string
        }
      | undefined
  }
}

export type AssumeIdentityMutationVariables = Exact<{
  input: AssumeIdentityInput
}>

export type AssumeIdentityMutation = {
  readonly assumeIdentity: {
    readonly __typename: 'User'
    readonly jwt?: string | undefined
    readonly termsAcceptedAt?: any | undefined
    readonly id: string
    readonly username: string
    readonly availability?: string | undefined
    readonly avatarUrl?: string | undefined
    readonly connectionCount: number
    readonly connectionStatus?: ConnectionStatusEnum | undefined
    readonly email?: string | undefined
    readonly secondaryEmail?: string | undefined
    readonly firstName: string
    readonly indispensableSurveyLink: string
    readonly isCurrentUser: boolean
    readonly lastName: string
    readonly phoneNumber?: string | undefined
    readonly uri: string
    readonly client?:
      | {
          readonly __typename: 'Client'
          readonly id: string
          readonly billingAddress?: string | undefined
          readonly accountsPayableEmail?: string | undefined
          readonly displayname: string
          readonly avatarUrl?: string | undefined
          readonly companySize?: CompanySizeEnum | undefined
          readonly connectionStatus?: ConnectionStatusEnum | undefined
          readonly countAvailablePositions: number
          readonly countRecentPositions: number
          readonly headline: string
          readonly metaDescription: string
          readonly metaTitle: string
          readonly name: string
          readonly profileComplete: boolean
          readonly profileCompletedAt?: any | undefined
          readonly uri: string
          readonly visibleOnPlatform: boolean
          readonly website?: string | undefined
          readonly companyDescription?: string | undefined
          readonly companyEmploymentBenefits?:
            | ReadonlyArray<{
                readonly id: string
                readonly employmentBenefit: {
                  readonly icon: string
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly companyLocations?:
            | ReadonlyArray<{
                readonly address?: string | undefined
                readonly addressExtended?: string | undefined
                readonly city?: string | undefined
                readonly country?: CountriesEnum | undefined
                readonly latitude?: number | undefined
                readonly longitude?: number | undefined
                readonly postalCode?: string | undefined
                readonly rawLocation?: string | undefined
                readonly state?: StatesEnum | undefined
              }>
            | undefined
          readonly companyPhotos?:
            | ReadonlyArray<{
                readonly id: string
                readonly alt?: string | undefined
                readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
                readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
                readonly url: string
              }>
            | undefined
          readonly companyValues?:
            | ReadonlyArray<{
                readonly id: string
                readonly description: string
                readonly title: string
              }>
            | undefined
          readonly location: {
            readonly address?: string | undefined
            readonly addressExtended?: string | undefined
            readonly city?: string | undefined
            readonly country?: CountriesEnum | undefined
            readonly latitude?: number | undefined
            readonly longitude?: number | undefined
            readonly postalCode?: string | undefined
            readonly rawLocation?: string | undefined
            readonly state?: StatesEnum | undefined
          }
          readonly permissions: {
            readonly createJobPosting: boolean
            readonly edit: boolean
            readonly editMeta: boolean
            readonly internalUser: boolean
            readonly readPendingBanner: boolean
            readonly toggleVisible: boolean
          }
          readonly social?:
            | {
                readonly facebook?: string | undefined
                readonly instagram?: string | undefined
                readonly linkedin?: string | undefined
                readonly twitter?: string | undefined
              }
            | undefined
          readonly trainings: {
            readonly pageInfo: { readonly totalCount: number }
          }
        }
      | undefined
    readonly activities?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly alerts?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly gigsEmployee?:
      | {
          readonly id: string
          readonly createdAt: any
          readonly deletedAt?: any | undefined
          readonly eligibleAt?: any | undefined
          readonly offboardedAt?: any | undefined
          readonly onboardedAt?: any | undefined
          readonly onboardingStatus: OnboardingStatusEnum
          readonly percentComplete?: number | undefined
          readonly rejectedAt?: any | undefined
          readonly savedAt?: any | undefined
          readonly screeningAt?: any | undefined
          readonly terminatedAt?: any | undefined
          readonly updatedAt: any
          readonly permissions: { readonly seeHistory: boolean }
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly applyToJobs: boolean
      readonly edit: boolean
      readonly hasRecruiterLabel: boolean
      readonly imposter: boolean
      readonly internalUser: boolean
      readonly publishJobOrders: boolean
      readonly readEmail: boolean
      readonly readJobBooster: boolean
      readonly readNotes: boolean
      readonly readPhone: boolean
      readonly triggerIndispensableSurvey: boolean
      readonly searchCandidates: boolean
      readonly searchCandidatesAsClient: boolean
      readonly searchCandidatesAsRecruiter: boolean
      readonly searchClients: boolean
      readonly searchClientsByRecruiters: boolean
      readonly searchJobPostings: boolean
      readonly searchJobPostingsByRecruiter: boolean
      readonly sendMessage: boolean
      readonly trainableUser: boolean
      readonly updateConnectionStatus: boolean
      readonly uploadCsv: boolean
      readonly matchCriteria: boolean
    }
    readonly social?:
      | {
          readonly calendly?: string | undefined
          readonly linkedin?: string | undefined
        }
      | undefined
    readonly candidate?:
      | {
          readonly __typename: 'Candidate'
          readonly id: string
          readonly backgroundCheckDate?: any | undefined
          readonly credentialCount: number
          readonly dnu?: string | undefined
          readonly hiringStatus?: HiringStatusEnum | undefined
          readonly i9Date?: any | undefined
          readonly idealEmployment?: string | undefined
          readonly isAbleToApply: boolean
          readonly isNeedEmploymentSponsor?: boolean | undefined
          readonly isUsWorkAuthorized?: boolean | undefined
          readonly noWorkExperience?: boolean | undefined
          readonly profileCompletedAt?: any | undefined
          readonly profilePercentComplete?: number | undefined
          readonly relayId: string
          readonly resumeUrl?: string | undefined
          readonly salaryExpectations?: string | undefined
          readonly candidateLicenses?:
            | ReadonlyArray<{
                readonly id: string
                readonly date?: any | undefined
                readonly number?: string | undefined
                readonly url?: string | undefined
                readonly license?:
                  | {
                      readonly id: string
                      readonly name: string
                      readonly country: CountriesEnum
                      readonly state?: string | undefined
                    }
                  | undefined
              }>
            | undefined
          readonly credentials?:
            | ReadonlyArray<{
                readonly id: string
                readonly title: string
                readonly badgeUrl: string
                readonly description?: string | undefined
                readonly training: {
                  readonly id: string
                  readonly trainingUrl: string
                }
              }>
            | undefined
          readonly education?:
            | ReadonlyArray<{
                readonly id: string
                readonly degree?: string | undefined
                readonly educationLevel?: EducationLevelEnum | undefined
                readonly school?: string | undefined
                readonly yearsAttended?: number | undefined
              }>
            | undefined
          readonly experiences?:
            | ReadonlyArray<{
                readonly id: string
                readonly companyName?: string | undefined
                readonly current?: boolean | undefined
                readonly endDate?: any | undefined
                readonly jobTitle?: string | undefined
                readonly responsibilities?: string | undefined
                readonly startDate?: any | undefined
                readonly yearsEmployed?: number | undefined
              }>
            | undefined
          readonly placements?:
            | ReadonlyArray<{
                readonly startDate?: any | undefined
                readonly id: string
                readonly interviewDate?: any | undefined
                readonly status?: PlacementStatusEnum | undefined
                readonly permissions: { readonly update: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly slug: string
                  readonly title: string
                  readonly client?: { readonly displayname: string } | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                  }
                }
              }>
            | undefined
          readonly jobApplications?:
            | ReadonlyArray<{
                readonly id: string
                readonly status?: JobApplicationStatusEnum | undefined
                readonly permissions: { readonly show: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly level?: number | undefined
                  readonly slug: string
                  readonly title: string
                  readonly client?:
                    | { readonly displayname: string; readonly name: string }
                    | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                    readonly managePlacements: boolean
                  }
                  readonly jobPostingScreening?:
                    | { readonly id: string }
                    | undefined
                }
                readonly screeningSubmissions?:
                  | ReadonlyArray<{ readonly id: string }>
                  | undefined
              }>
            | undefined
          readonly permissions: {
            readonly edit: boolean
            readonly readApplications: boolean
            readonly readCredentials: boolean
            readonly readLicense: boolean
            readonly readResume: boolean
            readonly readWorkPreferences: boolean
          }
          readonly recruiters?:
            | ReadonlyArray<{
                readonly avatarUrl?: string | undefined
                readonly firstName: string
                readonly id: string
                readonly lastName: string
              }>
            | undefined
          readonly skillRelations?:
            | ReadonlyArray<{
                readonly id: string
                readonly years: number
                readonly skill: {
                  readonly __typename: 'Skill'
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly summary?:
            | {
                readonly id: string
                readonly entry: string
                readonly title: string
              }
            | undefined
        }
      | undefined
    readonly subscription?:
      | {
          readonly __typename: 'Subscription'
          readonly id: string
          readonly active: boolean
          readonly plan: string
        }
      | undefined
  }
}

export type CreateUserPasswordResetRequestMutationVariables = Exact<{
  input: CreateUserPasswordResetRequestInput
}>

export type CreateUserPasswordResetRequestMutation = {
  readonly createUserPasswordResetRequest: boolean
}

export type CreateUserPromptResponseMutationVariables = Exact<{
  input: CreateUserPromptResponseInput
}>

export type CreateUserPromptResponseMutation = {
  readonly createUserPromptResponse: {
    readonly __typename: 'User'
    readonly jwt?: string | undefined
    readonly termsAcceptedAt?: any | undefined
    readonly id: string
    readonly username: string
    readonly availability?: string | undefined
    readonly avatarUrl?: string | undefined
    readonly connectionCount: number
    readonly connectionStatus?: ConnectionStatusEnum | undefined
    readonly email?: string | undefined
    readonly secondaryEmail?: string | undefined
    readonly firstName: string
    readonly indispensableSurveyLink: string
    readonly isCurrentUser: boolean
    readonly lastName: string
    readonly phoneNumber?: string | undefined
    readonly uri: string
    readonly client?:
      | {
          readonly __typename: 'Client'
          readonly id: string
          readonly billingAddress?: string | undefined
          readonly accountsPayableEmail?: string | undefined
          readonly displayname: string
          readonly avatarUrl?: string | undefined
          readonly companySize?: CompanySizeEnum | undefined
          readonly connectionStatus?: ConnectionStatusEnum | undefined
          readonly countAvailablePositions: number
          readonly countRecentPositions: number
          readonly headline: string
          readonly metaDescription: string
          readonly metaTitle: string
          readonly name: string
          readonly profileComplete: boolean
          readonly profileCompletedAt?: any | undefined
          readonly uri: string
          readonly visibleOnPlatform: boolean
          readonly website?: string | undefined
          readonly companyDescription?: string | undefined
          readonly companyEmploymentBenefits?:
            | ReadonlyArray<{
                readonly id: string
                readonly employmentBenefit: {
                  readonly icon: string
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly companyLocations?:
            | ReadonlyArray<{
                readonly address?: string | undefined
                readonly addressExtended?: string | undefined
                readonly city?: string | undefined
                readonly country?: CountriesEnum | undefined
                readonly latitude?: number | undefined
                readonly longitude?: number | undefined
                readonly postalCode?: string | undefined
                readonly rawLocation?: string | undefined
                readonly state?: StatesEnum | undefined
              }>
            | undefined
          readonly companyPhotos?:
            | ReadonlyArray<{
                readonly id: string
                readonly alt?: string | undefined
                readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
                readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
                readonly url: string
              }>
            | undefined
          readonly companyValues?:
            | ReadonlyArray<{
                readonly id: string
                readonly description: string
                readonly title: string
              }>
            | undefined
          readonly location: {
            readonly address?: string | undefined
            readonly addressExtended?: string | undefined
            readonly city?: string | undefined
            readonly country?: CountriesEnum | undefined
            readonly latitude?: number | undefined
            readonly longitude?: number | undefined
            readonly postalCode?: string | undefined
            readonly rawLocation?: string | undefined
            readonly state?: StatesEnum | undefined
          }
          readonly permissions: {
            readonly createJobPosting: boolean
            readonly edit: boolean
            readonly editMeta: boolean
            readonly internalUser: boolean
            readonly readPendingBanner: boolean
            readonly toggleVisible: boolean
          }
          readonly social?:
            | {
                readonly facebook?: string | undefined
                readonly instagram?: string | undefined
                readonly linkedin?: string | undefined
                readonly twitter?: string | undefined
              }
            | undefined
          readonly trainings: {
            readonly pageInfo: { readonly totalCount: number }
          }
        }
      | undefined
    readonly activities?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly alerts?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly gigsEmployee?:
      | {
          readonly id: string
          readonly createdAt: any
          readonly deletedAt?: any | undefined
          readonly eligibleAt?: any | undefined
          readonly offboardedAt?: any | undefined
          readonly onboardedAt?: any | undefined
          readonly onboardingStatus: OnboardingStatusEnum
          readonly percentComplete?: number | undefined
          readonly rejectedAt?: any | undefined
          readonly savedAt?: any | undefined
          readonly screeningAt?: any | undefined
          readonly terminatedAt?: any | undefined
          readonly updatedAt: any
          readonly permissions: { readonly seeHistory: boolean }
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly applyToJobs: boolean
      readonly edit: boolean
      readonly hasRecruiterLabel: boolean
      readonly imposter: boolean
      readonly internalUser: boolean
      readonly publishJobOrders: boolean
      readonly readEmail: boolean
      readonly readJobBooster: boolean
      readonly readNotes: boolean
      readonly readPhone: boolean
      readonly triggerIndispensableSurvey: boolean
      readonly searchCandidates: boolean
      readonly searchCandidatesAsClient: boolean
      readonly searchCandidatesAsRecruiter: boolean
      readonly searchClients: boolean
      readonly searchClientsByRecruiters: boolean
      readonly searchJobPostings: boolean
      readonly searchJobPostingsByRecruiter: boolean
      readonly sendMessage: boolean
      readonly trainableUser: boolean
      readonly updateConnectionStatus: boolean
      readonly uploadCsv: boolean
      readonly matchCriteria: boolean
    }
    readonly social?:
      | {
          readonly calendly?: string | undefined
          readonly linkedin?: string | undefined
        }
      | undefined
    readonly candidate?:
      | {
          readonly __typename: 'Candidate'
          readonly id: string
          readonly backgroundCheckDate?: any | undefined
          readonly credentialCount: number
          readonly dnu?: string | undefined
          readonly hiringStatus?: HiringStatusEnum | undefined
          readonly i9Date?: any | undefined
          readonly idealEmployment?: string | undefined
          readonly isAbleToApply: boolean
          readonly isNeedEmploymentSponsor?: boolean | undefined
          readonly isUsWorkAuthorized?: boolean | undefined
          readonly noWorkExperience?: boolean | undefined
          readonly profileCompletedAt?: any | undefined
          readonly profilePercentComplete?: number | undefined
          readonly relayId: string
          readonly resumeUrl?: string | undefined
          readonly salaryExpectations?: string | undefined
          readonly candidateLicenses?:
            | ReadonlyArray<{
                readonly id: string
                readonly date?: any | undefined
                readonly number?: string | undefined
                readonly url?: string | undefined
                readonly license?:
                  | {
                      readonly id: string
                      readonly name: string
                      readonly country: CountriesEnum
                      readonly state?: string | undefined
                    }
                  | undefined
              }>
            | undefined
          readonly credentials?:
            | ReadonlyArray<{
                readonly id: string
                readonly title: string
                readonly badgeUrl: string
                readonly description?: string | undefined
                readonly training: {
                  readonly id: string
                  readonly trainingUrl: string
                }
              }>
            | undefined
          readonly education?:
            | ReadonlyArray<{
                readonly id: string
                readonly degree?: string | undefined
                readonly educationLevel?: EducationLevelEnum | undefined
                readonly school?: string | undefined
                readonly yearsAttended?: number | undefined
              }>
            | undefined
          readonly experiences?:
            | ReadonlyArray<{
                readonly id: string
                readonly companyName?: string | undefined
                readonly current?: boolean | undefined
                readonly endDate?: any | undefined
                readonly jobTitle?: string | undefined
                readonly responsibilities?: string | undefined
                readonly startDate?: any | undefined
                readonly yearsEmployed?: number | undefined
              }>
            | undefined
          readonly placements?:
            | ReadonlyArray<{
                readonly startDate?: any | undefined
                readonly id: string
                readonly interviewDate?: any | undefined
                readonly status?: PlacementStatusEnum | undefined
                readonly permissions: { readonly update: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly slug: string
                  readonly title: string
                  readonly client?: { readonly displayname: string } | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                  }
                }
              }>
            | undefined
          readonly jobApplications?:
            | ReadonlyArray<{
                readonly id: string
                readonly status?: JobApplicationStatusEnum | undefined
                readonly permissions: { readonly show: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly level?: number | undefined
                  readonly slug: string
                  readonly title: string
                  readonly client?:
                    | { readonly displayname: string; readonly name: string }
                    | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                    readonly managePlacements: boolean
                  }
                  readonly jobPostingScreening?:
                    | { readonly id: string }
                    | undefined
                }
                readonly screeningSubmissions?:
                  | ReadonlyArray<{ readonly id: string }>
                  | undefined
              }>
            | undefined
          readonly permissions: {
            readonly edit: boolean
            readonly readApplications: boolean
            readonly readCredentials: boolean
            readonly readLicense: boolean
            readonly readResume: boolean
            readonly readWorkPreferences: boolean
          }
          readonly recruiters?:
            | ReadonlyArray<{
                readonly avatarUrl?: string | undefined
                readonly firstName: string
                readonly id: string
                readonly lastName: string
              }>
            | undefined
          readonly skillRelations?:
            | ReadonlyArray<{
                readonly id: string
                readonly years: number
                readonly skill: {
                  readonly __typename: 'Skill'
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly summary?:
            | {
                readonly id: string
                readonly entry: string
                readonly title: string
              }
            | undefined
        }
      | undefined
    readonly subscription?:
      | {
          readonly __typename: 'Subscription'
          readonly id: string
          readonly active: boolean
          readonly plan: string
        }
      | undefined
  }
}

export type LoginMutationVariables = Exact<{
  input: LoginUserInput
}>

export type LoginMutation = {
  readonly loginUser: {
    readonly __typename: 'User'
    readonly jwt?: string | undefined
    readonly termsAcceptedAt?: any | undefined
    readonly id: string
    readonly username: string
    readonly availability?: string | undefined
    readonly avatarUrl?: string | undefined
    readonly connectionCount: number
    readonly connectionStatus?: ConnectionStatusEnum | undefined
    readonly email?: string | undefined
    readonly secondaryEmail?: string | undefined
    readonly firstName: string
    readonly indispensableSurveyLink: string
    readonly isCurrentUser: boolean
    readonly lastName: string
    readonly phoneNumber?: string | undefined
    readonly uri: string
    readonly client?:
      | {
          readonly __typename: 'Client'
          readonly id: string
          readonly billingAddress?: string | undefined
          readonly accountsPayableEmail?: string | undefined
          readonly displayname: string
          readonly avatarUrl?: string | undefined
          readonly companySize?: CompanySizeEnum | undefined
          readonly connectionStatus?: ConnectionStatusEnum | undefined
          readonly countAvailablePositions: number
          readonly countRecentPositions: number
          readonly headline: string
          readonly metaDescription: string
          readonly metaTitle: string
          readonly name: string
          readonly profileComplete: boolean
          readonly profileCompletedAt?: any | undefined
          readonly uri: string
          readonly visibleOnPlatform: boolean
          readonly website?: string | undefined
          readonly companyDescription?: string | undefined
          readonly companyEmploymentBenefits?:
            | ReadonlyArray<{
                readonly id: string
                readonly employmentBenefit: {
                  readonly icon: string
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly companyLocations?:
            | ReadonlyArray<{
                readonly address?: string | undefined
                readonly addressExtended?: string | undefined
                readonly city?: string | undefined
                readonly country?: CountriesEnum | undefined
                readonly latitude?: number | undefined
                readonly longitude?: number | undefined
                readonly postalCode?: string | undefined
                readonly rawLocation?: string | undefined
                readonly state?: StatesEnum | undefined
              }>
            | undefined
          readonly companyPhotos?:
            | ReadonlyArray<{
                readonly id: string
                readonly alt?: string | undefined
                readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
                readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
                readonly url: string
              }>
            | undefined
          readonly companyValues?:
            | ReadonlyArray<{
                readonly id: string
                readonly description: string
                readonly title: string
              }>
            | undefined
          readonly location: {
            readonly address?: string | undefined
            readonly addressExtended?: string | undefined
            readonly city?: string | undefined
            readonly country?: CountriesEnum | undefined
            readonly latitude?: number | undefined
            readonly longitude?: number | undefined
            readonly postalCode?: string | undefined
            readonly rawLocation?: string | undefined
            readonly state?: StatesEnum | undefined
          }
          readonly permissions: {
            readonly createJobPosting: boolean
            readonly edit: boolean
            readonly editMeta: boolean
            readonly internalUser: boolean
            readonly readPendingBanner: boolean
            readonly toggleVisible: boolean
          }
          readonly social?:
            | {
                readonly facebook?: string | undefined
                readonly instagram?: string | undefined
                readonly linkedin?: string | undefined
                readonly twitter?: string | undefined
              }
            | undefined
          readonly trainings: {
            readonly pageInfo: { readonly totalCount: number }
          }
        }
      | undefined
    readonly activities?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly alerts?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly gigsEmployee?:
      | {
          readonly id: string
          readonly createdAt: any
          readonly deletedAt?: any | undefined
          readonly eligibleAt?: any | undefined
          readonly offboardedAt?: any | undefined
          readonly onboardedAt?: any | undefined
          readonly onboardingStatus: OnboardingStatusEnum
          readonly percentComplete?: number | undefined
          readonly rejectedAt?: any | undefined
          readonly savedAt?: any | undefined
          readonly screeningAt?: any | undefined
          readonly terminatedAt?: any | undefined
          readonly updatedAt: any
          readonly permissions: { readonly seeHistory: boolean }
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly applyToJobs: boolean
      readonly edit: boolean
      readonly hasRecruiterLabel: boolean
      readonly imposter: boolean
      readonly internalUser: boolean
      readonly publishJobOrders: boolean
      readonly readEmail: boolean
      readonly readJobBooster: boolean
      readonly readNotes: boolean
      readonly readPhone: boolean
      readonly triggerIndispensableSurvey: boolean
      readonly searchCandidates: boolean
      readonly searchCandidatesAsClient: boolean
      readonly searchCandidatesAsRecruiter: boolean
      readonly searchClients: boolean
      readonly searchClientsByRecruiters: boolean
      readonly searchJobPostings: boolean
      readonly searchJobPostingsByRecruiter: boolean
      readonly sendMessage: boolean
      readonly trainableUser: boolean
      readonly updateConnectionStatus: boolean
      readonly uploadCsv: boolean
      readonly matchCriteria: boolean
    }
    readonly social?:
      | {
          readonly calendly?: string | undefined
          readonly linkedin?: string | undefined
        }
      | undefined
    readonly candidate?:
      | {
          readonly __typename: 'Candidate'
          readonly id: string
          readonly backgroundCheckDate?: any | undefined
          readonly credentialCount: number
          readonly dnu?: string | undefined
          readonly hiringStatus?: HiringStatusEnum | undefined
          readonly i9Date?: any | undefined
          readonly idealEmployment?: string | undefined
          readonly isAbleToApply: boolean
          readonly isNeedEmploymentSponsor?: boolean | undefined
          readonly isUsWorkAuthorized?: boolean | undefined
          readonly noWorkExperience?: boolean | undefined
          readonly profileCompletedAt?: any | undefined
          readonly profilePercentComplete?: number | undefined
          readonly relayId: string
          readonly resumeUrl?: string | undefined
          readonly salaryExpectations?: string | undefined
          readonly candidateLicenses?:
            | ReadonlyArray<{
                readonly id: string
                readonly date?: any | undefined
                readonly number?: string | undefined
                readonly url?: string | undefined
                readonly license?:
                  | {
                      readonly id: string
                      readonly name: string
                      readonly country: CountriesEnum
                      readonly state?: string | undefined
                    }
                  | undefined
              }>
            | undefined
          readonly credentials?:
            | ReadonlyArray<{
                readonly id: string
                readonly title: string
                readonly badgeUrl: string
                readonly description?: string | undefined
                readonly training: {
                  readonly id: string
                  readonly trainingUrl: string
                }
              }>
            | undefined
          readonly education?:
            | ReadonlyArray<{
                readonly id: string
                readonly degree?: string | undefined
                readonly educationLevel?: EducationLevelEnum | undefined
                readonly school?: string | undefined
                readonly yearsAttended?: number | undefined
              }>
            | undefined
          readonly experiences?:
            | ReadonlyArray<{
                readonly id: string
                readonly companyName?: string | undefined
                readonly current?: boolean | undefined
                readonly endDate?: any | undefined
                readonly jobTitle?: string | undefined
                readonly responsibilities?: string | undefined
                readonly startDate?: any | undefined
                readonly yearsEmployed?: number | undefined
              }>
            | undefined
          readonly placements?:
            | ReadonlyArray<{
                readonly startDate?: any | undefined
                readonly id: string
                readonly interviewDate?: any | undefined
                readonly status?: PlacementStatusEnum | undefined
                readonly permissions: { readonly update: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly slug: string
                  readonly title: string
                  readonly client?: { readonly displayname: string } | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                  }
                }
              }>
            | undefined
          readonly jobApplications?:
            | ReadonlyArray<{
                readonly id: string
                readonly status?: JobApplicationStatusEnum | undefined
                readonly permissions: { readonly show: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly level?: number | undefined
                  readonly slug: string
                  readonly title: string
                  readonly client?:
                    | { readonly displayname: string; readonly name: string }
                    | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                    readonly managePlacements: boolean
                  }
                  readonly jobPostingScreening?:
                    | { readonly id: string }
                    | undefined
                }
                readonly screeningSubmissions?:
                  | ReadonlyArray<{ readonly id: string }>
                  | undefined
              }>
            | undefined
          readonly permissions: {
            readonly edit: boolean
            readonly readApplications: boolean
            readonly readCredentials: boolean
            readonly readLicense: boolean
            readonly readResume: boolean
            readonly readWorkPreferences: boolean
          }
          readonly recruiters?:
            | ReadonlyArray<{
                readonly avatarUrl?: string | undefined
                readonly firstName: string
                readonly id: string
                readonly lastName: string
              }>
            | undefined
          readonly skillRelations?:
            | ReadonlyArray<{
                readonly id: string
                readonly years: number
                readonly skill: {
                  readonly __typename: 'Skill'
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly summary?:
            | {
                readonly id: string
                readonly entry: string
                readonly title: string
              }
            | undefined
        }
      | undefined
    readonly subscription?:
      | {
          readonly __typename: 'Subscription'
          readonly id: string
          readonly active: boolean
          readonly plan: string
        }
      | undefined
  }
}

export type LogoutMutationVariables = Exact<{ [key: string]: never }>

export type LogoutMutation = { readonly logoutUser: boolean }

export type InviteUserMutationVariables = Exact<{
  input: InviteUserInput
}>

export type InviteUserMutation = { readonly inviteUser: boolean }

export type ResetUserPasswordMutationVariables = Exact<{
  input: ResetUserPasswordInput
}>

export type ResetUserPasswordMutation = {
  readonly resetUserPassword: {
    readonly __typename: 'User'
    readonly jwt?: string | undefined
    readonly termsAcceptedAt?: any | undefined
    readonly id: string
    readonly username: string
    readonly availability?: string | undefined
    readonly avatarUrl?: string | undefined
    readonly connectionCount: number
    readonly connectionStatus?: ConnectionStatusEnum | undefined
    readonly email?: string | undefined
    readonly secondaryEmail?: string | undefined
    readonly firstName: string
    readonly indispensableSurveyLink: string
    readonly isCurrentUser: boolean
    readonly lastName: string
    readonly phoneNumber?: string | undefined
    readonly uri: string
    readonly client?:
      | {
          readonly __typename: 'Client'
          readonly id: string
          readonly billingAddress?: string | undefined
          readonly accountsPayableEmail?: string | undefined
          readonly displayname: string
          readonly avatarUrl?: string | undefined
          readonly companySize?: CompanySizeEnum | undefined
          readonly connectionStatus?: ConnectionStatusEnum | undefined
          readonly countAvailablePositions: number
          readonly countRecentPositions: number
          readonly headline: string
          readonly metaDescription: string
          readonly metaTitle: string
          readonly name: string
          readonly profileComplete: boolean
          readonly profileCompletedAt?: any | undefined
          readonly uri: string
          readonly visibleOnPlatform: boolean
          readonly website?: string | undefined
          readonly companyDescription?: string | undefined
          readonly companyEmploymentBenefits?:
            | ReadonlyArray<{
                readonly id: string
                readonly employmentBenefit: {
                  readonly icon: string
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly companyLocations?:
            | ReadonlyArray<{
                readonly address?: string | undefined
                readonly addressExtended?: string | undefined
                readonly city?: string | undefined
                readonly country?: CountriesEnum | undefined
                readonly latitude?: number | undefined
                readonly longitude?: number | undefined
                readonly postalCode?: string | undefined
                readonly rawLocation?: string | undefined
                readonly state?: StatesEnum | undefined
              }>
            | undefined
          readonly companyPhotos?:
            | ReadonlyArray<{
                readonly id: string
                readonly alt?: string | undefined
                readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
                readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
                readonly url: string
              }>
            | undefined
          readonly companyValues?:
            | ReadonlyArray<{
                readonly id: string
                readonly description: string
                readonly title: string
              }>
            | undefined
          readonly location: {
            readonly address?: string | undefined
            readonly addressExtended?: string | undefined
            readonly city?: string | undefined
            readonly country?: CountriesEnum | undefined
            readonly latitude?: number | undefined
            readonly longitude?: number | undefined
            readonly postalCode?: string | undefined
            readonly rawLocation?: string | undefined
            readonly state?: StatesEnum | undefined
          }
          readonly permissions: {
            readonly createJobPosting: boolean
            readonly edit: boolean
            readonly editMeta: boolean
            readonly internalUser: boolean
            readonly readPendingBanner: boolean
            readonly toggleVisible: boolean
          }
          readonly social?:
            | {
                readonly facebook?: string | undefined
                readonly instagram?: string | undefined
                readonly linkedin?: string | undefined
                readonly twitter?: string | undefined
              }
            | undefined
          readonly trainings: {
            readonly pageInfo: { readonly totalCount: number }
          }
        }
      | undefined
    readonly activities?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly alerts?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly gigsEmployee?:
      | {
          readonly id: string
          readonly createdAt: any
          readonly deletedAt?: any | undefined
          readonly eligibleAt?: any | undefined
          readonly offboardedAt?: any | undefined
          readonly onboardedAt?: any | undefined
          readonly onboardingStatus: OnboardingStatusEnum
          readonly percentComplete?: number | undefined
          readonly rejectedAt?: any | undefined
          readonly savedAt?: any | undefined
          readonly screeningAt?: any | undefined
          readonly terminatedAt?: any | undefined
          readonly updatedAt: any
          readonly permissions: { readonly seeHistory: boolean }
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly applyToJobs: boolean
      readonly edit: boolean
      readonly hasRecruiterLabel: boolean
      readonly imposter: boolean
      readonly internalUser: boolean
      readonly publishJobOrders: boolean
      readonly readEmail: boolean
      readonly readJobBooster: boolean
      readonly readNotes: boolean
      readonly readPhone: boolean
      readonly triggerIndispensableSurvey: boolean
      readonly searchCandidates: boolean
      readonly searchCandidatesAsClient: boolean
      readonly searchCandidatesAsRecruiter: boolean
      readonly searchClients: boolean
      readonly searchClientsByRecruiters: boolean
      readonly searchJobPostings: boolean
      readonly searchJobPostingsByRecruiter: boolean
      readonly sendMessage: boolean
      readonly trainableUser: boolean
      readonly updateConnectionStatus: boolean
      readonly uploadCsv: boolean
      readonly matchCriteria: boolean
    }
    readonly social?:
      | {
          readonly calendly?: string | undefined
          readonly linkedin?: string | undefined
        }
      | undefined
    readonly candidate?:
      | {
          readonly __typename: 'Candidate'
          readonly id: string
          readonly backgroundCheckDate?: any | undefined
          readonly credentialCount: number
          readonly dnu?: string | undefined
          readonly hiringStatus?: HiringStatusEnum | undefined
          readonly i9Date?: any | undefined
          readonly idealEmployment?: string | undefined
          readonly isAbleToApply: boolean
          readonly isNeedEmploymentSponsor?: boolean | undefined
          readonly isUsWorkAuthorized?: boolean | undefined
          readonly noWorkExperience?: boolean | undefined
          readonly profileCompletedAt?: any | undefined
          readonly profilePercentComplete?: number | undefined
          readonly relayId: string
          readonly resumeUrl?: string | undefined
          readonly salaryExpectations?: string | undefined
          readonly candidateLicenses?:
            | ReadonlyArray<{
                readonly id: string
                readonly date?: any | undefined
                readonly number?: string | undefined
                readonly url?: string | undefined
                readonly license?:
                  | {
                      readonly id: string
                      readonly name: string
                      readonly country: CountriesEnum
                      readonly state?: string | undefined
                    }
                  | undefined
              }>
            | undefined
          readonly credentials?:
            | ReadonlyArray<{
                readonly id: string
                readonly title: string
                readonly badgeUrl: string
                readonly description?: string | undefined
                readonly training: {
                  readonly id: string
                  readonly trainingUrl: string
                }
              }>
            | undefined
          readonly education?:
            | ReadonlyArray<{
                readonly id: string
                readonly degree?: string | undefined
                readonly educationLevel?: EducationLevelEnum | undefined
                readonly school?: string | undefined
                readonly yearsAttended?: number | undefined
              }>
            | undefined
          readonly experiences?:
            | ReadonlyArray<{
                readonly id: string
                readonly companyName?: string | undefined
                readonly current?: boolean | undefined
                readonly endDate?: any | undefined
                readonly jobTitle?: string | undefined
                readonly responsibilities?: string | undefined
                readonly startDate?: any | undefined
                readonly yearsEmployed?: number | undefined
              }>
            | undefined
          readonly placements?:
            | ReadonlyArray<{
                readonly startDate?: any | undefined
                readonly id: string
                readonly interviewDate?: any | undefined
                readonly status?: PlacementStatusEnum | undefined
                readonly permissions: { readonly update: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly slug: string
                  readonly title: string
                  readonly client?: { readonly displayname: string } | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                  }
                }
              }>
            | undefined
          readonly jobApplications?:
            | ReadonlyArray<{
                readonly id: string
                readonly status?: JobApplicationStatusEnum | undefined
                readonly permissions: { readonly show: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly level?: number | undefined
                  readonly slug: string
                  readonly title: string
                  readonly client?:
                    | { readonly displayname: string; readonly name: string }
                    | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                    readonly managePlacements: boolean
                  }
                  readonly jobPostingScreening?:
                    | { readonly id: string }
                    | undefined
                }
                readonly screeningSubmissions?:
                  | ReadonlyArray<{ readonly id: string }>
                  | undefined
              }>
            | undefined
          readonly permissions: {
            readonly edit: boolean
            readonly readApplications: boolean
            readonly readCredentials: boolean
            readonly readLicense: boolean
            readonly readResume: boolean
            readonly readWorkPreferences: boolean
          }
          readonly recruiters?:
            | ReadonlyArray<{
                readonly avatarUrl?: string | undefined
                readonly firstName: string
                readonly id: string
                readonly lastName: string
              }>
            | undefined
          readonly skillRelations?:
            | ReadonlyArray<{
                readonly id: string
                readonly years: number
                readonly skill: {
                  readonly __typename: 'Skill'
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly summary?:
            | {
                readonly id: string
                readonly entry: string
                readonly title: string
              }
            | undefined
        }
      | undefined
    readonly subscription?:
      | {
          readonly __typename: 'Subscription'
          readonly id: string
          readonly active: boolean
          readonly plan: string
        }
      | undefined
  }
}

export type SignUpUserMutationVariables = Exact<{
  input: SignUpUserInput
}>

export type SignUpUserMutation = {
  readonly signUpUser: {
    readonly __typename: 'User'
    readonly jwt?: string | undefined
    readonly termsAcceptedAt?: any | undefined
    readonly id: string
    readonly username: string
    readonly availability?: string | undefined
    readonly avatarUrl?: string | undefined
    readonly connectionCount: number
    readonly connectionStatus?: ConnectionStatusEnum | undefined
    readonly email?: string | undefined
    readonly secondaryEmail?: string | undefined
    readonly firstName: string
    readonly indispensableSurveyLink: string
    readonly isCurrentUser: boolean
    readonly lastName: string
    readonly phoneNumber?: string | undefined
    readonly uri: string
    readonly client?:
      | {
          readonly __typename: 'Client'
          readonly id: string
          readonly billingAddress?: string | undefined
          readonly accountsPayableEmail?: string | undefined
          readonly displayname: string
          readonly avatarUrl?: string | undefined
          readonly companySize?: CompanySizeEnum | undefined
          readonly connectionStatus?: ConnectionStatusEnum | undefined
          readonly countAvailablePositions: number
          readonly countRecentPositions: number
          readonly headline: string
          readonly metaDescription: string
          readonly metaTitle: string
          readonly name: string
          readonly profileComplete: boolean
          readonly profileCompletedAt?: any | undefined
          readonly uri: string
          readonly visibleOnPlatform: boolean
          readonly website?: string | undefined
          readonly companyDescription?: string | undefined
          readonly companyEmploymentBenefits?:
            | ReadonlyArray<{
                readonly id: string
                readonly employmentBenefit: {
                  readonly icon: string
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly companyLocations?:
            | ReadonlyArray<{
                readonly address?: string | undefined
                readonly addressExtended?: string | undefined
                readonly city?: string | undefined
                readonly country?: CountriesEnum | undefined
                readonly latitude?: number | undefined
                readonly longitude?: number | undefined
                readonly postalCode?: string | undefined
                readonly rawLocation?: string | undefined
                readonly state?: StatesEnum | undefined
              }>
            | undefined
          readonly companyPhotos?:
            | ReadonlyArray<{
                readonly id: string
                readonly alt?: string | undefined
                readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
                readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
                readonly url: string
              }>
            | undefined
          readonly companyValues?:
            | ReadonlyArray<{
                readonly id: string
                readonly description: string
                readonly title: string
              }>
            | undefined
          readonly location: {
            readonly address?: string | undefined
            readonly addressExtended?: string | undefined
            readonly city?: string | undefined
            readonly country?: CountriesEnum | undefined
            readonly latitude?: number | undefined
            readonly longitude?: number | undefined
            readonly postalCode?: string | undefined
            readonly rawLocation?: string | undefined
            readonly state?: StatesEnum | undefined
          }
          readonly permissions: {
            readonly createJobPosting: boolean
            readonly edit: boolean
            readonly editMeta: boolean
            readonly internalUser: boolean
            readonly readPendingBanner: boolean
            readonly toggleVisible: boolean
          }
          readonly social?:
            | {
                readonly facebook?: string | undefined
                readonly instagram?: string | undefined
                readonly linkedin?: string | undefined
                readonly twitter?: string | undefined
              }
            | undefined
          readonly trainings: {
            readonly pageInfo: { readonly totalCount: number }
          }
        }
      | undefined
    readonly activities?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly alerts?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly gigsEmployee?:
      | {
          readonly id: string
          readonly createdAt: any
          readonly deletedAt?: any | undefined
          readonly eligibleAt?: any | undefined
          readonly offboardedAt?: any | undefined
          readonly onboardedAt?: any | undefined
          readonly onboardingStatus: OnboardingStatusEnum
          readonly percentComplete?: number | undefined
          readonly rejectedAt?: any | undefined
          readonly savedAt?: any | undefined
          readonly screeningAt?: any | undefined
          readonly terminatedAt?: any | undefined
          readonly updatedAt: any
          readonly permissions: { readonly seeHistory: boolean }
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly applyToJobs: boolean
      readonly edit: boolean
      readonly hasRecruiterLabel: boolean
      readonly imposter: boolean
      readonly internalUser: boolean
      readonly publishJobOrders: boolean
      readonly readEmail: boolean
      readonly readJobBooster: boolean
      readonly readNotes: boolean
      readonly readPhone: boolean
      readonly triggerIndispensableSurvey: boolean
      readonly searchCandidates: boolean
      readonly searchCandidatesAsClient: boolean
      readonly searchCandidatesAsRecruiter: boolean
      readonly searchClients: boolean
      readonly searchClientsByRecruiters: boolean
      readonly searchJobPostings: boolean
      readonly searchJobPostingsByRecruiter: boolean
      readonly sendMessage: boolean
      readonly trainableUser: boolean
      readonly updateConnectionStatus: boolean
      readonly uploadCsv: boolean
      readonly matchCriteria: boolean
    }
    readonly social?:
      | {
          readonly calendly?: string | undefined
          readonly linkedin?: string | undefined
        }
      | undefined
    readonly candidate?:
      | {
          readonly __typename: 'Candidate'
          readonly id: string
          readonly backgroundCheckDate?: any | undefined
          readonly credentialCount: number
          readonly dnu?: string | undefined
          readonly hiringStatus?: HiringStatusEnum | undefined
          readonly i9Date?: any | undefined
          readonly idealEmployment?: string | undefined
          readonly isAbleToApply: boolean
          readonly isNeedEmploymentSponsor?: boolean | undefined
          readonly isUsWorkAuthorized?: boolean | undefined
          readonly noWorkExperience?: boolean | undefined
          readonly profileCompletedAt?: any | undefined
          readonly profilePercentComplete?: number | undefined
          readonly relayId: string
          readonly resumeUrl?: string | undefined
          readonly salaryExpectations?: string | undefined
          readonly candidateLicenses?:
            | ReadonlyArray<{
                readonly id: string
                readonly date?: any | undefined
                readonly number?: string | undefined
                readonly url?: string | undefined
                readonly license?:
                  | {
                      readonly id: string
                      readonly name: string
                      readonly country: CountriesEnum
                      readonly state?: string | undefined
                    }
                  | undefined
              }>
            | undefined
          readonly credentials?:
            | ReadonlyArray<{
                readonly id: string
                readonly title: string
                readonly badgeUrl: string
                readonly description?: string | undefined
                readonly training: {
                  readonly id: string
                  readonly trainingUrl: string
                }
              }>
            | undefined
          readonly education?:
            | ReadonlyArray<{
                readonly id: string
                readonly degree?: string | undefined
                readonly educationLevel?: EducationLevelEnum | undefined
                readonly school?: string | undefined
                readonly yearsAttended?: number | undefined
              }>
            | undefined
          readonly experiences?:
            | ReadonlyArray<{
                readonly id: string
                readonly companyName?: string | undefined
                readonly current?: boolean | undefined
                readonly endDate?: any | undefined
                readonly jobTitle?: string | undefined
                readonly responsibilities?: string | undefined
                readonly startDate?: any | undefined
                readonly yearsEmployed?: number | undefined
              }>
            | undefined
          readonly placements?:
            | ReadonlyArray<{
                readonly startDate?: any | undefined
                readonly id: string
                readonly interviewDate?: any | undefined
                readonly status?: PlacementStatusEnum | undefined
                readonly permissions: { readonly update: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly slug: string
                  readonly title: string
                  readonly client?: { readonly displayname: string } | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                  }
                }
              }>
            | undefined
          readonly jobApplications?:
            | ReadonlyArray<{
                readonly id: string
                readonly status?: JobApplicationStatusEnum | undefined
                readonly permissions: { readonly show: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly level?: number | undefined
                  readonly slug: string
                  readonly title: string
                  readonly client?:
                    | { readonly displayname: string; readonly name: string }
                    | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                    readonly managePlacements: boolean
                  }
                  readonly jobPostingScreening?:
                    | { readonly id: string }
                    | undefined
                }
                readonly screeningSubmissions?:
                  | ReadonlyArray<{ readonly id: string }>
                  | undefined
              }>
            | undefined
          readonly permissions: {
            readonly edit: boolean
            readonly readApplications: boolean
            readonly readCredentials: boolean
            readonly readLicense: boolean
            readonly readResume: boolean
            readonly readWorkPreferences: boolean
          }
          readonly recruiters?:
            | ReadonlyArray<{
                readonly avatarUrl?: string | undefined
                readonly firstName: string
                readonly id: string
                readonly lastName: string
              }>
            | undefined
          readonly skillRelations?:
            | ReadonlyArray<{
                readonly id: string
                readonly years: number
                readonly skill: {
                  readonly __typename: 'Skill'
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly summary?:
            | {
                readonly id: string
                readonly entry: string
                readonly title: string
              }
            | undefined
        }
      | undefined
    readonly subscription?:
      | {
          readonly __typename: 'Subscription'
          readonly id: string
          readonly active: boolean
          readonly plan: string
        }
      | undefined
  }
}

export type UpdateUserPasswordMutationVariables = Exact<{
  input: UpdateUserPasswordInput
}>

export type UpdateUserPasswordMutation = {
  readonly updateUserPassword: {
    readonly __typename: 'User'
    readonly jwt?: string | undefined
    readonly termsAcceptedAt?: any | undefined
    readonly id: string
    readonly username: string
    readonly availability?: string | undefined
    readonly avatarUrl?: string | undefined
    readonly connectionCount: number
    readonly connectionStatus?: ConnectionStatusEnum | undefined
    readonly email?: string | undefined
    readonly secondaryEmail?: string | undefined
    readonly firstName: string
    readonly indispensableSurveyLink: string
    readonly isCurrentUser: boolean
    readonly lastName: string
    readonly phoneNumber?: string | undefined
    readonly uri: string
    readonly client?:
      | {
          readonly __typename: 'Client'
          readonly id: string
          readonly billingAddress?: string | undefined
          readonly accountsPayableEmail?: string | undefined
          readonly displayname: string
          readonly avatarUrl?: string | undefined
          readonly companySize?: CompanySizeEnum | undefined
          readonly connectionStatus?: ConnectionStatusEnum | undefined
          readonly countAvailablePositions: number
          readonly countRecentPositions: number
          readonly headline: string
          readonly metaDescription: string
          readonly metaTitle: string
          readonly name: string
          readonly profileComplete: boolean
          readonly profileCompletedAt?: any | undefined
          readonly uri: string
          readonly visibleOnPlatform: boolean
          readonly website?: string | undefined
          readonly companyDescription?: string | undefined
          readonly companyEmploymentBenefits?:
            | ReadonlyArray<{
                readonly id: string
                readonly employmentBenefit: {
                  readonly icon: string
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly companyLocations?:
            | ReadonlyArray<{
                readonly address?: string | undefined
                readonly addressExtended?: string | undefined
                readonly city?: string | undefined
                readonly country?: CountriesEnum | undefined
                readonly latitude?: number | undefined
                readonly longitude?: number | undefined
                readonly postalCode?: string | undefined
                readonly rawLocation?: string | undefined
                readonly state?: StatesEnum | undefined
              }>
            | undefined
          readonly companyPhotos?:
            | ReadonlyArray<{
                readonly id: string
                readonly alt?: string | undefined
                readonly displayRole?: CompanyPhotoDisplayRoleEnum | undefined
                readonly mediaType?: CompanyPhotoMediaTypeEnum | undefined
                readonly url: string
              }>
            | undefined
          readonly companyValues?:
            | ReadonlyArray<{
                readonly id: string
                readonly description: string
                readonly title: string
              }>
            | undefined
          readonly location: {
            readonly address?: string | undefined
            readonly addressExtended?: string | undefined
            readonly city?: string | undefined
            readonly country?: CountriesEnum | undefined
            readonly latitude?: number | undefined
            readonly longitude?: number | undefined
            readonly postalCode?: string | undefined
            readonly rawLocation?: string | undefined
            readonly state?: StatesEnum | undefined
          }
          readonly permissions: {
            readonly createJobPosting: boolean
            readonly edit: boolean
            readonly editMeta: boolean
            readonly internalUser: boolean
            readonly readPendingBanner: boolean
            readonly toggleVisible: boolean
          }
          readonly social?:
            | {
                readonly facebook?: string | undefined
                readonly instagram?: string | undefined
                readonly linkedin?: string | undefined
                readonly twitter?: string | undefined
              }
            | undefined
          readonly trainings: {
            readonly pageInfo: { readonly totalCount: number }
          }
        }
      | undefined
    readonly activities?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly alerts?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly gigsEmployee?:
      | {
          readonly id: string
          readonly createdAt: any
          readonly deletedAt?: any | undefined
          readonly eligibleAt?: any | undefined
          readonly offboardedAt?: any | undefined
          readonly onboardedAt?: any | undefined
          readonly onboardingStatus: OnboardingStatusEnum
          readonly percentComplete?: number | undefined
          readonly rejectedAt?: any | undefined
          readonly savedAt?: any | undefined
          readonly screeningAt?: any | undefined
          readonly terminatedAt?: any | undefined
          readonly updatedAt: any
          readonly permissions: { readonly seeHistory: boolean }
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly applyToJobs: boolean
      readonly edit: boolean
      readonly hasRecruiterLabel: boolean
      readonly imposter: boolean
      readonly internalUser: boolean
      readonly publishJobOrders: boolean
      readonly readEmail: boolean
      readonly readJobBooster: boolean
      readonly readNotes: boolean
      readonly readPhone: boolean
      readonly triggerIndispensableSurvey: boolean
      readonly searchCandidates: boolean
      readonly searchCandidatesAsClient: boolean
      readonly searchCandidatesAsRecruiter: boolean
      readonly searchClients: boolean
      readonly searchClientsByRecruiters: boolean
      readonly searchJobPostings: boolean
      readonly searchJobPostingsByRecruiter: boolean
      readonly sendMessage: boolean
      readonly trainableUser: boolean
      readonly updateConnectionStatus: boolean
      readonly uploadCsv: boolean
      readonly matchCriteria: boolean
    }
    readonly social?:
      | {
          readonly calendly?: string | undefined
          readonly linkedin?: string | undefined
        }
      | undefined
    readonly candidate?:
      | {
          readonly __typename: 'Candidate'
          readonly id: string
          readonly backgroundCheckDate?: any | undefined
          readonly credentialCount: number
          readonly dnu?: string | undefined
          readonly hiringStatus?: HiringStatusEnum | undefined
          readonly i9Date?: any | undefined
          readonly idealEmployment?: string | undefined
          readonly isAbleToApply: boolean
          readonly isNeedEmploymentSponsor?: boolean | undefined
          readonly isUsWorkAuthorized?: boolean | undefined
          readonly noWorkExperience?: boolean | undefined
          readonly profileCompletedAt?: any | undefined
          readonly profilePercentComplete?: number | undefined
          readonly relayId: string
          readonly resumeUrl?: string | undefined
          readonly salaryExpectations?: string | undefined
          readonly candidateLicenses?:
            | ReadonlyArray<{
                readonly id: string
                readonly date?: any | undefined
                readonly number?: string | undefined
                readonly url?: string | undefined
                readonly license?:
                  | {
                      readonly id: string
                      readonly name: string
                      readonly country: CountriesEnum
                      readonly state?: string | undefined
                    }
                  | undefined
              }>
            | undefined
          readonly credentials?:
            | ReadonlyArray<{
                readonly id: string
                readonly title: string
                readonly badgeUrl: string
                readonly description?: string | undefined
                readonly training: {
                  readonly id: string
                  readonly trainingUrl: string
                }
              }>
            | undefined
          readonly education?:
            | ReadonlyArray<{
                readonly id: string
                readonly degree?: string | undefined
                readonly educationLevel?: EducationLevelEnum | undefined
                readonly school?: string | undefined
                readonly yearsAttended?: number | undefined
              }>
            | undefined
          readonly experiences?:
            | ReadonlyArray<{
                readonly id: string
                readonly companyName?: string | undefined
                readonly current?: boolean | undefined
                readonly endDate?: any | undefined
                readonly jobTitle?: string | undefined
                readonly responsibilities?: string | undefined
                readonly startDate?: any | undefined
                readonly yearsEmployed?: number | undefined
              }>
            | undefined
          readonly placements?:
            | ReadonlyArray<{
                readonly startDate?: any | undefined
                readonly id: string
                readonly interviewDate?: any | undefined
                readonly status?: PlacementStatusEnum | undefined
                readonly permissions: { readonly update: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly slug: string
                  readonly title: string
                  readonly client?: { readonly displayname: string } | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                  }
                }
              }>
            | undefined
          readonly jobApplications?:
            | ReadonlyArray<{
                readonly id: string
                readonly status?: JobApplicationStatusEnum | undefined
                readonly permissions: { readonly show: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly level?: number | undefined
                  readonly slug: string
                  readonly title: string
                  readonly client?:
                    | { readonly displayname: string; readonly name: string }
                    | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                    readonly managePlacements: boolean
                  }
                  readonly jobPostingScreening?:
                    | { readonly id: string }
                    | undefined
                }
                readonly screeningSubmissions?:
                  | ReadonlyArray<{ readonly id: string }>
                  | undefined
              }>
            | undefined
          readonly permissions: {
            readonly edit: boolean
            readonly readApplications: boolean
            readonly readCredentials: boolean
            readonly readLicense: boolean
            readonly readResume: boolean
            readonly readWorkPreferences: boolean
          }
          readonly recruiters?:
            | ReadonlyArray<{
                readonly avatarUrl?: string | undefined
                readonly firstName: string
                readonly id: string
                readonly lastName: string
              }>
            | undefined
          readonly skillRelations?:
            | ReadonlyArray<{
                readonly id: string
                readonly years: number
                readonly skill: {
                  readonly __typename: 'Skill'
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly summary?:
            | {
                readonly id: string
                readonly entry: string
                readonly title: string
              }
            | undefined
        }
      | undefined
    readonly subscription?:
      | {
          readonly __typename: 'Subscription'
          readonly id: string
          readonly active: boolean
          readonly plan: string
        }
      | undefined
  }
}

export type BasePageInfoFragment = {
  readonly endCursor?: string | undefined
  readonly hasNextPage: boolean
  readonly hasPreviousPage: boolean
  readonly startCursor?: string | undefined
  readonly totalCount: number
}

export type PageInfoFragment = {
  readonly endCursor?: string | undefined
  readonly hasNextPage: boolean
  readonly hasPreviousPage: boolean
  readonly startCursor?: string | undefined
}

export type ActivityConnectionFragment = {
  readonly edges?:
    | ReadonlyArray<
        | {
            readonly __typename: 'ActivityEdge'
            readonly cursor: string
            readonly node?:
              | {
                  readonly id: string
                  readonly alert?: boolean | undefined
                  readonly body?: string | undefined
                  readonly createdAt: any
                  readonly jsonBody?: any | undefined
                  readonly recipientRead?: any | undefined
                  readonly updatedAt: any
                  readonly author?:
                    | {
                        readonly id: string
                        readonly avatarUrl?: string | undefined
                        readonly firstName: string
                        readonly lastName: string
                        readonly uri: string
                        readonly username: string
                      }
                    | undefined
                  readonly kontext?:
                    | {
                        readonly __typename: 'ChatMessage'
                        readonly id: string
                        readonly sender: { readonly username: string }
                      }
                    | {
                        readonly __typename: 'JobApplication'
                        readonly id: string
                        readonly uri: string
                        readonly jobPosting: {
                          readonly id: string
                          readonly slug: string
                          readonly client?:
                            | { readonly displayname: string }
                            | undefined
                        }
                        readonly user?:
                          | { readonly id: string; readonly username: string }
                          | undefined
                      }
                    | {
                        readonly __typename: 'JobPosting'
                        readonly id: string
                        readonly slug: string
                        readonly uri: string
                        readonly client?:
                          | {
                              readonly id: string
                              readonly displayname: string
                            }
                          | undefined
                      }
                    | {
                        readonly __typename: 'Placement'
                        readonly id: string
                        readonly uri: string
                        readonly updatedAt: any
                        readonly jobPosting: {
                          readonly id: string
                          readonly slug: string
                          readonly client?:
                            | {
                                readonly id: string
                                readonly displayname: string
                              }
                            | undefined
                        }
                        readonly user?:
                          | { readonly id: string; readonly username: string }
                          | undefined
                      }
                    | {
                        readonly __typename: 'User'
                        readonly id: string
                        readonly username: string
                        readonly uri: string
                      }
                    | {}
                    | undefined
                  readonly resource:
                    | {
                        readonly __typename: 'Client'
                        readonly id: string
                        readonly displayname: string
                        readonly uri: string
                      }
                    | { readonly __typename: 'GigsEmployee' }
                    | {
                        readonly __typename: 'JobApplication'
                        readonly id: string
                        readonly uri: string
                        readonly jobPosting: {
                          readonly id: string
                          readonly slug: string
                          readonly client?:
                            | { readonly displayname: string }
                            | undefined
                        }
                        readonly user?:
                          | { readonly id: string; readonly username: string }
                          | undefined
                      }
                    | {
                        readonly __typename: 'JobPosting'
                        readonly id: string
                        readonly slug: string
                        readonly uri: string
                        readonly client?:
                          | {
                              readonly id: string
                              readonly displayname: string
                            }
                          | undefined
                      }
                    | {
                        readonly __typename: 'Placement'
                        readonly id: string
                        readonly uri: string
                        readonly updatedAt: any
                        readonly jobPosting: {
                          readonly id: string
                          readonly slug: string
                          readonly client?:
                            | {
                                readonly id: string
                                readonly displayname: string
                              }
                            | undefined
                        }
                        readonly user?:
                          | { readonly id: string; readonly username: string }
                          | undefined
                      }
                    | {
                        readonly __typename: 'User'
                        readonly id: string
                        readonly username: string
                        readonly uri: string
                      }
                }
              | undefined
          }
        | undefined
      >
    | undefined
  readonly pageInfo: {
    readonly endCursor?: string | undefined
    readonly hasNextPage: boolean
    readonly hasPreviousPage: boolean
    readonly startCursor?: string | undefined
    readonly totalCount: number
  }
}

export type ActivityEdgeFragment = {
  readonly __typename: 'ActivityEdge'
  readonly cursor: string
  readonly node?:
    | {
        readonly id: string
        readonly alert?: boolean | undefined
        readonly body?: string | undefined
        readonly createdAt: any
        readonly jsonBody?: any | undefined
        readonly recipientRead?: any | undefined
        readonly updatedAt: any
        readonly author?:
          | {
              readonly id: string
              readonly avatarUrl?: string | undefined
              readonly firstName: string
              readonly lastName: string
              readonly uri: string
              readonly username: string
            }
          | undefined
        readonly kontext?:
          | {
              readonly __typename: 'ChatMessage'
              readonly id: string
              readonly sender: { readonly username: string }
            }
          | {
              readonly __typename: 'JobApplication'
              readonly id: string
              readonly uri: string
              readonly jobPosting: {
                readonly id: string
                readonly slug: string
                readonly client?: { readonly displayname: string } | undefined
              }
              readonly user?:
                | { readonly id: string; readonly username: string }
                | undefined
            }
          | {
              readonly __typename: 'JobPosting'
              readonly id: string
              readonly slug: string
              readonly uri: string
              readonly client?:
                | { readonly id: string; readonly displayname: string }
                | undefined
            }
          | {
              readonly __typename: 'Placement'
              readonly id: string
              readonly uri: string
              readonly updatedAt: any
              readonly jobPosting: {
                readonly id: string
                readonly slug: string
                readonly client?:
                  | { readonly id: string; readonly displayname: string }
                  | undefined
              }
              readonly user?:
                | { readonly id: string; readonly username: string }
                | undefined
            }
          | {
              readonly __typename: 'User'
              readonly id: string
              readonly username: string
              readonly uri: string
            }
          | {}
          | undefined
        readonly resource:
          | {
              readonly __typename: 'Client'
              readonly id: string
              readonly displayname: string
              readonly uri: string
            }
          | { readonly __typename: 'GigsEmployee' }
          | {
              readonly __typename: 'JobApplication'
              readonly id: string
              readonly uri: string
              readonly jobPosting: {
                readonly id: string
                readonly slug: string
                readonly client?: { readonly displayname: string } | undefined
              }
              readonly user?:
                | { readonly id: string; readonly username: string }
                | undefined
            }
          | {
              readonly __typename: 'JobPosting'
              readonly id: string
              readonly slug: string
              readonly uri: string
              readonly client?:
                | { readonly id: string; readonly displayname: string }
                | undefined
            }
          | {
              readonly __typename: 'Placement'
              readonly id: string
              readonly uri: string
              readonly updatedAt: any
              readonly jobPosting: {
                readonly id: string
                readonly slug: string
                readonly client?:
                  | { readonly id: string; readonly displayname: string }
                  | undefined
              }
              readonly user?:
                | { readonly id: string; readonly username: string }
                | undefined
            }
          | {
              readonly __typename: 'User'
              readonly id: string
              readonly username: string
              readonly uri: string
            }
      }
    | undefined
}

export type ActivityFragment = {
  readonly id: string
  readonly alert?: boolean | undefined
  readonly body?: string | undefined
  readonly createdAt: any
  readonly jsonBody?: any | undefined
  readonly recipientRead?: any | undefined
  readonly updatedAt: any
  readonly author?:
    | {
        readonly id: string
        readonly avatarUrl?: string | undefined
        readonly firstName: string
        readonly lastName: string
        readonly uri: string
        readonly username: string
      }
    | undefined
  readonly kontext?:
    | {
        readonly __typename: 'ChatMessage'
        readonly id: string
        readonly sender: { readonly username: string }
      }
    | {
        readonly __typename: 'JobApplication'
        readonly id: string
        readonly uri: string
        readonly jobPosting: {
          readonly id: string
          readonly slug: string
          readonly client?: { readonly displayname: string } | undefined
        }
        readonly user?:
          | { readonly id: string; readonly username: string }
          | undefined
      }
    | {
        readonly __typename: 'JobPosting'
        readonly id: string
        readonly slug: string
        readonly uri: string
        readonly client?:
          | { readonly id: string; readonly displayname: string }
          | undefined
      }
    | {
        readonly __typename: 'Placement'
        readonly id: string
        readonly uri: string
        readonly updatedAt: any
        readonly jobPosting: {
          readonly id: string
          readonly slug: string
          readonly client?:
            | { readonly id: string; readonly displayname: string }
            | undefined
        }
        readonly user?:
          | { readonly id: string; readonly username: string }
          | undefined
      }
    | {
        readonly __typename: 'User'
        readonly id: string
        readonly username: string
        readonly uri: string
      }
    | {}
    | undefined
  readonly resource:
    | {
        readonly __typename: 'Client'
        readonly id: string
        readonly displayname: string
        readonly uri: string
      }
    | { readonly __typename: 'GigsEmployee' }
    | {
        readonly __typename: 'JobApplication'
        readonly id: string
        readonly uri: string
        readonly jobPosting: {
          readonly id: string
          readonly slug: string
          readonly client?: { readonly displayname: string } | undefined
        }
        readonly user?:
          | { readonly id: string; readonly username: string }
          | undefined
      }
    | {
        readonly __typename: 'JobPosting'
        readonly id: string
        readonly slug: string
        readonly uri: string
        readonly client?:
          | { readonly id: string; readonly displayname: string }
          | undefined
      }
    | {
        readonly __typename: 'Placement'
        readonly id: string
        readonly uri: string
        readonly updatedAt: any
        readonly jobPosting: {
          readonly id: string
          readonly slug: string
          readonly client?:
            | { readonly id: string; readonly displayname: string }
            | undefined
        }
        readonly user?:
          | { readonly id: string; readonly username: string }
          | undefined
      }
    | {
        readonly __typename: 'User'
        readonly id: string
        readonly username: string
        readonly uri: string
      }
}

export type Kontext_MemberFragment = {
  readonly __typename: 'User'
  readonly id: string
  readonly username: string
  readonly uri: string
}

export type Kontext_ClientFragment = {
  readonly __typename: 'Client'
  readonly id: string
  readonly displayname: string
  readonly uri: string
}

export type Kontext_JobApplicationFragment = {
  readonly __typename: 'JobApplication'
  readonly id: string
  readonly uri: string
  readonly jobPosting: {
    readonly id: string
    readonly slug: string
    readonly client?: { readonly displayname: string } | undefined
  }
  readonly user?: { readonly id: string; readonly username: string } | undefined
}

export type Kontext_JobPostingFragment = {
  readonly __typename: 'JobPosting'
  readonly id: string
  readonly slug: string
  readonly uri: string
  readonly client?:
    | { readonly id: string; readonly displayname: string }
    | undefined
}

export type Kontext_PlacementFragment = {
  readonly __typename: 'Placement'
  readonly id: string
  readonly uri: string
  readonly updatedAt: any
  readonly jobPosting: {
    readonly id: string
    readonly slug: string
    readonly client?:
      | { readonly id: string; readonly displayname: string }
      | undefined
  }
  readonly user?: { readonly id: string; readonly username: string } | undefined
}

export type ProfessionalInterestFragment = {
  readonly id: string
  readonly icon?: string | undefined
  readonly name: string
}

export type ProfessionalInterestsQueryVariables = Exact<{
  [key: string]: never
}>

export type ProfessionalInterestsQuery = {
  readonly professionalInterests: ReadonlyArray<{
    readonly id: string
    readonly icon?: string | undefined
    readonly name: string
  }>
}

export type PlatformIntentionFragment = {
  readonly id: string
  readonly icon?: string | undefined
  readonly name: string
}

export type PlatformIntentionsQueryVariables = Exact<{ [key: string]: never }>

export type PlatformIntentionsQuery = {
  readonly platformIntentions: ReadonlyArray<{
    readonly id: string
    readonly icon?: string | undefined
    readonly name: string
  }>
}

export type SkillFragment = {
  readonly __typename: 'Skill'
  readonly id: string
  readonly name: string
}

export type SkillsQueryVariables = Exact<{ [key: string]: never }>

export type SkillsQuery = {
  readonly skills: ReadonlyArray<{
    readonly __typename: 'Skill'
    readonly id: string
    readonly name: string
  }>
}

export type JobPostingLicenseFragment = {
  readonly id: string
  readonly license: {
    readonly id: string
    readonly name: string
    readonly country: CountriesEnum
    readonly state?: string | undefined
  }
}

export type LicenseFragment = {
  readonly id: string
  readonly name: string
  readonly country: CountriesEnum
  readonly state?: string | undefined
}

export type LicensesQueryVariables = Exact<{ [key: string]: never }>

export type LicensesQuery = {
  readonly licenses: ReadonlyArray<{
    readonly id: string
    readonly name: string
    readonly country: CountriesEnum
    readonly state?: string | undefined
  }>
}

export type EmploymentBenefitFragment = {
  readonly __typename: 'EmploymentBenefit'
  readonly id: string
  readonly name: string
}

export type EmploymentBenefitsQueryVariables = Exact<{ [key: string]: never }>

export type EmploymentBenefitsQuery = {
  readonly employmentBenefits: ReadonlyArray<{
    readonly __typename: 'EmploymentBenefit'
    readonly id: string
    readonly name: string
  }>
}

export type FeaturedMembersQueryVariables = Exact<{
  recruiters?: InputMaybe<Scalars['Boolean']['input']>
}>

export type FeaturedMembersQuery = {
  readonly featuredMembers: ReadonlyArray<{
    readonly __typename: 'User'
    readonly id: string
    readonly username: string
    readonly availability?: string | undefined
    readonly avatarUrl?: string | undefined
    readonly connectionCount: number
    readonly connectionStatus?: ConnectionStatusEnum | undefined
    readonly email?: string | undefined
    readonly secondaryEmail?: string | undefined
    readonly firstName: string
    readonly indispensableSurveyLink: string
    readonly isCurrentUser: boolean
    readonly lastName: string
    readonly termsAcceptedAt?: any | undefined
    readonly phoneNumber?: string | undefined
    readonly uri: string
    readonly activities?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly alerts?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly gigsEmployee?:
      | {
          readonly id: string
          readonly createdAt: any
          readonly deletedAt?: any | undefined
          readonly eligibleAt?: any | undefined
          readonly offboardedAt?: any | undefined
          readonly onboardedAt?: any | undefined
          readonly onboardingStatus: OnboardingStatusEnum
          readonly percentComplete?: number | undefined
          readonly rejectedAt?: any | undefined
          readonly savedAt?: any | undefined
          readonly screeningAt?: any | undefined
          readonly terminatedAt?: any | undefined
          readonly updatedAt: any
          readonly permissions: { readonly seeHistory: boolean }
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly applyToJobs: boolean
      readonly edit: boolean
      readonly hasRecruiterLabel: boolean
      readonly imposter: boolean
      readonly internalUser: boolean
      readonly publishJobOrders: boolean
      readonly readEmail: boolean
      readonly readJobBooster: boolean
      readonly readNotes: boolean
      readonly readPhone: boolean
      readonly triggerIndispensableSurvey: boolean
      readonly searchCandidates: boolean
      readonly searchCandidatesAsClient: boolean
      readonly searchCandidatesAsRecruiter: boolean
      readonly searchClients: boolean
      readonly searchClientsByRecruiters: boolean
      readonly searchJobPostings: boolean
      readonly searchJobPostingsByRecruiter: boolean
      readonly sendMessage: boolean
      readonly trainableUser: boolean
      readonly updateConnectionStatus: boolean
      readonly uploadCsv: boolean
      readonly matchCriteria: boolean
    }
    readonly social?:
      | {
          readonly calendly?: string | undefined
          readonly linkedin?: string | undefined
        }
      | undefined
    readonly candidate?:
      | {
          readonly __typename: 'Candidate'
          readonly id: string
          readonly backgroundCheckDate?: any | undefined
          readonly credentialCount: number
          readonly dnu?: string | undefined
          readonly hiringStatus?: HiringStatusEnum | undefined
          readonly i9Date?: any | undefined
          readonly idealEmployment?: string | undefined
          readonly isAbleToApply: boolean
          readonly isNeedEmploymentSponsor?: boolean | undefined
          readonly isUsWorkAuthorized?: boolean | undefined
          readonly noWorkExperience?: boolean | undefined
          readonly profileCompletedAt?: any | undefined
          readonly profilePercentComplete?: number | undefined
          readonly relayId: string
          readonly resumeUrl?: string | undefined
          readonly salaryExpectations?: string | undefined
          readonly candidateLicenses?:
            | ReadonlyArray<{
                readonly id: string
                readonly date?: any | undefined
                readonly number?: string | undefined
                readonly url?: string | undefined
                readonly license?:
                  | {
                      readonly id: string
                      readonly name: string
                      readonly country: CountriesEnum
                      readonly state?: string | undefined
                    }
                  | undefined
              }>
            | undefined
          readonly credentials?:
            | ReadonlyArray<{
                readonly id: string
                readonly title: string
                readonly badgeUrl: string
                readonly description?: string | undefined
                readonly training: {
                  readonly id: string
                  readonly trainingUrl: string
                }
              }>
            | undefined
          readonly education?:
            | ReadonlyArray<{
                readonly id: string
                readonly degree?: string | undefined
                readonly educationLevel?: EducationLevelEnum | undefined
                readonly school?: string | undefined
                readonly yearsAttended?: number | undefined
              }>
            | undefined
          readonly experiences?:
            | ReadonlyArray<{
                readonly id: string
                readonly companyName?: string | undefined
                readonly current?: boolean | undefined
                readonly endDate?: any | undefined
                readonly jobTitle?: string | undefined
                readonly responsibilities?: string | undefined
                readonly startDate?: any | undefined
                readonly yearsEmployed?: number | undefined
              }>
            | undefined
          readonly placements?:
            | ReadonlyArray<{
                readonly startDate?: any | undefined
                readonly id: string
                readonly interviewDate?: any | undefined
                readonly status?: PlacementStatusEnum | undefined
                readonly permissions: { readonly update: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly slug: string
                  readonly title: string
                  readonly client?: { readonly displayname: string } | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                  }
                }
              }>
            | undefined
          readonly jobApplications?:
            | ReadonlyArray<{
                readonly id: string
                readonly status?: JobApplicationStatusEnum | undefined
                readonly permissions: { readonly show: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly level?: number | undefined
                  readonly slug: string
                  readonly title: string
                  readonly client?:
                    | { readonly displayname: string; readonly name: string }
                    | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                    readonly managePlacements: boolean
                  }
                  readonly jobPostingScreening?:
                    | { readonly id: string }
                    | undefined
                }
                readonly screeningSubmissions?:
                  | ReadonlyArray<{ readonly id: string }>
                  | undefined
              }>
            | undefined
          readonly permissions: {
            readonly edit: boolean
            readonly readApplications: boolean
            readonly readCredentials: boolean
            readonly readLicense: boolean
            readonly readResume: boolean
            readonly readWorkPreferences: boolean
          }
          readonly recruiters?:
            | ReadonlyArray<{
                readonly avatarUrl?: string | undefined
                readonly firstName: string
                readonly id: string
                readonly lastName: string
              }>
            | undefined
          readonly skillRelations?:
            | ReadonlyArray<{
                readonly id: string
                readonly years: number
                readonly skill: {
                  readonly __typename: 'Skill'
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly summary?:
            | {
                readonly id: string
                readonly entry: string
                readonly title: string
              }
            | undefined
        }
      | undefined
    readonly subscription?:
      | {
          readonly __typename: 'Subscription'
          readonly id: string
          readonly active: boolean
          readonly plan: string
        }
      | undefined
  }>
}

export type ScreeningFragment = {
  readonly id: string
  readonly name?: string | undefined
  readonly description?: string | undefined
}

export type ScreeningsQueryVariables = Exact<{ [key: string]: never }>

export type ScreeningsQuery = {
  readonly screenings: ReadonlyArray<{
    readonly id: string
    readonly name?: string | undefined
    readonly description?: string | undefined
  }>
}

export type EmployeeFragment = {
  readonly id: string
  readonly teams: ReadonlyArray<TeamEnum>
  readonly vangstBio: string
  readonly employeeTeamSortPositions?:
    | ReadonlyArray<{
        readonly id: string
        readonly position: number
        readonly team: string
      }>
    | undefined
  readonly user: {
    readonly __typename: 'User'
    readonly currentJobTitle?: string | undefined
    readonly id: string
    readonly username: string
    readonly availability?: string | undefined
    readonly avatarUrl?: string | undefined
    readonly connectionCount: number
    readonly connectionStatus?: ConnectionStatusEnum | undefined
    readonly email?: string | undefined
    readonly secondaryEmail?: string | undefined
    readonly firstName: string
    readonly indispensableSurveyLink: string
    readonly isCurrentUser: boolean
    readonly lastName: string
    readonly termsAcceptedAt?: any | undefined
    readonly phoneNumber?: string | undefined
    readonly uri: string
    readonly activities?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly alerts?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly gigsEmployee?:
      | {
          readonly id: string
          readonly createdAt: any
          readonly deletedAt?: any | undefined
          readonly eligibleAt?: any | undefined
          readonly offboardedAt?: any | undefined
          readonly onboardedAt?: any | undefined
          readonly onboardingStatus: OnboardingStatusEnum
          readonly percentComplete?: number | undefined
          readonly rejectedAt?: any | undefined
          readonly savedAt?: any | undefined
          readonly screeningAt?: any | undefined
          readonly terminatedAt?: any | undefined
          readonly updatedAt: any
          readonly permissions: { readonly seeHistory: boolean }
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly applyToJobs: boolean
      readonly edit: boolean
      readonly hasRecruiterLabel: boolean
      readonly imposter: boolean
      readonly internalUser: boolean
      readonly publishJobOrders: boolean
      readonly readEmail: boolean
      readonly readJobBooster: boolean
      readonly readNotes: boolean
      readonly readPhone: boolean
      readonly triggerIndispensableSurvey: boolean
      readonly searchCandidates: boolean
      readonly searchCandidatesAsClient: boolean
      readonly searchCandidatesAsRecruiter: boolean
      readonly searchClients: boolean
      readonly searchClientsByRecruiters: boolean
      readonly searchJobPostings: boolean
      readonly searchJobPostingsByRecruiter: boolean
      readonly sendMessage: boolean
      readonly trainableUser: boolean
      readonly updateConnectionStatus: boolean
      readonly uploadCsv: boolean
      readonly matchCriteria: boolean
    }
    readonly social?:
      | {
          readonly calendly?: string | undefined
          readonly linkedin?: string | undefined
        }
      | undefined
    readonly candidate?:
      | {
          readonly __typename: 'Candidate'
          readonly id: string
          readonly backgroundCheckDate?: any | undefined
          readonly credentialCount: number
          readonly dnu?: string | undefined
          readonly hiringStatus?: HiringStatusEnum | undefined
          readonly i9Date?: any | undefined
          readonly idealEmployment?: string | undefined
          readonly isAbleToApply: boolean
          readonly isNeedEmploymentSponsor?: boolean | undefined
          readonly isUsWorkAuthorized?: boolean | undefined
          readonly noWorkExperience?: boolean | undefined
          readonly profileCompletedAt?: any | undefined
          readonly profilePercentComplete?: number | undefined
          readonly relayId: string
          readonly resumeUrl?: string | undefined
          readonly salaryExpectations?: string | undefined
          readonly candidateLicenses?:
            | ReadonlyArray<{
                readonly id: string
                readonly date?: any | undefined
                readonly number?: string | undefined
                readonly url?: string | undefined
                readonly license?:
                  | {
                      readonly id: string
                      readonly name: string
                      readonly country: CountriesEnum
                      readonly state?: string | undefined
                    }
                  | undefined
              }>
            | undefined
          readonly credentials?:
            | ReadonlyArray<{
                readonly id: string
                readonly title: string
                readonly badgeUrl: string
                readonly description?: string | undefined
                readonly training: {
                  readonly id: string
                  readonly trainingUrl: string
                }
              }>
            | undefined
          readonly education?:
            | ReadonlyArray<{
                readonly id: string
                readonly degree?: string | undefined
                readonly educationLevel?: EducationLevelEnum | undefined
                readonly school?: string | undefined
                readonly yearsAttended?: number | undefined
              }>
            | undefined
          readonly experiences?:
            | ReadonlyArray<{
                readonly id: string
                readonly companyName?: string | undefined
                readonly current?: boolean | undefined
                readonly endDate?: any | undefined
                readonly jobTitle?: string | undefined
                readonly responsibilities?: string | undefined
                readonly startDate?: any | undefined
                readonly yearsEmployed?: number | undefined
              }>
            | undefined
          readonly placements?:
            | ReadonlyArray<{
                readonly startDate?: any | undefined
                readonly id: string
                readonly interviewDate?: any | undefined
                readonly status?: PlacementStatusEnum | undefined
                readonly permissions: { readonly update: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly slug: string
                  readonly title: string
                  readonly client?: { readonly displayname: string } | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                  }
                }
              }>
            | undefined
          readonly jobApplications?:
            | ReadonlyArray<{
                readonly id: string
                readonly status?: JobApplicationStatusEnum | undefined
                readonly permissions: { readonly show: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly level?: number | undefined
                  readonly slug: string
                  readonly title: string
                  readonly client?:
                    | { readonly displayname: string; readonly name: string }
                    | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                    readonly managePlacements: boolean
                  }
                  readonly jobPostingScreening?:
                    | { readonly id: string }
                    | undefined
                }
                readonly screeningSubmissions?:
                  | ReadonlyArray<{ readonly id: string }>
                  | undefined
              }>
            | undefined
          readonly permissions: {
            readonly edit: boolean
            readonly readApplications: boolean
            readonly readCredentials: boolean
            readonly readLicense: boolean
            readonly readResume: boolean
            readonly readWorkPreferences: boolean
          }
          readonly recruiters?:
            | ReadonlyArray<{
                readonly avatarUrl?: string | undefined
                readonly firstName: string
                readonly id: string
                readonly lastName: string
              }>
            | undefined
          readonly skillRelations?:
            | ReadonlyArray<{
                readonly id: string
                readonly years: number
                readonly skill: {
                  readonly __typename: 'Skill'
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly summary?:
            | {
                readonly id: string
                readonly entry: string
                readonly title: string
              }
            | undefined
        }
      | undefined
    readonly subscription?:
      | {
          readonly __typename: 'Subscription'
          readonly id: string
          readonly active: boolean
          readonly plan: string
        }
      | undefined
  }
}

export type GetEmployeesQueryVariables = Exact<{
  team?: InputMaybe<TeamEnum>
}>

export type GetEmployeesQuery = {
  readonly getEmployees: ReadonlyArray<{
    readonly id: string
    readonly teams: ReadonlyArray<TeamEnum>
    readonly vangstBio: string
    readonly employeeTeamSortPositions?:
      | ReadonlyArray<{
          readonly id: string
          readonly position: number
          readonly team: string
        }>
      | undefined
    readonly user: {
      readonly __typename: 'User'
      readonly currentJobTitle?: string | undefined
      readonly id: string
      readonly username: string
      readonly availability?: string | undefined
      readonly avatarUrl?: string | undefined
      readonly connectionCount: number
      readonly connectionStatus?: ConnectionStatusEnum | undefined
      readonly email?: string | undefined
      readonly secondaryEmail?: string | undefined
      readonly firstName: string
      readonly indispensableSurveyLink: string
      readonly isCurrentUser: boolean
      readonly lastName: string
      readonly termsAcceptedAt?: any | undefined
      readonly phoneNumber?: string | undefined
      readonly uri: string
      readonly activities?:
        | { readonly pageInfo: { readonly totalCount: number } }
        | undefined
      readonly alerts?:
        | { readonly pageInfo: { readonly totalCount: number } }
        | undefined
      readonly gigsEmployee?:
        | {
            readonly id: string
            readonly createdAt: any
            readonly deletedAt?: any | undefined
            readonly eligibleAt?: any | undefined
            readonly offboardedAt?: any | undefined
            readonly onboardedAt?: any | undefined
            readonly onboardingStatus: OnboardingStatusEnum
            readonly percentComplete?: number | undefined
            readonly rejectedAt?: any | undefined
            readonly savedAt?: any | undefined
            readonly screeningAt?: any | undefined
            readonly terminatedAt?: any | undefined
            readonly updatedAt: any
            readonly permissions: { readonly seeHistory: boolean }
          }
        | undefined
      readonly location: {
        readonly address?: string | undefined
        readonly addressExtended?: string | undefined
        readonly city?: string | undefined
        readonly country?: CountriesEnum | undefined
        readonly latitude?: number | undefined
        readonly longitude?: number | undefined
        readonly postalCode?: string | undefined
        readonly rawLocation?: string | undefined
        readonly state?: StatesEnum | undefined
      }
      readonly permissions: {
        readonly applyToJobs: boolean
        readonly edit: boolean
        readonly hasRecruiterLabel: boolean
        readonly imposter: boolean
        readonly internalUser: boolean
        readonly publishJobOrders: boolean
        readonly readEmail: boolean
        readonly readJobBooster: boolean
        readonly readNotes: boolean
        readonly readPhone: boolean
        readonly triggerIndispensableSurvey: boolean
        readonly searchCandidates: boolean
        readonly searchCandidatesAsClient: boolean
        readonly searchCandidatesAsRecruiter: boolean
        readonly searchClients: boolean
        readonly searchClientsByRecruiters: boolean
        readonly searchJobPostings: boolean
        readonly searchJobPostingsByRecruiter: boolean
        readonly sendMessage: boolean
        readonly trainableUser: boolean
        readonly updateConnectionStatus: boolean
        readonly uploadCsv: boolean
        readonly matchCriteria: boolean
      }
      readonly social?:
        | {
            readonly calendly?: string | undefined
            readonly linkedin?: string | undefined
          }
        | undefined
      readonly candidate?:
        | {
            readonly __typename: 'Candidate'
            readonly id: string
            readonly backgroundCheckDate?: any | undefined
            readonly credentialCount: number
            readonly dnu?: string | undefined
            readonly hiringStatus?: HiringStatusEnum | undefined
            readonly i9Date?: any | undefined
            readonly idealEmployment?: string | undefined
            readonly isAbleToApply: boolean
            readonly isNeedEmploymentSponsor?: boolean | undefined
            readonly isUsWorkAuthorized?: boolean | undefined
            readonly noWorkExperience?: boolean | undefined
            readonly profileCompletedAt?: any | undefined
            readonly profilePercentComplete?: number | undefined
            readonly relayId: string
            readonly resumeUrl?: string | undefined
            readonly salaryExpectations?: string | undefined
            readonly candidateLicenses?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly date?: any | undefined
                  readonly number?: string | undefined
                  readonly url?: string | undefined
                  readonly license?:
                    | {
                        readonly id: string
                        readonly name: string
                        readonly country: CountriesEnum
                        readonly state?: string | undefined
                      }
                    | undefined
                }>
              | undefined
            readonly credentials?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly title: string
                  readonly badgeUrl: string
                  readonly description?: string | undefined
                  readonly training: {
                    readonly id: string
                    readonly trainingUrl: string
                  }
                }>
              | undefined
            readonly education?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly degree?: string | undefined
                  readonly educationLevel?: EducationLevelEnum | undefined
                  readonly school?: string | undefined
                  readonly yearsAttended?: number | undefined
                }>
              | undefined
            readonly experiences?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly companyName?: string | undefined
                  readonly current?: boolean | undefined
                  readonly endDate?: any | undefined
                  readonly jobTitle?: string | undefined
                  readonly responsibilities?: string | undefined
                  readonly startDate?: any | undefined
                  readonly yearsEmployed?: number | undefined
                }>
              | undefined
            readonly placements?:
              | ReadonlyArray<{
                  readonly startDate?: any | undefined
                  readonly id: string
                  readonly interviewDate?: any | undefined
                  readonly status?: PlacementStatusEnum | undefined
                  readonly permissions: { readonly update: boolean }
                  readonly jobPosting: {
                    readonly id: string
                    readonly slug: string
                    readonly title: string
                    readonly client?:
                      | { readonly displayname: string }
                      | undefined
                    readonly permissions: {
                      readonly readJobApps: boolean
                      readonly readPlacements: boolean
                    }
                  }
                }>
              | undefined
            readonly jobApplications?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly status?: JobApplicationStatusEnum | undefined
                  readonly permissions: { readonly show: boolean }
                  readonly jobPosting: {
                    readonly id: string
                    readonly level?: number | undefined
                    readonly slug: string
                    readonly title: string
                    readonly client?:
                      | { readonly displayname: string; readonly name: string }
                      | undefined
                    readonly permissions: {
                      readonly readJobApps: boolean
                      readonly readPlacements: boolean
                      readonly managePlacements: boolean
                    }
                    readonly jobPostingScreening?:
                      | { readonly id: string }
                      | undefined
                  }
                  readonly screeningSubmissions?:
                    | ReadonlyArray<{ readonly id: string }>
                    | undefined
                }>
              | undefined
            readonly permissions: {
              readonly edit: boolean
              readonly readApplications: boolean
              readonly readCredentials: boolean
              readonly readLicense: boolean
              readonly readResume: boolean
              readonly readWorkPreferences: boolean
            }
            readonly recruiters?:
              | ReadonlyArray<{
                  readonly avatarUrl?: string | undefined
                  readonly firstName: string
                  readonly id: string
                  readonly lastName: string
                }>
              | undefined
            readonly skillRelations?:
              | ReadonlyArray<{
                  readonly id: string
                  readonly years: number
                  readonly skill: {
                    readonly __typename: 'Skill'
                    readonly id: string
                    readonly name: string
                  }
                }>
              | undefined
            readonly summary?:
              | {
                  readonly id: string
                  readonly entry: string
                  readonly title: string
                }
              | undefined
          }
        | undefined
      readonly subscription?:
        | {
            readonly __typename: 'Subscription'
            readonly id: string
            readonly active: boolean
            readonly plan: string
          }
        | undefined
    }
  }>
}

export type ChatMessageFragment = {
  readonly id: string
  readonly createdAt: any
  readonly recipientRead?: any | undefined
  readonly senderRead?: any | undefined
  readonly slateMessage: any
  readonly updatedAt: any
  readonly recipient: {
    readonly __typename: 'User'
    readonly id: string
    readonly username: string
    readonly availability?: string | undefined
    readonly avatarUrl?: string | undefined
    readonly connectionCount: number
    readonly connectionStatus?: ConnectionStatusEnum | undefined
    readonly email?: string | undefined
    readonly secondaryEmail?: string | undefined
    readonly firstName: string
    readonly indispensableSurveyLink: string
    readonly isCurrentUser: boolean
    readonly lastName: string
    readonly termsAcceptedAt?: any | undefined
    readonly phoneNumber?: string | undefined
    readonly uri: string
    readonly activities?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly alerts?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly gigsEmployee?:
      | {
          readonly id: string
          readonly createdAt: any
          readonly deletedAt?: any | undefined
          readonly eligibleAt?: any | undefined
          readonly offboardedAt?: any | undefined
          readonly onboardedAt?: any | undefined
          readonly onboardingStatus: OnboardingStatusEnum
          readonly percentComplete?: number | undefined
          readonly rejectedAt?: any | undefined
          readonly savedAt?: any | undefined
          readonly screeningAt?: any | undefined
          readonly terminatedAt?: any | undefined
          readonly updatedAt: any
          readonly permissions: { readonly seeHistory: boolean }
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly applyToJobs: boolean
      readonly edit: boolean
      readonly hasRecruiterLabel: boolean
      readonly imposter: boolean
      readonly internalUser: boolean
      readonly publishJobOrders: boolean
      readonly readEmail: boolean
      readonly readJobBooster: boolean
      readonly readNotes: boolean
      readonly readPhone: boolean
      readonly triggerIndispensableSurvey: boolean
      readonly searchCandidates: boolean
      readonly searchCandidatesAsClient: boolean
      readonly searchCandidatesAsRecruiter: boolean
      readonly searchClients: boolean
      readonly searchClientsByRecruiters: boolean
      readonly searchJobPostings: boolean
      readonly searchJobPostingsByRecruiter: boolean
      readonly sendMessage: boolean
      readonly trainableUser: boolean
      readonly updateConnectionStatus: boolean
      readonly uploadCsv: boolean
      readonly matchCriteria: boolean
    }
    readonly social?:
      | {
          readonly calendly?: string | undefined
          readonly linkedin?: string | undefined
        }
      | undefined
    readonly candidate?:
      | {
          readonly __typename: 'Candidate'
          readonly id: string
          readonly backgroundCheckDate?: any | undefined
          readonly credentialCount: number
          readonly dnu?: string | undefined
          readonly hiringStatus?: HiringStatusEnum | undefined
          readonly i9Date?: any | undefined
          readonly idealEmployment?: string | undefined
          readonly isAbleToApply: boolean
          readonly isNeedEmploymentSponsor?: boolean | undefined
          readonly isUsWorkAuthorized?: boolean | undefined
          readonly noWorkExperience?: boolean | undefined
          readonly profileCompletedAt?: any | undefined
          readonly profilePercentComplete?: number | undefined
          readonly relayId: string
          readonly resumeUrl?: string | undefined
          readonly salaryExpectations?: string | undefined
          readonly candidateLicenses?:
            | ReadonlyArray<{
                readonly id: string
                readonly date?: any | undefined
                readonly number?: string | undefined
                readonly url?: string | undefined
                readonly license?:
                  | {
                      readonly id: string
                      readonly name: string
                      readonly country: CountriesEnum
                      readonly state?: string | undefined
                    }
                  | undefined
              }>
            | undefined
          readonly credentials?:
            | ReadonlyArray<{
                readonly id: string
                readonly title: string
                readonly badgeUrl: string
                readonly description?: string | undefined
                readonly training: {
                  readonly id: string
                  readonly trainingUrl: string
                }
              }>
            | undefined
          readonly education?:
            | ReadonlyArray<{
                readonly id: string
                readonly degree?: string | undefined
                readonly educationLevel?: EducationLevelEnum | undefined
                readonly school?: string | undefined
                readonly yearsAttended?: number | undefined
              }>
            | undefined
          readonly experiences?:
            | ReadonlyArray<{
                readonly id: string
                readonly companyName?: string | undefined
                readonly current?: boolean | undefined
                readonly endDate?: any | undefined
                readonly jobTitle?: string | undefined
                readonly responsibilities?: string | undefined
                readonly startDate?: any | undefined
                readonly yearsEmployed?: number | undefined
              }>
            | undefined
          readonly placements?:
            | ReadonlyArray<{
                readonly startDate?: any | undefined
                readonly id: string
                readonly interviewDate?: any | undefined
                readonly status?: PlacementStatusEnum | undefined
                readonly permissions: { readonly update: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly slug: string
                  readonly title: string
                  readonly client?: { readonly displayname: string } | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                  }
                }
              }>
            | undefined
          readonly jobApplications?:
            | ReadonlyArray<{
                readonly id: string
                readonly status?: JobApplicationStatusEnum | undefined
                readonly permissions: { readonly show: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly level?: number | undefined
                  readonly slug: string
                  readonly title: string
                  readonly client?:
                    | { readonly displayname: string; readonly name: string }
                    | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                    readonly managePlacements: boolean
                  }
                  readonly jobPostingScreening?:
                    | { readonly id: string }
                    | undefined
                }
                readonly screeningSubmissions?:
                  | ReadonlyArray<{ readonly id: string }>
                  | undefined
              }>
            | undefined
          readonly permissions: {
            readonly edit: boolean
            readonly readApplications: boolean
            readonly readCredentials: boolean
            readonly readLicense: boolean
            readonly readResume: boolean
            readonly readWorkPreferences: boolean
          }
          readonly recruiters?:
            | ReadonlyArray<{
                readonly avatarUrl?: string | undefined
                readonly firstName: string
                readonly id: string
                readonly lastName: string
              }>
            | undefined
          readonly skillRelations?:
            | ReadonlyArray<{
                readonly id: string
                readonly years: number
                readonly skill: {
                  readonly __typename: 'Skill'
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly summary?:
            | {
                readonly id: string
                readonly entry: string
                readonly title: string
              }
            | undefined
        }
      | undefined
    readonly subscription?:
      | {
          readonly __typename: 'Subscription'
          readonly id: string
          readonly active: boolean
          readonly plan: string
        }
      | undefined
  }
  readonly sender: {
    readonly __typename: 'User'
    readonly id: string
    readonly username: string
    readonly availability?: string | undefined
    readonly avatarUrl?: string | undefined
    readonly connectionCount: number
    readonly connectionStatus?: ConnectionStatusEnum | undefined
    readonly email?: string | undefined
    readonly secondaryEmail?: string | undefined
    readonly firstName: string
    readonly indispensableSurveyLink: string
    readonly isCurrentUser: boolean
    readonly lastName: string
    readonly termsAcceptedAt?: any | undefined
    readonly phoneNumber?: string | undefined
    readonly uri: string
    readonly activities?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly alerts?:
      | { readonly pageInfo: { readonly totalCount: number } }
      | undefined
    readonly gigsEmployee?:
      | {
          readonly id: string
          readonly createdAt: any
          readonly deletedAt?: any | undefined
          readonly eligibleAt?: any | undefined
          readonly offboardedAt?: any | undefined
          readonly onboardedAt?: any | undefined
          readonly onboardingStatus: OnboardingStatusEnum
          readonly percentComplete?: number | undefined
          readonly rejectedAt?: any | undefined
          readonly savedAt?: any | undefined
          readonly screeningAt?: any | undefined
          readonly terminatedAt?: any | undefined
          readonly updatedAt: any
          readonly permissions: { readonly seeHistory: boolean }
        }
      | undefined
    readonly location: {
      readonly address?: string | undefined
      readonly addressExtended?: string | undefined
      readonly city?: string | undefined
      readonly country?: CountriesEnum | undefined
      readonly latitude?: number | undefined
      readonly longitude?: number | undefined
      readonly postalCode?: string | undefined
      readonly rawLocation?: string | undefined
      readonly state?: StatesEnum | undefined
    }
    readonly permissions: {
      readonly applyToJobs: boolean
      readonly edit: boolean
      readonly hasRecruiterLabel: boolean
      readonly imposter: boolean
      readonly internalUser: boolean
      readonly publishJobOrders: boolean
      readonly readEmail: boolean
      readonly readJobBooster: boolean
      readonly readNotes: boolean
      readonly readPhone: boolean
      readonly triggerIndispensableSurvey: boolean
      readonly searchCandidates: boolean
      readonly searchCandidatesAsClient: boolean
      readonly searchCandidatesAsRecruiter: boolean
      readonly searchClients: boolean
      readonly searchClientsByRecruiters: boolean
      readonly searchJobPostings: boolean
      readonly searchJobPostingsByRecruiter: boolean
      readonly sendMessage: boolean
      readonly trainableUser: boolean
      readonly updateConnectionStatus: boolean
      readonly uploadCsv: boolean
      readonly matchCriteria: boolean
    }
    readonly social?:
      | {
          readonly calendly?: string | undefined
          readonly linkedin?: string | undefined
        }
      | undefined
    readonly candidate?:
      | {
          readonly __typename: 'Candidate'
          readonly id: string
          readonly backgroundCheckDate?: any | undefined
          readonly credentialCount: number
          readonly dnu?: string | undefined
          readonly hiringStatus?: HiringStatusEnum | undefined
          readonly i9Date?: any | undefined
          readonly idealEmployment?: string | undefined
          readonly isAbleToApply: boolean
          readonly isNeedEmploymentSponsor?: boolean | undefined
          readonly isUsWorkAuthorized?: boolean | undefined
          readonly noWorkExperience?: boolean | undefined
          readonly profileCompletedAt?: any | undefined
          readonly profilePercentComplete?: number | undefined
          readonly relayId: string
          readonly resumeUrl?: string | undefined
          readonly salaryExpectations?: string | undefined
          readonly candidateLicenses?:
            | ReadonlyArray<{
                readonly id: string
                readonly date?: any | undefined
                readonly number?: string | undefined
                readonly url?: string | undefined
                readonly license?:
                  | {
                      readonly id: string
                      readonly name: string
                      readonly country: CountriesEnum
                      readonly state?: string | undefined
                    }
                  | undefined
              }>
            | undefined
          readonly credentials?:
            | ReadonlyArray<{
                readonly id: string
                readonly title: string
                readonly badgeUrl: string
                readonly description?: string | undefined
                readonly training: {
                  readonly id: string
                  readonly trainingUrl: string
                }
              }>
            | undefined
          readonly education?:
            | ReadonlyArray<{
                readonly id: string
                readonly degree?: string | undefined
                readonly educationLevel?: EducationLevelEnum | undefined
                readonly school?: string | undefined
                readonly yearsAttended?: number | undefined
              }>
            | undefined
          readonly experiences?:
            | ReadonlyArray<{
                readonly id: string
                readonly companyName?: string | undefined
                readonly current?: boolean | undefined
                readonly endDate?: any | undefined
                readonly jobTitle?: string | undefined
                readonly responsibilities?: string | undefined
                readonly startDate?: any | undefined
                readonly yearsEmployed?: number | undefined
              }>
            | undefined
          readonly placements?:
            | ReadonlyArray<{
                readonly startDate?: any | undefined
                readonly id: string
                readonly interviewDate?: any | undefined
                readonly status?: PlacementStatusEnum | undefined
                readonly permissions: { readonly update: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly slug: string
                  readonly title: string
                  readonly client?: { readonly displayname: string } | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                  }
                }
              }>
            | undefined
          readonly jobApplications?:
            | ReadonlyArray<{
                readonly id: string
                readonly status?: JobApplicationStatusEnum | undefined
                readonly permissions: { readonly show: boolean }
                readonly jobPosting: {
                  readonly id: string
                  readonly level?: number | undefined
                  readonly slug: string
                  readonly title: string
                  readonly client?:
                    | { readonly displayname: string; readonly name: string }
                    | undefined
                  readonly permissions: {
                    readonly readJobApps: boolean
                    readonly readPlacements: boolean
                    readonly managePlacements: boolean
                  }
                  readonly jobPostingScreening?:
                    | { readonly id: string }
                    | undefined
                }
                readonly screeningSubmissions?:
                  | ReadonlyArray<{ readonly id: string }>
                  | undefined
              }>
            | undefined
          readonly permissions: {
            readonly edit: boolean
            readonly readApplications: boolean
            readonly readCredentials: boolean
            readonly readLicense: boolean
            readonly readResume: boolean
            readonly readWorkPreferences: boolean
          }
          readonly recruiters?:
            | ReadonlyArray<{
                readonly avatarUrl?: string | undefined
                readonly firstName: string
                readonly id: string
                readonly lastName: string
              }>
            | undefined
          readonly skillRelations?:
            | ReadonlyArray<{
                readonly id: string
                readonly years: number
                readonly skill: {
                  readonly __typename: 'Skill'
                  readonly id: string
                  readonly name: string
                }
              }>
            | undefined
          readonly summary?:
            | {
                readonly id: string
                readonly entry: string
                readonly title: string
              }
            | undefined
        }
      | undefined
    readonly subscription?:
      | {
          readonly __typename: 'Subscription'
          readonly id: string
          readonly active: boolean
          readonly plan: string
        }
      | undefined
  }
}

export type ChatMessageConnectionFragment = {
  readonly edges?:
    | ReadonlyArray<
        | {
            readonly cursor: string
            readonly node?:
              | {
                  readonly id: string
                  readonly createdAt: any
                  readonly recipientRead?: any | undefined
                  readonly senderRead?: any | undefined
                  readonly slateMessage: any
                  readonly updatedAt: any
                  readonly recipient: {
                    readonly __typename: 'User'
                    readonly id: string
                    readonly username: string
                    readonly availability?: string | undefined
                    readonly avatarUrl?: string | undefined
                    readonly connectionCount: number
                    readonly connectionStatus?: ConnectionStatusEnum | undefined
                    readonly email?: string | undefined
                    readonly secondaryEmail?: string | undefined
                    readonly firstName: string
                    readonly indispensableSurveyLink: string
                    readonly isCurrentUser: boolean
                    readonly lastName: string
                    readonly termsAcceptedAt?: any | undefined
                    readonly phoneNumber?: string | undefined
                    readonly uri: string
                    readonly activities?:
                      | { readonly pageInfo: { readonly totalCount: number } }
                      | undefined
                    readonly alerts?:
                      | { readonly pageInfo: { readonly totalCount: number } }
                      | undefined
                    readonly gigsEmployee?:
                      | {
                          readonly id: string
                          readonly createdAt: any
                          readonly deletedAt?: any | undefined
                          readonly eligibleAt?: any | undefined
                          readonly offboardedAt?: any | undefined
                          readonly onboardedAt?: any | undefined
                          readonly onboardingStatus: OnboardingStatusEnum
                          readonly percentComplete?: number | undefined
                          readonly rejectedAt?: any | undefined
                          readonly savedAt?: any | undefined
                          readonly screeningAt?: any | undefined
                          readonly terminatedAt?: any | undefined
                          readonly updatedAt: any
                          readonly permissions: { readonly seeHistory: boolean }
                        }
                      | undefined
                    readonly location: {
                      readonly address?: string | undefined
                      readonly addressExtended?: string | undefined
                      readonly city?: string | undefined
                      readonly country?: CountriesEnum | undefined
                      readonly latitude?: number | undefined
                      readonly longitude?: number | undefined
                      readonly postalCode?: string | undefined
                      readonly rawLocation?: string | undefined
                      readonly state?: StatesEnum | undefined
                    }
                    readonly permissions: {
                      readonly applyToJobs: boolean
                      readonly edit: boolean
                      readonly hasRecruiterLabel: boolean
                      readonly imposter: boolean
                      readonly internalUser: boolean
                      readonly publishJobOrders: boolean
                      readonly readEmail: boolean
                      readonly readJobBooster: boolean
                      readonly readNotes: boolean
                      readonly readPhone: boolean
                      readonly triggerIndispensableSurvey: boolean
                      readonly searchCandidates: boolean
                      readonly searchCandidatesAsClient: boolean
                      readonly searchCandidatesAsRecruiter: boolean
                      readonly searchClients: boolean
                      readonly searchClientsByRecruiters: boolean
                      readonly searchJobPostings: boolean
                      readonly searchJobPostingsByRecruiter: boolean
                      readonly sendMessage: boolean
                      readonly trainableUser: boolean
                      readonly updateConnectionStatus: boolean
                      readonly uploadCsv: boolean
                      readonly matchCriteria: boolean
                    }
                    readonly social?:
                      | {
                          readonly calendly?: string | undefined
                          readonly linkedin?: string | undefined
                        }
                      | undefined
                    readonly candidate?:
                      | {
                          readonly __typename: 'Candidate'
                          readonly id: string
                          readonly backgroundCheckDate?: any | undefined
                          readonly credentialCount: number
                          readonly dnu?: string | undefined
                          readonly hiringStatus?: HiringStatusEnum | undefined
                          readonly i9Date?: any | undefined
                          readonly idealEmployment?: string | undefined
                          readonly isAbleToApply: boolean
                          readonly isNeedEmploymentSponsor?: boolean | undefined
                          readonly isUsWorkAuthorized?: boolean | undefined
                          readonly noWorkExperience?: boolean | undefined
                          readonly profileCompletedAt?: any | undefined
                          readonly profilePercentComplete?: number | undefined
                          readonly relayId: string
                          readonly resumeUrl?: string | undefined
                          readonly salaryExpectations?: string | undefined
                          readonly candidateLicenses?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly date?: any | undefined
                                readonly number?: string | undefined
                                readonly url?: string | undefined
                                readonly license?:
                                  | {
                                      readonly id: string
                                      readonly name: string
                                      readonly country: CountriesEnum
                                      readonly state?: string | undefined
                                    }
                                  | undefined
                              }>
                            | undefined
                          readonly credentials?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly title: string
                                readonly badgeUrl: string
                                readonly description?: string | undefined
                                readonly training: {
                                  readonly id: string
                                  readonly trainingUrl: string
                                }
                              }>
                            | undefined
                          readonly education?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly degree?: string | undefined
                                readonly educationLevel?:
                                  | EducationLevelEnum
                                  | undefined
                                readonly school?: string | undefined
                                readonly yearsAttended?: number | undefined
                              }>
                            | undefined
                          readonly experiences?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly companyName?: string | undefined
                                readonly current?: boolean | undefined
                                readonly endDate?: any | undefined
                                readonly jobTitle?: string | undefined
                                readonly responsibilities?: string | undefined
                                readonly startDate?: any | undefined
                                readonly yearsEmployed?: number | undefined
                              }>
                            | undefined
                          readonly placements?:
                            | ReadonlyArray<{
                                readonly startDate?: any | undefined
                                readonly id: string
                                readonly interviewDate?: any | undefined
                                readonly status?:
                                  | PlacementStatusEnum
                                  | undefined
                                readonly permissions: {
                                  readonly update: boolean
                                }
                                readonly jobPosting: {
                                  readonly id: string
                                  readonly slug: string
                                  readonly title: string
                                  readonly client?:
                                    | { readonly displayname: string }
                                    | undefined
                                  readonly permissions: {
                                    readonly readJobApps: boolean
                                    readonly readPlacements: boolean
                                  }
                                }
                              }>
                            | undefined
                          readonly jobApplications?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly status?:
                                  | JobApplicationStatusEnum
                                  | undefined
                                readonly permissions: { readonly show: boolean }
                                readonly jobPosting: {
                                  readonly id: string
                                  readonly level?: number | undefined
                                  readonly slug: string
                                  readonly title: string
                                  readonly client?:
                                    | {
                                        readonly displayname: string
                                        readonly name: string
                                      }
                                    | undefined
                                  readonly permissions: {
                                    readonly readJobApps: boolean
                                    readonly readPlacements: boolean
                                    readonly managePlacements: boolean
                                  }
                                  readonly jobPostingScreening?:
                                    | { readonly id: string }
                                    | undefined
                                }
                                readonly screeningSubmissions?:
                                  | ReadonlyArray<{ readonly id: string }>
                                  | undefined
                              }>
                            | undefined
                          readonly permissions: {
                            readonly edit: boolean
                            readonly readApplications: boolean
                            readonly readCredentials: boolean
                            readonly readLicense: boolean
                            readonly readResume: boolean
                            readonly readWorkPreferences: boolean
                          }
                          readonly recruiters?:
                            | ReadonlyArray<{
                                readonly avatarUrl?: string | undefined
                                readonly firstName: string
                                readonly id: string
                                readonly lastName: string
                              }>
                            | undefined
                          readonly skillRelations?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly years: number
                                readonly skill: {
                                  readonly __typename: 'Skill'
                                  readonly id: string
                                  readonly name: string
                                }
                              }>
                            | undefined
                          readonly summary?:
                            | {
                                readonly id: string
                                readonly entry: string
                                readonly title: string
                              }
                            | undefined
                        }
                      | undefined
                    readonly subscription?:
                      | {
                          readonly __typename: 'Subscription'
                          readonly id: string
                          readonly active: boolean
                          readonly plan: string
                        }
                      | undefined
                  }
                  readonly sender: {
                    readonly __typename: 'User'
                    readonly id: string
                    readonly username: string
                    readonly availability?: string | undefined
                    readonly avatarUrl?: string | undefined
                    readonly connectionCount: number
                    readonly connectionStatus?: ConnectionStatusEnum | undefined
                    readonly email?: string | undefined
                    readonly secondaryEmail?: string | undefined
                    readonly firstName: string
                    readonly indispensableSurveyLink: string
                    readonly isCurrentUser: boolean
                    readonly lastName: string
                    readonly termsAcceptedAt?: any | undefined
                    readonly phoneNumber?: string | undefined
                    readonly uri: string
                    readonly activities?:
                      | { readonly pageInfo: { readonly totalCount: number } }
                      | undefined
                    readonly alerts?:
                      | { readonly pageInfo: { readonly totalCount: number } }
                      | undefined
                    readonly gigsEmployee?:
                      | {
                          readonly id: string
                          readonly createdAt: any
                          readonly deletedAt?: any | undefined
                          readonly eligibleAt?: any | undefined
                          readonly offboardedAt?: any | undefined
                          readonly onboardedAt?: any | undefined
                          readonly onboardingStatus: OnboardingStatusEnum
                          readonly percentComplete?: number | undefined
                          readonly rejectedAt?: any | undefined
                          readonly savedAt?: any | undefined
                          readonly screeningAt?: any | undefined
                          readonly terminatedAt?: any | undefined
                          readonly updatedAt: any
                          readonly permissions: { readonly seeHistory: boolean }
                        }
                      | undefined
                    readonly location: {
                      readonly address?: string | undefined
                      readonly addressExtended?: string | undefined
                      readonly city?: string | undefined
                      readonly country?: CountriesEnum | undefined
                      readonly latitude?: number | undefined
                      readonly longitude?: number | undefined
                      readonly postalCode?: string | undefined
                      readonly rawLocation?: string | undefined
                      readonly state?: StatesEnum | undefined
                    }
                    readonly permissions: {
                      readonly applyToJobs: boolean
                      readonly edit: boolean
                      readonly hasRecruiterLabel: boolean
                      readonly imposter: boolean
                      readonly internalUser: boolean
                      readonly publishJobOrders: boolean
                      readonly readEmail: boolean
                      readonly readJobBooster: boolean
                      readonly readNotes: boolean
                      readonly readPhone: boolean
                      readonly triggerIndispensableSurvey: boolean
                      readonly searchCandidates: boolean
                      readonly searchCandidatesAsClient: boolean
                      readonly searchCandidatesAsRecruiter: boolean
                      readonly searchClients: boolean
                      readonly searchClientsByRecruiters: boolean
                      readonly searchJobPostings: boolean
                      readonly searchJobPostingsByRecruiter: boolean
                      readonly sendMessage: boolean
                      readonly trainableUser: boolean
                      readonly updateConnectionStatus: boolean
                      readonly uploadCsv: boolean
                      readonly matchCriteria: boolean
                    }
                    readonly social?:
                      | {
                          readonly calendly?: string | undefined
                          readonly linkedin?: string | undefined
                        }
                      | undefined
                    readonly candidate?:
                      | {
                          readonly __typename: 'Candidate'
                          readonly id: string
                          readonly backgroundCheckDate?: any | undefined
                          readonly credentialCount: number
                          readonly dnu?: string | undefined
                          readonly hiringStatus?: HiringStatusEnum | undefined
                          readonly i9Date?: any | undefined
                          readonly idealEmployment?: string | undefined
                          readonly isAbleToApply: boolean
                          readonly isNeedEmploymentSponsor?: boolean | undefined
                          readonly isUsWorkAuthorized?: boolean | undefined
                          readonly noWorkExperience?: boolean | undefined
                          readonly profileCompletedAt?: any | undefined
                          readonly profilePercentComplete?: number | undefined
                          readonly relayId: string
                          readonly resumeUrl?: string | undefined
                          readonly salaryExpectations?: string | undefined
                          readonly candidateLicenses?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly date?: any | undefined
                                readonly number?: string | undefined
                                readonly url?: string | undefined
                                readonly license?:
                                  | {
                                      readonly id: string
                                      readonly name: string
                                      readonly country: CountriesEnum
                                      readonly state?: string | undefined
                                    }
                                  | undefined
                              }>
                            | undefined
                          readonly credentials?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly title: string
                                readonly badgeUrl: string
                                readonly description?: string | undefined
                                readonly training: {
                                  readonly id: string
                                  readonly trainingUrl: string
                                }
                              }>
                            | undefined
                          readonly education?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly degree?: string | undefined
                                readonly educationLevel?:
                                  | EducationLevelEnum
                                  | undefined
                                readonly school?: string | undefined
                                readonly yearsAttended?: number | undefined
                              }>
                            | undefined
                          readonly experiences?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly companyName?: string | undefined
                                readonly current?: boolean | undefined
                                readonly endDate?: any | undefined
                                readonly jobTitle?: string | undefined
                                readonly responsibilities?: string | undefined
                                readonly startDate?: any | undefined
                                readonly yearsEmployed?: number | undefined
                              }>
                            | undefined
                          readonly placements?:
                            | ReadonlyArray<{
                                readonly startDate?: any | undefined
                                readonly id: string
                                readonly interviewDate?: any | undefined
                                readonly status?:
                                  | PlacementStatusEnum
                                  | undefined
                                readonly permissions: {
                                  readonly update: boolean
                                }
                                readonly jobPosting: {
                                  readonly id: string
                                  readonly slug: string
                                  readonly title: string
                                  readonly client?:
                                    | { readonly displayname: string }
                                    | undefined
                                  readonly permissions: {
                                    readonly readJobApps: boolean
                                    readonly readPlacements: boolean
                                  }
                                }
                              }>
                            | undefined
                          readonly jobApplications?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly status?:
                                  | JobApplicationStatusEnum
                                  | undefined
                                readonly permissions: { readonly show: boolean }
                                readonly jobPosting: {
                                  readonly id: string
                                  readonly level?: number | undefined
                                  readonly slug: string
                                  readonly title: string
                                  readonly client?:
                                    | {
                                        readonly displayname: string
                                        readonly name: string
                                      }
                                    | undefined
                                  readonly permissions: {
                                    readonly readJobApps: boolean
                                    readonly readPlacements: boolean
                                    readonly managePlacements: boolean
                                  }
                                  readonly jobPostingScreening?:
                                    | { readonly id: string }
                                    | undefined
                                }
                                readonly screeningSubmissions?:
                                  | ReadonlyArray<{ readonly id: string }>
                                  | undefined
                              }>
                            | undefined
                          readonly permissions: {
                            readonly edit: boolean
                            readonly readApplications: boolean
                            readonly readCredentials: boolean
                            readonly readLicense: boolean
                            readonly readResume: boolean
                            readonly readWorkPreferences: boolean
                          }
                          readonly recruiters?:
                            | ReadonlyArray<{
                                readonly avatarUrl?: string | undefined
                                readonly firstName: string
                                readonly id: string
                                readonly lastName: string
                              }>
                            | undefined
                          readonly skillRelations?:
                            | ReadonlyArray<{
                                readonly id: string
                                readonly years: number
                                readonly skill: {
                                  readonly __typename: 'Skill'
                                  readonly id: string
                                  readonly name: string
                                }
                              }>
                            | undefined
                          readonly summary?:
                            | {
                                readonly id: string
                                readonly entry: string
                                readonly title: string
                              }
                            | undefined
                        }
                      | undefined
                    readonly subscription?:
                      | {
                          readonly __typename: 'Subscription'
                          readonly id: string
                          readonly active: boolean
                          readonly plan: string
                        }
                      | undefined
                  }
                }
              | undefined
          }
        | undefined
      >
    | undefined
  readonly pageInfo: {
    readonly endCursor?: string | undefined
    readonly hasNextPage: boolean
    readonly hasPreviousPage: boolean
    readonly startCursor?: string | undefined
    readonly totalCount: number
  }
}

export type NotificationFragment = {
  readonly count: number
  readonly ids?: ReadonlyArray<string> | undefined
  readonly type: string
}

export type NotificationsQueryVariables = Exact<{ [key: string]: never }>

export type NotificationsQuery = {
  readonly getNotifications?:
    | ReadonlyArray<{
        readonly count: number
        readonly ids?: ReadonlyArray<string> | undefined
        readonly type: string
      }>
    | undefined
}

export type AllChatMessagesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<OrderByEnum>
  recentConversations?: InputMaybe<Scalars['Boolean']['input']>
  recipient?: InputMaybe<Scalars['String']['input']>
  unread?: InputMaybe<Scalars['Boolean']['input']>
}>

export type AllChatMessagesQuery = {
  readonly getChatMessages?:
    | {
        readonly edges?:
          | ReadonlyArray<
              | {
                  readonly cursor: string
                  readonly node?:
                    | {
                        readonly id: string
                        readonly createdAt: any
                        readonly recipientRead?: any | undefined
                        readonly senderRead?: any | undefined
                        readonly slateMessage: any
                        readonly updatedAt: any
                        readonly recipient: {
                          readonly __typename: 'User'
                          readonly id: string
                          readonly username: string
                          readonly availability?: string | undefined
                          readonly avatarUrl?: string | undefined
                          readonly connectionCount: number
                          readonly connectionStatus?:
                            | ConnectionStatusEnum
                            | undefined
                          readonly email?: string | undefined
                          readonly secondaryEmail?: string | undefined
                          readonly firstName: string
                          readonly indispensableSurveyLink: string
                          readonly isCurrentUser: boolean
                          readonly lastName: string
                          readonly termsAcceptedAt?: any | undefined
                          readonly phoneNumber?: string | undefined
                          readonly uri: string
                          readonly activities?:
                            | {
                                readonly pageInfo: {
                                  readonly totalCount: number
                                }
                              }
                            | undefined
                          readonly alerts?:
                            | {
                                readonly pageInfo: {
                                  readonly totalCount: number
                                }
                              }
                            | undefined
                          readonly gigsEmployee?:
                            | {
                                readonly id: string
                                readonly createdAt: any
                                readonly deletedAt?: any | undefined
                                readonly eligibleAt?: any | undefined
                                readonly offboardedAt?: any | undefined
                                readonly onboardedAt?: any | undefined
                                readonly onboardingStatus: OnboardingStatusEnum
                                readonly percentComplete?: number | undefined
                                readonly rejectedAt?: any | undefined
                                readonly savedAt?: any | undefined
                                readonly screeningAt?: any | undefined
                                readonly terminatedAt?: any | undefined
                                readonly updatedAt: any
                                readonly permissions: {
                                  readonly seeHistory: boolean
                                }
                              }
                            | undefined
                          readonly location: {
                            readonly address?: string | undefined
                            readonly addressExtended?: string | undefined
                            readonly city?: string | undefined
                            readonly country?: CountriesEnum | undefined
                            readonly latitude?: number | undefined
                            readonly longitude?: number | undefined
                            readonly postalCode?: string | undefined
                            readonly rawLocation?: string | undefined
                            readonly state?: StatesEnum | undefined
                          }
                          readonly permissions: {
                            readonly applyToJobs: boolean
                            readonly edit: boolean
                            readonly hasRecruiterLabel: boolean
                            readonly imposter: boolean
                            readonly internalUser: boolean
                            readonly publishJobOrders: boolean
                            readonly readEmail: boolean
                            readonly readJobBooster: boolean
                            readonly readNotes: boolean
                            readonly readPhone: boolean
                            readonly triggerIndispensableSurvey: boolean
                            readonly searchCandidates: boolean
                            readonly searchCandidatesAsClient: boolean
                            readonly searchCandidatesAsRecruiter: boolean
                            readonly searchClients: boolean
                            readonly searchClientsByRecruiters: boolean
                            readonly searchJobPostings: boolean
                            readonly searchJobPostingsByRecruiter: boolean
                            readonly sendMessage: boolean
                            readonly trainableUser: boolean
                            readonly updateConnectionStatus: boolean
                            readonly uploadCsv: boolean
                            readonly matchCriteria: boolean
                          }
                          readonly social?:
                            | {
                                readonly calendly?: string | undefined
                                readonly linkedin?: string | undefined
                              }
                            | undefined
                          readonly candidate?:
                            | {
                                readonly __typename: 'Candidate'
                                readonly id: string
                                readonly backgroundCheckDate?: any | undefined
                                readonly credentialCount: number
                                readonly dnu?: string | undefined
                                readonly hiringStatus?:
                                  | HiringStatusEnum
                                  | undefined
                                readonly i9Date?: any | undefined
                                readonly idealEmployment?: string | undefined
                                readonly isAbleToApply: boolean
                                readonly isNeedEmploymentSponsor?:
                                  | boolean
                                  | undefined
                                readonly isUsWorkAuthorized?:
                                  | boolean
                                  | undefined
                                readonly noWorkExperience?: boolean | undefined
                                readonly profileCompletedAt?: any | undefined
                                readonly profilePercentComplete?:
                                  | number
                                  | undefined
                                readonly relayId: string
                                readonly resumeUrl?: string | undefined
                                readonly salaryExpectations?: string | undefined
                                readonly candidateLicenses?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly date?: any | undefined
                                      readonly number?: string | undefined
                                      readonly url?: string | undefined
                                      readonly license?:
                                        | {
                                            readonly id: string
                                            readonly name: string
                                            readonly country: CountriesEnum
                                            readonly state?: string | undefined
                                          }
                                        | undefined
                                    }>
                                  | undefined
                                readonly credentials?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly title: string
                                      readonly badgeUrl: string
                                      readonly description?: string | undefined
                                      readonly training: {
                                        readonly id: string
                                        readonly trainingUrl: string
                                      }
                                    }>
                                  | undefined
                                readonly education?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly degree?: string | undefined
                                      readonly educationLevel?:
                                        | EducationLevelEnum
                                        | undefined
                                      readonly school?: string | undefined
                                      readonly yearsAttended?:
                                        | number
                                        | undefined
                                    }>
                                  | undefined
                                readonly experiences?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly companyName?: string | undefined
                                      readonly current?: boolean | undefined
                                      readonly endDate?: any | undefined
                                      readonly jobTitle?: string | undefined
                                      readonly responsibilities?:
                                        | string
                                        | undefined
                                      readonly startDate?: any | undefined
                                      readonly yearsEmployed?:
                                        | number
                                        | undefined
                                    }>
                                  | undefined
                                readonly placements?:
                                  | ReadonlyArray<{
                                      readonly startDate?: any | undefined
                                      readonly id: string
                                      readonly interviewDate?: any | undefined
                                      readonly status?:
                                        | PlacementStatusEnum
                                        | undefined
                                      readonly permissions: {
                                        readonly update: boolean
                                      }
                                      readonly jobPosting: {
                                        readonly id: string
                                        readonly slug: string
                                        readonly title: string
                                        readonly client?:
                                          | { readonly displayname: string }
                                          | undefined
                                        readonly permissions: {
                                          readonly readJobApps: boolean
                                          readonly readPlacements: boolean
                                        }
                                      }
                                    }>
                                  | undefined
                                readonly jobApplications?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly status?:
                                        | JobApplicationStatusEnum
                                        | undefined
                                      readonly permissions: {
                                        readonly show: boolean
                                      }
                                      readonly jobPosting: {
                                        readonly id: string
                                        readonly level?: number | undefined
                                        readonly slug: string
                                        readonly title: string
                                        readonly client?:
                                          | {
                                              readonly displayname: string
                                              readonly name: string
                                            }
                                          | undefined
                                        readonly permissions: {
                                          readonly readJobApps: boolean
                                          readonly readPlacements: boolean
                                          readonly managePlacements: boolean
                                        }
                                        readonly jobPostingScreening?:
                                          | { readonly id: string }
                                          | undefined
                                      }
                                      readonly screeningSubmissions?:
                                        | ReadonlyArray<{ readonly id: string }>
                                        | undefined
                                    }>
                                  | undefined
                                readonly permissions: {
                                  readonly edit: boolean
                                  readonly readApplications: boolean
                                  readonly readCredentials: boolean
                                  readonly readLicense: boolean
                                  readonly readResume: boolean
                                  readonly readWorkPreferences: boolean
                                }
                                readonly recruiters?:
                                  | ReadonlyArray<{
                                      readonly avatarUrl?: string | undefined
                                      readonly firstName: string
                                      readonly id: string
                                      readonly lastName: string
                                    }>
                                  | undefined
                                readonly skillRelations?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly years: number
                                      readonly skill: {
                                        readonly __typename: 'Skill'
                                        readonly id: string
                                        readonly name: string
                                      }
                                    }>
                                  | undefined
                                readonly summary?:
                                  | {
                                      readonly id: string
                                      readonly entry: string
                                      readonly title: string
                                    }
                                  | undefined
                              }
                            | undefined
                          readonly subscription?:
                            | {
                                readonly __typename: 'Subscription'
                                readonly id: string
                                readonly active: boolean
                                readonly plan: string
                              }
                            | undefined
                        }
                        readonly sender: {
                          readonly __typename: 'User'
                          readonly id: string
                          readonly username: string
                          readonly availability?: string | undefined
                          readonly avatarUrl?: string | undefined
                          readonly connectionCount: number
                          readonly connectionStatus?:
                            | ConnectionStatusEnum
                            | undefined
                          readonly email?: string | undefined
                          readonly secondaryEmail?: string | undefined
                          readonly firstName: string
                          readonly indispensableSurveyLink: string
                          readonly isCurrentUser: boolean
                          readonly lastName: string
                          readonly termsAcceptedAt?: any | undefined
                          readonly phoneNumber?: string | undefined
                          readonly uri: string
                          readonly activities?:
                            | {
                                readonly pageInfo: {
                                  readonly totalCount: number
                                }
                              }
                            | undefined
                          readonly alerts?:
                            | {
                                readonly pageInfo: {
                                  readonly totalCount: number
                                }
                              }
                            | undefined
                          readonly gigsEmployee?:
                            | {
                                readonly id: string
                                readonly createdAt: any
                                readonly deletedAt?: any | undefined
                                readonly eligibleAt?: any | undefined
                                readonly offboardedAt?: any | undefined
                                readonly onboardedAt?: any | undefined
                                readonly onboardingStatus: OnboardingStatusEnum
                                readonly percentComplete?: number | undefined
                                readonly rejectedAt?: any | undefined
                                readonly savedAt?: any | undefined
                                readonly screeningAt?: any | undefined
                                readonly terminatedAt?: any | undefined
                                readonly updatedAt: any
                                readonly permissions: {
                                  readonly seeHistory: boolean
                                }
                              }
                            | undefined
                          readonly location: {
                            readonly address?: string | undefined
                            readonly addressExtended?: string | undefined
                            readonly city?: string | undefined
                            readonly country?: CountriesEnum | undefined
                            readonly latitude?: number | undefined
                            readonly longitude?: number | undefined
                            readonly postalCode?: string | undefined
                            readonly rawLocation?: string | undefined
                            readonly state?: StatesEnum | undefined
                          }
                          readonly permissions: {
                            readonly applyToJobs: boolean
                            readonly edit: boolean
                            readonly hasRecruiterLabel: boolean
                            readonly imposter: boolean
                            readonly internalUser: boolean
                            readonly publishJobOrders: boolean
                            readonly readEmail: boolean
                            readonly readJobBooster: boolean
                            readonly readNotes: boolean
                            readonly readPhone: boolean
                            readonly triggerIndispensableSurvey: boolean
                            readonly searchCandidates: boolean
                            readonly searchCandidatesAsClient: boolean
                            readonly searchCandidatesAsRecruiter: boolean
                            readonly searchClients: boolean
                            readonly searchClientsByRecruiters: boolean
                            readonly searchJobPostings: boolean
                            readonly searchJobPostingsByRecruiter: boolean
                            readonly sendMessage: boolean
                            readonly trainableUser: boolean
                            readonly updateConnectionStatus: boolean
                            readonly uploadCsv: boolean
                            readonly matchCriteria: boolean
                          }
                          readonly social?:
                            | {
                                readonly calendly?: string | undefined
                                readonly linkedin?: string | undefined
                              }
                            | undefined
                          readonly candidate?:
                            | {
                                readonly __typename: 'Candidate'
                                readonly id: string
                                readonly backgroundCheckDate?: any | undefined
                                readonly credentialCount: number
                                readonly dnu?: string | undefined
                                readonly hiringStatus?:
                                  | HiringStatusEnum
                                  | undefined
                                readonly i9Date?: any | undefined
                                readonly idealEmployment?: string | undefined
                                readonly isAbleToApply: boolean
                                readonly isNeedEmploymentSponsor?:
                                  | boolean
                                  | undefined
                                readonly isUsWorkAuthorized?:
                                  | boolean
                                  | undefined
                                readonly noWorkExperience?: boolean | undefined
                                readonly profileCompletedAt?: any | undefined
                                readonly profilePercentComplete?:
                                  | number
                                  | undefined
                                readonly relayId: string
                                readonly resumeUrl?: string | undefined
                                readonly salaryExpectations?: string | undefined
                                readonly candidateLicenses?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly date?: any | undefined
                                      readonly number?: string | undefined
                                      readonly url?: string | undefined
                                      readonly license?:
                                        | {
                                            readonly id: string
                                            readonly name: string
                                            readonly country: CountriesEnum
                                            readonly state?: string | undefined
                                          }
                                        | undefined
                                    }>
                                  | undefined
                                readonly credentials?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly title: string
                                      readonly badgeUrl: string
                                      readonly description?: string | undefined
                                      readonly training: {
                                        readonly id: string
                                        readonly trainingUrl: string
                                      }
                                    }>
                                  | undefined
                                readonly education?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly degree?: string | undefined
                                      readonly educationLevel?:
                                        | EducationLevelEnum
                                        | undefined
                                      readonly school?: string | undefined
                                      readonly yearsAttended?:
                                        | number
                                        | undefined
                                    }>
                                  | undefined
                                readonly experiences?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly companyName?: string | undefined
                                      readonly current?: boolean | undefined
                                      readonly endDate?: any | undefined
                                      readonly jobTitle?: string | undefined
                                      readonly responsibilities?:
                                        | string
                                        | undefined
                                      readonly startDate?: any | undefined
                                      readonly yearsEmployed?:
                                        | number
                                        | undefined
                                    }>
                                  | undefined
                                readonly placements?:
                                  | ReadonlyArray<{
                                      readonly startDate?: any | undefined
                                      readonly id: string
                                      readonly interviewDate?: any | undefined
                                      readonly status?:
                                        | PlacementStatusEnum
                                        | undefined
                                      readonly permissions: {
                                        readonly update: boolean
                                      }
                                      readonly jobPosting: {
                                        readonly id: string
                                        readonly slug: string
                                        readonly title: string
                                        readonly client?:
                                          | { readonly displayname: string }
                                          | undefined
                                        readonly permissions: {
                                          readonly readJobApps: boolean
                                          readonly readPlacements: boolean
                                        }
                                      }
                                    }>
                                  | undefined
                                readonly jobApplications?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly status?:
                                        | JobApplicationStatusEnum
                                        | undefined
                                      readonly permissions: {
                                        readonly show: boolean
                                      }
                                      readonly jobPosting: {
                                        readonly id: string
                                        readonly level?: number | undefined
                                        readonly slug: string
                                        readonly title: string
                                        readonly client?:
                                          | {
                                              readonly displayname: string
                                              readonly name: string
                                            }
                                          | undefined
                                        readonly permissions: {
                                          readonly readJobApps: boolean
                                          readonly readPlacements: boolean
                                          readonly managePlacements: boolean
                                        }
                                        readonly jobPostingScreening?:
                                          | { readonly id: string }
                                          | undefined
                                      }
                                      readonly screeningSubmissions?:
                                        | ReadonlyArray<{ readonly id: string }>
                                        | undefined
                                    }>
                                  | undefined
                                readonly permissions: {
                                  readonly edit: boolean
                                  readonly readApplications: boolean
                                  readonly readCredentials: boolean
                                  readonly readLicense: boolean
                                  readonly readResume: boolean
                                  readonly readWorkPreferences: boolean
                                }
                                readonly recruiters?:
                                  | ReadonlyArray<{
                                      readonly avatarUrl?: string | undefined
                                      readonly firstName: string
                                      readonly id: string
                                      readonly lastName: string
                                    }>
                                  | undefined
                                readonly skillRelations?:
                                  | ReadonlyArray<{
                                      readonly id: string
                                      readonly years: number
                                      readonly skill: {
                                        readonly __typename: 'Skill'
                                        readonly id: string
                                        readonly name: string
                                      }
                                    }>
                                  | undefined
                                readonly summary?:
                                  | {
                                      readonly id: string
                                      readonly entry: string
                                      readonly title: string
                                    }
                                  | undefined
                              }
                            | undefined
                          readonly subscription?:
                            | {
                                readonly __typename: 'Subscription'
                                readonly id: string
                                readonly active: boolean
                                readonly plan: string
                              }
                            | undefined
                        }
                      }
                    | undefined
                }
              | undefined
            >
          | undefined
        readonly pageInfo: {
          readonly endCursor?: string | undefined
          readonly hasNextPage: boolean
          readonly hasPreviousPage: boolean
          readonly startCursor?: string | undefined
          readonly totalCount: number
        }
      }
    | undefined
}

export type CreateChatMessageMutationVariables = Exact<{
  input: ChatMessageInput
}>

export type CreateChatMessageMutation = {
  readonly createChatMessage?:
    | {
        readonly id: string
        readonly slateMessage: any
        readonly recipient: { readonly id: string; readonly username: string }
        readonly sender: { readonly id: string; readonly username: string }
      }
    | undefined
}

export type MarkChatMessageReadMutationVariables = Exact<{
  input: ChatMessageReadInput
}>

export type MarkChatMessageReadMutation = {
  readonly markChatMessageRead?:
    | { readonly id: string; readonly recipientRead?: any | undefined }
    | undefined
}

export const Company_EditFragmentDoc = /*#__PURE__*/ `
    fragment Company_Edit on Client {
  id
  avatarUrl
  billingAddress
  accountsPayableEmail
  companyPhotos {
    id
    alt
    displayRole
    mediaType
    url
  }
  companyEmploymentBenefits {
    id
    employmentBenefit {
      icon
      id
      name
    }
  }
  companyLocations {
    address
    addressExtended
    city
    country
    latitude
    longitude
    postalCode
    rawLocation
    state
  }
  companySize
  companyValues {
    id
    description
    title
  }
  description
  displayname
  headline
  location {
    address
    addressExtended
    city
    country
    latitude
    longitude
    postalCode
    rawLocation
    state
  }
  metaDescription
  metaTitle
  name
  permissions {
    toggleVisible
    editMeta
  }
  social {
    facebook
    instagram
    linkedin
    twitter
  }
  users {
    id
    firstName
    lastName
    email
  }
  visibleOnPlatform
  website
}
    `
export const CompanyFragmentDoc = /*#__PURE__*/ `
    fragment Company on Client {
  __typename
  id
  billingAddress
  accountsPayableEmail
  displayname
  avatarUrl
  companyEmploymentBenefits {
    id
    employmentBenefit {
      icon
      id
      name
    }
  }
  companyLocations {
    address
    addressExtended
    city
    country
    latitude
    longitude
    postalCode
    rawLocation
    state
  }
  companyPhotos {
    id
    alt
    displayRole
    mediaType
    url
  }
  companySize
  companyValues {
    id
    description
    title
  }
  connectionStatus
  countAvailablePositions
  countRecentPositions
  companyDescription: description
  headline
  location {
    address
    addressExtended
    city
    country
    latitude
    longitude
    postalCode
    rawLocation
    state
  }
  metaDescription
  metaTitle
  name
  permissions {
    createJobPosting
    edit
    editMeta
    internalUser
    readPendingBanner
    toggleVisible
  }
  profileComplete
  profileCompletedAt
  social {
    facebook
    instagram
    linkedin
    twitter
  }
  trainings {
    pageInfo {
      totalCount
    }
  }
  uri
  visibleOnPlatform
  website
}
    `
export const MemberLicenseFragmentDoc = /*#__PURE__*/ `
    fragment MemberLicense on CandidateLicense {
  id
  date
  number
  license {
    id
    name
    country
    state
  }
  url
}
    `
export const MemberCredentialFragmentDoc = /*#__PURE__*/ `
    fragment MemberCredential on Credential {
  id
  badgeUrl
  description
  title
  training {
    id
    trainingUrl
  }
}
    `
export const MemberEducationFragmentDoc = /*#__PURE__*/ `
    fragment MemberEducation on CandidateEducation {
  id
  degree
  educationLevel
  school
  yearsAttended
}
    `
export const MemberExperienceFragmentDoc = /*#__PURE__*/ `
    fragment MemberExperience on CandidateExperience {
  id
  companyName
  current
  endDate
  jobTitle
  responsibilities
  startDate
  yearsEmployed
}
    `
export const SkillFragmentDoc = /*#__PURE__*/ `
    fragment Skill on Skill {
  __typename
  id
  name
}
    `
export const MemberSkillFragmentDoc = /*#__PURE__*/ `
    fragment MemberSkill on CandidateSkill {
  id
  skill {
    ...Skill
  }
  years
}
    ${SkillFragmentDoc}`
export const MemberSummaryFragmentDoc = /*#__PURE__*/ `
    fragment MemberSummary on CandidateSummary {
  id
  entry
  title
}
    `
export const MemberFragmentDoc = /*#__PURE__*/ `
    fragment Member on User {
  __typename
  id
  username
  availability
  avatarUrl
  activities {
    pageInfo {
      totalCount
    }
  }
  alerts {
    pageInfo {
      totalCount
    }
  }
  connectionCount
  connectionStatus
  email
  secondaryEmail
  firstName
  gigsEmployee {
    id
    createdAt
    deletedAt
    eligibleAt
    offboardedAt
    onboardedAt
    onboardingStatus
    percentComplete
    permissions {
      seeHistory
    }
    rejectedAt
    savedAt
    screeningAt
    terminatedAt
    updatedAt
  }
  indispensableSurveyLink
  isCurrentUser
  lastName
  termsAcceptedAt
  location {
    address
    addressExtended
    city
    country
    latitude
    longitude
    postalCode
    rawLocation
    state
  }
  phoneNumber
  permissions {
    applyToJobs
    edit
    hasRecruiterLabel
    imposter
    internalUser
    publishJobOrders
    readEmail
    readJobBooster
    readNotes
    readPhone
    triggerIndispensableSurvey
    searchCandidates
    searchCandidatesAsClient
    searchCandidatesAsRecruiter
    searchClients
    searchClientsByRecruiters
    searchJobPostings
    searchJobPostingsByRecruiter
    sendMessage
    trainableUser
    updateConnectionStatus
    uploadCsv
    matchCriteria
  }
  social {
    calendly
    linkedin
  }
  candidate {
    __typename
    id
    backgroundCheckDate
    candidateLicenses {
      ...MemberLicense
    }
    credentials {
      id
      title
    }
    credentials {
      ...MemberCredential
    }
    credentialCount
    dnu
    education {
      ...MemberEducation
    }
    experiences {
      ...MemberExperience
    }
    hiringStatus
    i9Date
    idealEmployment
    isAbleToApply
    isNeedEmploymentSponsor
    isUsWorkAuthorized
    placements {
      startDate
    }
    jobApplications {
      id
      status
      permissions {
        show
      }
      jobPosting {
        id
        client {
          displayname
          name
        }
        level
        permissions {
          readJobApps
          readPlacements
          managePlacements
        }
        slug
        title
        jobPostingScreening {
          id
        }
      }
      screeningSubmissions {
        id
      }
    }
    noWorkExperience
    permissions {
      edit
      readApplications
      readCredentials
      readLicense
      readResume
      readWorkPreferences
    }
    placements {
      id
      interviewDate
      status
      permissions {
        update
      }
      interviewDate
      startDate
      jobPosting {
        id
        client {
          displayname
        }
        slug
        title
        permissions {
          readJobApps
          readPlacements
        }
      }
    }
    profileCompletedAt
    profilePercentComplete
    recruiters {
      avatarUrl
      firstName
      id
      lastName
    }
    relayId
    resumeUrl
    salaryExpectations
    skillRelations {
      ...MemberSkill
    }
    summary {
      ...MemberSummary
    }
  }
  uri
  subscription {
    __typename
    id
    active
    plan
  }
}
    ${MemberLicenseFragmentDoc}
${MemberCredentialFragmentDoc}
${MemberEducationFragmentDoc}
${MemberExperienceFragmentDoc}
${MemberSkillFragmentDoc}
${MemberSummaryFragmentDoc}`
export const PageInfoFragmentDoc = /*#__PURE__*/ `
    fragment PageInfo on PageInfo {
  endCursor
  hasNextPage
  hasPreviousPage
  startCursor
}
    `
export const Company_FollowersFragmentDoc = /*#__PURE__*/ `
    fragment Company_Followers on Client {
  followerCount
  followers(after: $after, before: $before, first: $first, last: $last) {
    edges {
      cursor
      node {
        ... on Client {
          ...Company
        }
        ... on User {
          ...Member
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${CompanyFragmentDoc}
${MemberFragmentDoc}
${PageInfoFragmentDoc}`
export const JobPosting_CompanyFragmentDoc = /*#__PURE__*/ `
    fragment JobPosting_Company on Client {
  __typename
  id
  displayname
  avatarUrl
  billingAddress
  companyEmploymentBenefits {
    id
    employmentBenefit {
      icon
      id
      name
    }
  }
  companyLocations {
    address
    addressExtended
    city
    country
    latitude
    longitude
    postalCode
    rawLocation
    state
  }
  companyPhotos {
    id
    alt
    displayRole
    mediaType
    url
  }
  companySize
  companyValues {
    id
    description
    title
  }
  connectionStatus
  countAvailablePositions
  countRecentPositions
  description
  headline
  location {
    address
    addressExtended
    city
    country
    latitude
    longitude
    postalCode
    rawLocation
    state
  }
  name
  permissions {
    createJobPosting
    edit
    readPendingBanner
    toggleVisible
  }
  profileComplete
  profileCompletedAt
  social {
    facebook
    instagram
    linkedin
    twitter
  }
  visibleOnPlatform
  website
}
    `
export const ScreeningQuestionFragmentDoc = /*#__PURE__*/ `
    fragment ScreeningQuestion on ScreeningQuestion {
  id
  typeOf
  question
}
    `
export const JobPosting_ScreeningFragmentDoc = /*#__PURE__*/ `
    fragment JobPosting_Screening on JobPostingScreening {
  id
  screening {
    id
    description
    name
    screeningQuestions {
      ...ScreeningQuestion
    }
  }
}
    ${ScreeningQuestionFragmentDoc}`
export const JobPosting_CredentialFragmentDoc = /*#__PURE__*/ `
    fragment JobPosting_Credential on Credential {
  __typename
  id
  badgeUrl
  description
  title
  training {
    id
    trainingUrl
  }
}
    `
export const LicenseFragmentDoc = /*#__PURE__*/ `
    fragment License on License {
  id
  name
  country
  state
}
    `
export const JobPostingLicenseFragmentDoc = /*#__PURE__*/ `
    fragment JobPostingLicense on JobPostingLicense {
  id
  license {
    ...License
  }
}
    ${LicenseFragmentDoc}`
export const JobPostingFragmentDoc = /*#__PURE__*/ `
    fragment JobPosting on JobPosting {
  __typename
  id
  accountExecs {
    avatarUrl
    firstName
    id
    lastName
    username
  }
  accountsPayableEmail
  activities {
    pageInfo {
      totalCount
    }
  }
  applicationReceived
  atsRecordType
  atsStatus
  baseSalaryValue
  client {
    ...JobPosting_Company
  }
  associatedClient {
    ...JobPosting_Company
  }
  countJobApplicationsNew
  countJobApplicationsTotal
  description
  depositAmount
  education
  employmentBenefits {
    employmentBenefit {
      icon
      id
      name
    }
    id
  }
  employmentTypes
  endDate
  quantity
  experience
  externalId
  isIngested
  isPublished
  isRemote
  jobApplicationStatusCounts {
    count
    status
  }
  gigsInfo {
    additionalRequirements
    billRate
    costCenterCreated
    companyOnboarded
    details
    engagementDeposit
    kickoffCall
    level
    payRate
    salaryPayPeriod
    dressCode
    specialRequests
    parkingFacilityInformation
  }
  jobPostingScreening {
    ...JobPosting_Screening
  }
  location {
    address
    addressExtended
    city
    country
    latitude
    longitude
    postalCode
    rawLocation
    state
  }
  permissions {
    destroy
    edit
    internalUser
    managePlacements
    readEndDate
    readJobApps
    readPlacements
    togglePublished
    writeAtsRecordType
    writeRecruiterToJob
    writeSubmitApplicationUrl
  }
  placements {
    id
    status
  }
  placementStatusCounts {
    count
    status
  }
  physicalRequirements
  primaryContact {
    avatarUrl
    firstName
    id
    lastName
  }
  postedAt
  recommendedCredentials {
    id
    credential {
      ...JobPosting_Credential
    }
  }
  recruiters {
    avatarUrl
    firstName
    id
    lastName
    username
  }
  shift
  syndicateIndeed
  timeSheetManagers {
    avatarUrl
    firstName
    id
    lastName
    username
  }
  requiredLicenses {
    ...JobPostingLicense
  }
  responsibilities
  salaryRange {
    maxValue
    minValue
    payPeriod
  }
  slug
  startDate
  submitApplicationUrl
  title
  uri
  validThrough
  workingEnvironment
}
    ${JobPosting_CompanyFragmentDoc}
${JobPosting_ScreeningFragmentDoc}
${JobPosting_CredentialFragmentDoc}
${JobPostingLicenseFragmentDoc}`
export const BasePageInfoFragmentDoc = /*#__PURE__*/ `
    fragment BasePageInfo on BasePageInfo {
  endCursor
  hasNextPage
  hasPreviousPage
  startCursor
  totalCount
}
    `
export const Company_JobPostingsFragmentDoc = /*#__PURE__*/ `
    fragment Company_JobPostings on Client {
  jobPostings(
    atsRecordTypes: $atsRecordTypes
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        ... on JobPosting {
          ...JobPosting
        }
      }
    }
    pageInfo {
      ...BasePageInfo
    }
  }
}
    ${JobPostingFragmentDoc}
${BasePageInfoFragmentDoc}`
export const Company_PhotosFragmentDoc = /*#__PURE__*/ `
    fragment Company_Photos on Client {
  companyPhotos {
    id
    alt
    displayRole
    mediaType
    url
  }
}
    `
export const ScreeningQResponseFragmentDoc = /*#__PURE__*/ `
    fragment screeningQResponse on ScreeningQResponse {
  id
  screeningQuestion {
    id
    question
  }
  answer
}
    `
export const ScreeningSubmissionFragmentDoc = /*#__PURE__*/ `
    fragment ScreeningSubmission on ScreeningSubmission {
  id
  jobApplication {
    id
    jobPosting {
      id
      title
      slug
    }
  }
  screeningQResponses {
    ...screeningQResponse
  }
}
    ${ScreeningQResponseFragmentDoc}`
export const Company_JobApplicationFragmentDoc = /*#__PURE__*/ `
    fragment Company_JobApplication on JobApplication {
  __typename
  id
  atsRecordType
  createdAt
  clientInterestAt
  clientInterestMessage
  hasClientInterest
  jobPosting {
    id
    level
    title
    jobPostingScreening {
      ...JobPosting_Screening
    }
    location {
      city
      state
    }
    slug
    client {
      displayname
    }
  }
  permissions {
    indicateInterest
    show
  }
  screeningSubmissions {
    ...ScreeningSubmission
  }
  status
  user {
    ...Member
  }
}
    ${JobPosting_ScreeningFragmentDoc}
${ScreeningSubmissionFragmentDoc}
${MemberFragmentDoc}`
export const CompanyJobApplications_JobApplicationConnectionFragmentDoc = /*#__PURE__*/ `
    fragment CompanyJobApplications_JobApplicationConnection on JobApplicationConnection {
  edges {
    cursor
    node {
      ...Company_JobApplication
    }
  }
  pageInfo {
    ...BasePageInfo
  }
}
    ${Company_JobApplicationFragmentDoc}
${BasePageInfoFragmentDoc}`
export const Company_PlacementFragmentDoc = /*#__PURE__*/ `
    fragment Company_Placement on Placement {
  __typename
  id
  createdAt
  interviewDate
  jobPosting {
    id
  }
  permissions {
    seeHistory
  }
  history {
    __typename
    whodunnit
  }
  interviewDate
  startDate
  status
  updatedAt
  user {
    ...Member
  }
}
    ${MemberFragmentDoc}`
export const CompanyJobPlacments_JobPlacementConnectionFragmentDoc = /*#__PURE__*/ `
    fragment CompanyJobPlacments_JobPlacementConnection on PlacementConnection {
  edges {
    cursor
    node {
      ...Company_Placement
    }
  }
  pageInfo {
    ...BasePageInfo
  }
}
    ${Company_PlacementFragmentDoc}
${BasePageInfoFragmentDoc}`
export const JobPosting_RecommendedCredentialFragmentDoc = /*#__PURE__*/ `
    fragment JobPosting_RecommendedCredential on JobPostingCredential {
  id
  credential {
    ...JobPosting_Credential
  }
}
    ${JobPosting_CredentialFragmentDoc}`
export const JobPosting_EditFragmentDoc = /*#__PURE__*/ `
    fragment JobPosting_Edit on JobPosting {
  id
  accountExecs {
    firstName
    id
    lastName
  }
  accountsPayableEmail
  associatedClient {
    displayname
  }
  atsRecordType
  atsStatus
  description
  depositAmount
  education
  employmentTypes
  endDate
  expectedHours
  experience
  isPublished
  externalId
  quantity
  isRemote
  jobPostingScreening {
    ...JobPosting_Screening
  }
  gigsInfo {
    billRate
    payRate
    costCenterCreated
    engagementDeposit
    level
    details
    additionalRequirements
    kickoffCall
    salaryPayPeriod
    dressCode
    specialRequests
    parkingFacilityInformation
  }
  location {
    address
    addressExtended
    city
    country
    latitude
    longitude
    postalCode
    rawLocation
    state
  }
  physicalRequirements
  recommendedCredentials {
    ...JobPosting_RecommendedCredential
  }
  primaryContact {
    avatarUrl
    firstName
    id
    lastName
  }
  recruiters {
    firstName
    id
    lastName
  }
  timeSheetManagers {
    firstName
    id
    lastName
  }
  requiredLicenses {
    ...JobPostingLicense
  }
  salaryRange {
    maxValue
    minValue
    payPeriod
  }
  shift
  syndicateIndeed
  startDate
  submitApplicationUrl
  slug
  responsibilities
  title
  workingEnvironment
}
    ${JobPosting_ScreeningFragmentDoc}
${JobPosting_RecommendedCredentialFragmentDoc}
${JobPostingLicenseFragmentDoc}`
export const JobPosting_NoteFragmentDoc = /*#__PURE__*/ `
    fragment JobPosting_Note on Note {
  id
  author {
    ...Member
  }
  body
  createdAt
  jsonBody
  namespace
  updatedAt
}
    ${MemberFragmentDoc}`
export const Kontext_JobApplicationFragmentDoc = /*#__PURE__*/ `
    fragment Kontext_JobApplication on JobApplication {
  __typename
  id
  jobPosting {
    id
    client {
      displayname
    }
    slug
  }
  uri
  user {
    id
    username
  }
}
    `
export const Kontext_PlacementFragmentDoc = /*#__PURE__*/ `
    fragment Kontext_Placement on Placement {
  __typename
  id
  jobPosting {
    id
    client {
      id
      displayname
    }
    slug
  }
  uri
  user {
    id
    username
  }
  updatedAt
}
    `
export const Kontext_JobPostingFragmentDoc = /*#__PURE__*/ `
    fragment Kontext_JobPosting on JobPosting {
  __typename
  id
  client {
    id
    displayname
  }
  slug
  uri
}
    `
export const Kontext_MemberFragmentDoc = /*#__PURE__*/ `
    fragment Kontext_Member on User {
  __typename
  id
  username
  uri
}
    `
export const Kontext_ClientFragmentDoc = /*#__PURE__*/ `
    fragment Kontext_Client on Client {
  __typename
  id
  displayname
  uri
}
    `
export const ActivityFragmentDoc = /*#__PURE__*/ `
    fragment Activity on Activity {
  id
  alert
  author {
    id
    avatarUrl
    firstName
    lastName
    uri
    username
  }
  body
  createdAt
  kontext {
    ... on JobApplication {
      ...Kontext_JobApplication
    }
    ... on Placement {
      ...Kontext_Placement
    }
    ... on JobPosting {
      ...Kontext_JobPosting
    }
    ... on User {
      ...Kontext_Member
    }
    ... on ChatMessage {
      __typename
      id
      sender {
        username
      }
    }
  }
  jsonBody
  resource {
    __typename
    ... on JobApplication {
      ...Kontext_JobApplication
    }
    ... on Placement {
      ...Kontext_Placement
    }
    ... on JobPosting {
      ...Kontext_JobPosting
    }
    ... on User {
      ...Kontext_Member
    }
    ... on Client {
      ...Kontext_Client
    }
  }
  recipientRead
  updatedAt
}
    ${Kontext_JobApplicationFragmentDoc}
${Kontext_PlacementFragmentDoc}
${Kontext_JobPostingFragmentDoc}
${Kontext_MemberFragmentDoc}
${Kontext_ClientFragmentDoc}`
export const ActivityEdgeFragmentDoc = /*#__PURE__*/ `
    fragment ActivityEdge on ActivityEdge {
  __typename
  cursor
  node {
    ...Activity
  }
}
    ${ActivityFragmentDoc}`
export const JobPosting_ActivityConnectionFragmentDoc = /*#__PURE__*/ `
    fragment JobPosting_ActivityConnection on ActivityConnection {
  edges {
    ...ActivityEdge
  }
  pageInfo {
    ...BasePageInfo
  }
}
    ${ActivityEdgeFragmentDoc}
${BasePageInfoFragmentDoc}`
export const JobPosting_ActivitiesFragmentDoc = /*#__PURE__*/ `
    fragment JobPosting_Activities on JobPosting {
  id
  activities(
    after: $after
    before: $before
    first: $first
    last: $last
    notes: $notes
  ) {
    ...JobPosting_ActivityConnection
  }
}
    ${JobPosting_ActivityConnectionFragmentDoc}`
export const Member_EditFragmentDoc = /*#__PURE__*/ `
    fragment Member_Edit on User {
  id
  availability
  avatarUrl
  email
  secondaryEmail
  firstName
  lastName
  phoneNumber
  social {
    calendly
    linkedin
  }
  location {
    address
    addressExtended
    city
    country
    latitude
    longitude
    postalCode
    rawLocation
    state
  }
  candidate {
    backgroundCheckDate
    candidateLicenses {
      ...MemberLicense
    }
    dnu
    education {
      id
      degree
      educationLevel
      school
      yearsAttended
    }
    experiences {
      id
      companyName
      current
      endDate
      jobTitle
      responsibilities
      startDate
      yearsEmployed
    }
    hiringStatus
    i9Date
    idealEmployment
    isNeedEmploymentSponsor
    isUsWorkAuthorized
    noWorkExperience
    profilePercentComplete
    resumeUrl
    recruiters {
      avatarUrl
      firstName
      id
      lastName
    }
    salaryExpectations
    skillRelations {
      id
      skill {
        ...Skill
      }
      years
    }
    summary {
      id
      entry
      title
    }
  }
}
    ${MemberLicenseFragmentDoc}
${SkillFragmentDoc}`
export const Member_ConnectionsFragmentDoc = /*#__PURE__*/ `
    fragment Member_Connections on User {
  connectionCount(
    status: $status
    connectionResourceType: $connectionResourceType
  )
  connections(
    after: $after
    before: $before
    connectionResourceType: $connectionResourceType
    first: $first
    last: $last
    status: $status
  ) {
    edges {
      cursor
      node {
        ... on User {
          ...Member
        }
        ... on Client {
          ...Company
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${MemberFragmentDoc}
${CompanyFragmentDoc}
${PageInfoFragmentDoc}`
export const Member_JobPostingFragmentDoc = /*#__PURE__*/ `
    fragment Member_JobPosting on JobPosting {
  __typename
  id
  applicationReceived
  atsRecordType
  client {
    __typename
    id
    displayname
    avatarUrl
    connectionStatus
    description
    name
    location {
      address
      addressExtended
      city
      country
      latitude
      longitude
      postalCode
      rawLocation
      state
    }
  }
  jobPostingScreening {
    ...JobPosting_Screening
  }
  description
  employmentTypes
  location {
    address
    addressExtended
    city
    country
    latitude
    longitude
    postalCode
    rawLocation
    state
  }
  permissions {
    destroy
    edit
    readJobApps
  }
  postedAt
  requiredLicenses {
    ...JobPostingLicense
  }
  slug
  title
}
    ${JobPosting_ScreeningFragmentDoc}
${JobPostingLicenseFragmentDoc}`
export const Member_JobApplicationFragmentDoc = /*#__PURE__*/ `
    fragment Member_JobApplication on JobApplication {
  __typename
  id
  createdAt
  clientInterestAt
  clientInterestMessage
  hasClientInterest
  permissions {
    show
  }
  jobPosting {
    ...Member_JobPosting
  }
  screeningSubmissions {
    ...ScreeningSubmission
  }
  status
}
    ${Member_JobPostingFragmentDoc}
${ScreeningSubmissionFragmentDoc}`
export const Member_JobApplicationsFragmentDoc = /*#__PURE__*/ `
    fragment Member_JobApplications on User {
  candidate {
    jobApplications {
      ...Member_JobApplication
    }
  }
}
    ${Member_JobApplicationFragmentDoc}`
export const ActivityConnectionFragmentDoc = /*#__PURE__*/ `
    fragment ActivityConnection on ActivityConnection {
  edges {
    ...ActivityEdge
  }
  pageInfo {
    ...BasePageInfo
  }
}
    ${ActivityEdgeFragmentDoc}
${BasePageInfoFragmentDoc}`
export const Member_AlertsFragmentDoc = /*#__PURE__*/ `
    fragment Member_Alerts on User {
  id
  alerts(after: $after, before: $before, first: $first, last: $last) {
    ...ActivityConnection
  }
  username
}
    ${ActivityConnectionFragmentDoc}`
export const Member_ActivitiesFragmentDoc = /*#__PURE__*/ `
    fragment Member_Activities on User {
  id
  activities(
    after: $after
    before: $before
    first: $first
    last: $last
    notes: $notes
  ) {
    ...ActivityConnection
  }
  username
}
    ${ActivityConnectionFragmentDoc}`
export const MetaInfoFragmentDoc = /*#__PURE__*/ `
    fragment MetaInfo on MetaInfo {
  canonicalUrl
  createdAt
  description
  id
  robots
  title
  updatedAt
}
    `
export const PageFragmentDoc = /*#__PURE__*/ `
    fragment Page on Page {
  author {
    id
    avatarUrl
    firstName
    lastName
    username
  }
  createdAt
  description
  id
  markdownContent
  metaInfo {
    ...MetaInfo
  }
  pagePhotos {
    id
    alt
    height
    mediaType
    width
    url
  }
  pageType
  postedAt
  rawUrl
  subtitle
  title
  updatedAt
  search {
    id
    domainQueryName
    queryString
    resourceType
  }
}
    ${MetaInfoFragmentDoc}`
export const EsResultFragmentDoc = /*#__PURE__*/ `
    fragment EsResult on EsResult {
  id
  score
  highlight
  label
  slug
  type
}
    `
export const EsCompanyResultConnectionFragmentDoc = /*#__PURE__*/ `
    fragment EsCompanyResultConnection on EsClientResultConnection {
  edges {
    cursor
    node {
      ... on EsClientResult {
        ...EsResult
      }
    }
  }
  pageInfo {
    ...BasePageInfo
  }
}
    ${EsResultFragmentDoc}
${BasePageInfoFragmentDoc}`
export const EsCredentialResultConnectionFragmentDoc = /*#__PURE__*/ `
    fragment EsCredentialResultConnection on EsCredentialResultConnection {
  edges {
    cursor
    node {
      ... on EsCredentialResult {
        ...EsResult
      }
    }
  }
  pageInfo {
    ...BasePageInfo
  }
}
    ${EsResultFragmentDoc}
${BasePageInfoFragmentDoc}`
export const EsJobPostingResultConnectionFragmentDoc = /*#__PURE__*/ `
    fragment EsJobPostingResultConnection on EsJobPostingResultConnection {
  edges {
    cursor
    node {
      ... on EsJobPostingResult {
        ...EsResult
      }
    }
  }
  pageInfo {
    ...BasePageInfo
  }
}
    ${EsResultFragmentDoc}
${BasePageInfoFragmentDoc}`
export const EsMemberResultConnectionFragmentDoc = /*#__PURE__*/ `
    fragment EsMemberResultConnection on EsCandidateResultConnection {
  edges {
    cursor
    node {
      ... on EsCandidateResult {
        ...EsResult
      }
    }
  }
  pageInfo {
    ...BasePageInfo
  }
}
    ${EsResultFragmentDoc}
${BasePageInfoFragmentDoc}`
export const EsSlugNameResultFragmentDoc = /*#__PURE__*/ `
    fragment EsSlugNameResult on EsSlugNameResult {
  id
  name
  slug
  avatarUrl
  type
}
    `
export const EsSlugNameResultConnectionFragmentDoc = /*#__PURE__*/ `
    fragment EsSlugNameResultConnection on EsSlugNameResultConnection {
  edges {
    cursor
    node {
      ... on EsSlugNameResult {
        ...EsSlugNameResult
      }
    }
  }
}
    ${EsSlugNameResultFragmentDoc}`
export const SubscriptionFragmentDoc = /*#__PURE__*/ `
    fragment Subscription on Subscription {
  __typename
  id
  name
  plan
  active
  userId
}
    `
export const QuestionAnswerFragmentDoc = /*#__PURE__*/ `
    fragment QuestionAnswer on QuestionAnswer {
  id
  answer
}
    `
export const QuestionAttemptFragmentDoc = /*#__PURE__*/ `
    fragment QuestionAttempt on QuestionAttempt {
  __typename
  id
  quizQuestion {
    sortPosition
    question {
      value
      questionAnswerType
    }
    questionAnswers {
      ...QuestionAnswer
    }
  }
}
    ${QuestionAnswerFragmentDoc}`
export const QuizAttemptFragmentDoc = /*#__PURE__*/ `
    fragment QuizAttempt on QuizAttempt {
  __typename
  id
  createdAt
  grade
  status
  userCurrentQuestionAttempt {
    ...QuestionAttempt
  }
}
    ${QuestionAttemptFragmentDoc}`
export const QuizFragmentDoc = /*#__PURE__*/ `
    fragment Quiz on Quiz {
  __typename
  createdAt
  id
  currentUserQuizAttempts {
    ...QuizAttempt
  }
  description
  slug
  timeToComplete
  title
  totalCorrectToGainCertification
  totalQuestions
  videoUrl
}
    ${QuizAttemptFragmentDoc}`
export const TrainingFragmentDoc = /*#__PURE__*/ `
    fragment Training on Training {
  __typename
  id
  currentUserPassed
  countCandidatesCompletedTraining
  creatorClient {
    id
    avatarUrl
    displayname
  }
  credential {
    id
    badgeUrl
    description
    title
  }
  description
  isPublished
  permissions {
    viewCount
    viewTrainingMembers
  }
  quizzes {
    ...Quiz
  }
  slug
  title
  totalQuestionsCount
  totalTimeToComplete
  trainingUrl
}
    ${QuizFragmentDoc}`
export const ClientTrainingFragmentDoc = /*#__PURE__*/ `
    fragment ClientTraining on ClientTraining {
  __typename
  id
  client {
    displayname
  }
  training {
    ...Training
  }
}
    ${TrainingFragmentDoc}`
export const ClientTrainingEdgeFragmentDoc = /*#__PURE__*/ `
    fragment ClientTrainingEdge on ClientTrainingEdge {
  __typename
  cursor
  node {
    ...ClientTraining
  }
}
    ${ClientTrainingFragmentDoc}`
export const ClientTrainingConnectionFragmentDoc = /*#__PURE__*/ `
    fragment ClientTrainingConnection on ClientTrainingConnection {
  edges {
    ...ClientTrainingEdge
  }
  pageInfo {
    ...BasePageInfo
  }
}
    ${ClientTrainingEdgeFragmentDoc}
${BasePageInfoFragmentDoc}`
export const TrainingMemberEdgeFragmentDoc = /*#__PURE__*/ `
    fragment TrainingMemberEdge on UserEdge {
  __typename
  cursor
  node {
    ...Member
  }
}
    ${MemberFragmentDoc}`
export const TrainingMemberConnectionFragmentDoc = /*#__PURE__*/ `
    fragment TrainingMemberConnection on UserConnection {
  edges {
    ...TrainingMemberEdge
  }
  pageInfo {
    ...BasePageInfo
  }
}
    ${TrainingMemberEdgeFragmentDoc}
${BasePageInfoFragmentDoc}`
export const QuizEdgeFragmentDoc = /*#__PURE__*/ `
    fragment QuizEdge on QuizEdge {
  __typename
  cursor
  node {
    ...Quiz
  }
}
    ${QuizFragmentDoc}`
export const QuizConnectionFragmentDoc = /*#__PURE__*/ `
    fragment QuizConnection on QuizConnection {
  edges {
    ...QuizEdge
  }
  pageInfo {
    ...BasePageInfo
  }
}
    ${QuizEdgeFragmentDoc}
${BasePageInfoFragmentDoc}`
export const QuizQuestionFragmentDoc = /*#__PURE__*/ `
    fragment QuizQuestion on QuizQuestion {
  __typename
  question {
    id
    questionAnswerType
    value
  }
  questionAnswers {
    id
    answer
  }
  sortPosition
}
    `
export const CredentialFragmentDoc = /*#__PURE__*/ `
    fragment Credential on Credential {
  __typename
  id
  badgeUrl
  description
  slug
  title
  training {
    id
    trainingUrl
  }
}
    `
export const Viewer_UserFragmentDoc = /*#__PURE__*/ `
    fragment Viewer_User on User {
  ...Member
  jwt
  termsAcceptedAt
  client {
    ...Company
  }
}
    ${MemberFragmentDoc}
${CompanyFragmentDoc}`
export const ProfessionalInterestFragmentDoc = /*#__PURE__*/ `
    fragment ProfessionalInterest on ProfessionalInterest {
  id
  icon
  name
}
    `
export const PlatformIntentionFragmentDoc = /*#__PURE__*/ `
    fragment PlatformIntention on PlatformIntention {
  id
  icon
  name
}
    `
export const EmploymentBenefitFragmentDoc = /*#__PURE__*/ `
    fragment EmploymentBenefit on EmploymentBenefit {
  __typename
  id
  name
}
    `
export const ScreeningFragmentDoc = /*#__PURE__*/ `
    fragment Screening on Screening {
  id
  name
  description
}
    `
export const EmployeeFragmentDoc = /*#__PURE__*/ `
    fragment Employee on Employee {
  id
  employeeTeamSortPositions {
    id
    position
    team
  }
  teams
  user {
    ...Member
    currentJobTitle
  }
  vangstBio
}
    ${MemberFragmentDoc}`
export const ChatMessageFragmentDoc = /*#__PURE__*/ `
    fragment ChatMessage on ChatMessage {
  id
  createdAt
  recipient {
    ...Member
  }
  recipientRead
  sender {
    ...Member
  }
  senderRead
  slateMessage
  updatedAt
}
    ${MemberFragmentDoc}`
export const ChatMessageConnectionFragmentDoc = /*#__PURE__*/ `
    fragment ChatMessageConnection on ChatMessageConnection {
  edges {
    cursor
    node {
      ...ChatMessage
    }
  }
  pageInfo {
    ...BasePageInfo
  }
}
    ${ChatMessageFragmentDoc}
${BasePageInfoFragmentDoc}`
export const NotificationFragmentDoc = /*#__PURE__*/ `
    fragment Notification on Notification {
  count
  ids
  type
}
    `
export const CompanyDocument = /*#__PURE__*/ `
    query Company($displayname: String!) {
  getClient(displayname: $displayname) {
    ...Company
  }
}
    ${CompanyFragmentDoc}`

export const useCompanyQuery = <TData = CompanyQuery, TError = FetcherError>(
  variables: CompanyQueryVariables,
  options?: UseQueryOptions<CompanyQuery, TError, TData>,
) => {
  return useQuery<CompanyQuery, TError, TData>(
    ['Company', variables],
    fetcher<CompanyQuery, CompanyQueryVariables>(CompanyDocument, variables),
    options,
  )
}

useCompanyQuery.getKey = (variables: CompanyQueryVariables) => [
  'Company',
  variables,
]

export const CompanyEditDocument = /*#__PURE__*/ `
    query CompanyEdit($displayname: String!) {
  getClient(displayname: $displayname) {
    ...Company_Edit
  }
}
    ${Company_EditFragmentDoc}`

export const useCompanyEditQuery = <
  TData = CompanyEditQuery,
  TError = FetcherError,
>(
  variables: CompanyEditQueryVariables,
  options?: UseQueryOptions<CompanyEditQuery, TError, TData>,
) => {
  return useQuery<CompanyEditQuery, TError, TData>(
    ['CompanyEdit', variables],
    fetcher<CompanyEditQuery, CompanyEditQueryVariables>(
      CompanyEditDocument,
      variables,
    ),
    options,
  )
}

useCompanyEditQuery.getKey = (variables: CompanyEditQueryVariables) => [
  'CompanyEdit',
  variables,
]

export const CompanyFollowersDocument = /*#__PURE__*/ `
    query CompanyFollowers($displayname: String!, $after: String, $before: String, $first: Int = 24, $last: Int) {
  getClient(displayname: $displayname) {
    ...Company_Followers
  }
}
    ${Company_FollowersFragmentDoc}`

export const useCompanyFollowersQuery = <
  TData = CompanyFollowersQuery,
  TError = FetcherError,
>(
  variables: CompanyFollowersQueryVariables,
  options?: UseQueryOptions<CompanyFollowersQuery, TError, TData>,
) => {
  return useQuery<CompanyFollowersQuery, TError, TData>(
    ['CompanyFollowers', variables],
    fetcher<CompanyFollowersQuery, CompanyFollowersQueryVariables>(
      CompanyFollowersDocument,
      variables,
    ),
    options,
  )
}

useCompanyFollowersQuery.getKey = (
  variables: CompanyFollowersQueryVariables,
) => ['CompanyFollowers', variables]

export const CompanyJobPostingsDocument = /*#__PURE__*/ `
    query CompanyJobPostings($displayname: String!, $atsRecordTypes: [AtsRecordTypeEnum], $after: String, $before: String, $first: Int = 24, $last: Int) {
  getClient(displayname: $displayname) {
    ...Company_JobPostings
  }
}
    ${Company_JobPostingsFragmentDoc}`

export const useCompanyJobPostingsQuery = <
  TData = CompanyJobPostingsQuery,
  TError = FetcherError,
>(
  variables: CompanyJobPostingsQueryVariables,
  options?: UseQueryOptions<CompanyJobPostingsQuery, TError, TData>,
) => {
  return useQuery<CompanyJobPostingsQuery, TError, TData>(
    ['CompanyJobPostings', variables],
    fetcher<CompanyJobPostingsQuery, CompanyJobPostingsQueryVariables>(
      CompanyJobPostingsDocument,
      variables,
    ),
    options,
  )
}

useCompanyJobPostingsQuery.getKey = (
  variables: CompanyJobPostingsQueryVariables,
) => ['CompanyJobPostings', variables]

export const CompanyPhotosDocument = /*#__PURE__*/ `
    query CompanyPhotos($displayname: String!) {
  getClient(displayname: $displayname) {
    ...Company_Photos
  }
}
    ${Company_PhotosFragmentDoc}`

export const useCompanyPhotosQuery = <
  TData = CompanyPhotosQuery,
  TError = FetcherError,
>(
  variables: CompanyPhotosQueryVariables,
  options?: UseQueryOptions<CompanyPhotosQuery, TError, TData>,
) => {
  return useQuery<CompanyPhotosQuery, TError, TData>(
    ['CompanyPhotos', variables],
    fetcher<CompanyPhotosQuery, CompanyPhotosQueryVariables>(
      CompanyPhotosDocument,
      variables,
    ),
    options,
  )
}

useCompanyPhotosQuery.getKey = (variables: CompanyPhotosQueryVariables) => [
  'CompanyPhotos',
  variables,
]

export const CompanyJobApplicationDocument = /*#__PURE__*/ `
    query CompanyJobApplication($id: ID!) {
  getJobApplication(id: $id) {
    ...Company_JobApplication
  }
}
    ${Company_JobApplicationFragmentDoc}`

export const useCompanyJobApplicationQuery = <
  TData = CompanyJobApplicationQuery,
  TError = FetcherError,
>(
  variables: CompanyJobApplicationQueryVariables,
  options?: UseQueryOptions<CompanyJobApplicationQuery, TError, TData>,
) => {
  return useQuery<CompanyJobApplicationQuery, TError, TData>(
    ['CompanyJobApplication', variables],
    fetcher<CompanyJobApplicationQuery, CompanyJobApplicationQueryVariables>(
      CompanyJobApplicationDocument,
      variables,
    ),
    options,
  )
}

useCompanyJobApplicationQuery.getKey = (
  variables: CompanyJobApplicationQueryVariables,
) => ['CompanyJobApplication', variables]

export const CompanyJobApplicationsDocument = /*#__PURE__*/ `
    query CompanyJobApplications($hasClientInterest: Boolean, $jobPostingId: String, $displayname: String, $status: [JobApplicationStatusEnum!], $after: String, $before: String, $first: Int = 24, $last: Int) {
  getJobApplications(
    hasClientInterest: $hasClientInterest
    jobPostingId: $jobPostingId
    displayname: $displayname
    status: $status
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    ...CompanyJobApplications_JobApplicationConnection
  }
}
    ${CompanyJobApplications_JobApplicationConnectionFragmentDoc}`

export const useCompanyJobApplicationsQuery = <
  TData = CompanyJobApplicationsQuery,
  TError = FetcherError,
>(
  variables?: CompanyJobApplicationsQueryVariables,
  options?: UseQueryOptions<CompanyJobApplicationsQuery, TError, TData>,
) => {
  return useQuery<CompanyJobApplicationsQuery, TError, TData>(
    variables === undefined
      ? ['CompanyJobApplications']
      : ['CompanyJobApplications', variables],
    fetcher<CompanyJobApplicationsQuery, CompanyJobApplicationsQueryVariables>(
      CompanyJobApplicationsDocument,
      variables,
    ),
    options,
  )
}

useCompanyJobApplicationsQuery.getKey = (
  variables?: CompanyJobApplicationsQueryVariables,
) =>
  variables === undefined
    ? ['CompanyJobApplications']
    : ['CompanyJobApplications', variables]

export const CompanyJobPlacementsDocument = /*#__PURE__*/ `
    query CompanyJobPlacements($jobPostingId: String!, $status: [PlacementStatusEnum!], $candidateId: String, $after: String, $before: String, $first: Int = 24, $last: Int) {
  getPlacements(
    jobPostingId: $jobPostingId
    status: $status
    candidateId: $candidateId
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    ...CompanyJobPlacments_JobPlacementConnection
  }
}
    ${CompanyJobPlacments_JobPlacementConnectionFragmentDoc}`

export const useCompanyJobPlacementsQuery = <
  TData = CompanyJobPlacementsQuery,
  TError = FetcherError,
>(
  variables: CompanyJobPlacementsQueryVariables,
  options?: UseQueryOptions<CompanyJobPlacementsQuery, TError, TData>,
) => {
  return useQuery<CompanyJobPlacementsQuery, TError, TData>(
    ['CompanyJobPlacements', variables],
    fetcher<CompanyJobPlacementsQuery, CompanyJobPlacementsQueryVariables>(
      CompanyJobPlacementsDocument,
      variables,
    ),
    options,
  )
}

useCompanyJobPlacementsQuery.getKey = (
  variables: CompanyJobPlacementsQueryVariables,
) => ['CompanyJobPlacements', variables]

export const CompanyCompanyJobPlacementsDocument = /*#__PURE__*/ `
    query CompanyCompanyJobPlacements($active: Boolean, $jobPostingId: String!, $after: String, $before: String, $first: Int = 24, $last: Int) {
  getCompanyPlacements(
    active: $active
    jobPostingId: $jobPostingId
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    ...CompanyJobPlacments_JobPlacementConnection
  }
}
    ${CompanyJobPlacments_JobPlacementConnectionFragmentDoc}`

export const useCompanyCompanyJobPlacementsQuery = <
  TData = CompanyCompanyJobPlacementsQuery,
  TError = FetcherError,
>(
  variables: CompanyCompanyJobPlacementsQueryVariables,
  options?: UseQueryOptions<CompanyCompanyJobPlacementsQuery, TError, TData>,
) => {
  return useQuery<CompanyCompanyJobPlacementsQuery, TError, TData>(
    ['CompanyCompanyJobPlacements', variables],
    fetcher<
      CompanyCompanyJobPlacementsQuery,
      CompanyCompanyJobPlacementsQueryVariables
    >(CompanyCompanyJobPlacementsDocument, variables),
    options,
  )
}

useCompanyCompanyJobPlacementsQuery.getKey = (
  variables: CompanyCompanyJobPlacementsQueryVariables,
) => ['CompanyCompanyJobPlacements', variables]

export const CreateCompanyUserDocument = /*#__PURE__*/ `
    mutation CreateCompanyUser($input: CreateCompanyUserInput!) {
  createCompanyUser(input: $input) {
    id
    client {
      displayname
      name
    }
    firstName
    lastName
    username
  }
}
    `

export const useCreateCompanyUserMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateCompanyUserMutation,
    TError,
    CreateCompanyUserMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateCompanyUserMutation,
    TError,
    CreateCompanyUserMutationVariables,
    TContext
  >(
    ['CreateCompanyUser'],
    (variables?: CreateCompanyUserMutationVariables) =>
      fetcher<CreateCompanyUserMutation, CreateCompanyUserMutationVariables>(
        CreateCompanyUserDocument,
        variables,
      )(),
    options,
  )
}

export const FollowCompanyDocument = /*#__PURE__*/ `
    mutation FollowCompany($input: FollowClientInput!) {
  followClient(input: $input) {
    ... on Client {
      ...Company
    }
  }
}
    ${CompanyFragmentDoc}`

export const useFollowCompanyMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    FollowCompanyMutation,
    TError,
    FollowCompanyMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    FollowCompanyMutation,
    TError,
    FollowCompanyMutationVariables,
    TContext
  >(
    ['FollowCompany'],
    (variables?: FollowCompanyMutationVariables) =>
      fetcher<FollowCompanyMutation, FollowCompanyMutationVariables>(
        FollowCompanyDocument,
        variables,
      )(),
    options,
  )
}

export const IndicateInterestDocument = /*#__PURE__*/ `
    mutation IndicateInterest($input: ClientShowInterestInput!) {
  clientShowInterest(input: $input) {
    ...Company_JobApplication
  }
}
    ${Company_JobApplicationFragmentDoc}`

export const useIndicateInterestMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    IndicateInterestMutation,
    TError,
    IndicateInterestMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    IndicateInterestMutation,
    TError,
    IndicateInterestMutationVariables,
    TContext
  >(
    ['IndicateInterest'],
    (variables?: IndicateInterestMutationVariables) =>
      fetcher<IndicateInterestMutation, IndicateInterestMutationVariables>(
        IndicateInterestDocument,
        variables,
      )(),
    options,
  )
}

export const UnfollowCompanyDocument = /*#__PURE__*/ `
    mutation UnfollowCompany($input: UnfollowClientInput!) {
  unfollowClient(input: $input) {
    ... on Client {
      ...Company
    }
  }
}
    ${CompanyFragmentDoc}`

export const useUnfollowCompanyMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UnfollowCompanyMutation,
    TError,
    UnfollowCompanyMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UnfollowCompanyMutation,
    TError,
    UnfollowCompanyMutationVariables,
    TContext
  >(
    ['UnfollowCompany'],
    (variables?: UnfollowCompanyMutationVariables) =>
      fetcher<UnfollowCompanyMutation, UnfollowCompanyMutationVariables>(
        UnfollowCompanyDocument,
        variables,
      )(),
    options,
  )
}

export const UpdateCompanyDocument = /*#__PURE__*/ `
    mutation UpdateCompany($input: UpdateCompanyInput!) {
  updateCompany(input: $input) {
    ...Company_Edit
  }
}
    ${Company_EditFragmentDoc}`

export const useUpdateCompanyMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateCompanyMutation,
    TError,
    UpdateCompanyMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateCompanyMutation,
    TError,
    UpdateCompanyMutationVariables,
    TContext
  >(
    ['UpdateCompany'],
    (variables?: UpdateCompanyMutationVariables) =>
      fetcher<UpdateCompanyMutation, UpdateCompanyMutationVariables>(
        UpdateCompanyDocument,
        variables,
      )(),
    options,
  )
}

export const UpdateJobApplicationDocument = /*#__PURE__*/ `
    mutation UpdateJobApplication($input: UpdateJobApplicationInput!) {
  updateJobApplication(input: $input) {
    ...Company_JobApplication
  }
}
    ${Company_JobApplicationFragmentDoc}`

export const useUpdateJobApplicationMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateJobApplicationMutation,
    TError,
    UpdateJobApplicationMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateJobApplicationMutation,
    TError,
    UpdateJobApplicationMutationVariables,
    TContext
  >(
    ['UpdateJobApplication'],
    (variables?: UpdateJobApplicationMutationVariables) =>
      fetcher<
        UpdateJobApplicationMutation,
        UpdateJobApplicationMutationVariables
      >(UpdateJobApplicationDocument, variables)(),
    options,
  )
}

export const UpdatePlacementDocument = /*#__PURE__*/ `
    mutation UpdatePlacement($input: UpdatePlacementInput!) {
  updatePlacement(input: $input) {
    ...Company_Placement
  }
}
    ${Company_PlacementFragmentDoc}`

export const useUpdatePlacementMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdatePlacementMutation,
    TError,
    UpdatePlacementMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdatePlacementMutation,
    TError,
    UpdatePlacementMutationVariables,
    TContext
  >(
    ['UpdatePlacement'],
    (variables?: UpdatePlacementMutationVariables) =>
      fetcher<UpdatePlacementMutation, UpdatePlacementMutationVariables>(
        UpdatePlacementDocument,
        variables,
      )(),
    options,
  )
}

export const AddToJobDocument = /*#__PURE__*/ `
    mutation AddToJob($input: AddToJobInput!) {
  addToJob(input: $input) {
    ...Company_JobApplication
  }
}
    ${Company_JobApplicationFragmentDoc}`

export const useAddToJobMutation = <TError = FetcherError, TContext = unknown>(
  options?: UseMutationOptions<
    AddToJobMutation,
    TError,
    AddToJobMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AddToJobMutation,
    TError,
    AddToJobMutationVariables,
    TContext
  >(
    ['AddToJob'],
    (variables?: AddToJobMutationVariables) =>
      fetcher<AddToJobMutation, AddToJobMutationVariables>(
        AddToJobDocument,
        variables,
      )(),
    options,
  )
}

export const UpdateGigsEmployeeDocument = /*#__PURE__*/ `
    mutation UpdateGigsEmployee($input: UpdateGigsEmployeeInput!) {
  updateGigsEmployee(input: $input) {
    id
    onboardingStatus
  }
}
    `

export const useUpdateGigsEmployeeMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateGigsEmployeeMutation,
    TError,
    UpdateGigsEmployeeMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateGigsEmployeeMutation,
    TError,
    UpdateGigsEmployeeMutationVariables,
    TContext
  >(
    ['UpdateGigsEmployee'],
    (variables?: UpdateGigsEmployeeMutationVariables) =>
      fetcher<UpdateGigsEmployeeMutation, UpdateGigsEmployeeMutationVariables>(
        UpdateGigsEmployeeDocument,
        variables,
      )(),
    options,
  )
}

export const JobPostingDocument = /*#__PURE__*/ `
    query JobPosting($id: String!) {
  getJobPosting(id: $id) {
    ...JobPosting
  }
}
    ${JobPostingFragmentDoc}`

export const useJobPostingQuery = <
  TData = JobPostingQuery,
  TError = FetcherError,
>(
  variables: JobPostingQueryVariables,
  options?: UseQueryOptions<JobPostingQuery, TError, TData>,
) => {
  return useQuery<JobPostingQuery, TError, TData>(
    ['JobPosting', variables],
    fetcher<JobPostingQuery, JobPostingQueryVariables>(
      JobPostingDocument,
      variables,
    ),
    options,
  )
}

useJobPostingQuery.getKey = (variables: JobPostingQueryVariables) => [
  'JobPosting',
  variables,
]

export const JobPostingEditDocument = /*#__PURE__*/ `
    query JobPostingEdit($id: String!) {
  getJobPosting(id: $id) {
    ...JobPosting_Edit
  }
}
    ${JobPosting_EditFragmentDoc}`

export const useJobPostingEditQuery = <
  TData = JobPostingEditQuery,
  TError = FetcherError,
>(
  variables: JobPostingEditQueryVariables,
  options?: UseQueryOptions<JobPostingEditQuery, TError, TData>,
) => {
  return useQuery<JobPostingEditQuery, TError, TData>(
    ['JobPostingEdit', variables],
    fetcher<JobPostingEditQuery, JobPostingEditQueryVariables>(
      JobPostingEditDocument,
      variables,
    ),
    options,
  )
}

useJobPostingEditQuery.getKey = (variables: JobPostingEditQueryVariables) => [
  'JobPostingEdit',
  variables,
]

export const JobPostingActivitiesDocument = /*#__PURE__*/ `
    query JobPostingActivities($after: String, $before: String, $first: Int = 24, $last: Int, $id: String!, $notes: Boolean) {
  getJobPosting(id: $id) {
    ...JobPosting_Activities
  }
}
    ${JobPosting_ActivitiesFragmentDoc}`

export const useJobPostingActivitiesQuery = <
  TData = JobPostingActivitiesQuery,
  TError = FetcherError,
>(
  variables: JobPostingActivitiesQueryVariables,
  options?: UseQueryOptions<JobPostingActivitiesQuery, TError, TData>,
) => {
  return useQuery<JobPostingActivitiesQuery, TError, TData>(
    ['JobPostingActivities', variables],
    fetcher<JobPostingActivitiesQuery, JobPostingActivitiesQueryVariables>(
      JobPostingActivitiesDocument,
      variables,
    ),
    options,
  )
}

useJobPostingActivitiesQuery.getKey = (
  variables: JobPostingActivitiesQueryVariables,
) => ['JobPostingActivities', variables]

export const GetMembersDownloadDocument = /*#__PURE__*/ `
    query GetMembersDownload($id: ID!) {
  getMembersDownload(id: $id) {
    id
    status
    url
    failures
    processingStartedAt
    processingEndedAt
  }
}
    `

export const useGetMembersDownloadQuery = <
  TData = GetMembersDownloadQuery,
  TError = FetcherError,
>(
  variables: GetMembersDownloadQueryVariables,
  options?: UseQueryOptions<GetMembersDownloadQuery, TError, TData>,
) => {
  return useQuery<GetMembersDownloadQuery, TError, TData>(
    ['GetMembersDownload', variables],
    fetcher<GetMembersDownloadQuery, GetMembersDownloadQueryVariables>(
      GetMembersDownloadDocument,
      variables,
    ),
    options,
  )
}

useGetMembersDownloadQuery.getKey = (
  variables: GetMembersDownloadQueryVariables,
) => ['GetMembersDownload', variables]

export const GetMembersDownloadsDocument = /*#__PURE__*/ `
    query GetMembersDownloads {
  getMembersDownloads {
    id
    status
    url
    failures
    processingStartedAt
    processingEndedAt
  }
}
    `

export const useGetMembersDownloadsQuery = <
  TData = GetMembersDownloadsQuery,
  TError = FetcherError,
>(
  variables?: GetMembersDownloadsQueryVariables,
  options?: UseQueryOptions<GetMembersDownloadsQuery, TError, TData>,
) => {
  return useQuery<GetMembersDownloadsQuery, TError, TData>(
    variables === undefined
      ? ['GetMembersDownloads']
      : ['GetMembersDownloads', variables],
    fetcher<GetMembersDownloadsQuery, GetMembersDownloadsQueryVariables>(
      GetMembersDownloadsDocument,
      variables,
    ),
    options,
  )
}

useGetMembersDownloadsQuery.getKey = (
  variables?: GetMembersDownloadsQueryVariables,
) =>
  variables === undefined
    ? ['GetMembersDownloads']
    : ['GetMembersDownloads', variables]

export const CreateJobPostingDocument = /*#__PURE__*/ `
    mutation CreateJobPosting($input: JobPostingInput!) {
  createJobPosting(input: $input) {
    ...JobPosting
  }
}
    ${JobPostingFragmentDoc}`

export const useCreateJobPostingMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateJobPostingMutation,
    TError,
    CreateJobPostingMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateJobPostingMutation,
    TError,
    CreateJobPostingMutationVariables,
    TContext
  >(
    ['CreateJobPosting'],
    (variables?: CreateJobPostingMutationVariables) =>
      fetcher<CreateJobPostingMutation, CreateJobPostingMutationVariables>(
        CreateJobPostingDocument,
        variables,
      )(),
    options,
  )
}

export const UpdateJobPostingDocument = /*#__PURE__*/ `
    mutation UpdateJobPosting($input: JobPostingInput!) {
  updateJobPosting(input: $input) {
    ...JobPosting
  }
}
    ${JobPostingFragmentDoc}`

export const useUpdateJobPostingMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateJobPostingMutation,
    TError,
    UpdateJobPostingMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateJobPostingMutation,
    TError,
    UpdateJobPostingMutationVariables,
    TContext
  >(
    ['UpdateJobPosting'],
    (variables?: UpdateJobPostingMutationVariables) =>
      fetcher<UpdateJobPostingMutation, UpdateJobPostingMutationVariables>(
        UpdateJobPostingDocument,
        variables,
      )(),
    options,
  )
}

export const DeleteJobPostingDocument = /*#__PURE__*/ `
    mutation DeleteJobPosting($input: DeleteJobPostingInput!) {
  deleteJobPosting(input: $input) {
    id
  }
}
    `

export const useDeleteJobPostingMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    DeleteJobPostingMutation,
    TError,
    DeleteJobPostingMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DeleteJobPostingMutation,
    TError,
    DeleteJobPostingMutationVariables,
    TContext
  >(
    ['DeleteJobPosting'],
    (variables?: DeleteJobPostingMutationVariables) =>
      fetcher<DeleteJobPostingMutation, DeleteJobPostingMutationVariables>(
        DeleteJobPostingDocument,
        variables,
      )(),
    options,
  )
}

export const DeletePlacementDocument = /*#__PURE__*/ `
    mutation DeletePlacement($input: DeletePlacementInput!) {
  deletePlacement(input: $input)
}
    `

export const useDeletePlacementMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    DeletePlacementMutation,
    TError,
    DeletePlacementMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DeletePlacementMutation,
    TError,
    DeletePlacementMutationVariables,
    TContext
  >(
    ['DeletePlacement'],
    (variables?: DeletePlacementMutationVariables) =>
      fetcher<DeletePlacementMutation, DeletePlacementMutationVariables>(
        DeletePlacementDocument,
        variables,
      )(),
    options,
  )
}

export const DownloadMembersDocument = /*#__PURE__*/ `
    mutation DownloadMembers($input: DownloadMembersInput!) {
  downloadMembers(input: $input) {
    id
    status
    url
  }
}
    `

export const useDownloadMembersMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    DownloadMembersMutation,
    TError,
    DownloadMembersMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DownloadMembersMutation,
    TError,
    DownloadMembersMutationVariables,
    TContext
  >(
    ['DownloadMembers'],
    (variables?: DownloadMembersMutationVariables) =>
      fetcher<DownloadMembersMutation, DownloadMembersMutationVariables>(
        DownloadMembersDocument,
        variables,
      )(),
    options,
  )
}

export const MemberDocument = /*#__PURE__*/ `
    query Member($username: String!) {
  getUser(username: $username) {
    ...Member
  }
}
    ${MemberFragmentDoc}`

export const useMemberQuery = <TData = MemberQuery, TError = FetcherError>(
  variables: MemberQueryVariables,
  options?: UseQueryOptions<MemberQuery, TError, TData>,
) => {
  return useQuery<MemberQuery, TError, TData>(
    ['Member', variables],
    fetcher<MemberQuery, MemberQueryVariables>(MemberDocument, variables),
    options,
  )
}

useMemberQuery.getKey = (variables: MemberQueryVariables) => [
  'Member',
  variables,
]

export const MemberAlertsDocument = /*#__PURE__*/ `
    query MemberAlerts($after: String, $before: String, $first: Int = 24, $last: Int, $username: String!) {
  getUser(username: $username) {
    ...Member_Alerts
  }
}
    ${Member_AlertsFragmentDoc}`

export const useMemberAlertsQuery = <
  TData = MemberAlertsQuery,
  TError = FetcherError,
>(
  variables: MemberAlertsQueryVariables,
  options?: UseQueryOptions<MemberAlertsQuery, TError, TData>,
) => {
  return useQuery<MemberAlertsQuery, TError, TData>(
    ['MemberAlerts', variables],
    fetcher<MemberAlertsQuery, MemberAlertsQueryVariables>(
      MemberAlertsDocument,
      variables,
    ),
    options,
  )
}

useMemberAlertsQuery.getKey = (variables: MemberAlertsQueryVariables) => [
  'MemberAlerts',
  variables,
]

export const MemberActivitiesDocument = /*#__PURE__*/ `
    query MemberActivities($after: String, $before: String, $first: Int = 24, $last: Int, $username: String!, $notes: Boolean) {
  getUser(username: $username) {
    ...Member_Activities
  }
}
    ${Member_ActivitiesFragmentDoc}`

export const useMemberActivitiesQuery = <
  TData = MemberActivitiesQuery,
  TError = FetcherError,
>(
  variables: MemberActivitiesQueryVariables,
  options?: UseQueryOptions<MemberActivitiesQuery, TError, TData>,
) => {
  return useQuery<MemberActivitiesQuery, TError, TData>(
    ['MemberActivities', variables],
    fetcher<MemberActivitiesQuery, MemberActivitiesQueryVariables>(
      MemberActivitiesDocument,
      variables,
    ),
    options,
  )
}

useMemberActivitiesQuery.getKey = (
  variables: MemberActivitiesQueryVariables,
) => ['MemberActivities', variables]

export const MemberEditDocument = /*#__PURE__*/ `
    query MemberEdit($username: String!) {
  getUser(username: $username) {
    ...Member_Edit
  }
}
    ${Member_EditFragmentDoc}`

export const useMemberEditQuery = <
  TData = MemberEditQuery,
  TError = FetcherError,
>(
  variables: MemberEditQueryVariables,
  options?: UseQueryOptions<MemberEditQuery, TError, TData>,
) => {
  return useQuery<MemberEditQuery, TError, TData>(
    ['MemberEdit', variables],
    fetcher<MemberEditQuery, MemberEditQueryVariables>(
      MemberEditDocument,
      variables,
    ),
    options,
  )
}

useMemberEditQuery.getKey = (variables: MemberEditQueryVariables) => [
  'MemberEdit',
  variables,
]

export const MemberConnectionsDocument = /*#__PURE__*/ `
    query MemberConnections($after: String, $before: String, $connectionResourceType: ConnectionActorEnum, $first: Int = 24, $last: Int, $status: ConnectionStatusFilterEnum, $username: String!) {
  getUser(username: $username) {
    ...Member_Connections
  }
}
    ${Member_ConnectionsFragmentDoc}`

export const useMemberConnectionsQuery = <
  TData = MemberConnectionsQuery,
  TError = FetcherError,
>(
  variables: MemberConnectionsQueryVariables,
  options?: UseQueryOptions<MemberConnectionsQuery, TError, TData>,
) => {
  return useQuery<MemberConnectionsQuery, TError, TData>(
    ['MemberConnections', variables],
    fetcher<MemberConnectionsQuery, MemberConnectionsQueryVariables>(
      MemberConnectionsDocument,
      variables,
    ),
    options,
  )
}

useMemberConnectionsQuery.getKey = (
  variables: MemberConnectionsQueryVariables,
) => ['MemberConnections', variables]

export const MemberJobApplicationsDocument = /*#__PURE__*/ `
    query MemberJobApplications($username: String!) {
  getUser(username: $username) {
    ...Member_JobApplications
  }
}
    ${Member_JobApplicationsFragmentDoc}`

export const useMemberJobApplicationsQuery = <
  TData = MemberJobApplicationsQuery,
  TError = FetcherError,
>(
  variables: MemberJobApplicationsQueryVariables,
  options?: UseQueryOptions<MemberJobApplicationsQuery, TError, TData>,
) => {
  return useQuery<MemberJobApplicationsQuery, TError, TData>(
    ['MemberJobApplications', variables],
    fetcher<MemberJobApplicationsQuery, MemberJobApplicationsQueryVariables>(
      MemberJobApplicationsDocument,
      variables,
    ),
    options,
  )
}

useMemberJobApplicationsQuery.getKey = (
  variables: MemberJobApplicationsQueryVariables,
) => ['MemberJobApplications', variables]

export const AcceptMemberConnectionDocument = /*#__PURE__*/ `
    mutation AcceptMemberConnection($input: AcceptCandidateConnectionInput!) {
  acceptCandidateConnection(input: $input) {
    ... on User {
      ...Member
    }
  }
}
    ${MemberFragmentDoc}`

export const useAcceptMemberConnectionMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    AcceptMemberConnectionMutation,
    TError,
    AcceptMemberConnectionMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AcceptMemberConnectionMutation,
    TError,
    AcceptMemberConnectionMutationVariables,
    TContext
  >(
    ['AcceptMemberConnection'],
    (variables?: AcceptMemberConnectionMutationVariables) =>
      fetcher<
        AcceptMemberConnectionMutation,
        AcceptMemberConnectionMutationVariables
      >(AcceptMemberConnectionDocument, variables)(),
    options,
  )
}

export const ApplyToJobDocument = /*#__PURE__*/ `
    mutation ApplyToJob($input: ApplyToJobInput!) {
  applyToJob(input: $input) {
    ...Member_JobApplication
  }
}
    ${Member_JobApplicationFragmentDoc}`

export const useApplyToJobMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    ApplyToJobMutation,
    TError,
    ApplyToJobMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ApplyToJobMutation,
    TError,
    ApplyToJobMutationVariables,
    TContext
  >(
    ['ApplyToJob'],
    (variables?: ApplyToJobMutationVariables) =>
      fetcher<ApplyToJobMutation, ApplyToJobMutationVariables>(
        ApplyToJobDocument,
        variables,
      )(),
    options,
  )
}

export const ConnectWithMemberDocument = /*#__PURE__*/ `
    mutation ConnectWithMember($input: ConnectWithCandidateInput!) {
  connectWithCandidate(input: $input) {
    ... on User {
      ...Member
    }
  }
}
    ${MemberFragmentDoc}`

export const useConnectWithMemberMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    ConnectWithMemberMutation,
    TError,
    ConnectWithMemberMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ConnectWithMemberMutation,
    TError,
    ConnectWithMemberMutationVariables,
    TContext
  >(
    ['ConnectWithMember'],
    (variables?: ConnectWithMemberMutationVariables) =>
      fetcher<ConnectWithMemberMutation, ConnectWithMemberMutationVariables>(
        ConnectWithMemberDocument,
        variables,
      )(),
    options,
  )
}

export const CreateScreeningSubmissionDocument = /*#__PURE__*/ `
    mutation CreateScreeningSubmission($input: CreateScreeningSubmissionInput!) {
  createScreeningSubmission(input: $input) {
    ...ScreeningSubmission
  }
}
    ${ScreeningSubmissionFragmentDoc}`

export const useCreateScreeningSubmissionMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateScreeningSubmissionMutation,
    TError,
    CreateScreeningSubmissionMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateScreeningSubmissionMutation,
    TError,
    CreateScreeningSubmissionMutationVariables,
    TContext
  >(
    ['CreateScreeningSubmission'],
    (variables?: CreateScreeningSubmissionMutationVariables) =>
      fetcher<
        CreateScreeningSubmissionMutation,
        CreateScreeningSubmissionMutationVariables
      >(CreateScreeningSubmissionDocument, variables)(),
    options,
  )
}

export const CreateActivityDocument = /*#__PURE__*/ `
    mutation CreateActivity($input: CreateActivityInput!) {
  createActivity(input: $input) {
    ...Activity
  }
}
    ${ActivityFragmentDoc}`

export const useCreateActivityMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateActivityMutation,
    TError,
    CreateActivityMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateActivityMutation,
    TError,
    CreateActivityMutationVariables,
    TContext
  >(
    ['CreateActivity'],
    (variables?: CreateActivityMutationVariables) =>
      fetcher<CreateActivityMutation, CreateActivityMutationVariables>(
        CreateActivityDocument,
        variables,
      )(),
    options,
  )
}

export const CreateNoteDocument = /*#__PURE__*/ `
    mutation CreateNote($input: CreateNoteInput!) {
  createNote(input: $input) {
    id
  }
}
    `

export const useCreateNoteMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateNoteMutation,
    TError,
    CreateNoteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateNoteMutation,
    TError,
    CreateNoteMutationVariables,
    TContext
  >(
    ['CreateNote'],
    (variables?: CreateNoteMutationVariables) =>
      fetcher<CreateNoteMutation, CreateNoteMutationVariables>(
        CreateNoteDocument,
        variables,
      )(),
    options,
  )
}

export const DeclineMemberConnectionDocument = /*#__PURE__*/ `
    mutation DeclineMemberConnection($input: DeclineCandidateConnectionInput!) {
  declineCandidateConnection(input: $input) {
    ... on User {
      ...Member
    }
  }
}
    ${MemberFragmentDoc}`

export const useDeclineMemberConnectionMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    DeclineMemberConnectionMutation,
    TError,
    DeclineMemberConnectionMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DeclineMemberConnectionMutation,
    TError,
    DeclineMemberConnectionMutationVariables,
    TContext
  >(
    ['DeclineMemberConnection'],
    (variables?: DeclineMemberConnectionMutationVariables) =>
      fetcher<
        DeclineMemberConnectionMutation,
        DeclineMemberConnectionMutationVariables
      >(DeclineMemberConnectionDocument, variables)(),
    options,
  )
}

export const DisconnectWithMemberDocument = /*#__PURE__*/ `
    mutation DisconnectWithMember($input: DisconnectWithCandidateInput!) {
  disconnectWithCandidate(input: $input) {
    ... on User {
      ...Member
    }
  }
}
    ${MemberFragmentDoc}`

export const useDisconnectWithMemberMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    DisconnectWithMemberMutation,
    TError,
    DisconnectWithMemberMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DisconnectWithMemberMutation,
    TError,
    DisconnectWithMemberMutationVariables,
    TContext
  >(
    ['DisconnectWithMember'],
    (variables?: DisconnectWithMemberMutationVariables) =>
      fetcher<
        DisconnectWithMemberMutation,
        DisconnectWithMemberMutationVariables
      >(DisconnectWithMemberDocument, variables)(),
    options,
  )
}

export const GenerateChargebeeCheckoutDocument = /*#__PURE__*/ `
    mutation GenerateChargebeeCheckout($input: GenerateChargebeeCheckoutInput!) {
  generateChargebeeCheckout(input: $input) {
    id
    url
  }
}
    `

export const useGenerateChargebeeCheckoutMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    GenerateChargebeeCheckoutMutation,
    TError,
    GenerateChargebeeCheckoutMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    GenerateChargebeeCheckoutMutation,
    TError,
    GenerateChargebeeCheckoutMutationVariables,
    TContext
  >(
    ['GenerateChargebeeCheckout'],
    (variables?: GenerateChargebeeCheckoutMutationVariables) =>
      fetcher<
        GenerateChargebeeCheckoutMutation,
        GenerateChargebeeCheckoutMutationVariables
      >(GenerateChargebeeCheckoutDocument, variables)(),
    options,
  )
}

export const GenerateChargebeePortalDocument = /*#__PURE__*/ `
    mutation GenerateChargebeePortal($input: GenerateChargebeePortalInput!) {
  generateChargebeePortal(input: $input) {
    id
    accessUrl
  }
}
    `

export const useGenerateChargebeePortalMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    GenerateChargebeePortalMutation,
    TError,
    GenerateChargebeePortalMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    GenerateChargebeePortalMutation,
    TError,
    GenerateChargebeePortalMutationVariables,
    TContext
  >(
    ['GenerateChargebeePortal'],
    (variables?: GenerateChargebeePortalMutationVariables) =>
      fetcher<
        GenerateChargebeePortalMutation,
        GenerateChargebeePortalMutationVariables
      >(GenerateChargebeePortalDocument, variables)(),
    options,
  )
}

export const MarkAlertReadDocument = /*#__PURE__*/ `
    mutation MarkAlertRead($input: MarkAlertReadInput!) {
  markAlertRead(input: $input) {
    id
    resource {
      ... on User {
        username
      }
    }
  }
}
    `

export const useMarkAlertReadMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    MarkAlertReadMutation,
    TError,
    MarkAlertReadMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    MarkAlertReadMutation,
    TError,
    MarkAlertReadMutationVariables,
    TContext
  >(
    ['MarkAlertRead'],
    (variables?: MarkAlertReadMutationVariables) =>
      fetcher<MarkAlertReadMutation, MarkAlertReadMutationVariables>(
        MarkAlertReadDocument,
        variables,
      )(),
    options,
  )
}

export const UpdateMemberUserDocument = /*#__PURE__*/ `
    mutation UpdateMemberUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    ...Member
  }
}
    ${MemberFragmentDoc}`

export const useUpdateMemberUserMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateMemberUserMutation,
    TError,
    UpdateMemberUserMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateMemberUserMutation,
    TError,
    UpdateMemberUserMutationVariables,
    TContext
  >(
    ['UpdateMemberUser'],
    (variables?: UpdateMemberUserMutationVariables) =>
      fetcher<UpdateMemberUserMutation, UpdateMemberUserMutationVariables>(
        UpdateMemberUserDocument,
        variables,
      )(),
    options,
  )
}

export const NodeDocument = /*#__PURE__*/ `
    query Node($id: ID!) {
  node(id: $id) {
    ... on Client {
      ...Company
    }
    ... on User {
      ...Member
    }
    ... on JobPosting {
      ...JobPosting
    }
    ... on Credential {
      __typename
      id
      training {
        ...Training
      }
    }
  }
}
    ${CompanyFragmentDoc}
${MemberFragmentDoc}
${JobPostingFragmentDoc}
${TrainingFragmentDoc}`

export const useNodeQuery = <TData = NodeQuery, TError = FetcherError>(
  variables: NodeQueryVariables,
  options?: UseQueryOptions<NodeQuery, TError, TData>,
) => {
  return useQuery<NodeQuery, TError, TData>(
    ['Node', variables],
    fetcher<NodeQuery, NodeQueryVariables>(NodeDocument, variables),
    options,
  )
}

useNodeQuery.getKey = (variables: NodeQueryVariables) => ['Node', variables]

export const NodesDocument = /*#__PURE__*/ `
    query Nodes($ids: [ID!]!) {
  nodes(ids: $ids) {
    ... on Client {
      ...Company
    }
    ... on User {
      ...Member
    }
    ... on JobPosting {
      ...JobPosting
    }
    ... on Credential {
      __typename
      id
      training {
        ...Training
      }
    }
  }
}
    ${CompanyFragmentDoc}
${MemberFragmentDoc}
${JobPostingFragmentDoc}
${TrainingFragmentDoc}`

export const useNodesQuery = <TData = NodesQuery, TError = FetcherError>(
  variables: NodesQueryVariables,
  options?: UseQueryOptions<NodesQuery, TError, TData>,
) => {
  return useQuery<NodesQuery, TError, TData>(
    ['Nodes', variables],
    fetcher<NodesQuery, NodesQueryVariables>(NodesDocument, variables),
    options,
  )
}

useNodesQuery.getKey = (variables: NodesQueryVariables) => ['Nodes', variables]

export const PageDocument = /*#__PURE__*/ `
    query Page($rawUrl: String) {
  getPage(rawUrl: $rawUrl) {
    ...Page
  }
}
    ${PageFragmentDoc}`

export const usePageQuery = <TData = PageQuery, TError = FetcherError>(
  variables?: PageQueryVariables,
  options?: UseQueryOptions<PageQuery, TError, TData>,
) => {
  return useQuery<PageQuery, TError, TData>(
    variables === undefined ? ['Page'] : ['Page', variables],
    fetcher<PageQuery, PageQueryVariables>(PageDocument, variables),
    options,
  )
}

usePageQuery.getKey = (variables?: PageQueryVariables) =>
  variables === undefined ? ['Page'] : ['Page', variables]

export const CreatePageDocument = /*#__PURE__*/ `
    mutation CreatePage($input: CreatePageInput!) {
  createPage(input: $input) {
    ...Page
  }
}
    ${PageFragmentDoc}`

export const useCreatePageMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreatePageMutation,
    TError,
    CreatePageMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreatePageMutation,
    TError,
    CreatePageMutationVariables,
    TContext
  >(
    ['CreatePage'],
    (variables?: CreatePageMutationVariables) =>
      fetcher<CreatePageMutation, CreatePageMutationVariables>(
        CreatePageDocument,
        variables,
      )(),
    options,
  )
}

export const UpdatePageDocument = /*#__PURE__*/ `
    mutation UpdatePage($input: UpdatePageInput!) {
  updatePage(input: $input) {
    ...Page
  }
}
    ${PageFragmentDoc}`

export const useUpdatePageMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdatePageMutation,
    TError,
    UpdatePageMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdatePageMutation,
    TError,
    UpdatePageMutationVariables,
    TContext
  >(
    ['UpdatePage'],
    (variables?: UpdatePageMutationVariables) =>
      fetcher<UpdatePageMutation, UpdatePageMutationVariables>(
        UpdatePageDocument,
        variables,
      )(),
    options,
  )
}

export const PagesDocument = /*#__PURE__*/ `
    query Pages($rawUrl: String, $rawUrlCont: String, $rawUrlEndsWith: String, $ids: String, $beforePostedAt: ISO8601Date, $afterPostedAt: ISO8601Date, $postedAtStart: ISO8601Date, $postedAtEnd: ISO8601Date, $pageType: [PageTypeEnum!]) {
  getPages(
    rawUrl: $rawUrl
    rawUrlCont: $rawUrlCont
    rawUrlEndsWith: $rawUrlEndsWith
    ids: $ids
    beforePostedAt: $beforePostedAt
    afterPostedAt: $afterPostedAt
    postedAtStart: $postedAtStart
    postedAtEnd: $postedAtEnd
    pageType: $pageType
  ) {
    ...Page
  }
}
    ${PageFragmentDoc}`

export const usePagesQuery = <TData = PagesQuery, TError = FetcherError>(
  variables?: PagesQueryVariables,
  options?: UseQueryOptions<PagesQuery, TError, TData>,
) => {
  return useQuery<PagesQuery, TError, TData>(
    variables === undefined ? ['Pages'] : ['Pages', variables],
    fetcher<PagesQuery, PagesQueryVariables>(PagesDocument, variables),
    options,
  )
}

usePagesQuery.getKey = (variables?: PagesQueryVariables) =>
  variables === undefined ? ['Pages'] : ['Pages', variables]

export const GetSalaryGuideDocument = /*#__PURE__*/ `
    query GetSalaryGuide {
  getReport(report: SALARY_GUIDE) {
    __typename
    url
  }
}
    `

export const useGetSalaryGuideQuery = <
  TData = GetSalaryGuideQuery,
  TError = FetcherError,
>(
  variables?: GetSalaryGuideQueryVariables,
  options?: UseQueryOptions<GetSalaryGuideQuery, TError, TData>,
) => {
  return useQuery<GetSalaryGuideQuery, TError, TData>(
    variables === undefined
      ? ['GetSalaryGuide']
      : ['GetSalaryGuide', variables],
    fetcher<GetSalaryGuideQuery, GetSalaryGuideQueryVariables>(
      GetSalaryGuideDocument,
      variables,
    ),
    options,
  )
}

useGetSalaryGuideQuery.getKey = (variables?: GetSalaryGuideQueryVariables) =>
  variables === undefined ? ['GetSalaryGuide'] : ['GetSalaryGuide', variables]

export const GetJobsReportDocument = /*#__PURE__*/ `
    query GetJobsReport {
  getReport(report: JOBS_REPORT) {
    __typename
    url
  }
}
    `

export const useGetJobsReportQuery = <
  TData = GetJobsReportQuery,
  TError = FetcherError,
>(
  variables?: GetJobsReportQueryVariables,
  options?: UseQueryOptions<GetJobsReportQuery, TError, TData>,
) => {
  return useQuery<GetJobsReportQuery, TError, TData>(
    variables === undefined ? ['GetJobsReport'] : ['GetJobsReport', variables],
    fetcher<GetJobsReportQuery, GetJobsReportQueryVariables>(
      GetJobsReportDocument,
      variables,
    ),
    options,
  )
}

useGetJobsReportQuery.getKey = (variables?: GetJobsReportQueryVariables) =>
  variables === undefined ? ['GetJobsReport'] : ['GetJobsReport', variables]

export const SearchCompaniesDocument = /*#__PURE__*/ `
    query SearchCompanies($after: String, $before: String, $companySize: CompanySizeEnum, $first: Int, $hasTraining: Boolean, $hiring: Boolean, $last: Int, $matchLocation: SearchMatchLocationInput, $radiusLocation: SearchRadiusLocationInput, $term: String) {
  searchClients(
    after: $after
    before: $before
    companySize: $companySize
    first: $first
    hasTraining: $hasTraining
    hiring: $hiring
    last: $last
    matchLocation: $matchLocation
    radiusLocation: $radiusLocation
    term: $term
  ) {
    ...EsCompanyResultConnection
  }
}
    ${EsCompanyResultConnectionFragmentDoc}`

export const useSearchCompaniesQuery = <
  TData = SearchCompaniesQuery,
  TError = FetcherError,
>(
  variables?: SearchCompaniesQueryVariables,
  options?: UseQueryOptions<SearchCompaniesQuery, TError, TData>,
) => {
  return useQuery<SearchCompaniesQuery, TError, TData>(
    variables === undefined
      ? ['SearchCompanies']
      : ['SearchCompanies', variables],
    fetcher<SearchCompaniesQuery, SearchCompaniesQueryVariables>(
      SearchCompaniesDocument,
      variables,
    ),
    options,
  )
}

useSearchCompaniesQuery.getKey = (variables?: SearchCompaniesQueryVariables) =>
  variables === undefined ? ['SearchCompanies'] : ['SearchCompanies', variables]

export const SearchCredentialsDocument = /*#__PURE__*/ `
    query SearchCredentials($after: String, $before: String, $companyName: String, $first: Int, $last: Int, $term: String, $isFeatured: Boolean) {
  searchCredentials(
    after: $after
    before: $before
    companyName: $companyName
    first: $first
    last: $last
    term: $term
    isFeatured: $isFeatured
  ) {
    ...EsCredentialResultConnection
  }
}
    ${EsCredentialResultConnectionFragmentDoc}`

export const useSearchCredentialsQuery = <
  TData = SearchCredentialsQuery,
  TError = FetcherError,
>(
  variables?: SearchCredentialsQueryVariables,
  options?: UseQueryOptions<SearchCredentialsQuery, TError, TData>,
) => {
  return useQuery<SearchCredentialsQuery, TError, TData>(
    variables === undefined
      ? ['SearchCredentials']
      : ['SearchCredentials', variables],
    fetcher<SearchCredentialsQuery, SearchCredentialsQueryVariables>(
      SearchCredentialsDocument,
      variables,
    ),
    options,
  )
}

useSearchCredentialsQuery.getKey = (
  variables?: SearchCredentialsQueryVariables,
) =>
  variables === undefined
    ? ['SearchCredentials']
    : ['SearchCredentials', variables]

export const SearchCompaniesByRecruitersDocument = /*#__PURE__*/ `
    query SearchCompaniesByRecruiters($after: String, $before: String, $companySize: CompanySizeEnum, $first: Int, $hasTraining: Boolean, $hiring: Boolean, $last: Int, $matchLocation: SearchMatchLocationInput, $radiusLocation: SearchRadiusLocationInput, $term: String, $visibleOnPlatform: Boolean) {
  searchClientsByRecruiters(
    after: $after
    before: $before
    companySize: $companySize
    first: $first
    hasTraining: $hasTraining
    hiring: $hiring
    last: $last
    matchLocation: $matchLocation
    radiusLocation: $radiusLocation
    term: $term
    visibleOnPlatform: $visibleOnPlatform
  ) {
    ...EsCompanyResultConnection
  }
}
    ${EsCompanyResultConnectionFragmentDoc}`

export const useSearchCompaniesByRecruitersQuery = <
  TData = SearchCompaniesByRecruitersQuery,
  TError = FetcherError,
>(
  variables?: SearchCompaniesByRecruitersQueryVariables,
  options?: UseQueryOptions<SearchCompaniesByRecruitersQuery, TError, TData>,
) => {
  return useQuery<SearchCompaniesByRecruitersQuery, TError, TData>(
    variables === undefined
      ? ['SearchCompaniesByRecruiters']
      : ['SearchCompaniesByRecruiters', variables],
    fetcher<
      SearchCompaniesByRecruitersQuery,
      SearchCompaniesByRecruitersQueryVariables
    >(SearchCompaniesByRecruitersDocument, variables),
    options,
  )
}

useSearchCompaniesByRecruitersQuery.getKey = (
  variables?: SearchCompaniesByRecruitersQueryVariables,
) =>
  variables === undefined
    ? ['SearchCompaniesByRecruiters']
    : ['SearchCompaniesByRecruiters', variables]

export const SearchJobPostingsDocument = /*#__PURE__*/ `
    query SearchJobPostings($applyDefaults: ApplyDefaultsEnum, $after: String, $atsRecordTypes: [AtsRecordTypeEnum!], $atsStatus: [JobPostingAtsStatusEnum!], $before: String, $betweenTimes: SearchBetweenTimesInput, $displayname: String, $associatedClientDisplayname: String, $first: Int, $isRemote: Boolean, $jobStartDateBetween: SearchJobStartDateBetweenInput, $last: Int, $matchLocation: SearchMatchLocationInput, $orderBy: OrderByEnum, $radiusLocation: SearchRadiusLocationInput, $requiredLicenseIds: [String!], $term: String, $employmentTypes: [EmploymentTypesEnum!]) {
  searchJobPostings(
    applyDefaults: $applyDefaults
    after: $after
    atsRecordTypes: $atsRecordTypes
    atsStatus: $atsStatus
    before: $before
    betweenTimes: $betweenTimes
    displayname: $displayname
    associatedClientDisplayname: $associatedClientDisplayname
    first: $first
    isRemote: $isRemote
    jobStartDateBetween: $jobStartDateBetween
    last: $last
    matchLocation: $matchLocation
    orderBy: $orderBy
    radiusLocation: $radiusLocation
    requiredLicenseIds: $requiredLicenseIds
    term: $term
    employmentTypes: $employmentTypes
  ) {
    ...EsJobPostingResultConnection
  }
}
    ${EsJobPostingResultConnectionFragmentDoc}`

export const useSearchJobPostingsQuery = <
  TData = SearchJobPostingsQuery,
  TError = FetcherError,
>(
  variables?: SearchJobPostingsQueryVariables,
  options?: UseQueryOptions<SearchJobPostingsQuery, TError, TData>,
) => {
  return useQuery<SearchJobPostingsQuery, TError, TData>(
    variables === undefined
      ? ['SearchJobPostings']
      : ['SearchJobPostings', variables],
    fetcher<SearchJobPostingsQuery, SearchJobPostingsQueryVariables>(
      SearchJobPostingsDocument,
      variables,
    ),
    options,
  )
}

useSearchJobPostingsQuery.getKey = (
  variables?: SearchJobPostingsQueryVariables,
) =>
  variables === undefined
    ? ['SearchJobPostings']
    : ['SearchJobPostings', variables]

export const SearchJobPostingsByRecruitersDocument = /*#__PURE__*/ `
    query SearchJobPostingsByRecruiters($after: String, $atsRecordTypes: [AtsRecordTypeEnum!], $atsStatus: [JobPostingAtsStatusEnum!], $before: String, $betweenTimes: SearchBetweenTimesInput, $first: Int, $isPublished: Boolean, $isRemote: Boolean, $jobStartDateBetween: SearchJobStartDateBetweenInput, $last: Int, $matchLocation: SearchMatchLocationInput, $radiusLocation: SearchRadiusLocationInput, $recruiterUsername: String, $requiredLicenseIds: [String!], $term: String, $employmentTypes: [EmploymentTypesEnum!], $visibleClient: Boolean) {
  searchJobPostingsByRecruiters(
    atsRecordTypes: $atsRecordTypes
    atsStatus: $atsStatus
    after: $after
    before: $before
    betweenTimes: $betweenTimes
    first: $first
    isPublished: $isPublished
    isRemote: $isRemote
    jobStartDateBetween: $jobStartDateBetween
    last: $last
    matchLocation: $matchLocation
    radiusLocation: $radiusLocation
    recruiterUsername: $recruiterUsername
    requiredLicenseIds: $requiredLicenseIds
    term: $term
    employmentTypes: $employmentTypes
    visibleClient: $visibleClient
  ) {
    ...EsJobPostingResultConnection
  }
}
    ${EsJobPostingResultConnectionFragmentDoc}`

export const useSearchJobPostingsByRecruitersQuery = <
  TData = SearchJobPostingsByRecruitersQuery,
  TError = FetcherError,
>(
  variables?: SearchJobPostingsByRecruitersQueryVariables,
  options?: UseQueryOptions<SearchJobPostingsByRecruitersQuery, TError, TData>,
) => {
  return useQuery<SearchJobPostingsByRecruitersQuery, TError, TData>(
    variables === undefined
      ? ['SearchJobPostingsByRecruiters']
      : ['SearchJobPostingsByRecruiters', variables],
    fetcher<
      SearchJobPostingsByRecruitersQuery,
      SearchJobPostingsByRecruitersQueryVariables
    >(SearchJobPostingsByRecruitersDocument, variables),
    options,
  )
}

useSearchJobPostingsByRecruitersQuery.getKey = (
  variables?: SearchJobPostingsByRecruitersQueryVariables,
) =>
  variables === undefined
    ? ['SearchJobPostingsByRecruiters']
    : ['SearchJobPostingsByRecruiters', variables]

export const SearchMembersDocument = /*#__PURE__*/ `
    query SearchMembers($acceptedMemberConnectionsFor: String, $after: String, $before: String, $first: Int, $last: Int, $isRecruiter: Boolean, $matchLocation: SearchMatchLocationInput, $radiusLocation: SearchRadiusLocationInput, $skills: [String!], $term: String) {
  searchCandidates(
    acceptedMemberConnectionsFor: $acceptedMemberConnectionsFor
    after: $after
    before: $before
    first: $first
    last: $last
    isRecruiter: $isRecruiter
    matchLocation: $matchLocation
    radiusLocation: $radiusLocation
    skills: $skills
    term: $term
  ) {
    ...EsMemberResultConnection
  }
}
    ${EsMemberResultConnectionFragmentDoc}`

export const useSearchMembersQuery = <
  TData = SearchMembersQuery,
  TError = FetcherError,
>(
  variables?: SearchMembersQueryVariables,
  options?: UseQueryOptions<SearchMembersQuery, TError, TData>,
) => {
  return useQuery<SearchMembersQuery, TError, TData>(
    variables === undefined ? ['SearchMembers'] : ['SearchMembers', variables],
    fetcher<SearchMembersQuery, SearchMembersQueryVariables>(
      SearchMembersDocument,
      variables,
    ),
    options,
  )
}

useSearchMembersQuery.getKey = (variables?: SearchMembersQueryVariables) =>
  variables === undefined ? ['SearchMembers'] : ['SearchMembers', variables]

export const SearchSlugNamesDocument = /*#__PURE__*/ `
    query searchSlugNames($after: String, $before: String, $first: Int, $last: Int, $term: String) {
  searchSlugNames(
    after: $after
    before: $before
    first: $first
    last: $last
    term: $term
  ) {
    ...EsSlugNameResultConnection
  }
}
    ${EsSlugNameResultConnectionFragmentDoc}`

export const useSearchSlugNamesQuery = <
  TData = SearchSlugNamesQuery,
  TError = FetcherError,
>(
  variables?: SearchSlugNamesQueryVariables,
  options?: UseQueryOptions<SearchSlugNamesQuery, TError, TData>,
) => {
  return useQuery<SearchSlugNamesQuery, TError, TData>(
    variables === undefined
      ? ['searchSlugNames']
      : ['searchSlugNames', variables],
    fetcher<SearchSlugNamesQuery, SearchSlugNamesQueryVariables>(
      SearchSlugNamesDocument,
      variables,
    ),
    options,
  )
}

useSearchSlugNamesQuery.getKey = (variables?: SearchSlugNamesQueryVariables) =>
  variables === undefined ? ['searchSlugNames'] : ['searchSlugNames', variables]

export const SearchCandidatesByClientsDocument = /*#__PURE__*/ `
    query SearchCandidatesByClients($acceptedMemberConnectionsFor: String, $after: String, $before: String, $first: Int, $hasALicense: Boolean, $hasResume: Boolean, $hasWorkExperience: Boolean, $hiringStatus: [HiringStatusEnum!], $isNeedEmploymentSponsor: Boolean, $isUsWorkAuthorized: Boolean, $last: Int, $matchLocation: SearchMatchLocationInput, $possessedLicenseIds: [String!], $radiusLocation: SearchRadiusLocationInput, $skills: [String!], $term: String) {
  searchCandidatesByClients(
    acceptedMemberConnectionsFor: $acceptedMemberConnectionsFor
    after: $after
    before: $before
    first: $first
    hasALicense: $hasALicense
    hasResume: $hasResume
    hasWorkExperience: $hasWorkExperience
    hiringStatus: $hiringStatus
    isNeedEmploymentSponsor: $isNeedEmploymentSponsor
    isUsWorkAuthorized: $isUsWorkAuthorized
    last: $last
    matchLocation: $matchLocation
    possessedLicenseIds: $possessedLicenseIds
    radiusLocation: $radiusLocation
    skills: $skills
    term: $term
  ) {
    ...EsMemberResultConnection
  }
}
    ${EsMemberResultConnectionFragmentDoc}`

export const useSearchCandidatesByClientsQuery = <
  TData = SearchCandidatesByClientsQuery,
  TError = FetcherError,
>(
  variables?: SearchCandidatesByClientsQueryVariables,
  options?: UseQueryOptions<SearchCandidatesByClientsQuery, TError, TData>,
) => {
  return useQuery<SearchCandidatesByClientsQuery, TError, TData>(
    variables === undefined
      ? ['SearchCandidatesByClients']
      : ['SearchCandidatesByClients', variables],
    fetcher<
      SearchCandidatesByClientsQuery,
      SearchCandidatesByClientsQueryVariables
    >(SearchCandidatesByClientsDocument, variables),
    options,
  )
}

useSearchCandidatesByClientsQuery.getKey = (
  variables?: SearchCandidatesByClientsQueryVariables,
) =>
  variables === undefined
    ? ['SearchCandidatesByClients']
    : ['SearchCandidatesByClients', variables]

export const SearchCandidatesByRecruitersDocument = /*#__PURE__*/ `
    query SearchCandidatesByRecruiters($acceptedMemberConnectionsFor: String, $hasALicense: Boolean, $hasResume: Boolean, $hasWorkExperience: Boolean, $hiringStatus: [HiringStatusEnum!], $isAbleToApply: Boolean, $isNeedEmploymentSponsor: Boolean, $isRecruiter: Boolean, $isAccountExec: Boolean, $isUsWorkAuthorized: Boolean, $matchLocation: SearchMatchLocationInput, $placementStatus: [PlacementStatusEnum!], $placementsForCompany: String, $possessedLicenseIds: [String!], $recruiter: String, $radiusLocation: SearchRadiusLocationInput, $skills: [String!], $term: String, $termsAccepted: Boolean, $after: String, $before: String, $first: Int, $last: Int) {
  searchCandidatesByRecruiters(
    acceptedMemberConnectionsFor: $acceptedMemberConnectionsFor
    hasALicense: $hasALicense
    hasResume: $hasResume
    hasWorkExperience: $hasWorkExperience
    hiringStatus: $hiringStatus
    isAbleToApply: $isAbleToApply
    isNeedEmploymentSponsor: $isNeedEmploymentSponsor
    isRecruiter: $isRecruiter
    isAccountExec: $isAccountExec
    isUsWorkAuthorized: $isUsWorkAuthorized
    matchLocation: $matchLocation
    placementStatus: $placementStatus
    placementsForCompany: $placementsForCompany
    possessedLicenseIds: $possessedLicenseIds
    recruiter: $recruiter
    radiusLocation: $radiusLocation
    skills: $skills
    term: $term
    termsAccepted: $termsAccepted
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    ...EsMemberResultConnection
  }
}
    ${EsMemberResultConnectionFragmentDoc}`

export const useSearchCandidatesByRecruitersQuery = <
  TData = SearchCandidatesByRecruitersQuery,
  TError = FetcherError,
>(
  variables?: SearchCandidatesByRecruitersQueryVariables,
  options?: UseQueryOptions<SearchCandidatesByRecruitersQuery, TError, TData>,
) => {
  return useQuery<SearchCandidatesByRecruitersQuery, TError, TData>(
    variables === undefined
      ? ['SearchCandidatesByRecruiters']
      : ['SearchCandidatesByRecruiters', variables],
    fetcher<
      SearchCandidatesByRecruitersQuery,
      SearchCandidatesByRecruitersQueryVariables
    >(SearchCandidatesByRecruitersDocument, variables),
    options,
  )
}

useSearchCandidatesByRecruitersQuery.getKey = (
  variables?: SearchCandidatesByRecruitersQueryVariables,
) =>
  variables === undefined
    ? ['SearchCandidatesByRecruiters']
    : ['SearchCandidatesByRecruiters', variables]

export const SubscriptionDocument = /*#__PURE__*/ `
    query Subscription($id: String!) {
  getSubscription(id: $id) {
    ...Subscription
  }
}
    ${SubscriptionFragmentDoc}`

export const useSubscriptionQuery = <
  TData = SubscriptionQuery,
  TError = FetcherError,
>(
  variables: SubscriptionQueryVariables,
  options?: UseQueryOptions<SubscriptionQuery, TError, TData>,
) => {
  return useQuery<SubscriptionQuery, TError, TData>(
    ['Subscription', variables],
    fetcher<SubscriptionQuery, SubscriptionQueryVariables>(
      SubscriptionDocument,
      variables,
    ),
    options,
  )
}

useSubscriptionQuery.getKey = (variables: SubscriptionQueryVariables) => [
  'Subscription',
  variables,
]

export const CreateSubscriptionDocument = /*#__PURE__*/ `
    mutation CreateSubscription($input: SubscriptionInput!) {
  createSubscription(input: $input) {
    ...Subscription
  }
}
    ${SubscriptionFragmentDoc}`

export const useCreateSubscriptionMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateSubscriptionMutation,
    TError,
    CreateSubscriptionMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateSubscriptionMutation,
    TError,
    CreateSubscriptionMutationVariables,
    TContext
  >(
    ['CreateSubscription'],
    (variables?: CreateSubscriptionMutationVariables) =>
      fetcher<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(
        CreateSubscriptionDocument,
        variables,
      )(),
    options,
  )
}

export const UpdateSubscriptionDocument = /*#__PURE__*/ `
    mutation UpdateSubscription($input: SubscriptionInput!) {
  updateSubscription(input: $input) {
    ...Subscription
  }
}
    ${SubscriptionFragmentDoc}`

export const useUpdateSubscriptionMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateSubscriptionMutation,
    TError,
    UpdateSubscriptionMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateSubscriptionMutation,
    TError,
    UpdateSubscriptionMutationVariables,
    TContext
  >(
    ['UpdateSubscription'],
    (variables?: UpdateSubscriptionMutationVariables) =>
      fetcher<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>(
        UpdateSubscriptionDocument,
        variables,
      )(),
    options,
  )
}

export const QuizDocument = /*#__PURE__*/ `
    query Quiz($id: String!) {
  getQuiz(id: $id) {
    ...Quiz
  }
}
    ${QuizFragmentDoc}`

export const useQuizQuery = <TData = QuizQuery, TError = FetcherError>(
  variables: QuizQueryVariables,
  options?: UseQueryOptions<QuizQuery, TError, TData>,
) => {
  return useQuery<QuizQuery, TError, TData>(
    ['Quiz', variables],
    fetcher<QuizQuery, QuizQueryVariables>(QuizDocument, variables),
    options,
  )
}

useQuizQuery.getKey = (variables: QuizQueryVariables) => ['Quiz', variables]

export const TrainingDocument = /*#__PURE__*/ `
    query Training($id: String!) {
  getTraining(id: $id) {
    ...Training
  }
}
    ${TrainingFragmentDoc}`

export const useTrainingQuery = <TData = TrainingQuery, TError = FetcherError>(
  variables: TrainingQueryVariables,
  options?: UseQueryOptions<TrainingQuery, TError, TData>,
) => {
  return useQuery<TrainingQuery, TError, TData>(
    ['Training', variables],
    fetcher<TrainingQuery, TrainingQueryVariables>(TrainingDocument, variables),
    options,
  )
}

useTrainingQuery.getKey = (variables: TrainingQueryVariables) => [
  'Training',
  variables,
]

export const PublicCredentialsCatalogueDocument = /*#__PURE__*/ `
    query PublicCredentialsCatalogue {
  publicCredentialsCatalogue {
    ...Credential
  }
}
    ${CredentialFragmentDoc}`

export const usePublicCredentialsCatalogueQuery = <
  TData = PublicCredentialsCatalogueQuery,
  TError = FetcherError,
>(
  variables?: PublicCredentialsCatalogueQueryVariables,
  options?: UseQueryOptions<PublicCredentialsCatalogueQuery, TError, TData>,
) => {
  return useQuery<PublicCredentialsCatalogueQuery, TError, TData>(
    variables === undefined
      ? ['PublicCredentialsCatalogue']
      : ['PublicCredentialsCatalogue', variables],
    fetcher<
      PublicCredentialsCatalogueQuery,
      PublicCredentialsCatalogueQueryVariables
    >(PublicCredentialsCatalogueDocument, variables),
    options,
  )
}

usePublicCredentialsCatalogueQuery.getKey = (
  variables?: PublicCredentialsCatalogueQueryVariables,
) =>
  variables === undefined
    ? ['PublicCredentialsCatalogue']
    : ['PublicCredentialsCatalogue', variables]

export const CompanyCredentialsCatalogueDocument = /*#__PURE__*/ `
    query CompanyCredentialsCatalogue($displayname: String!) {
  getCompanyCredentialsCatalogue(displayname: $displayname) {
    ...Credential
  }
}
    ${CredentialFragmentDoc}`

export const useCompanyCredentialsCatalogueQuery = <
  TData = CompanyCredentialsCatalogueQuery,
  TError = FetcherError,
>(
  variables: CompanyCredentialsCatalogueQueryVariables,
  options?: UseQueryOptions<CompanyCredentialsCatalogueQuery, TError, TData>,
) => {
  return useQuery<CompanyCredentialsCatalogueQuery, TError, TData>(
    ['CompanyCredentialsCatalogue', variables],
    fetcher<
      CompanyCredentialsCatalogueQuery,
      CompanyCredentialsCatalogueQueryVariables
    >(CompanyCredentialsCatalogueDocument, variables),
    options,
  )
}

useCompanyCredentialsCatalogueQuery.getKey = (
  variables: CompanyCredentialsCatalogueQueryVariables,
) => ['CompanyCredentialsCatalogue', variables]

export const ClientTrainingsWtfDocument = /*#__PURE__*/ `
    query ClientTrainingsWtf($displayname: String!, $after: String, $before: String, $first: Int = 24, $last: Int) {
  getClientTrainings(
    displayname: $displayname
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    ...ClientTrainingConnection
  }
}
    ${ClientTrainingConnectionFragmentDoc}`

export const useClientTrainingsWtfQuery = <
  TData = ClientTrainingsWtfQuery,
  TError = FetcherError,
>(
  variables: ClientTrainingsWtfQueryVariables,
  options?: UseQueryOptions<ClientTrainingsWtfQuery, TError, TData>,
) => {
  return useQuery<ClientTrainingsWtfQuery, TError, TData>(
    ['ClientTrainingsWtf', variables],
    fetcher<ClientTrainingsWtfQuery, ClientTrainingsWtfQueryVariables>(
      ClientTrainingsWtfDocument,
      variables,
    ),
    options,
  )
}

useClientTrainingsWtfQuery.getKey = (
  variables: ClientTrainingsWtfQueryVariables,
) => ['ClientTrainingsWtf', variables]

export const ClientTrainingsDocument = /*#__PURE__*/ `
    query ClientTrainings($displayname: String!, $after: String, $before: String, $first: Int = 24, $last: Int) {
  getClient(displayname: $displayname) {
    clientTrainings(after: $after, before: $before, first: $first, last: $last) {
      ...ClientTrainingConnection
    }
  }
}
    ${ClientTrainingConnectionFragmentDoc}`

export const useClientTrainingsQuery = <
  TData = ClientTrainingsQuery,
  TError = FetcherError,
>(
  variables: ClientTrainingsQueryVariables,
  options?: UseQueryOptions<ClientTrainingsQuery, TError, TData>,
) => {
  return useQuery<ClientTrainingsQuery, TError, TData>(
    ['ClientTrainings', variables],
    fetcher<ClientTrainingsQuery, ClientTrainingsQueryVariables>(
      ClientTrainingsDocument,
      variables,
    ),
    options,
  )
}

useClientTrainingsQuery.getKey = (variables: ClientTrainingsQueryVariables) => [
  'ClientTrainings',
  variables,
]

export const TrainingMembersDocument = /*#__PURE__*/ `
    query TrainingMembers($trainingId: String, $after: String, $before: String, $first: Int = 24, $last: Int) {
  getTrainingMembers(
    trainingId: $trainingId
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    ...TrainingMemberConnection
  }
}
    ${TrainingMemberConnectionFragmentDoc}`

export const useTrainingMembersQuery = <
  TData = TrainingMembersQuery,
  TError = FetcherError,
>(
  variables?: TrainingMembersQueryVariables,
  options?: UseQueryOptions<TrainingMembersQuery, TError, TData>,
) => {
  return useQuery<TrainingMembersQuery, TError, TData>(
    variables === undefined
      ? ['TrainingMembers']
      : ['TrainingMembers', variables],
    fetcher<TrainingMembersQuery, TrainingMembersQueryVariables>(
      TrainingMembersDocument,
      variables,
    ),
    options,
  )
}

useTrainingMembersQuery.getKey = (variables?: TrainingMembersQueryVariables) =>
  variables === undefined ? ['TrainingMembers'] : ['TrainingMembers', variables]

export const CreateQuizDocument = /*#__PURE__*/ `
    mutation CreateQuiz($input: CreateQuizInput!) {
  createQuiz(input: $input) {
    ...Quiz
  }
}
    ${QuizFragmentDoc}`

export const useCreateQuizMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateQuizMutation,
    TError,
    CreateQuizMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateQuizMutation,
    TError,
    CreateQuizMutationVariables,
    TContext
  >(
    ['CreateQuiz'],
    (variables?: CreateQuizMutationVariables) =>
      fetcher<CreateQuizMutation, CreateQuizMutationVariables>(
        CreateQuizDocument,
        variables,
      )(),
    options,
  )
}

export const CreateQuizAttemptDocument = /*#__PURE__*/ `
    mutation CreateQuizAttempt($input: CreateQuizAttemptInput!) {
  createQuizAttempt(input: $input) {
    ...QuizAttempt
  }
}
    ${QuizAttemptFragmentDoc}`

export const useCreateQuizAttemptMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateQuizAttemptMutation,
    TError,
    CreateQuizAttemptMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateQuizAttemptMutation,
    TError,
    CreateQuizAttemptMutationVariables,
    TContext
  >(
    ['CreateQuizAttempt'],
    (variables?: CreateQuizAttemptMutationVariables) =>
      fetcher<CreateQuizAttemptMutation, CreateQuizAttemptMutationVariables>(
        CreateQuizAttemptDocument,
        variables,
      )(),
    options,
  )
}

export const UpdateQuizAttemptDocument = /*#__PURE__*/ `
    mutation UpdateQuizAttempt($input: UpdateQuizAttemptInput!) {
  updateQuizAttempt(input: $input) {
    ...QuizAttempt
  }
}
    ${QuizAttemptFragmentDoc}`

export const useUpdateQuizAttemptMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateQuizAttemptMutation,
    TError,
    UpdateQuizAttemptMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateQuizAttemptMutation,
    TError,
    UpdateQuizAttemptMutationVariables,
    TContext
  >(
    ['UpdateQuizAttempt'],
    (variables?: UpdateQuizAttemptMutationVariables) =>
      fetcher<UpdateQuizAttemptMutation, UpdateQuizAttemptMutationVariables>(
        UpdateQuizAttemptDocument,
        variables,
      )(),
    options,
  )
}

export const ViewerDocument = /*#__PURE__*/ `
    query Viewer {
  currentUser {
    ...Viewer_User
  }
}
    ${Viewer_UserFragmentDoc}`

export const useViewerQuery = <TData = ViewerQuery, TError = FetcherError>(
  variables?: ViewerQueryVariables,
  options?: UseQueryOptions<ViewerQuery, TError, TData>,
) => {
  return useQuery<ViewerQuery, TError, TData>(
    variables === undefined ? ['Viewer'] : ['Viewer', variables],
    fetcher<ViewerQuery, ViewerQueryVariables>(ViewerDocument, variables),
    options,
  )
}

useViewerQuery.getKey = (variables?: ViewerQueryVariables) =>
  variables === undefined ? ['Viewer'] : ['Viewer', variables]

export const GetUserInvitationDocument = /*#__PURE__*/ `
    query GetUserInvitation($id: ID!) {
  getUserInvitation(id: $id) {
    __typename
    id
    user {
      ...Viewer_User
    }
    userEmail
    userType
  }
}
    ${Viewer_UserFragmentDoc}`

export const useGetUserInvitationQuery = <
  TData = GetUserInvitationQuery,
  TError = FetcherError,
>(
  variables: GetUserInvitationQueryVariables,
  options?: UseQueryOptions<GetUserInvitationQuery, TError, TData>,
) => {
  return useQuery<GetUserInvitationQuery, TError, TData>(
    ['GetUserInvitation', variables],
    fetcher<GetUserInvitationQuery, GetUserInvitationQueryVariables>(
      GetUserInvitationDocument,
      variables,
    ),
    options,
  )
}

useGetUserInvitationQuery.getKey = (
  variables: GetUserInvitationQueryVariables,
) => ['GetUserInvitation', variables]

export const GetUserPasswordResetRequestDocument = /*#__PURE__*/ `
    query GetUserPasswordResetRequest($id: ID!) {
  getUserPasswordResetRequest(id: $id) {
    __typename
    id
    expiresAt
    user {
      ...Viewer_User
    }
  }
}
    ${Viewer_UserFragmentDoc}`

export const useGetUserPasswordResetRequestQuery = <
  TData = GetUserPasswordResetRequestQuery,
  TError = FetcherError,
>(
  variables: GetUserPasswordResetRequestQueryVariables,
  options?: UseQueryOptions<GetUserPasswordResetRequestQuery, TError, TData>,
) => {
  return useQuery<GetUserPasswordResetRequestQuery, TError, TData>(
    ['GetUserPasswordResetRequest', variables],
    fetcher<
      GetUserPasswordResetRequestQuery,
      GetUserPasswordResetRequestQueryVariables
    >(GetUserPasswordResetRequestDocument, variables),
    options,
  )
}

useGetUserPasswordResetRequestQuery.getKey = (
  variables: GetUserPasswordResetRequestQueryVariables,
) => ['GetUserPasswordResetRequest', variables]

export const AcceptTermsAndConditionsDocument = /*#__PURE__*/ `
    mutation AcceptTermsAndConditions {
  acceptTermsAndConditions {
    ...Viewer_User
  }
}
    ${Viewer_UserFragmentDoc}`

export const useAcceptTermsAndConditionsMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    AcceptTermsAndConditionsMutation,
    TError,
    AcceptTermsAndConditionsMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AcceptTermsAndConditionsMutation,
    TError,
    AcceptTermsAndConditionsMutationVariables,
    TContext
  >(
    ['AcceptTermsAndConditions'],
    (variables?: AcceptTermsAndConditionsMutationVariables) =>
      fetcher<
        AcceptTermsAndConditionsMutation,
        AcceptTermsAndConditionsMutationVariables
      >(AcceptTermsAndConditionsDocument, variables)(),
    options,
  )
}

export const AssumeIdentityDocument = /*#__PURE__*/ `
    mutation AssumeIdentity($input: AssumeIdentityInput!) {
  assumeIdentity(input: $input) {
    ...Viewer_User
  }
}
    ${Viewer_UserFragmentDoc}`

export const useAssumeIdentityMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    AssumeIdentityMutation,
    TError,
    AssumeIdentityMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AssumeIdentityMutation,
    TError,
    AssumeIdentityMutationVariables,
    TContext
  >(
    ['AssumeIdentity'],
    (variables?: AssumeIdentityMutationVariables) =>
      fetcher<AssumeIdentityMutation, AssumeIdentityMutationVariables>(
        AssumeIdentityDocument,
        variables,
      )(),
    options,
  )
}

export const CreateUserPasswordResetRequestDocument = /*#__PURE__*/ `
    mutation CreateUserPasswordResetRequest($input: CreateUserPasswordResetRequestInput!) {
  createUserPasswordResetRequest(input: $input)
}
    `

export const useCreateUserPasswordResetRequestMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateUserPasswordResetRequestMutation,
    TError,
    CreateUserPasswordResetRequestMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateUserPasswordResetRequestMutation,
    TError,
    CreateUserPasswordResetRequestMutationVariables,
    TContext
  >(
    ['CreateUserPasswordResetRequest'],
    (variables?: CreateUserPasswordResetRequestMutationVariables) =>
      fetcher<
        CreateUserPasswordResetRequestMutation,
        CreateUserPasswordResetRequestMutationVariables
      >(CreateUserPasswordResetRequestDocument, variables)(),
    options,
  )
}

export const CreateUserPromptResponseDocument = /*#__PURE__*/ `
    mutation CreateUserPromptResponse($input: CreateUserPromptResponseInput!) {
  createUserPromptResponse(input: $input) {
    ...Viewer_User
  }
}
    ${Viewer_UserFragmentDoc}`

export const useCreateUserPromptResponseMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateUserPromptResponseMutation,
    TError,
    CreateUserPromptResponseMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateUserPromptResponseMutation,
    TError,
    CreateUserPromptResponseMutationVariables,
    TContext
  >(
    ['CreateUserPromptResponse'],
    (variables?: CreateUserPromptResponseMutationVariables) =>
      fetcher<
        CreateUserPromptResponseMutation,
        CreateUserPromptResponseMutationVariables
      >(CreateUserPromptResponseDocument, variables)(),
    options,
  )
}

export const LoginDocument = /*#__PURE__*/ `
    mutation Login($input: LoginUserInput!) {
  loginUser(input: $input) {
    ...Viewer_User
  }
}
    ${Viewer_UserFragmentDoc}`

export const useLoginMutation = <TError = FetcherError, TContext = unknown>(
  options?: UseMutationOptions<
    LoginMutation,
    TError,
    LoginMutationVariables,
    TContext
  >,
) => {
  return useMutation<LoginMutation, TError, LoginMutationVariables, TContext>(
    ['Login'],
    (variables?: LoginMutationVariables) =>
      fetcher<LoginMutation, LoginMutationVariables>(
        LoginDocument,
        variables,
      )(),
    options,
  )
}

export const LogoutDocument = /*#__PURE__*/ `
    mutation Logout {
  logoutUser
}
    `

export const useLogoutMutation = <TError = FetcherError, TContext = unknown>(
  options?: UseMutationOptions<
    LogoutMutation,
    TError,
    LogoutMutationVariables,
    TContext
  >,
) => {
  return useMutation<LogoutMutation, TError, LogoutMutationVariables, TContext>(
    ['Logout'],
    (variables?: LogoutMutationVariables) =>
      fetcher<LogoutMutation, LogoutMutationVariables>(
        LogoutDocument,
        variables,
      )(),
    options,
  )
}

export const InviteUserDocument = /*#__PURE__*/ `
    mutation InviteUser($input: InviteUserInput!) {
  inviteUser(input: $input)
}
    `

export const useInviteUserMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    InviteUserMutation,
    TError,
    InviteUserMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    InviteUserMutation,
    TError,
    InviteUserMutationVariables,
    TContext
  >(
    ['InviteUser'],
    (variables?: InviteUserMutationVariables) =>
      fetcher<InviteUserMutation, InviteUserMutationVariables>(
        InviteUserDocument,
        variables,
      )(),
    options,
  )
}

export const ResetUserPasswordDocument = /*#__PURE__*/ `
    mutation ResetUserPassword($input: ResetUserPasswordInput!) {
  resetUserPassword(input: $input) {
    ...Viewer_User
  }
}
    ${Viewer_UserFragmentDoc}`

export const useResetUserPasswordMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    ResetUserPasswordMutation,
    TError,
    ResetUserPasswordMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ResetUserPasswordMutation,
    TError,
    ResetUserPasswordMutationVariables,
    TContext
  >(
    ['ResetUserPassword'],
    (variables?: ResetUserPasswordMutationVariables) =>
      fetcher<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(
        ResetUserPasswordDocument,
        variables,
      )(),
    options,
  )
}

export const SignUpUserDocument = /*#__PURE__*/ `
    mutation SignUpUser($input: SignUpUserInput!) {
  signUpUser(input: $input) {
    ...Viewer_User
  }
}
    ${Viewer_UserFragmentDoc}`

export const useSignUpUserMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SignUpUserMutation,
    TError,
    SignUpUserMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SignUpUserMutation,
    TError,
    SignUpUserMutationVariables,
    TContext
  >(
    ['SignUpUser'],
    (variables?: SignUpUserMutationVariables) =>
      fetcher<SignUpUserMutation, SignUpUserMutationVariables>(
        SignUpUserDocument,
        variables,
      )(),
    options,
  )
}

export const UpdateUserPasswordDocument = /*#__PURE__*/ `
    mutation UpdateUserPassword($input: UpdateUserPasswordInput!) {
  updateUserPassword(input: $input) {
    ...Viewer_User
  }
}
    ${Viewer_UserFragmentDoc}`

export const useUpdateUserPasswordMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateUserPasswordMutation,
    TError,
    UpdateUserPasswordMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateUserPasswordMutation,
    TError,
    UpdateUserPasswordMutationVariables,
    TContext
  >(
    ['UpdateUserPassword'],
    (variables?: UpdateUserPasswordMutationVariables) =>
      fetcher<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>(
        UpdateUserPasswordDocument,
        variables,
      )(),
    options,
  )
}

export const ProfessionalInterestsDocument = /*#__PURE__*/ `
    query ProfessionalInterests {
  professionalInterests {
    ...ProfessionalInterest
  }
}
    ${ProfessionalInterestFragmentDoc}`

export const useProfessionalInterestsQuery = <
  TData = ProfessionalInterestsQuery,
  TError = FetcherError,
>(
  variables?: ProfessionalInterestsQueryVariables,
  options?: UseQueryOptions<ProfessionalInterestsQuery, TError, TData>,
) => {
  return useQuery<ProfessionalInterestsQuery, TError, TData>(
    variables === undefined
      ? ['ProfessionalInterests']
      : ['ProfessionalInterests', variables],
    fetcher<ProfessionalInterestsQuery, ProfessionalInterestsQueryVariables>(
      ProfessionalInterestsDocument,
      variables,
    ),
    options,
  )
}

useProfessionalInterestsQuery.getKey = (
  variables?: ProfessionalInterestsQueryVariables,
) =>
  variables === undefined
    ? ['ProfessionalInterests']
    : ['ProfessionalInterests', variables]

export const PlatformIntentionsDocument = /*#__PURE__*/ `
    query PlatformIntentions {
  platformIntentions {
    ...PlatformIntention
  }
}
    ${PlatformIntentionFragmentDoc}`

export const usePlatformIntentionsQuery = <
  TData = PlatformIntentionsQuery,
  TError = FetcherError,
>(
  variables?: PlatformIntentionsQueryVariables,
  options?: UseQueryOptions<PlatformIntentionsQuery, TError, TData>,
) => {
  return useQuery<PlatformIntentionsQuery, TError, TData>(
    variables === undefined
      ? ['PlatformIntentions']
      : ['PlatformIntentions', variables],
    fetcher<PlatformIntentionsQuery, PlatformIntentionsQueryVariables>(
      PlatformIntentionsDocument,
      variables,
    ),
    options,
  )
}

usePlatformIntentionsQuery.getKey = (
  variables?: PlatformIntentionsQueryVariables,
) =>
  variables === undefined
    ? ['PlatformIntentions']
    : ['PlatformIntentions', variables]

export const SkillsDocument = /*#__PURE__*/ `
    query Skills {
  skills {
    ...Skill
  }
}
    ${SkillFragmentDoc}`

export const useSkillsQuery = <TData = SkillsQuery, TError = FetcherError>(
  variables?: SkillsQueryVariables,
  options?: UseQueryOptions<SkillsQuery, TError, TData>,
) => {
  return useQuery<SkillsQuery, TError, TData>(
    variables === undefined ? ['Skills'] : ['Skills', variables],
    fetcher<SkillsQuery, SkillsQueryVariables>(SkillsDocument, variables),
    options,
  )
}

useSkillsQuery.getKey = (variables?: SkillsQueryVariables) =>
  variables === undefined ? ['Skills'] : ['Skills', variables]

export const LicensesDocument = /*#__PURE__*/ `
    query Licenses {
  licenses {
    ...License
  }
}
    ${LicenseFragmentDoc}`

export const useLicensesQuery = <TData = LicensesQuery, TError = FetcherError>(
  variables?: LicensesQueryVariables,
  options?: UseQueryOptions<LicensesQuery, TError, TData>,
) => {
  return useQuery<LicensesQuery, TError, TData>(
    variables === undefined ? ['Licenses'] : ['Licenses', variables],
    fetcher<LicensesQuery, LicensesQueryVariables>(LicensesDocument, variables),
    options,
  )
}

useLicensesQuery.getKey = (variables?: LicensesQueryVariables) =>
  variables === undefined ? ['Licenses'] : ['Licenses', variables]

export const EmploymentBenefitsDocument = /*#__PURE__*/ `
    query EmploymentBenefits {
  employmentBenefits {
    ...EmploymentBenefit
  }
}
    ${EmploymentBenefitFragmentDoc}`

export const useEmploymentBenefitsQuery = <
  TData = EmploymentBenefitsQuery,
  TError = FetcherError,
>(
  variables?: EmploymentBenefitsQueryVariables,
  options?: UseQueryOptions<EmploymentBenefitsQuery, TError, TData>,
) => {
  return useQuery<EmploymentBenefitsQuery, TError, TData>(
    variables === undefined
      ? ['EmploymentBenefits']
      : ['EmploymentBenefits', variables],
    fetcher<EmploymentBenefitsQuery, EmploymentBenefitsQueryVariables>(
      EmploymentBenefitsDocument,
      variables,
    ),
    options,
  )
}

useEmploymentBenefitsQuery.getKey = (
  variables?: EmploymentBenefitsQueryVariables,
) =>
  variables === undefined
    ? ['EmploymentBenefits']
    : ['EmploymentBenefits', variables]

export const FeaturedMembersDocument = /*#__PURE__*/ `
    query FeaturedMembers($recruiters: Boolean) {
  featuredMembers(recruiters: $recruiters) {
    ...Member
  }
}
    ${MemberFragmentDoc}`

export const useFeaturedMembersQuery = <
  TData = FeaturedMembersQuery,
  TError = FetcherError,
>(
  variables?: FeaturedMembersQueryVariables,
  options?: UseQueryOptions<FeaturedMembersQuery, TError, TData>,
) => {
  return useQuery<FeaturedMembersQuery, TError, TData>(
    variables === undefined
      ? ['FeaturedMembers']
      : ['FeaturedMembers', variables],
    fetcher<FeaturedMembersQuery, FeaturedMembersQueryVariables>(
      FeaturedMembersDocument,
      variables,
    ),
    options,
  )
}

useFeaturedMembersQuery.getKey = (variables?: FeaturedMembersQueryVariables) =>
  variables === undefined ? ['FeaturedMembers'] : ['FeaturedMembers', variables]

export const ScreeningsDocument = /*#__PURE__*/ `
    query Screenings {
  screenings {
    ...Screening
  }
}
    ${ScreeningFragmentDoc}`

export const useScreeningsQuery = <
  TData = ScreeningsQuery,
  TError = FetcherError,
>(
  variables?: ScreeningsQueryVariables,
  options?: UseQueryOptions<ScreeningsQuery, TError, TData>,
) => {
  return useQuery<ScreeningsQuery, TError, TData>(
    variables === undefined ? ['Screenings'] : ['Screenings', variables],
    fetcher<ScreeningsQuery, ScreeningsQueryVariables>(
      ScreeningsDocument,
      variables,
    ),
    options,
  )
}

useScreeningsQuery.getKey = (variables?: ScreeningsQueryVariables) =>
  variables === undefined ? ['Screenings'] : ['Screenings', variables]

export const GetEmployeesDocument = /*#__PURE__*/ `
    query GetEmployees($team: TeamEnum) {
  getEmployees(team: $team) {
    ...Employee
  }
}
    ${EmployeeFragmentDoc}`

export const useGetEmployeesQuery = <
  TData = GetEmployeesQuery,
  TError = FetcherError,
>(
  variables?: GetEmployeesQueryVariables,
  options?: UseQueryOptions<GetEmployeesQuery, TError, TData>,
) => {
  return useQuery<GetEmployeesQuery, TError, TData>(
    variables === undefined ? ['GetEmployees'] : ['GetEmployees', variables],
    fetcher<GetEmployeesQuery, GetEmployeesQueryVariables>(
      GetEmployeesDocument,
      variables,
    ),
    options,
  )
}

useGetEmployeesQuery.getKey = (variables?: GetEmployeesQueryVariables) =>
  variables === undefined ? ['GetEmployees'] : ['GetEmployees', variables]

export const NotificationsDocument = /*#__PURE__*/ `
    query Notifications {
  getNotifications {
    ...Notification
  }
}
    ${NotificationFragmentDoc}`

export const useNotificationsQuery = <
  TData = NotificationsQuery,
  TError = FetcherError,
>(
  variables?: NotificationsQueryVariables,
  options?: UseQueryOptions<NotificationsQuery, TError, TData>,
) => {
  return useQuery<NotificationsQuery, TError, TData>(
    variables === undefined ? ['Notifications'] : ['Notifications', variables],
    fetcher<NotificationsQuery, NotificationsQueryVariables>(
      NotificationsDocument,
      variables,
    ),
    options,
  )
}

useNotificationsQuery.getKey = (variables?: NotificationsQueryVariables) =>
  variables === undefined ? ['Notifications'] : ['Notifications', variables]

export const AllChatMessagesDocument = /*#__PURE__*/ `
    query AllChatMessages($after: String, $before: String, $first: Int = 24, $last: Int, $orderBy: OrderByEnum, $recentConversations: Boolean, $recipient: String, $unread: Boolean) {
  getChatMessages(
    after: $after
    before: $before
    first: $first
    last: $last
    orderBy: $orderBy
    recentConversations: $recentConversations
    recipient: $recipient
    unread: $unread
  ) {
    ...ChatMessageConnection
  }
}
    ${ChatMessageConnectionFragmentDoc}`

export const useAllChatMessagesQuery = <
  TData = AllChatMessagesQuery,
  TError = FetcherError,
>(
  variables?: AllChatMessagesQueryVariables,
  options?: UseQueryOptions<AllChatMessagesQuery, TError, TData>,
) => {
  return useQuery<AllChatMessagesQuery, TError, TData>(
    variables === undefined
      ? ['AllChatMessages']
      : ['AllChatMessages', variables],
    fetcher<AllChatMessagesQuery, AllChatMessagesQueryVariables>(
      AllChatMessagesDocument,
      variables,
    ),
    options,
  )
}

useAllChatMessagesQuery.getKey = (variables?: AllChatMessagesQueryVariables) =>
  variables === undefined ? ['AllChatMessages'] : ['AllChatMessages', variables]

export const CreateChatMessageDocument = /*#__PURE__*/ `
    mutation CreateChatMessage($input: ChatMessageInput!) {
  createChatMessage(input: $input) {
    id
    recipient {
      id
      username
    }
    sender {
      id
      username
    }
    slateMessage
  }
}
    `

export const useCreateChatMessageMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateChatMessageMutation,
    TError,
    CreateChatMessageMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateChatMessageMutation,
    TError,
    CreateChatMessageMutationVariables,
    TContext
  >(
    ['CreateChatMessage'],
    (variables?: CreateChatMessageMutationVariables) =>
      fetcher<CreateChatMessageMutation, CreateChatMessageMutationVariables>(
        CreateChatMessageDocument,
        variables,
      )(),
    options,
  )
}

export const MarkChatMessageReadDocument = /*#__PURE__*/ `
    mutation MarkChatMessageRead($input: ChatMessageReadInput!) {
  markChatMessageRead(input: $input) {
    id
    recipientRead
  }
}
    `

export const useMarkChatMessageReadMutation = <
  TError = FetcherError,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    MarkChatMessageReadMutation,
    TError,
    MarkChatMessageReadMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    MarkChatMessageReadMutation,
    TError,
    MarkChatMessageReadMutationVariables,
    TContext
  >(
    ['MarkChatMessageRead'],
    (variables?: MarkChatMessageReadMutationVariables) =>
      fetcher<
        MarkChatMessageReadMutation,
        MarkChatMessageReadMutationVariables
      >(MarkChatMessageReadDocument, variables)(),
    options,
  )
}
